webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.base = undefined;

var _defineProperty2 = __webpack_require__(84);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(23);

var _extends4 = _interopRequireDefault(_extends3);

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _vuex = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base = exports.base = function base(Language) {
  var key = (0, _keys2.default)(Language)[0];
  return {
    data: function data() {
      return {
        resData: ""
      };
    },
    mounted: function mounted() {},

    computed: (0, _extends4.default)((0, _defineProperty3.default)({}, key, function () {
      return this.translate(this.LANGUAGE, Language[key]);
    }), (0, _vuex.mapState)(["USER", "LANGUAGE", "PAGEMAXINDEX", "SIDEBARACTIVE", "SIDEBARVUE"])),
    methods: (0, _extends4.default)({
      getAjaxData: function getAjaxData(ajax, params, field) {
        var _this = this;

        this.$http(ajax, { //       this.getAjaxData(URL_FINDUSER,{"user_id":"1"},"msg")
          params: params
        }).then(function (res) {
          _this.resData = res.data;
        });
      }
    }, (0, _vuex.mapMutations)(["SAVEUSER", "SAVELANGUAGE", "SAVEPAGEMAXINDEX", "SAVESIDEBARACTIVE", "GETSIDEBARVUE"])),
    watch: {
      LANGUAGE: function LANGUAGE(curVal, oldVal) {}
    }
  };
};

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Api = undefined;

var _classCallCheck2 = __webpack_require__(593);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(594);

var _createClass3 = _interopRequireDefault(_createClass2);

var _env = __webpack_require__(205);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Api = function () {
    function Api() {
        (0, _classCallCheck3.default)(this, Api);

        this.commissionURl20 = _env.VUE_APP_MIDDLE_LAYER_API20; //佣金中间件, 转发不同区域的佣金求情给对应的服务.
        this.commissionEnable = _env.commissionEnable; // 设定 启用佣金设定功能
        this.changeable = true; // 设定 启用GM/UK
        this.enableDistribution = true; //设定 启用代理上层佣金分配
        this.profitURL = _env.VUE_APP_MIDDLE_LAYER_API20 + '/profit';
    }

    (0, _createClass3.default)(Api, [{
        key: 'getUrl',
        value: function getUrl(curArea, path) {
            return null;
        }
    }, {
        key: 'getUrl20',
        value: function getUrl20(curArea, path) {
            var code = this.commissionURl20.substr(this.commissionURl20.length - 1, 1),
                URL = code == '/' ? this.commissionURl20 + curArea + path : this.commissionURl20 + '/' + curArea + '/' + path;
            return URL;
        }
    }]);
    return Api;
}();

exports.Api = Api;

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URL_ADD_ACCOUNT = exports.URL_VERSION_BACK = exports.URL_BEGIN_CALCULATE = exports.URL_SHARE_VERSION = exports.URL_SHARE_REPORT = exports.URL_UPDATE_SETTING = exports.URL_ACCOUNT_SETTING = exports.URL_TEMPLATE_SAVE = exports.URL_TEMPLATE_HISTORY = exports.URL_TEMPLATE_GET = exports.URL_MTDBS = exports.URL_MTCLIENTS = exports.URL_TOOL_ALERT_IGNORE2 = exports.URL_TOOL_ALERT_IGNORE = exports.URL_TOOLCHECKID = exports.URL_TOOLCHECKCPA = exports.URL_SALEMONTHLYCOMMDET = exports.URL_SALEMONTHLYCOMM = exports.URL_CPADETAIL = exports.URL_CPA = exports.URL_IBMONTHLYDETAIL = exports.URL_IBMONTHLYUPDATE = exports.URL_IBMONTHLYSECOND = exports.URL_IBMONTHLYINDEX = exports.URL_REALTIMEDETAIL = exports.URL_REALTIME = exports.URL_AUDITREPORTDETAIL = exports.URL_AUDITREPORT = exports.URL_ACTIVEREPORT = exports.URL_DEFAULT = exports.URL_PRERELATION = exports.URL_PREIBCON = exports.URL_SALESCHECK = exports.URL_SYMBOLDEL = exports.URL_SYMBOLOTHER = exports.URL_SYMBOLSPREAD = exports.URL_IBCPA = exports.URL_IBPREVIEW = exports.URL_SALESDEL = exports.URL_IBRULE = exports.URL_IBSET = exports.URL_IBALL = exports.URL_SALELIST = exports.URL_SALESPREVIEW = exports.URL_SALESEXTRA = exports.URL_SALESSPECIAL = exports.URL_SALESSET = exports.URL_commissionLogin20 = exports.URL_commissionLogin = exports.URL_commissionUKLogin = exports.URL_commissionGMLogin = undefined;

var _commissionEnv = __webpack_require__(5);

var api = new _commissionEnv.Api();
var URL_commissionGMLogin = exports.URL_commissionGMLogin = api.GMURL + '/user/login';
var URL_commissionUKLogin = exports.URL_commissionUKLogin = api.UKURL + '/user/login';
var URL_commissionLogin = exports.URL_commissionLogin = api.commissionURl + '/user/signin';
var URL_commissionLogin20 = exports.URL_commissionLogin20 = api.commissionURl20 + '/user/signin';

var URL_SALESSET = exports.URL_SALESSET = 'sales/set'; // ��ȡ����������Ӷ���趨
var URL_SALESSPECIAL = exports.URL_SALESSPECIAL = 'sales/special'; // ��ȡ�ر������Ϣ
var URL_SALESEXTRA = exports.URL_SALESEXTRA = 'sales/extra'; // ��ȡ�����Ա��
var URL_SALESPREVIEW = exports.URL_SALESPREVIEW = 'sales/preview'; // ��ȡ����Ӷ��Ԥ������
var URL_SALELIST = exports.URL_SALELIST = 'sales/list'; // ��ȡ���������б�

var URL_IBALL = exports.URL_IBALL = 'ib/all'; // ��ȡ���д����б�
var URL_IBSET = exports.URL_IBSET = 'ib/set'; // ��ȡ�����´���Ӷ���趨
var URL_IBRULE = exports.URL_IBRULE = 'ib/rule'; // ��ȡ�����´��������趨
var URL_SALESDEL = exports.URL_SALESDEL = 'sales/del'; // ɾ������Ӷ���趨

var URL_IBPREVIEW = exports.URL_IBPREVIEW = 'ib/preview'; //��ȡ ����Ӷ��Ԥ������
var URL_IBCPA = exports.URL_IBCPA = 'ib/cpa'; ///��ȡ CPA���� ����

var URL_SYMBOLSPREAD = exports.URL_SYMBOLSPREAD = 'symbol/spread'; //��ȡ�����¼ӵ��趨������
var URL_SYMBOLOTHER = exports.URL_SYMBOLOTHER = 'symbol/other'; //���ʣ��Ļ��Ҷ�����
var URL_SYMBOLDEL = exports.URL_SYMBOLDEL = 'symbol/del'; // ɾ��һ���ӵ�����
var URL_SALESCHECK = exports.URL_SALESCHECK = 'sales/check'; // ������ ID �Ƿ���ȷ
var URL_PREIBCON = exports.URL_PREIBCON = 'pre/ibcon'; // ������д���Ӷ�𱨱�

var URL_PRERELATION = exports.URL_PRERELATION = 'pre/relation'; // ��ù�ϵͼ����

var URL_DEFAULT = exports.URL_DEFAULT = 'tool/default/'; // ����Ӷ���趨Ĭ������

var URL_ACTIVEREPORT = exports.URL_ACTIVEREPORT = 'pre/status'; //�Ѽ����������
var URL_AUDITREPORT = exports.URL_AUDITREPORT = 'pre/audits'; //��˸��ٱ���
var URL_AUDITREPORTDETAIL = exports.URL_AUDITREPORTDETAIL = 'pre/audit';

var URL_REALTIME = exports.URL_REALTIME = "report/realtime"; // ʵʱӶ����
var URL_REALTIMEDETAIL = exports.URL_REALTIMEDETAIL = "report/ibres"; // ʵʱӶ����ϸ

var URL_IBMONTHLYINDEX = exports.URL_IBMONTHLYINDEX = "report/monres"; // �����½YӶ��
var URL_IBMONTHLYSECOND = exports.URL_IBMONTHLYSECOND = 'report/monibres'; // �����½�Ӷ����
var URL_IBMONTHLYUPDATE = exports.URL_IBMONTHLYUPDATE = 'report/status'; // �����½����״̬
var URL_IBMONTHLYDETAIL = exports.URL_IBMONTHLYDETAIL = 'report/monibdet'; // �����½���ϸ

var URL_CPA = exports.URL_CPA = 'report/cpa';
var URL_CPADETAIL = exports.URL_CPADETAIL = 'report/cpacli';

var URL_SALEMONTHLYCOMM = exports.URL_SALEMONTHLYCOMM = 'report/salesres';
var URL_SALEMONTHLYCOMMDET = exports.URL_SALEMONTHLYCOMMDET = 'report/salesdet';

var URL_TOOLCHECKCPA = exports.URL_TOOLCHECKCPA = 'tool/checkCpa'; // ����Ƿ���CPA
var URL_TOOLCHECKID = exports.URL_TOOLCHECKID = 'tool/checkId'; // ���id�Ƿ��ڹ�ϵͼ
var URL_TOOL_ALERT_IGNORE = exports.URL_TOOL_ALERT_IGNORE = 'tool/alert_ignore'; // Ӷ��������֪ͨ����
var URL_TOOL_ALERT_IGNORE2 = exports.URL_TOOL_ALERT_IGNORE2 = 'tool/alert_ignore2';

var URL_MTCLIENTS = exports.URL_MTCLIENTS = 'report/getMTClients';
var URL_MTDBS = exports.URL_MTDBS = 'report/getMTDbs';

var URL_TEMPLATE_GET = exports.URL_TEMPLATE_GET = 'tool/template';
var URL_TEMPLATE_HISTORY = exports.URL_TEMPLATE_HISTORY = 'tool/templateHistroy';
var URL_TEMPLATE_SAVE = exports.URL_TEMPLATE_SAVE = 'tool/templateSave';

// profit share setting api
var URL_ACCOUNT_SETTING = exports.URL_ACCOUNT_SETTING = api.profitURL + '/account-setting';
var URL_UPDATE_SETTING = exports.URL_UPDATE_SETTING = api.profitURL + '/update-setting';
var URL_SHARE_REPORT = exports.URL_SHARE_REPORT = api.profitURL + '/share-report';
var URL_SHARE_VERSION = exports.URL_SHARE_VERSION = api.profitURL + '/share-version';
var URL_BEGIN_CALCULATE = exports.URL_BEGIN_CALCULATE = api.profitURL + '/begin-calculate';
var URL_VERSION_BACK = exports.URL_VERSION_BACK = api.profitURL + '/version-back';
var URL_ADD_ACCOUNT = exports.URL_ADD_ACCOUNT = api.profitURL + '/add-account';

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatDate = formatDate;
exports.updateTimeByUtc = updateTimeByUtc;
exports.getTimeDiff = getTimeDiff;

var _vue = __webpack_require__(20);

var _vue2 = _interopRequireDefault(_vue);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatDate(time) {
    return time ? (0, _moment2.default)(time).format('YYYY-MM-DD HH:mm:ss') : "";
}

function updateTimeByUtc(diff, time) {
    return time ? (0, _moment2.default)(time).add(+diff, 'hour').format('YYYY-MM-DD HH:mm:ss') : "";
}

function compareYear(birthday) {
    var moment = _vue2.default.prototype.$moment;
    var nowDate = moment();
    var year = nowDate.get('year');
    var month = nowDate.get('month') + 1;
    var day = nowDate.get('date');

    var befYear = birthday.get('year');
    var befMonth = birthday.get('month') + 1;
    var befday = birthday.get('date');

    var date = year + '-' + month + '-' + (day + 1);
    var beforeDate = befYear + 18 + '-' + befMonth + '-' + befday;

    return moment(date).isAfter(beforeDate, 'date');
}

function getTimeDiff() {
    var timeDiff = sessionStorage.getItem('UTCDIFF');
    if (timeDiff) {
        return timeDiff;
    } else {
        sessionStorage.setItem('UTCDIFF', new String(-new Date().getTimezoneOffset() / 60));
        return sessionStorage.getItem('UTCDIFF');
    }
}

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(907)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1101),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40cdcb6e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URL_SALES_BANK_LIST = exports.URL_SALES_BANK_DELETE = exports.URL_SALES_BANK_CREATE = exports.URL_MT_GROUP_CONFIG = exports.URL_MT_SERVER = exports.URL_LINKSLIST_ENTITY = exports.URL_LINKSLIST_ADD = exports.URL_LINKSLIST_DELETE = exports.URL_LINKSLIST_CREATE = exports.URL_LINKSLIST = exports.URL_BROADCAST_DELETE = exports.URL_BROADCAST_UPDATE = exports.URL_BROADCAST_CREATE = exports.URL_BROADCASTLIST = exports.URL_SAVEPRIVILEGE = exports.URL_FINDALLPRIVILEGE = exports.URL_DELETEROLE = exports.URL_ADDROLE = exports.URL_FINDALLROLE = exports.URL_TESTLOGIN = exports.URL_DOWNLOAD = exports.URL_UPLOAD = exports.URL_GET_CLIENT_PARENT_INFO = exports.URL_RELATION_GETNODEID = exports.URL_RELATIONSEARCH = exports.URL_RELATION = exports.URL_LASTCODEVERIFY = exports.URL_GETCODE = exports.URL_CODEVERIFY = exports.URL_GET_PROCESS_STATE = exports.URL_CHANGEPARENTSALES = exports.URL_FINDNEXTLEVELBYID = exports.URL_LOGINSALEPLATFORM = exports.URL_CHANGEPWD = exports.URL_SIGNOUT = exports.URL_GETBYID = exports.URL_UPDATE = exports.RELATIONSHIP_SENDEMAILBYUPDATESALES = exports.RELATIONSHIP_UPDATENODECODE = exports.RELATIONSHIP_UPDATEPARENID = exports.URL_CREATE = exports.URL_SINGIN = exports.URL_UPDATEUSER = exports.URL_FINDUSERID = exports.URL_FINDUSER = exports.URL_CREATEUSER = exports.RELATIONSHIP_SEACHNODECODE = exports.POSITIONS_SEARCH = exports.URL_FINDUSER_BYEMAIL = exports.URL_USERDELETE = exports.URL_USERLIST = exports.URL_FINDSALES = exports.URL_CLIENTLIST = undefined;

var _env = __webpack_require__(205);

var URL_CLIENTLIST = exports.URL_CLIENTLIST = _env.SERVER + 'sales/list'; // accountList页面接口

var URL_FINDSALES = exports.URL_FINDSALES = _env.SERVER + 'sales/findById'; // accountList页面接口
var URL_USERLIST = exports.URL_USERLIST = _env.SERVER + 'user/list'; // userLise页面接口
var URL_USERDELETE = exports.URL_USERDELETE = _env.SERVER + 'user/delete'; // userLise页面接口
var URL_FINDUSER_BYEMAIL = exports.URL_FINDUSER_BYEMAIL = _env.SERVER + 'user/getByEmail';
var POSITIONS_SEARCH = exports.POSITIONS_SEARCH = _env.SERVER + "positions/search"; // dailyReport页面接口 -
// export const RELATIONSHIP_SEACHNODECODE = SERVER + "relationship/seachNodeCode"  // dailyReport页面接口 -
var RELATIONSHIP_SEACHNODECODE = exports.RELATIONSHIP_SEACHNODECODE = _env.SERVER + "relationship2/seachParentId"; // dailyReport页面接口 -

var URL_CREATEUSER = exports.URL_CREATEUSER = _env.SERVER + 'user/create'; // 用户开户页面接口
var URL_FINDUSER = exports.URL_FINDUSER = _env.SERVER + 'user/findUser'; // 用户查看页面接口
var URL_FINDUSERID = exports.URL_FINDUSERID = _env.SERVER + 'user/findUserId'; // 用户修改查询ID
var URL_UPDATEUSER = exports.URL_UPDATEUSER = _env.SERVER + 'user/update'; // 用户开户页面接口

var URL_SINGIN = exports.URL_SINGIN = _env.SERVER + 'user/signin'; //登录
// export const URL_CREATE = SERVER+'sales/create'          //修改销售资料
var URL_CREATE = exports.URL_CREATE = _env.SERVER + 'relationship2/create'; //修改销售资料
var RELATIONSHIP_UPDATEPARENID = exports.RELATIONSHIP_UPDATEPARENID = _env.SERVER + 'relationship2/updateParentId'; //修改销售上级
var RELATIONSHIP_UPDATENODECODE = exports.RELATIONSHIP_UPDATENODECODE = _env.SERVER + 'relationship2/updateNodeCode'; //修改销node_code*

var RELATIONSHIP_SENDEMAILBYUPDATESALES = exports.RELATIONSHIP_SENDEMAILBYUPDATESALES = _env.SERVER + 'relationship2/sendEmailByUpdateSales'; //修改销售密码时发送邮件
// export const URL_UPDATE = SERVER+'sales/update'          //修改销售资料
var URL_UPDATE = exports.URL_UPDATE = _env.SERVER + 'relationship2/update'; //修改销售资料
// export const URL_GETBYID = SERVER+'sales/getById'          //修改
var URL_GETBYID = exports.URL_GETBYID = _env.SERVER + 'relationship2/getSalesById'; //修改返回data
var URL_SIGNOUT = exports.URL_SIGNOUT = _env.SERVER + 'user/signout'; //修改
var URL_CHANGEPWD = exports.URL_CHANGEPWD = _env.SERVER + 'user/changePwd'; //修改密码
var URL_LOGINSALEPLATFORM = exports.URL_LOGINSALEPLATFORM = _env.SERVER + 'user/loginSalePlatform'; //登录销售平台
var URL_FINDNEXTLEVELBYID = exports.URL_FINDNEXTLEVELBYID = _env.SERVER + 'sales/findNextLevelById'; //搜索销售的下一级
var URL_CHANGEPARENTSALES = exports.URL_CHANGEPARENTSALES = _env.SERVER + 'sales/changeLastLevelByIds'; //更改上一级
var URL_GET_PROCESS_STATE = exports.URL_GET_PROCESS_STATE = _env.SERVER + 'sales/processState'; //获取更改上一级进度

// relationship表
// export const URL_CODEVERIFY = SERVER+'relationship/checkNodeCode'  // 开户代码code校验
var URL_CODEVERIFY = exports.URL_CODEVERIFY = _env.SERVER + 'Relationship2/checkNodeCode'; // 开户代码code校验
var URL_GETCODE = exports.URL_GETCODE = _env.SERVER + 'Relationship2/getCodeById'; // 开户代码code校验
// export const URL_LASTCODEVERIFY = SERVER+'relationship/checkParentCode'  // 开户上级代码lastcode校验
var URL_LASTCODEVERIFY = exports.URL_LASTCODEVERIFY = _env.SERVER + 'relationship2/checkParentId'; // 开户上级代码lastcode校验
var URL_RELATION = exports.URL_RELATION = _env.SERVER + 'relationship/list'; //关系树状图
var URL_RELATIONSEARCH = exports.URL_RELATIONSEARCH = _env.SERVER + 'relationship/search'; //查询关系
var URL_RELATION_GETNODEID = exports.URL_RELATION_GETNODEID = _env.SERVER + 'relationship/getNodeId'; //获取账号查询关系
var URL_GET_CLIENT_PARENT_INFO = exports.URL_GET_CLIENT_PARENT_INFO = _env.SERVER + 'relationship/getClientParentInfo';

var URL_UPLOAD = exports.URL_UPLOAD = _env.SERVER + 'files/upload'; //文件上传
var URL_DOWNLOAD = exports.URL_DOWNLOAD = _env.SERVER + 'files/download'; //文件下载

var URL_TESTLOGIN = exports.URL_TESTLOGIN = _env.SERVER + 'testLogIn'; //定时检测是否登录


//添加权限
var URL_FINDALLROLE = exports.URL_FINDALLROLE = _env.SERVER + 'role/getList'; //查询所有的角色
var URL_ADDROLE = exports.URL_ADDROLE = _env.SERVER + 'role/addRole'; //添加角色
var URL_DELETEROLE = exports.URL_DELETEROLE = _env.SERVER + 'role/deleteRole'; //删除角色

var URL_FINDALLPRIVILEGE = exports.URL_FINDALLPRIVILEGE = _env.SERVER + 'privilege/getList'; //查询所有的权限
var URL_SAVEPRIVILEGE = exports.URL_SAVEPRIVILEGE = _env.SERVER + 'privilege/savePrivilege'; //保存权限


//直播间相关接口
var URL_BROADCASTLIST = exports.URL_BROADCASTLIST = _env.SERVER + 'broadcast/getList'; //获取直播间列表
var URL_BROADCAST_CREATE = exports.URL_BROADCAST_CREATE = _env.SERVER + 'broadcast/create'; //添加直播间
var URL_BROADCAST_UPDATE = exports.URL_BROADCAST_UPDATE = _env.SERVER + 'broadcast/update'; //修改直播间
var URL_BROADCAST_DELETE = exports.URL_BROADCAST_DELETE = _env.SERVER + 'broadcast/delete'; //删除直播间


//专属推荐链接接口
var URL_LINKSLIST = exports.URL_LINKSLIST = _env.SERVER + 'sales/getLinks'; //获取专属推荐链接
var URL_LINKSLIST_CREATE = exports.URL_LINKSLIST_CREATE = _env.SERVER + 'sales/createExclusiveLink'; //添加专属推荐链接
var URL_LINKSLIST_DELETE = exports.URL_LINKSLIST_DELETE = _env.SERVER + 'sales/deleteLinks'; //删除专属推荐链接
var URL_LINKSLIST_ADD = exports.URL_LINKSLIST_ADD = _env.SERVER + 'sales/createLink'; //添加代理链接
var URL_LINKSLIST_ENTITY = exports.URL_LINKSLIST_ENTITY = _env.SERVER + 'sales/getLinksEntity'; //获取专属推荐链接 （切换entity时触发）
var URL_MT_SERVER = exports.URL_MT_SERVER = _env.SERVER + 'sales/getMTServer'; //获取平台类型
var URL_MT_GROUP_CONFIG = exports.URL_MT_GROUP_CONFIG = _env.SERVER + 'sales/getMTConfig'; //获取加点佣金杠杆


//销售绑定银行卡
var URL_SALES_BANK_CREATE = exports.URL_SALES_BANK_CREATE = _env.SERVER + 'relationship2/createBank'; //新增
var URL_SALES_BANK_DELETE = exports.URL_SALES_BANK_DELETE = _env.SERVER + 'relationship2/deleteBank'; //删除
var URL_SALES_BANK_LIST = exports.URL_SALES_BANK_LIST = _env.SERVER + 'relationship2/getBankList'; //查询

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(944)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(1140),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(882)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1073),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.export_table_to_excel = export_table_to_excel;
exports.export_json_to_excel = export_json_to_excel;
exports.export_json_to_multi_excel = export_json_to_multi_excel;
/* eslint-disable */
__webpack_require__(967);
__webpack_require__(207);
__webpack_require__(968);

function generateArray(table) {
    var out = [];
    var rows = table.querySelectorAll('tr');
    var ranges = [];
    for (var R = 0; R < rows.length; ++R) {
        var outRow = [];
        var row = rows[R];
        var columns = row.querySelectorAll('td');
        for (var C = 0; C < columns.length; ++C) {
            var cell = columns[C];
            var colspan = cell.getAttribute('colspan');
            var rowspan = cell.getAttribute('rowspan');
            var cellValue = cell.innerText;
            if (cellValue !== "" && cellValue == +cellValue) cellValue = +cellValue;

            //Skip ranges
            ranges.forEach(function (range) {
                if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
                    for (var i = 0; i <= range.e.c - range.s.c; ++i) {
                        outRow.push(null);
                    }
                }
            });

            //Handle Row Span
            if (rowspan || colspan) {
                rowspan = rowspan || 1;
                colspan = colspan || 1;
                ranges.push({ s: { r: R, c: outRow.length }, e: { r: R + rowspan - 1, c: outRow.length + colspan - 1 } });
            };

            //Handle Value
            outRow.push(cellValue !== "" ? cellValue : null);

            //Handle Colspan
            if (colspan) for (var k = 0; k < colspan - 1; ++k) {
                outRow.push(null);
            }
        }
        out.push(outRow);
    }
    return [out, ranges];
};

function datenum(v, date1904) {
    if (date1904) v += 1462;
    var epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function sheet_from_array_of_arrays(data, opts) {
    var ws = {};
    var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
    for (var R = 0; R != data.length; ++R) {
        for (var C = 0; C != data[R].length; ++C) {
            if (range.s.r > R) range.s.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.r < R) range.e.r = R;
            if (range.e.c < C) range.e.c = C;
            var cell = { v: data[R][C] };
            if (cell.v == null) continue;
            var cell_ref = XLSX.utils.encode_cell({ c: C, r: R });

            if (typeof cell.v === 'number') cell.t = 'n';else if (typeof cell.v === 'boolean') cell.t = 'b';else if (cell.v instanceof Date) {
                cell.t = 'n';
                cell.z = XLSX.SSF._table[14];
                cell.v = datenum(cell.v);
            } else cell.t = 's';

            ws[cell_ref] = cell;
        }
    }
    if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    return ws;
}

function Workbook() {
    if (!(this instanceof Workbook)) return new Workbook();
    this.SheetNames = [];
    this.Sheets = {};
}

function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
    }return buf;
}

function export_table_to_excel(id) {
    var theTable = document.getElementById(id);
    console.log('a');
    var oo = generateArray(theTable);
    var ranges = oo[1];

    /* original data */
    var data = oo[0];
    var ws_name = "SheetJS";
    console.log(data);

    var wb = new Workbook(),
        ws = sheet_from_array_of_arrays(data);

    /* add ranges to worksheet */
    // ws['!cols'] = ['apple', 'banan'];
    ws['!merges'] = ranges;

    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;

    var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' });

    saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), "test.xlsx");
}

function formatJson(jsonData) {
    console.log(jsonData);
}
function export_json_to_excel(th, jsonData, defaultTitle) {

    /* original data */

    var data = jsonData;
    data.unshift(th);
    var ws_name = "SheetJS";

    var wb = new Workbook(),
        ws = sheet_from_array_of_arrays(data);

    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;

    var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' });
    var title = defaultTitle || '列表';
    saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), title + ".xlsx");
}
function export_json_to_multi_excel(th, jsonData, sheetNames, defaultTitle) {

    /* original data */
    var wb = new Workbook();
    for (var i = 0; i < jsonData.length; i++) {
        jsonData[i].unshift(th[i]);
        var ws = sheet_from_array_of_arrays(jsonData[i]);
        wb.SheetNames.push(sheetNames[i]);
        wb.Sheets[sheetNames[i]] = ws;
    }

    var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' });
    var title = defaultTitle || '列表';
    saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), title + ".xlsx");
}

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(917)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(1111),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _commissionEnv = __webpack_require__(5);

var api = new _commissionEnv.Api();
exports.default = {
    // dailyReport: {
    //   link: 'dailyReport',
    //   set: false,
    //   icon: 'icon-copy'
    // },
    userList: {
        Role_ID: "A0001",
        link: '/userList',
        set: false,
        icon: 'icon-stack2',
        show: true
    },
    authList: {
        Role_ID: "A0002",
        link: '/authList',
        set: false,
        icon: 'el-icon-warning',
        show: true
    },
    // accountList: {
    //     Role_ID: "A0003",
    //     link: '/accountList',
    //     set: false,
    //     icon: 'icon-stack',
    //     show: true,
    // },
    // relation: {
    //     Role_ID: "A0004",
    //     link: '/relation',
    //     set: false,
    //     icon: 'icon-sort-amount-asc',
    //     show: true,
    // },
    // loginSalePlatform: {
    //     Role_ID: "A0005",
    //     link: "/loginSalePlatform",
    //     set: false,
    //     icon: 'glyphicon glyphicon-user',
    //     show: true,
    // },
    // changeParentSales: {
    //     Role_ID: "A0006",
    //     link: "/changeParentSales",
    //     set: false,
    //     icon: 'glyphicon glyphicon-pencil',
    //     show: true,
    // },
    // clientParentInfo: {
    //     Role_ID: "A0011",
    //     link: "/clientParentInfo",
    //     set: false,
    //     icon: 'glyphicon glyphicon-pencil',
    //     show: true,
    // },
    // commissionView: {
    //     Role_ID: "A0007",
    //     link: '/commissionView',
    //     set: false,
    //     icon: 'glyphicon glyphicon-cog',
    //     show: api.commissionEnable,
    // },
    commissionView_v2: {
        Role_ID: "A0011",
        link: "/commissionView_v2",
        set: false,
        icon: 'glyphicon glyphicon-cog',
        show: true
    },
    profitShareView: {
        Role_ID: "A0008",
        link: '/profitShareView',
        set: false,
        icon: 'glyphicon glyphicon-file',
        show: api.commissionEnable
    },
    changepswd: {
        Role_ID: "A0009",
        link: "/changepswd",
        set: false,
        icon: 'glyphicon glyphicon-cog',
        show: true
    },
    logOut: {
        Role_ID: "A0010",
        link: 'logOut',
        set: false,
        icon: 'glyphicon glyphicon-off',
        show: true
    }
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modal = undefined;

var _uiv = __webpack_require__(14);

var modal = exports.modal = function modal() {
  return {
    data: function data() {
      return {
        modalShow: false,
        modalLink: '',
        modalBool: false
      };
    },

    methods: {
      modalhide: function modalhide() {
        var _this = this;

        setTimeout(function () {
          _this.modalShow = false;
        }, 1200);
      },
      toModalLink: function toModalLink() {
        if (this.modalLink) {
          this.$router.push({
            path: this.modalLink
          });
        }
      }
    },
    watch: {
      modalShow: function modalShow(curVal, oldVal) {
        if (curVal && !this.modalLink) {
          this.modalhide();
        }
      }
    },
    components: {
      Modal: _uiv.Modal
    }
  };
};

/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(1077),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(926)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(1121),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(899)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1093),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(953)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(1150),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f9621510",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SERVER = exports.SERVER = 'https://pj-stapor-spbo10-backend-dev.agile168.com/'; // spbo api url
var VUE_APP_MIDDLE_LAYER_API20 = exports.VUE_APP_MIDDLE_LAYER_API20 = 'https://pj-commis-middle-layer20-dev.agile168.com'; // 佣金中间件, 转发不同区域的佣金请求给对应的服务.
var commissionEnable = exports.commissionEnable = true;
var tabDbType = exports.tabDbType = ["UK", "GM", "MU"];

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = undefined;

var _veeValidate = __webpack_require__(191);

var validate = exports.validate = function validate() {
  // const dictionary = {
  //   en: {
  //     messages: {
  //       email: () => '邮箱格式不正x确哦'
  //     }
  //   }
  // };
  // Validator.updateDictionary(dictionary);
  return {
    methods: {
      addValidator: function addValidator(name, reg, errText) {
        var bool = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

        _veeValidate.Validator.extend(name, {
          messages: { en: errText },
          validate: function validate(value) {
            return bool ? reg.test(value) : !reg.test(value);
          }
        });
      },
      newFileObj: function newFileObj(index, postAction, fileName, imgName, num) {
        var _this = this;

        return {
          files: [],
          accept: 'image/png,image/gif,image/jpeg,image/webp', // 表单的accept属性, MIME type
          size: 1024 * 1024 * 10, // 允许上传的最大字节
          extensions: 'gif,jpg,jpeg,png,webp', // 允许上传的文件后缀   其他用法  ['gif', 'jpg', 'jpeg','png', 'webp']   /\.(gif|jpe?g|png|webp)$/i
          multiple: false, // 是否允许选择多个文件
          directory: false, // 是否是上传文件夹
          drop: false, // 拖拽上传  如果设置成 true 则读取父组件作为容器
          dropDirectory: false, // 拖拽上传  如果设置成 true 则读取父组件作为容器
          thread: 0, // 拖拽上传 如果设置成 true 则读取父组件作为容器
          name: 'file' + index, // input标签的 name 属性
          postAction: postAction, // POST 请求的上传URL
          putAction: '', // PUT 请求的上传URL  如果使用请先填写put
          data: {}, // 传参
          auto: false,
          sel: false,
          selErr: false,
          inputFilter: function inputFilter(newFile, oldFile, prevent) {
            //证件正面照片上传
            _this.$refs["upload" + num].active = true; // 开启上传
            console.log(_this.$refs["upload" + num]);
            _this.formMsgArr[imgName] = _this[fileName].files[0].response.name;
          }
        };
      },
      compareYear: function compareYear(birthday, min) {
        var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        //  this.compareYear(this.$moment("1988-10-5"),18,30)
        var nowDate = this.$moment();
        var year = nowDate.get('year');
        var month = nowDate.get('month') + 1;
        var day = nowDate.get('date');

        var befYear = birthday.get('year');
        var befMonth = birthday.get('month') + 1;
        var befday = birthday.get('date');

        var date = year + '-' + month + '-' + day;
        var beforeDateMin = befYear + min + '-' + befMonth + '-' + (befday - 1);
        if (max) {
          var beforeDateMax = befYear + max + '-' + befMonth + '-' + (befday + 1);
          return this.$moment(date).isBetween(beforeDateMin, beforeDateMax, 'date');
        } else {
          return this.$moment(date).isAfter(beforeDateMin, 'date');
        }
      }
    }
  };
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */
/* Blob.js
 * A Blob implementation.
 * 2014-05-27
 *
 * By Eli Grey, http://eligrey.com
 * By Devin Samarin, https://github.com/eboyjr
 * License: X11/MIT
 *   See LICENSE.md
 */

/*global self, unescape */
/*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
 plusplus: true */

/*! @source http://purl.eligrey.com/github/Blob.js/blob/master/Blob.js */

(function (view) {
    "use strict";

    view.URL = view.URL || view.webkitURL;

    if (view.Blob && view.URL) {
        try {
            new Blob();
            return;
        } catch (e) {}
    }

    // Internally we use a BlobBuilder implementation to base Blob off of
    // in order to support older browsers that only have BlobBuilder
    var BlobBuilder = view.BlobBuilder || view.WebKitBlobBuilder || view.MozBlobBuilder || function (view) {
        var get_class = function get_class(object) {
            return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
        },
            FakeBlobBuilder = function BlobBuilder() {
            this.data = [];
        },
            FakeBlob = function Blob(data, type, encoding) {
            this.data = data;
            this.size = data.length;
            this.type = type;
            this.encoding = encoding;
        },
            FBB_proto = FakeBlobBuilder.prototype,
            FB_proto = FakeBlob.prototype,
            FileReaderSync = view.FileReaderSync,
            FileException = function FileException(type) {
            this.code = this[this.name = type];
        },
            file_ex_codes = ("NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR " + "NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR").split(" "),
            file_ex_code = file_ex_codes.length,
            real_URL = view.URL || view.webkitURL || view,
            real_create_object_URL = real_URL.createObjectURL,
            real_revoke_object_URL = real_URL.revokeObjectURL,
            URL = real_URL,
            btoa = view.btoa,
            atob = view.atob,
            ArrayBuffer = view.ArrayBuffer,
            Uint8Array = view.Uint8Array;
        FakeBlob.fake = FB_proto.fake = true;
        while (file_ex_code--) {
            FileException.prototype[file_ex_codes[file_ex_code]] = file_ex_code + 1;
        }
        if (!real_URL.createObjectURL) {
            URL = view.URL = {};
        }
        URL.createObjectURL = function (blob) {
            var type = blob.type,
                data_URI_header;
            if (type === null) {
                type = "application/octet-stream";
            }
            if (blob instanceof FakeBlob) {
                data_URI_header = "data:" + type;
                if (blob.encoding === "base64") {
                    return data_URI_header + ";base64," + blob.data;
                } else if (blob.encoding === "URI") {
                    return data_URI_header + "," + decodeURIComponent(blob.data);
                }if (btoa) {
                    return data_URI_header + ";base64," + btoa(blob.data);
                } else {
                    return data_URI_header + "," + encodeURIComponent(blob.data);
                }
            } else if (real_create_object_URL) {
                return real_create_object_URL.call(real_URL, blob);
            }
        };
        URL.revokeObjectURL = function (object_URL) {
            if (object_URL.substring(0, 5) !== "data:" && real_revoke_object_URL) {
                real_revoke_object_URL.call(real_URL, object_URL);
            }
        };
        FBB_proto.append = function (data /*, endings*/) {
            var bb = this.data;
            // decode data to a binary string
            if (Uint8Array && (data instanceof ArrayBuffer || data instanceof Uint8Array)) {
                var str = "",
                    buf = new Uint8Array(data),
                    i = 0,
                    buf_len = buf.length;
                for (; i < buf_len; i++) {
                    str += String.fromCharCode(buf[i]);
                }
                bb.push(str);
            } else if (get_class(data) === "Blob" || get_class(data) === "File") {
                if (FileReaderSync) {
                    var fr = new FileReaderSync();
                    bb.push(fr.readAsBinaryString(data));
                } else {
                    // async FileReader won't work as BlobBuilder is sync
                    throw new FileException("NOT_READABLE_ERR");
                }
            } else if (data instanceof FakeBlob) {
                if (data.encoding === "base64" && atob) {
                    bb.push(atob(data.data));
                } else if (data.encoding === "URI") {
                    bb.push(decodeURIComponent(data.data));
                } else if (data.encoding === "raw") {
                    bb.push(data.data);
                }
            } else {
                if (typeof data !== "string") {
                    data += ""; // convert unsupported types to strings
                }
                // decode UTF-16 to binary string
                bb.push(unescape(encodeURIComponent(data)));
            }
        };
        FBB_proto.getBlob = function (type) {
            if (!arguments.length) {
                type = null;
            }
            return new FakeBlob(this.data.join(""), type, "raw");
        };
        FBB_proto.toString = function () {
            return "[object BlobBuilder]";
        };
        FB_proto.slice = function (start, end, type) {
            var args = arguments.length;
            if (args < 3) {
                type = null;
            }
            return new FakeBlob(this.data.slice(start, args > 1 ? end : this.data.length), type, this.encoding);
        };
        FB_proto.toString = function () {
            return "[object Blob]";
        };
        FB_proto.close = function () {
            this.size = this.data.length = 0;
        };
        return FakeBlobBuilder;
    }(view);

    view.Blob = function Blob(blobParts, options) {
        var type = options ? options.type || "" : "";
        var builder = new BlobBuilder();
        if (blobParts) {
            for (var i = 0, len = blobParts.length; i < len; i++) {
                builder.append(blobParts[i]);
            }
        }
        return builder.getBlob(type);
    };
})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined.content || undefined);

/***/ }),
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAgCAYAAAFyR/jpAAAAAXNSR0IArs4c6QAAA7pJREFUSA3tVk1IVFEUvueNOqMyM/ZmlBCEMKhl0A8YBOoiqKBAKFvWonAjLkrUIQghaGayNtUihGjRSqI2BoGEmhBEUQRlGbQqk/Jn8D3TbBzv7Zyr9/ne8804/rQIeos5P993zrm/5w5j+JldFQdJ0qcJIQAy3D8Tj9ZJD/1Mx3VhGWsqQHQf0+qJGYxNDjIzHj2nwlblshzm9cqoZSj6sgQjXn5EsMUnjMEzJyZqAeCM5TMSeo9lLCvZslo8BwEzTFjIsqKRJBYuz103KCeMjGFgWrMCuR9GwxcmPksQgH3EyHEFojzAmCiRNqU1k9HdNlCWkjXLYingnI/YwZw6ZZOR2VhgB6iuSh/WA6XQNDZnx926DBb3dgSM7+avZfABjrHRTfSyYTqhcyaYYwReRLsPNHY53J66IoOmk/phxlkfEXzgqw12TAzZyXb9Z6JiT0Zk3pLPUXE6Hkng4rcTQMtL0utThyIrwStI+VRwzq1Q5GxyY8EAo54JjXjkkxmPnPUEXU5HZQwcF0zsEsDuuHiephVsJCIjGFhOrHDHVMCT7XLKYNyiQbxq8kqEO1p8Lk5WE8xE5BEXooEYBYwdFUyb92JTkwtWV7yExuG0wuVNVUY+Eg9GJhxLFRIXcK7zOGQ/XnVqEkPZEiDuR0KNwukEyhNmxPXf2GWLgMF8ODZVrAheEltUWgiGlbUmuWA4DD8RcbUDtF1eQcoHrKBO6sAvOc62OrM4m9dlsan9KsAtFc/aZyKobaL5uwO8bNydlQ+gk6PlGM0KulpzVF4N5/b8i8F4p3Muzuy16N6FRTGAJyBEs0dyOqQHtq3Vz3Ov1BLq2CkVMHejsiqdnn++sMirlE9KjbVvRVHK5ZixuKmHjFnoxxnucxRkrBvvUJPLtylTFhYDdQXmi3cP8UqdsGfD+9kX2rn9uL112PHN6GAmI/2ci/rNJMkeCybOrFcrFFeDrakPdh61r5/Ylkrtzr+l4/+1W/gctFB+udRGUq/BnvkUO6c1AAQy4NMaQm2TjzcyELl9r96fEosCH62lW7FUEH6EdH+1LKwSzyT1k5yzHuxctu4AZqEP6kvbJt8o3nol/uHpwnbYquJw5r2OwgrAd6sN362ksqUE9qWoMHCo5OLYV4c/D0Mko0GDc1NRsWjas7Ai4Ei7caTnlU1SCxZHQ83fpuy+fHT1PihuzsJEEqJTM7tun2Zc6KEScR9aUtbIVZJ85LoL55M0H467sO0Q5RO+dZz/hbduLV2ZAHzHGP23prcY9T9JxFk5TGzZEAAAAABJRU5ErkJggg=="

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(913)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(1107),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(888)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(1080),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(902)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(1096),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */,
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(20);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(989);

var _App2 = _interopRequireDefault(_App);

var _index = __webpack_require__(591);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(592);

var _index4 = _interopRequireDefault(_index3);

var _axios = __webpack_require__(444);

var _axios2 = _interopRequireDefault(_axios);

var _veeValidate = __webpack_require__(191);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _vueClipboards = __webpack_require__(987);

var _vueClipboards2 = _interopRequireDefault(_vueClipboards);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _elementUi = __webpack_require__(856);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(874);

var _Blob = __webpack_require__(207);

var _Blob2 = _interopRequireDefault(_Blob);

var _Export2Excel = __webpack_require__(65);

var _Export2Excel2 = _interopRequireDefault(_Export2Excel);

var _en = __webpack_require__(859);

var _en2 = _interopRequireDefault(_en);

var _zhCN = __webpack_require__(268);

var _zhCN2 = _interopRequireDefault(_zhCN);

var _zhTW = __webpack_require__(860);

var _zhTW2 = _interopRequireDefault(_zhTW);

var _vueI18n = __webpack_require__(988);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueI18n2.default);
var msg = {
    en: (0, _extends3.default)({}, _en2.default),
    cn: (0, _extends3.default)({}, _zhCN2.default),
    hk: (0, _extends3.default)({}, _zhTW2.default)
};
var _i18n = new _vueI18n2.default({ locale: 'en', messages: msg });
_vue2.default.use(_elementUi2.default, {
    i18n: function i18n(key, value) {
        return _i18n.t(key, value);
    }
});

_vue2.default.use(_vueClipboards2.default);
_vue2.default.use(_veeValidate2.default);
_vue2.default.prototype.$http = _axios2.default;
_vue2.default.prototype.$moment = _moment2.default;
_vue2.default.prototype.$ALLNUM = 20000;
_axios2.default.defaults.withCredentials = true;
_vue2.default.config.productionTip = false;

// require("common/js/uitl").reveal()    //  暴露公用方法
__webpack_require__(197); //  兼容ie9
__webpack_require__(579); // 引入翻译

/* eslint-disable no-new */
new _vue2.default({
    el: '#app',
    router: _index2.default,
    store: _index4.default,
    i18n: _i18n,
    render: function render(h) {
        return h(_App2.default);
    }
});
// Object.prototype.mapEach = function(fn){
//     let keys = Object.keys(this)
//     console.log(fn(this))
//     keys.forEach(item => this[item] = '111')
//     // keys.forEach((item,index) => fn({[item]: this[item]}, item, this[item]))
//     return keys
// }
// var o = {name:'jack',jn:'nodejs'}

// console.log(o.mapEach(m => o[m]))
// console.log(o)

/***/ }),
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(24);

var _veeValidate = __webpack_require__(191);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      lastOperationTime: new Date().getTime(),
      currentTime: new Date().getTime(),
      tOut: 10 * 60 * 1000
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(["USER", "LANGUAGE", "PAGEMAXINDEX"])),
  beforeCreate: function beforeCreate() {
    var _this = this;

    if (this.$route.redirectedFrom && this.$route.redirectedFrom.indexOf('fromSpbo2') > 0) {
      var info = atob(this.$router.currentRoute.query.info);
      var obj = JSON.parse(info);
      this.$http.interceptors.request.use(function (conf) {
        conf.headers['spbo2_auth'] = obj.auth;
        return conf;
      });
      sessionStorage.user = (0, _stringify2.default)(obj.user);
      var area20 = obj.area20;
      sessionStorage.area20 = (0, _stringify2.default)(area20);
      sessionStorage.profitshare_area = (0, _stringify2.default)(profitshare_area);
      var currentArea20 = {
        group: profitshare_area[0],
        value: area20[0]
      };
      sessionStorage.currentArea20 = (0, _stringify2.default)(currentArea20);
      sessionStorage.fromSpbo2 = true;
      window.addEventListener("message", function (e) {
        if (['cn', 'en', 'hk'].indexOf(e.data) >= 0) {
          _this.SAVELANGUAGE(e.data);
          localStorage.language = e.data;
        }
      });
      this.$nextTick(function () {
        _this.SAVELANGUAGE(obj.lang);
        localStorage.language = obj.lang;
      });
      return;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.SAVELANGUAGE(localStorage.language || "cn");
    this.SAVEPAGEMAXINDEX(localStorage.pageMaxIndex || 0);
    this.SAVEUSER(sessionStorage.user);

    if (!this.USER) {
      // this.$router.push("/login")
      this.$router.push(this.$route.query.link ? '/login?link=' + this.$route.query.link : '/login');
    }

    document.body.addEventListener("click", function () {
      _this2.lastOperationTime = new Date().getTime();
    });

    window.setInterval(this.tTime, 10000);
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(["SAVELANGUAGE", "SAVEUSER", "SAVEPAGEMAXINDEX"]), {
    tTime: function tTime() {
      if (sessionStorage.fromSpbo2) return;
      this.currentTime = new Date().getTime();
      if (this.currentTime - this.lastOperationTime > this.tOut) {
        sessionStorage.clear();
        this.$router.push({ path: '/' });
      }
    }
  })
};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _menuAllList = __webpack_require__(105);

var _menuAllList2 = _interopRequireDefault(_menuAllList);

var _api = __webpack_require__(40);

var _lodash = __webpack_require__(956);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [__webpack_require__(3).base({ registerLan: "authOption" }), __webpack_require__(3).base({ sidebarLan: "sidebarList" }), __webpack_require__(3).base({ sidebarLan1: "tableModelAuthList" }), __webpack_require__(3).base({ addRoleDialogLan: "addRoleDialog" })],
  data: function data() {
    var _this = this;

    var validateNo = function validateNo(rule, value, callback) {
      if (!value.trim() || value == "") {
        callback(new Error(_this.addRoleDialogLan.not_empty));
        return;
      }
      var titleReg = /^[a-zA-Z0-9_-]{4,16}$/;
      if (!titleReg.test(value)) {
        callback(new Error(_this.addRoleDialogLan.roleNameError));
        return;
      }
      callback();
    };
    var validateDesc = function validateDesc(rule, value, callback) {
      if (!value.trim() || value == "") {
        callback(new Error(_this.addRoleDialogLan.not_empty));
        return;
      }
      callback();
    };
    return {
      dialogVisible: false,
      formLabelAlign: {
        Role_No: '',
        Desc: ''
      },
      selectBool: false,
      defaultProps: {
        label: 'label'
      },
      list: [],
      rules: {
        Role_No: [{ required: true, validator: validateNo, trigger: 'change' }],
        Desc: [{ required: true, validator: validateDesc, trigger: 'change' }] }
    };
  },

  computed: {
    data2: function data2() {
      var data = [];
      // this.data2 = sidebarList;
      for (var key in _menuAllList2.default) {
        _menuAllList2.default[key].label = this.sidebarLan[key].text;
        _menuAllList2.default[key].name = key;
        data.push(_menuAllList2.default[key]);
      }
      return data;
    }
  },
  methods: {
    setCheckedNodes: function setCheckedNodes() {
      //全选
      if (!this.selectBool) {
        this.$refs.tree.setCheckedNodes(this.data2);
        this.selectBool = true;
      } else {
        this.$refs.tree.setCheckedKeys([]); //清空
        this.selectBool = false;
      }
    },
    setCheckedKeys: function setCheckedKeys() {
      this.$refs.tree.setCheckedKeys();
    },
    submit: function submit() {},
    submitForm: function submitForm(formName) {
      var _this2 = this;

      var obj = _lodash2.default.find(this.list, function (item) {
        return item.Role_ID == _this2.formLabelAlign.Role_No;
      });
      if (obj) {
        return this.$message.error(this.addRoleDialogLan.role_exists);
      }
      var nodes = this.$refs.tree.getCheckedKeys();
      if (nodes.length === 0) return this.$message.error(this.addRoleDialogLan.select_one_option);
      var data = { "role": this.formLabelAlign.Role_No, "Desc": this.formLabelAlign.Desc, "prioritys": nodes };
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.$http.post(_api.URL_ADDROLE, data).then(function (res) {
            _this2.$emit("addRefresh");
            _this2.$refs[formName].resetFields();
            if (res.data.code == 700) {
              _this2.$message.error(_this2.addRoleDialogLan.role_exists);
            }
            _this2.handleClose();
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleClose: function handleClose() {
      this.$refs["ruleForm"].resetFields();
      this.dialogVisible = false;
      this.selectBool = false;
      this.$refs.tree.setCheckedKeys([]); //清空
    },
    open: function open(list) {
      this.list = list;
      this.dialogVisible = true;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _authList_box_ = __webpack_require__(992);

var _authList_box_2 = _interopRequireDefault(_authList_box_);

var _authList_box_3 = __webpack_require__(993);

var _authList_box_4 = _interopRequireDefault(_authList_box_3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  props: {
    lang: {},
    auth_list: {}
  },
  components: {
    box_1: _authList_box_2.default,
    box_2: _authList_box_4.default
  },
  data: function data() {
    return {
      list_opt_data: [{ right_id: "A0001", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false }, { right_id: "A0002", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false }, { right_id: "A0003", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false }, { right_id: "A0004", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false }, { right_id: "A0005", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false }, { right_id: "A0006", label: "", entity: ["UK", "GM", "MU", "EU"], current_entity: [], entity_auth_swich: true, check: false }, { right_id: "A0007", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false }, { right_id: "A0008", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false }, { right_id: "A0009", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false }, { right_id: "A0010", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false }, { right_id: "A0011", label: "", entity: ["UK", "GM", "MU"], current_entity: ["UK"], entity_auth_swich: false, check: false }],
      data_list: [],
      show_list_opt_data: []
    };
  },

  watch: {
    lang: {
      handler: function handler(val) {
        this.update_lang();
      },
      deep: true
    }
  },
  methods: {
    init_data: function init_data() {
      this.update_lang();
      this.add_auth();
    },
    add_auth: function add_auth() {
      var _this = this;

      this.auth_list.forEach(function (item) {
        for (var i = 0; i < _this.show_list_opt_data.length; i++) {
          if (item.right_id == _this.show_list_opt_data[i].right_id) {
            _this.show_list_opt_data[i].check = true;
            _this.show_list_opt_data[i].current_entity = item.entity;
          }
        }
      });
      this.data_list = JSON.parse((0, _stringify2.default)(this.show_list_opt_data));
    },
    update_lang: function update_lang() {
      var _this2 = this;

      this.lang.forEach(function (item) {
        for (var i = 0; i < _this2.list_opt_data.length; i++) {
          if (item.right_id == _this2.list_opt_data[i].right_id) {
            _this2.list_opt_data[i].label = item.text;
            _this2.show_list_opt_data.push(_this2.list_opt_data[i]);
          }
        }
      });
      this.data_list = JSON.parse((0, _stringify2.default)(this.show_list_opt_data));
    },
    box_type: function box_type(item) {
      if (item.entity_auth_swich) {
        return "box_2";
      } else {
        return "box_1";
      }
    },
    update_data: function update_data(val) {
      for (var i = 0; i < this.show_list_opt_data.length; i++) {
        if (val.right_id == this.data_list[i].right_id) {
          this.show_list_opt_data[i].check = val.check;
          this.show_list_opt_data[i].current_entity = val.entity;
          this.data_list[i].check = val.check;
          this.data_list[i].current_entity = val.entity;
          break;
        }
      }
    },
    data_change: function data_change(val) {
      this.update_data(val);
    },

    // 全选
    Check_All: function Check_All() {
      this.show_list_opt_data.forEach(function (item, key) {
        item.check = true;
        if (item.entity_auth_swich) {
          item.current_entity = item.entity;
        }
      });
      this.data_list = JSON.parse((0, _stringify2.default)(this.show_list_opt_data));
    },

    // 清空
    Clear_All: function Clear_All() {
      this.show_list_opt_data.forEach(function (item, key) {
        item.check = false;
        if (item.entity_auth_swich) {
          item.current_entity = [];
        }
      });
      this.data_list.forEach(function (item, key) {
        item.check = false;
        if (item.entity_auth_swich) {
          item.current_entity = [];
        }
      });
    },

    // 重置数据
    Reset_Data: function Reset_Data() {
      this.Clear_All();
      // this.init_data();
    },

    // 获取数据
    Get_Data: function Get_Data() {
      var _temp = [];
      this.data_list.forEach(function (item, index) {
        if (item.check) {
          _temp.push({
            right_id: item.right_id,
            entity: item.current_entity
          });
        }
      });
      return _temp;
    }
  },
  mounted: function mounted() {
    this.init_data();
  }
};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    box_data: {}
  },
  data: function data() {
    return {
      check_data: []
    };
  },
  mounted: function mounted() {
    this.init_data();
  },

  watch: {
    "box_data.check": function box_dataCheck(val) {
      this.init_data();
    }
  },
  methods: {
    init_data: function init_data() {
      console.log('this.box_data', this.box_data);
      if (this.box_data.check) {
        this.check_data.push(this.box_data.right_id);
      } else {
        this.check_data = [];
      }
    },
    data_change: function data_change(val) {
      this.$emit("check_change", this.Get_Data());
    },
    Get_Data: function Get_Data() {
      var _temp = {
        right_id: this.box_data.right_id,
        entity: this.box_data.current_entity,
        check: false
      };
      if (this.check_data.length != 0) {
        _temp.check = true;
        return _temp;
      } else {
        return _temp;
      }
    }
  }
};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    box_data: {}
  },
  data: function data() {
    return {
      entity_data: this.box_data.current_entity,
      checkAll: false,
      isIndeterminate: true
    };
  },

  watch: {
    "box_data.current_entity": function box_dataCurrent_entity(val) {
      this.entity_data = this.box_data.current_entity;
      this.checked_change(this.entity_data, "init");
    }
  },
  methods: {
    check_all_change: function check_all_change(val) {
      this.entity_data = val ? this.box_data.entity : [];
      this.isIndeterminate = false;
      this.checked_change(this.entity_data);
    },
    checked_change: function checked_change() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.entity_data;
      var type = arguments[1];

      var checkedCount = val.length;
      this.checkAll = checkedCount === this.box_data.entity.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.box_data.entity.length;
      if (!type) {
        this.$emit("check_change", this.Get_Data());
      }
    },
    Get_Data: function Get_Data() {
      var _temp = {
        right_id: this.box_data.right_id,
        entity: this.entity_data,
        check: false
      };
      if (this.isIndeterminate) {
        _temp.check = true;
      } else if (this.box_data.entity.length == _temp.entity.length) {
        _temp.check = true;
      }
      return _temp;
    }
  },
  mounted: function mounted() {
    this.checked_change(this.entity_data, "init");
  }
};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _addRoleDialog = __webpack_require__(990);

var _addRoleDialog2 = _interopRequireDefault(_addRoleDialog);

var _noData = __webpack_require__(64);

var _noData2 = _interopRequireDefault(_noData);

var _vueUploadComponent = __webpack_require__(130);

var _vueUploadComponent2 = _interopRequireDefault(_vueUploadComponent);

var _uiv = __webpack_require__(14);

var _vuex = __webpack_require__(24);

var _api = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    thData: { // 表格th数据
      type: Array,
      default: []
    },
    trData: {}, // 表格tr数据
    totalData: {
      default: false
    },
    handle: {
      default: false
    },
    multiLanguage: { // 翻译，也是文字型数据
      type: Object,
      default: {}
    },
    trCls: { // tr class
      default: false
    }
  },
  data: function data() {
    return {
      deleteCol: { // 删除功能
        switch: false,
        list: []
      },
      totalTr: {}
    };
  },
  mounted: function mounted() {},

  computed: {
    trDataKeys: function trDataKeys() {
      return (0, _keys2.default)(this.trData[0]);
    }
  },
  methods: (0, _extends3.default)({
    addRole: function addRole() {
      //TODO 打开弹框
      this.$refs["RoleDialog"].open(this.trData);
    },
    addRefresh: function addRefresh() {
      this.$emit("addRefresh");
    },
    deletePitch: function deletePitch(item) {
      if (this.deleteCol.switch === false) {
        return;
      }
      var id = item[this.handle.idKey];
      var index = this.deleteCol.list.indexOf(id);
      if (index === -1) {
        this.deleteCol.list.push(id);
      } else {
        this.deleteCol.list.splice(index, 1);
      }
    },
    deleteColNotarizeFn: function deleteColNotarizeFn() {
      this.deleteCol.switch = false;
      this.$emit("deleteList", this.deleteCol.list);
      this.deleteCol.list = [];
    },
    clickColFn: function clickColFn(colItem, index) {
      this.$emit("clickCol", colItem, index);
    },
    linkRegister: function linkRegister(item) {
      var _this = this;

      if (this.deleteCol.switch === true) {
        this.deletePitch(item);
        return;
      }
      this.$http.post(_api.URL_FINDALLPRIVILEGE, { "role": item.Role_ID }).then(function (res) {
        if (res.data.data) {
          var data = res.data.data;
          var _temp_list = [];
          data.forEach(function (item) {
            _temp_list.push(item.right_id + "$" + item.entity);
          });
          _this.$router.push({
            path: _this.handle.link,
            query: {
              Role_ID: item[_this.handle.idKey],
              data: _temp_list
            }
          });
        }
      });
    }
  }, (0, _vuex.mapMutations)(["SAVEPAGEMAXINDEX"])),
  watch: {},
  components: {
    fileUpload: _vueUploadComponent2.default,
    Dropdown: _uiv.Dropdown,
    noData: _noData2.default, RoleDialog: _addRoleDialog2.default
  }
};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _typeof2 = __webpack_require__(66);

var _typeof3 = _interopRequireDefault(_typeof2);

var _commissionEnv = __webpack_require__(5);

var _util = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
  data: function data() {
    return {
      UTCDIFF: (0, _util.getTimeDiff)(),
      meta: [],
      data: []
      // keys: {}
    };
  },

  props: {
    multiLanguage: {
      type: Object,
      default: {}
    },
    button_text: {
      type: String,
      default: "Download Excel"
    },
    name: {
      type: String,
      default: "data.xlsx"
    },
    keys: {
      default: Array
    },
    ajaxUrl: {
      default: false
    },
    label: {
      default: false
    },
    ajaxGetKey: {
      default: false
    },
    ajaxPar: {
      default: {}
    },
    ajaxType: {
      default: "get"
    },
    colData: {
      default: false
    },
    mainAcc: {
      default: ''
    },
    reqData: {
      default: false
    }
  },
  mounted: function mounted() {},

  computed: {
    id_name: function id_name() {
      var now = new Date().getTime();
      return "export_" + now;
    }
  },
  methods: {
    emitXmlHeader: function emitXmlHeader() {
      var headerRow = "<tr>\n";
      // for (var colName in this.keys) {
      //   headerRow += "  <th style="text-align: left;">\n";
      //   headerRow += colName + "\n";
      //   headerRow += "  </th>\n";
      // }
      this.keys.forEach(function (item) {
        headerRow += "  <th style='text-align: left;'>\n";
        headerRow += item + "\n";
        headerRow += "  </th>\n";
      });

      headerRow += "</tr>\n";
      // var metatags = null
      // this.meta.forEach(function (element) {
      //   metatags += "<meta "
      //   element.forEach(function (m) {
      //     metatags += m.key + "='" + m.value + "' "
      //   })
      //   metatags += ">"
      // })
      return "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'><head>" + "<meta http-equiv='Content-Type' content='text/html; charset=utf-8'>" + "<!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Data</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>\n" + "<thead>\n\n" + headerRow + "</thead>\n\n" + "</tbody>\n";
    },
    emitXmlFooter: function emitXmlFooter() {
      return "\n</tbody>\n" + "</table>\n" + "</body>\n" + "</html>\n";
    },

    jsonToHtml: function jsonToHtml(jsonObject) {
      var row = null;
      var col = null;
      var xml = null;
      var data = (typeof jsonObject === 'undefined' ? 'undefined' : (0, _typeof3.default)(jsonObject)) !== "object" ? JSON.parse(jsonObject) : jsonObject;
      xml = this.emitXmlHeader();
      // console.log(JSON.stringify(data))
      for (row = 0; row < data.length; row++) {
        xml += "<tr>\n";

        for (col in data[row]) {
          xml += "  <td style='text-align: left;'>\n";
          xml += (String(data[row][col]) ? String(data[row][col]) : "") + "\n";
          xml += "  </td>\n";
        }
        xml += "</tr>\n";
      }
      xml += this.emitXmlFooter();
      return xml;
    },
    generate_excel: function generate_excel() {
      var _this = this;

      var uri = "data:application/vnd.ms-excel;base64,";
      var base64 = function base64(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      };
      if (this.ajaxUrl) {
        var ajaxPar = this.ajaxType === "post" ? this.ajaxPar : { params: this.ajaxPar, headers: { UTCDIFF: this.UTCDIFF } };
        this.$http[this.ajaxType](this.ajaxUrl, ajaxPar).then(function (res) {
          if (_this.label == 'getSalesInfo') {
            var result = res.data.data.sales_info;
            var formatData = [];
            result.forEach(function (element) {
              formatData.push({
                sales_id: element.sales_id,
                acc_name: element.acc_name,
                phone: element.phone,
                email: element.email,
                remark: element.remark,
                officeState: _this.multiLanguage.th.employeeState[element.officeState],
                last_update: (0, _util.updateTimeByUtc)(_this.UTCDIFF, element.last_update),
                status: element.status == 0 ? _this.multiLanguage.isSetting.unsated : element.status == 1 ? _this.multiLanguage.isSetting.unchecked : _this.multiLanguage.isSetting.checked
              });
            });
            _this.data = formatData;
            var href = uri + base64(_this.jsonToHtml(_this.data));
            window.location.href = href;
          } else if (_this.label == 'allCommissionReport') {
            var data = res.data.data.data;
            var arr = [];
            data.forEach(function (item) {
              item.internalCommissionReturn = '';
              item.cpaCommissionReturn = '';
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = (0, _getIterator3.default)(item.first), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var code = _step.value;

                  item.internalCommissionReturn += code + ' ' + _this.multiLanguage.unit + ' / ';
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = (0, _getIterator3.default)(item.cpa), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _code = _step2.value;

                  item.cpaCommissionReturn += _code + ' ' + _this.multiLanguage.unit + ' / ';
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              var obj = {};
              obj['type'] = _this.multiLanguage[item.type];
              obj['account'] = item.ibId;
              obj['name'] = item.name;
              obj['commissionReturn'] = item.mode == 1 ? _this.multiLanguage.CPACommission + ' : ' + item.cpaCommissionReturn : item.mode == 0 ? _this.multiLanguage.internalCommission + ' : ' + item.internalCommissionReturn : item.mode == 2 ? _this.multiLanguage.internalCommission + ' : ' + item.internalCommissionReturn + ' + ' + _this.multiLanguage.CPACommission + ' : ' + item.cpaCommissionReturn : '';
              arr.push(obj);
            });
            _this.data = arr;
            var href = uri + base64(_this.jsonToHtml(_this.data));
            window.location.href = href;
          } else {
            // salesCommissionSettingPreview
            var _arr = [];
            res.data.data.data.forEach(function (item) {
              var obj = {};
              obj['mainAcc'] = _this.mainAcc;
              obj['subordinateType'] = _this.multiLanguage.type[item.type];
              obj['subordinateAccount'] = item.account;
              obj['subordinateName'] = item.name;
              obj['relationType'] = _this.multiLanguage.relationType[item.relationType];
              obj['condition'] = '';
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = (0, _getIterator3.default)(item.condition), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var val = _step3.value;

                  obj['condition'] += (val.clientType == 1 ? _this.multiLanguage.clientType.IBClient : val.clientType == 2 ? _this.multiLanguage.clientType.directClient : '') + ' ';
                  var _iteratorNormalCompletion4 = true;
                  var _didIteratorError4 = false;
                  var _iteratorError4 = undefined;

                  try {
                    for (var _iterator4 = (0, _getIterator3.default)(_this.reqData), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                      var d = _step4.value;

                      if (val.ruleId == d.ruleId) {
                        obj['condition'] += _this.multiLanguage.rule[d.langKey.split('.')[1]] + ' : ';
                        obj['condition'] += val.value + ';';
                      }
                    }
                  } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                      }
                    } finally {
                      if (_didIteratorError4) {
                        throw _iteratorError4;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }

              _arr.push(obj);
            });
            _this.data = _arr;
            var href = uri + base64(_this.jsonToHtml(_this.data));
            // a.href = href
            // a.download = this.name;
            window.location.href = href;
          }
        });
      } else if (this.colData) {
        this.data = this.colData;
        var href = uri + base64(this.jsonToHtml(this.data));
        window.location.href = href;
      }
    }
  }
};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _uiv = __webpack_require__(14);

var _vuex = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = { // :class="'hide': Object.keys(seekDropdown.list).length == 1"
  props: ["seekDropdown", "hideBtn"],
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  computed: (0, _extends3.default)({
    seekLan: function seekLan() {
      return this.translate(this.LANGUAGE, "commissionSeek");
    }
  }, (0, _vuex.mapState)(["LANGUAGE"])),
  methods: {
    emitSeek: function emitSeek() {
      this.$emit("seek", this.seekDropdown.seekStr);
    },
    setSeekDropdown: function setSeekDropdown(index) {
      if (this.$parent.seekDropdownProps) {
        this.$parent.seekDropdownProps.active = index;
      } else if (this.$parent.seekDropdown) {
        this.$parent.seekDropdown.active = index;
      }
    }
  },
  components: {
    Dropdown: _uiv.Dropdown
  }
};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    crumbs: {
      type: Object
    }
  }
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = __webpack_require__(24);

var _uiv = __webpack_require__(14);

var _api = __webpack_require__(40);

exports.default = {
  mixins: [__webpack_require__(3).base({ headerLan: "header" })],
  data: function data() {
    return {
      user: JSON.parse(sessionStorage.user),
      setLanguageShow: false,
      isLogOut: false,
      menunum: 0,
      language: ''
    };
  },
  mounted: function mounted() {},

  computed: {
    languageImage: function languageImage() {
      return '/static/limitless/assets/images/flags/' + this.LANGUAGE + '.png';
    }
  },
  methods: {
    sureFn: function sureFn() {
      var that = this; //确定退出登录按钮
      this.isLogOut = !this.isLogOut;
      that.$http.get(_api.URL_SIGNOUT, {
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) {
        console.log(res);
        if (res.data.code == '0') {
          that.$router.push({
            path: 'login'
          });
        } else {
          alert(res.data.msg);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    noFn: function noFn() {
      ////取消退出登录按钮
      this.isLogOut = !this.isLogOut;
    },
    logOutFn: function logOutFn() {
      //退出登录
      this.isLogOut = !this.isLogOut;
    },
    changeLanguage: function changeLanguage(language) {
      this.SAVELANGUAGE(language);
      localStorage.language = language;
    }
  },
  components: {
    Dropdown: _uiv.Dropdown
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(66);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      meta: [],
      data: []
      // keys: {}
    };
  },

  props: {
    button_text: {
      type: String,
      default: "Download Excel"
    },
    name: {
      type: String,
      default: "data.xlsx"
    },
    keys: {
      default: Array
    },
    ajaxUrl: {
      default: false
    },
    ajaxGetKey: {
      default: false
    },
    ajaxPar: {
      default: {}
    },
    ajaxType: {
      default: "get"
    },
    colData: {
      default: false
    }
  },
  mounted: function mounted() {},

  computed: {
    id_name: function id_name() {
      var now = new Date().getTime();
      return "export_" + now;
    }
  },
  methods: {
    emitXmlHeader: function emitXmlHeader() {
      var headerRow = "<tr>\n";
      // for (var colName in this.keys) {
      //   headerRow += "  <th style="text-align: left;">\n";
      //   headerRow += colName + "\n";
      //   headerRow += "  </th>\n";
      // }
      this.keys.forEach(function (item) {
        headerRow += "  <th style='text-align: left;'>\n";
        headerRow += item + "\n";
        headerRow += "  </th>\n";
      });

      headerRow += "</tr>\n";
      // var metatags = null
      // this.meta.forEach(function (element) {
      //   metatags += "<meta "
      //   element.forEach(function (m) {
      //     metatags += m.key + "='" + m.value + "' "
      //   })
      //   metatags += ">"
      // })
      return "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'><head>" + "<!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Data</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>\n" + "<thead>\n\n" + headerRow + "</thead>\n\n" + "</tbody>\n";
    },
    emitXmlFooter: function emitXmlFooter() {
      return "\n</tbody>\n" + "</table>\n" + "</body>\n" + "</html>\n";
    },

    jsonToHtml: function jsonToHtml(jsonObject) {
      var row = null;
      var col = null;
      var xml = null;
      var data = (typeof jsonObject === "undefined" ? "undefined" : (0, _typeof3.default)(jsonObject)) !== "object" ? JSON.parse(jsonObject) : jsonObject;
      xml = this.emitXmlHeader();

      for (row = 0; row < data.length; row++) {
        xml += "<tr>\n";

        for (col in data[row]) {
          xml += "  <td style='text-align: left;'>\n";
          xml += (String(data[row][col]) ? String(data[row][col]) : "") + "\n";
          xml += "  </td>\n";
        }
        xml += "</tr>\n";
      }
      xml += this.emitXmlFooter();
      return xml;
    },
    generate_excel: function generate_excel() {
      var _this = this;

      var uri = "data:application/vnd.ms-excel;base64,";
      var base64 = function base64(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      };

      if (this.ajaxUrl) {
        var ajaxPar = this.ajaxType === "post" ? this.ajaxPar : { params: this.ajaxPar };
        this.$http[this.ajaxType](this.ajaxUrl, ajaxPar).then(function (res) {
          var getVal = function getVal(obj, arr) {
            if (arr.length > 1) {
              return getVal(obj[arr[0]], arr.slice(1));
            } else {
              return obj[arr[0]];
            }
          };
          console.log(res);
          _this.data = getVal(res, _this.ajaxGetKey);

          var href = uri + base64(_this.jsonToHtml(_this.data));
          // a.href = href
          // a.download = this.name;
          window.location.href = href;
        });
      } else if (this.colData) {
        this.data = this.colData;
        var href = uri + base64(this.jsonToHtml(this.data));
        window.location.href = href;
      }
    }
  }
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    label: {
      type: String,
      default: ""
    },
    errTexrt: {
      type: String,
      default: ""
    },
    errBool: {
      type: Boolean,
      default: false
    },
    col: {},
    labelCol: {
      default: "2"
    },
    contentCol: {
      default: "10"
    }
  }
};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _seek = __webpack_require__(419);

var _seek2 = _interopRequireDefault(_seek);

var _selPage = __webpack_require__(82);

var _selPage2 = _interopRequireDefault(_selPage);

var _seekDatePicker = __webpack_require__(194);

var _seekDatePicker2 = _interopRequireDefault(_seekDatePicker);

var _noData = __webpack_require__(64);

var _noData2 = _interopRequireDefault(_noData);

var _vueUploadComponent = __webpack_require__(130);

var _vueUploadComponent2 = _interopRequireDefault(_vueUploadComponent);

var _uiv = __webpack_require__(14);

var _jsonExcel = __webpack_require__(996);

var _jsonExcel2 = _interopRequireDefault(_jsonExcel);

var _vuex = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    thData: { // 表格th数据
      type: Array,
      default: []
    },
    trData: {}, // 表格tr数据
    totalData: {
      default: false
    },
    handle: {
      default: false
    },
    multiLanguage: { // 翻译，也是文字型数据
      type: Object,
      default: {}
    },
    selPage: { // 显示条目数
      default: false
    },
    seekDropdown: { // 搜索目标选项
      default: false
    },
    page: { // 分页
      default: false
    },
    jsonExcelAjax: { // 下载Excel
      default: false
    },
    sort: { // 排序
      default: false
    },
    seekDatePicker: { // 时间搜索
      default: false
    },
    trCls: { // tr class
      default: false
    }
  },
  data: function data() {
    return {
      pageactive: this.page ? this.page.active : "",
      seekDropdownProps: this.seekDropdown ? this.seekDropdown : "",
      deleteCol: { // 删除功能
        switch: false,
        list: []
      },
      totalTr: {}
    };
  },
  mounted: function mounted() {
    this.totalData && this.total();
    if (this.selPage && !this.selPage.active) this.$parent.selPage.active = 0;
  },

  computed: {
    trDataKeys: function trDataKeys() {
      return (0, _keys2.default)(this.trData[0]);
    }
  },
  methods: (0, _extends3.default)({
    total: function total() {
      var _this = this;

      if (!this.totalData || !this.totalData.length) return;
      var keys = (0, _keys2.default)(this.totalData[0]);
      var obj = {};
      this.totalData.forEach(function (item) {
        keys.forEach(function (key, keyIndex) {
          if (Object.prototype.toString.call(item[key]) === "[object Number]" && keyIndex !== 0) {
            if (!obj[key] && obj[key] !== 0) obj[key] = 0;
            obj[key] += item[key];
          } else if (Object.prototype.toString.call(item[key]) === "[object String]") {
            obj[key] = "#";
          } else if (keyIndex === 0) {
            obj[key] = _this.multiLanguage.total;
          }
        });
      });
      (0, _keys2.default)(obj).forEach(function (key) {
        if (Object.prototype.toString.call(obj[key]) === "[object Number]") {
          obj[key] = +obj[key].toFixed(2);
        }
      });
      this.totalTr = obj;
    },
    sortFn: function sortFn(key) {
      if (!this.sort || this.$parent.sort.key !== key) return;
      if (this.sort.method === "ASC") {
        this.$parent.sort.method = "DESC";
      } else if (this.sort.method === "DESC") {
        this.$parent.sort.method = "ASC";
      }
      this.$emit("tableChange");
    },
    clickSeekDropdown: function clickSeekDropdown(index) {
      this.$emit("clickSeekDropdown", index);
    },
    selPageFn: function selPageFn(index, item) {
      this.SAVEPAGEMAXINDEX(index);
      this.$parent.selPage.active = index;
      this.$parent.selPage.limit = this.selPage.list[this.selPage.active];
      this.$parent.page.offset = 0;
      this.pageactive = 1;
      this.$parent.page.active = 1;
      this.$emit("tableChange");
    },
    callpageFn: function callpageFn(index) {
      this.$parent.page.active = index;
      this.$parent.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : "";
      this.$emit("tableChange");
    },
    setSeekDropdown: function setSeekDropdown(index) {
      this.seekDropdownActive = index;
    },
    refresh: function refresh() {
      if (this.$parent.page) this.$parent.page.active = 1;
      if (this.$parent.page) this.pageactive = 1;
      if (this.$parent.page) this.$parent.page.offset = 0;
      if (this.$parent.seekDropdown) this.$parent.seekDropdown.seekStr = "";
      this.$emit("tableChange");
    },
    seek: function seek(seekStr) {
      this.pageactive = 1;
      if (this.page) this.$parent.page.offset = 0;
      if (this.$parent.page) this.$parent.page.active = 1;
      this.$emit("seek");
    },
    seekDatePickerFn: function seekDatePickerFn(seekVal) {
      this.$emit("seek");
    },
    clickColFn: function clickColFn(colItem, index) {
      this.$emit("clickCol", colItem, index);
    },
    deleteColClick: function deleteColClick() {
      this.deleteCol.switch = true;
    },
    deleteColNotarizeFn: function deleteColNotarizeFn() {
      this.deleteCol.switch = false;
      this.$emit("deleteList", this.deleteCol.list);
      this.deleteCol.list = [];
    },
    deletePitch: function deletePitch(item) {
      if (this.deleteCol.switch === false) {
        return;
      }
      var id = item[this.handle.idKey];
      var index = this.deleteCol.list.indexOf(id);
      if (index === -1) {
        this.deleteCol.list.push(id);
      } else {
        this.deleteCol.list.splice(index, 1);
      }
    },
    linkRegister: function linkRegister(item) {
      if (this.deleteCol.switch === true) {
        this.deletePitch(item);
      } else {
        this.$router.push({
          path: this.handle.link,
          query: {
            id: item[this.handle.idKey]
          }
        });
      }
    }
  }, (0, _vuex.mapMutations)(["SAVEPAGEMAXINDEX"])),
  watch: {
    seekDropdownActive: function seekDropdownActive(curVal, oldVal) {
      this.$parent.seekData.seekDropdownActive = curVal;
    },
    totalData: function totalData(curVal, oldVal) {
      curVal.length > 0 && this.total();
    }
  },
  components: {
    seek: _seek2.default,
    selPage: _selPage2.default,
    seekDatePicker: _seekDatePicker2.default,
    fileUpload: _vueUploadComponent2.default,
    Dropdown: _uiv.Dropdown,
    Pagination: _uiv.Pagination,
    jsonExcel: _jsonExcel2.default,
    noData: _noData2.default
  }
};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  props: {
    text: {},
    fontSize: {}
  }
};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _uiv = __webpack_require__(14);

var _vuex = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = { // :class="'hide': Object.keys(seekDropdown.list).length == 1"
  props: ["seekDropdown"],
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  computed: (0, _extends3.default)({
    seekLan: function seekLan() {
      return this.translate(this.LANGUAGE, "seek");
    }
  }, (0, _vuex.mapState)(["LANGUAGE"])),
  methods: {
    emitSeek: function emitSeek() {
      this.$emit("seek", this.seekDropdown.seekStr);
    },
    setSeekDropdown: function setSeekDropdown(index) {
      if (this.$parent.seekDropdownProps) {
        this.$parent.seekDropdownProps.active = index;
      } else if (this.$parent.seekDropdown) {
        this.$parent.seekDropdown.active = index;
      }
    }
  },
  components: {
    Dropdown: _uiv.Dropdown
  }
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _uiv = __webpack_require__(14);

var _vuex = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["seekDatePicker"],
  data: function data() {
    return {
      formModel: {
        startDate: "",
        stopDate: ""
      }
    };
  },
  mounted: function mounted() {
    this.getDate();
  },

  computed: (0, _extends3.default)({
    seekLan: function seekLan() {
      return this.translate(this.LANGUAGE, "seek");
    },
    testStopDate: function testStopDate() {
      return "required|date_format:YYYY-MM-DD";
    }
  }, (0, _vuex.mapState)(["LANGUAGE"])),
  methods: {
    emitSeek: function emitSeek() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        result && _this.$emit("seekDatePicker", _this.formModel);
      });
    },
    getDate: function getDate() {
      this.$parent.seekDatePicker.startDate = this.$moment().subtract(1, "days").format("YYYY-MM-DD");
      this.$parent.seekDatePicker.endDate = this.$moment().format("YYYY-MM-DD");
    },
    setSeekDropdown: function setSeekDropdown(index) {
      if (this.$parent.seekDropdownProps) {
        this.$parent.seekDropdownProps.active = index;
      } else if (this.$parent.seekDropdown) {
        this.$parent.seekDropdown.active = index;
      }
    }
  },
  components: {
    Dropdown: _uiv.Dropdown,
    DatePicker: _uiv.DatePicker
  }
};

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uiv = __webpack_require__(14);

var _vuex = __webpack_require__(24);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["multiLanguage", "selPage"],
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    if (!this.selPage.active) this.$parent.selPage.active = 0;
  },

  methods: {
    emitSelPage: function emitSelPage(index, item) {
      this.$emit("selPage", index, item);
    }
  },
  components: {
    Dropdown: _uiv.Dropdown
  }
};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _api = __webpack_require__(40);

var _commissionEnv = __webpack_require__(5);

var _menuAllList = __webpack_require__(105);

var _menuAllList2 = _interopRequireDefault(_menuAllList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
  mixins: [__webpack_require__(3).base({ sidebarLan: "sidebarList" })],
  data: function data() {
    return {
      purview: JSON.parse(sessionStorage.user).purview,
      isLogOut: true,
      MenuList: {},
      sidebarList: _menuAllList2.default
    };
  },
  mounted: function mounted() {
    this.init_sidebar();
  },

  computed: {
    sidebarListCom: function sidebarListCom() {
      return this.MenuList;
    }
  },
  methods: {
    setSidebarActive: function setSidebarActive(sidebarActive) {
      if (sidebarActive == "accountDatum") sidebarActive = "accountList";
      if (sidebarActive == "userDatum") sidebarActive = "userList";
      this.SAVESIDEBARACTIVE(sidebarActive);
    },
    pageInit: function pageInit() {
      //TODO获取页面权限
      // 2019-3-20 更新页面权限，由原先的menuList向rightObject过度
      var _data = [];
      JSON.parse(sessionStorage.rightObject).forEach(function (item) {
        _data.push(item.right_id);
      });
      var menu = {};
      for (var key in this.sidebarList) {
        for (var i in _data) {
          if (this.sidebarList[key].Role_ID == _data[i]) menu[key] = this.sidebarList[key];
        }
      }
      for (var _key in menu) {
        menu[_key].set = false;
      }
      for (var _key2 in menu) {
        menu[_key2].set = true;
        break;
      }
      this.MenuList = menu;
      // if (this.purview == "customer_service") {
      //   delete this.sidebarList.userList
      //   delete this.sidebarList.dailyReport
      // }
      // this.sidebarSet(this.$route.path.split('/')[1])
    },
    sureFn: function sureFn() {
      var _this = this;

      //确定退出登录
      this.isLogOut = !this.isLogOut;
      this.$http.post(_api.URL_SIGNOUT).then(function (res) {
        if (res.data.code == '200') {
          _this.SAVEUSER("");
          sessionStorage.user = _this.USER;

          _this.$router.push({
            path: '/login'
          });
        } else {
          alert(res.data.msg);
        }
      });
    },
    sidebarImage: function sidebarImage(index) {
      return __webpack_require__(1154)("./sidebar-_tem" + (index + 1) + '.png');
    },
    sidebarSet: function sidebarSet(index) {
      if (this.sidebarList[index]) {
        var item = this.sidebarList[index];
        if (item.link == 'logOut') {
          this.sureFn();
        } else {
          this.setListActive(index);
          this.$router.push({
            path: item.link
          });
        }
      }
    },
    setListActive: function setListActive(index) {
      var keys = (0, _keys2.default)(this.sidebarList);
      if (keys.indexOf(index) != -1) {
        for (var key in this.sidebarList) {
          this.sidebarList[key].set = false;
        }
        this.sidebarList[index].set = true;
        this.setSidebarActive(this.sidebarList[index].link);
      }
    },

    // 组件内部使用
    init_sidebar: function init_sidebar() {
      this.pageInit();
      this.setSidebarActive(this.$route.path.split('/')[1]);
      this.GETSIDEBARVUE(this);
    },

    // 组件外部使用
    Init_SideBar: function Init_SideBar() {
      this.pageInit();
      this.setSidebarActive(this.$route.path.split('/')[1]);
    }
  }
};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _util = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      firstData: [],
      secondData: [],
      firstHead: [],
      secondHead: []
    };
  },

  props: {
    rID: {
      default: ''
    },
    firstTh: {
      type: Object,
      default: function _default() {}
    },
    secondTh: {
      type: Object,
      default: function _default() {}
    },
    sheetName: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    downloadName: {
      default: 'download'
    },
    ajaxUrl: {
      default: false
    },
    dataTh: {
      default: false
    },
    ajaxGetKey: {
      default: false
    },
    ajaxPar: {
      default: {}
    },
    ajaxType: {
      default: "get"
    }
  },
  methods: {
    tablesToExcel: function tablesToExcel() {
      var _this = this;

      var curArea = JSON.parse(sessionStorage.getItem('currentArea'));
      var id = this.rID ? " " + this.rID : '';
      var name = this.downloadName ? " " + this.downloadName : '';
      var wbname = curArea.value + ' ' + name + id;
      var ajaxPar = this.ajaxType === "post" ? this.ajaxPar : { params: this.ajaxPar };
      this.$http[this.ajaxType](this.ajaxUrl, ajaxPar).then(function (res) {
        var getVal = function getVal(obj, arr) {
          if (arr.length > 1) {
            return getVal(obj[arr[0]], arr.slice(1));
          } else {
            return obj[arr[0]];
          }
        };
        var getTableHeadAndBody = function getTableHeadAndBody(head, bodyData, langObj) {
          var tmpObj = void 0;
          // ���dataThΪtrue,��ȡ�÷����ļ��ı���ͷ������������ͷ
          if (_this.dataTh) {
            tmpObj = langObj.th;
          } else {
            tmpObj = bodyData[0] ? bodyData[0] : langObj.th;
          }
          var thKeys = (0, _keys2.default)(tmpObj);
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(thKeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              head.push({ key: item, name: langObj.th[item] });
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          var tmpArr = (0, _keys2.default)(langObj).filter(function (v) {
            return v != 'th';
          });
          bodyData.forEach(function (val, index) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = (0, _getIterator3.default)(tmpArr), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var key = _step2.value;

                var _tmpObj = langObj[key];
                val[key] = val[key] || val[key] == 0 ? _tmpObj['changeTime'] ? (0, _util.updateTimeByUtc)((0, _util.getTimeDiff)(), val[key]) : _tmpObj[val[key]] : '';
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          });
        };
        var data = getVal(res, _this.ajaxGetKey);
        _this.firstData = data[0];
        _this.secondData = data[1];
        _this.firstHead = [];
        _this.secondHead = [];
        getTableHeadAndBody(_this.firstHead, _this.firstData, _this.firstTh);
        getTableHeadAndBody(_this.secondHead, _this.secondData, _this.secondTh);
        _this.export2Excel(wbname);
      });
    },
    export2Excel: function export2Excel(excelName) {
      var _this2 = this;

      new Promise(function(resolve) { resolve(); }).then((function () {
        var _require = __webpack_require__(65),
            export_json_to_multi_excel = _require.export_json_to_multi_excel;

        var firstHeader = _this2.getHeadKeyOrName(_this2.firstHead, 'name');
        var firstKey = _this2.getHeadKeyOrName(_this2.firstHead, 'key');
        var secondHeader = _this2.getHeadKeyOrName(_this2.secondHead, 'name');
        var secondKey = _this2.getHeadKeyOrName(_this2.secondHead, 'key');
        var data = [_this2.formatJson(firstKey, _this2.firstData), _this2.formatJson(secondKey, _this2.secondData)];
        export_json_to_multi_excel([firstHeader, secondHeader], data, _this2.sheetName, excelName);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    getHeadKeyOrName: function getHeadKeyOrName(thArr, type) {
      var arr = [];
      thArr.forEach(function (item) {
        if ((item.flag === undefined || item.flag) && (item.unneed === undefined || item.unneed)) {
          arr.push(item[type]);
        }
      });
      return arr;
    }
  }
}; //
//
//
//
//
//

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(214);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = __webpack_require__(213);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(212);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _EditableTable = __webpack_require__(1003);

var _EditableTable2 = _interopRequireDefault(_EditableTable);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var api = new _commissionEnv.Api();
var components = {
  "editable-table": _EditableTable2.default
};
var data = function data() {
  return {
    loading: null,
    rows: [],
    columnNames: []
  };
};
var computed = {};
var props = {
  curArea: {
    type: String,
    default: ""
  }
};
var methods = {
  getUrl20: function getUrl20() {
    return api.getUrl20(this.curArea, _commissionApi.URL_TOOL_ALERT_IGNORE);
  },
  save: function save(rowIndex, columnIndex, value) {
    var _this = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var url, name, _ref, updateRows, oldRows;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = _this.getUrl20();
              name = _this.rows[rowIndex][0];
              _context.next = 4;
              return _this.$http.post(url, { name: name, value: value });

            case 4:
              _ref = _context.sent;
              updateRows = _ref.data.data.updateRows;

              if (updateRows == 1) {
                oldRows = [].concat((0, _toConsumableArray3.default)(_this.rows));

                oldRows[rowIndex][columnIndex] = value;
                _this.rows = oldRows;
              }
              return _context.abrupt("return", updateRows == 1);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  onSave: function onSave() {
    return this.save.bind(this);
  },
  load: function load() {
    var _this2 = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var url, _ref2, _data, keys, values;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this2.loading !== _this2.curArea)) {
                _context2.next = 10;
                break;
              }

              _this2.loading = _this2.curArea;
              _this2.columnNames = [];
              _this2.rows = [];
              url = _this2.getUrl20();
              _context2.next = 7;
              return _this2.$http.get(url);

            case 7:
              _ref2 = _context2.sent;
              _data = _ref2.data.data;


              if (_data instanceof Array) {
                keys = [{ name: "name", editable: false }, "value"];
                values = _data.map(function (o) {
                  return [o.name, o.value];
                });

                _this2.columnNames = keys;
                _this2.rows = values;
              } else {
                alert("From " + url + " not get data required. \nPlease check url for alert_ignore");
              }

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};
function beforeUpdate() {
  this.load().catch(console.error);
}

function beforeMount() {
  this.load().catch(console.error);
}
exports.default = {
  data: data,
  props: props,
  computed: computed,
  methods: methods,
  beforeMount: beforeMount,
  beforeUpdate: beforeUpdate,
  components: components
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(214);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(212);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

var _noData = __webpack_require__(64);

var _noData2 = _interopRequireDefault(_noData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var api = new _commissionEnv.Api(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [__webpack_require__(3).base({ multiLanguage: "alertIgnore" })],
  props: {
    curArea: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      addData: {
        node_id: '',
        type: ''
      },
      loading: false,
      dialogFormVisible: false,
      activeType: 'ALL',
      trData: [],
      searchVal: ''
    };
  },

  computed: {
    typeMap: function typeMap() {
      return this.multiLanguage.typeMap;
    }
  },
  watch: {
    curArea: function curArea(value) {
      this.refresh();
    }
  },
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    dropdownFn: function dropdownFn(e) {
      this.activeType = e;
      this.refresh();
    },
    refresh: function refresh() {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var url, _ref, data;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                url = api.getUrl20(_this.curArea, _commissionApi.URL_TOOL_ALERT_IGNORE2) + '?searchVal=' + _this.searchVal;

                if (_this.activeType != 'ALL') url += '&type=' + _this.activeType;
                _context.next = 5;
                return _this.$http.get(url);

              case 5:
                _ref = _context.sent;
                data = _ref.data.data;

                _this.trData = data.map(function (it) {
                  it.label = _this.typeMap[it.type];
                  return it;
                });
                _this.loading = false;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    addItem: function addItem() {
      this.addData.node_id = '';
      this.addData.type = '';
      this.dialogFormVisible = true;
    },
    deleteItem: function deleteItem(item) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var yes, url, _ref2, data;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                yes = confirm(_this2.multiLanguage.deleteTips);

                if (yes) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                url = api.getUrl20(_this2.curArea, _commissionApi.URL_TOOL_ALERT_IGNORE2);
                _context2.next = 6;
                return _this2.$http.post(url, { node_id: item.node_id, type: item.type, operate: 'delete' });

              case 6:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this2.refresh();

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    addCommit: function addCommit() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var url, _ref3, data;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!_this3.addData.node_id || !_this3.addData.type)) {
                  _context3.next = 3;
                  break;
                }

                alert(_this3.multiLanguage.submitTips);
                return _context3.abrupt("return");

              case 3:
                url = api.getUrl20(_this3.curArea, _commissionApi.URL_TOOL_ALERT_IGNORE2);
                _context3.next = 6;
                return _this3.$http.post(url, { node_id: _this3.addData.node_id, type: _this3.addData.type, operate: 'add' });

              case 6:
                _ref3 = _context3.sent;
                data = _ref3.data;

                _this3.dialogFormVisible = false;
                _this3.refresh();

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    search: function search() {
      this.refresh();
    }
  }
};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(213);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _set = __webpack_require__(108);

var _set2 = _interopRequireDefault(_set);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Usage:
 * <editable-list-cell data=[1,2,3] width="50" pattern="/^\d+$/" tips="Please input digitals." change=function/>
 */
var props = {
  data: {
    type: Array,
    required: true
  },
  width: {
    type: [Number, String], //unit is percend
    default: ""
  },
  pattern: {
    type: String, //regexp
    required: true
  },
  change: {
    type: Function, //()=>void
    required: true
  },
  tips: {
    type: String,
    default: ""
  },
  editable: {
    type: Boolean,
    default: true
  }
};
var methods = {
  changeHanlder: function changeHanlder(newData, isSave) {
    if (isSave) {
      this.newData = newData.split(",").filter(function (d) {
        return d != "";
      });
    }
  },
  deleteDataAt: function deleteDataAt(index) {
    var yes = confirm("Are Your sure to delet?");
    if (yes) {
      var o = this.newData.filter(function (d, i) {
        return i != index;
      }).join(",");
      return this.change(o).then(this.changeHanlder.bind(this, o));
    }
  },
  adding: function adding() {
    this.addItem = "";
  },
  add: function add() {
    var dataOK = this.addItem != null && this.p.test(this.addItem);
    var z = new _set2.default([].concat((0, _toConsumableArray3.default)(this.newData)));
    if (dataOK && !z.has(this.addItem)) {
      z.add(this.addItem);
      var newData = [].concat((0, _toConsumableArray3.default)(z)).filter(function (d) {
        return d != "";
      }).join(",");
      this.change(newData).then(this.changeHanlder.bind(this, newData));
    } else {
      var formatTip = this.tips || "Input should match /" + this.pattern + "/";
      if (!dataOK) {
        alert(formatTip);
      }
    }
    this.addItem = null;
  }
};
function data() {
  return {
    newData: this.data,
    addItem: null,
    p: new RegExp(this.pattern)
  };
}
exports.default = {
  props: props,
  methods: methods,
  data: data
};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EditableListCell = __webpack_require__(1001);

var _EditableListCell2 = _interopRequireDefault(_EditableListCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Example:
 * <editable-row
 *   column-names="[{name:'a',editable:false},'b','c']"
 *   values="[1,2,3]"
 *   save="(key,value)=>bool"
 *  />
 */
var props = {
  values: {
    type: Array,
    required: true
  },
  columnNames: {
    type: Array,
    required: true
  },
  save: Function //(key,value)->boolean
};
function data() {
  return {};
}
var computed = {
  widths: function widths() {
    if (this.columnNames.length == 2) {
      return [20, 80];
    }
    return new Array(this.columnNames.length, Math.floor(100 / this.columnNames.length));
  }
};
var methods = {
  onSave: function onSave(index, value) {
    var oldValue = this.values[index];
    if (value !== oldValue) {
      return this.save(index, value);
    }
    return false;
  },
  getSave: function getSave(index) {
    return this.onSave.bind(this, index);
  }
};

var components = {
  "editable-list-cell": _EditableListCell2.default
};

exports.default = {
  props: props,
  data: data,
  computed: computed,
  components: components,
  methods: methods
};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EditableRow = __webpack_require__(1002);

var _EditableRow2 = _interopRequireDefault(_EditableRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** example
 *  <editable-table
 *    title="Table Name",
 *    column-names="['a',{name:'b',editable:true},'c']"
 *    rows="[['a','b','c'],['a','b','c']]"
 *    save= '(indexOfRow,key,value)=>bool'
 *   />
 */
var props = {
  title: {
    require: false,
    type: String,
    default: ""
  },
  save: {
    require: true,
    type: Function //(rowIndex,key,value)->boolean
  },
  columnNames: {
    require: true,
    type: Array //array of String
  },
  rows: {
    require: true,
    type: Array //[[String]]
  }
};

var components = {
  "editable-row": _EditableRow2.default
};
function rowSave(rowIndex, columnIndex, value) {
  return this.save(rowIndex, columnIndex, value);
}
var methods = {
  onSave: function onSave(rowIndex) {
    return rowSave.bind(this, rowIndex);
  }
};
var computed = {};
function data() {
  return {};
}

exports.default = {
  components: components,
  data: data,
  computed: computed,
  props: props,
  methods: methods
};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _uiv = __webpack_require__(14);

var _vuex = __webpack_require__(24);

var _commissionJsonExcel = __webpack_require__(192);

var _commissionJsonExcel2 = _interopRequireDefault(_commissionJsonExcel);

var _selPage = __webpack_require__(82);

var _selPage2 = _interopRequireDefault(_selPage);

var _commissionEnv = __webpack_require__(5);

var _commissionApi = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
  components: {
    jsonExcel: _commissionJsonExcel2.default,
    selPage: _selPage2.default,
    Pagination: _uiv.Pagination
  },
  mixins: [__webpack_require__(3).base({ allCommissionLan: "allCommissionReport" })],
  props: ['curArea'],
  data: function data() {
    return {
      seekStr: '',
      trData: [],
      label: 'allCommissionReport',
      page: { // 分页
        active: 1,
        pageLeng: 0,
        offset: 0 // 查询数据库的offset需要的值，初始只为0组件内部处理最后给出一个能直接传给后台的值
      },
      selPage: { // 配合分页的显示col数目选择
        list: [5, 10, 25, 50], // 选择显示col数目
        active: localStorage.pageMaxIndex, // 当前list的坐标
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex] // 查询数据库的limit需要的值，初始值设为list的0坐标组件内部处理最后给出一个传给后台的值 
      },
      //  pageactive: this.page ? this.page.active : "",
      pageactive: 1
    };
  },

  computed: {
    thData: function thData() {
      return [this.allCommissionLan.type, this.allCommissionLan.account, this.allCommissionLan.name, this.allCommissionLan.commissionReturn];
    },
    getIBInfoUrl: function getIBInfoUrl() {
      return api.getUrl20(this.curArea, _commissionApi.URL_PREIBCON);
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: api.getUrl20(this.curArea, _commissionApi.URL_PREIBCON),
        ajaxType: "get",
        getKey: ["data", "data", "rows"],
        ajaxPar: {
          pageNum: 0,
          pageSize: this.page.pageLeng,
          id: this.seekStr
        }
      };
    }
  },
  methods: (0, _extends3.default)({
    pageInit: function pageInit() {
      var _this = this;

      this.$http.get(api.getUrl20(this.curArea, _commissionApi.URL_PREIBCON), { params: { pageNum: this.pageactive - 1, pageSize: this.selPage.limit, id: this.seekStr } }).then(function (res) {
        if (res.data.code == 200 && res.data.data && res.data.msg == 'OK') {
          var data = res.data.data.data;
          _this.page.pageLeng = res.data.data.count;
          _this.trData = data;
        }
      });
    },
    seekFn: function seekFn() {
      this.pageInit();
    },
    callpageFn: function callpageFn(index) {
      this.page.active = index;
      this.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : "";
      this.pageInit();
    },
    selPageFn: function selPageFn(index, item) {
      this.SAVEPAGEMAXINDEX(index);
      this.selPage.active = index;
      this.selPage.limit = this.selPage.list[this.selPage.active];
      this.page.offset = 0;
      this.pageactive = 1;
      this.page.active = 1;
      this.pageInit();
    }
  }, (0, _vuex.mapMutations)(["SAVEPAGEMAXINDEX"])),
  mounted: function mounted() {
    this.pageInit();
  },

  watch: {
    curArea: function curArea(val) {
      this.pageInit();
    }
  }
};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _util = __webpack_require__(11);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
    name: 'auditTrailDetailReport',
    mixins: [__webpack_require__(3).base({ detailLan: "auditTrailReport" })],
    props: ['curArea'],
    data: function data() {
        return {
            trData: [],
            queryObj: {},
            url: '',
            loading: true,
            changeTime: false,
            timeDiff: 0,
            page: {
                active: 1,
                pageLeng: 0
            },
            selPage: {
                list: [5, 10, 25, 50],
                active: localStorage.pageMaxIndex,
                limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
            },
            tip: {
                key: ['OLD_VALUE', 'NEW_VALUE']
            }
        };
    },

    computed: {
        thData: function thData() {
            return this.detailLan.detailTh;
        },
        name: function name() {
            return this.detailLan.detailText;
        },
        downLoadTran: function downLoadTran() {
            return { TYPE: this.detailLan.typeList };
        },
        jsonExcelAjax: function jsonExcelAjax() {
            return {
                url: this.url,
                ajaxType: "get",
                getKey: ["data", "data", 'rows'],
                ajaxPar: {
                    lang: this.LANGUAGE,
                    begintime: (0, _util.formatDate)(this.queryObj.begintime),
                    endtime: (0, _util.formatDate)(this.queryObj.endtime),
                    pageNum: 0,
                    pageSize: this.page.pageLeng,
                    id: this.queryObj.MODIFIED_ID
                }
            };
        }
    },
    mounted: function mounted() {
        this.queryObj = this.$route.query;
        this.timeDiff = (0, _util.getTimeDiff)();
        //this.queryObj.begintime = new Date(new Date(this.queryObj.begintime).getTime())
        //this.queryObj.endtime = new Date(new Date(this.queryObj.endtime).getTime())
        this.tableAjax();
    },

    methods: {
        tableAjax: function tableAjax() {
            var _this = this;

            this.changeTime = true;
            this.url = api.getUrl20(this.curArea, _commissionApi.URL_AUDITREPORTDETAIL);
            var tableObj = {
                params: {
                    begintime: (0, _util.formatDate)(this.queryObj.begintime),
                    endtime: (0, _util.formatDate)(this.queryObj.endtime),
                    pageNum: this.page.active - 1,
                    pageSize: this.selPage.limit,
                    id: this.queryObj.MODIFIED_ID
                }
            };
            this.$http.get(this.url, tableObj).then(function (res) {
                _this.trData = res.data.data.rows;
                _this.page.pageLeng = res.data.data.count;
                _this.setOfficeState();
                _this.loading = false;
            });
        },
        setOfficeState: function setOfficeState() {
            var _this2 = this;

            var list = this.detailLan.typeList;
            if (Object.prototype.toString.call(this.trData) == "[object Array]") {
                this.trData.forEach(function (item, index) {
                    var temp = _this2.trData[index];
                    temp.type = temp.TYPE || temp.TYPE == 0 ? list[temp.TYPE] : '';
                    if (_this2.changeTime) {
                        temp.LOG_DATE = temp.LOG_DATE ? (0, _util.updateTimeByUtc)(_this2.timeDiff, temp.LOG_DATE) : '';
                    }
                });
            }
        }
    },
    watch: {
        detailLan: function detailLan() {
            this.changeTime = false;
            this.setOfficeState();
        },
        curArea: function curArea() {
            sessionStorage.removeItem('back');
            this.$router.push('auditTrailReport');
        }
    },
    components: {
        mtable: _mytable2.default
    }
};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _commissionApi = __webpack_require__(7);

var _util = __webpack_require__(11);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
    name: 'auditTrailReport',
    mixins: [__webpack_require__(3).base({ auditTrailLan: "auditTrailReport" })],
    props: ['curArea'],
    data: function data() {
        return {
            trData: [],
            category: "-1",
            account: '',
            start_time: new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
            end_time: new Date(),
            url: '',
            loading: true,
            changeTime: false,
            link: {
                key: ['MODIFIED_ID'],
                path: 'auditTrailDetailReport'
            },
            page: {
                active: 1,
                pageLeng: 0
            },
            selPage: {
                list: [5, 10, 25, 50],
                active: localStorage.pageMaxIndex,
                limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
            }
        };
    },

    computed: {
        back: function back() {
            return (0, _stringify2.default)({
                path: 'auditTrailReport',
                begintime: this.start_time,
                endtime: this.end_time,
                pageNum: this.page.active - 1,
                pageSize: this.selPage.limit,
                type: this.category,
                id: this.account
            });
        },
        name: function name() {
            return this.auditTrailLan.indexText;
        },
        thData: function thData() {
            return this.auditTrailLan.indexTh;
        },
        downLoadTran: function downLoadTran() {
            return { TYPE: this.auditTrailLan.category };
        },
        jsonExcelAjax: function jsonExcelAjax() {
            return {
                url: this.url,
                ajaxType: "get",
                getKey: ["data", "data", "data"],
                ajaxPar: {
                    lang: this.LANGUAGE,
                    begintime: (0, _util.formatDate)(this.start_time),
                    endtime: (0, _util.formatDate)(this.end_time),
                    pageNum: 0,
                    pageSize: this.page.pageLeng,
                    type: this.category,
                    id: this.account
                }
            };
        }
    },
    mounted: function mounted() {
        if (sessionStorage.getItem('back')) {
            var backObj = JSON.parse(sessionStorage.getItem('back'));
            if (backObj.path === 'auditTrailReport') {
                this.category = backObj.type;
                this.account = backObj.id;
                this.start_time = backObj.begintime;
                this.end_time = backObj.endtime;
                this.page.active = backObj.pageNum + 1;
                this.selPage.limit = backObj.pageSize;
            }
            this.tableAjax();
            sessionStorage.removeItem('back');
        } else {
            this.tableAjax();
        }
    },

    methods: {
        searchDatas: function searchDatas() {
            this.loading = true;
            this.page.active = 1;
            this.tableAjax();
        },
        tableAjax: function tableAjax() {
            var _this = this;

            this.changeTime = true;
            this.url = api.getUrl20(this.curArea, _commissionApi.URL_AUDITREPORT);
            var tableObj = {
                params: {
                    begintime: (0, _util.formatDate)(this.start_time),
                    endtime: (0, _util.formatDate)(this.end_time),
                    pageNum: this.page.active - 1,
                    pageSize: this.selPage.limit,
                    type: this.category,
                    id: this.account
                }
            };
            this.$http.get(this.url, tableObj).then(function (res) {
                _this.trData = res.data.data.data;
                _this.page.pageLeng = res.data.data.count;
                _this.setOfficeState();
                _this.loading = false;
            });
        },
        setOfficeState: function setOfficeState() {
            var _this2 = this;

            var list = this.auditTrailLan.category;
            if (Object.prototype.toString.call(this.trData) == "[object Array]") {
                this.trData.forEach(function (item, index) {
                    var temp = _this2.trData[index];
                    temp.type = temp.TYPE || temp.TYPE == 0 ? list[temp.TYPE] : '';
                    if (_this2.changeTime) {
                        temp.begintime = (0, _util.updateTimeByUtc)((0, _util.getTimeDiff)(), temp.begintime);
                        temp.endtime = (0, _util.updateTimeByUtc)((0, _util.getTimeDiff)(), temp.endtime);
                    }
                });
            }
        }
    },
    watch: {
        auditTrailLan: function auditTrailLan() {
            this.changeTime = false;
            this.setOfficeState();
        },
        curArea: function curArea() {
            this.type = '-1';
            this.account = '';
            this.start_time = new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000);
            this.end_time = new Date();
            this.page.active = 1;
            this.loading = true;
            this.tableAjax();
        }
    },
    components: {
        mtable: _mytable2.default
    }
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _util = __webpack_require__(11);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
    name: "ibreport",
    mixins: [__webpack_require__(3).base({ multiLanguage: "commissionTable" })],
    props: ['curArea'],
    data: function data() {
        return {
            ibAccount: '',
            type: '-1',
            timeDiff: 0,
            changeTime: false,
            url: '',
            trData: [], //  表格tr数据 
            sort: { // 排序
                key: "",
                method: "ASC"
            },
            page: { // 分页
                active: 1,
                pageLeng: 0
            },
            selPage: { //  配合分页的显示col数目选择
                list: [5, 10, 25, 50],
                active: localStorage.pageMaxIndex,
                limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
            },
            loading: true
        };
    },
    mounted: function mounted() {
        this.timeDiff = (0, _util.getTimeDiff)();
        this.tableAjax();
    },

    computed: {
        thData: function thData() {
            // 表格th数据
            return this.multiLanguage.ibTh;
        },
        name: function name() {
            return this.multiLanguage.ibreport.text;
        },
        downLoadTran: function downLoadTran() {
            return { STATUS: this.multiLanguage.ibreport.statusList };
        },
        jsonExcelAjax: function jsonExcelAjax() {
            return {
                url: this.url,
                ajaxType: "get",
                getKey: ["data", "data", "rows"],
                ajaxPar: {
                    pageSize: this.page.pageLeng,
                    pageNum: 0,
                    area: this.LANGUAGE,
                    sort: this.sort.method,
                    sortKey: this.sort.key,
                    id: this.ibAccount,
                    type: this.type
                }
            };
        }
    },
    methods: {
        searchData: function searchData() {
            this.loading = true;
            this.page.active = 1;
            this.tableAjax();
        },
        tableAjax: function tableAjax() {
            this.changeTime = true;
            this.url = api.getUrl20(this.curArea, _commissionApi.URL_ACTIVEREPORT);
            var obj = {
                params: {
                    id: this.ibAccount,
                    type: this.type,
                    sort: this.sort.method,
                    sortKey: this.sort.key,
                    pageNum: this.page.active - 1,
                    pageSize: this.selPage.limit
                },
                headers: {
                    UTCDIFF: this.timeDiff
                }
            };
            this.getIbReportDatas(this.url, obj);
        },
        getIbReportDatas: function getIbReportDatas(url, obj) {
            var _this = this;

            this.$http.get(url, obj).then(function (res) {
                _this.trData = res.data.data.rows;
                _this.page.pageLeng = res.data.data.count;
                _this.setOfficeState();
                _this.loading = false;
            });
        },
        setOfficeState: function setOfficeState() {
            var _this2 = this;

            var list = this.multiLanguage.ibreport.statusList;
            if (Object.prototype.toString.call(this.trData) == "[object Array]") {
                this.trData.forEach(function (item, index) {
                    var temp = _this2.trData[index];
                    temp.status = temp.STATUS || temp.STATUS == 0 ? list[temp.STATUS] : '';
                    if (_this2.changeTime) {
                        temp.FIRST_REBATE_TIME = (0, _util.updateTimeByUtc)(_this2.timeDiff, temp.FIRST_REBATE_TIME);
                        temp.LAST_REBATE_TIME = (0, _util.updateTimeByUtc)(_this2.timeDiff, temp.LAST_REBATE_TIME);
                    }
                });
            }
        }
    },
    watch: {
        multiLanguage: function multiLanguage() {
            this.changeTime = false;
            this.setOfficeState();
        },
        curArea: function curArea() {
            this.ibAccount = '';
            this.type = '-1';
            this.sort.method = 'ASC';
            this.sort.key = '';
            this.loading = true;
            this.tableAjax();
        }
    },
    components: {
        mtable: _mytable2.default
    }
};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uiv = __webpack_require__(14);

var _commissionEnv = __webpack_require__(5);

var _commissionApi = __webpack_require__(7);

var api = new _commissionEnv.Api(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['IBregion'],
  components: {
    Modal: _uiv.Modal
  },
  watch: {
    IBregion: function IBregion(curVal, oldVal) {
      this.pageInit();
    }
  },
  mixins: [__webpack_require__(3).base({ spreadCommissionLan: "spreadCommissionMappingReport" })],
  data: function data() {
    return {
      showModal: false,
      sucSave: false,
      data: [],
      editData: {
        data: [],
        user: ''
      }
    };
  },
  mounted: function mounted() {
    this.pageInit();
  },

  methods: {
    // 初始化数据
    pageInit: function pageInit() {
      var _this = this;

      if (this.IBregion == 'GM') api.switchGMPort();else if (this.IBregion == 'UK') api.switchUKPort();
      this.$http.get(api.getUrl20(_commissionApi.URL_SYMBOLSPREAD)).then(function (res) {
        _this.data = res.data.data;
        _this.data.forEach(function (item, index) {
          if (item.SYMBOL == 'OTHER') {
            var obj = _this.data.splice(index, 1)[0];
            _this.data.splice(_this.data.length, 0, obj);
          }
        });
      });
    },

    // 提交
    submitFn: function submitFn() {
      var _this2 = this;

      this.data.forEach(function (item, index) {
        if (item.changed && item.SYMBOL && item.COMMISSION) {
          var tem = { SYMBOL: item.SYMBOL, COMMISSION: item.COMMISSION };
          _this2.editData.data.push(tem);
          _this2.editData.user = JSON.parse(sessionStorage.user).user_name;
          item.changed = false;
        }
      });
      if (this.editData.data.length > 0) {
        this.$http.post(api.getUrl20(_commissionApi.URL_SYMBOLSPREAD), this.editData).then(function (res) {
          if (res.data.code == 200 && res.data.data == 'SUCCESS' && res.data.msg == 'OK') {
            _this2.showModal = true;
            _this2.sucSave = true;
            _this2.pageInit();
          } else {
            _this2.showModal = true;
            _this2.sucSave = false;
          }
          _this2.editData.data = [];
          _this2.editData.user = '';
        });
      } else return;
    },

    // 添加一行
    addItem: function addItem(item, arr) {
      var code = arr.indexOf(item) + 1;
      var obj = {
        COMMISSION: '',
        newItem: true,
        LAST_UPDATE: new Date().toLocaleString(),
        selecteData: [],
        SYMBOL: ''
      };
      this.$http.get(api.getUrl20(_commissionApi.URL_SYMBOLOTHER)).then(function (res) {
        res.data.data.forEach(function (item, index) {
          var tem = { value: index, label: item };
          obj.selecteData.push(tem);
        });
      });
      arr.splice(code, 0, obj);
    },

    // 删除一行
    removeItem: function removeItem(item, arr) {
      var _this3 = this;

      var msg = this.spreadCommissionLan.confirmDeleteText;
      if (confirm(msg) == true) {
        var code = arr.indexOf(item);
        if (arr.length > 1) {
          var _item = arr.splice(code, 1)[0];
          var deleteData = { symbol: _item.SYMBOL, user: JSON.parse(sessionStorage.user).user_name };
          this.$http.post(api.getUrl20(_commissionApi.URL_SYMBOLDEL), deleteData).then(function (res) {
            if (res.data.code == 200 && res.data.data == 'SUCCESS' && res.data.msg == 'OK') {
              _this3.showModal = true;
              _this3.sucSave = true;
            } else {
              _this3.showModal = true;
              _this3.sucSave = false;
            }
          });
        } else {
          for (var key in item) {
            item[key] = '';
          }
        }
      }
    }
  }
};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _util = __webpack_require__(11);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
  name: "CPACommissionResult",
  mixins: [__webpack_require__(3).base({ CPAResultLan: "cpaIBResult" })],
  props: ["curArea"],
  data: function data() {
    return {
      trData: [],
      beginTime: "",
      endTime: "",
      timeDiff: 0,
      url: "",
      area: [],
      loading: true,
      changeTime: false,
      link: {
        key: ["CPACommissionResult"],
        path: "CPAMonthlyCommResult"
      },
      page: {
        active: 1,
        pageLeng: 0
      },
      selPage: {
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    };
  },

  computed: {
    back: function back() {
      return (0, _stringify2.default)({
        path: "CPACommissionResult",
        beginTime: (0, _util.formatDate)(this.beginTime),
        endTime: (0, _util.formatDate)(this.endTime),
        pageNum: this.page.active - 1,
        pageSize: this.selPage.limit
      });
    },
    thData: function thData() {
      return this.CPAResultLan.cpaIndexTh;
    },
    name: function name() {
      return this.CPAResultLan.indexText;
    },
    downLoadTran: function downLoadTran() {
      return { STATUS: this.CPAResultLan.statusList };
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: "get",
        getKey: ["data", "data", "rows"],
        ajaxPar: {
          type: "IB",
          iscpa: true,
          pageSize: this.page.pageLeng,
          pageNum: 0,
          lang: this.LANGUAGE,
          beginTime: (0, _util.formatDate)(this.beginTime),
          endTime: (0, _util.formatDate)(this.endTime)
        }
      };
    }
  },
  mounted: function mounted() {
    this.area = JSON.parse(sessionStorage.getItem("area")).GM;
    this.timeDiff = (0, _util.getTimeDiff)();
    if (sessionStorage.getItem("back")) {
      var backObj = JSON.parse(sessionStorage.getItem("back"));
      if (backObj.path === "CPACommissionResult") {
        this.beginTime = backObj.beginTime;
        this.endTime = backObj.endTime;
        this.page.active = backObj.pageNum + 1;
        this.selPage.limit = backObj.pageSize;
      }
      this.tableAjax();
      sessionStorage.removeItem("back");
    } else {
      this.tableAjax();
    }
  },

  methods: {
    searchData: function searchData() {
      this.page.active = 1;
      this.tableAjax();
    },
    tableAjax: function tableAjax() {
      var _this = this;

      this.loading = true;
      this.changeTime = true;
      this.url = api.getUrl20(this.curArea, _commissionApi.URL_IBMONTHLYINDEX);
      var obj = {
        params: {
          type: "IB",
          iscpa: true,
          beginTime: this.beginTime,
          endTime: this.endTime,
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        }
      };
      this.$http.get(this.url, obj).then(function (res) {
        _this.trData = res.data.data.rows;
        _this.page.pageLeng = res.data.data.count;
        _this.setOfficeState();
        _this.loading = false;
      });
    },
    setOfficeState: function setOfficeState() {
      var _this2 = this;

      var list = this.CPAResultLan.statusList;
      if (Object.prototype.toString.call(this.trData) == "[object Array]") {
        this.trData.forEach(function (item, index) {
          var temp = _this2.trData[index];
          temp.CPACommissionResult = _this2.CPAResultLan.cpaIndexTh[1].name;
          temp.status = temp.STATUS || temp.STATUS == 0 ? list[temp.STATUS] : "";
          if (_this2.changeTime) temp.LAST_UPDATE = (0, _util.updateTimeByUtc)(_this2.timeDiff, temp.LAST_UPDATE);
        });
      }
    }
  },
  watch: {
    CPAResultLan: function CPAResultLan() {
      this.changeTime = false;
      this.setOfficeState();
    },
    curArea: function curArea() {
      this.beginTime = "", this.endTime = "", this.page.active = 1;
      if (this.area.indexOf(this.curArea) > -1) this.$router.push("ibSetting");else this.tableAjax();
    }
  },
  components: {
    mtable: _mytable2.default
  }
};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _commissionEnv = __webpack_require__(5);

var _commissionApi = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var api = new _commissionEnv.Api(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "CPAMonthlyCommDetailResult",
  mixins: [__webpack_require__(3).base({ CPACommDetailLan: "cpaIBResult" })],
  props: ["curArea"],
  data: function data() {
    return {
      trData: [],
      queryObj: {},
      area: [],
      url: "",
      loading: true
    };
  },

  computed: {
    thData: function thData() {
      return this.CPACommDetailLan.detailTh;
    },
    name: function name() {
      return this.CPACommDetailLan.datailText;
    },
    downLoadTran: function downLoadTran() {
      return { IB_ID: this.CPACommDetailLan.total };
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: "get",
        getKey: ["data", "data"],
        rID: this.queryObj.REPORT_ID,
        cID: this.queryObj.IB_ID,
        ajaxPar: {
          lang: this.LANGUAGE,
          ib_id: this.queryObj.IB_ID,
          report_id: this.queryObj.REPORT_ID
        }
      };
    }
  },
  mounted: function mounted() {
    this.area = JSON.parse(sessionStorage.getItem("area")).GM;
    this.queryObj = this.$route.query;
    this.tableAjax();
  },

  methods: {
    tableAjax: function tableAjax() {
      var _this = this;

      this.loading = true;
      this.url = api.getUrl20(this.curArea, _commissionApi.URL_CPADETAIL);
      var tableObj = {
        params: {
          ib_id: this.queryObj.IB_ID,
          report_id: this.queryObj.REPORT_ID
        }
      };
      this.$http.get(this.url, tableObj).then(function (res) {
        _this.trData = res.data.data;
        _this.setOfficeState();
        _this.loading = false;
      });
    },
    setOfficeState: function setOfficeState() {
      var _this2 = this;

      var list = this.CPACommDetailLan.total;
      if (Object.prototype.toString.call(this.trData) == "[object Array]") {
        this.trData.forEach(function (item, index) {
          var temp = _this2.trData[index];
          if (index === _this2.trData.length - 1) temp.ib_id = list[temp.IB_ID];else temp.ib_id = temp.IB_ID;
        });
      }
    }
  },
  watch: {
    CPACommDetailLan: function CPACommDetailLan() {
      this.setOfficeState();
    },
    curArea: function curArea() {
      if (this.area.indexOf(this.curArea) > -1) this.$router.push("ibSetting");else this.$router.push("/ib/CPACommissionResult");
    }
  },
  components: {
    mtable: _mytable2.default
  }
};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _util = __webpack_require__(11);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
  name: "CPAMonthlyCommResult",
  mixins: [__webpack_require__(3).base({ CPACommLan: "cpaIBResult" })],
  props: ["curArea"],
  data: function data() {
    return {
      trData: [],
      queryObj: {},
      status: "-1",
      proxyAccount: "",
      url: "",
      area: [],
      timeDiff: 0,
      loading: true,
      changeTime: false,
      link: {
        key: ["CPA_COMMISSION"],
        path: "CPAMonthlyCommDetailResult"
      },
      operate: {
        checkbox: true,
        url: api.getUrl20(this.curArea, _commissionApi.URL_IBMONTHLYUPDATE),
        level: "IB"
      },
      page: {
        active: 1,
        pageLeng: 0
      },
      selPage: {
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    };
  },

  computed: {
    back: function back() {
      if (sessionStorage.getItem("back")) {
        var backObj = JSON.parse(sessionStorage.getItem("back"));
        backObj.secondBack = {
          status: this.status,
          proxyAccount: this.proxyAccount,
          report_id: this.queryObj.REPORT_ID,
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        };
        return (0, _stringify2.default)(backObj);
      }
    },
    name: function name() {
      return this.CPACommLan.text;
    },
    thData: function thData() {
      return this.CPACommLan.computeTh;
    },
    downLoadTran: function downLoadTran() {
      return { STATUS: this.CPACommLan.CPAStatusList };
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: "get",
        getKey: ["data", "data", "rows"],
        rID: this.queryObj.REPORT_ID,
        ajaxPar: {
          type: this.status,
          pageNum: 0,
          pageSize: this.page.pageLeng,
          ib_id: this.proxyAccount,
          report_id: this.queryObj.REPORT_ID
        }
      };
    }
  },
  mounted: function mounted() {
    this.area = JSON.parse(sessionStorage.getItem("area")).GM;
    this.queryObj = this.$route.query;
    this.timeDiff = (0, _util.getTimeDiff)();
    var sinStr = sessionStorage.getItem("back");
    if (sinStr) {
      var sinObj = JSON.parse(sinStr);
      var secondBack = sinObj.secondBack;
      if (secondBack) {
        this.status = secondBack.status;
        this.proxyAccount = secondBack.id;
        this.report_id = secondBack.report_id;
        this.page.active = secondBack.pageNum + 1;
        this.selPage.limit = secondBack.pageSize;
      }
      //this.tableAjax()
      delete sinObj.secondBack;
      sessionStorage.setItem("back", (0, _stringify2.default)(sinObj));
    }
    this.tableAjax();
  },

  methods: {
    searchDatas: function searchDatas() {
      this.page.active = 1;
      this.tableAjax();
    },
    tableAjax: function tableAjax() {
      var _this = this;

      this.loading = true;
      this.changeTime = true;
      this.url = api.getUrl20(this.curArea, _commissionApi.URL_CPA);
      var tableObj = {
        params: {
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit,
          type: this.status,
          ib_id: this.proxyAccount,
          report_id: this.queryObj.REPORT_ID
        }
      };
      this.$http.get(this.url, tableObj).then(function (res) {
        _this.trData = res.data.data.rows;
        _this.page.pageLeng = res.data.data.count;
        _this.setOfficeState();
        _this.loading = false;
      });
    },
    setOfficeState: function setOfficeState() {
      var _this2 = this;

      var list = this.CPACommLan.CPAStatusList;
      if (Object.prototype.toString.call(this.trData) == "[object Array]") {
        this.trData.forEach(function (item, index) {
          item.checked = false;
          item.status = item.STATUS || item.STATUS == 0 ? list[item.STATUS] : "";
          item.TYPE = 2;
          if (_this2.changeTime) item.LAST_UPDATE = (0, _util.updateTimeByUtc)(_this2.timeDiff, item.LAST_UPDATE);
        });
      }
    }
  },
  watch: {
    CPACommLan: function CPACommLan() {
      this.changeTime = false;
      this.setOfficeState();
    },
    curArea: function curArea(newVal) {
      this.status = -1;
      this.proxyAccount = "";
      this.page.active = 1;
      if (this.area.indexOf(this.curArea) > -1) this.$router.push("ibSetting");else this.tableAjax();
    }
  },
  components: {
    mtable: _mytable2.default
  }
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var api = new _commissionEnv.Api(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'monthCommDetailResult',
  mixins: [__webpack_require__(3).base({ detailLan: 'monthlyIBResult' }), __webpack_require__(3).base({ publicLan: 'publicLan' })],
  props: ['curArea'],
  data: function data() {
    return {
      trData: [],
      queryObj: {},
      url: '',
      action: false,
      isLower: false,
      loading: true,
      product: {},
      thKeys: []
    };
  },
  mounted: function mounted() {
    this.queryObj = this.$route.query;
    this.tableAjax();
  },

  methods: {
    actionChange: function actionChange(value) {
      this.action = value;
      this.tableAjax();
    },
    tableAjax: function tableAjax() {
      var _this = this;

      this.loading = true;
      var tableObj = {
        params: {
          report_id: this.queryObj.REPORT_ID,
          type: this.queryObj.TYPE,
          id: this.queryObj.IB_ID
        }
      };
      this.url = api.getUrl20(this.curArea, _commissionApi.URL_IBMONTHLYDETAIL);
      this.$http.get(this.url, tableObj).then(function (res) {
        _this.trData = res.data.data.data;
        _this.group = res.data.data.group;
        if (_this.trData.length == 0) {
          _this.thKeys.push('CLIENT_ID');
          _this.thKeys.push('PLATFORM');
          _this.thKeys.push('TRADING_ACCOUNT_ID');

          var arr = (0, _keys2.default)(_this.group).filter(function (v) {
            return v != 'ALL';
          });
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var v = _step.value;

              _this.thKeys.push(v + '_LOT');
              _this.thKeys.push(v + '_REBATE_DIFF');
              _this.thKeys.push(v + '_COMMISSION_DIFF');
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          _this.thKeys = (0, _keys2.default)(_this.trData[0]);
        }
        _this.setOfficeState();
        _this.loading = false;
      });
    },
    setOfficeState: function setOfficeState() {
      var _this2 = this;

      var total = this.detailLan.detailTotal;
      var internal = this.detailLan.internal;
      var afterrule = this.detailLan.afterrule;
      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach(function (item, index) {
          var temp = _this2.trData[index];
          if (_this2.queryObj.TYPE == 1) {
            var group = temp.PRODUCT_GROUP;
            var rule = temp.RULE_ID;
            temp.rule_id = temp.RULE_ID ? _this2.publicLan.rule[temp.RULE_ID] : '';
            temp.product_group = temp.PRODUCT_GROUP ? _this2.publicLan.products[temp.PRODUCT_GROUP] : '';
            if (index !== _this2.trData.length - 1) {
              temp.ib_id = temp.IB_ID;
              return true;
            }
            temp.ib_id = _this2.detailLan.total[temp.IB_ID];
            return true;
          }
          if (index > _this2.trData.length - 3) {
            temp.trading_account_id = temp.TRADING_ACCOUNT_ID ? total[temp.TRADING_ACCOUNT_ID] : '';
            temp[_this2.thKeys[4].toLowerCase()] = internal[temp[_this2.thKeys[4]]];
            temp[_this2.thKeys[6].toLowerCase()] = temp[_this2.thKeys[6]] ? afterrule[temp[_this2.thKeys[6]]] ? afterrule[temp[_this2.thKeys[6]]] : temp[_this2.thKeys[6]] : '';
            return true;
          }

          temp.client_id = temp.CLIENT_ID;
          temp[_this2.thKeys[2].toLowerCase()] = temp[_this2.thKeys[2]];
          temp[_this2.thKeys[4].toLowerCase()] = temp[_this2.thKeys[4]];
          temp[_this2.thKeys[6].toLowerCase()] = temp[_this2.thKeys[6]];
        });
      }
    }
  },
  computed: {
    thData: function thData() {
      if (this.queryObj.TYPE == 0) {
        //if(this.thKeys.length == 0) return this.detailLan.extraDetail
        var arr = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(this.thKeys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var v = _step2.value;

            var obj = {};
            obj.key = v;
            obj.name = this.publicLan.detailTh[v];
            arr.push(obj);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (arr.length != 0) {
          arr[2].key = arr[2].key.toLowerCase();
          arr[4].key = arr[4].key.toLowerCase();
          arr[6].key = arr[6].key.toLowerCase();
        }
        return arr;
      }
      return this.detailLan.lowerTh;
    },
    name: function name() {
      return this.detailLan.datailText;
    },
    downLoadTran: function downLoadTran() {
      if (this.queryObj.TYPE == 1) {
        return {
          IB_ID: this.detailLan.total,
          RULE_ID: this.publicLan.rule,
          PRODUCT_GROUP: this.publicLan.products
        };
      }
      var dlObj = { TRADING_ACCOUNT_ID: this.detailLan.detailTotal };
      dlObj[this.thKeys[4]] = this.detailLan.internal;
      dlObj[this.thKeys[6]] = this.detailLan.afterrule;
      return dlObj;
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data', 'data'],
        rID: this.queryObj.REPORT_ID,
        cID: this.queryObj.IB_ID,
        type: this.detailLan.typeList[this.queryObj.TYPE],
        ajaxPar: {
          report_id: this.queryObj.REPORT_ID,
          type: this.queryObj.TYPE,
          id: this.queryObj.IB_ID
        }
      };
    }
  },
  watch: {
    detailLan: function detailLan() {
      this.queryObj.type = this.detailLan.typeList[this.queryObj.TYPE];
      this.setOfficeState();
    },
    curArea: function curArea() {
      this.$router.push('monthlyIBResult');
    }
  },
  components: {
    mtable: _mytable2.default
  }
};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(84);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _util = __webpack_require__(11);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
  name: 'monthlyIBCommisionResult',
  mixins: [__webpack_require__(3).base({
    monthlyIBCommLan: 'monthlyIBResult'
  }), __webpack_require__(3).base({ publicLan: 'publicLan' })],
  props: ['curArea'],
  data: function data() {
    return {
      trData: [],
      queryObj: {},
      url: '',
      beginTime: '',
      endTime: '',
      timeDiff: 0,
      type: '-1',
      status: '-1',
      // proxyAccount: '',
      // depositAccount: '',
      selectKey: 'id',
      selectVal: '',
      groupKey: [],
      loading: true,
      changeTime: false,
      link: {
        key: ['AMOUNT'],
        path: 'monthCommDetailResult'
      },
      operate: {
        checkbox: true,
        url: api.getUrl20(this.curArea, _commissionApi.URL_IBMONTHLYUPDATE),
        //url: api.getLocalUrl20(URL_IBMONTHLYUPDATE),
        level: 'IB'
      },
      page: {
        active: 1,
        pageLeng: 0
      },
      selPage: {
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    };
  },
  mounted: function mounted() {
    this.queryObj = this.$route.query;
    this.timeDiff = (0, _util.getTimeDiff)();
    var sinStr = sessionStorage.getItem('back');
    if (sinStr) {
      var sinObj = JSON.parse(sinStr);
      var secondBack = sinObj.secondBack;
      if (secondBack) {
        this.type = secondBack.type;
        this.status = secondBack.status;
        // this.proxyAccount = secondBack.id
        this.selectKey = secondBack.selectKey;
        this.selectVal = secondBack.selectVal;
        this.page.active = secondBack.pageNum + 1;
        this.selPage.limit = secondBack.pageSize;
      }
      this.tableAjax();
      delete sinObj.secondBack;
      sessionStorage.setItem('back', (0, _stringify2.default)(sinObj));
    } else {
      this.tableAjax();
    }
  },

  methods: {
    searchDatas: function searchDatas() {
      this.page.active = 1;
      this.tableAjax();
    },
    tableAjax: function tableAjax() {
      var _params,
          _this = this;

      if (!/^\d{0,}$/.test(this.selectVal)) {
        this.$message.error('' + this.monthlyIBCommLan.selectKeys[this.selectKey] + this.publicLan.notNumber);
        return;
      }
      this.changeTime = true;
      this.loading = true;
      this.url = api.getUrl20(this.curArea, _commissionApi.URL_IBMONTHLYSECOND);
      var tableObj = {
        params: (_params = {
          type: this.type,
          status: this.status
        }, (0, _defineProperty3.default)(_params, this.selectKey, this.selectVal), (0, _defineProperty3.default)(_params, 'report_id', this.queryObj.REPORT_ID), (0, _defineProperty3.default)(_params, 'pageNum', this.page.active - 1), (0, _defineProperty3.default)(_params, 'pageSize', this.selPage.limit), _params)
      };

      this.$http.get(this.url, tableObj).then(function (res) {
        _this.trData = res.data.data.data;
        _this.page.pageLeng = res.data.data.count;
        var group = res.data.data.group || {};
        _this.groupKey = (0, _keys2.default)(group).filter(function (v) {
          return v != 'ALL' && v != 'CPA';
        });
        _this.setOfficeState();
        _this.loading = false;
      });
    },
    setOfficeState: function setOfficeState() {
      var _this2 = this;

      var typeList = this.monthlyIBCommLan.typeList;
      var list = this.monthlyIBCommLan.IBStatusList;
      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach(function (item, index) {
          item.checked = false;
          item.type = item.TYPE || item.TYPE == 0 ? typeList[item.TYPE] : '';
          item.status = item.STATUS || item.STATUS == 0 ? list[item.STATUS] : '';
          if (_this2.changeTime) item.LAST_UPDATE = (0, _util.updateTimeByUtc)(_this2.timeDiff, item.LAST_UPDATE);
        });
      }
    }
  },
  computed: {
    back: function back() {
      if (sessionStorage.getItem('back')) {
        var backObj = JSON.parse(sessionStorage.getItem('back'));
        backObj.secondBack = {
          type: this.type,
          status: this.status,
          // id: this.proxyAccount,
          selectKey: this.selectKey,
          selectVal: this.selectVal,
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        };
        return (0, _stringify2.default)(backObj);
      }
    },
    thData: function thData() {
      return this.monthlyIBCommLan.commmissionTh_v2;
    },
    downLoadName: function downLoadName() {
      return this.monthlyIBCommLan.text;
    },
    downLoadTran: function downLoadTran() {
      return {
        TYPE: this.monthlyIBCommLan.typeList,
        STATUS: this.monthlyIBCommLan.IBStatusList
      };
    },
    firstTh: function firstTh() {
      var obj = {
        th: this.monthlyIBCommLan.firstTh_v2,
        TYPE: this.monthlyIBCommLan.typeList
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.groupKey), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          obj.th[key + '_LOT'] = this.publicLan.detailTh[key + '_LOT'];
          obj.th[key + '_COMMISSION_DIFF'] = this.publicLan.detailTh[key + '_COMMISSION_DIFF'];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return obj;
    },
    secondTh: function secondTh() {
      return {
        th: this.monthlyIBCommLan.secondTh,
        TYPE: this.monthlyIBCommLan.typeList,
        RULE_ID: this.publicLan.rule,
        PRODUCT_GROUP: this.publicLan.products
      };
    },
    multiExcelAjax: function multiExcelAjax() {
      return {
        //url: api.getUrl20(this.curArea, URL_IBMONTHLYSECOND),
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data'],
        rID: this.queryObj.REPORT_ID,
        ajaxPar: (0, _defineProperty3.default)({
          downLoadDetail: 'true',
          type: this.type,
          status: this.status,
          report_id: this.queryObj.REPORT_ID
        }, this.selectKey, this.selectVal)
      };
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data', 'data'],
        rID: this.queryObj.REPORT_ID,
        ajaxPar: (0, _defineProperty3.default)({
          pageSize: this.page.pageLeng,
          pageNum: 0,
          type: this.type,
          status: this.status,
          report_id: this.queryObj.REPORT_ID
        }, this.selectKey, this.selectVal)
      };
    }
  },
  watch: {
    monthlyIBCommLan: function monthlyIBCommLan() {
      this.changeTime = false;
      this.setOfficeState();
    },
    curArea: function curArea() {
      this.type = '-1';
      this.status = '-1';
      // this.proxyAccount = ''
      this.selectVal = '';
      this.page.active = 1;
      sessionStorage.removeItem('back');
      this.tableAjax();
    }
  },
  components: {
    mtable: _mytable2.default
  }
};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _util = __webpack_require__(11);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
  name: 'monthlyIBResult',
  mixins: [__webpack_require__(3).base({ monthlyLan: 'monthlyIBResult' })],
  props: ['curArea'],
  data: function data() {
    return {
      trData: [],
      url: '',
      beginTime: '',
      endTime: '',
      timeDiff: 0,
      loading: true,
      changeTime: false,
      link: {
        key: ['IBCommissionResult'],
        path: 'monthlyIBCommisionResult'
      },
      page: {
        active: 1,
        pageLeng: 0
      },
      selPage: {
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    };
  },
  mounted: function mounted() {
    this.timeDiff = (0, _util.getTimeDiff)();
    if (sessionStorage.getItem('back')) {
      var backObj = JSON.parse(sessionStorage.getItem('back'));
      if (backObj.path === 'monthlyIBResult') {
        this.beginTime = backObj.beginTime;
        this.endTime = backObj.endTime;
        this.page.active = backObj.pageNum + 1;
        this.selPage.limit = backObj.pageSize;
      }
      this.tableAjax();
      sessionStorage.removeItem('back');
    } else {
      this.tableAjax();
    }
  },

  methods: {
    searchData: function searchData() {
      this.loading = true;
      this.page.active = 1;
      this.tableAjax();
    },
    tableAjax: function tableAjax() {
      var _this = this;

      this.changeTime = true;
      this.url = api.getUrl20(this.curArea, _commissionApi.URL_IBMONTHLYINDEX);
      var obj = {
        params: {
          type: 'IB',
          iscpa: false,
          beginTime: (0, _util.formatDate)(this.beginTime),
          endTime: (0, _util.formatDate)(this.endTime),
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        }
      };
      this.$http.get(this.url, obj).then(function (res) {
        _this.trData = res.data.data.rows;
        _this.page.pageLeng = res.data.data.count;
        _this.setOfficeState();
        _this.loading = false;
      });
    },
    setOfficeState: function setOfficeState() {
      var _this2 = this;

      var list = this.monthlyLan.statusList;
      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach(function (item, index) {
          var temp = _this2.trData[index];
          temp.IBCommissionResult = _this2.monthlyLan.monthlyTh[1].name;
          temp.status = temp.STATUS || temp.STATUS == 0 ? list[temp.STATUS] : '';
          if (_this2.changeTime) temp.LAST_UPDATE = (0, _util.updateTimeByUtc)(_this2.timeDiff, temp.LAST_UPDATE);
        });
      }
    }
  },
  computed: {
    back: function back() {
      return (0, _stringify2.default)({
        path: 'monthlyIBResult',
        beginTime: this.beginTime,
        endTime: this.endTime,
        pageNum: this.page.active - 1,
        pageSize: this.selPage.limit
      });
    },
    name: function name() {
      return this.monthlyLan.indexText;
    },
    downLoadTran: function downLoadTran() {
      return { STATUS: this.monthlyLan.statusList };
    },
    thData: function thData() {
      return this.monthlyLan.monthlyTh;
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data', 'rows'],
        ajaxPar: {
          type: 'IB',
          iscpa: false,
          pageSize: this.page.pageLeng,
          pageNum: 0,
          beginTime: (0, _util.formatDate)(this.beginTime),
          endTime: (0, _util.formatDate)(this.endTime)
        }
      };
    }
  },
  watch: {
    monthlyLan: function monthlyLan() {
      this.changeTime = false;
      this.setOfficeState();
    },
    curArea: function curArea() {
      ;this.beginTime = '', this.endTime = '', this.page.active = 1;
      this.loading = true;
      this.tableAjax();
    }
  },
  components: {
    mtable: _mytable2.default
  }
};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var api = new _commissionEnv.Api(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'realTimeDetailResult',
  mixins: [__webpack_require__(3).base({ multiLanguage: 'realTimeReport' }), __webpack_require__(3).base({ publicLan: 'publicLan' })],
  props: ['curArea'],
  data: function data() {
    return {
      trData: [],
      obj: {},
      url: '',
      loading: true
    };
  },
  mounted: function mounted() {
    this.obj = this.$route.query;
    var getReqObj = {
      params: {
        report_id: this.obj.REPORT_ID,
        type: this.obj.TYPE,
        id: this.obj.IB_ID,
        beginTime: this.obj.BEGINTIME,
        endTime: this.obj.ENDTIME
      }
    };
    this.url = api.getUrl20(this.curArea, _commissionApi.URL_REALTIMEDETAIL);
    this.getIbReportDatas(this.url, getReqObj);
  },

  methods: {
    getIbReportDatas: function getIbReportDatas(url, obj) {
      var _this = this;

      this.$http.get(url, obj).then(function (res) {
        _this.trData = res.data.data;
        _this.setOfficeState();
        _this.loading = false;
      });
    },
    setOfficeState: function setOfficeState() {
      var _this2 = this;

      var list = this.multiLanguage.detailType;
      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach(function (item, index) {
          var temp = _this2.trData[index];
          if (_this2.obj.TYPE == 1) {
            var group = temp.PRODUCT_GROUP;
            var rule = temp.RULE_ID;
            temp.rule_id = temp.RULE_ID ? _this2.publicLan.rule[temp.RULE_ID] : '';
            temp.product_group = temp.PRODUCT_GROUP ? _this2.publicLan.products[temp.PRODUCT_GROUP] : '';
            if (index !== _this2.trData.length - 1) {
              temp.ib_id = temp.IB_ID;
              return true;
            }
            temp.ib_id = _this2.multiLanguage.total[temp.IB_ID];
            return true;
          }
          temp.type = temp.TYPE || temp.TYPE == 0 ? list[temp.TYPE] : '';
          if (index === _this2.trData.length - 1) {
            temp.trade_order_id = _this2.multiLanguage.total[temp.TRADE_ORDER_ID];
            return true;
          }
          temp.trade_order_id = temp.TRADE_ORDER_ID;
        });
      }
    }
  },
  computed: {
    thData: function thData() {
      return this.multiLanguage[this.obj.TYPE == 1 ? 'lowerLevel' : 'detailTh_v2'];
    },
    name: function name() {
      return this.multiLanguage.detail;
    },
    downLoadTran: function downLoadTran() {
      if (this.obj.TYPE == 1) {
        return {
          IB_ID: this.multiLanguage.total,
          RULE_ID: this.publicLan.rule,
          PRODUCT_GROUP: this.publicLan.products
        };
      }
      return {
        TRADE_ORDER_ID: this.multiLanguage.total,
        TYPE: this.multiLanguage.detailType
      };
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data'],
        rID: this.obj.IB_ID,
        type: this.multiLanguage.typeList[this.obj.TYPE],
        ajaxPar: {
          report_id: this.obj.REPORT_ID,
          type: this.obj.TYPE,
          id: this.obj.IB_ID,
          beginTime: this.obj.BEGINTIME,
          endTime: this.obj.ENDTIME
        }
      };
    }
  },
  watch: {
    multiLanguage: function multiLanguage() {
      this.obj.type = this.multiLanguage.typeList[this.obj.TYPE];
      this.changeTime = false;
      this.setOfficeState();
    },
    curArea: function curArea() {
      sessionStorage.removeItem('back');
      this.$router.push('realTimeResult');
    }
  },
  components: {
    mtable: _mytable2.default
  }
};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _util = __webpack_require__(11);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
  name: 'realTimeResult',
  mixins: [__webpack_require__(3).base({ multiLanguage: 'realTimeReport' }), __webpack_require__(3).base({ publicLan: 'publicLan' })],
  props: ['curArea'],
  data: function data() {
    return {
      trData: [],
      url: '',
      loading: true,
      realTime: {
        type: '-1',
        IB_ID: '',
        deposit_order_id: '',
        start_time: new Date(new Date().getTime() - 7 * 24 * 36e5),
        end_time: '',
        client_account: '',
        symbol: '',
        trade_order_id: '',
        mtlogin: '',
        depositAccount: ''
      },
      link: {
        key: ['AMOUNT'],
        path: '/ib_v2/realTimeDetailResult'
      },
      page: {
        // 分页
        active: 1,
        pageLeng: 0
      },
      selPage: {
        //  配合分页的显示col数目选择
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      },
      more: false
    };
  },
  mounted: function mounted() {
    if (sessionStorage.getItem('back')) {
      var backObj = JSON.parse(sessionStorage.getItem('back'));
      if (backObj.path === 'realTimeResult') {
        this.realTime.symbol = backObj.symbol;
        this.realTime.trade_order_id = backObj.trade_order_id;
        this.realTime.client_account = backObj.client_account;
        this.realTime.mtlogin = backObj.mtlogin;
        this.realTime.depositAccount = backObj.depositAccount;
        this.realTime.type = backObj.type;
        this.realTime.IB_ID = backObj.id;
        this.realTime.deposit_order_id = backObj.report_id;
        this.realTime.start_time = backObj.beginTime;
        this.realTime.end_time = backObj.endTime;
        this.page.active = backObj.pageNum + 1;
        this.selPage.limit = backObj.pageSize;
        this.more = backObj.more;
      }
      this.tableAjax();
      sessionStorage.removeItem('back');
    } else {
      this.tableAjax();
    }
  },

  methods: {
    searchData: function searchData() {
      this.page.active = 1;
      this.tableAjax();
    },
    tableAjax: function tableAjax() {
      var _this = this;

      var checkParams = ['trade_order_id', 'IB_ID', 'client_account', 'mtlogin', 'depositAccount', 'deposit_order_id'].every(function (v) {
        var r = /^\d{0,}$/.test(_this.realTime[v]);
        if (!r) _this.$message.error('' + _this.multiLanguage[v].replace(/：/, '') + _this.publicLan.notNumber);
        return r;
      });
      if (!checkParams) return;

      this.loading = true;
      this.url = api.getUrl20(this.curArea, _commissionApi.URL_REALTIME);
      var obj = {
        params: {
          symbol: this.realTime.symbol,
          trade_order_id: this.realTime.trade_order_id,
          client_account: this.realTime.client_account,
          mtlogin: this.realTime.mtlogin,
          depositAccount: this.realTime.depositAccount,
          type: this.realTime.type,
          id: this.realTime.IB_ID,
          report_id: this.realTime.deposit_order_id,
          beginTime: (0, _util.formatDate)(this.realTime.start_time),
          endTime: (0, _util.formatDate)(this.realTime.end_time),
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        }
      };
      this.getIbReportDatas(this.url, obj);
    },
    getIbReportDatas: function getIbReportDatas(url, obj) {
      var _this2 = this;

      this.$http.get(url, obj).then(function (res) {
        _this2.trData = res.data.data.data;
        _this2.page.pageLeng = res.data.data.count;
        _this2.setOfficeState();
        _this2.loading = false;
      });
    },
    setOfficeState: function setOfficeState() {
      var _this3 = this;

      var list = this.multiLanguage.typeList;
      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach(function (item, index) {
          var temp = _this3.trData[index];
          temp.type = temp.TYPE || temp.TYPE == 0 ? list[+temp.TYPE] : '';
        });
      }
    }
  },
  computed: {
    back: function back() {
      return (0, _stringify2.default)({
        path: 'realTimeResult',
        symbol: this.realTime.symbol,
        trade_order_id: this.realTime.trade_order_id,
        client_account: this.realTime.client_account,
        mtlogin: this.realTime.mtlogin,
        depositAccount: this.realTime.depositAccount,
        type: this.realTime.type,
        id: this.realTime.IB_ID,
        report_id: this.realTime.deposit_order_id,
        pageNum: this.page.active - 1,
        pageSize: this.selPage.limit,
        beginTime: this.realTime.start_time,
        endTime: this.realTime.end_time,
        more: this.more
      });
    },
    name: function name() {
      return this.multiLanguage.text;
    },
    downLoadTran: function downLoadTran() {
      return { TYPE: this.multiLanguage.typeList };
    },
    thData: function thData() {
      return this.multiLanguage.realTimeTh_v2;
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data', 'data'],
        ajaxPar: {
          pageSize: this.page.pageLeng,
          pageNum: 0,
          symbol: this.realTime.symbol,
          trade_order_id: this.realTime.trade_order_id,
          client_account: this.realTime.client_account,
          mtlogin: this.realTime.mtlogin,
          depositAccount: this.realTime.depositAccount,
          type: this.realTime.type,
          id: this.realTime.IB_ID,
          report_id: this.realTime.deposit_order_id,
          beginTime: (0, _util.formatDate)(this.realTime.start_time),
          endTime: (0, _util.formatDate)(this.realTime.end_time)
        }
      };
    },
    firstTh: function firstTh() {
      var nweArray = this.multiLanguage.detailTh_v2.slice();
      var obj = {
        th: {},
        TYPE: this.multiLanguage.detailType
      };
      for (var index = 1; index < 4; index++) {
        nweArray.splice(index + 1, 0, this.multiLanguage.extraHead[index]);
      }var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(nweArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var v = _step.value;
          obj['th'][v.key.toLocaleUpperCase()] = v.name;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return obj;
    },
    secondTh: function secondTh() {
      var nweArray = this.multiLanguage.extraHead.concat(this.multiLanguage.lowerLevel);
      var obj = {
        th: {},
        RULE_ID: this.publicLan.rule,
        PRODUCT_GROUP: this.publicLan.products
      };
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(nweArray), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var v = _step2.value;

          obj['th'][v.key.toLocaleUpperCase()] = v.name;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return obj;
    },
    multiExcelAjax: function multiExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data'],
        dataTh: true,
        filter: {
          columns: ['client_account', 'mtlogin'],
          btnName: this.multiLanguage.downloadFilterExcel,
          errorMsg: this.multiLanguage.errorMsg,
          mapping: { client_account: 'CLIENT_ID', mtlogin: 'TRADING_ACCOUNT_ID' },
          filterDownloadName: this.multiLanguage.filterName
        },
        ajaxPar: {
          detail: 'true',
          pageSize: this.page.pageLeng,
          pageNum: 0,
          symbol: this.realTime.symbol,
          trade_order_id: this.realTime.trade_order_id,
          client_account: this.realTime.client_account,
          mtlogin: this.realTime.mtlogin,
          depositAccount: this.realTime.depositAccount,
          type: this.realTime.type,
          id: this.realTime.IB_ID,
          report_id: this.realTime.deposit_order_id,
          beginTime: (0, _util.formatDate)(this.realTime.start_time),
          endTime: (0, _util.formatDate)(this.realTime.end_time)
        }
      };
    }
  },
  watch: {
    multiLanguage: function multiLanguage() {
      this.setOfficeState();
    },
    curArea: function curArea(newVal, oldVal) {
      this.realTime.type = '-1';
      this.realTime.IB_ID = '';
      this.realTime.deposit_order_id = '';
      this.realTime.mtlogin = '';
      this.realTime.depositAccount = '';
      this.realTime.start_time = new Date(new Date().getTime() - 7 * 24 * 36e5);
      this.realTime.end_time = '';
      this.page.active = 1;
      this.tableAjax();
    }
  },
  components: {
    mtable: _mytable2.default
  }
};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    multiLanguage: {
      type: Object,
      default: {}
    },
    commission: {
      type: Object,
      default: {}
    },
    version: {
      type: String,
      default: ''
    },
    viewBtn: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      checkedCPAS: []
    };
  },

  methods: {
    addItem: function addItem() {
      var _this = this;

      // 添加手数的方法
      /**
       * 条件1 可以添加最多10条 
      */
      if (this.commission.cpa.length + this.checkedCPAS.length <= 10) {
        this.checkedCPAS.forEach(function (el) {
          var tem = {};
          var keys = (0, _keys2.default)(_this.commission.cpa[el]);
          keys.forEach(function (item) {
            tem[item] = '';
          });
          _this.commission.cpa.splice(el + 1, 0, tem);
        });
        this.checkedCPAS = [];
      } else return;
    },
    removeItem: function removeItem() {
      // 删除手数的方法
      /**
       * 条件1 最少保留一条
       */
      if (this.checkedCPAS.length > 0) {
        var msg = this.multiLanguage.btnGroup.confirmDeleteText;
        if (confirm(msg) == true) {
          if (this.commission.cpa.length - this.checkedCPAS.length >= 1) {
            var tem = this.commission.cpa.concat([]);
            this.checkedCPAS.forEach(function (item) {
              delete tem[item];
            });
            this.commission.cpa = tem.filter(function (item) {
              return item != null;
            });
            this.checkedCPAS = [];
          } else return;
        }
      } else return;
    }
  }
};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _commissionSeek = __webpack_require__(417);

var _commissionSeek2 = _interopRequireDefault(_commissionSeek);

var _selPage = __webpack_require__(82);

var _selPage2 = _interopRequireDefault(_selPage);

var _noData = __webpack_require__(64);

var _noData2 = _interopRequireDefault(_noData);

var _uiv = __webpack_require__(14);

var _vuex = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 导入状态管理，mapMutations

// 导入子组件： 查询不到数据
// 导入子组件：搜索框
exports.default = {
  mixins: [__webpack_require__(3).base({ ibCommissionLan: "ibCommission" })],
  props: { // 接收父组件传递过来的数据，且验证数据格式

    isSetting: { // 是否设定的状态
      type: Object,
      default: {}
    },
    ibSpecialType: {
      type: Object,
      default: {}
    },
    thData: { // 表头数据
      type: Array,
      default: []
    },
    trData: { // 表主体数据
      type: Array,
      default: []
    },
    handle: { // 操作信息
      default: false
    },
    sort: { // 排序方式
      default: false
    },
    multiLanguage: { // 多语言
      type: Object,
      default: {}
    },
    seekDropdown: { // 搜索功能的选项
      default: false
    },
    selPage: { // 显示条目数
      default: false
    },
    page: { // 分页
      default: false
    },
    region: { // 地区信息
      defalut: false
    },
    ibc: { // ibc search box
      defalut: ''
    },
    modifyTime: {
      defalut: ''
    },
    confirmTime: {
      defalut: ''
    },
    templateSel: {
      type: Object,
      defalut: {}
    },
    ibTemplate: {
      type: Object,
      defalut: {}
    }
  },
  components: { // 子组件声明
    seek: _commissionSeek2.default,
    selPage: _selPage2.default,
    noData: _noData2.default,
    Dropdown: _uiv.Dropdown,
    Pagination: _uiv.Pagination
  },
  data: function data() {
    return {
      seekDropdownProps: this.seekDropdown ? this.seekDropdown : "",
      ibcAccount: '',
      modifyTstart: '',
      modifyTend: '',
      confirmTstart: '',
      confirmTend: ''
    };
  },

  methods: (0, _extends3.default)({
    excelCallbackFn: function excelCallbackFn() {
      this.$emit('downLoadExcelFn');
    },
    dropdownFn: function dropdownFn(e) {
      if (e.target.innerHTML == this.multiLanguage.isSetting.checked) {
        this.isSetting.active = 2;
        this.isSetting.listActive = 'checked';
      } else if (e.target.innerHTML == this.multiLanguage.isSetting.unchecked) {
        this.isSetting.active = 1;
        this.isSetting.listActive = 'unchecked';
      } else if (e.target.innerHTML == this.multiLanguage.isSetting.unsated) {
        this.isSetting.active = 0;
        this.isSetting.listActive = 'unsated';
      } else {
        this.isSetting.active = null;
        this.isSetting.listActive = 'allStatus';
      }
      if (this.$parent.page) this.$parent.page.active = 1;
      if (this.$parent.page) this.$parent.page.offset = 0;
      this.$emit("tableChange");
    },
    dropdownFnSpecial: function dropdownFnSpecial(e) {
      if (e.target.innerHTML == this.multiLanguage.ibSpecialType.all) {
        this.ibSpecialType.active = 2;
        this.ibSpecialType.listActive = 'all';
      } else if (e.target.innerHTML == this.multiLanguage.ibSpecialType.special) {
        this.ibSpecialType.active = 1;
        this.ibSpecialType.listActive = 'special';
      } else if (e.target.innerHTML == this.multiLanguage.ibSpecialType.normal) {
        this.ibSpecialType.active = 0;
        this.ibSpecialType.listActive = 'normal';
      } else {
        this.ibSpecialType.active = 2;
        this.ibSpecialType.listActive = 'all';
      }
      if (this.$parent.page) this.$parent.page.active = 1;
      if (this.$parent.page) this.$parent.page.offset = 0;
      this.$emit("tableChange");
    },
    dropdownFnTemplate: function dropdownFnTemplate(item) {
      this.templateSel.active = item.templateId;
      if (this.$parent.page) this.$parent.page.active = 1;
      if (this.$parent.page) this.$parent.page.offset = 0;
      this.$emit("tableChange");
    },
    linkRegister: function linkRegister(item) {
      this.$router.push({
        path: this.handle.link,
        query: {
          id: item[this.handle.idKey],
          ibc: item.ibc,
          region: this.region
        }
      });
    },
    refresh: function refresh() {
      var _this = this;

      if (this.$parent.page) this.$parent.page.active = 1;
      if (this.$parent.page) this.$parent.page.offset = 0;
      if (this.$parent.seekDropdown) this.$parent.seekDropdown.seekStr = "";
      this.ibcAccount = '';
      this.$nextTick(function () {
        return _this.$emit("tableChange");
      });
    },
    sortFn: function sortFn(key) {
      if (!this.sort || this.$parent.sort.key !== key) return;
      if (this.sort.method === "ASC") {
        this.$parent.sort.method = "DESC";
      } else if (this.sort.method === "DESC") {
        this.$parent.sort.method = "ASC";
      }
      this.$emit("tableChange");
    },
    seek: function seek(seekStr) {
      this.$parent.page.active = 1;
      if (this.page) this.$parent.page.offset = 0;
      if (this.$parent.page) this.$parent.page.active = 1;
      this.$emit("seek");
    },
    clickSeekDropdown: function clickSeekDropdown(index) {
      this.$emit("clickSeekDropdown", index);
    },
    callpageFn: function callpageFn(index) {
      this.$parent.page.active = index;
      this.$parent.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : "";
      this.$emit("tableChange");
    },
    selPageFn: function selPageFn(index, item) {
      this.SAVEPAGEMAXINDEX(index);
      this.$parent.selPage.active = index;
      this.$parent.selPage.limit = this.selPage.list[this.selPage.active];
      this.$parent.page.offset = 0;
      this.$parent.page.active = 1;
      this.$emit("tableChange");
    },
    templateLang: function templateLang(item) {
      var tmplang = "" + (this.ibCommissionLan[item.templateId] || item.templateId);
      if (tmplang) {
        var i = item.templateOverwritten ? 1 : 0;
        tmplang += "(" + this.multiLanguage.ibTempOverwriteType[i] + ")";
      }
      return tmplang;
    }
  }, (0, _vuex.mapMutations)(["SAVEPAGEMAXINDEX"])),
  watch: {
    ibcAccount: function ibcAccount(val, old) {
      this.$emit('update:ibc', val);
    },
    modifyTstart: function modifyTstart(val, old) {
      var start = val ? val : new Date(1000);
      var end = this.modifyTend ? this.modifyTend : new Date();
      this.$emit('update:modifyTime', [start, end]);
    },
    modifyTend: function modifyTend(val, old) {
      var start = this.modifyTstart ? this.modifyTstart : new Date(1000);
      var end = val ? val : new Date();
      this.$emit('update:modifyTime', [start, end]);
    },
    confirmTstart: function confirmTstart(val, old) {
      var start = val ? val : new Date(1000);
      var end = this.confirmTend ? this.confirmTend : new Date();
      this.$emit('update:confirmTime', [start, end]);
    },
    confirmTend: function confirmTend(val, old) {
      var start = this.confirmTstart ? this.confirmTstart : new Date(1000);
      var end = val ? val : new Date();
      this.$emit('update:confirmTime', [start, end]);
    },
    'templateSel.overwritten': function templateSelOverwritten(val, old) {
      this.seek();
    }
  }
}; // 导入第三方组件，Dropdown下拉菜单,Pagination页码
// 导入子组件：条目数，配合分页使用
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commissionEnv = __webpack_require__(5);

var _commissionApi = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
  props: ['region', 'ibCommissionLan'],
  mixins: [__webpack_require__(3).base({ ibCommissionRuleSettingLan: "ibCommissionRuleSetting" })],
  data: function data() {
    return {
      enableDistribution: api.enableDistribution,
      previewData: {
        mainIB: this.$route.query.id,
        IB: [],
        lowerIB: [],
        specialIB: []
      },
      ruleSeq: []
    };
  },
  mounted: function mounted() {
    this.pageInit();
  },

  methods: {
    pageInit: function pageInit() {
      var _this = this;

      this.$http.get(api.getUrl20(this.region, _commissionApi.URL_IBPREVIEW + '/' + this.$route.query.id)).then(function (res) {
        _this.previewData.IB = res.data.data.IB;
        _this.previewData.lowerIB = res.data.data.lowerIB;
        _this.previewData.specialIB = res.data.data.specialIB;
        _this.ruleSeq = res.data.data.ruleSeq;
      });
    }
  }
};

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ibCommissionPreview = __webpack_require__(1019);

var _ibCommissionPreview2 = _interopRequireDefault(_ibCommissionPreview);

var _ibCommissionSettingContent = __webpack_require__(1021);

var _ibCommissionSettingContent2 = _interopRequireDefault(_ibCommissionSettingContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 导入子组件 代理佣金具体内容设定

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'IBCommissionSetting',
  mixins: [__webpack_require__(3).base({ ibCommissionLan: "ibCommission" })],
  props: ['curArea'],
  components: {
    ibCommissionPreview: _ibCommissionPreview2.default,
    ibCommissionSettingContent: _ibCommissionSettingContent2.default
  },
  data: function data() {
    return {
      viewBtn: 'onlyOne',
      showPreview: false
    };
  },

  methods: {
    afterVerifyFn: function afterVerifyFn() {
      // 审核成功后 再次刷新version0
      this.$refs.version0 && this.$refs.version0.pageInit('0');
    }
  }
}; //  导入子组件 代理佣金预览

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(83);

var _promise2 = _interopRequireDefault(_promise);

var _internalCommission = __webpack_require__(1023);

var _internalCommission2 = _interopRequireDefault(_internalCommission);

var _cpaCommission = __webpack_require__(1017);

var _cpaCommission2 = _interopRequireDefault(_cpaCommission);

var _ruleSetting = __webpack_require__(1024);

var _ruleSetting2 = _interopRequireDefault(_ruleSetting);

var _commissionApi = __webpack_require__(7);

var _util = __webpack_require__(11);

var _uiv = __webpack_require__(14);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);
moment().format();

var api = new _commissionEnv.Api();
exports.default = {
  mixins: [__webpack_require__(3).base({ multiLanguageTable: "commissionTable" })],
  props: {
    curArea: {
      type: String,
      default: ''
    },
    multiLanguage: { //多语言
      type: Object,
      default: {}
    },
    version: { // 版本
      type: String,
      default: ''
    },
    viewBtn: { // 视图
      type: String,
      default: ''
    }
  },
  components: {
    Modal: _uiv.Modal,
    Btn: _uiv.Btn,
    Dropdown: _uiv.Dropdown,
    internalCommission: _internalCommission2.default,
    cpaCommission: _cpaCommission2.default,
    ruleSetting: _ruleSetting2.default
  },
  data: function data() {
    return {
      showModal: false,
      sucSave: false,
      UTCDIFF: (0, _util.getTimeDiff)(),
      mode: 0,
      timeIsChange: '',
      enableDistribution: api.enableDistribution,
      commission: {
        cpa: [],
        enable: false,
        lvl: [],
        ReminderDate: '',
        ReminderMsg: '',
        sendEml: '',
        enableUpperCalc: '',
        updateBy: '',
        lastUpdate: '',
        confirmBy: '',
        lastConfirm: '',
        isConfirm: false,
        isSpecial: false,
        templateId: null,
        templateOverwrite: false
      },
      groupSeq: [],
      relation: [],
      rule: [],
      ruleSeq: [],
      currentIB: {},
      ibTemplate: null,
      cpaTemplate: null
    };
  },
  mounted: function mounted() {
    this.pageInit(this.version);
  },

  computed: {
    lvlLawful1: function lvlLawful1() {
      var _this = this;

      // 检查lvl的开始和结束是否合法
      var res = true;
      if (this.mode == '0' || this.mode == '2') {
        this.commission.lvl.forEach(function (item, index) {
          if (index < _this.commission.lvl.length - 1) {
            res = item.start - item.end > 0 ? false : true;
          }
        });
      }
      return res;
    },
    lvlLawful2: function lvlLawful2() {
      var _this2 = this;

      // 检查lvl的区间是否连贯
      var res = true;
      if (this.mode == '0' || this.mode == '2') {
        this.commission.lvl.forEach(function (item, index) {
          if (_this2.commission.lvl[index + 1]) {
            if (!((_this2.commission.lvl[index + 1].start - _this2.commission.lvl[index].end).toFixed(2) == 0.01)) {
              res = false;
              return;
            }
          }
        });
      }
      return res;
    },
    cpaLawful1: function cpaLawful1() {
      var _this3 = this;

      // 检查cpa的开始和结束是否合法
      var res = true;
      if (this.mode == '1' || this.mode == '2') {
        this.commission.cpa.forEach(function (item, index) {
          if (index < _this3.commission.cpa.length - 1) {
            res = item.start - item.end > 0 ? false : true;
          }
        });
      }
      return res;
    },
    cpaLawful2: function cpaLawful2() {
      var _this4 = this;

      // 检查cpa的区间是否连贯
      var res = true;
      if (this.mode == '1' || this.mode == '2') {
        this.commission.cpa.forEach(function (item, index) {
          if (_this4.commission.cpa[index + 1]) {
            if (!((_this4.commission.cpa[index + 1].start - _this4.commission.cpa[index].end).toFixed(2) == 1)) {
              res = false;
              return;
            }
          }
        });
      }
      return res;
    },
    updateData: function updateData() {
      var _this5 = this;

      // 需要更新的数据
      this.commission.lvl.forEach(function (item, index) {
        item.lvl = index + 1;
        if (index == _this5.commission.lvl.length - 1) item.end = '-1.00';
        if (index == 0) item.start = '0.00';
      });
      if (this.commission.cpa !== 'not exist') {
        this.commission.cpa.forEach(function (item, index) {
          if (index == _this5.commission.cpa.length - 1) item.end = '-1.00';
          if (index == 0) item.start = '1.00';
        });
      }
      return {
        commission: {
          ibId: this.$route.query.id,
          updateBy: JSON.parse(sessionStorage.user).user_name,
          enable: this.commission.enable,
          isSpecial: this.commission.isSpecial,
          expiredDate: this.commission.ReminderDate,
          expiredMessage: this.commission.ReminderMsg,
          expiredMessageSend: this.timeIsChange ? false : this.commission.sendEml,
          lvl: this.commission.lvl,
          cpa: this.commission.cpa,
          mode: this.mode,
          enableUpperCalc: this.enableDistribution ? this.commission.enableUpperCalc : false,
          templateId: this.commission.templateId || false
          //templateOverwritten: this.commission.templateOverwrite?1:0,
        },
        rule: this.rule
      };
    },
    verifyData: function verifyData() {
      // 提交审核的参数
      return {
        commission: {
          ibId: this.$route.query.id,
          confirmBy: JSON.parse(sessionStorage.user).user_name
        }
      };
    },
    templateLang: function templateLang() {
      var _this6 = this;

      if (!this.ibTemplate || this.ibTemplate.length == 0) return '';
      var temp = this.ibTemplate.find(function (it) {
        return it.templateId == _this6.commission.templateId;
      });
      if (!temp) return '';
      var lang = this.multiLanguage[temp.langKey] || temp.templateId;
      var i = this.commission.templateOverwrite ? 1 : 0;
      return lang + '(' + this.multiLanguageTable.ibTempOverwriteType[i] + ')';
    }
  },
  methods: {
    pageInit: function pageInit(version) {
      var _this7 = this;

      // 初始化数据
      var oId = this.$route.query.id;
      this.$http.get(api.getUrl20(this.curArea, _commissionApi.URL_IBSET) + '/' + version + '/' + oId, { headers: { UTCDIFF: this.UTCDIFF } }).then(function (res) {
        if (res.data.code == 200 && res.data.data && res.data.msg == 'OK') {
          var data = res.data.data;
          _this7.mode = data.commission.mode;
          _this7.commission.enable = data.commission.enable;
          _this7.commission.lvl = data.commission.lvl;
          _this7.commission.cpa = data.commission.cpa;
          _this7.commission.ReminderDate = data.commission.expiredDate;
          _this7.commission.ReminderMsg = data.commission.expiredMessage;
          _this7.commission.sendEml = data.commission.expiredMessageSend;
          _this7.commission.enableUpperCalc = data.commission.enableUpperCalc;
          _this7.commission.updateBy = data.commission.updateBy;
          _this7.commission.lastUpdate = data.commission.lastUpdate ? (0, _util.updateTimeByUtc)(_this7.UTCDIFF, data.commission.lastUpdate) : data.commission.lastUpdate;
          _this7.commission.confirmBy = data.commission.confirmBy;
          _this7.commission.lastConfirm = data.commission.lastConfirm ? (0, _util.updateTimeByUtc)(_this7.UTCDIFF, data.commission.lastConfirm) : data.commission.lastConfirm;
          _this7.commission.isConfirm = data.commission.isConfirm;
          _this7.commission.isSpecial = data.commission.isSpecial;
          _this7.commission.templateId = data.commission.templateId;
          _this7.commission.templateOverwrite = data.commission.templateOverwritten;
          _this7.groupSeq = data.groupSeq;
          _this7.relation = data.relation.slice(0, -1);
          _this7.currentIB = {
            id: data.commission.ibId,
            ibc: data.relation[data.relation.length - 1].ibc || null,
            name: data.commission.name
          };

          _this7.rule = data.rule.length > 0 ? data.rule : [[]];
          _this7.ruleSeq = data.ruleSeq;
          _this7.ibTemplate = data.template.ibTemplate;
          _this7.cpaTemplate = data.template.cpaTemplate;
        }
      });
    },
    submit: function submit() {
      var _this8 = this;

      // 提交
      function isTrueFn(element) {
        return element == true;
      }
      var arr = [];
      if (this.mode == '0' || this.mode == '2') arr.push(this.$refs.internalCommission.$validator.validateAll());
      if (this.mode == '1' || this.mode == '2') arr.push(this.$refs.cpaCommission.$validator.validateAll());
      arr.push(this.$refs.ruleSetting.$validator.validateAll());
      _promise2.default.all(arr).then(function (result) {
        if (_this8.lvlLawful1 && _this8.lvlLawful2 && _this8.cpaLawful1 && _this8.cpaLawful2 && result.every(isTrueFn) && _this8.checkRuleSetting1(_this8.updateData.rule)) {
          // 发请求去保存
          // console.log('发请求')
          _this8.$http.post(api.getUrl20(_this8.curArea, _commissionApi.URL_IBSET) + '/1', _this8.updateData).then(function (res) {
            if (res.data.code == 200 && res.data.data.msg == "OK") {
              //this.showModal = true
              //this.sucSave = true
              _this8.$message.success(_this8.multiLanguage.submitResult.succeed);
              _this8.commission.updateBy = JSON.parse(sessionStorage.user).user_name;
              _this8.commission.lastUpdate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
              _this8.commission.isConfirm = false;
              _this8.commission.templateOverwrite = res.data.data.templateOverwritten;
            } else {
              //this.showModal = true
              //this.sucSave = false
              _this8.$message.error(_this8.multiLanguage.submitResult.serverErr);
            }
          });
        } else {
          _this8.showModal = true;
          _this8.sucSave = false;
        }
      });
    },
    verify: function verify() {
      var _this9 = this;

      // 确认审核
      if (!this.commission.updateBy) {
        alert(this.multiLanguage.alertMsg.beforeSave);
        return;
      } else if (this.verifyData.commission.confirmBy == this.commission.updateBy) {
        alert(this.multiLanguage.alertMsg.checkFail);
        return;
      } else {
        var msg = this.multiLanguage.alertMsg.verifyTips;
        if (confirm(msg) == true) {
          this.$http.post(api.getUrl20(this.curArea, _commissionApi.URL_IBSET) + '/0', this.verifyData).then(function (res) {
            if (res.data.code == 200 && res.data.data.msg == "OK") {
              //this.showModal = true
              //this.sucSave = true
              _this9.$message.success(_this9.multiLanguage.submitResult.auditSuccess);
              _this9.commission.isConfirm = true;
              _this9.$emit('afterVerify');
            } else {
              //this.showModal = true
              //this.sucSave = false
              _this9.$message.error(_this9.multiLanguage.submitResult.serverErr);
            }
          });
        }
      }
    },
    normSetFn: function normSetFn(path, type) {
      var _this10 = this;

      // 拿到内设数据
      this.$http.get(api.getUrl20(this.curArea, _commissionApi.URL_DEFAULT) + path).then(function (res) {
        if (res.data.code === 200) {
          if (type === 'ib') {
            _this10.commission.lvl = res.data.data.setting;
            _this10.mode = _this10.mode !== 2 ? 0 : 2;
            _this10.commission.enableUpperCalc = true;
            _this10.rule = res.data.data.rulemapping;
            _this10.rule.forEach(function (val) {
              val.forEach(function (v) {
                v.value = +v.value ? parseFloat(v.value).toFixed(4) : 0;
              });
            });
            _this10.commission.templateId = path;
            _this10.commission.templateOverwrite = false;
          } else if (type === 'cpa') {
            _this10.commission.cpa = res.data.data.setting;
            _this10.mode = _this10.mode !== 2 ? 1 : 2;
            _this10.commission.enableUpperCalc = true;
            _this10.rule = res.data.data.rulemapping;
          }
        }
      });
    },
    checkIdFn: function checkIdFn(ruleItem) {
      var _this11 = this;

      // 检查id是否在关系图
      this.$http(api.getUrl20(this.curArea, _commissionApi.URL_TOOLCHECKID), { params: { id: ruleItem.commTarget, type: 'IB' } }).then(function (res) {
        var result = res.data.data.result;
        if (!result) {
          alert(_this11.multiLanguage.alertMsg.noAccount);
          ruleItem.commTarget = '';
        }
      });
    },
    checkRuleSetting1: function checkRuleSetting1(rule) {
      var checkRule = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(rule), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var val = _step.value;

          var rCheck = {};
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = (0, _getIterator3.default)(val), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var r = _step2.value;

              if (r.ruleId == 3 || r.ruleId == 5) {
                if (!checkRule[r.ruleId + '-' + r.ruleGroup]) {
                  checkRule[r.ruleId + '-' + r.ruleGroup] = { count: 1, content: (0, _stringify2.default)({ spreadEnable: r.spreadEnable, externalCommissionEnable: r.externalCommissionEnable, internalCommissionEnable: r.internalCommissionEnable }) };
                } else {
                  if ((0, _stringify2.default)({ spreadEnable: r.spreadEnable, externalCommissionEnable: r.externalCommissionEnable, internalCommissionEnable: r.internalCommissionEnable }) != checkRule[r.ruleId + '-' + r.ruleGroup].content) {
                    // 存在“分层最高金额”这个规则设定时，加点、外佣、内返的值必须相同
                    alert(this.multiLanguage.alertMsg.checkRuleFail1);
                    return false;
                  } else {
                    checkRule[r.ruleId + '-' + r.ruleGroup].count++;
                  }
                }
                if (rCheck[r.ruleId + '-' + r.ruleGroup] == undefined) rCheck[r.ruleId + '-' + r.ruleGroup] = true;else {
                  return false;
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      for (var key in checkRule) {
        if (checkRule[key].count != rule.length) {
          // 存在“分层最高金额”这个规则时，每个级别都必须有一条相同的“分层最高金额”，并保证“加点、外佣、内返”一致
          alert(this.multiLanguage.alertMsg.checkRuleFail2);
          return false;
        }
      }
      return true;
    }
  }
};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _iTable = __webpack_require__(1018);

var _iTable2 = _interopRequireDefault(_iTable);

var _commissionEnv = __webpack_require__(5);

var _commissionApi = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 导入 URL_IBALL（获取所有代理列表）接口
// 导入 子组件：主体内容
var api = new _commissionEnv.Api(); // 创建实例 api

// 导入 Api(构造函数) commission 配置项
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [__webpack_require__(3).base({ multiLanguage: "commissionTable" }), __webpack_require__(3).base({ ibCommissionLan: "ibCommission" })], // 导入 多语言commissionTable，作用：渲染子组件需要的所有翻译。
  props: ['curArea', 'status'], // 接受父组件传递过来的curArea地区信息，作用：子组件根据它发ajax。注意这里是：非第三方组件，此处可以不用验证传入的内容，所以用数组字符串的形式接受props。
  components: { // 子组件声明
    itable: _iTable2.default
  },
  data: function data() {
    return {
      loading: false, // 作用：存放loading的状态，能默认不启动loading。
      trData: [], //  作用：存放表主体数据
      isSetting: { // 作用：存放设定的状态
        /**
         * active:
         *  * 当前活动的状态，作用是发ajax请求去后台拿数据时，告诉后台需要什么状态的数据；
         *  * 是个布尔类型，false表示未设定的状态，true表示已设定的状态，而如果为null,这不告诉后台，那么將返回全部状态数据。
         *
         * listActive:
         *  * 页面上属于状态的下拉菜单，根据这个值来显示当前选中的是哪个状态。
         *
         * list:
         *  * 状态列表：allStatus全部状态、sated已设定、unsated未设定
         */
        active: this.status ? this.status : null,
        listActive: this.status && this.status == '0' ? 'unsated' : this.status && this.status == '1' ? 'unchecked' : 'allStatus',
        list: { allStatus: "allStatus", sated: "sated", unsated: "unsated", checked: 'checked', unchecked: 'unchecked' }
      },
      ibSpecialType: {
        active: 2,
        listActive: 'all'
      },
      ibc: "",
      sort: { // 作用：存放排序信息：key排序的关键字段，methods排序的方法
        key: "node_id",
        method: "ASC"
      },
      handle: { //  作用：存放操作信息：link跳转的地址，idKey调整时传递的关键字段是id
        link: "ibCommissionSetting",
        idKey: "node_id"
      },
      seekDropdown: { // 作用：存放搜索的选项
        active: 'loginId', // list坐标
        seekStr: "", // 搜索内容
        list: { // 搜索项列表
          loginId: "node_id",
          userName: "name",
          phone: "phone",
          email: "email"
        }
      },
      page: { // 作用：存放分页信息
        active: 1,
        pageLeng: 0,
        offset: 0 // 查询数据库的offset需要的值，初始只为0组件内部处理最后给出一个能直接传给后台的值
      },
      selPage: { // 作用：配合分页的显示col数目选择
        list: [5, 10, 25, 50], // 选择显示col数目
        active: localStorage.pageMaxIndex, // 当前list的坐标
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex] // 查询数据库的limit需要的值，初始值设为list的0坐标组件内部处理最后给出一个传给后台的值
      },
      modifyTime: '',
      confirmTime: '',
      templateSel: { active: 'allTemplateId', overwritten: 2 },
      ibTemplate: {}
    };
  },
  mounted: function mounted() {
    /**
     * 每次挂载这个组件成功后
     *  * 初始化 搜索的内容
     *  * 初始化 表格数据
     */
    this.seekDropdown && (this.seekDropdown.seekStr = "");
    this.tableAjax();
  },

  computed: {
    thData: function thData() {
      // 表格th数据
      return [this.multiLanguage.th.specialCommission, this.multiLanguage.th.loginId, this.multiLanguage.th.ibcAccount, this.multiLanguage.th.IBCode, this.multiLanguage.th.accountName, this.multiLanguage.th.phone, this.multiLanguage.th.email, this.multiLanguage.th.updateBy, this.multiLanguage.th.confirmBy, this.multiLanguage.th.template, this.multiLanguage.th.status, this.multiLanguage.th.settingStatus];
    }
  },
  methods: {
    tableAjax: function tableAjax() {
      var _this = this;

      // 请求表格数据的方法
      try {
        /**
        * 先启动loading效果
        * 准备ajax的参数：{offset,limit,sortKey,sort,seekKey,seekVal,isSetting}
        * 发起ajax请求，注意这里的url要动态传入，成功之后拿到表主体数据赋值给 this.trData,还有条目总数
        * 所有操作完成之后，关闭loading效果
        */
        this.loading = true;

        var offset = this.page.offset,
            limit = this.selPage.limit,
            sortKey = this.sort.key,
            sort = this.sort.method,
            seekKey = this.seekDropdown.list[this.seekDropdown.active],
            seekVal = this.seekDropdown.seekStr,
            isSetting = this.isSetting.active,
            isSpecial = this.ibSpecialType.active,
            ibc = this.ibc,
            modifyTime = this.modifyTime,
            confirmTime = this.confirmTime,
            templateId = this.templateSel.active,
            templateOverwritten = this.templateSel.overwritten;

        this.$http(api.getUrl20(this.curArea, _commissionApi.URL_IBALL), { params: { limit: limit, offset: offset, sortKey: sortKey, sort: sort, seekKey: seekKey, seekVal: seekVal,
            isSetting: isSetting, ibc: ibc, isSpecial: isSpecial, modifyTime: modifyTime, confirmTime: confirmTime, templateId: templateId, templateOverwritten: templateOverwritten } }).then(function (res) {
          var data = res.data.data;
          if (data.ibTemplate) _this.ibTemplate = data.ibTemplate.reduce(function (s, i) {
            s[i.templateId] = i;
            return s;
          }, { allTemplateId: { templateId: 'allTemplateId', langKey: 'ib_allTemplate' } });
          var tmp = [];
          data.rows.forEach(function (item) {
            var tempId = _this.ibTemplate[item.templateId] ? _this.ibTemplate[item.templateId].langKey : '';
            if (!_this.ibCommissionLan[tempId]) tempId = item.templateId;
            tmp.push({
              isSpecial: item.isSpecial,
              node_id: item.nodeId,
              ibc: item.ibc,
              node_code: item.nodeCode,
              name: item.name,
              phone: item.phone,
              email: item.email,
              updateBy: item.modifyBy,
              confirmBy: item.confirmBy,
              enable: item.enable,
              ib_rebatesetting: item.ibSetting,
              templateId: tempId || '',
              templateOverwritten: item.templateOverwritten
            });
          });
          _this.trData = tmp;
          _this.page.pageLeng = data.count;
          _this.loading = false;
        }).catch(function (err) {
          _this.loading = false;
        });
      } catch (error) {
        this.loading = false;
      }
    },
    excelDown: function excelDown() {
      var _this2 = this;

      // 下载excel表格的方法：先发ajax请求拿到数据
      /**
       * 准备ajax的参数：{offset,limit,sortKey,sort,seekKey,seekVal,isSetting}
       * 发起ajax请求，注意这里的url要动态传入，成功之后拿到 excel表主体数据 保存在一个变量中excelData,并遍历它对其中的一些数据做翻译
       * 准备一个变量excelTH保存 excel表头信息
       * 最后调用 export2Excel 生成excel表格
       */
      var offset = this.page.offset,
          limit = this.page.pageLeng,
          sortKey = this.sort.key,
          sort = this.sort.method,
          seekKey = this.seekDropdown.list[this.seekDropdown.active],
          seekVal = this.seekDropdown.seekStr,
          isSetting = this.isSetting.active,
          isSpecial = this.ibSpecialType.active,
          ibc = this.ibc,
          modifyTime = this.modifyTime,
          confirmTime = this.confirmTime,
          templateId = this.templateSel.active,
          templateOverwritten = this.templateSel.overwritten;

      this.$http(api.getUrl20(this.curArea, _commissionApi.URL_IBALL), { params: { limit: limit, offset: offset, sortKey: sortKey, sort: sort, seekKey: seekKey, seekVal: seekVal,
          isSetting: isSetting, ibc: ibc, isSpecial: isSpecial, modifyTime: modifyTime, confirmTime: confirmTime, templateId: templateId, templateOverwritten: templateOverwritten } }).then(function (res) {
        var excelData = [];
        var ibtemplate = {};
        if (res.data.data.ibTemplate) ibtemplate = res.data.data.ibTemplate.reduce(function (s, i) {
          s[i.templateId] = i;
          return s;
        }, { allTemplateId: { templateId: 'allTemplateId', langKey: 'ib_allTemplate' } });
        var data = res.data.data.rows;
        data.forEach(function (item) {
          var tem = {};
          for (var key in item) {
            if (key == 'enable') {
              tem[key] = item[key] == 0 ? _this2.multiLanguage.ibStatus.disenable : _this2.multiLanguage.ibStatus.enable;
            } else if (key == 'ibSetting') {
              tem[key] = item[key] == 0 ? _this2.multiLanguage.isSetting.unsated : item[key] == 1 ? _this2.multiLanguage.isSetting.unchecked : _this2.multiLanguage.isSetting.checked;
            } else if (key == 'isSpecial') {
              tem[key] = item[key] == 0 ? 'N' : 'Y';
            } else if (key == 'templateId') {
              var lang = item[key] ? ibtemplate[item[key]].langKey : '';
              tem[key] = _this2.ibCommissionLan[lang] || item[key];
              if (item['templateOverwritten']) tem[key] += '(Overwritten)';
            } else if (key == 'modifyTime' || key == 'confirmTime' || key == 'templateOverwritten') {} else tem[key] = item[key];
          }
          excelData.push(tem);
        });
        var excelTH = (0, _keys2.default)(excelData[0]);
        _this2.export2Excel(excelTH, excelData);
      });
    },
    export2Excel: function export2Excel(excelTH, excelData) {
      var _this3 = this;

      // 下载excel表格的方法：拿到 excel表头和excel表主体数据 之后利用插件Export2Excel.js生成excel表格
      var thRes = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(excelTH), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var code = _step.value;

          code == 'nodeId' && thRes.push(this.multiLanguage.th.loginId);
          code == 'ibc' && thRes.push(this.multiLanguage.th.ibcAccount);
          code == 'nodeCode' && thRes.push(this.multiLanguage.th.IBCode);
          code == 'name' && thRes.push(this.multiLanguage.th.accountName);
          code == 'phone' && thRes.push(this.multiLanguage.th.phone);
          code == 'email' && thRes.push(this.multiLanguage.th.email);
          code == 'enable' && thRes.push(this.multiLanguage.th.status);
          code == 'ibSetting' && thRes.push(this.multiLanguage.th.settingStatus);
          code == 'isSpecial' && thRes.push(this.multiLanguage.th.specialCommission);
          code == 'modifyBy' && thRes.push(this.multiLanguage.th.updateBy);
          code == 'confirmBy' && thRes.push(this.multiLanguage.th.confirmBy);
          code == 'templateId' && thRes.push(this.multiLanguage.th.template);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      new Promise(function(resolve) { resolve(); }).then((function () {
        var _require = __webpack_require__(65),
            export_json_to_excel = _require.export_json_to_excel;

        var tHeader = thRes;
        var filterVal = excelTH;
        var list = excelData;
        var data = _this3.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, 'excel');
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      // export2Excel这个方法所需要的一个方法，作用：格式数据
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    }
  },
  watch: {
    curArea: function curArea() {
      // 监听：curArea 地区发生变化时，根据地区不同，初始化的baseUrl，之后执行tableAjax方法
      this.tableAjax();
    }
  }
};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [__webpack_require__(3).base({ publicLan: "publicLan" })],
  props: {
    multiLanguage: { // 多语言
      type: Object,
      default: {}
    },
    commission: { // 佣金数据
      type: Object,
      default: {}
    },
    groupSeq: { // 产品组
      type: Array,
      default: []
    },
    version: { // 当前版本：0为审核的版本，1为未审核的版本
      type: String,
      default: ''
    },
    viewBtn: { // 浏览的视图： double为对比浏览，onlyOne为单页浏览
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      checkedLvls: [] // 已经选中的commission.lvl的下标，存放在这个数组里面，方便添加或者删除 lvl 时使用
    };
  },

  methods: {
    addItem: function addItem() {
      var _this = this;

      // 添加lvl的方法
      /* 条件：
        * 1、最多只能添加4个级别，
        * 2、可以在指定的位置添加级别
        * 3、如果没有选中位置，则默认在最后添加级别 */
      if (this.checkedLvls.length > 0 && this.commission.lvl.length + this.checkedLvls.length <= 4) {
        this.checkedLvls.forEach(function (el) {
          var tem = {};
          var keys = (0, _keys2.default)(_this.commission.lvl[el]);
          keys.forEach(function (item) {
            tem[item] = '';
          });
          _this.commission.lvl.splice(el + 1, 0, tem);
        });
        this.checkedLvls = [];
      } else if (this.checkedLvls.length == 0 && this.commission.lvl.length + this.checkedLvls.length < 4) {
        var tem = {};
        var keys = (0, _keys2.default)(this.commission.lvl[0]);
        keys.forEach(function (item) {
          tem[item] = '';
        });
        this.commission.lvl.push(tem);
      } else return;
    },
    removeItem: function removeItem() {
      // 删除lvl的方法
      /* 条件：
      * 1、必须选中才能删除，且删除前需要确认
      * 2、最少保留一个级别
      * 3、删除可以指定的级别
      * */
      if (this.checkedLvls.length > 0) {
        var msg = this.multiLanguage.btnGroup.confirmDeleteText;
        if (confirm(msg) == true) {
          if (this.commission.lvl.length - this.checkedLvls.length >= 1) {
            var tem = this.commission.lvl.concat([]);
            this.checkedLvls.forEach(function (item) {
              delete tem[item];
            });
            this.commission.lvl = tem.filter(function (item) {
              return item != null;
            });
            this.checkedLvls = [];
          } else return;
        }
      } else return;
    }
  }
};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuedraggable = __webpack_require__(131);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    draggable: _vuedraggable2.default
  },
  props: {
    multiLanguage: {
      type: Object,
      default: {}
    },
    groupSeq: {
      type: Array,
      default: []
    },
    enableUpperCalc: {
      type: Boolean,
      default: false
    },
    version: {
      type: String,
      default: ''
    },
    relation: {
      type: Array,
      default: []
    },
    rule: {
      type: Array,
      default: []
    },
    ruleSeq: {
      type: Array,
      default: []
    },
    viewBtn: {
      type: String,
      default: ''
    },
    currentIB: {
      type: Object,
      default: {}
    }
  },
  mixins: [__webpack_require__(3).base({ ruleSettingLan: "ibCommissionRuleSetting" }), __webpack_require__(3).base({ publicLan: "publicLan" })],
  data: function data() {
    return {
      drag: null,
      ruleGroup: '',
      checkedLevel: [],
      onfocus: false
    };
  },

  methods: {
    addLevel: function addLevel() {
      // 添加级别
      this.rule.splice(this.rule.length - 1, 0, [{
        commTarget: null,
        enableCommTarget: false,
        externalCommissionEnable: false,
        internalCommissionEnable: false,
        productGroup: 'ALL',
        ruleGroup: 0,
        ruleId: 1,
        spreadEnable: false,
        value: ""
      }]);
    },
    removeLevel: function removeLevel() {
      // 删除级别
      if (this.checkedLevel.length > 0) {
        var msg = this.multiLanguage.btnGroup.confirmDeleteText;
        if (confirm(msg) == true) {
          if (this.rule.length - this.checkedLevel.length >= 1) {
            var tem = this.rule.concat([]);
            this.checkedLevel.forEach(function (item) {
              delete tem[item];
            });
            this.$parent.rule = tem.filter(function (item) {
              return item != null;
            });
            this.checkedLevel = [];
          } else return;
        }
      } else return;
    },
    addRule: function addRule(levelItem) {
      // 添加规则
      levelItem.push({
        commTarget: null,
        enableCommTarget: false,
        externalCommissionEnable: false,
        internalCommissionEnable: false,
        productGroup: 'ALL',
        ruleGroup: 0,
        ruleId: 1,
        spreadEnable: false,
        value: ""
      });
    },
    removeRule: function removeRule(levelItem, ruleIndex) {
      // 删除规则
      var msg = this.multiLanguage.btnGroup.confirmDeleteText;
      if (confirm(msg) == true) {
        levelItem.splice(ruleIndex, 1);
      }
    },
    selectRuleFn: function selectRuleFn(ruleItem) {
      // 切换 单选按钮： 按佣金还是自定金额。 如果是自定金额就將 加点 外佣 内返 这个3个复习按钮 全部禁用且改为 未选中
      if (ruleItem.ruleGroup == 1) {
        ruleItem.spreadEnable = false;
        ruleItem.externalCommissionEnable = false;
        ruleItem.internalCommissionEnable = false;
      }
      ruleItem.value = '';
    },
    selectRule6Fn: function selectRule6Fn(ruleItem) {
      //切换 选择器方法： 如果选择的是rule6 就將value清空
      ruleItem.ruleId == 6 ? ruleItem.value = '' : null;
    },
    checkId: function checkId(ruleItem) {
      this.$emit('checkId', ruleItem);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ibTemplateSettingContent = __webpack_require__(1026);

var _ibTemplateSettingContent2 = _interopRequireDefault(_ibTemplateSettingContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 导入子组件 代理佣金具体内容设定

exports.default = {
  name: 'IBCommissionSetting',
  mixins: [__webpack_require__(3).base({ ibCommissionLan: "ibCommission" })],
  props: ['curArea'],
  components: {
    ibTemplateSettingContent: _ibTemplateSettingContent2.default
  },
  data: function data() {
    return {
      viewBtn: 'onlyOne',
      showPreview: false,
      currentTemplate: 'DEFAULT'
    };
  },

  methods: {
    afterVerifyFn: function afterVerifyFn() {
      // 审核成功后 再次刷新version0
      this.$refs.version0 && this.$refs.version0.pageInit('0');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(83);

var _promise2 = _interopRequireDefault(_promise);

var _internalCommission = __webpack_require__(1027);

var _internalCommission2 = _interopRequireDefault(_internalCommission);

var _ruleSetting = __webpack_require__(1028);

var _ruleSetting2 = _interopRequireDefault(_ruleSetting);

var _commissionApi = __webpack_require__(7);

var _util = __webpack_require__(11);

var _uiv = __webpack_require__(14);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);

var api = new _commissionEnv.Api();
exports.default = {
  props: {
    curArea: {
      type: String,
      default: ''
    },
    multiLanguage: { //多语言
      type: Object,
      default: {}
    },
    version: { // 版本
      type: String,
      default: ''
    },
    viewBtn: { // 视图
      type: String,
      default: ''
    }
  },
  components: {
    Modal: _uiv.Modal,
    Btn: _uiv.Btn,
    Dropdown: _uiv.Dropdown,
    internalCommission: _internalCommission2.default,
    ruleSetting: _ruleSetting2.default
  },
  data: function data() {
    return {
      showModal: false,
      sucSave: false,
      newTempFlag: false,
      newTempName: '',
      mode: 0,
      timeIsChange: '',
      enableDistribution: api.enableDistribution,
      commission: {
        cpa: [],
        enable: true,
        lvl: [],
        ReminderDate: '',
        ReminderMsg: '',
        sendEml: '',
        enableUpperCalc: '',
        updateBy: '',
        lastUpdate: '',
        confirmBy: '',
        lastConfirm: '',
        isConfirm: false
      },
      groupSeq: [],
      relation: [],
      rule: [],
      ruleSeq: [],
      currentIB: {},
      ibTemplate: [],
      salesTemplate: [],
      cpaTemplate: null,
      tempHistory: [],
      currentVersion: null,
      temp_name: this.$parent.currentTemplate
    };
  },
  mounted: function mounted() {
    this.pageInit();
  },

  computed: {
    lvlLawful1: function lvlLawful1() {
      var _this = this;

      // 检查lvl的开始和结束是否合法
      var res = true;
      if (this.mode == '0' || this.mode == '2') {
        this.commission.lvl.forEach(function (item, index) {
          if (index < _this.commission.lvl.length - 1) {
            res = item.start - item.end > 0 ? false : true;
          }
        });
      }
      return res;
    },
    lvlLawful2: function lvlLawful2() {
      var _this2 = this;

      // 检查lvl的区间是否连贯
      var res = true;
      if (this.mode == '0' || this.mode == '2') {
        this.commission.lvl.forEach(function (item, index) {
          if (_this2.commission.lvl[index + 1]) {
            if (!((_this2.commission.lvl[index + 1].start - _this2.commission.lvl[index].end).toFixed(2) == 0.01)) {
              res = false;
              return;
            }
          }
        });
      }
      return res;
    },
    cpaLawful1: function cpaLawful1() {
      var _this3 = this;

      // 检查cpa的开始和结束是否合法
      var res = true;
      if (this.mode == '1' || this.mode == '2') {
        this.commission.cpa.forEach(function (item, index) {
          if (index < _this3.commission.cpa.length - 1) {
            res = item.start - item.end > 0 ? false : true;
          }
        });
      }
      return res;
    },
    cpaLawful2: function cpaLawful2() {
      var _this4 = this;

      // 检查cpa的区间是否连贯
      var res = true;
      if (this.mode == '1' || this.mode == '2') {
        this.commission.cpa.forEach(function (item, index) {
          if (_this4.commission.cpa[index + 1]) {
            if (!((_this4.commission.cpa[index + 1].start - _this4.commission.cpa[index].end).toFixed(2) == 1)) {
              res = false;
              return;
            }
          }
        });
      }
      return res;
    },
    updateData: function updateData() {
      var _this5 = this;

      // 需要更新的数据
      this.commission.lvl.forEach(function (item, index) {
        item.lvl = index + 1;
        if (index == _this5.commission.lvl.length - 1) item.end = '-1.00';
        if (index == 0) item.start = '0.00';
      });
      if (this.commission.cpa !== 'not exist') {
        this.commission.cpa.forEach(function (item, index) {
          if (index == _this5.commission.cpa.length - 1) item.end = '-1.00';
          if (index == 0) item.start = '1.00';
        });
      }
      var temp_lang = 'auto';
      if (this.ibTemplate && this.ibTemplate.length > 0) {
        this.ibTemplate.forEach(function (it) {
          if (it.templateId == _this5.temp_name) temp_lang = it.langKey;
        });
      }
      return {
        newTempFlag: this.newTempFlag,
        updateBy: JSON.parse(sessionStorage.user).user_name,
        lvl: this.commission.lvl,
        rule: this.rule,
        tmplateName: this.newTempFlag ? this.newTempName : this.temp_name,
        tmpLang: this.newTempFlag ? 'auto' : temp_lang
      };
    }
  },
  methods: {
    pageInit: function pageInit() {
      var _this6 = this;

      // 初始化数据
      this.$http.get(api.getUrl20(this.curArea, _commissionApi.URL_TEMPLATE_GET + '/' + this.temp_name)).then(function (res) {
        if (res.data.code == 200 && res.data.data && res.data.msg == 'OK') {
          _this6.mode = 0;
          _this6.commission.enableUpperCalc = true;
          _this6.commission.lvl = res.data.data.setting;
          _this6.rule = res.data.data.rulemapping;
          _this6.groupSeq = res.data.data.groupSeq;
          _this6.ruleSeq = res.data.data.ruleSeq;
          _this6.ibTemplate = res.data.data.ibTemplate;
          _this6.salesTemplate = res.data.data.salesTemplate;
          _this6.tempHistory = [{ TEMPLATE_ID: _this6.temp_name, VERSION: 0 }].concat(res.data.data.history);
          _this6.currentVersion = _this6.tempHistory.length > 0 ? _this6.tempHistory[0].VERSION : null;
          if (!_this6.ibTemplate || _this6.ibTemplate.length == 0) _this6.temp_name = '';
        }
      });
    },
    submit: function submit() {
      var _this7 = this;

      // 提交
      if (this.newTempFlag) {
        var sameName = false;
        this.ibTemplate.forEach(function (it) {
          if (it.templateId == _this7.newTempName) sameName = true;
        });
        this.salesTemplate.forEach(function (it) {
          if (it.templateId == _this7.newTempName) sameName = true;
        });
        if (sameName) {
          alert(this.multiLanguage.alertMsg.templateExist);
          return;
        }
      }
      function isTrueFn(element) {
        return element == true;
      }
      var arr = [this.$validator.validateAll()];
      arr.push(this.$refs.internalCommission.$validator.validateAll());
      arr.push(this.$refs.ruleSetting.$validator.validateAll());
      _promise2.default.all(arr).then(function (result) {
        if (_this7.lvlLawful1 && _this7.lvlLawful2 && _this7.cpaLawful1 && _this7.cpaLawful2 && result.every(isTrueFn) && _this7.checkRuleSetting1(_this7.updateData.rule)) {
          // 发请求去保存
          // console.log('发请求')
          _this7.$http.post(api.getUrl20(_this7.curArea, _commissionApi.URL_TEMPLATE_SAVE + '/0'), _this7.updateData).then(function (res) {
            if (res.data.code == 200) {
              _this7.showModal = true;
              _this7.sucSave = true;
              _this7.ibTemplate = res.data.data.ibTemplate;
              _this7.tempHistory = res.data.data.history;
              _this7.temp_name = _this7.updateData.tmplateName;
              if (_this7.tempHistory.length > 0) _this7.currentVersion = _this7.tempHistory[0].VERSION;
            } else {
              _this7.showModal = true;
              _this7.sucSave = false;
            }
          });
        } else {
          _this7.showModal = true;
          _this7.sucSave = false;
        }
      });
    },
    onTemplateChange: function onTemplateChange(tempId) {
      this.pageInit();
      this.$parent.currentTemplate = this.temp_name;
    },
    onVersionChange: function onVersionChange(version) {
      var _this8 = this;

      if (version == 0) {
        this.pageInit();
        return;
      }
      this.$http.get(api.getUrl20(this.curArea, _commissionApi.URL_TEMPLATE_HISTORY) + '/' + this.temp_name + '/' + this.currentVersion).then(function (res) {
        if (res.data.code === 200) {
          _this8.commission.lvl = res.data.data.setting;
          _this8.rule = res.data.data.rulemapping;
        }
      });
    },
    createTemplate: function createTemplate() {
      this.newTempName = '';
      this.newTempFlag = !this.newTempFlag;
    },
    checkIdFn: function checkIdFn(ruleItem) {
      var _this9 = this;

      // 检查id是否在关系图
      this.$http(api.getUrl20(this.curArea, _commissionApi.URL_TOOLCHECKID), { params: { id: ruleItem.commTarget, type: 'IB' } }).then(function (res) {
        var result = res.data.data.result;
        if (!result) {
          alert(_this9.multiLanguage.alertMsg.noAccount);
          ruleItem.commTarget = '';
        }
      });
    },
    checkRuleSetting1: function checkRuleSetting1(rule) {
      var checkRule = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(rule), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var val = _step.value;

          var rCheck = {};
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = (0, _getIterator3.default)(val), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var r = _step2.value;

              if (r.ruleId == 3 || r.ruleId == 5) {
                if (!checkRule[r.ruleId + '-' + r.ruleGroup]) {
                  checkRule[r.ruleId + '-' + r.ruleGroup] = { count: 1, content: (0, _stringify2.default)({ spreadEnable: r.spreadEnable, externalCommissionEnable: r.externalCommissionEnable, internalCommissionEnable: r.internalCommissionEnable }) };
                } else {
                  if ((0, _stringify2.default)({ spreadEnable: r.spreadEnable, externalCommissionEnable: r.externalCommissionEnable, internalCommissionEnable: r.internalCommissionEnable }) != checkRule[r.ruleId + '-' + r.ruleGroup].content) {
                    // 存在“分层最高金额”这个规则设定时，加点、外佣、内返的值必须相同
                    alert(this.multiLanguage.alertMsg.checkRuleFail1);
                    return false;
                  } else {
                    checkRule[r.ruleId + '-' + r.ruleGroup].count++;
                  }
                }
                if (rCheck[r.ruleId + '-' + r.ruleGroup] == undefined) rCheck[r.ruleId + '-' + r.ruleGroup] = true;else {
                  return false;
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      for (var key in checkRule) {
        if (checkRule[key].count != rule.length) {
          // 存在“分层最高金额”这个规则时，每个级别都必须有一条相同的“分层最高金额”，并保证“加点、外佣、内返”一致
          alert(this.multiLanguage.alertMsg.checkRuleFail2);
          return false;
        }
      }
      return true;
    },
    dataFormat: function dataFormat(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  watch: {
    curArea: function curArea() {
      this.$parent.currentTemplate = 'DEFAULT';
      this.temp_name = 'DEFAULT';
      this.pageInit();
    }
  }
};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [__webpack_require__(3).base({ publicLan: "publicLan" })],
  props: {
    multiLanguage: { // 多语言
      type: Object,
      default: {}
    },
    commission: { // 佣金数据
      type: Object,
      default: {}
    },
    groupSeq: { // 产品组
      type: Array,
      default: []
    },
    version: { // 当前版本：0为审核的版本，1为未审核的版本
      type: String,
      default: ''
    },
    viewBtn: { // 浏览的视图： double为对比浏览，onlyOne为单页浏览
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      checkedLvls: [] // 已经选中的commission.lvl的下标，存放在这个数组里面，方便添加或者删除 lvl 时使用
    };
  },

  methods: {
    addItem: function addItem() {
      var _this = this;

      // 添加lvl的方法
      /* 条件：
        * 1、最多只能添加4个级别，
        * 2、可以在指定的位置添加级别
        * 3、如果没有选中位置，则默认在最后添加级别 */
      if (this.checkedLvls.length > 0 && this.commission.lvl.length + this.checkedLvls.length <= 4) {
        this.checkedLvls.forEach(function (el) {
          var tem = {};
          var keys = (0, _keys2.default)(_this.commission.lvl[el]);
          keys.forEach(function (item) {
            tem[item] = '';
          });
          _this.commission.lvl.splice(el + 1, 0, tem);
        });
        this.checkedLvls = [];
      } else if (this.checkedLvls.length == 0 && this.commission.lvl.length + this.checkedLvls.length < 4) {
        var tem = {};
        var keys = (0, _keys2.default)(this.commission.lvl[0]);
        keys.forEach(function (item) {
          tem[item] = '';
        });
        this.commission.lvl.push(tem);
      } else return;
    },
    removeItem: function removeItem() {
      // 删除lvl的方法
      /* 条件：
      * 1、必须选中才能删除，且删除前需要确认
      * 2、最少保留一个级别
      * 3、删除可以指定的级别
      * */
      if (this.checkedLvls.length > 0) {
        var msg = this.multiLanguage.btnGroup.confirmDeleteText;
        if (confirm(msg) == true) {
          if (this.commission.lvl.length - this.checkedLvls.length >= 1) {
            var tem = this.commission.lvl.concat([]);
            this.checkedLvls.forEach(function (item) {
              delete tem[item];
            });
            this.commission.lvl = tem.filter(function (item) {
              return item != null;
            });
            this.checkedLvls = [];
          } else return;
        }
      } else return;
    }
  }
};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuedraggable = __webpack_require__(131);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    draggable: _vuedraggable2.default
  },
  props: {
    multiLanguage: {
      type: Object,
      default: {}
    },
    groupSeq: {
      type: Array,
      default: []
    },
    enableUpperCalc: {
      type: Boolean,
      default: false
    },
    version: {
      type: String,
      default: ''
    },
    relation: {
      type: Array,
      default: []
    },
    rule: {
      type: Array,
      default: []
    },
    ruleSeq: {
      type: Array,
      default: []
    },
    viewBtn: {
      type: String,
      default: ''
    },
    currentIB: {
      type: Object,
      default: {}
    }
  },
  mixins: [__webpack_require__(3).base({ ruleSettingLan: "ibCommissionRuleSetting" }), __webpack_require__(3).base({ publicLan: "publicLan" })],
  data: function data() {
    return {
      drag: null,
      ruleGroup: '',
      checkedLevel: [],
      onfocus: false
    };
  },

  methods: {
    addLevel: function addLevel() {
      // 添加级别
      this.rule.splice(this.rule.length - 1, 0, [{
        commTarget: null,
        enableCommTarget: false,
        externalCommissionEnable: false,
        internalCommissionEnable: false,
        productGroup: 'ALL',
        ruleGroup: 0,
        ruleId: 1,
        spreadEnable: false,
        value: ""
      }]);
    },
    removeLevel: function removeLevel() {
      // 删除级别
      if (this.checkedLevel.length > 0) {
        var msg = this.multiLanguage.btnGroup.confirmDeleteText;
        if (confirm(msg) == true) {
          if (this.rule.length - this.checkedLevel.length >= 1) {
            var tem = this.rule.concat([]);
            this.checkedLevel.forEach(function (item) {
              delete tem[item];
            });
            this.$parent.rule = tem.filter(function (item) {
              return item != null;
            });
            this.checkedLevel = [];
          } else return;
        }
      } else return;
    },
    addRule: function addRule(levelItem) {
      // 添加规则
      levelItem.push({
        commTarget: null,
        enableCommTarget: false,
        externalCommissionEnable: false,
        internalCommissionEnable: false,
        productGroup: 'ALL',
        ruleGroup: 0,
        ruleId: 1,
        spreadEnable: false,
        value: ""
      });
    },
    removeRule: function removeRule(levelItem, ruleIndex) {
      // 删除规则
      var msg = this.multiLanguage.btnGroup.confirmDeleteText;
      if (confirm(msg) == true) {
        levelItem.splice(ruleIndex, 1);
      }
    },
    selectRuleFn: function selectRuleFn(ruleItem) {
      // 切换 单选按钮： 按佣金还是自定金额。 如果是自定金额就將 加点 外佣 内返 这个3个复习按钮 全部禁用且改为 未选中
      if (ruleItem.ruleGroup == 1) {
        ruleItem.spreadEnable = false;
        ruleItem.externalCommissionEnable = false;
        ruleItem.internalCommissionEnable = false;
      }
      ruleItem.value = '';
    },
    selectRule6Fn: function selectRule6Fn(ruleItem) {
      //切换 选择器方法： 如果选择的是rule6 就將value清空
      ruleItem.ruleId == 6 ? ruleItem.value = '' : null;
    },
    checkId: function checkId(ruleItem) {
      this.$emit('checkId', ruleItem);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _util = __webpack_require__(11);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
    name: 'monthlyIBResult',
    mixins: [__webpack_require__(3).base({ mtclient: "mtclient" })],
    props: ['curArea'],
    data: function data() {
        return {
            trData: [],
            login: '',
            url: "",
            loading: false,
            page: {
                active: 1,
                pageLeng: 0
            },
            selPage: {
                list: [5, 10, 25, 50],
                active: localStorage.pageMaxIndex,
                limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
            },
            sort: {
                key: "",
                method: "ASC"
            },
            mtdbs: [],
            selDb: 'mt4'
        };
    },
    created: function created() {
        var _this = this;

        var requrl = api.getUrl20(this.curArea, _commissionApi.URL_MTDBS);
        this.$http.get(requrl).then(function (res) {
            _this.mtdbs = res.data.data.rows;
            if (_this.mtdbs && _this.mtdbs.length > 0) _this.selDb = _this.mtdbs[0].name;
            _this.tableAjax();
        });
    },

    methods: {
        searchData: function searchData() {
            this.page.active = 1;
            this.tableAjax();
        },
        changeMT: function changeMT(mt) {
            this.selDb = mt;
            this.tableAjax();
        },
        tableAjax: function tableAjax() {
            var _this2 = this;

            this.loading = true;
            this.url = api.getUrl20(this.curArea, _commissionApi.URL_MTCLIENTS);
            var obj = {
                params: {
                    login: this.login,
                    sortKey: this.sort.key,
                    sortVal: this.sort.method,
                    pageNum: this.page.active - 1,
                    pageSize: this.selPage.limit,
                    mtdb: this.selDb
                }
            };
            this.$http.get(this.url, obj).then(function (res) {
                _this2.trData = res.data.data.rows;
                _this2.page.pageLeng = res.data.data.count;
                _this2.setOfficeState();
                _this2.loading = false;
            });
        },
        setOfficeState: function setOfficeState() {
            var status = this.mtclient.status;
            if (Object.prototype.toString.call(this.trData) == "[object Array]") {
                this.trData.forEach(function (item) {
                    return item.enable = item.ENABLE || item.ENABLE == 0 ? status[item.ENABLE] : '';
                });
            }
        }
    },
    computed: {
        name: function name() {
            return this.mtclient.indexText;
        },
        downLoadTran: function downLoadTran() {
            return { ENABLE: this.mtclient.status };
        },
        thData: function thData() {
            return this.mtclient.tableHead;
        },
        jsonExcelAjax: function jsonExcelAjax() {
            return { url: this.url, ajaxType: "get", getKey: ["data", "data", 'rows'],
                ajaxPar: {
                    login: this.login,
                    sortKey: this.sort.key,
                    sortVal: this.sort.method,
                    pageSize: this.page.pageLeng,
                    mtdb: this.selDb,
                    pageNum: 0
                }
            };
        }
    },
    watch: {
        mtclient: function mtclient() {
            this.setOfficeState();
        },
        curArea: function curArea() {
            this.page.active = 1;
            this.tableAjax();
        }
    },
    components: {
        mtable: _mytable2.default
    }
};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _relationshipSeek = __webpack_require__(1032);

var _relationshipSeek2 = _interopRequireDefault(_relationshipSeek);

var _selPage = __webpack_require__(82);

var _selPage2 = _interopRequireDefault(_selPage);

var _noData = __webpack_require__(64);

var _noData2 = _interopRequireDefault(_noData);

var _uiv = __webpack_require__(14);

var _vuex = __webpack_require__(24);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();
exports.default = {
    props: {
        filterData: {
            type: Object,
            default: {}
        },
        thData: { // 表格th数据
            type: Array,
            default: []
        },
        trData: {}, // 表格tr数据
        sort: { // 排序
            default: false
        },
        multiLanguage: { // 翻译，也是文字型数据
            type: Object,
            default: {}
        },
        seekDropdown: { // 搜索目标选项
            default: false
        },
        selPage: { // 显示条目数
            default: false
        },
        page: { // 分页
            default: false
        }
    },
    components: {
        seek: _relationshipSeek2.default,
        selPage: _selPage2.default,
        noData: _noData2.default,
        Btn: _uiv.Btn,
        Pagination: _uiv.Pagination,
        Dropdown: _uiv.Dropdown
    },
    data: function data() {
        return {
            showName: true,
            pageactive: this.page ? this.page.active : "",
            seekDropdownProps: this.seekDropdown ? this.seekDropdown : ""
        };
    },

    methods: (0, _extends3.default)({
        excelCallbackFn: function excelCallbackFn() {
            this.$emit('downLoadExcelFn', this.showName);
        },
        filterFn: function filterFn(data, arr, seekStr, index) {
            var _this = this;

            console.log(data);
            var code = '';

            var _loop = function _loop(key) {
                if (key == 'IB' || key == 'SL' || key == 'M' || key == "O" || key == "R" || "N" == key || 'C' == key || 'UN' == key) {
                    _this.trData[0][key].forEach(function (el, i) {
                        if (el.id == seekStr) code = key;
                    });
                } else {
                    if (_this.trData[0][key].id == seekStr) code = key;
                }
            };

            for (var key in this.trData[0]) {
                _loop(key);
            }
            if (index <= this.thData.indexOf(code)) {
                this.$parent.filterVal = data;
                this.pageactive = 1;
                if (this.page) this.$parent.page.offset = 0;
                if (this.$parent.page) this.$parent.page.active = 1;
                this.$emit('filterFn');
            }
        },
        seek: function seek(seekStr) {
            this.pageactive = 1;
            if (this.page) this.$parent.page.offset = 0;
            if (this.$parent.page) this.$parent.page.active = 1;
            this.$emit("seek");
        },
        callpageFn: function callpageFn(index) {
            this.$parent.page.active = index;
            this.$parent.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : "";
            this.$parent.filterVal ? this.$emit('filterFn') : this.$emit("tableChange");
        },
        selPageFn: function selPageFn(index, item) {
            this.SAVEPAGEMAXINDEX(index);
            this.$parent.selPage.active = index;
            this.$parent.selPage.limit = this.selPage.list[this.selPage.active];
            this.$parent.page.offset = 0;
            this.pageactive = 1;
            this.$parent.page.active = 1;
            this.$parent.filterVal ? this.$emit('filterFn') : this.$emit("tableChange");
        }
    }, (0, _vuex.mapMutations)(["SAVEPAGEMAXINDEX"]))
};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _from = __webpack_require__(107);

var _from2 = _interopRequireDefault(_from);

var _set = __webpack_require__(108);

var _set2 = _interopRequireDefault(_set);

var _commissionEnv = __webpack_require__(5);

var _commissionApi = __webpack_require__(7);

var _relationShipTable = __webpack_require__(1030);

var _relationShipTable2 = _interopRequireDefault(_relationShipTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var api = new _commissionEnv.Api(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [__webpack_require__(3).base({ multiLanguage: "commissionTable" })],
  props: ['curArea'],
  components: {
    itable: _relationShipTable2.default
  },
  data: function data() {
    return {
      filterDatainit: [],
      loading: '',
      filterVal: '',
      thTitle: ["TD", "CL", "IB", "SL", "M", "O", "R", "N", "C", "UN"],
      trData: [], //  表格tr数据
      seekDropdown: { // 搜索选项
        seekStr: "" // 搜索内容
      },
      filterStr: '',
      page: { // 分页
        active: 1,
        pageLeng: 0,
        offset: 0 // 查询数据库的offset需要的值，初始只为0组件内部处理最后给出一个能直接传给后台的值
      },
      selPage: { // 配合分页的显示col数目选择
        list: [5, 10, 25, 50], // 选择显示col数目
        active: localStorage.pageMaxIndex, // 当前list的坐标
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex] // 查询数据库的limit需要的值，初始值设为list的0坐标组件内部处理最后给出一个传给后台的值 
      },
      filterData: {}
    };
  },
  mounted: function mounted() {
    this.seekDropdown && (this.seekDropdown.seekStr = "");
  },

  computed: {},
  methods: {
    excelDown: function excelDown(showName) {
      var _this = this;

      this.$http.get(api.getUrl20(this.curArea, _commissionApi.URL_PRERELATION), { params: { pageNum: 0, pageSize: this.page.pageLeng, id: this.seekDropdown.seekStr } }).then(function (res) {
        if (res.data.code == 200 && res.data.data.data.length > 0 && res.data.msg == 'OK') {
          var excelData = res.data.data.data;
          var data = res.data.data;
          var set = new _set2.default();
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(excelData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var val = _step.value;
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(val)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var v = _step2.value;
                  set.add(v);
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          var excelTH = (0, _from2.default)(set);
          _this.getMax('IB', excelData, data.IB_ID);
          _this.getMax('SL', excelData, data.SL_ID);
          _this.getMax('M', excelData, data.M_ID);
          _this.getMax('O', excelData, data.O_ID);
          _this.getMax('R', excelData, data.R_ID);
          _this.getMax('N', excelData, data.N_ID);
          _this.getMax('C', excelData, data.C_ID);
          _this.getMax('UN', excelData, data.UN_ID);

          _this.getTH('IB', 'UPIB', excelTH, excelData);
          _this.getTH('SL', 'UPSL', excelTH, excelData);
          _this.getTH('M', 'UPM', excelTH, excelData);
          _this.getTH('O', 'UPO', excelTH, excelData);
          _this.getTH('R', 'UPR', excelTH, excelData);
          _this.getTH('N', 'UPN', excelTH, excelData);
          _this.getTH('C', 'UPC', excelTH, excelData);
          _this.getTH('UN', 'UPUN', excelTH, excelData);
          _this.export2Excel(excelTH, excelData, showName);
        }
      });
    },
    export2Excel: function export2Excel(excelTH, excelData, showName) {
      var _this2 = this;

      var thRes = [];
      var trRes = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(excelTH), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;
          thRes.push(this.multiLanguage.th.loginType.roleType[item]);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      excelData.forEach(function (item) {
        var tem = {};
        for (var key in item) {
          if (key == 'TD' || "CL" == key) {
            if ((0, _keys2.default)(item[key]).length > 0) {
              tem[key] = item[key].id + (showName ? ' - ' + (item[key].name ? item[key].name : '') : '');
            } else {
              tem[key] = ' - ';
            }
          } else {
            if (item[key].length == 0) tem[key] = ' - ';else if (item[key].length == 1) tem[key] = (0, _keys2.default)(item[key][0]).length > 0 ? item[key][0].id + (showName ? ' - ' + (item[key][0].name ? item[key][0].name : '') : '') : ' - ';else {
              tem[key] = (0, _keys2.default)(item[key][0]).length > 0 ? item[key][0].id + (showName ? ' - ' + (item[key][0].name ? item[key][0].name : '') : '') : ' - ';
              for (var i = 1; i < item[key].length; i++) {
                tem['UP' + key + i] = (0, _keys2.default)(item[key][i]).length > 0 ? item[key][i].id + (showName ? '-' + (item[key][i].name ? item[key][i].name : '') : '') : ' - ';
              }
            }
          }
        }
        trRes.push(tem);
      });
      new Promise(function(resolve) { resolve(); }).then((function () {
        var _require = __webpack_require__(65),
            export_json_to_excel = _require.export_json_to_excel;

        var tHeader = thRes;
        var filterVal = excelTH;
        var list = trRes;
        var data = _this2.formatJson(filterVal, list);
        var curArea = JSON.parse(sessionStorage.getItem('currentArea'));
        export_json_to_excel(tHeader, data, curArea.value + ' ' + _this2.multiLanguage.relationshipListReport);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    filterFn: function filterFn() {
      var _this3 = this;

      this.loading = true;
      var pageNum = this.page.active - 1;
      var pageSize = this.selPage.limit;
      var id = this.filterVal;
      this.$http.get(api.getUrl20(this.curArea, _commissionApi.URL_PRERELATION), { params: { pageNum: pageNum, pageSize: pageSize, id: id } }).then(function (res) {
        if (res.data.code == 200 && res.data.data.data.length > 0 && res.data.msg == 'OK') {
          _this3.trData = res.data.data.data;
          _this3.page.pageLeng = res.data.data.count;
          var set = new _set2.default();
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = (0, _getIterator3.default)(_this3.trData), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var val = _step4.value;
              var _iteratorNormalCompletion5 = true;
              var _didIteratorError5 = false;
              var _iteratorError5 = undefined;

              try {
                for (var _iterator5 = (0, _getIterator3.default)((0, _keys2.default)(val)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  var v = _step5.value;
                  set.add(v);
                }
              } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                  }
                } finally {
                  if (_didIteratorError5) {
                    throw _iteratorError5;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          _this3.thTitle = (0, _from2.default)(set);
          _this3.getMax('IB', _this3.trData, _this3.filterDatainit.IB_ID);
          _this3.getMax('SL', _this3.trData, _this3.filterDatainit.SL_ID);
          _this3.getMax('M', _this3.trData, _this3.filterDatainit.M_ID);
          _this3.getMax('O', _this3.trData, _this3.filterDatainit.O_ID);
          _this3.getMax('R', _this3.trData, _this3.filterDatainit.R_ID);
          _this3.getMax('N', _this3.trData, _this3.filterDatainit.N_ID);
          _this3.getMax('C', _this3.trData, _this3.filterDatainit.C_ID);
          _this3.getMax('UN', _this3.trData, _this3.filterDatainit.UN_ID);

          _this3.getTH('IB', 'UPIB', _this3.thTitle, _this3.trData);
          _this3.getTH('SL', 'UPSL', _this3.thTitle, _this3.trData);
          _this3.getTH('M', 'UPM', _this3.thTitle, _this3.trData);
          _this3.getTH('O', 'UPO', _this3.thTitle, _this3.trData);
          _this3.getTH('R', 'UPR', _this3.thTitle, _this3.trData);
          _this3.getTH('N', 'UPN', _this3.thTitle, _this3.trData);
          _this3.getTH('C', 'UPC', _this3.thTitle, _this3.trData);
          _this3.getTH('UN', 'UPUN', _this3.thTitle, _this3.trData);

          _this3.loading = false;
        } else {
          _this3.loading = false;
        }
      });
    },
    tableAjax: function tableAjax() {
      var _this4 = this;

      this.loading = true;
      var pageNum = this.page.active - 1;
      var pageSize = this.selPage.limit;
      var id = this.seekDropdown.seekStr;
      this.$http(api.getUrl20(this.curArea, _commissionApi.URL_PRERELATION), {
        params: { pageNum: pageNum, pageSize: pageSize, id: id }
      }).then(function (res) {
        if (res.data.code == 200 && res.data.data.data && res.data.msg == 'OK') {
          _this4.trData = res.data.data.data;
          _this4.page.pageLeng = res.data.data.count;
          _this4.filterVal = '';
          // 获取筛选项
          var data = res.data.data;
          _this4.filterDatainit = data;
          _this4.filterData.CL = data.CL_ID;
          _this4.filterData.IB = data.IB_ID[0];
          for (var i = 1; i < data.IB_ID.length; i++) {
            _this4.filterData['UPIB' + i] = data.IB_ID[i];
          }_this4.filterData.SL = data.SL_ID[0];
          for (var i = 1; i < data.SL_ID.length; i++) {
            _this4.filterData['UPSL' + i] = data.SL_ID[i];
          }_this4.filterData.M = data.M_ID[0];
          for (var i = 1; i < data.M_ID.length; i++) {
            _this4.filterData['UPM' + i] = data.M_ID[i];
          }for (var i = 1; i < data.O_ID.length; i++) {
            _this4.filterData['UPO' + i] = data.O_ID[i];
          }
          for (var i = 1; i < data.R_ID.length; i++) {
            _this4.filterData['UPR' + i] = data.R_ID[i];
          }
          for (var i = 1; i < data.N_ID.length; i++) {
            _this4.filterData['UPN' + i] = data.N_ID[i];
          }
          for (var i = 1; i < data.C_ID.length; i++) {
            _this4.filterData['UPC' + i] = data.C_ID[i];
          }
          for (var i = 1; i < data.UN_ID.length; i++) {
            _this4.filterData['UPUN' + i] = data.UN_ID[i];
          }
          // 获取筛选项结束
          var set = new _set2.default();
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = (0, _getIterator3.default)(_this4.trData), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var val = _step6.value;
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;

              try {
                for (var _iterator7 = (0, _getIterator3.default)((0, _keys2.default)(val)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var v = _step7.value;
                  set.add(v);
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }

          _this4.thTitle = (0, _from2.default)(set);
          _this4.getMax('IB', _this4.trData, data.IB_ID);
          _this4.getMax('SL', _this4.trData, data.SL_ID);
          _this4.getMax('M', _this4.trData, data.M_ID);
          _this4.getMax('O', _this4.trData, data.O_ID);
          _this4.getMax('R', _this4.trData, data.R_ID);
          _this4.getMax('N', _this4.trData, data.N_ID);
          _this4.getMax('C', _this4.trData, data.C_ID);
          _this4.getMax('UN', _this4.trData, data.UN_ID);

          _this4.getTH('IB', 'UPIB', _this4.thTitle, _this4.trData);
          _this4.getTH('SL', 'UPSL', _this4.thTitle, _this4.trData);
          _this4.getTH('M', 'UPM', _this4.thTitle, _this4.trData);
          _this4.getTH('O', 'UPO', _this4.thTitle, _this4.trData);
          _this4.getTH('R', 'UPR', _this4.thTitle, _this4.trData);
          _this4.getTH('N', 'UPN', _this4.thTitle, _this4.trData);
          _this4.getTH('C', 'UPC', _this4.thTitle, _this4.trData);
          _this4.getTH('UN', 'UPUN', _this4.thTitle, _this4.trData);

          _this4.loading = false;
        } else {
          _this4.trData = [];
          _this4.filterData = {};
          _this4.loading = false;
          _this4.page.pageLeng = 0;
        }
      });
    },
    getTH: function getTH(key, newTH, thData, trData) {
      var code = thData.indexOf(key);
      if (trData.length > 0) {
        if (trData[0][key].length > 1) {
          for (var i = trData[0][key].length - 1; i >= 1; i--) {
            thData.splice(code + 1, 0, newTH + i);
          }
        }
      }
    },
    getMax: function getMax(key, data, dataArr) {
      var maxLen = dataArr.length;
      // let maxLen = 0
      // for (let item of data) {
      //   if (item[key]){
      //     if (item[key].length > maxLen) maxLen = item[key].length
      //   }
      // }
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = (0, _getIterator3.default)(data), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var item = _step8.value;

          if (item[key]) {
            var more = maxLen - item[key].length;
            while (more-- > 0) {
              item[key].push({});
            }
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    }
  },
  watch: {
    curArea: function curArea() {
      this.page.offset = 0;
      this.tableAjax();
    }
  }
};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["seekDropdown"],
  data: function data() {
    return {};
  },

  directives: { // 自定义指令 v-focus 让文本框自动聚焦
    focus: {
      inserted: function inserted(el) {
        el.focus();
      }
    }
  },
  mounted: function mounted() {},

  computed: (0, _extends3.default)({
    seekLan: function seekLan() {
      return this.translate(this.LANGUAGE, "commissionSeek");
    }
  }, (0, _vuex.mapState)(["LANGUAGE"])),
  methods: {
    emitSeek: function emitSeek() {
      this.$emit("seek", this.seekDropdown.seekStr);
    }
  },
  components: {}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = __webpack_require__(208);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var api = new _commissionEnv.Api(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'monthCommDetailResult',
  mixins: [__webpack_require__(3).base({
    salesMonDetailLan: 'salesMonthlyResult'
  }), __webpack_require__(3).base({ publicLan: 'publicLan' })],
  props: ['curArea'],
  data: function data() {
    return {
      trData: [],
      queryObj: {},
      url: '',
      action: false,
      isLower: true,
      loading: true,
      keys: []
    };
  },
  mounted: function mounted() {
    this.queryObj = this.$route.query;
    if (this.queryObj.TYPE == 1) this.isLower = false;
    this.tableAjax();
  },

  methods: {
    actionChange: function actionChange(value) {
      this.action = value;
      this.tableAjax();
    },
    tableAjax: function tableAjax() {
      var _this = this;

      this.loading = true;
      this.url = api.getUrl20(this.curArea, _commissionApi.URL_SALEMONTHLYCOMMDET);
      var tableObj = {
        params: {
          type: this.queryObj.TYPE,
          sales_id: this.queryObj.SALES_ID,
          report_id: this.queryObj.REPORT_ID
        }
      };
      if (this.queryObj.TYPE == 0) {
        tableObj.params.isExpand = this.action;
        this.$http.get(this.url, tableObj).then(function (res) {
          _this.trData = res.data.data;
          if (_this.trData.length > 1) {
            _this.keys = _this.trData[0].length == 0 ? (0, _keys2.default)(_this.salesMonDetailLan.detailTh) : (0, _keys2.default)(_this.trData[0][0]);
            _this.setOfficeState();
          }
          _this.loading = false;
        });
        return;
      }
      this.$http.get(this.url, tableObj).then(function (res) {
        _this.trData = res.data.data;
        _this.setOfficeLevel();
        _this.loading = false;
      });
    },
    setOfficeLevel: function setOfficeLevel() {
      var _this2 = this;

      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach(function (item, index) {
          var temp = _this2.trData[index];
          temp.level = temp.LEVEL ? _this2.salesMonDetailLan.levelObj[temp.LEVEL] : '';
          temp.client_type = temp.CLIENT_TYPE || temp.CLIENT_TYPE == 0 ? _this2.salesMonDetailLan.client_type[temp.CLIENT_TYPE] : '';
          temp.rule_id = temp.RULE_ID ? _this2.publicLan.rule[temp.RULE_ID] : '';
          if (index == _this2.trData.length - 1) temp.sub_sales_id = _this2.salesMonDetailLan.total[temp.SUB_SALES_ID];else temp.sub_sales_id = temp.SUB_SALES_ID;
        });
      }
    },
    setOfficeState: function setOfficeState() {
      var _this3 = this;

      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach(function (item, index) {
          var arr = _this3.trData[index];
          arr.forEach(function (obj, under) {
            var temp = arr[under];
            if (under == arr.length - 2) {
              temp.ib_id = _this3.salesMonDetailLan.detailTotal[temp.IB_ID];
              temp[_this3.keys[2].toLowerCase()] = _this3.salesMonDetailLan.detailTotal[temp[_this3.keys[2]]];
              temp[_this3.keys[4].toLowerCase()] = _this3.salesMonDetailLan.detailTotal[temp[_this3.keys[4]]];
            } else {
              temp.ib_id = temp.IB_ID;
              temp[_this3.keys[2].toLowerCase()] = temp[_this3.keys[2]];
              temp[_this3.keys[4].toLowerCase()] = temp[_this3.keys[4]];
            }
          });
          if (index === _this3.trData.length - 1) {
            arr[0].ib_id = _this3.queryObj.SALES_ID + _this3.salesMonDetailLan.detailTotal[arr[0].IB_ID];
          }
        });
      }
    },
    formaDetailTotal: function formaDetailTotal(detailTotal) {
      var detailTotal_clone = (0, _assign2.default)({}, detailTotal);
      detailTotal_clone['TOTAL'] = this.queryObj.SALES_ID + detailTotal['TOTAL'];
      return detailTotal_clone;
    }
  },
  computed: {
    thData: function thData() {
      if (this.queryObj.TYPE == 0) {
        var arr = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(this.keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var v = _step.value;

            var obj = {};
            obj.key = v;
            obj.name = this.publicLan.detailTh[v];
            arr.push(obj);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (arr.length != 0) {
          arr[0].key = arr[0].key.toLowerCase();
          arr[2].key = arr[2].key.toLowerCase();
          arr[4].key = arr[4].key.toLowerCase();
        }
        return arr;
      }
      return this.salesMonDetailLan.lowerTh;
    },
    name: function name() {
      return this.salesMonDetailLan.datailText;
    },
    downLoadTran: function downLoadTran() {
      if (this.queryObj.TYPE == 0) {
        var detailTotal = this.formaDetailTotal(this.salesMonDetailLan.detailTotal);
        var dlObj = { IB_ID: detailTotal };
        dlObj[this.keys[2]] = detailTotal;
        dlObj[this.keys[4]] = detailTotal;
        return dlObj;
      }
      return {
        LEVEL: this.salesMonDetailLan.levelObj,
        RULE_ID: this.publicLan.rule,
        CLIENT_TYPE: this.salesMonDetailLan.client_type,
        SUB_SALES_ID: this.salesMonDetailLan.total
      };
    },
    jsonExcelAjax: function jsonExcelAjax() {
      var excelObj = {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data'],
        rID: this.queryObj.REPORT_ID,
        cID: this.queryObj.SALES_ID,
        type: this.salesMonDetailLan.typeList[this.queryObj.TYPE],
        ajaxPar: {
          type: this.queryObj.TYPE,
          sales_id: this.queryObj.SALES_ID,
          report_id: this.queryObj.REPORT_ID
        }
      };
      if (this.queryObj.TYPE == 0) {
        excelObj.ajaxPar.isExpand = this.action;
      }
      return excelObj;
    }
  },
  watch: {
    salesMonDetailLan: function salesMonDetailLan() {
      this.queryObj.type = this.salesMonDetailLan.typeList[this.queryObj.TYPE];
      if (this.queryObj.TYPE == 0) this.setOfficeState();else this.setOfficeLevel();
    },
    curArea: function curArea() {
      this.$router.push('saleMonthlyResult');
    }
  },
  components: {
    mtable: _mytable2.default
  }
};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(84);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _util = __webpack_require__(11);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
  name: 'saleMonCommResult',
  mixins: [__webpack_require__(3).base({
    monthlySalesCommLan: 'salesMonthlyResult'
  }), __webpack_require__(3).base({ publicLan: 'publicLan' })],
  props: ['curArea'],
  data: function data() {
    return {
      trData: [],
      queryObj: {},
      url: '',
      beginTime: '',
      endTime: '',
      timeDiff: 0,
      type: '-1',
      status: '-1',
      selectKey: 'id',
      selectVal: '',
      loading: true,
      changeTime: false,
      link: {
        key: ['AMOUNT'],
        path: 'saleMonCommDetailResult'
        //forwordKey: 'TYPE',
      },
      operate: {
        checkbox: true,
        url: api.getUrl20(this.curArea, _commissionApi.URL_IBMONTHLYUPDATE),
        level: 'SL'
      },
      page: {
        active: 1,
        pageLeng: 0
      },
      selPage: {
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    };
  },
  mounted: function mounted() {
    this.queryObj = this.$route.query;
    this.timeDiff = (0, _util.getTimeDiff)();
    var sinStr = sessionStorage.getItem('back');
    if (sinStr) {
      var sinObj = JSON.parse(sinStr);
      var secondBack = sinObj.secondBack;
      if (secondBack) {
        this.type = secondBack.type;
        this.status = secondBack.status;
        this.selectKey = secondBack.selectKey;
        this.selectVal = secondBack.selectVal;
        this.page.active = secondBack.pageNum + 1;
        this.selPage.limit = secondBack.pageSize;
      }
      this.tableAjax();
      delete sinObj.secondBack;
      sessionStorage.setItem('back', (0, _stringify2.default)(sinObj));
    } else {
      this.tableAjax();
    }
  },

  methods: {
    searchDatas: function searchDatas() {
      this.page.active = 1;
      this.tableAjax();
    },
    tableAjax: function tableAjax() {
      var _params,
          _this = this;

      if (!/^\d{0,}$/.test(this.selectVal)) {
        this.$message.error('' + this.monthlySalesCommLan.selectKeys[this.selectKey] + this.publicLan.notNumber);
        return;
      }
      this.loading = true;
      this.changeTime = true;
      this.url = api.getUrl20(this.curArea, _commissionApi.URL_SALEMONTHLYCOMM);
      var tableObj = {
        params: (_params = {
          type: this.type,
          status: this.status
        }, (0, _defineProperty3.default)(_params, this.selectKey, this.selectVal), (0, _defineProperty3.default)(_params, 'report_id', this.queryObj.REPORT_ID), (0, _defineProperty3.default)(_params, 'pageNum', this.page.active - 1), (0, _defineProperty3.default)(_params, 'pageSize', this.selPage.limit), _params)
      };
      this.$http.get(this.url, tableObj).then(function (res) {
        _this.trData = res.data.data.data;
        _this.page.pageLeng = res.data.data.count;
        _this.setOfficeState();
        _this.loading = false;
      });
    },
    setOfficeState: function setOfficeState() {
      var _this2 = this;

      var typeList = this.monthlySalesCommLan.typeList;
      var list = this.monthlySalesCommLan.statusList;
      var levelObj = this.monthlySalesCommLan.levelObj;
      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach(function (item, index) {
          item.level = levelObj[item.LEVEL];
          item.checked = false;
          item.type = item.TYPE || item.TYPE == 0 ? typeList[item.TYPE] : '';
          item.status = item.STATUS || item.STATUS == 0 ? list[item.STATUS] : '';
          if (_this2.changeTime) item.LAST_UPDATE = (0, _util.updateTimeByUtc)(_this2.timeDiff, item.LAST_UPDATE);
        });
      }
    }
  },
  computed: {
    back: function back() {
      if (sessionStorage.getItem('back')) {
        var backObj = JSON.parse(sessionStorage.getItem('back'));
        backObj.secondBack = {
          type: this.type,
          status: this.status,
          selectKey: this.selectKey,
          selectVal: this.selectVal,
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        };
        return (0, _stringify2.default)(backObj);
      }
    },
    name: function name() {
      return this.monthlySalesCommLan.text;
    },
    detailName: function detailName() {
      return this.monthlySalesCommLan.downloadName;
    },
    downLoadTran: function downLoadTran() {
      return {
        TYPE: this.monthlySalesCommLan.typeList,
        LEVEL: this.monthlySalesCommLan.levelObj,
        STATUS: this.monthlySalesCommLan.statusList,
        CLIENT_TYPE: this.monthlySalesCommLan.client_type,
        LOW_LEVEL: this.monthlySalesCommLan.levelObj
      };
    },
    thData: function thData() {
      return this.monthlySalesCommLan.commmissionTh_v2;
    },
    detailTh: function detailTh() {
      return this.monthlySalesCommLan.downloadTh_v2;
    },
    detailExcelAjax: function detailExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data'],
        rID: this.queryObj.REPORT_ID,
        ajaxPar: (0, _defineProperty3.default)({
          downLoadDetail: 'true',
          pageSize: this.page.pageLeng,
          pageNum: 0,
          type: this.type,
          status: this.status,
          report_id: this.queryObj.REPORT_ID
        }, this.selectKey, this.selectVal)
      };
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data', 'data'],
        rID: this.queryObj.REPORT_ID,
        ajaxPar: (0, _defineProperty3.default)({
          pageSize: this.page.pageLeng,
          pageNum: 0,
          type: this.type,
          status: this.status,
          report_id: this.queryObj.REPORT_ID
        }, this.selectKey, this.selectVal)
      };
    }
  },
  watch: {
    monthlySalesCommLan: function monthlySalesCommLan() {
      this.changeTime = false;
      this.setOfficeState();
    },
    curArea: function curArea() {
      this.type = '-1';
      this.status = '-1';
      this.selectVal = '';
      this.page.active = 1;
      sessionStorage.removeItem('back');
      this.operate.url = api.getUrl20(this.curArea, _commissionApi.URL_IBMONTHLYUPDATE);
      this.tableAjax();
    }
  },
  components: {
    mtable: _mytable2.default
  }
};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _mytable = __webpack_require__(27);

var _mytable2 = _interopRequireDefault(_mytable);

var _util = __webpack_require__(11);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
  name: "monthlyIBResult",
  mixins: [__webpack_require__(3).base({
    salesMonthlyLan: "salesMonthlyResult"
  })],
  props: ["curArea"],
  data: function data() {
    return {
      trData: [],
      url: "",
      timeDiff: 0,
      beginTime: "",
      endTime: "",
      loading: true,
      changeTime: false,
      link: {
        key: ["saleCommResult"],
        path: "saleMonCommResult"
      },
      page: {
        active: 1,
        pageLeng: 0
      },
      selPage: {
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    };
  },
  mounted: function mounted() {
    this.timeDiff = (0, _util.getTimeDiff)();
    if (sessionStorage.getItem("back")) {
      var backObj = JSON.parse(sessionStorage.getItem("back"));
      if (backObj.path === "saleMonthlyResult") {
        this.beginTime = backObj.beginTime;
        this.endTime = backObj.endTime;
        this.page.active = backObj.pageNum + 1;
        this.selPage.limit = backObj.pageSize;
      }
      this.tableAjax();
      sessionStorage.removeItem("back");
    } else {
      this.tableAjax();
    }
  },

  methods: {
    searchData: function searchData() {
      this.page.active = 1;
      this.tableAjax();
    },
    tableAjax: function tableAjax() {
      var _this = this;

      this.loading = true;
      this.changeTime = true;
      this.url = api.getUrl20(this.curArea, _commissionApi.URL_IBMONTHLYINDEX);
      var obj = {
        params: {
          type: "SALES",
          beginTime: (0, _util.formatDate)(this.beginTime),
          endTime: (0, _util.formatDate)(this.endTime),
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        }
      };
      this.$http.get(this.url, obj).then(function (res) {
        _this.trData = res.data.data.rows;
        _this.page.pageLeng = res.data.data.count;
        _this.setOfficeState();
        _this.loading = false;
      });
    },
    setOfficeState: function setOfficeState() {
      var _this2 = this;

      var list = this.salesMonthlyLan.indexStatusList;
      if (Object.prototype.toString.call(this.trData) == "[object Array]") {
        this.trData.forEach(function (item, index) {
          var temp = _this2.trData[index];
          temp.saleCommResult = _this2.salesMonthlyLan.indexTh[1].name;
          temp.status = temp.STATUS || temp.STATUS == 0 ? list[temp.STATUS] : "";
          if (_this2.changeTime) temp.LAST_UPDATE = (0, _util.updateTimeByUtc)(_this2.timeDiff, temp.LAST_UPDATE);
        });
      }
    }
  },
  computed: {
    back: function back() {
      return (0, _stringify2.default)({
        path: "saleMonthlyResult",
        pageSize: this.selPage.limit,
        pageNum: this.page.active - 1,
        beginTime: this.beginTime,
        endTime: this.endTime
      });
    },
    name: function name() {
      return this.salesMonthlyLan.indexText;
    },
    downLoadTran: function downLoadTran() {
      return { STATUS: this.salesMonthlyLan.indexStatusList };
    },
    thData: function thData() {
      return this.salesMonthlyLan.indexTh;
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: "get",
        getKey: ["data", "data", "rows"],
        ajaxPar: {
          type: "SALES",
          pageSize: this.page.pageLeng,
          pageNum: 0,
          lang: this.LANGUAGE,
          beginTime: (0, _util.formatDate)(this.beginTime),
          endTime: (0, _util.formatDate)(this.endTime)
        }
      };
    }
  },
  watch: {
    salesMonthlyLan: function salesMonthlyLan() {
      this.changeTime = false;
      this.setOfficeState();
    },
    curArea: function curArea() {
      this.beginTime = "", this.endTime = "", this.page.active = 1;
      this.tableAjax();
    }
  },
  components: {
    mtable: _mytable2.default
  }
};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuedraggable = __webpack_require__(131);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    draggable: _vuedraggable2.default
  },
  mixins: [__webpack_require__(3).base({ ruleSettingLan: "ruleItem" }), __webpack_require__(3).base({ publicLan: "publicLan" })],
  props: {
    viewBtn: {
      type: String,
      default: ''
    },
    enable: {
      type: Boolean,
      default: false
    },
    multiLanguage: {
      type: Object,
      default: {}
    },
    version: {
      type: String,
      default: ''
    },
    relation: {
      type: Array,
      default: []
    },
    currentIB: {
      type: Object,
      default: {}
    },
    rule: {
      type: Array,
      default: []
    },
    ruleSeq: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      checkedLevel: [],
      onfocus: false
    };
  },

  computed: {
    newRelation: function newRelation() {
      var arr = []; // 最后返回的数组
      var len = this.rule.length - 1; // 因为最后一个当前自己，不需要，所有重倒数第二个开始截取数组
      var num = this.rule.length - this.relation.length; // rule 和 relation 的长度差值
      if (num <= 1) arr = this.relation.slice(len * -1); // 根据rule的长度截取出新的relation数组，因为rule最后一个必定是自己，所以判断结果时要从 两者长度差值小于等于1 的值开始截取
      else {
          // 否则，当rule的长度于relation的长度差值 大于1时，
          arr = this.relation.concat([]); // 先复制一份完整的relation給arr
          for (var i = 0; i < num - 1; i++) {
            // 然后根据 rule的长度减去relation的长度的差值来循环添加 not exist，因为两者差值在这里已经是大于1的值，所以要减去1才能得出正确的循环次数，
            arr.unshift({ name: 'not exist', id: 'not exist' }); // 代码到这里，表示所有的关系都已经添加了，之后添加的rule级别都是不在关系图里面的， 所以我用not exist 表示不存在
          }
        }
      return arr;
    }
  },
  methods: {
    addLevel: function addLevel() {
      // 添加级别
      this.rule.unshift([{
        ruleId: 4,
        clientType: 0,
        value: '',
        enableCommTarget: false,
        commTarget: ''
      }]);
    },
    removeLevel: function removeLevel() {
      // 删除级别
      if (this.checkedLevel.length > 0) {
        var msg = this.multiLanguage.btnGroup.confirmDeleteText;
        if (confirm(msg) == true) {
          if (this.rule.length - this.checkedLevel.length >= 1) {
            var tem = this.rule.concat([]);
            this.checkedLevel.forEach(function (item) {
              delete tem[item];
            });
            this.$parent.rule = tem.filter(function (item) {
              return item != null;
            });
            this.checkedLevel = [];
          } else return;
        }
      } else return;
    },
    addRule: function addRule(levelItem) {
      // 添加规则
      levelItem.push({
        ruleId: 4,
        clientType: 0,
        value: '',
        enableCommTarget: false,
        commTarget: ''
      });
    },
    removeRule: function removeRule(levelItem, ruleIndex) {
      // 删除规则
      var msg = this.multiLanguage.btnGroup.confirmDeleteText;
      if (confirm(msg) == true) {
        levelItem.splice(ruleIndex, 1);
      }
    },
    checkId: function checkId(ruleItem) {
      this.$emit('checkId', ruleItem);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _util = __webpack_require__(11);

var _commissionSeek = __webpack_require__(417);

var _commissionSeek2 = _interopRequireDefault(_commissionSeek);

var _selPage = __webpack_require__(82);

var _selPage2 = _interopRequireDefault(_selPage);

var _seekDatePicker = __webpack_require__(194);

var _seekDatePicker2 = _interopRequireDefault(_seekDatePicker);

var _noData = __webpack_require__(64);

var _noData2 = _interopRequireDefault(_noData);

var _vueUploadComponent = __webpack_require__(130);

var _vueUploadComponent2 = _interopRequireDefault(_vueUploadComponent);

var _uiv = __webpack_require__(14);

var _commissionJsonExcel = __webpack_require__(192);

var _commissionJsonExcel2 = _interopRequireDefault(_commissionJsonExcel);

var _vuex = __webpack_require__(24);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
  props: {
    isSetting: {
      type: Object,
      default: {}
    },
    thData: { // 表格th数据
      type: Array,
      default: []
    },
    trData: {}, // 表格tr数据
    totalData: {
      default: false
    },
    handle: {
      default: false
    },
    multiLanguage: { // 翻译，也是文字型数据
      type: Object,
      default: {}
    },
    selPage: { // 显示条目数
      default: false
    },
    seekDropdown: { // 搜索目标选项
      default: false
    },
    page: { // 分页
      default: false
    },
    jsonExcelAjax: { // 下载Excel
      default: false
    },
    sort: { // 排序
      default: false
    },
    seekDatePicker: { // 时间搜索
      default: false
    },
    trCls: { // tr class
      default: false
    },
    region: {
      defalut: false
    },
    label: {
      defalut: false
    }
  },
  data: function data() {
    return {
      pageactive: this.page ? this.page.active : "",
      seekDropdownProps: this.seekDropdown ? this.seekDropdown : "",
      deleteCol: { // 删除功能
        switch: false,
        list: []
      },
      totalTr: {}
    };
  },
  mounted: function mounted() {
    this.totalData && this.total();
    if (this.selPage && !this.selPage.active) this.$parent.selPage.active = 0;
  },

  computed: {
    trDataKeys: function trDataKeys() {
      return (0, _keys2.default)(this.trData[0]);
    }
  },
  methods: (0, _extends3.default)({
    momentFn: function momentFn(date) {
      // 格式化时间 updateTimeByUtc getTimeDiff
      var newDate = (0, _util.updateTimeByUtc)((0, _util.getTimeDiff)(), date);
      return newDate;
    },

    // 是否設定
    dropdownFn: function dropdownFn(e) {
      if (e.target.innerHTML == this.multiLanguage.isSetting.checked) {
        this.isSetting.active = 2;
        this.isSetting.listActive = 'checked';
      } else if (e.target.innerHTML == this.multiLanguage.isSetting.unchecked) {
        this.isSetting.active = 1;
        this.isSetting.listActive = 'unchecked';
      } else if (e.target.innerHTML == this.multiLanguage.isSetting.unsated) {
        this.isSetting.active = 0;
        this.isSetting.listActive = 'unsated';
      } else {
        this.isSetting.active = null;
        this.isSetting.listActive = 'allStatus';
      }
      this.$emit("tableChange");
    },
    total: function total() {
      var _this = this;

      if (!this.totalData || !this.totalData.length) return;
      var keys = (0, _keys2.default)(this.totalData[0]);
      var obj = {};
      this.totalData.forEach(function (item) {
        keys.forEach(function (key, keyIndex) {
          if (Object.prototype.toString.call(item[key]) === "[object Number]" && keyIndex !== 0) {
            if (!obj[key] && obj[key] !== 0) obj[key] = 0;
            obj[key] += item[key];
          } else if (Object.prototype.toString.call(item[key]) === "[object String]") {
            obj[key] = "#";
          } else if (keyIndex === 0) {
            obj[key] = _this.multiLanguage.total;
          }
        });
      });
      (0, _keys2.default)(obj).forEach(function (key) {
        if (Object.prototype.toString.call(obj[key]) === "[object Number]") {
          obj[key] = +obj[key].toFixed(2);
        }
      });
      this.totalTr = obj;
    },
    sortFn: function sortFn(key) {
      if (!this.sort || this.$parent.sort.key !== key) return;
      if (this.sort.method === "ASC") {
        this.$parent.sort.method = "DESC";
      } else if (this.sort.method === "DESC") {
        this.$parent.sort.method = "ASC";
      }
      this.$emit("tableChange");
    },
    clickSeekDropdown: function clickSeekDropdown(index) {
      this.$emit("clickSeekDropdown", index);
    },
    selPageFn: function selPageFn(index, item) {
      this.SAVEPAGEMAXINDEX(index);
      this.$parent.selPage.active = index;
      this.$parent.selPage.limit = this.selPage.list[this.selPage.active];
      this.$parent.page.offset = 0;
      this.pageactive = 1;
      this.$parent.page.active = 1;
      this.$emit("tableChange");
    },
    callpageFn: function callpageFn(index) {
      this.$parent.page.active = index;
      this.$parent.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : "";
      this.$emit("tableChange");
    },
    setSeekDropdown: function setSeekDropdown(index) {
      this.seekDropdownActive = index;
    },
    refresh: function refresh() {
      if (this.$parent.page) this.$parent.page.active = 1;
      if (this.$parent.page) this.pageactive = 1;
      if (this.$parent.page) this.$parent.page.offset = 0;
      if (this.$parent.seekDropdown) this.$parent.seekDropdown.seekStr = "";
      this.$emit("tableChange");
    },
    seek: function seek(seekStr) {
      this.pageactive = 1;
      if (this.page) this.$parent.page.offset = 0;
      if (this.$parent.page) this.$parent.page.active = 1;
      this.$emit("seek");
    },
    seekDatePickerFn: function seekDatePickerFn(seekVal) {
      this.$emit("seek");
    },
    clickColFn: function clickColFn(colItem, index) {
      this.$emit("clickCol", colItem, index);
    },
    deleteColClick: function deleteColClick() {
      this.deleteCol.switch = true;
    },
    deleteColNotarizeFn: function deleteColNotarizeFn() {
      this.deleteCol.switch = false;
      this.$emit("deleteList", this.deleteCol.list);
      this.deleteCol.list = [];
    },
    deletePitch: function deletePitch(item) {
      if (this.deleteCol.switch === false) {
        return;
      }
      var id = item[this.handle.idKey];
      var index = this.deleteCol.list.indexOf(id);
      if (index === -1) {
        this.deleteCol.list.push(id);
      } else {
        this.deleteCol.list.splice(index, 1);
      }
    },
    linkRegister: function linkRegister(item) {
      if (this.deleteCol.switch === true) {
        this.deletePitch(item);
      } else {
        this.$router.push({
          path: this.handle.link,
          query: {
            id: item[this.handle.idKey],
            region: this.region
          }
        });
      }
    }
  }, (0, _vuex.mapMutations)(["SAVEPAGEMAXINDEX"])),
  watch: {
    seekDropdownActive: function seekDropdownActive(curVal, oldVal) {
      this.$parent.seekData.seekDropdownActive = curVal;
    },
    totalData: function totalData(curVal, oldVal) {
      curVal.length > 0 && this.total();
    }
  },
  components: {
    seek: _commissionSeek2.default,
    selPage: _selPage2.default,
    seekDatePicker: _seekDatePicker2.default,
    fileUpload: _vueUploadComponent2.default,
    Dropdown: _uiv.Dropdown,
    Pagination: _uiv.Pagination,
    jsonExcel: _commissionJsonExcel2.default,
    noData: _noData2.default
  }
};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(83);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _util = __webpack_require__(11);

var _ruleSetting = __webpack_require__(1036);

var _ruleSetting2 = _interopRequireDefault(_ruleSetting);

var _specialAndOverlook = __webpack_require__(1042);

var _specialAndOverlook2 = _interopRequireDefault(_specialAndOverlook);

var _commissionApi = __webpack_require__(7);

var _uiv = __webpack_require__(14);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);
moment().format();

var api = new _commissionEnv.Api();
exports.default = {
  props: {
    multiLanguage: {
      type: Object,
      default: {}
    },
    version: {
      type: String,
      default: ''
    },
    viewBtn: {
      type: String,
      default: ''
    },
    curArea: {
      type: String,
      default: ''
    }
  },
  components: {
    Modal: _uiv.Modal,
    ruleSetting: _ruleSetting2.default,
    specialAndOverlook: _specialAndOverlook2.default,
    Btn: _uiv.Btn,
    Dropdown: _uiv.Dropdown
  },
  data: function data() {
    return {
      UTCDIFF: (0, _util.getTimeDiff)(),
      showModal: false,
      sucSave: false,
      enable: false,
      updateBy: '',
      confirmBy: '',
      lastUpdate: '',
      lastConfirm: '',
      relation: [],
      rule: [],
      currentIB: {},
      specialIB: [],
      overlookIB: [],
      isConfirm: false,
      ruleSeq: [],
      salesTemplate: null
    };
  },
  mounted: function mounted() {
    this.pageInit(this.version);
  },

  computed: {
    updateData: function updateData() {
      // 需要修改的数据
      var newRule = [];
      if (!this.enable) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(this.rule), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var ruleLevel = _step.value;

            var newRuleLevel = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = (0, _getIterator3.default)(ruleLevel), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var ruleItem = _step2.value;

                if (!ruleItem.enableCommTarget && ruleItem.value.trim() !== '' || ruleItem.enableCommTarget && ruleItem.commTarget !== '' && ruleItem.value.trim() !== '') newRuleLevel.push(ruleItem);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            newRule.push(newRuleLevel);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      var specialIb = [];
      if (this.specialIB.length == 1 && !this.specialIB[0].ibId) {
        specialIb = [];
      } else {
        this.specialIB.forEach(function (it) {
          it.value.forEach(function (it2) {
            specialIb.push({ ibId: it.ibId, name: it.name, withSub: it.withSub, rebate: it2.rebate, level: it2.level });
          });
        });
      }
      return {
        enable: this.enable,
        salesId: this.$route.query.id,
        updateBy: JSON.parse(sessionStorage.user).user_name,
        rule: this.enable ? this.rule : newRule,
        specialIb: specialIb,
        ignoreIb: this.overlookIB.length == 1 && !this.overlookIB[0].ibId ? [] : this.overlookIB
      };
    },
    verifyData: function verifyData() {
      // 提交审核的参数
      return {
        salesId: this.$route.query.id,
        confirmBy: JSON.parse(sessionStorage.user).user_name
      };
    }
  },
  methods: {
    pageInit: function pageInit(version) {
      var _this = this;

      // 初始化数据
      var oId = this.$route.query.id;
      this.$http.get(api.getUrl20(this.curArea, _commissionApi.URL_SALESSET + '/' + version + '/' + oId)).then(function (res) {
        if (res.data.code == 200 && res.data.msg == 'OK') {
          var data = res.data.data;
          _this.enable = data.enable;
          _this.updateBy = data.updateBy;
          _this.lastUpdate = data.lastUpdate ? (0, _util.updateTimeByUtc)(_this.UTCDIFF, data.lastUpdate) : data.lastUpdate;
          _this.confirmBy = data.confirmBy;
          _this.lastConfirm = data.lastConfirm ? (0, _util.updateTimeByUtc)(_this.UTCDIFF, data.lastConfirm) : data.lastConfirm;
          _this.relation = data.relation.slice(0, -1);
          _this.rule = data.rule.length > 0 ? data.rule : [[{
            ruleId: 4,
            clientType: 0,
            value: '',
            enableCommTarget: false,
            commTarget: ''
          }]];
          _this.currentIB = {
            id: data.salesId,
            name: data.relation[data.relation.length - 1].name
          };
          var specialData = data.specialIb.length > 0 ? data.specialIb : [{ ibId: '', name: '', withSub: true, rebate: '', level: 0 }];
          // this.specialIB = data.specialIb.length > 0 ? data.specialIb : [{ibId: '',name: '',withSub: true,rebate: ''}]
          var obj = specialData.reduce(function (a, b) {
            if (a[b.ibId]) {
              a[b.ibId].value.push({ level: b.level, rebate: b.rebate });
            } else {
              a[b.ibId] = { ibId: b.ibId, name: b.name, withSub: b.withSub, value: [] };
              a[b.ibId].value.push({ level: b.level, rebate: b.rebate });
            }
            return a;
          }, {});
          var ret = [];
          (0, _keys2.default)(obj).forEach(function (it) {
            obj[it].value = obj[it].value.sort(function (a, b) {
              return b.level - a.level;
            });
            ret.push(obj[it]);
          });
          _this.specialIB = ret;
          _this.overlookIB = data.ignoreIb.length > 0 ? data.ignoreIb : [{ ibId: '', name: '', withSub: true }];
          _this.isConfirm = data.isConfirm;
          _this.ruleSeq = data.ruleSeq;
          _this.$parent.reqData = data.ruleSeq;
          _this.salesTemplate = data.salesTemplate;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      // 保存修改
      function isTrueFn(element) {
        return element == true;
      }
      var arr = [this.$refs.ruleSetting.$validator.validateAll(), this.$refs.specialAndOverlook.$validator.validateAll()];
      _promise2.default.all(arr).then(function (result) {
        if (result.every(isTrueFn) && (_this2.enable ? _this2.checkRuleResultFn() : true)) {
          _this2.$http.post(api.getUrl20(_this2.curArea, _commissionApi.URL_SALESSET) + '/1', _this2.updateData).then(function (res) {
            if (res.data.code == 200 && res.data.data == "OK" && res.data.msg == "OK") {
              //this.showModal = true
              //this.sucSave = true
              _this2.$message.success(_this2.multiLanguage.submitResult.succeed);
              _this2.updateBy = JSON.parse(sessionStorage.user).user_name;
              _this2.lastUpdate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
              _this2.isConfirm = false;
            } else {
              //this.showModal = true
              //this.sucSave = false
              _this2.$message.error(_this2.multiLanguage.submitResult.serverErr);
            }
          });
        } else {
          _this2.showModal = true;
          _this2.sucSave = false;
        }
      });
    },
    verify: function verify() {
      var _this3 = this;

      // 确认修改
      if (!this.updateBy) {
        alert(this.multiLanguage.alertMsg.beforeSave);
        return;
      } else if (this.verifyData.confirmBy == this.updateBy) {
        alert(this.multiLanguage.alertMsg.checkFail);
        return;
      } else {
        var msg = this.multiLanguage.alertMsg.verifyTips;
        if (confirm(msg) == true) {
          this.$http.post(api.getUrl20(this.curArea, _commissionApi.URL_SALESSET) + '/0', this.verifyData).then(function (res) {
            if (res.data.code == 200 && res.data.data == "OK") {
              //this.showModal = true
              //this.sucSave = true
              _this3.$message.success(_this3.multiLanguage.submitResult.auditSuccess);
              _this3.$emit('afterVerify');
              _this3.isConfirm = true;
            } else {
              //this.showModal = true
              //this.sucSave = false
              _this3.$message.error(_this3.multiLanguage.submitResult.serverErr);
            }
          });
        }
      }
    },
    checkIdFn: function checkIdFn(ruleItem) {
      var _this4 = this;

      // 检查id是否在关系图
      this.$http(api.getUrl20(this.curArea, _commissionApi.URL_TOOLCHECKID), { params: { id: ruleItem.commTarget, type: 'SL' } }).then(function (res) {
        var result = res.data.data.result;
        if (!result) {
          alert(_this4.multiLanguage.alertMsg.noAccount);
          ruleItem.commTarget = '';
        }
      });
    },
    getLengthWithMatch: function getLengthWithMatch(arr, callback) {
      var len = 0;
      arr.forEach(function (a) {
        len += callback(a) ? 1 : 0;
      });
      return len;
    },
    hasSameItem: function hasSameItem(arr, names) {
      // 数组中的所有项的name属性的值是否都相同
      if (arr.length > 1) {
        var target = arr[0]; // 参照物
        for (var i = 1; i < arr.length; i++) {
          if (this.isSameObject(target, arr[i], names)) return true;
        }
      }
      return false;
    },
    isSameObject: function isSameObject(obj1, obj2, properties) {
      // 判断两个对象的所有properties是否都相同
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(properties), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var p = _step3.value;

          if (obj1[p] !== obj2[p]) return false;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return true;
    },
    checkRuleSetting2: function checkRuleSetting2(rules) {
      // 规则设定检查2
      var falseCommTargetLength = this.getLengthWithMatch(rules, function (r) {
        return !r.enableCommTarget;
      });
      if (falseCommTargetLength === 0) return true; //规则中没有为false的项
      if (falseCommTargetLength != rules.length) {
        // enableCommTarget存在不相同
        // alert('分配账号设定不同。')
        alert(this.multiLanguage.alertMsg.checkRuleFail1);
        return false;
      }

      if (this.getLengthWithMatch(rules, function (r) {
        return r.ruleId === 4;
      }) > 0) {
        if (this.getLengthWithMatch(rules, function (r) {
          return r.ruleId === 7 || r.ruleId === 8;
        }) > 0) {
          // alert('固定金额与固定金额(普通组别)、固定金额(VIP 组别)不能同时选择。')
          alert(this.multiLanguage.alertMsg.checkRuleFail2);
          return false;
        }
      }

      var zeroClientTypeLength = this.getLengthWithMatch(rules, function (r) {
        return r.clientType === 0;
      });
      if (zeroClientTypeLength > 0) {
        // ruleId 不能重复
        if (this.hasSameItem(rules, ['ruleId'])) alert(this.multiLanguage.alertMsg.checkRuleFail3); // alert('相同规则下，全部客户类型与其他客户类型冲突') 
        return !this.hasSameItem(rules, ['ruleId']);
      } else {
        // 项与项之间的ruleId和clientType不能相同
        if (this.hasSameItem(rules, ['ruleId', 'clientType'])) alert(this.multiLanguage.alertMsg.checkRuleFail4); //alert('存在重复的规则设定')
        return !this.hasSameItem(rules, ['ruleId', 'clientType']);
      }
      return true;
    },
    checkRuleSetting1: function checkRuleSetting1(rule) {
      // 规则设定检查1
      var checkRule = {};
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = (0, _getIterator3.default)(rule), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var val = _step4.value;
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = (0, _getIterator3.default)(val), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var r = _step5.value;

              if (r.ruleId == 5) {
                if (!checkRule[r.ruleId + '-clientType']) {
                  checkRule[r.ruleId + '-clientType'] = { count: 1, content: (0, _stringify2.default)({ clientType: r.clientType }) };
                } else {
                  if ((0, _stringify2.default)({ clientType: r.clientType }) != checkRule[r.ruleId + '-clientType'].content) {
                    return false;
                  } else {
                    checkRule[r.ruleId + '-clientType'].count++;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      for (var key in checkRule) {
        if (checkRule[key].count != rule.length) {
          //alert('存在“分层最高金额”这个规则时，每个级别都必须有一条“分层最高金额”，并保证“客户类型”一致')
          alert(this.multiLanguage.alertMsg.checkRuleFail5);
          return false;
        }
      }
      return true;
    },
    checkRuleResultFn: function checkRuleResultFn() {
      var result = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = (0, _getIterator3.default)(this.updateData.rule), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var rule = _step6.value;

          result.push(this.checkRuleSetting2(rule));
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      if (result.every(function (r) {
        return r === true;
      }) && this.checkRuleSetting1(this.updateData.rule)) {
        // console.log('1_',result,this.checkRuleSetting1(this.updateData.rule))
        return true;
      } else {
        // console.log('2_',result,this.checkRuleSetting1(this.updateData.rule))
        return false;
      }
    },
    normSetFn: function normSetFn(path) {
      var _this5 = this;

      // 拿到内设数据
      this.$http.get(api.getUrl20(this.curArea, _commissionApi.URL_DEFAULT) + path).then(function (res) {
        if (res.data.code === 200) {
          _this5.rule = res.data.data.rulemapping;
        }
      });
    }
  },
  watch: {
    curArea: function curArea() {
      this.pageInit(this.version);
    }
  }
};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uiv = __webpack_require__(14);

var _commissionJsonExcel = __webpack_require__(192);

var _commissionJsonExcel2 = _interopRequireDefault(_commissionJsonExcel);

var _commissionEnv = __webpack_require__(5);

var _commissionApi = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();

exports.default = {
  mixins: [__webpack_require__(3).base({ publicLan: "publicLan" })],
  props: {
    region: {
      type: String,
      default: ''
    },
    multiLanguage: {
      type: Object,
      default: {}
    },
    reqData: {
      type: Array,
      default: []
    }
  },
  components: {
    Pagination: _uiv.Pagination,
    jsonExcel: _commissionJsonExcel2.default
  },
  computed: {
    thData: function thData() {
      var arr = [];
      this.multiLanguage.previewThead.forEach(function (element) {
        arr.push(element.text);
      });
      return arr;
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: api.getUrl20(this.region, _commissionApi.URL_SALESPREVIEW) + '/' + this.mainAcc,
        ajaxType: "get",
        getKey: ["data", "data", "data"],
        ajaxPar: {
          pageNum: 0,
          pageSize: this.totalData,
          type: this.type,
          seekVal: this.seachVal
        }
      };
    }
  },
  mounted: function mounted() {
    this.pageInit();
  },
  data: function data() {
    return {
      loading: false,
      clause: '5',
      type: '0',
      seachVal: '',
      currentPage: 1,
      totalPage: 0,
      totalData: 0,
      previewData: [],
      mainAcc: this.$route.query.id
    };
  },

  methods: {
    pageInit: function pageInit() {
      var _this = this;

      // 初始化数据
      this.loading = true;
      this.$http.get(api.getUrl20(this.region, _commissionApi.URL_SALESPREVIEW) + '/' + this.mainAcc, { params: {
          pageNum: this.currentPage - 1,
          pageSize: this.clause,
          type: this.type,
          seekVal: this.seachVal
        } }).then(function (res) {
        if (res.data.code == 200 && res.data.data && res.data.msg == 'OK') {
          _this.previewData = res.data.data.data;
          _this.totalData = res.data.data.count;
          _this.totalPage = Math.ceil(res.data.data.count / _this.clause);
          _this.loading = false;
        }
      });
    },
    callpageFn: function callpageFn() {
      // 翻页的方法
      this.pageInit();
    },
    seachFn: function seachFn() {
      // 搜索的方法
      this.currentPage = 1;
      this.pageInit();
    }
  },
  watch: {
    clause: function clause(curVal) {
      // 监听条目的变化
      this.currentPage = 1;
      this.pageInit();
    },
    region: function region() {
      this.pageInit();
    }
  }
};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _saleCommissionPreview = __webpack_require__(1039);

var _saleCommissionPreview2 = _interopRequireDefault(_saleCommissionPreview);

var _saleCommissionContent = __webpack_require__(1038);

var _saleCommissionContent2 = _interopRequireDefault(_saleCommissionContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'salesCommissionSetting',
  props: ['curArea'],
  mixins: [__webpack_require__(3).base({ salesCommissionLan: "salesCommission" })],
  data: function data() {
    return {
      showPreview: false,
      viewBtn: 'onlyOne',
      reqData: null
    };
  },

  components: {
    saleCommissionPreview: _saleCommissionPreview2.default,
    saleCommissionContent: _saleCommissionContent2.default
  },
  methods: {
    afterVerifyFn: function afterVerifyFn() {
      // 审核成功后 再次刷新version0
      this.$refs.version0 && this.$refs.version0.pageInit('0');
    }
  }
};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sTable = __webpack_require__(1037);

var _sTable2 = _interopRequireDefault(_sTable);

var _commissionEnv = __webpack_require__(5);

var _commissionApi = __webpack_require__(7);

var _util = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();
exports.default = {
  name: 'salesCommission',
  props: ['curArea', 'status'],
  mixins: [__webpack_require__(3).base({ multiLanguage: "commissionTable" })],
  components: {
    mtable: _sTable2.default
  },
  data: function data() {
    return {
      UTCDIFF: (0, _util.getTimeDiff)(),
      loading: false,
      label: 'getSalesInfo',
      region: 'GM',
      isSetting: {
        list: { // 状态列表
          allStatus: "allStatus",
          sated: "sated",
          unsated: "unsated",
          checked: 'checked',
          unchecked: 'unchecked'
        },
        active: this.status ? this.status : null,
        listActive: this.status && this.status == '0' ? 'unsated' : this.status && this.status == '1' ? 'unchecked' : 'allStatus'
      },
      trData: "", //  表格tr数据
      sort: { // 排序
        key: "sales_id",
        method: "ASC"
      },
      handle: { //  操作
        link: "saleCommissionSetting",
        idKey: "sales_id",
        delete: false
      },
      seekDropdown: { // 搜索选项
        list: { // 搜索项列表
          loginId: "sales_id",
          userName: "acc_name",
          phone: "phone",
          email: "email"
        },
        active: 'loginId', // list坐标
        seekStr: "" // 搜索内容
      },
      page: { // 分页
        active: 1,
        pageLeng: 0,
        offset: 0 // 查询数据库的offset需要的值，初始只为0组件内部处理最后给出一个能直接传给后台的值
      },
      selPage: { // 配合分页的显示col数目选择
        list: [5, 10, 25, 50], // 选择显示col数目
        active: localStorage.pageMaxIndex, // 当前list的坐标
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex] // 查询数据库的limit需要的值，初始值设为list的0坐标组件内部处理最后给出一个传给后台的值
      }
    };
  },
  mounted: function mounted() {
    this.seekDropdown && (this.seekDropdown.seekStr = "");
    this.tableAjax();
  },

  computed: {
    thData: function thData() {
      // 表格th数据
      return [this.multiLanguage.th.loginId, this.multiLanguage.th.accountName, this.multiLanguage.th.phone, this.multiLanguage.th.email, this.multiLanguage.th.remark, this.multiLanguage.th.officeState.name, this.multiLanguage.th.last_update, this.multiLanguage.th.settingStatus];
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: api.getUrl20(this.curArea, _commissionApi.URL_SALELIST),
        ajaxType: "get",
        getKey: ["data", "data", "sales_info"],
        ajaxPar: {
          limit: this.$ALLNUM,
          offset: 0,
          sort: this.sort.method,
          sortKey: this.sort.key,
          seekKey: this.seekDropdown.list[this.seekDropdown.active],
          seekVal: this.seekDropdown.seekStr,
          isSetting: this.isSetting.active

        }
      };
    }
  },
  methods: {
    tableAjax: function tableAjax() {
      var _this = this;

      try {
        this.loading = true;
        var offset = this.page.offset;
        var limit = this.selPage.limit;
        var sortKey = this.sort.key;
        var sort = this.sort.method;
        var seekKey = this.seekDropdown.list[this.seekDropdown.active];
        var seekVal = this.seekDropdown.seekStr;
        var isSetting = this.isSetting.active;
        this.$http(api.getUrl20(this.curArea, _commissionApi.URL_SALELIST), {
          params: { limit: limit, offset: offset, sortKey: sortKey, sort: sort, seekKey: seekKey, seekVal: seekVal, isSetting: isSetting },
          headers: {
            UTCDIFF: this.UTCDIFF
          }
        }).then(function (res) {
          var data = res.data.data;
          _this.trData = data.sales_info;
          _this.page.pageLeng = data.pageLength;
          _this.loading = false;
        });
      } catch (error) {
        this.loading = false;
      }
    },
    setOfficeState: function setOfficeState() {
      var _this2 = this;

      if (Object.prototype.toString.call(this.trData) == "[object Array]") {
        this.trData.forEach(function (item, index) {
          _this2.trData[index].officeState = _this2.trData[index].officeState == "F" ? _this2.multiLanguage.th.officeState.countryArr[0].text : _this2.trData[index].officeState == "P" ? _this2.multiLanguage.th.officeState.countryArr[1].text : _this2.multiLanguage.th.officeState.countryArr[2].text;
          _this2.trData[index].status = _this2.trData[index].status == true ? _this2.multiLanguage.isSetting.sated : _this2.multiLanguage.isSetting.unsated;
        });
      }
    }
  },
  watch: {
    curArea: function curArea() {
      // 监听：curArea 地区发生变化时，根据地区不同，初始化的baseUrl，之后执行tableAjax方法
      this.tableAjax();
    },
    multiLanguage: function multiLanguage() {
      // this.setOfficeState()
    }
  }
};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();
exports.default = {
  mixins: [__webpack_require__(3).base({ ruleSettingLan: "ruleItem" })],
  props: {
    version: {
      type: String,
      default: ''
    },
    enable: {
      type: Boolean,
      default: false
    },
    multiLanguage: { // 多语言
      type: Object,
      default: {}
    },
    specialIB: { // 特别代理
      type: Array,
      default: []
    },
    overlookIB: { // 被忽视的代理
      type: Array,
      default: []
    },
    curArea: {
      type: String,
      default: ''
    }
  },
  computed: {
    newSpecialIB: function newSpecialIB() {
      // 新的 特别代理
      return this.specialIB;
    },
    newOverlookIB: function newOverlookIB() {
      // 新的 被忽视的代理
      return this.overlookIB;
    }
  },
  methods: {
    addItem: function addItem(index, arr) {
      // 添加
      var tem = {};
      var keys = (0, _keys2.default)(arr[0]);
      keys.forEach(function (key) {
        key == 'withSub' ? tem[key] = true : tem[key] = '';
      });
      tem.value = [{ level: 0, rebate: '' }];
      arr.splice(index + 1, 0, tem);
    },
    removeItem: function removeItem(index, arr) {
      //删除
      if (arr.length > 1) {
        var msg = this.multiLanguage.btnGroup.confirmDeleteText;
        if (confirm(msg) == true) arr.splice(index, 1);
      }
    },
    addItemLev: function addItemLev(index, i, arr) {
      var tem = {};
      tem.level = arr[index].value.length;
      tem.rebate = '';
      arr[index].value.unshift(tem);
    },
    removeItemLev: function removeItemLev(index, i, arr) {
      if (arr[index].value.length > 1) {
        var msg = this.multiLanguage.btnGroup.confirmDeleteText;
        if (confirm(msg) == true) {
          var lev = arr[index].value[i].level;
          arr[index].value.splice(i, 1);
          arr[index].value.forEach(function (it) {
            if (it.level >= lev) it.level -= 1;
          });
        }
      }
    },
    withSubChecked: function withSubChecked(item) {
      setTimeout(function () {
        item.forEach(function (it) {
          it.withSub = item[0].withSub;
          it.ibId = item[0].ibId;
        });
      }, 0);
    },
    checkIBFn: function checkIBFn(item, type, faulty) {
      // 检查是不是代理
      if (faulty) return;else {
        // localhost:3010/GM/sales/check?salesId=6218908&ibId=680000033&type=ignore
        this.$http.get(api.getUrl20(this.curArea, _commissionApi.URL_SALESCHECK), { params: { salesId: this.$route.query.id, ibId: item.ibId, type: type } }).then(function (res) {
          var data = res.data.data;
          if (data.name) item.name = data.name;else {
            alert(data);
            item.ibId = '';
            item.name = '';
          }
        });
      }
    }
  }
};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuedraggable = __webpack_require__(131);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    draggable: _vuedraggable2.default
  },
  mixins: [__webpack_require__(3).base({ ruleSettingLan: "ruleItem" }), __webpack_require__(3).base({ publicLan: "publicLan" })],
  props: {
    viewBtn: {
      type: String,
      default: ''
    },
    enable: {
      type: Boolean,
      default: false
    },
    multiLanguage: {
      type: Object,
      default: {}
    },
    version: {
      type: String,
      default: ''
    },
    relation: {
      type: Array,
      default: []
    },
    currentIB: {
      type: Object,
      default: {}
    },
    rule: {
      type: Array,
      default: []
    },
    ruleSeq: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      checkedLevel: [],
      onfocus: false
    };
  },

  computed: {
    newRelation: function newRelation() {
      var arr = []; // 最后返回的数组
      var len = this.rule.length - 1; // 因为最后一个当前自己，不需要，所有重倒数第二个开始截取数组
      var num = this.rule.length - this.relation.length; // rule 和 relation 的长度差值
      if (num <= 1) arr = this.relation.slice(len * -1); // 根据rule的长度截取出新的relation数组，因为rule最后一个必定是自己，所以判断结果时要从 两者长度差值小于等于1 的值开始截取 
      else {
          // 否则，当rule的长度于relation的长度差值 大于1时，
          arr = this.relation.concat([]); // 先复制一份完整的relation給arr
          for (var i = 0; i < num - 1; i++) {
            // 然后根据 rule的长度减去relation的长度的差值来循环添加 not exist，因为两者差值在这里已经是大于1的值，所以要减去1才能得出正确的循环次数，
            arr.unshift({ name: 'not exist', id: 'not exist' }); // 代码到这里，表示所有的关系都已经添加了，之后添加的rule级别都是不在关系图里面的， 所以我用not exist 表示不存在
          }
        }
      return arr;
    }
  },
  methods: {
    addLevel: function addLevel() {
      // 添加级别
      this.rule.unshift([{
        ruleId: 4,
        clientType: 0,
        value: '',
        enableCommTarget: false,
        commTarget: ''
      }]);
    },
    removeLevel: function removeLevel() {
      // 删除级别
      if (this.checkedLevel.length > 0) {
        var msg = this.multiLanguage.btnGroup.confirmDeleteText;
        if (confirm(msg) == true) {
          if (this.rule.length - this.checkedLevel.length >= 1) {
            var tem = this.rule.concat([]);
            this.checkedLevel.forEach(function (item) {
              delete tem[item];
            });
            this.$parent.rule = tem.filter(function (item) {
              return item != null;
            });
            this.checkedLevel = [];
          } else return;
        }
      } else return;
    },
    addRule: function addRule(levelItem) {
      // 添加规则
      levelItem.push({
        ruleId: 4,
        clientType: 0,
        value: '',
        enableCommTarget: false,
        commTarget: ''
      });
    },
    removeRule: function removeRule(levelItem, ruleIndex) {
      // 删除规则
      var msg = this.multiLanguage.btnGroup.confirmDeleteText;
      if (confirm(msg) == true) {
        levelItem.splice(ruleIndex, 1);
      }
    },
    checkId: function checkId(ruleItem) {
      this.$emit('checkId', ruleItem);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(83);

var _promise2 = _interopRequireDefault(_promise);

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _util = __webpack_require__(11);

var _ruleSetting = __webpack_require__(1043);

var _ruleSetting2 = _interopRequireDefault(_ruleSetting);

var _commissionApi = __webpack_require__(7);

var _uiv = __webpack_require__(14);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);
//moment().format();

var api = new _commissionEnv.Api();
exports.default = {
  props: {
    multiLanguage: {
      type: Object,
      default: {}
    },
    version: {
      type: String,
      default: ''
    },
    viewBtn: {
      type: String,
      default: ''
    },
    curArea: {
      type: String,
      default: ''
    }
  },
  components: {
    Modal: _uiv.Modal,
    ruleSetting: _ruleSetting2.default,
    Btn: _uiv.Btn,
    Dropdown: _uiv.Dropdown
  },
  data: function data() {
    return {
      newTempFlag: false,
      temp_name: this.$parent.currentTemplate,
      tempHistory: [],
      salesTemplate: [],
      ibTemplate: [],
      currentVersion: null,
      newTempName: '',
      UTCDIFF: (0, _util.getTimeDiff)(),
      showModal: false,
      sucSave: false,
      enable: false,
      updateBy: '',
      confirmBy: '',
      lastUpdate: '',
      lastConfirm: '',
      relation: [],
      rule: [],
      currentIB: {},
      specialIB: [],
      overlookIB: [],
      isConfirm: false,
      ruleSeq: []
    };
  },
  mounted: function mounted() {
    this.pageInit();
  },

  computed: {
    updateData: function updateData() {
      var _this = this;

      // 需要修改的数据
      var newRule = [];
      if (!this.enable) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(this.rule), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var ruleLevel = _step.value;

            var newRuleLevel = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = (0, _getIterator3.default)(ruleLevel), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var ruleItem = _step2.value;

                if (!ruleItem.enableCommTarget && ruleItem.value.trim() !== '' || ruleItem.enableCommTarget && ruleItem.commTarget !== '' && ruleItem.value.trim() !== '') newRuleLevel.push(ruleItem);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            newRule.push(newRuleLevel);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      var temp_lang = 'auto';
      if (this.salesTemplate && this.salesTemplate.length > 0) {
        this.salesTemplate.forEach(function (it) {
          if (it.templateId == _this.temp_name) temp_lang = it.langKey;
        });
      }
      return {
        newTempFlag: this.newTempFlag,
        updateBy: JSON.parse(sessionStorage.user).user_name,
        rule: this.enable ? this.rule : newRule,
        tmplateName: this.newTempFlag ? this.newTempName : this.temp_name,
        tmpLang: this.newTempFlag ? 'auto' : temp_lang
      };
    }
  },
  methods: {
    pageInit: function pageInit(version) {
      var _this2 = this;

      // 初始化数据
      this.$http.get(api.getUrl20(this.curArea, _commissionApi.URL_TEMPLATE_GET + '/' + this.temp_name)).then(function (res) {
        if (res.data.code == 200 && res.data.msg == 'OK') {
          var data = res.data.data;
          _this2.enable = true;
          _this2.rule = data.rulemapping.length > 0 ? data.rulemapping : [[{
            ruleId: 4,
            clientType: 0,
            value: '',
            enableCommTarget: false,
            commTarget: ''
          }]];
          _this2.ruleSeq = data.ruleSeq;
          _this2.$parent.reqData = data.ruleSeq;
          _this2.ibTemplate = data.ibTemplate;
          _this2.salesTemplate = data.salesTemplate;
          _this2.tempHistory = [{ TEMPLATE_ID: _this2.temp_name, VERSION: 0 }].concat(data.history);
          _this2.currentVersion = null;
          if (_this2.tempHistory && _this2.tempHistory.length > 0) _this2.currentVersion = _this2.tempHistory[0].VERSION;
          if (!_this2.salesTemplate || _this2.salesTemplate.length == 0) _this2.temp_name = '';
        }
      });
    },
    onTemplateChange: function onTemplateChange() {
      this.pageInit();
      this.$parent.currentTemplate = this.temp_name;
    },
    onVersionChange: function onVersionChange(version) {
      var _this3 = this;

      if (version == 0) {
        this.pageInit();
        return;
      }
      this.$http.get(api.getUrl20(this.curArea, _commissionApi.URL_TEMPLATE_HISTORY) + '/' + this.temp_name + '/' + this.currentVersion).then(function (res) {
        if (res.data.code === 200) {
          _this3.rule = res.data.data.rulemapping;
        }
      });
    },
    createTemplate: function createTemplate() {
      this.newTempName = '';
      this.newTempFlag = !this.newTempFlag;
    },
    submit: function submit() {
      var _this4 = this;

      // 保存修改
      if (this.newTempFlag) {
        var sameName = false;
        this.ibTemplate.forEach(function (it) {
          if (it.templateId == _this4.newTempName) sameName = true;
        });
        this.salesTemplate.forEach(function (it) {
          if (it.templateId == _this4.newTempName) sameName = true;
        });
        if (sameName) {
          alert(this.multiLanguage.alertMsg.templateExist);
          return;
        }
      }
      function isTrueFn(element) {
        return element == true;
      }
      var arr = [this.$refs.ruleSetting.$validator.validateAll()];
      _promise2.default.all(arr).then(function (result) {
        if (result.every(isTrueFn) && (_this4.enable ? _this4.checkRuleResultFn() : true)) {
          _this4.$http.post(api.getUrl20(_this4.curArea, _commissionApi.URL_TEMPLATE_SAVE + '/1'), _this4.updateData).then(function (res) {
            if (res.data.code == 200 && res.data.msg == "OK") {
              _this4.showModal = true;
              _this4.sucSave = true;
              _this4.salesTemplate = res.data.data.salesTemplate;
              _this4.temp_name = _this4.updateData.tmplateName;
              _this4.tempHistory = res.data.data.history;
              if (_this4.tempHistory && _this4.tempHistory.length > 0) _this4.currentVersion = _this4.tempHistory[0].VERSION;
            } else {
              _this4.showModal = true;
              _this4.sucSave = false;
            }
          });
        } else {
          _this4.showModal = true;
          _this4.sucSave = false;
        }
      });
    },
    checkIdFn: function checkIdFn(ruleItem) {
      var _this5 = this;

      // 检查id是否在关系图
      this.$http(api.getUrl20(this.curArea, _commissionApi.URL_TOOLCHECKID), { params: { id: ruleItem.commTarget, type: 'SL' } }).then(function (res) {
        var result = res.data.data.result;
        if (!result) {
          alert(_this5.multiLanguage.alertMsg.noAccount);
          ruleItem.commTarget = '';
        }
      });
    },
    getLengthWithMatch: function getLengthWithMatch(arr, callback) {
      var len = 0;
      arr.forEach(function (a) {
        len += callback(a) ? 1 : 0;
      });
      return len;
    },
    hasSameItem: function hasSameItem(arr, names) {
      // 数组中的所有项的name属性的值是否都相同
      if (arr.length > 1) {
        var target = arr[0]; // 参照物
        for (var i = 1; i < arr.length; i++) {
          if (this.isSameObject(target, arr[i], names)) return true;
        }
      }
      return false;
    },
    isSameObject: function isSameObject(obj1, obj2, properties) {
      // 判断两个对象的所有properties是否都相同
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(properties), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var p = _step3.value;

          if (obj1[p] !== obj2[p]) return false;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return true;
    },
    checkRuleSetting2: function checkRuleSetting2(rules) {
      // 规则设定检查2
      var falseCommTargetLength = this.getLengthWithMatch(rules, function (r) {
        return !r.enableCommTarget;
      });
      if (falseCommTargetLength === 0) return true; //规则中没有为false的项
      if (falseCommTargetLength != rules.length) {
        // enableCommTarget存在不相同
        // alert('分配账号设定不同。')
        alert(this.multiLanguage.alertMsg.checkRuleFail1);
        return false;
      }

      if (this.getLengthWithMatch(rules, function (r) {
        return r.ruleId === 4;
      }) > 0) {
        if (this.getLengthWithMatch(rules, function (r) {
          return r.ruleId === 7 || r.ruleId === 8;
        }) > 0) {
          // alert('固定金额与固定金额(普通组别)、固定金额(VIP 组别)不能同时选择。')
          alert(this.multiLanguage.alertMsg.checkRuleFail2);
          return false;
        }
      }

      var zeroClientTypeLength = this.getLengthWithMatch(rules, function (r) {
        return r.clientType === 0;
      });
      if (zeroClientTypeLength > 0) {
        // ruleId 不能重复
        if (this.hasSameItem(rules, ['ruleId'])) alert(this.multiLanguage.alertMsg.checkRuleFail3); // alert('相同规则下，全部客户类型与其他客户类型冲突') 
        return !this.hasSameItem(rules, ['ruleId']);
      } else {
        // 项与项之间的ruleId和clientType不能相同
        if (this.hasSameItem(rules, ['ruleId', 'clientType'])) alert(this.multiLanguage.alertMsg.checkRuleFail4); //alert('存在重复的规则设定')
        return !this.hasSameItem(rules, ['ruleId', 'clientType']);
      }
      return true;
    },
    checkRuleSetting1: function checkRuleSetting1(rule) {
      // 规则设定检查1
      var checkRule = {};
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = (0, _getIterator3.default)(rule), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var val = _step4.value;
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = (0, _getIterator3.default)(val), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var r = _step5.value;

              if (r.ruleId == 5) {
                if (!checkRule[r.ruleId + '-clientType']) {
                  checkRule[r.ruleId + '-clientType'] = { count: 1, content: (0, _stringify2.default)({ clientType: r.clientType }) };
                } else {
                  if ((0, _stringify2.default)({ clientType: r.clientType }) != checkRule[r.ruleId + '-clientType'].content) {
                    return false;
                  } else {
                    checkRule[r.ruleId + '-clientType'].count++;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      for (var key in checkRule) {
        if (checkRule[key].count != rule.length) {
          //alert('存在“分层最高金额”这个规则时，每个级别都必须有一条“分层最高金额”，并保证“客户类型”一致')
          alert(this.multiLanguage.alertMsg.checkRuleFail5);
          return false;
        }
      }
      return true;
    },
    checkRuleResultFn: function checkRuleResultFn() {
      var result = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = (0, _getIterator3.default)(this.updateData.rule), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var rule = _step6.value;

          result.push(this.checkRuleSetting2(rule));
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      if (result.every(function (r) {
        return r === true;
      }) && this.checkRuleSetting1(this.updateData.rule)) {
        // console.log('1_',result,this.checkRuleSetting1(this.updateData.rule))
        return true;
      } else {
        // console.log('2_',result,this.checkRuleSetting1(this.updateData.rule))
        return false;
      }
    },
    normSetFn: function normSetFn(path) {
      var _this6 = this;

      // 拿到内设数据
      this.$http.get(api.getUrl20(this.curArea, _commissionApi.URL_DEFAULT) + path).then(function (res) {
        if (res.data.code === 200) {
          _this6.rule = res.data.data.rulemapping;
        }
      });
    },
    dataFormat: function dataFormat(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  watch: {
    curArea: function curArea() {
      this.$parent.currentTemplate = 'SALES_DEFAULT';
      this.temp_name = 'SALES_DEFAULT';
      this.pageInit();
    }
  }
};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _saleTemplateContent = __webpack_require__(1044);

var _saleTemplateContent2 = _interopRequireDefault(_saleTemplateContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'salesTemplateSetting',
  props: ['curArea'],
  mixins: [__webpack_require__(3).base({ salesCommissionLan: "salesCommission" })],
  data: function data() {
    return {
      showPreview: false,
      viewBtn: 'onlyOne',
      reqData: null,
      currentTemplate: 'SALES_DEFAULT'
    };
  },

  components: {
    saleTemplateContent: _saleTemplateContent2.default
  },
  methods: {
    afterVerifyFn: function afterVerifyFn() {
      // 审核成功后 再次刷新version0
      this.$refs.version0 && this.$refs.version0.pageInit('0');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _util = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      data: []
    };
  },

  props: {
    name: {
      type: String,
      default: '下載'
    },
    rID: {
      default: ''
    },
    cID: {
      default: ''
    },
    type: {
      default: ''
    },
    keys: {
      default: Array
    },
    ajaxUrl: {
      default: false
    },
    ajaxGetKey: {
      default: false
    },
    ajaxPar: {
      default: {}
    },
    ajaxType: {
      default: 'get'
    },
    colData: {
      default: false
    },
    downLoadTran: {
      type: Object,
      default: function _default() {}
    }
  },
  methods: {
    getHeadKeyOrName: function getHeadKeyOrName(type) {
      var arr = [];
      this.keys.forEach(function (item) {
        if ((item.flag === undefined || item.flag) && (item.unneed === undefined || item.unneed)) {
          arr.push(item[type]);
        }
      });
      return arr;
    },
    generate_excel: function generate_excel() {
      var _this = this;

      var curArea = JSON.parse(sessionStorage.getItem('currentArea20'));
      var rID = this.rID ? ' ' + this.rID : '';
      var cID = this.cID ? ' ' + this.cID : '';
      var typeStr = this.type ? ' ' + this.type : '';
      var downLoadName = curArea.value + ' ' + this.name + rID + cID + typeStr;

      var ajaxPar = this.ajaxType === 'post' ? this.ajaxPar : { params: this.ajaxPar };
      this.$http[this.ajaxType](this.ajaxUrl, ajaxPar).then(function (res) {
        var getVal = function getVal(obj, arr) {
          if (arr.length > 1) {
            return getVal(obj[arr[0]], arr.slice(1));
          } else {
            return obj[arr[0]];
          }
        };
        _this.data = getVal(res, _this.ajaxGetKey);
        _this.export2Excel(_this.resolveData(_this.data), downLoadName);
      });
    },
    export2Excel: function export2Excel(excelData, excelName) {
      var _this2 = this;

      new Promise(function(resolve) { resolve(); }).then((function () {
        var _require = __webpack_require__(65),
            export_json_to_excel = _require.export_json_to_excel;

        var tHeader = _this2.getHeadKeyOrName('name');
        var filterVal = _this2.getHeadKeyOrName('key');
        var list = excelData;
        var data = _this2.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, excelName);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    resolveData: function resolveData(data) {
      var arr = [];
      if (Array.isArray(data[0])) {
        // 后台数据格式[[{},{}],[{},{}]...]
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var array = _step.value;

            this.traverse(arr, array);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        // 后台数据格式[{},{},{}...]
        this.traverse(arr, data);
      }
      return arr;
    },
    traverse: function traverse(arr, data) {
      for (var i in data) {
        var v = data[i];
        var obj = {};
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(this.keys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            // 如果头部有flag并且设置了flag为false 或者 有unneed并且设置了unneed为false,则不取值
            if (item.flag !== undefined && !item.flag || item.unneed !== undefined && !item.unneed) continue;
            // 头部键需要转大写的转大写取值
            var tempKey = item.upper === undefined || item.upper ? item.key.toUpperCase() : item.key;
            // 如果头部有utcTime并且为true,则转换时间格式,时区不变
            if (item.utcTime != undefined && item.utcTime) {
              obj[item.key] = v[tempKey] ? (0, _util.formatDate)(v[tempKey]) : '';
              continue;
            }
            // 如果头部有changeTime并且为true,则转换对应时区时间
            if (item.changeTime != undefined && item.changeTime) {
              obj[item.key] = v[tempKey] ? (0, _util.updateTimeByUtc)((0, _util.getTimeDiff)(), v[tempKey]) : '';
              continue;
            }
            // 下载翻译对象不存在或者对象不存在此键,则直接取后台返回的值,否则取翻译对象中的值
            if (this.downLoadTran === undefined || !this.downLoadTran[tempKey]) {
              obj[item.key] = v[tempKey] || v[tempKey] == 0 ? v[tempKey] : '';
              continue;
            }
            var temp = this.downLoadTran[tempKey][v[tempKey]];
            // 翻译对象通过键取值的对象中有part属性,则给此列数据最后一个做翻译,此列其余数据取后台返回的数据
            if (!this.downLoadTran[tempKey].part) {
              obj[item.key] = temp || temp == 0 ? temp : '';
              continue;
            }
            if (i >= data.length - this.downLoadTran[tempKey].index) {
              obj[item.key] = temp || temp == 0 ? temp : '';
              continue;
            }
            obj[item.key] = v[tempKey] || v[tempKey] == 0 ? v[tempKey] : '';
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        arr.push(obj);
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _util = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      firstData: [],
      secondData: [],
      firstHead: [],
      secondHead: []
    };
  },

  props: {
    rID: {
      default: ''
    },
    firstTh: {
      type: Object,
      default: function _default() {}
    },
    secondTh: {
      type: Object,
      default: function _default() {}
    },
    sheetName: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    downloadName: {
      default: 'download'
    },
    ajaxUrl: {
      default: false
    },
    dataTh: {
      default: false
    },
    ajaxGetKey: {
      default: false
    },
    ajaxPar: {
      default: {}
    },
    ajaxType: {
      default: 'get'
    },
    filter: {
      default: false
    }
  },
  methods: {
    tablesToExcel: function tablesToExcel() {
      var _this = this;

      if (!this.canFilter) {
        this.$message.error(this.filter.errorMsg);
        return;
      }
      var curArea = JSON.parse(sessionStorage.getItem('currentArea20'));
      var id = this.rID ? ' ' + this.rID : '';
      var name = this.downloadName ? ' ' + this.downloadName : '';
      var wbname = curArea.value + ' ' + name + id;
      var ajaxPar = this.ajaxType === 'post' ? this.ajaxPar : { params: this.ajaxPar };
      this.$http[this.ajaxType](this.ajaxUrl, ajaxPar).then(function (res) {
        var getVal = function getVal(obj, arr) {
          if (arr.length > 1) {
            return getVal(obj[arr[0]], arr.slice(1));
          } else {
            return obj[arr[0]];
          }
        };
        var getTableHeadAndBody = function getTableHeadAndBody(head, bodyData, langObj) {
          var tmpObj = void 0;
          // ���dataThΪtrue,��ȡ�÷����ļ��ı���ͷ������������ͷ
          if (_this.dataTh) tmpObj = langObj.th;else tmpObj = bodyData[0] ? bodyData[0] : langObj.th;
          var thKeys = (0, _keys2.default)(tmpObj);
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(thKeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              head.push({ key: item, name: langObj.th[item] });
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          var tmpArr = (0, _keys2.default)(langObj).filter(function (v) {
            return v != 'th';
          });
          bodyData.forEach(function (val, index) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = (0, _getIterator3.default)(tmpArr), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var key = _step2.value;

                var _tmpObj = langObj[key];
                val[key] = val[key] || val[key] == 0 ? _tmpObj['changeTime'] ? (0, _util.updateTimeByUtc)((0, _util.getTimeDiff)(), val[key]) : _tmpObj[val[key]] : '';
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          });
        };
        var data = getVal(res, _this.ajaxGetKey);
        var columns = _this.filter.columns;
        var mapping = _this.filter.mapping;
        _this.firstData = columns ? data[0].filter(function (v) {
          return columns.every(function (f) {
            return !_this.ajaxPar[f] || v[mapping[f]] == _this.ajaxPar[f];
          });
        }) : data[0];
        _this.secondData = data[1];
        _this.firstHead = [];
        _this.secondHead = [];
        getTableHeadAndBody(_this.firstHead, _this.firstData, _this.firstTh);
        getTableHeadAndBody(_this.secondHead, _this.secondData, _this.secondTh);
        _this.export2Excel(wbname);
      });
    },
    export2Excel: function export2Excel(excelName) {
      var _this2 = this;

      new Promise(function(resolve) { resolve(); }).then((function () {
        var _require = __webpack_require__(65),
            export_json_to_multi_excel = _require.export_json_to_multi_excel;

        var firstHeader = _this2.getHeadKeyOrName(_this2.firstHead, 'name');
        var firstKey = _this2.getHeadKeyOrName(_this2.firstHead, 'key');
        var secondHeader = _this2.getHeadKeyOrName(_this2.secondHead, 'name');
        var secondKey = _this2.getHeadKeyOrName(_this2.secondHead, 'key');
        var data = [_this2.formatJson(firstKey, _this2.firstData), _this2.formatJson(secondKey, _this2.secondData)];
        export_json_to_multi_excel([firstHeader, secondHeader], data, _this2.sheetName, excelName);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    getHeadKeyOrName: function getHeadKeyOrName(thArr, type) {
      var arr = [];
      thArr.forEach(function (item) {
        if ((item.flag === undefined || item.flag) && (item.unneed === undefined || item.unneed)) {
          arr.push(item[type]);
        }
      });
      return arr;
    }
  },
  computed: {
    canFilter: function canFilter() {
      var columns = this.filter.columns;
      var params = this.ajaxPar;
      if (!columns) return true;
      if (columns.every(function (v) {
        return !params[v];
      })) return false;
      return columns.reduce(function (p, c) {
        return p && /^\d{0,}$/.test(params[c] || '');
      }, true);
    }
  }
}; //
//
//
//
//
//

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _seek = __webpack_require__(419);

var _seek2 = _interopRequireDefault(_seek);

var _selPage = __webpack_require__(82);

var _selPage2 = _interopRequireDefault(_selPage);

var _seekDatePicker = __webpack_require__(194);

var _seekDatePicker2 = _interopRequireDefault(_seekDatePicker);

var _noData = __webpack_require__(64);

var _noData2 = _interopRequireDefault(_noData);

var _vueUploadComponent = __webpack_require__(130);

var _vueUploadComponent2 = _interopRequireDefault(_vueUploadComponent);

var _uiv = __webpack_require__(14);

var _excel = __webpack_require__(1046);

var _excel2 = _interopRequireDefault(_excel);

var _multiSheetExcel = __webpack_require__(1047);

var _multiSheetExcel2 = _interopRequireDefault(_multiSheetExcel);

var _vuex = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    thData: {
      // 表格th数据
      type: Array,
      default: []
    },
    firstTh: {
      type: Object,
      default: function _default() {}
    },
    secondTh: {
      type: Object,
      default: function _default() {}
    },
    detailTh: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    trData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }, // 表格tr数据
    totalData: {
      default: false
    },
    operate: {
      default: false
    },
    link: {
      default: false
    },
    tip: {
      default: false
    },
    handle: {
      default: false
    },
    multiLanguage: {
      // 翻译，也是文字型数据
      type: Object,
      default: {}
    },
    selPage: {
      // 显示条目数
      default: false
    },
    seekDropdown: {
      // 搜索目标选项
      default: false
    },
    page: {
      // 分页
      default: false
    },
    jsonExcelAjax: {
      // 下载Excel
      default: false
    },
    name: {
      default: ''
    },
    detailName: {
      defalut: ''
    },
    detailExcelAjax: {
      default: false
    },
    multiExcelAjax: {
      default: false
    },
    sort: {
      // 排序
      default: false
    },
    seekDatePicker: {
      // 时间搜索
      default: false
    },
    trCls: {
      // tr class
      default: false
    },
    back: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    downLoadTran: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      //pageactive: this.page ? this.page.active : "",
      seekDropdownProps: this.seekDropdown ? this.seekDropdown : '',
      deleteCol: {
        // 删除功能
        switch: false,
        list: []
      },
      totalTr: {},
      checkedArr: [],
      refuseReason: '',
      isIndeterminate: false,
      selectAll: false,
      trSize: 0,
      selectData: []
    };
  },
  mounted: function mounted() {
    this.totalData && this.total();
    if (this.selPage && !this.selPage.active) this.$parent.selPage.active = 0;
  },

  computed: {
    trDataKeys: function trDataKeys() {
      return (0, _keys2.default)(this.trData[0]);
    }
  },
  methods: (0, _extends3.default)({
    updateStatus: function updateStatus(value) {
      var _this = this;

      if (window.confirm(this.multiLanguage.commit)) {
        var ajaxObj = {};
        var name = JSON.parse(sessionStorage.getItem('user')).user_name;
        if (value == '3') {
          ajaxObj = { type: value, level: this.operate.level, data: this.checkedArr, update_by: name };
        } else {
          ajaxObj = { type: value, level: this.operate.level, reject_reason: this.refuseReason, data: this.checkedArr, update_by: name };
        }
        this.refuseReason = '';
        this.checkedArr = [];
        this.$http.post(this.operate.url, ajaxObj).then(function (res) {
          _this.$emit('tableChange');
        });
      } else {
        return false;
      }
    },
    checkAll: function checkAll(val) {
      this.checkedArr = val ? this.selectData.slice() : [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.trData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var v = _step.value;

          if (v.STATUS !== undefined && [0, 1, 2].indexOf(+v.STATUS) > -1) v.checked = val;
        }
        //console.log(this.checkedArr.length)
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.isIndeterminate = false;
    },
    updateCheckArr: function updateCheckArr(checkObj) {
      //console.log(this.checkedArr.indexOf(checkObj) > -1)
      if (this.checkedArr.indexOf(checkObj) > -1) this.checkedArr.splice(this.checkedArr.indexOf(checkObj), 1);else this.checkedArr.push(checkObj);
      //console.log(this.trSize)
      this.selectAll = this.checkedArr.length === this.trSize;
      this.isIndeterminate = this.checkedArr.length > 0 && this.checkedArr.length < this.trSize;
      //console.log(this.checkedArr)
    },
    total: function total() {
      var _this2 = this;

      if (!this.totalData || !this.totalData.length) return;
      var keys = (0, _keys2.default)(this.totalData[0]);
      var obj = {};
      this.totalData.forEach(function (item) {
        keys.forEach(function (key, keyIndex) {
          if (Object.prototype.toString.call(item[key]) === '[object Number]' && keyIndex !== 0) {
            if (!obj[key] && obj[key] !== 0) obj[key] = 0;
            obj[key] += item[key];
          } else if (Object.prototype.toString.call(item[key]) === '[object String]') {
            obj[key] = '#';
          } else if (keyIndex === 0) {
            obj[key] = _this2.multiLanguage.total;
          }
        });
      });
      (0, _keys2.default)(obj).forEach(function (key) {
        if (Object.prototype.toString.call(obj[key]) === '[object Number]') {
          obj[key] = +obj[key].toFixed(2);
        }
      });
      this.totalTr = obj;
    },
    sortFn: function sortFn(key, flag) {
      if (!this.sort || !flag) return;
      this.sort.key = key;
      if (this.sort.method === 'ASC') this.$parent.sort.method = 'DESC';else if (this.sort.method === 'DESC') this.$parent.sort.method = 'ASC';
      this.$emit('tableChange');
    },
    clickSeekDropdown: function clickSeekDropdown(index) {
      this.$emit('clickSeekDropdown', index);
    },
    selPageFn: function selPageFn(index, item) {
      this.SAVEPAGEMAXINDEX(index);
      this.$parent.selPage.active = index;
      this.$parent.selPage.limit = this.selPage.list[this.selPage.active];
      this.$parent.page.offset = 0;
      this.pageactive = 1;
      this.$parent.page.active = 1;
      this.$emit('tableChange');
    },
    callpageFn: function callpageFn(index) {
      this.$parent.page.active = index;
      this.$parent.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : '';
      this.$emit('tableChange');
    },
    setSeekDropdown: function setSeekDropdown(index) {
      this.seekDropdownActive = index;
    },
    seek: function seek(seekStr) {
      this.pageactive = 1;
      if (this.page) this.$parent.page.offset = 0;
      if (this.$parent.page) this.$parent.page.active = 1;
      this.$emit('seek');
    },
    seekDatePickerFn: function seekDatePickerFn(seekVal) {
      this.$emit('seek');
    },
    clickColFn: function clickColFn(colItem, index) {
      this.$emit('clickCol', colItem, index);
    },
    deleteColClick: function deleteColClick() {
      this.deleteCol.switch = true;
    },
    deleteColNotarizeFn: function deleteColNotarizeFn() {
      this.deleteCol.switch = false;
      this.$emit('deleteList', this.deleteCol.list);
      this.deleteCol.list = [];
    },
    deletePitch: function deletePitch(item) {
      if (this.deleteCol.switch === false) {
        return;
      }
      var id = item[this.handle.idKey];
      var index = this.deleteCol.list.indexOf(id);
      if (index === -1) {
        this.deleteCol.list.push(id);
      } else {
        this.deleteCol.list.splice(index, 1);
      }
    },
    linkDetails: function linkDetails(item) {
      if (this.back !== '') {
        sessionStorage.setItem('back', this.back);
      }
      this.$router.push({
        path: this.link.path,
        query: item
      });
    },
    linkRegister: function linkRegister(item) {
      if (this.deleteCol.switch === true) {
        this.deletePitch(item);
      } else {
        this.$router.push({
          path: this.handle.link,
          query: {
            id: item[this.handle.idKey]
          }
        });
      }
    }
  }, (0, _vuex.mapMutations)(['SAVEPAGEMAXINDEX'])),
  watch: {
    trData: function trData(newVal, oldVal) {
      this.selectAll = false;
      this.isIndeterminate = false;
      this.trSize = 0;
      this.selectData = [];
      if (this.operate) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(newVal), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var v = _step2.value;

            if (v.STATUS !== undefined && [0, 1, 2].indexOf(+v.STATUS) > -1) {
              this.trSize++;
              this.selectData.push(v);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    },
    seekDropdownActive: function seekDropdownActive(curVal, oldVal) {
      this.$parent.seekData.seekDropdownActive = curVal;
    },
    totalData: function totalData(curVal, oldVal) {
      curVal.length > 0 && this.total();
    }
  },
  components: {
    seek: _seek2.default,
    selPage: _selPage2.default,
    seekDatePicker: _seekDatePicker2.default,
    fileUpload: _vueUploadComponent2.default,
    Dropdown: _uiv.Dropdown,
    Pagination: _uiv.Pagination,
    jsonExcel: _excel2.default,
    //detailExcel,
    multiSheetExcel: _multiSheetExcel2.default,
    noData: _noData2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: "from",
  mounted: function mounted() {},

  components: {}
};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _crumbs = __webpack_require__(57);

var _crumbs2 = _interopRequireDefault(_crumbs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'commissionView_v2',
  created: function created() {
    if (this.role && this.region) {
      this.role == 'ib' ? this.jump('/ibPrimary_v2/?status=' + this.status + '&region=' + this.region) : this.jump('/salePrimary_v2/?status=' + this.status + '&region=' + this.region);

      var currentArea = JSON.parse(sessionStorage.currentArea20);
      currentArea.value = this.region;
      sessionStorage.currentArea20 = (0, _stringify2.default)(currentArea);
    }
  },
  beforeCreate: function beforeCreate() {
    var areaObj = JSON.parse(sessionStorage.area20);
    var profitshare_area = JSON.parse(sessionStorage.profitshare_area);
    var storage = sessionStorage.currentArea20 || "{}";
    var currentArea = JSON.parse(storage);
    currentArea.group = profitshare_area[0];
    currentArea.value = areaObj[0];
    sessionStorage.currentArea20 = (0, _stringify2.default)(currentArea);
  },

  mixins: [__webpack_require__(3).base({ commissionViewLan: "commissionView" })],
  data: function data() {
    return {
      role: this.$route.query.role ? this.$route.query.role.split('$')[0] : '',
      region: this.$route.query.role ? this.$route.query.role.split('$')[1] : '',
      status: this.$route.query.role ? this.$route.query.role.split('$')[2] : '',
      act: '',
      fromSpbo2: sessionStorage.fromSpbo2
    };
  },

  computed: {
    active: function active() {
      //   return this.$route.path.slice(this.$route.path.indexOf('/',1),this.$route.path.lastIndexOf('/'))
      return this.$route.path.slice(this.$route.path.indexOf('/'), this.$route.path.lastIndexOf('/'));
    }
  },
  components: {
    crumbs: _crumbs2.default
  },
  methods: {
    jump: function jump(link) {
      //   this.$router.push({path: this.path + link})
      this.$router.push(link);
      //   this.active = link
      this.act = link;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _set = __webpack_require__(108);

var _set2 = _interopRequireDefault(_set);

var _from = __webpack_require__(107);

var _from2 = _interopRequireDefault(_from);

var _values = __webpack_require__(209);

var _values2 = _interopRequireDefault(_values);

var _uiv = __webpack_require__(14);

var _commissionApi = __webpack_require__(7);

var _commissionEnv = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var api = new _commissionEnv.Api(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: ['status'],
    mixins: [__webpack_require__(3).base({ ibPrimaryLan: "ibPrimary" })],
    data: function data() {
        return {
            apiChangeable: api.changeable,
            path: '/commissionView/ibPrimary',
            activeName: 'first',
            actArea: JSON.parse(sessionStorage.currentArea20).value,
            curAreaGroup: this.$route.query.role ? this.$route.query.role.split('$')[1] : this.$route.query.region ? this.$route.query.region : JSON.parse(sessionStorage.currentArea20).group,
            checkCpa: false
        };
    },

    components: {
        BtnGroup: _uiv.BtnGroup,
        Btn: _uiv.Btn,
        Dropdown: _uiv.Dropdown
    },
    computed: {
        activePrimary: {
            get: function get() {
                return this.$route.path.slice(this.$route.path.lastIndexOf('/'));
            },
            set: function set() {}
        },
        area: function area() {
            var area_data = JSON.parse(sessionStorage.area20);
            var values = (0, _values2.default)(area_data);
            return (0, _from2.default)(new _set2.default(values.flat(Infinity)));
            // return area_data
        },

        curArea: {
            get: function get() {
                var res = '';
                if (!this.actArea) {
                    res = this.area[0];
                } else res = this.actArea;
                return res;
            },
            set: function set(newValue) {
                this.actArea = newValue;
            }
        }
    },
    methods: {
        jump: function jump(link) {
            sessionStorage.removeItem('back');
            // this.$router.push({path: this.path+link})
            this.$router.push(link);
            this.activePrimary = link;
        },
        checkCpaFn: function checkCpaFn() {
            var _this = this;

            this.$http(api.getUrl20(this.curArea, _commissionApi.URL_TOOLCHECKCPA)).then(function (res) {
                if (res.data.code == 200 && res.data.data && res.data.msg == 'OK') {
                    _this.checkCpa = res.data.data.cpaCheck;
                }
            });
        },
        areaGroupSwitchFn: function areaGroupSwitchFn(key) {
            this.curArea = key;
            var currentArea = JSON.parse(sessionStorage.currentArea20);
            currentArea.value = key;
            sessionStorage.currentArea20 = (0, _stringify2.default)(currentArea);
        }
    },
    watch: {
        curAreaGroup: function curAreaGroup() {
            this.actArea = '';
            var currentArea = JSON.parse(sessionStorage.currentArea20);
            currentArea.value = this.area[0];
            sessionStorage.currentArea20 = (0, _stringify2.default)(currentArea);
        }
    }
};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _set = __webpack_require__(108);

var _set2 = _interopRequireDefault(_set);

var _from = __webpack_require__(107);

var _from2 = _interopRequireDefault(_from);

var _values = __webpack_require__(209);

var _values2 = _interopRequireDefault(_values);

var _commissionEnv = __webpack_require__(5);

var _uiv = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var api = new _commissionEnv.Api();
exports.default = {
  mixins: [__webpack_require__(3).base({ salePrimaryLan: "salePrimary" })],
  props: ['status'],
  data: function data() {
    return {
      apiChangeable: api.changeable,
      path: '/commissionView/salePrimary',
      actArea: JSON.parse(sessionStorage.currentArea20).value,
      //   actArea: '',
      curAreaGroup: this.$route.query.role ? this.$route.query.role.split('$')[1] : this.$route.query.region ? this.$route.query.region : JSON.parse(sessionStorage.currentArea20).group
    };
  },

  computed: {
    activePrimary: {
      get: function get() {
        return this.$route.path.slice(this.$route.path.lastIndexOf('/'));
      },
      set: function set() {}
    },
    area: function area() {
      var area_data = JSON.parse(sessionStorage.area20);
      var values = (0, _values2.default)(area_data);
      return (0, _from2.default)(new _set2.default(values.flat(Infinity)));
      // return area_data
    },

    curArea: {
      get: function get() {
        var res = '';
        if (!this.actArea) {
          res = this.area[0];
        } else res = this.actArea;
        return res;
      },
      set: function set(newValue) {
        this.actArea = newValue;
      }
    }
  },
  components: {
    BtnGroup: _uiv.BtnGroup,
    Btn: _uiv.Btn,
    Dropdown: _uiv.Dropdown
  },
  methods: {
    jump: function jump(link) {
      sessionStorage.removeItem('back');
      //   this.$router.push({path: this.path+link})
      this.$router.push(link);
      this.activePrimary = link;
    },
    areaGroupSwitchFn: function areaGroupSwitchFn(key) {
      this.curArea = key;
      var currentArea = JSON.parse(sessionStorage.currentArea20);
      currentArea.value = key;
      sessionStorage.currentArea20 = (0, _stringify2.default)(currentArea);
    }
  },
  watch: {
    curAreaGroup: function curAreaGroup() {
      this.actArea = '';
      var currentArea = JSON.parse(sessionStorage.currentArea20);
      currentArea.value = this.area[0];
      sessionStorage.currentArea20 = (0, _stringify2.default)(currentArea);
    }
  }
};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _util = __webpack_require__(11);

var _ProfitTable = __webpack_require__(195);

var _ProfitTable2 = _interopRequireDefault(_ProfitTable);

var _commissionApi = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var data = function data() {
  return {
    loading: true,
    trData: [],
    is_selected: "0",
    searchVal: "",
    searchKey: "LOGIN",
    visible: false,
    more: false,
    filter: {
      deposit: "ALL",
      withdrawal: "ALL",
      transfer: "ALL"
    },
    account: {
      login: "",
      ib: "",
      percentage: "",
      date: ""
    },
    page: {
      active: 1,
      pageLeng: 0
    },
    selPage: {
      list: [5, 10, 25, 50],
      active: localStorage.pageMaxIndex,
      limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
    },
    operate: {
      btnGroup: true,
      updateVal: { do: 1, undo: 0, three: 2 },
      showKey: {
        1: ["IS_DELETED", "0"],
        0: ["IS_DELETED", "1"],
        2: ["IS_DELETED", "0"]
      },
      url: _commissionApi.URL_UPDATE_SETTING,
      updateKey: {
        "0": "IS_DELETED",
        "1": "IS_DELETED",
        backup: "NEXT_CALC_DATE"
      }
    }
  };
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var mounted = function mounted() {
  this.requestHandle();
};

var methods = {
  addAccount: function addAccount() {
    this.visible = true;
  },
  addAccountHandle: function addAccountHandle() {
    var _this = this;

    this.$refs.account.validate(function (valid) {
      if (valid) {
        var accountInfo = {
          area: _this.curArea,
          account: _this.account
        };
        accountInfo.account.update_by = JSON.parse(sessionStorage.getItem("user")).user_name;
        accountInfo.account.date = _this.$moment(_this.account.date).format("YYYY-MM-DD HH:mm:ss");
        _this.$http.post(_commissionApi.URL_ADD_ACCOUNT, accountInfo).then(function (res) {
          var result = res.data.data;
          _this.visible = false;
          _this.$refs.account.resetFields();
          var message = _this.accountSettingLan.code_mapping[result];
          var type = _this.accountSettingLan.message_type[result];
          _this.$message({ message: message, type: type });
          if (type == "success") _this.requestHandle();
        });
      }
    });
  },
  cancelSubmit: function cancelSubmit() {
    this.visible = false;
    this.$refs.account.resetFields();
  },
  changeHandle: function changeHandle() {
    this.page.active = 1;
    this.requestHandle();
  },
  requestHandle: function requestHandle() {
    var _this2 = this;

    try {
      var obj = {
        params: {
          status: this.is_selected,
          searchKey: this.searchKey,
          searchVal: this.searchVal,
          area: this.curArea,
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit,
          filter: this.filter
        }
      };
      this.$http.get(_commissionApi.URL_ACCOUNT_SETTING, obj).then(function (res) {
        _this2.trData = res.data.data.rows;
        _this2.page.pageLeng = res.data.data.count;
        _this2.loading = false;
        _this2.trData.forEach(function (t) {
          var mapping = _this2.accountSettingLan.enable_mapping;
          t.deposit = t.DEPOSIT ? mapping[t.DEPOSIT] : "";
          t.withdrawal = t.WITHDRAWAL ? mapping[t.WITHDRAWAL] : "";
          t.fundtransfer = t.FUNDTRANSFER ? mapping[t.FUNDTRANSFER] : "";
          t.is_negative_before = _this2.accountSettingLan.result_mapper[t.IS_NEGATIVE_BEFORE];
          t.is_deleted = _this2.accountSettingLan.status_mapper[t.IS_DELETED];
          t.LAST_UPDATE = (0, _util.updateTimeByUtc)((0, _util.getTimeDiff)(), t.LAST_UPDATE);
          t.checked = false;
        });
      });
    } catch (error) {
      this.loading = false;
    }
  },
  calculateHandle: function calculateHandle() {
    var _this3 = this;

    if (window.confirm(this.accountSettingLan.confirm)) {
      this.$http.post(_commissionApi.URL_BEGIN_CALCULATE, { area: this.curArea }).then(function (res) {
        var result = res.data.data;
        if (result == "SUCCESS") {
          _this3.$message({
            message: _this3.accountSettingLan.calculateDone,
            type: "success"
          });
          _this3.requestHandle();
        } else _this3.$message({
          message: _this3.accountSettingLan.noNeedCal,
          type: "warning"
        });
      });
    }
  }
};

var props = {
  curArea: {
    type: String,
    required: true
  }
};

var mixins = [__webpack_require__(3).base({ accountSettingLan: "accountSetting" })];

var computed = {
  thData: function thData() {
    return this.accountSettingLan.first_row;
  },
  jsonExcelAjax: function jsonExcelAjax() {
    return {
      url: _commissionApi.URL_ACCOUNT_SETTING,
      ajaxType: "get",
      getKey: ["data", "data", "rows"],
      ajaxPar: {
        pageSize: this.page.pageLeng,
        pageNum: 0,
        status: this.is_selected,
        searchKey: this.searchKey,
        searchVal: this.searchVal,
        area: this.curArea,
        filter: this.filter
      }
    };
  },
  downLoadTran: function downLoadTran() {
    var language = this.accountSettingLan;
    return {
      IS_DELETED: language.status_mapper,
      IS_NEGATIVE_BEFORE: language.result_mapper,
      DEPOSIT: language.enable_mapping,
      WITHDRAWAL: language.enable_mapping,
      FUNDTRANSFER: language.enable_mapping
    };
  },
  name: function name() {
    return this.accountSettingLan.title;
  }
};

var watch = {
  curArea: function curArea() {
    var _this4 = this;

    this.page.active = 1;
    this.searchKey = "LOGIN";
    this.searchVal = "";
    this.is_selected = "0";
    this.more = false;
    this.loading = true;
    (0, _keys2.default)(this.filter).forEach(function (v) {
      return _this4.filter[v] = "ALL";
    });
    this.requestHandle();
  },
  accountSettingLan: function accountSettingLan(newVal, oldVal) {
    var _this5 = this;

    this.trData.forEach(function (t) {
      var mapping = _this5.accountSettingLan.enable_mapping;
      t.deposit = t.DEPOSIT ? mapping[t.DEPOSIT] : "";
      t.withdrawal = t.WITHDRAWAL ? mapping[t.WITHDRAWAL] : "";
      t.fundtransfer = t.FUNDTRANSFER ? mapping[t.FUNDTRANSFER] : "";
      t.is_negative_before = newVal.result_mapper[t.IS_NEGATIVE_BEFORE];
      t.is_deleted = newVal.status_mapper[t.IS_DELETED];
    });
  }
};

var components = { ProfitTable: _ProfitTable2.default };

exports.default = {
  data: data,
  mounted: mounted,
  methods: methods,
  props: props,
  mixins: mixins,
  computed: computed,
  watch: watch,
  components: components
};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(11);

var _ProfitTable = __webpack_require__(195);

var _ProfitTable2 = _interopRequireDefault(_ProfitTable);

var _commissionApi = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var data = function data() {
  return {
    loading: false,
    trData: [],
    searchKey: "LOGIN",
    searchVal: "",
    idFrom: "",
    idTo: "",
    report_id_list: {},
    page: {
      active: 1,
      pageLeng: 0
    },
    selPage: {
      list: [5, 10, 25, 50],
      active: localStorage.pageMaxIndex,
      limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
    }
  };
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var mounted = function mounted() {
  var _this = this;

  this.$http.get(_commissionApi.URL_SHARE_REPORT, {
    params: { area: this.curArea, searchKey: "list" }
  }).then(function (res) {
    var list = res.data.data;
    if (list.length == 0) return;
    _this.idFrom = list[0].REPORT_ID;
    _this.idTo = list[0].REPORT_ID;
    list.forEach(function (v) {
      return _this.report_id_list[v.REPORT_ID] = v.REPORT_ID;
    });
    _this.requestHandle();
  }).catch(function (e) {
    return alert(e);
  });
};

var methods = {
  searchHandle: function searchHandle() {
    this.page.active = 1;
    this.requestHandle();
  },
  requestHandle: function requestHandle() {
    var _this2 = this;

    this.loading = true;
    var obj = {
      params: {
        searchKey: this.searchKey,
        searchVal: this.searchVal,
        idFrom: this.idFrom,
        idTo: this.idTo,
        area: this.curArea,
        pageNum: this.page.active - 1,
        pageSize: this.selPage.limit
      }
    };
    this.$http.get(_commissionApi.URL_SHARE_REPORT, obj).then(function (res) {
      _this2.trData = res.data.data.rows;
      _this2.page.pageLeng = res.data.data.count;
      _this2.loading = false;
    });
  }
};

var props = {
  curArea: {
    type: String,
    required: true
  }
};

var mixins = [__webpack_require__(3).base({ report: "profitShareReport" })];

var computed = {
  thData: function thData() {
    return this.report.first_row;
  },
  jsonExcelAjax: function jsonExcelAjax() {
    return {
      url: _commissionApi.URL_SHARE_REPORT,
      ajaxType: "get",
      getKey: ["data", "data", "rows"],
      ajaxPar: {
        pageSize: this.page.pageLeng,
        pageNum: 0,
        searchKey: this.searchKey,
        searchVal: this.searchVal,
        idFrom: this.idFrom,
        idTo: this.idTo,
        area: this.curArea
      }
    };
  },
  name: function name() {
    return this.report.title;
  }
};

var watch = {
  curArea: function curArea() {
    this.page.active = 1;
    this.ib_id = "";
    this.requestHandle();
  }
};

var components = { ProfitTable: _ProfitTable2.default };

exports.default = {
  data: data,
  mounted: mounted,
  methods: methods,
  props: props,
  mixins: mixins,
  computed: computed,
  watch: watch,
  components: components
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _crumbs = __webpack_require__(57);

var _crumbs2 = _interopRequireDefault(_crumbs);

var _uiv = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var data = function data() {
    return {
        curArea: sessionStorage.currentArea20 ? JSON.parse(sessionStorage.currentArea20).group : ''
    };
};

var mixins = [__webpack_require__(3).base({ profitShareViewLan: "profitShareView" })];

var beforeCreate = function beforeCreate() {
    var areaObj = sessionStorage.area20 ? JSON.parse(sessionStorage.area20) : "";
    var profitshare_area = sessionStorage.profitshare_area ? JSON.parse(sessionStorage.profitshare_area) : "";
    var storage = sessionStorage.currentArea20 || "{}";
    var currentArea20 = JSON.parse(storage);
    currentArea20.group = profitshare_area[0];
    currentArea20.value = areaObj[0];
    sessionStorage.currentArea20 = (0, _stringify2.default)(currentArea20);
};

var computed = {
    activePrimary: {
        get: function get() {
            return this.$route.path.slice(this.$route.path.lastIndexOf('/'));
        },
        set: function set() {}
    },
    profitshare_area: function profitshare_area() {
        return JSON.parse(sessionStorage.profitshare_area);
    }
};

var methods = {
    areaGroupSwitchFn: function areaGroupSwitchFn(key) {
        this.curArea = key;
        var currentArea20 = JSON.parse(sessionStorage.currentArea20);
        currentArea20.group = key;
        sessionStorage.currentArea20 = (0, _stringify2.default)(currentArea20);
    },
    jump: function jump(link) {
        sessionStorage.removeItem('back');
        this.$router.push(link);
        this.activePrimary = link;
    }
};

var components = { crumbs: _crumbs2.default, BtnGroup: _uiv.BtnGroup, Btn: _uiv.Btn, Dropdown: _uiv.Dropdown };

exports.default = {
    name: "profitShareView",
    data: data,
    beforeCreate: beforeCreate,
    mixins: mixins,
    computed: computed,
    methods: methods,
    components: components
};

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _selPage = __webpack_require__(82);

var _selPage2 = _interopRequireDefault(_selPage);

var _noData = __webpack_require__(64);

var _noData2 = _interopRequireDefault(_noData);

var _uiv = __webpack_require__(14);

var _excel = __webpack_require__(1056);

var _excel2 = _interopRequireDefault(_excel);

var _multiSheetExcel = __webpack_require__(998);

var _multiSheetExcel2 = _interopRequireDefault(_multiSheetExcel);

var _vuex = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    thData: {
      // 表格th数据
      type: Array,
      default: []
    },
    firstTh: {
      type: Object,
      default: function _default() {}
    },
    secondTh: {
      type: Object,
      default: function _default() {}
    },
    detailTh: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    trData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    operate: {
      default: false
    },
    link: {
      default: false
    },
    tip: {
      default: false
    },
    multiLanguage: {
      // 翻译，也是文字型数据
      type: Object,
      default: {}
    },
    selPage: {
      // 显示条目数
      default: false
    },
    page: {
      // 分页
      default: false
    },
    jsonExcelAjax: {
      // 下载Excel
      default: false
    },
    name: {
      default: ""
    },
    detailName: {
      defalut: ""
    },
    detailExcelAjax: {
      default: false
    },
    multiExcelAjax: {
      default: false
    },
    back: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    downLoadTran: {
      type: Object,
      default: function _default() {}
    },
    curArea: {
      defalut: ""
    }
  },
  data: function data() {
    return {
      checkedArr: [],
      isIndeterminate: false,
      selectAll: false,
      trSize: 0,
      selectData: [],
      mapObj: {},
      doConfirm: true,
      undoConfirm: true,
      threeConfirm: true,
      visible: false,
      timePicker: "",
      pickerOption: {
        disabledDate: function disabledDate() {}
      }
    };
  },
  mounted: function mounted() {
    if (this.selPage && !this.selPage.active) this.$parent.selPage.active = 0;
    var obj = this.operate.updateVal;
    if (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) this.mapObj[obj[key]] = key + "Confirm";
      }
    }
  },

  methods: (0, _extends3.default)({
    confirmHandle: function confirmHandle(value) {
      var _this = this;

      if (this.checkedArr.length > 0) {
        if (value == 0) this.visible = true;
        if (value == 1) this.updateStatus(value);
        if (value == 2) this.dateHandle();
        return;
      }
      var show = this.operate.showKey[value];
      var key = this.mapObj[value];
      this[key] = !this[key];
      this.trData.forEach(function (val) {
        if (_this[key]) val.show = false;else val.show = val[show[0]] == show[1];
        if (val.show) {
          _this.trSize++;
          _this.selectData.push(val);
        }
      });
      if (this.doConfirm && this.undoConfirm && this.threeConfirm) {
        this.trSize = 0;
        this.selectData = [];
      }
    },
    confirmDateHandle: function confirmDateHandle() {
      if (!this.timePicker) {
        this.$message({
          message: this.multiLanguage.required,
          type: "warning"
        });
        return;
      }
      var updateVal = this.$moment(this.timePicker).format("YYYY-MM-DD HH:mm:ss");
      this.undoConfirm ? this.updateStatus(updateVal) : this.updateStatus(0, updateVal);
    },
    dateHandle: function dateHandle() {
      var _this2 = this;

      this.visible = true;
      var validTime = { start: "1970-01-01", end: "" };
      var yesterday = this.$moment().subtract(1, "d");
      var eightYesterday = yesterday.format("YYYY-MM-DD") + " 08:00:00";
      var passEight = yesterday.isAfter(eightYesterday);
      validTime.end = passEight ? yesterday.format("YYYY-MM-DD") : yesterday.subtract(1, "d").format("YYYY-MM-DD");
      this.checkedArr.forEach(function (v) {
        var endDate = v.LAST_CALC_END_DATE || v.APPLICATION_DATE;
        var dateMoment = _this2.$moment(endDate);
        if (!dateMoment.isAfter(validTime.start)) return;
        validTime.start = v.LAST_CALC_END_DATE ? dateMoment.format("YYYY-MM-DD") : dateMoment.subtract(1, "d").format("YYYY-MM-DD");
      });
      this.pickerOption.disabledDate = function (time) {
        return time.getTime() > new Date(validTime.end) || time.getTime() < new Date(validTime.start);
      };
    },
    updateStatus: function updateStatus(value, options) {
      var _this3 = this;

      if (window.confirm(this.multiLanguage.commit)) {
        var ajaxObj = { area: this.curArea, data: this.checkedArr };

        var updateMap = this.operate.updateKey;
        if (updateMap) {
          // 找不到需要更新的字段，则使用备用的字段
          var updateKey = updateMap[value] || updateMap.backup;
          ajaxObj.update_key = updateKey;
          ajaxObj.value = value;
          ajaxObj.update_by = JSON.parse(sessionStorage.getItem("user")).user_name;
        }

        if (options) ajaxObj.bind_date = options;

        this.checkedArr = [];
        this.$http.post(this.operate.url, ajaxObj).then(function (res) {
          _this3.trSize = 0;
          _this3.selectData = [];
          _this3.isIndeterminate = false;
          _this3.visible = false;
          var key = _this3.mapObj[value] || "threeConfirm";
          _this3[key] = !_this3[key];
          _this3.$emit("tableChange");
        });
      } else return false;
    },
    checkAll: function checkAll(val) {
      this.checkedArr = val ? this.selectData.slice() : [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.trData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var v = _step.value;
          v.checked = val;
        } //console.log(this.checkedArr.length)
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.isIndeterminate = false;
    },
    updateCheckArr: function updateCheckArr(checkObj) {
      if (this.checkedArr.indexOf(checkObj) > -1) this.checkedArr.splice(this.checkedArr.indexOf(checkObj), 1);else this.checkedArr.push(checkObj);
      this.selectAll = this.checkedArr.length === this.trSize;
      this.isIndeterminate = this.checkedArr.length > 0 && this.checkedArr.length < this.trSize;
    },
    selPageFn: function selPageFn(index, item) {
      this.SAVEPAGEMAXINDEX(index);
      this.$parent.selPage.active = index;
      this.$parent.selPage.limit = this.selPage.list[this.selPage.active];
      this.$parent.page.offset = 0;
      this.pageactive = 1;
      this.$parent.page.active = 1;
      this.$emit("tableChange");
    },
    callpageFn: function callpageFn(index) {
      this.$parent.page.active = index;
      this.$parent.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : "";
      this.$emit("tableChange");
    },
    linkDetails: function linkDetails(item) {
      if (this.back !== "") {
        sessionStorage.setItem("back", this.back);
      }
      this.$router.push({
        path: this.link.path,
        query: item
      });
    }
  }, (0, _vuex.mapMutations)(["SAVEPAGEMAXINDEX"])),
  watch: {
    trData: function trData(newVal, oldVal) {
      var _this4 = this;

      this.selectAll = false;
      this.isIndeterminate = false;
      this.trSize = 0;
      this.selectData = [];
      this.checkedArr = [];
      var show = this.operate.showKey;
      if (this.operate) {
        newVal.forEach(function (v) {
          if (_this4.operate.btnGroup) {
            if (_this4.doConfirm && _this4.undoConfirm && _this4.threeConfirm) v.show = false;else v.show = _this4.doConfirm && _this4.threeConfirm ? v[show[0][0]] == show[0][1] : v[show[1][0]] == show[1][1];
          }
          if (_this4.operate.btn) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = (0, _getIterator3.default)(show), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var condition = _step2.value;

                if (v[condition.key] == condition.value) v.show = true;
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
          if (v.show) {
            _this4.trSize++;
            _this4.selectData.push(v);
          }
        });
      }
    }
  },
  components: {
    selPage: _selPage2.default,
    Dropdown: _uiv.Dropdown,
    Pagination: _uiv.Pagination,
    jsonExcel: _excel2.default,
    multiSheetExcel: _multiSheetExcel2.default,
    noData: _noData2.default
  }
};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProfitTable = __webpack_require__(195);

var _ProfitTable2 = _interopRequireDefault(_ProfitTable);

var _commissionApi = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var data = function data() {
  return {
    loading: false,
    trData: [],
    searchKey: 'LOGIN',
    searchVal: '',
    report_id: '',
    report_id_list: {},
    page: {
      active: 1,
      pageLeng: 0
    },
    selPage: {
      list: [5, 10, 25, 50],
      active: localStorage.pageMaxIndex,
      limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
    },
    operate: {
      btn: true,
      showKey: [{ key: 'IS_DELETED', value: 0 }],
      url: _commissionApi.URL_VERSION_BACK
    }
  };
};

var mounted = function mounted() {
  this.requestHandle();
};

var methods = {
  requestHandle: function requestHandle() {
    var _this = this;

    this.loading = true;
    var obj = {
      params: {
        area: this.curArea,
        searchKey: this.searchKey,
        searchVal: this.searchVal,
        pageNum: this.page.active - 1,
        pageSize: this.selPage.limit
      }
    };
    this.$http.get(_commissionApi.URL_SHARE_VERSION, obj).then(function (res) {
      _this.trData = res.data.data.rows;
      _this.page.pageLeng = res.data.data.count;
      _this.loading = false;
      _this.trData.forEach(function (t) {
        t.is_deleted = _this.version.status_mapper[t.IS_DELETED];
      });
    });
  }
};

var props = {
  curArea: {
    type: String,
    required: true
  }
};

var mixins = [__webpack_require__(3).base({ version: "versionReport" })];

var computed = {
  thData: function thData() {
    return this.version.first_row;
  }
};

var watch = {
  curArea: function curArea() {
    this.page.active = 1;
    this.ib_id = '';
    this.requestHandle();
  },
  version: function version(newVal, oldVal) {
    this.trData.forEach(function (t) {
      t.is_negative_before = newVal.result_mapper[t.IS_NEGATIVE_BEFORE];
      t.is_deleted = newVal.status_mapper[t.IS_DELETED];
    });
  }
};

var components = { ProfitTable: _ProfitTable2.default };

exports.default = {
  data: data,
  mounted: mounted,
  methods: methods,
  props: props,
  mixins: mixins,
  computed: computed,
  watch: watch,
  components: components
};

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _util = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      data: []
    };
  },

  props: {
    name: {
      type: String,
      default: "下載"
    },
    rID: {
      default: ""
    },
    cID: {
      default: ""
    },
    type: {
      default: ""
    },
    keys: {
      default: Array
    },
    ajaxUrl: {
      default: false
    },
    ajaxGetKey: {
      default: false
    },
    ajaxPar: {
      default: {}
    },
    ajaxType: {
      default: "get"
    },
    colData: {
      default: false
    },
    downLoadTran: {
      type: Object,
      default: function _default() {}
    }
  },
  methods: {
    getHeadKeyOrName: function getHeadKeyOrName(type) {
      var arr = [];
      this.keys.forEach(function (item) {
        if ((item.flag === undefined || item.flag) && (item.unneed === undefined || item.unneed)) {
          arr.push(item[type]);
        }
      });
      return arr;
    },
    generate_excel: function generate_excel() {
      var _this = this;

      var curArea = JSON.parse(sessionStorage.getItem('currentArea20'));
      var rID = this.rID ? ' ' + this.rID : '';
      var cID = this.cID ? ' ' + this.cID : '';
      var typeStr = this.type ? ' ' + this.type : '';
      var downLoadName = curArea.group + ' ' + this.name + rID + cID + typeStr;

      var ajaxPar = this.ajaxType === "post" ? this.ajaxPar : { params: this.ajaxPar };
      this.$http[this.ajaxType](this.ajaxUrl, ajaxPar).then(function (res) {
        var getVal = function getVal(obj, arr) {
          if (arr.length > 1) {
            return getVal(obj[arr[0]], arr.slice(1));
          } else {
            return obj[arr[0]];
          }
        };
        _this.data = getVal(res, _this.ajaxGetKey);
        _this.export2Excel(_this.resolveData(_this.data), downLoadName);
      });
    },
    export2Excel: function export2Excel(excelData, excelName) {
      var _this2 = this;

      new Promise(function(resolve) { resolve(); }).then((function () {
        var _require = __webpack_require__(65),
            export_json_to_excel = _require.export_json_to_excel;

        var tHeader = _this2.getHeadKeyOrName('name');
        var filterVal = _this2.getHeadKeyOrName('key');
        var list = excelData;
        var data = _this2.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, excelName);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    resolveData: function resolveData(data) {
      var arr = [];
      if (Array.isArray(data[0])) {
        // 后台数据格式[[{},{}],[{},{}]...]
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var array = _step.value;

            this.traverse(arr, array);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        // 后台数据格式[{},{},{}...]
        this.traverse(arr, data);
      }
      return arr;
    },
    traverse: function traverse(arr, data) {
      for (var i in data) {
        var v = data[i];
        var obj = {};
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(this.keys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            // 如果头部有flag并且设置了flag为false 或者 有unneed并且设置了unneed为false,则不取值
            if (item.flag !== undefined && !item.flag || item.unneed !== undefined && !item.unneed) continue;
            // 头部键需要转大写的转大写取值
            var tempKey = item.upper === undefined || item.upper ? item.key.toUpperCase() : item.key;
            // 如果头部有utcTime并且为true,则转换时间格式,时区不变
            if (item.utcTime != undefined && item.utcTime) {
              obj[item.key] = v[tempKey] ? (0, _util.formatDate)(v[tempKey]) : '';
              continue;
            }
            // 如果头部有changeTime并且为true,则转换对应时区时间
            if (item.changeTime != undefined && item.changeTime) {
              obj[item.key] = v[tempKey] ? (0, _util.updateTimeByUtc)((0, _util.getTimeDiff)(), v[tempKey]) : '';
              continue;
            }
            // 下载翻译对象不存在或者对象不存在此键,则直接取后台返回的值,否则取翻译对象中的值
            if (this.downLoadTran === undefined || !this.downLoadTran[tempKey]) {
              obj[item.key] = v[tempKey] || v[tempKey] == 0 ? v[tempKey] : '';
              continue;
            }
            var temp = this.downLoadTran[tempKey][v[tempKey]];
            // 翻译对象通过键取值的对象中有part属性,则给此列数据最后一个做翻译,此列其余数据取后台返回的数据
            if (!this.downLoadTran[tempKey].part) {
              obj[item.key] = temp || temp == 0 ? temp : "";
              continue;
            }
            if (i >= data.length - this.downLoadTran[tempKey].index) {
              obj[item.key] = temp || temp == 0 ? temp : "";
              continue;
            }
            obj[item.key] = v[tempKey] || v[tempKey] == 0 ? v[tempKey] : '';
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        arr.push(obj);
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _crumbs = __webpack_require__(57);

var _crumbs2 = _interopRequireDefault(_crumbs);

var _api = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var MtablePar = {
  handle: { //  操作中间几个按钮
    link: "authOption", // 跳转路由
    idKey: "Role_ID", // 跳转路由传id的key值
    delete: true, // 设置有删除功能
    deleteUrl: _api.URL_USERDELETE, // 删除接口
    deleteKey: "Role_ID" // 删除接口查询的key值
  }
};

exports.default = {
  name: "authList",
  mixins: [__webpack_require__(3).base({ registerLan: "authOption" }), __webpack_require__(3).base({ multiLanguage: "tableModelAuthList" }), __webpack_require__(590).AuthMtable(MtablePar)],
  data: function data() {
    return {
      trData: "", //  表格tr数据 
      handle: { //  操作中间几个按钮
        link: "authOption", // 跳转路由
        idKey: "Role_ID", // 跳转路由传id的key值
        delete: true, // 设置有删除功能
        deleteKey: "user_id" // 删除接口查询的key值
      }
    };
  },
  mounted: function mounted() {
    this.seekDropdown && (this.seekDropdown.seekStr = "");
  },

  computed: {
    thData: function thData() {
      // 表格th数据
      return [this.multiLanguage.th.Role_ID, this.multiLanguage.th.Desc];
    }
  },
  methods: {
    tableAjax: function tableAjax() {
      var _this = this;

      //获取数据
      this.$http(_api.URL_FINDALLROLE).then(function (res) {
        var data = res.data.data;
        _this.trData = data;
      });
    },
    deleteList: function deleteList(list) {
      var _this2 = this;

      if (list.length == 0) {
        return;
      }
      this.$http.post(_api.URL_DELETEROLE, {
        "role": list
      }).then(function (res) {
        if (res.data.code == 400) {
          //TODO 翻译
          _this2.$message.error(_this2.registerLan.submitResult.role_error);
        } else {
          _this2.tableAjax();
        }
      });
    }
  },
  components: {
    crumbs: _crumbs2.default
  }
};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _crumbs = __webpack_require__(57);

var _crumbs2 = _interopRequireDefault(_crumbs);

var _mimput = __webpack_require__(193);

var _mimput2 = _interopRequireDefault(_mimput);

var _api = __webpack_require__(40);

var _menuAllList = __webpack_require__(105);

var _menuAllList2 = _interopRequireDefault(_menuAllList);

var _authList = __webpack_require__(991);

var _authList2 = _interopRequireDefault(_authList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "authOption",
  mixins: [__webpack_require__(3).base({ registerLan: "authOption" }), __webpack_require__(3).base({ sidebarLan: "sidebarList" }), __webpack_require__(206).validate(), __webpack_require__(106).modal()],
  data: function data() {
    return {
      actionType: this.$route.query.id || this.$route.query.id == 0 ? "change" : "reg",
      selectBool: false,
      sidebarListLink: _menuAllList2.default
    };
  },

  computed: {
    auth_data: function auth_data() {
      var _auth_list = [];
      this.$route.query.data.forEach(function (item) {
        _auth_list.push({
          right_id: item.split("$")[0],
          entity: item.split("$")[1].split("/")
        });
      });
      return _auth_list;
    },
    lang_data: function lang_data() {
      var _lang_data = [];
      for (var key in this.sidebarListLink) {
        if (this.sidebarLan[key].text) {
          _lang_data.push({
            right_id: this.sidebarListLink[key].Role_ID,
            text: this.sidebarLan[key].text
          });
        } else {
          console.log("请在文件中配置该菜单");
        }
      }
      return _lang_data;
    }
  },
  methods: {
    setCheckedNodes: function setCheckedNodes() {
      //全选
      if (!this.selectBool) {
        this.$refs.tree.Check_All();
        this.selectBool = true;
      } else {
        this.$refs.tree.Clear_All(); //清空
        this.selectBool = false;
      }
    },
    submitFn: function submitFn() {
      var _this = this;

      var _data = this.$refs.tree.Get_Data();
      //TODO
      this.$http.post(_api.URL_SAVEPRIVILEGE, { "role": this.$route.query.Role_ID, "prioritys": _data }).then(function (res) {
        if (res.data.code == '200') {
          _this.modalLink = "/authList";
          _this.modalBool = true;
          _data.forEach(function (item) {
            item.entity = item.entity.join("/");
          });
          sessionStorage.rightObject = (0, _stringify2.default)(_data);
          // TODO menulList 逐渐废弃使用
          // 以下代码段，逐渐废弃
          // BEGIN
          var _right_list = [];
          _data.forEach(function (item) {
            _right_list.push(item.right_id);
          });
          sessionStorage.menuList = (0, _stringify2.default)(_right_list);
          // END
          // 如果Role_ID和当前用户的purview相同，那么进行初始化，否则不进行
          if (JSON.parse(sessionStorage.user).purview == _this.$route.query.Role_ID) {
            _this.SIDEBARVUE.Init_SideBar();
          }
        } else if (res.data.code == '0') {
          _this.user_id_point = true;
        }
        _this.modalShow = true;
      });
    },
    selectChange: function selectChange(key) {
      this[key] = event.target.value;
    },
    resetData: function resetData() {
      this.$refs.tree.Reset_Data();
    }
  },
  components: {
    crumbs: _crumbs2.default,
    mimput: _mimput2.default,
    authList: _authList2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _crumbs = __webpack_require__(57);

var _crumbs2 = _interopRequireDefault(_crumbs);

var _mimput = __webpack_require__(193);

var _mimput2 = _interopRequireDefault(_mimput);

var _api = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "changepswd",
  mixins: [__webpack_require__(3).base({ sidebarListLan: "sidebarList" }), __webpack_require__(106).modal()],
  data: function data() {
    return {
      fromVal: {
        oldpaswd: "",
        newpaswd: "",
        okpaswd: ""
      },
      modalBool: false,
      user: JSON.parse(sessionStorage.user)
    };
  },
  mounted: function mounted() {
    this.$refs.user_name.disabled = true;
  },

  methods: {
    changeOk: function changeOk() {
      var _this = this;

      //确认修改前，判断所有的框是否都已校验成功
      this.$validator.validateAll().then(function (result) {
        if (result) {
          //校验成功
          var that = _this;
          //              let uid = JSON.parse(sessionStorage.user).user_id
          //发送请求
          that.$http.post(_api.URL_CHANGEPWD, { //   server +'user/changemsg'
            newpasswd: that.fromVal.newpaswd, //新密码
            oldpasswd: that.fromVal.oldpaswd
          }).then(function (res) {
            var data = res.data;
            if (data.code == 460) {
              _this.modalBool = false;
            } else {

              _this.modalBool = true;
              //                  that.$router.push({
              //                    path: "accountList"
              //                  });
            }
            _this.modalShow = true;
          });
        } else {
          _this.modalShow = true;
        }
      });
    }
  },
  components: {
    crumbs: _crumbs2.default,
    mimput: _mimput2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(40);

var _crumbs = __webpack_require__(57);

var _crumbs2 = _interopRequireDefault(_crumbs);

var _mtable = __webpack_require__(418);

var _mtable2 = _interopRequireDefault(_mtable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @clickCol="clickCol"
// :trCls="(item) => { return getaccType(item.acc_type) != 'CL' ? 'pointer' : '' }"
exports.default = {
  name: "loginSalePlatform",
  mixins: [__webpack_require__(3).base({ multiLanguage: "tableModel" })],
  data: function data() {
    return {
      allType: [],
      checkboxs: [{
        name: "UN",
        bool: false
      }, {
        name: "C",
        bool: false
      }, {
        name: "N",
        bool: false
      }, {
        name: "R",
        bool: false
      }, {
        name: "O",
        bool: false
      }, {
        name: "M",
        bool: false
      }, {
        name: "SL",
        bool: false
      }, {
        name: "IB",
        bool: false
      }, {
        name: "CL",
        bool: false
      }],
      trData: [],
      sort: { // 排序
        key: "node_id",
        method: "ASC"
      },
      seekDropdown: { // 搜索选项
        list: {
          loginId: "node_id"
        },
        active: "loginId",
        seekStr: ""
      },
      seekDatePicker: {
        startDate: this.$moment().subtract(1, "days").format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD")
      },
      jsonExcelAjax: {},
      usersType: [],
      path: [],
      apply: false
    };
  },
  mounted: function mounted() {},

  computed: {
    thData: function thData() {
      // 表格th数据
      return [this.multiLanguage.th.loginId, this.multiLanguage.th.accountName, this.multiLanguage.th.loginType.name, this.multiLanguage.th.mt4_sync_deposits_sum, this.multiLanguage.th.mt4_sync_withdrawal_sum, this.multiLanguage.th.balance2, this.multiLanguage.th.balance, this.multiLanguage.th.volume_sum, this.multiLanguage.th.newAgentCount, this.multiLanguage.th.newClientCount];
    }
  },
  methods: {
    toggle: function toggle(item) {
      item.bool = !item.bool;
    },
    clickCol: function clickCol(colItem, index) {
      if (this.usersType[index] !== "CL") {
        this.path.indexOf(colItem.sales_id) == -1 && this.path.push(colItem.sales_id);
        this.tableAjax(this.path[this.path.length - 1]);
      }
    },
    goPath: function goPath(path) {
      var index = path != -1 ? this.path.indexOf(path) + 1 : -1;
      this.path = this.path.slice(0, index);
      this.tableAjax(this.path[this.path.length - 1]);
    },
    tableAjax: function tableAjax() {
      var node_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      var _this = this;

      var searchKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var nodeIdType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      var startDate = this.seekDatePicker.startDate + " 00:00:00";
      var endDate = this.seekDatePicker.endDate + " 23:59:59";
      searchKeys = this.seekDropdown.seekStr;

      nodeIdType = this.allType;
      this.$http.post(_api.POSITIONS_SEARCH, { nodeIdType: nodeIdType, node_id: node_id, searchKeys: searchKeys, startDate: startDate, endDate: endDate }).then(function (res) {
        var data = res.data.data;
        if (res.data.code === 200) {
          _this.apply = res.data.data.apply;
          var dataList = [];
          _this.usersType = [];
          data.sales = data.sales ? data.sales : [];
          data.sales.forEach(function (item) {
            _this.usersType.push(item.acc_type);
            dataList.push({
              sales_id: _this.defaultVal(item.node_id),
              acc_name: _this.defaultVal(item.name),
              acc_type: _this.defaultVal(_this.setaccType(item.acc_type)),
              mt4_sync_deposits_sum: _this.defaultVal(item.mt4_sync_deposits_sum),
              mt4_sync_withdrawals_sum: _this.defaultVal(item.mt4_sync_withdrawals_sum),
              margin: _this.defaultVal((item.mt4_sync_deposits_sum || 0) + (item.mt4_sync_withdrawals_sum || 0)),
              balance: _this.defaultVal(item.balance),
              volume_sum: _this.defaultVal(item.volume_sum),
              newAgentCount: _this.defaultVal(item.agentcount),
              newClientCount: _this.defaultVal(item.clientcount)
            });
          });
          _this.trData = dataList;
        } else {
          _this.trData = [];
        }
      });
    },
    defaultVal: function defaultVal(val) {
      if ((val || val == 0) && Object.prototype.toString.call(val) === "[object Number]") {
        return (/\./.test(val) ? parseFloat(val.toFixed(2)) : val
        );
      } else if (val || val == 0) {
        return val;
      } else {
        return 0;
      }
    },
    setaccType: function setaccType(acc_type) {
      switch (acc_type) {
        case "UN":
          return this.multiLanguage.th.loginType.typeArr[0].text;
        case "C":
          return this.multiLanguage.th.loginType.typeArr[1].text;
        case "N":
          return this.multiLanguage.th.loginType.typeArr[2].text;
        case "R":
          return this.multiLanguage.th.loginType.typeArr[3].text;
        case "O":
          return this.multiLanguage.th.loginType.typeArr[4].text;
        case "M":
          return this.multiLanguage.th.loginType.typeArr[5].text;
        case "SL":
          return this.multiLanguage.th.loginType.typeArr[6].text;
        case "IB":
          return this.multiLanguage.th.loginType.typeArr[7].text;
        case "CL":
          return this.multiLanguage.th.loginType.typeArr[8].text;
        default:
          return acc_type;
      }
    },
    getaccType: function getaccType(acc_type) {
      switch (acc_type) {
        case this.multiLanguage.th.loginType.typeArr[0].text:
          return "UN";
        case this.multiLanguage.th.loginType.typeArr[1].text:
          return "C";
        case this.multiLanguage.th.loginType.typeArr[2].text:
          return "N";
        case this.multiLanguage.th.loginType.typeArr[3].text:
          return "R";
        case this.multiLanguage.th.loginType.typeArr[4].text:
          return "O";
        case this.multiLanguage.th.loginType.typeArr[5].text:
          return "M";
        case this.multiLanguage.th.loginType.typeArr[6].text:
          return "SL";
        case this.multiLanguage.th.loginType.typeArr[7].text:
          return "IB";
        case this.multiLanguage.th.loginType.typeArr[8].text:
          return "CL";
        default:
          return acc_type;
      }
    }
  },
  watch: {
    trData: function trData(curVal, oldVal) {
      this.jsonExcelAjax.colData = curVal;
    }
  },
  components: {
    mtable: _mtable2.default,
    crumbs: _crumbs2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(83);

var _promise2 = _interopRequireDefault(_promise);

var _api = __webpack_require__(40);

var _commissionApi = __webpack_require__(7);

var _menuAllList = __webpack_require__(105);

var _menuAllList2 = _interopRequireDefault(_menuAllList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "login",
  mixins: [__webpack_require__(3).base({ loginLan: "login" }), __webpack_require__(106).modal()],
  data: function data() {
    return {
      link: this.$route.query.link ? this.$route.query.link : '',
      fromValue: {
        name: "",
        password: ""
      },
      languageSelList: {
        cn: "简体中文",
        hk: "繁體中文",
        en: "English"
      },
      languageSelActive: localStorage.language || "cn"
    };
  },
  mounted: function mounted() {
    sessionStorage.setItem('UTCDIFF', new String(-new Date().getTimezoneOffset() / 60));
  },

  methods: {
    loginFn: function loginFn() {
      var _this = this;

      var p1 = this.$http.post(_api.URL_SINGIN, { name: this.fromValue.name, password: this.fromValue.password });
      // let p2 = this.$http.post(URL_commissionLogin,{name:this.fromValue.name,password:this.fromValue.password})
      var p3 = this.$http.post(_commissionApi.URL_commissionLogin20, { name: this.fromValue.name, password: this.fromValue.password });
      _promise2.default.all([p1, p3]).then(function (res) {
        var resJson = res[0]['data'];
        if (resJson && resJson['code'] == 200 && resJson['data']) {
          var user = resJson['data'];
          sessionStorage.user = (0, _stringify2.default)(user);
          _this.SAVEUSER((0, _stringify2.default)(user));
          // var link = (user.purview == "admin")?"/userList":"/accountList";
          var privilege_request = _this.$http.post(_api.URL_FINDALLPRIVILEGE, { "role": user.purview });
          _promise2.default.all([privilege_request]).then(function (res) {
            var resJson1 = res[0]['data'];
            var _role_id = [];
            resJson1.data.forEach(function (item) {
              _role_id.push(item.right_id);
            });
            if (resJson1 && resJson1['code'] == 200 && resJson1['data']) {
              sessionStorage.menuList = (0, _stringify2.default)(_role_id);
              sessionStorage.rightObject = (0, _stringify2.default)(resJson1['data']);
              var link = '';

              var _loop = function _loop(key) {
                var role_id = _menuAllList2.default[key].Role_ID;
                var index = _role_id.findIndex(function (element) {
                  return element.toString() === role_id.toString();
                });
                if (index > -1) {
                  link = _menuAllList2.default[key].link;
                  return 'break';
                }
              };

              for (var key in _menuAllList2.default) {
                var _ret = _loop(key);

                if (_ret === 'break') break;
              }
              if (_this.link) link = _this.link;
              // else link = (user.purview == "admin")?"/userList":"/accountList"; // 暂时关闭 登录去用户列表或者账户列表
              // else link = '/ib/ibSetting' // 暂时 登录去佣金设定页面
              _this.$router.push({
                path: link
              });
            }
          });
        } else {
          //TODO  友好提示
          _this.modalShow = true;
        }
        // let area = res[1].data.data.area
        // sessionStorage.area = JSON.stringify(area)
        var area20 = res[1].data.data.area;
        var profitshare_area = res[1].data.data.profitshare_area;
        sessionStorage.area20 = (0, _stringify2.default)(area20);
        sessionStorage.profitshare_area = (0, _stringify2.default)(profitshare_area);

        // let currentArea = {
        //   group: Object.keys(area)[0],
        //   value: area[Object.keys(area)[0]][0]
        // }
        // sessionStorage.currentArea = JSON.stringify(currentArea)
        var currentArea20 = {
          group: profitshare_area[0],
          value: area20[0]
        };
        sessionStorage.currentArea20 = (0, _stringify2.default)(currentArea20);
      });
    }
  },
  watch: {
    languageSelActive: function languageSelActive(curVal, oldVal) {
      this.SAVELANGUAGE(curVal);
    }
  }
};

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(995);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(997);

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "",
  mounted: function mounted() {},

  components: {
    mheader: _header2.default,
    sidebar: _sidebar2.default
  }
};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _crumbs = __webpack_require__(57);

var _crumbs2 = _interopRequireDefault(_crumbs);

var _mimput = __webpack_require__(193);

var _mimput2 = _interopRequireDefault(_mimput);

var _api = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "userDatum",
  mixins: [__webpack_require__(3).base({ registerLan: "userDatum" }), __webpack_require__(206).validate(), __webpack_require__(106).modal()],
  data: function data() {
    return {
      actionType: this.$route.query.id || this.$route.query.id == 0 ? "change" : "reg",
      jurisdictions: [],
      jurisdictionActive: "customer_service",
      formMsgArr: {
        sales_id: '',
        user_name: '',
        password: '',
        phone: '',
        remark: '',
        email: ''
      },
      user_id_point: false, //注册账号重复的提示
      user_name_point: false, //注册账号名重复的提示
      is_repeat_email: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.pegeInit();
    this.getAllRole();
    this.$refs.sales_id.disabled = this.actionType == "reg" ? false : true;
    this.$refs.user_name.disabled = this.actionType == "reg" ? false : true;
    setTimeout(function () {
      _this.$refs.user_name.value = " ";
    });
  },

  methods: {
    validate_email: function validate_email(event) {
      var _this2 = this;

      this.$http.post(_api.URL_FINDUSER_BYEMAIL, { email: event.target.value }).then(function (res) {
        var data = res.data;
        _this2.is_repeat_email = false;
        if (data) {
          _this2.is_repeat_email = true;
        }
      });
    },
    pegeInit: function pegeInit() {
      var _this3 = this;

      if (this.actionType == "change") {
        //用户保存修改操作.
        var oId = this.$route.query.id;
        var userdata = { user_id: oId };
        this.$http.post(_api.URL_FINDUSERID, userdata).then(function (res) {
          var data = res.data;
          _this3.formMsgArr.sales_id = oId;
          _this3.formMsgArr.user_name = data.user_name;
          _this3.formMsgArr.phone = data.phone;
          _this3.formMsgArr.email = data.email;
          _this3.formMsgArr.remark = data.remark;
          _this3.jurisdictionActive = data.purview;
        });
      }
    },
    submitFn: function submitFn() {
      var _this4 = this;

      this.$validator.validateAll().then(function (result) {
        if (_this4.is_repeat_email) return;
        if (result) {
          _this4.$http.post(_this4.actionType == "change" ? _api.URL_UPDATEUSER : _api.URL_CREATEUSER, {
            type: _this4.actionType,
            user_id: _this4.formMsgArr.sales_id,
            password: _this4.formMsgArr.password,
            user_name: _this4.formMsgArr.user_name,
            phone: _this4.formMsgArr.phone,
            remark: _this4.formMsgArr.remark,
            email: _this4.formMsgArr.email,
            purview: _this4.jurisdictionActive
          }).then(function (res) {
            if (res.data.code == '200') {
              _this4.modalLink = "/userList";
              _this4.modalBool = true;
            } else if (res.data.code == '401') {
              _this4.user_id_point = true;
            } else if (res.data.code == '402') {
              _this4.user_name_point = true;
            }
            _this4.modalShow = true;
          });
        } else {
          _this4.modalShow = true;
        }
      });
    },
    selectChange: function selectChange(key) {
      this.getAllRole();
      this[key] = event.target.value;
    },
    getAllRole: function getAllRole() {
      var _this5 = this;

      this.jurisdictions = [];
      this.$http.get(_api.URL_FINDALLROLE).then(function (res) {
        var roles = res.data.data;
        roles.forEach(function (role) {
          _this5.jurisdictions.push(role["Role_ID"]);
        });
      });
    }
  },
  watch: {
    'formMsgArr.sales_id': function formMsgArrSales_id(curVal, oldVal) {
      this.user_id_point = false;
    },
    'formMsgArr.user_name': function formMsgArrUser_name(curVal, oldVal) {
      this.user_name_point = false;
    }
  },
  components: {
    crumbs: _crumbs2.default,
    mimput: _mimput2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(40);

var _crumbs = __webpack_require__(57);

var _crumbs2 = _interopRequireDefault(_crumbs);

var _mtable = __webpack_require__(418);

var _mtable2 = _interopRequireDefault(_mtable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "userList",
  mixins: [__webpack_require__(3).base({ multiLanguage: "tableModelUserList" })],
  data: function data() {
    return {
      trData: "", //  表格tr数据 
      sort: { // 排序
        key: "user_id",
        method: "ASC"
      },
      handle: { //  操作中间几个按钮
        link: "userDatum", // 跳转路由
        idKey: "user_id", // 跳转路由传id的key值
        delete: true, // 设置有删除功能
        deleteUrl: _api.URL_USERDELETE, // 删除接口
        deleteKey: "user_id" // 删除接口查询的key值
      },
      seekDropdown: { // 搜索选项
        list: {
          loginId: "user_id",
          userName: "user_name",
          phone: "phone",
          email: "email"
        },
        active: 'loginId',
        seekStr: ""
      },
      page: { // 分页
        active: 1,
        pageLeng: 0,
        offset: 0
      },
      selPage: { //  配合分页的显示col数目选择
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    };
  },
  mounted: function mounted() {
    this.seekDropdown && (this.seekDropdown.seekStr = "");
    this.tableAjax();
  },

  computed: {
    thData: function thData() {
      // 表格th数据
      return [this.multiLanguage.th.loginId, this.multiLanguage.th.accountName, this.multiLanguage.th.phone, this.multiLanguage.th.email, this.multiLanguage.th.remark];
    },
    jsonExcelAjax: function jsonExcelAjax() {
      return {
        url: _api.URL_USERLIST,
        ajaxType: "get",
        getKey: ["data", "data", "rows"],
        ajaxPar: {
          limit: this.$ALLNUM,
          offset: 0,
          sort: this.sort.method,
          sortKey: this.sort.key,
          seekKey: this.seekDropdown.list[this.seekDropdown.active],
          seekVal: this.seekDropdown.seekStr
        }
      };
    }
  },
  methods: {
    tableAjax: function tableAjax() {
      var _this = this;

      var offset = this.page.offset;
      var limit = this.selPage.limit;
      var sortKey = this.sort.key;
      var sort = this.sort.method;
      var seekKey = this.seekDropdown.list[this.seekDropdown.active];
      var seekVal = this.seekDropdown.seekStr;

      this.$http(_api.URL_USERLIST, {
        params: { limit: limit, offset: offset, sortKey: sortKey, sort: sort, seekKey: seekKey, seekVal: seekVal }
      }).then(function (res) {
        var data = res.data.data;
        _this.trData = data.rows;
        _this.page.pageLeng = data.count;
      });
    },
    deleteList: function deleteList(list) {
      var _this2 = this;

      // 删除事件
      this.$http.post(this.handle.deleteUrl, {
        sortKey: this.handle.deleteKey,
        removeList: list
      }).then(function (res) {
        if (_this2.page) _this2.page.active = 1;
        if (_this2.seekDropdown) _this2.seekDropdown.seekStr = "";
        _this2.tableAjax();
      });
    }
  },
  components: {
    mtable: _mtable2.default,
    crumbs: _crumbs2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 549 */,
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        alertIgnore: {
            refresh: '刷新',
            add: '添加',
            type: '类型',
            node_id: '帐号',
            operate: '操作',
            delete: '删除',
            cancel: '取消',
            submit: '提交',
            submitTips: '请正确输入!',
            deleteTips: '确定删除?',
            typeMap: {
                IB: '父代理',
                IB_SUB: '子代理',
                SL: '父销售',
                SL_SUB: '子销售',
                ALL: '全部类型'
            }
        }
    },
    hk: {
        alertIgnore: {
            refresh: '刷新',
            add: '添加',
            type: '類型',
            node_id: '帳號',
            operate: '操作',
            delete: '刪除',
            cancel: '取消',
            submit: '提交',
            submitTips: '請正確輸入!',
            deleteTips: '確定刪除?',
            typeMap: {
                IB: '父代理',
                IB_SUB: '子代理',
                SL: '父銷售',
                SL_SUB: '子銷售',
                ALL: '全部類型'
            }
        }
    },
    en: {
        alertIgnore: {
            refresh: 'Refresh',
            add: 'Add',
            type: 'Type',
            node_id: 'Node_id',
            operate: 'Operate',
            delete: 'Delete',
            cancel: 'Cancel',
            submit: 'Submit',
            submitTips: 'Please input correct information!',
            deleteTips: 'Are you sure to delete it?',
            typeMap: {
                IB: 'Parent IB',
                IB_SUB: 'Sub IB',
                SL: 'Parent Sales',
                SL_SUB: 'Sub Sales',
                ALL: 'All Type'
            }
        }
    }
};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        allCommissionReport: {
            title: '代理佣金设定报表',
            type: '代理类型',
            account: '代理账号',
            name: '代理姓名',
            commissionReturn: '代理获得的佣金',
            IB: '代理',
            seek: '搜索',
            CPACommission: 'CPA返佣',
            internalCommission: '内返',
            unit: 'USD',
            downloadExcelForms: '下载 Excel',
            clauses_text: '显示条目数',
            amount: '总数',
            present: '当前'

        }
    },
    hk: {
        allCommissionReport: {
            title: '代理佣金設定報表',
            type: '代理類型',
            account: '代理賬號',
            name: '代理姓名',
            commissionReturn: '代理獲得的佣金',
            IB: '代理',
            seek: '搜索',
            CPACommission: 'CPA返佣',
            internalCommission: '內返',
            unit: 'USD',
            downloadExcelForms: '下載 Excel',
            clauses_text: '顯示條目數',
            amount: '總數',
            present: '當前'

        }
    },
    en: {
        allCommissionReport: {
            title: 'IB Commission Setting Report',
            type: 'IB Type',
            account: 'IB Account',
            name: 'IB Name',
            commissionReturn: 'Commission Rebate',
            IB: 'IB',
            seek: 'Search',
            CPACommission: 'CPA Commission',
            internalCommission: 'Internal Commission',
            unit: 'USD',
            downloadExcelForms: 'Download Excel',
            clauses_text: 'Display',
            amount: ' Total Count',
            present: 'Current'

        }
    }
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        auditTrailReport: {
            indexText: '审核跟踪报表',
            detailText: '审核跟踪明细报表',
            goback: '返回',
            start_time: "开始时间：",
            end_time: "结束时间：",
            selectTimeText: '选择日期',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            downloadExcelForms: "下载 Excel",
            nodata: "没有查询到数据",
            search: '搜索',
            type: '类别：',
            account: '账号：',
            typeList: { "0": "增加", "1": "修改", "2": "刪除" },
            category: { "-1": "所有", "0": "代理", "1": "销售" },
            indexTh: [{
                key: 'type',
                name: '类别'
            }, {
                key: 'MODIFIED_ID',
                name: '账号'
            }, {
                key: 'NAME',
                name: '名称'
            }, {
                key: 'COUNT',
                name: '添加修改次数'
            }, {
                key: 'begintime',
                name: '开始时间',
                upper: false,
                changeTime: true
            }, {
                key: 'endtime',
                name: '结束时间',
                upper: false,
                changeTime: true
            }],
            detailTh: [{
                key: 'type',
                name: '类别'
            }, {
                key: 'DESCRIPTION',
                name: '描述'
            }, {
                key: 'LOG_DATE',
                name: '记录时间',
                changeTime: true
            }, {
                key: 'OLD_VALUE',
                name: '修改前的值'
            }, {
                key: 'NEW_VALUE',
                name: '修改后的值'
            }, {
                key: 'LOG_BY',
                name: '修改者'
            }]
        }
    },
    hk: {
        auditTrailReport: {
            indexText: '審核跟蹤報表',
            detailText: '審核跟蹤明細報表',
            goback: '返回',
            start_time: "開始時間：",
            end_time: "結束時間：",
            selectTimeText: '選擇日期',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            downloadExcelForms: "下載 Excel",
            nodata: "沒有查詢到數據",
            search: "搜索",
            type: '類別：',
            account: '賬號：',
            typeList: { "0": "增加", "1": "修改", "2": "刪除" },
            category: { "-1": "所有", "0": "代理", "1": "銷售" },
            indexTh: [{
                key: 'type',
                name: '類別'
            }, {
                key: 'MODIFIED_ID',
                name: '賬號'
            }, {
                key: 'NAME',
                name: '名稱'
            }, {
                key: 'COUNT',
                name: '添加修改次數'
            }, {
                key: 'begintime',
                name: '開始時間',
                upper: false,
                changeTime: true
            }, {
                key: 'endtime',
                name: '結束時間',
                upper: false,
                changeTime: true
            }],
            detailTh: [{
                key: 'type',
                name: '類別'
            }, {
                key: 'DESCRIPTION',
                name: '描述'
            }, {
                key: 'LOG_DATE',
                name: '記錄時間',
                changeTime: true
            }, {
                key: 'OLD_VALUE',
                name: '修改前的值'
            }, {
                key: 'NEW_VALUE',
                name: '修改後的值'
            }, {
                key: 'LOG_BY',
                name: '修改者'
            }]
        }
    },
    en: {
        auditTrailReport: {
            indexText: 'Audit Trail Report',
            detailText: 'Audit Trail Detail Report',
            goback: 'Go Back',
            start_time: "Start Time：",
            end_time: "End time：",
            selectTimeText: 'Select Date',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            downloadExcelForms: "Download Excel",
            search: "Search",
            nodata: "No data found",
            type: 'Type：',
            account: 'Account：',
            typeList: { "0": "Add", "1": "Update", "2": "Delete" },
            category: { "-1": "All", "0": "IB", "1": "Sales" },
            indexTh: [{
                key: 'type',
                name: 'Type'
            }, {
                key: 'MODIFIED_ID',
                name: 'Account'
            }, {
                key: 'NAME',
                name: 'Name'
            }, {
                key: 'COUNT',
                name: 'Count'
            }, {
                key: 'begintime',
                name: 'Start Time',
                upper: false,
                changeTime: true
            }, {
                key: 'endtime',
                name: 'End Time',
                upper: false,
                changeTime: true
            }],
            detailTh: [{
                key: 'type',
                name: 'Type'
            }, {
                key: 'DESCRIPTION',
                name: 'Description'
            }, {
                key: 'LOG_DATE',
                name: 'Log Date',
                changeTime: true
            }, {
                key: 'OLD_VALUE',
                name: 'Old Value'
            }, {
                key: 'NEW_VALUE',
                name: 'New Value'
            }, {
                key: 'LOG_BY',
                name: 'Log By'
            }]
        }
    }
};

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(84);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _cpaIBResult;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    cn: {
        cpaIBResult: {
            indexText: 'CPA佣金结果',
            text: 'CPA月结佣金计算结果',
            datailText: 'CPA月结佣金计算结果明细',
            goback: '返回',
            start_time: "开始时间：",
            end_time: "结束时间：",
            selectTimeText: '选择日期',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            downloadExcelForms: "下载 Excel",
            nodata: "没有查询到数据",
            search: '搜索',
            commissionType: '佣金类别：',
            proxyAccount: '代理账号：',
            type: 'CPA佣金',
            status: '状态：',
            confirm: '佣金确定',
            reject: '佣金拒绝',
            rejectMessage: '请输入拒绝原因',
            commit: '您真的要确定/拒绝吗?',
            total: { TOTAL: "合计", part: "part", index: 1 },
            statusList: { "0": "未确定", "1": "全部确定", "2": "部分确定" },
            CPAStatusList: { "-1": "所有", "2": "未确定", "3": "已确定", "4": "已拒绝" },
            cpaIndexTh: [{
                key: 'REPORT_ID',
                name: '编号'
            }, {
                key: 'CPACommissionResult',
                name: 'CPA佣金计算结果',
                unneed: false
            }, {
                key: 'DATE_FROM',
                name: '开始时间'
            }, {
                key: 'DATE_TO',
                name: '结束时间'
            }, {
                key: 'LAST_UPDATE',
                name: '完成时间',
                changeTime: true
            }, {
                key: 'status',
                name: '状态'
            }],
            computeTh: [{
                key: 'IB_ID',
                name: '代理账号'
            }, {
                key: 'IB_NAME',
                name: '代理姓名'
            }, {
                key: 'CPA_COMMISSION',
                name: '金额'
            }, {
                key: 'NO_OF_CLIENT',
                name: '即月达标客户数量'
            }, {
                key: 'TOTAL_NO_OF_CLIENT',
                name: '总共达标客户数量'
            }, {
                key: 'status',
                name: '状态'
            }, {
                key: 'REJECT_REASON',
                name: '拒绝原因'
            }, {
                key: 'DEPOSIT_ORDER_ID',
                name: '佣金单号'
            }, {
                key: 'DEPOSIT_COMMENT',
                name: '佣金注解'
            }, {
                key: 'UPDATE_BY',
                name: '最后更新'
            }, {
                key: 'LAST_UPDATE',
                name: '更新时间',
                changeTime: true
            }],
            detailTh: [{
                key: 'ib_id',
                name: '代理账号'
            }, {
                key: 'CLIENT_ID',
                name: '达标客户账号'
            }, {
                key: 'CLIENT_NAME',
                name: '达标客户姓名'
            }, {
                key: 'CLIENT_DOC_NO',
                name: '证件号码'
            }, {
                key: 'LOT',
                name: '手数'
            }, {
                key: 'CPA_COMMISSION',
                name: '金额'
            }]
        }
    },
    hk: {
        cpaIBResult: {
            indexText: 'CPA佣金結果',
            text: 'CPA月結佣金計算結果',
            datailText: 'CPA月結佣金計算結果明細',
            goback: '返回',
            start_time: "開始時間：",
            end_time: "結束時間：",
            selectTimeText: '選擇日期',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            downloadExcelForms: "下載 Excel",
            search: "搜索",
            nodata: "沒有查詢到數據",
            commissionType: '佣金類別：',
            proxyAccount: '代理賬號：',
            type: 'CPA佣金',
            status: '狀態：',
            confirm: '佣金確定',
            reject: '佣金拒絕',
            rejectMessage: '請輸入拒絕原因',
            commit: '您真的要確定/拒絕嗎?',
            total: { TOTAL: "合計", part: "part", index: 1 },
            statusList: { "0": "未確定", "1": "全部確定", "2": "部分確定" },
            CPAStatusList: { "-1": "所有", "2": "未確定", "3": "已確定", "4": "已拒絕" },
            cpaIndexTh: [{
                key: 'REPORT_ID',
                name: '編號'
            }, {
                key: 'CPACommissionResult',
                name: 'CPA佣金計算結果',
                unneed: false
            }, {
                key: 'DATE_FROM',
                name: '開始時間'
            }, {
                key: 'DATE_TO',
                name: '結束時間'
            }, {
                key: 'LAST_UPDATE',
                name: '完成時間',
                changeTime: true
            }, {
                key: 'status',
                name: '狀態'
            }],
            computeTh: [{
                key: 'IB_ID',
                name: '代理賬號'
            }, {
                key: 'IB_NAME',
                name: '代理姓名'
            }, {
                key: 'CPA_COMMISSION',
                name: '金額'
            }, {
                key: 'NO_OF_CLIENT',
                name: '即月達標客戶數量'
            }, {
                key: 'TOTAL_NO_OF_CLIENT',
                name: '總共達標客戶數量'
            }, {
                key: 'status',
                name: '狀態'
            }, {
                key: 'REJECT_REASON',
                name: '拒絕原因'
            }, {
                key: 'DEPOSIT_ORDER_ID',
                name: '佣金單號'
            }, {
                key: 'DEPOSIT_COMMENT',
                name: '佣金注解'
            }, {
                key: 'UPDATE_BY',
                name: '最後更新'
            }, {
                key: 'LAST_UPDATE',
                name: '更新時間',
                changeTime: true
            }],
            detailTh: [{
                key: 'ib_id',
                name: '代理賬號'
            }, {
                key: 'CLIENT_ID',
                name: '達標客戶賬號'
            }, {
                key: 'CLIENT_NAME',
                name: '達標客戶姓名'
            }, {
                key: 'CLIENT_DOC_NO',
                name: '證件號碼'
            }, {
                key: 'LOT',
                name: '手數'
            }, {
                key: 'CPA_COMMISSION',
                name: '金額'
            }]
        }
    },
    en: {
        cpaIBResult: (_cpaIBResult = {
            indexText: 'CPA Commisson Result',
            text: 'CPA Monthly commission Result',
            datailText: 'CPA Monthly Commission Result Detail',
            goback: 'Go Back',
            start_time: "Start Time：",
            end_time: "End Time：",
            selectTimeText: 'Select Date',
            search: 'Search',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            downloadExcelForms: "Download Excel",
            nodata: "No data found"
        }, (0, _defineProperty3.default)(_cpaIBResult, 'search', 'Search'), (0, _defineProperty3.default)(_cpaIBResult, 'commissionType', 'Type：'), (0, _defineProperty3.default)(_cpaIBResult, 'proxyAccount', 'Account：'), (0, _defineProperty3.default)(_cpaIBResult, 'type', 'CPA Commission'), (0, _defineProperty3.default)(_cpaIBResult, 'status', 'Status：'), (0, _defineProperty3.default)(_cpaIBResult, 'confirm', 'Confirm'), (0, _defineProperty3.default)(_cpaIBResult, 'reject', 'Reject'), (0, _defineProperty3.default)(_cpaIBResult, 'rejectMessage', 'Please enter a reject reason'), (0, _defineProperty3.default)(_cpaIBResult, 'commit', 'Do you really want to confirm/reject?'), (0, _defineProperty3.default)(_cpaIBResult, 'total', { TOTAL: "Total", part: "part", index: 1 }), (0, _defineProperty3.default)(_cpaIBResult, 'statusList', { "0": "Unconfirmed", "1": "All Confirmed", "2": "Partially Confirmed" }), (0, _defineProperty3.default)(_cpaIBResult, 'CPAStatusList', { "-1": "All", "2": "Unconfirmed", "3": "Confirmed", "4": "Rejected" }), (0, _defineProperty3.default)(_cpaIBResult, 'cpaIndexTh', [{
            key: 'REPORT_ID',
            name: 'Record ID'
        }, {
            key: 'CPACommissionResult',
            name: 'CPA Commission Result',
            unneed: false
        }, {
            key: 'DATE_FROM',
            name: 'Start Time'
        }, {
            key: 'DATE_TO',
            name: 'End Time'
        }, {
            key: 'LAST_UPDATE',
            name: 'Completion Time',
            changeTime: true
        }, {
            key: 'status',
            name: 'Status'
        }]), (0, _defineProperty3.default)(_cpaIBResult, 'computeTh', [{
            key: 'IB_ID',
            name: 'IB Account'
        }, {
            key: 'IB_NAME',
            name: 'IB name'
        }, {
            key: 'CPA_COMMISSION',
            name: 'Amount'
        }, {
            key: 'NO_OF_CLIENT',
            name: 'Current Month Count'
        }, {
            key: 'TOTAL_NO_OF_CLIENT',
            name: 'Total Count'
        }, {
            key: 'status',
            name: 'Status'
        }, {
            key: 'REJECT_REASON',
            name: 'Reject Reason'
        }, {
            key: 'DEPOSIT_ORDER_ID',
            name: 'Order ID'
        }, {
            key: 'DEPOSIT_COMMENT',
            name: 'Comment'
        }, {
            key: 'UPDATE_BY',
            name: 'Update By'
        }, {
            key: 'LAST_UPDATE',
            name: 'Last Update',
            changeTime: true
        }]), (0, _defineProperty3.default)(_cpaIBResult, 'detailTh', [{
            key: 'ib_id',
            name: 'IB account'
        }, {
            key: 'CLIENT_ID',
            name: 'Client ID'
        }, {
            key: 'CLIENT_NAME',
            name: 'Client Name'
        }, {
            key: 'CLIENT_DOC_NO',
            name: 'Client Doc Number'
        }, {
            key: 'LOT',
            name: 'LOTS'
        }, {
            key: 'CPA_COMMISSION',
            name: 'Amount'
        }]), _cpaIBResult)
    }
};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        ibCommission: {
            unconfirmed: '未审核的',
            confirmed: '已审核的',
            contrastBrowse: '对比浏览',
            singlepageBrowse: '单页浏览',
            updateBy: '最后修改',
            confirmBy: '最后审核',
            templateSetting: '模板管理',
            templateName: '模板名称',
            templateHistory: '模板历史',
            templateCreate: '新建模板',
            templateBase: '基础模板',
            alertMsg: {
                noAccount: '这不是一个正确的账号',
                checkFail: '不能由同一人完成修改和审核',
                verifyTips: '是否确定审核，如果数据有修改，请先保存，否则将被覆盖!',
                beforeSave: '请先保存数据',
                checkRuleFail1: '存在“分层最高金额”这个规则设定时，加点、外佣、内返的值必须相同',
                checkRuleFail2: '存在“分层最高金额”这个规则时，每个级别都必须有一条相同的“分层最高金额”，并保证“加点、外佣、内返”一致',
                templateExist: '模板名已存在!'
            },
            ibCommissionPreview: {
                ibCommissionPreview: '代理佣金预览',
                lowerIBCommissionPreview: '下级代理佣金预览',
                specialIBCommissionPreview: '特别代理佣金预览',
                unit: 'USD',
                mainIb: '主代理',
                subIb: '子代理',
                th: {
                    ibType: '代理类型',
                    ibAccount: '代理账号',
                    ibName: '代理姓名',
                    CommissionReturn: '代理获得的佣金',
                    subIBAccount: '子代理账号',
                    mainIBAccount: '主代理账号',
                    getSubCondition: '主代理获取子代理的条件',
                    additionAmount: '额外金额',
                    specialIBAccount: '特别代理账号',
                    originalMainAccount: '原主账号',
                    getSpecialCondition: '收拥代理获取特别代理的条件'
                },
                rules: {
                    subIB: '子代理的',
                    spreadCommission: '加点',
                    externalCommission: '外佣',
                    internalCommission: '内返',
                    exceptant: '以外的',
                    after: '之后的',
                    differenceForMaxInternalCommission: '与最高内返差值给上一层账号',
                    everyTransactionByFixedamount: '每手按照固定金额',
                    toTargetIB: '返给指定代理',
                    exceedTO: '每手如果超过以下金额，余下全部给上一层账号',
                    forex: '外汇',
                    gold: '黄金',
                    silver: '白银',
                    energy: '能源',
                    index: '指数'
                }
            },
            commissionRule: '佣金规则',
            ruleCommission: {
                pleaseChooseSubIB: '请选择子代理的',
                pleaseHandleSubIB: '请把子代理的',
                spreadCommission: '加点',
                externalCommission: '外佣',
                internalCommission: '内返',
                partOf: '部分的',
                toUpperAccount: '给上一层账号',
                differenceForMaxInternalCommission: '与最高内返差值给上一层账号',
                everyTransactionByFixedamount: '每手按照固定金额',
                toTargetIB: '返给指定代理',
                exceedTO: '每手如果超过以下金额，余下全部给上一层账号'
            },
            upperCommission: {
                upperTitle: '分配去上层账号',
                targetTitle: '分配去指定账号',
                targetPlaceholder: '请输入账号',
                noUpperIB: '没有上层代理'
            },
            reminderDate: '到期时间',
            reminderMsg: '到期提示信息',
            reminderMsgPlaceholder: '请输入内容',
            choiceDateTime: '请选择日期时间',
            sented: '已发送',
            ibAccount: '代理账号',
            ibcAccount: "收佣账号",
            ibCommissionSetting: '代理佣金设定',
            upperCommissiondistribution: '多层佣金分配',
            submitResult: {
                err: '请正确填写信息',
                succeed: '保存成功',
                auditSuccess: '审核成功',
                serverErr: '提交失败'
            },
            crumbs: {
                amend: "佣金修改"
            },
            enable: '启用',
            specialCommission: '特殊返佣',
            infinite: '以上',
            to: '至',
            or: '至',

            commonCaculation: '内返计算',
            CPACaculation: 'CPA计算',
            comAndCPA: '内返 + CPA计算',
            CPACommission: 'CPA返拥',

            SettingTemplate: '设定模版',
            ib_allTemplate: '全部模版',
            ib_default: '标准内返',
            ib_max: '高标准内返',
            ib_min: '低标准内返',
            ib_second_level: '第二层开始',
            ib_minus_1: '减一内返',
            ib_minus_2: '减二内返',
            ib_plus2: '加二内返',
            ib_max12upper: '高标 12 USD(一级代理)',
            ib_max12lower: '高标 12 USD(子代理)',
            ib_default12: '12 USD',
            ib_subib_plana: '下层代理计划 A',
            ib_subib_planb: '下层代理计划 B',
            ib_subib_planc: '下层代理计划 C',
            ib_egypt_masterplan: '埃及标准内返',
            ib_extra5: '额外5%',

            ib_8_9_10_from3to2: '8,9,10 (三级返二级)',
            ib_8_9_10_from3to2and1: '8,9,10 (三级返二级一级)',
            ib_8_9_10: '8,9,10',
            ib_9_10: '9,10',
            ib_10_11_12: '10,11,12',
            ib_8: '8 USD',
            ib_10: '10 USD',
            ib_12: '12 USD',
            ib_12_diff: '与 12 USD 差值返回一级代理',
            ib_9_10_11_12: '9,10,11,12',
            ib_sea_9: 'SEA 9 USD',
            ib_sea_12: 'SEA 12 USD',
            ib_8_9_10_11: '8,9,10,11 (返上层 1 USD)',
            ib_9_10_11_12_1lvl_1: '9,10,11,12 (返上层 1 USD)',
            ib_7_8_9_10_1lvl: '7,8,9,10 (返上层 2 USD)',
            ib_7_8_9_10: '7,8,9,10 (返上二层各 1 USD)',
            ib_uae_5_6_7: 'UAE 5,6,7',
            ib_uae_7_8_9: '7,8,9',
            ib_uae_1_2_3_variable: '1,2,3 Variable',
            ib_egy_5_6_7: 'EGY 5,6,7',
            ib_5_6_7: '5,6,7',
            ib_5: '5 USD',
            ib_7: '7 USD',
            ib_3_level_plan: '3 层代理计划',
            ib_uae_8: '8 USD',
            ib_4_5_6: '4,5,6',
            ib_09_10_11_12: '微型帐户代理返佣',
            ib_08_09_10_11: '微型帐户代理返佣(二级)',
            ib_07_08_09_10: '微型帐户代理返佣(三级)',
            ib_tw_1st: 'TW VIP(MIB)',
            ib_tw_2nd: 'TW VIP(SUB IB)',
            ib_edge_1st: 'Edge for MIB',
            ib_edge_2nd: 'Edge for 2 SUB IB',
            ib_edge_3rd: 'Edge for 3 SUB IB',
            ib_kr: '韩国代理',
            ib_8_upper_4: '固8返上4',
            ib_tw_3rd: 'TW VIP(SUB2 IB)',
            ib_6_7_8_9_1lvl: '6,7,8,9 (返第一层 3 USD)',
            ib_6_7_8_9_2lvl: '6,7,8,9 (返第二层 3 USD)',
            ib_4_5_6_7_2lvl: '4,5,6,7(返二级3,返一级2)(泰国专用)',
            ib_5_6_7_8_1lvl: '5,6,7,8(返上层4USD)',
            ib_4_5_6_7_2lvl_1_4: '4,5,6,7(返二级1,返一级4)',
            ib_4_5_6_7_2lvl_2_3: '4,5,6,7(返二级2,返一级3)',
            ib_7_8_9_10_1lvl_spread: '7.8.9.10 (返上层 2 USD),加点返到主代理',
            ib_7_8_9_10_2lvl_spread: '7.8.9.10 (返上二层各 1 USD),加点返到主代理',
            ib_7_8_9_10_2lvl_fix2: '7,8,9,10 (二级固定2)',
            ib_spread_1: '加 0.1 点返佣',
            ib_ia_option1: 'OPTION 1 (USD)',
            ib_ia_option2: 'OPTION 2 (USD)',
            ib_ia_option3: 'OPTION 3 (USD)',
            ib_ia_spread: 'SPREAD (USD)',
            ib_ia_option1_eur: 'OPTION 1 (EUR)',
            ib_ia_option2_eur: 'OPTION 2 (EUR)',
            ib_ia_option3_eur: 'OPTION 3 (EUR)',
            ib_ia_spread_eur: 'SPREAD (EUR)',
            ib_ia_option1_gbp: 'OPTION 1 (GBP)',
            ib_ia_option2_gbp: 'OPTION 2 (GBP)',
            ib_ia_option3_gbp: 'OPTION 3 (GBP)',
            ib_ia_spread_gbp: 'SPREAD (GBP)',
            ib_ia_premium_raw_eur: 'Premium raw(EUR)',
            ib_ia_raw30: 'RAW 30',
            ib_ia_raw13: 'RAW 13',
            ib_ia_raw50: 'RAW 50',
            ib_ia_edge5: 'EDGE 5',
            ib_05prem: '05Prem',
            ib_8_9_10_1lvl_2: '8,9,10 (返上层 2 USD)',
            ib_mx_option1: 'OPTION 1',
            ib_mx_option2: 'OPTION 2',
            ib_mx_option3: 'OPTION 3',
            ib_mx_option4: 'OPTION 4 (Markup)',
            ib_mx_50sub: '50% Sub',
            ib_mx_level3: 'LEVEL 3',
            ib_680005729: 'SIB under MIB 680005729',
            ib_ecn: 'ECN',
            ib_vn_ecn: 'VN ECN',
            ib_sub_50p_2: '50% 下层 2',
            ib_sub_50p_3: '50% 下层 3',

            cpa_SettingTemplate: 'CPA 设定模板',
            cpa_default: '标准CPA',
            cpa_min: '低标准CPA',
            cpa_max: '高标准CPA',

            cpa_20_25_30: '20,25,30',
            cpa_200_250_300: '200,250,300',

            CPA: {
                totalVolume: '总成交量',
                LOT: '手数',
                remarks: '当月符合条件的客户数目',
                commissionPer: '每个客户佣金'
            },
            btnGroup: {
                submit: '保存修改',
                add: '添加',
                remove: '删除',
                addLots: '添加手数',
                removeLots: '删除手数',
                confirmDeleteText: '确认删除所选记录吗？',
                commissionPreviewBtn: '佣金预览',
                back: '返回',
                addLevel: '添加级别',
                removeLevel: '删除级别',
                check: '确认审核',
                backData: '返回之前数据'
            },
            thead: {
                lots: '手数 \/ 产品',
                operation: '操作'
            }
        }
    },
    hk: {
        ibCommission: {
            unconfirmed: '未審核的',
            confirmed: '已審核的',
            contrastBrowse: '對比瀏覽',
            singlepageBrowse: '單頁瀏覽',
            updateBy: '最后修改',
            confirmBy: '最后審核',
            templateSetting: '模板管理',
            templateName: '模板名称',
            templateHistory: '模板历史',
            templateCreate: '新建模板',
            templateBase: '基礎模板',
            alertMsg: {
                noAccount: '這不是一個正確的賬號',
                checkFail: '不能由同一人完成修改和審核',
                verifyTips: '是否確定審核，如果數據有修改，請先保存，否則將被覆蓋!',
                beforeSave: '請先保存數據',
                checkRuleFail1: '存在“分層最高金額”這個規則設定時，加點、外佣、內返的值必須相同',
                checkRuleFail2: '存在“分層最高金額”這個規則時，每個級別都必須有一條相同的“分層最高金額”，并保證“加點、外佣、內返”一致',
                templateExist: '模板名已存在!'
            },
            ibCommissionPreview: {
                ibCommissionPreview: '代理佣金預覽',
                lowerIBCommissionPreview: '下級代理佣金預覽',
                specialIBCommissionPreview: '特別代理佣金預覽',
                unit: 'USD',
                mainIb: '主代理',
                subIb: '子代理',
                th: {
                    ibType: '代理類型',
                    ibAccount: '代理賬號',
                    ibName: '代理姓名',
                    CommissionReturn: '代理獲得的佣金',
                    subIBAccount: '子代理賬號',
                    mainIBAccount: '主代理賬號',
                    getSubCondition: '主代理獲取子代理的條件',
                    additionAmount: '額外金額',
                    specialIBAccount: '特別代理賬號',
                    originalMainAccount: '原主賬號',
                    getSpecialCondition: '收拥代理獲取特別代理的條件'
                },
                rules: {
                    subIB: '子代理的',
                    spreadCommission: '加點',
                    externalCommission: '外佣',
                    internalCommission: '內返',
                    exceptant: '以外的',
                    after: '之后的',
                    differenceForMaxInternalCommission: '與最高內返差值給上一層賬號',
                    everyTransactionByFixedamount: '每手按照固定金額',
                    toTargetIB: '返給指定代理',
                    exceedTO: '每手如果超過以下金額，余下全部給上一層賬號',
                    forex: '外匯',
                    gold: '黃金',
                    silver: '白銀',
                    energy: '能源',
                    index: '指數'
                }
            },
            commissionRule: '佣金規則',
            ruleCommission: {
                pleaseChooseSubIB: '請選擇子代理的',
                pleaseHandleSubIB: '請把子代理的',
                spreadCommission: '加點',
                externalCommission: '外佣',
                internalCommission: '內返',
                partOf: '部分的',
                toUpperAccount: '給上一層賬號',
                differenceForMaxInternalCommission: '與最高內返差值給上一層賬號',
                everyTransactionByFixedamount: '每手按照固定金額',
                toTargetIB: '返給指定代理',
                exceedTO: '每手如果超過以下金額，余下全部給上一層賬號'
            },
            upperCommission: {
                upperTitle: '分配去上層賬號',
                targetTitle: '分配去指定賬號',
                targetPlaceholder: '請輸入賬號',
                noUpperIB: '沒有上層代理'
            },
            reminderDate: '到期時間',
            reminderMsg: '到期提示信息',
            reminderMsgPlaceholder: '請輸入內容',
            choiceDateTime: '請選擇日期時間',
            sented: '已發送',
            ibAccount: '代理賬號',
            ibcAccount: "收佣賬號",
            ibCommissionSetting: '代理佣金設定',
            upperCommissiondistribution: '多層佣金分配',
            submitResult: {
                err: '請正確填寫信息',
                succeed: '保存成功',
                auditSuccess: '審核成功',
                serverErr: '提交失敗'
            },
            crumbs: {
                amend: "佣金修改"
            },
            enable: '啟用',
            specialCommission: '特殊返佣',
            infinite: '以上',
            to: '至',
            or: '至',
            commonCaculation: '內返計算',
            CPACaculation: 'CPA計算',
            comAndCPA: '內返 + CPA計算',
            CPACommission: 'CPA返佣',

            SettingTemplate: '設定模板',
            ib_allTemplate: '全部模版',
            ib_default: '標準內返',
            ib_max: '高標準內返',
            ib_min: '低標準內返',
            ib_second_level: '第二層開始',
            ib_minus_1: '減一內返',
            ib_minus_2: '減二內返',
            ib_plus2: '加二內返',
            ib_max12upper: '高標 12 USD(一級代理)',
            ib_max12lower: '高標 12 USD(子代理)',
            ib_default12: '12 USD',
            ib_subib_plana: '下層代理計劃 A',
            ib_subib_planb: '下層代理計劃 B',
            ib_subib_planc: '下層代理計劃 C',
            ib_egypt_masterplan: '埃及標準內返',
            ib_extra5: '額外5%',

            ib_8_9_10_from3to2: '8,9,10 (三級返二級)',
            ib_8_9_10_from3to2and1: '8,9,10 (三級返二級一級)',
            ib_8_9_10: '8,9,10',
            ib_9_10: '9,10',
            ib_10_11_12: '10,11,12',
            ib_8: '8 USD',
            ib_10: '10 USD',
            ib_12: '12 USD',
            ib_12_diff: '与 12 USD 差值返回一级代理',
            ib_9_10_11_12: '9,10,11,12',
            ib_sea_9: 'SEA 9 USD',
            ib_sea_12: 'SEA 12 USD',
            ib_8_9_10_11: '8,9,10,11 (返上層 1 USD)',
            ib_9_10_11_12_1lvl_1: '9,10,11,12 (返上層 1 USD)',
            ib_7_8_9_10_1lvl: '7,8,9,10 (返上層 2 USD)',
            ib_7_8_9_10: '7,8,9,10 (返上二層各 1 USD)',
            ib_uae_5_6_7: 'UAE 5,6,7',
            ib_uae_7_8_9: '7,8,9',
            ib_uae_1_2_3_variable: '1,2,3 Variable',
            ib_egy_5_6_7: 'EGY 5,6,7',
            ib_5_6_7: '5,6,7',
            ib_5: '5 USD',
            ib_7: '7 USD',
            ib_3_level_plan: '3 層代理計劃',
            ib_uae_8: '8 USD',
            ib_4_5_6: '4,5,6',
            ib_09_10_11_12: '微型帳戶代理返佣',
            ib_08_09_10_11: '微型帐户代理返佣(二級)',
            ib_07_08_09_10: '微型帐户代理返佣(三級)',
            ib_tw_1st: 'TW VIP(MIB)',
            ib_tw_2nd: 'TW VIP(SUB IB)',
            ib_edge_1st: 'Edge for MIB',
            ib_edge_2nd: 'Edge for 2 SUB IB',
            ib_edge_3rd: 'Edge for 3 SUB IB',
            ib_kr: '韓國代理',
            ib_8_upper_4: '固8返上4',
            ib_tw_3rd: 'TW VIP(SUB2 IB)',
            ib_6_7_8_9_1lvl: '6,7,8,9 (返第一層 3 USD)',
            ib_6_7_8_9_2lvl: '6,7,8,9 (返第二層 3 USD)',
            ib_4_5_6_7_2lvl: '4,5,6,7(返二級3,返一級2)(泰國專用)',
            ib_5_6_7_8_1lvl: '5,6,7,8(返上層4USD)',
            ib_4_5_6_7_2lvl_1_4: '4,5,6,7(返二級1,返一級4)',
            ib_4_5_6_7_2lvl_2_3: '4,5,6,7(返二級2,返一級3)',
            ib_7_8_9_10_1lvl_spread: '7.8.9.10 (返上層 2 USD),加點返到主代理',
            ib_7_8_9_10_2lvl_spread: '7.8.9.10 (返上二層各 1 USD),加點返到主代理',
            ib_7_8_9_10_2lvl_fix2: '7,8,9,10 (二級固定2)',
            ib_spread_1: '加 0.1 點返佣',
            ib_ia_option1: 'OPTION 1 (USD)',
            ib_ia_option2: 'OPTION 2 (USD)',
            ib_ia_option3: 'OPTION 3 (USD)',
            ib_ia_spread: 'SPREAD (USD)',
            ib_ia_option1_eur: 'OPTION 1 (EUR)',
            ib_ia_option2_eur: 'OPTION 2 (EUR)',
            ib_ia_option3_eur: 'OPTION 3 (EUR)',
            ib_ia_spread_eur: 'SPREAD (EUR)',
            ib_ia_option1_gbp: 'OPTION 1 (GBP)',
            ib_ia_option2_gbp: 'OPTION 2 (GBP)',
            ib_ia_option3_gbp: 'OPTION 3 (GBP)',
            ib_ia_spread_gbp: 'SPREAD (GBP)',
            ib_ia_premium_raw_eur: 'Premium raw(EUR)',
            ib_ia_raw30: 'RAW 30',
            ib_ia_raw13: 'RAW 13',
            ib_ia_raw50: 'RAW 50',
            ib_ia_edge5: 'EDGE 5',
            ib_05prem: '05Prem',
            ib_8_9_10_1lvl_2: '8,9,10 (返上層 2 USD)',
            ib_mx_option1: 'OPTION 1',
            ib_mx_option2: 'OPTION 2',
            ib_mx_option3: 'OPTION 3',
            ib_mx_option4: 'OPTION 4 (Markup)',
            ib_mx_50sub: '50% Sub',
            ib_mx_level3: 'LEVEL 3',
            ib_680005729: 'SIB under MIB 680005729',
            ib_ecn: 'ECN',
            ib_vn_ecn: 'VN ECN',
            ib_sub_50p_2: '50% sub 2',
            ib_sub_50p_3: '50% sub 3',

            cpa_SettingTemplate: 'CPA 設定模板',
            cpa_default: '標準CPA',
            cpa_min: '低標準CPA',
            cpa_max: '高標準CPA',

            cpa_20_25_30: '20,25,30',
            cpa_200_250_300: '200,250,300',

            CPA: {
                totalVolume: '總成交量',
                LOT: '手數',
                remarks: '當月符合條件的客戶數目',
                commissionPer: '每個客戶佣金'
            },
            btnGroup: {
                submit: '保存修改',
                add: '添加',
                remove: '刪除',
                addLots: '添加手數',
                removeLots: '刪除手數',
                confirmDeleteText: '確認刪除所選記錄嗎？',
                commissionPreviewBtn: '佣金預覽',
                back: '返回',
                addLevel: '添加級別',
                removeLevel: '刪除級別',
                check: '確認審核',
                backData: '返回之前數據'
            },
            thead: {
                lots: '手數 \/ 產品',
                operation: '操作'
            }
        }
    },
    en: {
        ibCommission: {
            unconfirmed: 'unconfirmed',
            confirmed: 'confirmed',
            contrastBrowse: 'Contrast Browse',
            singlepageBrowse: 'Singlepage Browse',
            updateBy: 'UpdateBy',
            confirmBy: 'ConfirmBy',
            templateSetting: 'Template Maintenance',
            templateName: 'Template Name',
            templateHistory: 'Template History',
            templateCreate: 'New Template',
            templateBase: 'Base Template',
            alertMsg: {
                noAccount: 'Invalid Account',
                checkFail: 'Can not check Modification and inspection by same person',
                verifyTips: 'Whether to confirm audit, if the data has been modified, please save first, otherwise it will be overwritten!',
                beforeSave: 'Please save the data first',
                checkRuleFail1: 'Check Rule Setting Fail :  1',
                checkRuleFail2: 'Check Rule Setting Fail :  2',
                templateExist: 'Template Name Already Exist!'
            },
            ibCommissionPreview: {
                ibCommissionPreview: 'IB Commission Setting Preview',
                lowerIBCommissionPreview: 'Lower IB Commission Preview',
                specialIBCommissionPreview: 'Special IB Commission Preview',
                unit: 'USD',
                mainIb: 'Main IB',
                subIb: 'Sub IB',
                th: {
                    ibType: 'IB Type',
                    ibAccount: 'IB Account',
                    ibName: 'IB Name',
                    CommissionReturn: 'Commission Rebate',
                    subIBAccount: 'Sub IB Account',
                    mainIBAccount: 'Main IB Account',
                    getSubCondition: 'The condition to Main IB',
                    additionAmount: 'Extra Amount',
                    specialIBAccount: 'Special IB Account',
                    originalMainAccount: 'Original Main Account',
                    getSpecialCondition: 'The condition to IB Account'
                },
                rules: {
                    subIB: 'Sub IB',
                    spreadCommission: 'Spread Commission',
                    externalCommission: 'External Commission',
                    internalCommission: 'Internal Commission',
                    exceptant: 'Exceptant',
                    after: 'After',
                    differenceForMaxInternalCommission: 'Difference to max rebate level',
                    everyTransactionByFixedamount: 'Fixed Amount per lot',
                    toTargetIB: 'To Target IB',
                    exceedTO: 'If per lot commission exceed the defined amount, the remaining to upper account',
                    forex: 'Forex',
                    gold: 'Gold',
                    silver: 'Silver',
                    energy: 'Energy',
                    index: 'Index'
                }
            },
            commissionRule: 'Commission Rule',
            ruleCommission: {
                pleaseChooseSubIB: 'Please Choose Sub IB',
                pleaseHandleSubIB: 'Please Handle Sub IB',
                spreadCommission: 'Spread Commission',
                externalCommission: 'External Commission',
                internalCommission: 'Internal Commission',
                partOf: 'Part of',
                toUpperAccount: 'To Upper Account',
                differenceForMaxInternalCommission: 'Difference to max rebate level',
                everyTransactionByFixedAmount: 'Fixed Amount per lot',
                toTargetIB: 'To Target IB',
                exceedTO: 'If per lot commission exceed the defined amount, the remaining to upper account'
            },
            upperCommission: {
                upperTitle: 'Distribution to Upper IB Account',
                targetTitle: 'Distribution to Direct Account',
                targetPlaceholder: 'Please Input The Account',
                noUpperIB: 'No Upper IB'
            },
            reminderDate: 'Reminder Date',
            reminderMsg: 'Reminder Message',
            reminderMsgPlaceholder: 'Please Enter',
            choiceDateTime: 'Please choose datetime',
            sented: 'Sent',
            ibAccount: 'IB Account',
            ibcAccount: "Commission Account",
            ibCommissionSetting: 'IB Commission Setting',
            upperCommissiondistribution: 'More Commission Distribution',
            submitResult: {
                err: 'Please fill in the information correctly',
                succeed: 'Save Successfully',
                auditSuccess: 'Check Successfully',
                serverErr: 'Submit failed!'
            },
            crumbs: {
                amend: "Amend Commission"
            },
            enable: 'Enable',
            specialCommission: 'Special Commission',
            infinite: 'infinity',
            to: 'to',
            or: 'to',
            commonCaculation: 'Internal Commission Calculation',
            CPACaculation: 'CPA Caculation',
            comAndCPA: 'Internal Commission + CPA Caculation',
            CPACommission: 'CPA Commission',

            SettingTemplate: 'Setting Template',
            ib_allTemplate: 'All Template',
            ib_default: 'Standard Rebate',
            ib_max: 'High Internal Commission Calculation',
            ib_min: 'Low Internal Commission Calculation',
            ib_second_level: 'Second level',
            ib_minus_1: 'Minus One Internal Commission',
            ib_minus_2: 'Minus Two Internal Commission',
            ib_plus2: 'Plus 2 Rebate',
            ib_max12upper: 'Highest 12 (1st Level IB)',
            ib_max12lower: 'Highest 12 (Sub IB)',
            ib_default12: '12 USD',
            ib_subib_plana: 'Sub IB Plan A',
            ib_subib_planb: 'Sub IB Plan B',
            ib_subib_planc: 'Sub IB Plan C',
            ib_egypt_masterplan: 'Egypt Standard Rebate',
            ib_extra5: 'Extra 5%',

            ib_8_9_10_from3to2: '8,9,10 (From Lv3 to Lv2)',
            ib_8_9_10_from3to2and1: '8,9,10 (From Lv3 to Lv2 and Lv1)',
            ib_8_9_10: '8,9,10',
            ib_9_10: '9,10',
            ib_10_11_12: '10,11,12',
            ib_8: '8 USD',
            ib_10: '10 USD',
            ib_12: '12 USD',
            ib_12_diff: 'Diff with 12 USD to upper IB',
            ib_9_10_11_12: '9,10,11,12',
            ib_sea_9: 'SEA 9 USD',
            ib_sea_12: 'SEA 12 USD',
            ib_8_9_10_11: '8,9,10,11 (1 USD to upper)',
            ib_9_10_11_12_1lvl_1: '9,10,11,12 (1 USD to upper)',
            ib_7_8_9_10_1lvl: '7,8,9,10 (2 USD to upper)',
            ib_7_8_9_10: '7,8,9,10 (1 USD to 2 upper level)',
            ib_uae_5_6_7: 'UAE 5,6,7',
            ib_uae_7_8_9: '7,8,9',
            ib_uae_1_2_3_variable: '1,2,3 Variable',
            ib_egy_5_6_7: 'EGY 5,6,7',
            ib_5_6_7: '5,6,7',
            ib_5: '5 USD',
            ib_7: '7 USD',
            ib_3_level_plan: '3 Level Plan',
            ib_uae_8: '8 USD',
            ib_4_5_6: '4,5,6',
            ib_09_10_11_12: 'Mini IB Rebate',
            ib_08_09_10_11: 'Mini IB Rebate (2 Level)',
            ib_07_08_09_10: 'Mini IB Rebate (3 Level)',
            ib_tw_1st: 'TW VIP(MIB)',
            ib_tw_2nd: 'TW VIP(SUB IB)',
            ib_edge_1st: 'Edge for MIB',
            ib_edge_2nd: 'Edge for 2 SUB IB',
            ib_edge_3rd: 'Edge for 3 SUB IB',
            ib_kr: 'Korea IB',
            ib_8_upper_4: '8 USD Only and 4 to upper',
            ib_tw_3rd: 'TW VIP(SUB2 IB)',
            ib_6_7_8_9_1lvl: '6,7,8,9 (3 USD to 1st)',
            ib_6_7_8_9_2lvl: '6,7,8,9 (3 USD to 2nd)',
            ib_4_5_6_7_2lvl: '4,5,6,7(3 to 2nd,2 to 1st)(For Thailand)',
            ib_5_6_7_8_1lvl: '5,6,7,8(4 USD to upper)',
            ib_4_5_6_7_2lvl_1_4: '4,5,6,7(1 to 2nd,4 to 1st)',
            ib_4_5_6_7_2lvl_2_3: '4,5,6,7(2 to 2nd,3 to 1st)',
            ib_7_8_9_10_1lvl_spread: '7,8,9,10 (2 USD to upper),spread to Master',
            ib_7_8_9_10_2lvl_spread: '7,8,9,10 (1 to 2nd,1 to 1st),spread to Master',
            ib_7_8_9_10_2lvl_fix2: '7,8,9,10 (Fix 2 to 2nd)',
            ib_spread_1: 'Add 0.1 pips rebate',
            ib_ia_option1: 'OPTION 1 (USD)',
            ib_ia_option2: 'OPTION 2 (USD)',
            ib_ia_option3: 'OPTION 3 (USD)',
            ib_ia_spread: 'SPREAD (USD)',
            ib_ia_option1_eur: 'OPTION 1 (EUR)',
            ib_ia_option2_eur: 'OPTION 2 (EUR)',
            ib_ia_option3_eur: 'OPTION 3 (EUR)',
            ib_ia_spread_eur: 'SPREAD (EUR)',
            ib_ia_option1_gbp: 'OPTION 1 (GBP)',
            ib_ia_option2_gbp: 'OPTION 2 (GBP)',
            ib_ia_option3_gbp: 'OPTION 3 (GBP)',
            ib_ia_spread_gbp: 'SPREAD (GBP)',
            ib_ia_premium_raw_eur: 'Premium raw(EUR)',
            ib_ia_raw30: 'RAW 30',
            ib_ia_raw13: 'RAW 13',
            ib_ia_raw50: 'RAW 50',
            ib_ia_edge5: 'EDGE 5',
            ib_05prem: '05Prem',
            ib_8_9_10_1lvl_2: '8,9,10 (2 USD to upper)',
            ib_mx_option1: 'OPTION 1',
            ib_mx_option2: 'OPTION 2',
            ib_mx_option3: 'OPTION 3',
            ib_mx_option4: 'OPTION 4 (Markup)',
            ib_mx_50sub: '50% Sub',
            ib_mx_level3: 'LEVEL 3',
            ib_680005729: 'SIB under MIB 680005729',
            ib_ecn: 'ECN',
            ib_vn_ecn: 'VN ECN',
            ib_sub_50p_2: '50% sub 2',
            ib_sub_50p_3: '50% sub 3',

            cpa_SettingTemplate: 'CPA Setting Template',
            cpa_default: 'Standard CPA',
            cpa_min: 'Low CPA Caculation',
            cpa_max: 'High CPA Caculation',

            cpa_20_25_30: '20,25,30',
            cpa_200_250_300: '200,250,300',

            CPA: {
                totalVolume: 'Total Volume',
                LOT: 'LOT',
                remarks: 'No of client per month amount',
                commissionPer: 'Commission per head count'
            },
            btnGroup: {
                submit: 'Save',
                add: 'Add',
                remove: 'Remove',
                addLots: 'Add Lots',
                removeLots: 'Remove Lots',
                confirmDeleteText: 'Are you sure to delete the selected record ?',
                commissionPreviewBtn: 'Commission Preview',
                back: 'Back',
                addLevel: 'Add Level',
                removeLevel: 'Remove Level',
                check: 'Check',
                backData: 'Return Data'
            },
            thead: {
                lots: 'Lots \/ Products',
                operation: 'Operation'
            }
        }
    }
};

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    ibCommissionRuleSetting: {
      currentIB: '当前代理',
      levelIB: '级代理',
      notExist: '不存在',
      rule: '规则',
      product: '产品',
      ALL: '全部',
      toOriginalAccount: '分配給原始账号',
      toTargetAccount: '分配给指定账号',
      ruleIdGroup: ['按佣金', '自定金额'],
      spreadCommission: '加点',
      externalCommission: '外佣',
      internalCommission: '内返',
      addRule: '添加规则',
      remove: '删除',
      percentage: '百分比',
      extrapercentage: '额外百分比',
      maxlevel: '分层最高金额',
      maxlevel2: '分层最高金额',
      fixamount: '固定金额',
      maxdiff: '与最高内返相差',
      percentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 分 配 ，總 設 定 不 超 過 100 % 。',
      extrapercentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 計 算 ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
      maxlevel_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
      maxlevel2_desc: '按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
      fixamount_desc: '按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
      maxdiff_desc: '按 即 月 交 易 量 達 到 的 內 返 條 件 , 與 最 高 內 返 條 件 的 相 差 來 分 配 佣 金  。相 差 的 金 額 以 輸 入 的 上 限 由 下 到 上 來 分 配 。'
    }
  },
  hk: {
    ibCommissionRuleSetting: {
      currentIB: '當前代理',
      levelIB: '級代理',
      notExist: '不存在',
      rule: '規則',
      product: '產品',
      ALL: '全部',
      toOriginalAccount: '分配給原始賬號',
      toTargetAccount: '分配給指定賬號',
      ruleIdGroup: ['按佣金', '自定金額'],
      spreadCommission: '加點',
      externalCommission: '外佣',
      internalCommission: '內返',
      addRule: '添加規則',
      remove: '刪除',
      percentage: '百分比',
      extrapercentage: '額外百分比',
      maxlevel: '分層最高金額',
      maxlevel2: '分層最高金額',
      fixamount: '固定金額',
      maxdiff: '與最高內返相差',
      percentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 分 配 ，總 設 定 不 超 過 100 % 。',
      extrapercentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 計 算 ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
      maxlevel_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
      maxlevel2_desc: '按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
      fixamount_desc: '按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
      maxdiff_desc: '按 即 月 交 易 量 達 到 的 內 返 條 件 , 與 最 高 內 返 條 件 的 相 差 來 分 配 佣 金  。相 差 的 金 額 以 輸 入 的 上 限 由 下 到 上 來 分 配 。'
    }
  },
  en: {
    ibCommissionRuleSetting: {
      currentIB: 'Current IB',
      levelIB: 'Level IB',
      notExist: 'Not Exist',
      rule: 'Rule',
      product: 'Product',
      ALL: 'ALL',
      toOriginalAccount: 'To Original Account',
      toTargetAccount: 'To Target Account',
      ruleIdGroup: ['Gist Commission', 'Customize Money'],
      spreadCommission: 'Spread Commission',
      externalCommission: 'External Commission',
      internalCommission: 'Internal Commission',
      addRule: 'Add Rule',
      remove: 'Remove',
      percentage: 'Percentage',
      extrapercentage: 'Extrapercentage',
      maxlevel: 'Maxlevel',
      maxlevel2: 'Maxlevel',
      fixamount: 'Fixamount',
      maxdiff: 'Maxdiff',
      percentage_desc: 'percentage_desc',
      extrapercentage_desc: 'extrapercentage_desc',
      maxlevel_desc: 'maxlevel_desc',
      maxlevel2_desc: 'maxlevel2_desc',
      fixamount_desc: 'fixamount_desc',
      maxdiff_desc: 'maxdiff_desc'
    }
  }
};

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(84);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _monthlyIBResult;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    cn: {
        monthlyIBResult: {
            indexText: '代理月结佣金结果',
            text: '代理月结佣金计算结果',
            datailText: '代理月结佣金计算结果明细',
            goback: '返回',
            start_time: "开始时间：",
            end_time: "结束时间：",
            selectTimeText: '选择日期',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            downloadExcelForms: "下载 Excel",
            downloadDetailExcel: "下载明细",
            nodata: "没有查询到数据",
            search: '搜索',
            commissionType: '佣金类别：',
            status: '状态：',
            confirm: '佣金确定',
            reject: '佣金拒绝',
            rejectMessage: '请输入拒绝原因',
            commit: '您真的要确定/拒绝吗?',
            spread: '展开',
            fold: '折叠',
            sheetName: ['额外返佣', '下层返佣'],
            downloadName: '代理月结佣金明细',
            proxyAccount: '代理账号：',
            selectKeys: { "id": "代理账号", "depositAccount": "入金账号" },
            typeList: { "-1": "所有", "0": "额外返佣", "1": "下层返佣" },
            IBStatusList: { "-1": "所有", "2": "未确定", "3": "已确定", "4": "已拒绝" },
            statusList: { "-1": "所有", "0": "未确定", "1": "全部确定", "2": "部分确定" },
            total: { total: "合计", part: "part", index: 1 },
            detailTotal: { total: '合计', lots: '总交易量', index: 2, part: 'part' },
            internal: { internal: '总额外返佣', index: 1, part: 'part' },
            afterrule: { afterrule: '总额外返佣(调整后)', index: 1, part: 'part' },
            monthlyTh: [{ key: 'REPORT_ID', name: '编号' }, { key: 'IBCommissionResult', name: '代理佣金结果', unneed: false }, { key: 'DATE_FROM', name: '开始时间' }, { key: 'DATE_TO', name: '结束时间' }, { key: 'LAST_UPDATE', name: '完成时间', changeTime: true }, { key: 'status', name: '状态' }],
            commmissionTh: [{ key: 'type', name: '佣金类别' }, { key: 'IB_ID', name: '代理账号' }, { key: 'NAME', name: '代理姓名' }, { key: 'AMOUNT', name: '金额' }, { key: 'status', name: '状态' }, { key: 'REJECT_REASON', name: '拒绝原因' }, { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' }, { key: 'DEPOSIT_COMMENT', name: '佣金注解' }, { key: 'UPDATE_BY', name: '最后更新' }, { key: 'LAST_UPDATE', name: '更新时间', changeTime: true }],
            commmissionTh_v2: [{ key: 'type', name: '佣金类别' }, { key: 'IB_ID', name: '代理账号' }, { key: 'NAME', name: '代理姓名' }, { key: 'DEPOSIT_PLATFORM', name: '交易平台' }, { key: 'DEPOSIT_ACCOUNT_ID', name: '入金账号' }, { key: 'AMOUNT', name: '金额' }, { key: 'status', name: '状态' }, { key: 'REJECT_REASON', name: '拒绝原因' }, { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' }, { key: 'DEPOSIT_COMMENT', name: '佣金注解' }, { key: 'UPDATE_BY', name: '最后更新' }, { key: 'LAST_UPDATE', name: '更新时间', changeTime: true }],
            firstTh: {
                TYPE: '佣金类别',
                IB_ID: '代理账号',
                NAME: '代理姓名',
                AMOUNT: '金额(已调整)',
                TOTAL_COMMISSION: '总额外佣金'
            },
            firstTh_v2: {
                TYPE: '佣金类别',
                IB_ID: '代理账号',
                DEPOSIT_ACCOUNT: '入金账号',
                NAME: '代理姓名',
                AMOUNT: '金额(已调整)',
                PLATFORM: '交易平台',
                TOTAL_COMMISSION: '总额外佣金'
            },
            secondTh: {
                TYPE: '佣金类别',
                IB_ID: '代理账号',
                NAME: '代理姓名',
                AMOUNT: '金额',
                SUB_IB_ID: '下层代理账号',
                SUB_DEPOSIT_ACCOUNT: '下层代理入金账号',
                RULE_ID: '规则',
                VALUE: '规则参数',
                PRODUCT_GROUP: '产品',
                TOTAL_VOLUME: '总手数',
                INTERNAL_COMMISSION: '内佣金额',
                INTERNAL_COMMISSION_DIFF: '内佣金额(差值)',
                RULE_COMMISSION: '总金额'
            },
            lowerTh: [{ key: 'ib_id', name: '下层代理账号' }, { key: 'SUB_DEPOSIT_ACCOUNT', name: '下层代理入金账号' }, { key: 'NAME', name: '代理姓名' }, { key: 'rule_id', name: '规则' }, { key: 'VALUE', name: '规则参数' }, { key: 'product_group', name: '产品' }, { key: 'TOTAL_VOLUME', name: '总手数' }, { key: 'INTERNAL_COMMISSION', name: '内佣金额' }, { key: 'INTERNAL_COMMISSION_DIFF', name: '内佣金额(差值)' }, { key: 'RULE_COMMISSION', name: '总金额' }]
        }
    },
    hk: {
        monthlyIBResult: {
            indexText: '代理月結佣金結果',
            text: '代理月結佣金計算結果',
            datailText: '代理月結佣金計算結果明細',
            goback: '返回',
            start_time: "開始時間：",
            end_time: "結束時間：",
            selectTimeText: '選擇日期',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            downloadExcelForms: "下載 Excel",
            downloadDetailExcel: "下載明細",
            search: "搜索",
            nodata: "沒有查詢到數據",
            commissionType: '佣金類別：',
            status: '狀態：',
            confirm: '佣金確定',
            reject: '佣金拒絕',
            rejectMessage: '請輸入拒絕原因',
            commit: '您真的要確定/拒絕嗎?',
            spread: '展開',
            fold: '摺疊',
            sheetName: ['額外返佣', '下層返佣'],
            downloadName: '代理月結佣金明細',
            proxyAccount: '代理賬號：',
            selectKeys: { "0": "代理賬號", "1": "入金賬號" },
            typeList: { "-1": "所有", "0": "額外返佣", "1": "下層返佣" },
            IBStatusList: { "-1": "所有", "2": "未確定", "3": "已確定", "4": "已拒絕" },
            statusList: { "-1": "所有", "0": "未確定", "1": "全部確定", "2": "部分確定" },
            total: { total: "合計", part: "part", index: 1 },
            detailTotal: { total: '合計', lots: '總交易量', index: 2, part: 'part' },
            internal: { internal: '總額外返佣', index: 1, part: 'part' },
            afterrule: { afterrule: '總額外返佣(調整后)', index: 1, part: 'part' },
            monthlyTh: [{ key: 'REPORT_ID', name: '編號' }, { key: 'IBCommissionResult', name: '代理佣金結果', unneed: false }, { key: 'DATE_FROM', name: '開始時間' }, { key: 'DATE_TO', name: '結束時間' }, { key: 'LAST_UPDATE', name: '完成時間', changeTime: true }, { key: 'status', name: '狀態' }],
            commmissionTh: [{ key: 'type', name: '佣金類別' }, { key: 'IB_ID', name: '代理賬號' }, { key: 'NAME', name: '代理姓名' }, { key: 'AMOUNT', name: '金額' }, { key: 'status', name: '狀態' }, { key: 'REJECT_REASON', name: '拒絕原因' }, { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' }, { key: 'DEPOSIT_COMMENT', name: '佣金注解' }, { key: 'UPDATE_BY', name: '最後更新' }, { key: 'LAST_UPDATE', name: '更新時間', changeTime: true }],
            commmissionTh_v2: [{ key: 'type', name: '佣金類別' }, { key: 'IB_ID', name: '代理賬號' }, { key: 'NAME', name: '代理姓名' }, { key: 'DEPOSIT_PLATFORM', name: '交易平台' }, { key: 'DEPOSIT_ACCOUNT_ID', name: '入金賬號' }, { key: 'AMOUNT', name: '金額' }, { key: 'status', name: '狀態' }, { key: 'REJECT_REASON', name: '拒絕原因' }, { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' }, { key: 'DEPOSIT_COMMENT', name: '佣金注解' }, { key: 'UPDATE_BY', name: '最後更新' }, { key: 'LAST_UPDATE', name: '更新時間', changeTime: true }],
            firstTh: {
                TYPE: '佣金類別',
                IB_ID: '代理賬號',
                NAME: '代理姓名',
                AMOUNT: '金額(已調整)',
                TOTAL_COMMISSION: '總額外佣金'
            },
            firstTh_v2: {
                TYPE: '佣金類別',
                IB_ID: '代理賬號',
                DEPOSIT_ACCOUNT: '入金賬號',
                NAME: '代理姓名',
                AMOUNT: '金額(已調整)',
                PLATFORM: '交易平台',
                TOTAL_COMMISSION: '總額外佣金'
            },
            secondTh: {
                TYPE: '佣金類別',
                IB_ID: '代理賬號',
                NAME: '代理姓名',
                AMOUNT: '金額',
                SUB_IB_ID: '下層代理賬號',
                SUB_DEPOSIT_ACCOUNT: '下層代理入金賬號',
                RULE_ID: '規則',
                VALUE: '規則參數',
                PRODUCT_GROUP: '產品',
                TOTAL_VOLUME: '總手數',
                INTERNAL_COMMISSION: '內佣金額',
                INTERNAL_COMMISSION_DIFF: '內佣金額(差值)',
                RULE_COMMISSION: '總金額'
            },
            lowerTh: [{ key: 'ib_id', name: '下層代理賬號' }, { key: 'SUB_DEPOSIT_ACCOUNT', name: '下層代理入金賬號' }, { key: 'NAME', name: '代理姓名' }, { key: 'rule_id', name: '規則' }, { key: 'VALUE', name: '規則參數' }, { key: 'product_group', name: '產品' }, { key: 'TOTAL_VOLUME', name: '總手數' }, { key: 'INTERNAL_COMMISSION', name: '內佣金額' }, { key: 'INTERNAL_COMMISSION_DIFF', name: '內佣金額(差值)' }, { key: 'RULE_COMMISSION', name: '總金額' }]
        }
    },
    en: {
        monthlyIBResult: (_monthlyIBResult = {
            indexText: 'IB Monthly Commission Result',
            text: 'IB Monthly Commission Result',
            datailText: 'IB Monthly Commission Result Detail',
            goback: 'Go Back',
            start_time: "Start Time：",
            end_time: "End Time：",
            selectTimeText: 'Select Date',
            search: 'Search',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            downloadExcelForms: "Download Excel",
            downloadDetailExcel: "Download Detail",
            nodata: "No data found"
        }, (0, _defineProperty3.default)(_monthlyIBResult, 'search', 'Search'), (0, _defineProperty3.default)(_monthlyIBResult, 'commissionType', 'Type：'), (0, _defineProperty3.default)(_monthlyIBResult, 'status', 'Status：'), (0, _defineProperty3.default)(_monthlyIBResult, 'confirm', 'Confirm'), (0, _defineProperty3.default)(_monthlyIBResult, 'reject', 'Reject'), (0, _defineProperty3.default)(_monthlyIBResult, 'rejectMessage', 'Please enter a reject reason'), (0, _defineProperty3.default)(_monthlyIBResult, 'commit', 'Do you really want to confirm/reject?'), (0, _defineProperty3.default)(_monthlyIBResult, 'spread', 'Expand'), (0, _defineProperty3.default)(_monthlyIBResult, 'fold', 'Collapse'), (0, _defineProperty3.default)(_monthlyIBResult, 'sheetName', ['ExtraCommission', 'LowerLevelCommission']), (0, _defineProperty3.default)(_monthlyIBResult, 'downloadName', 'IBMonthlyCommissionDetail'), (0, _defineProperty3.default)(_monthlyIBResult, 'proxyAccount', 'Account：'), (0, _defineProperty3.default)(_monthlyIBResult, 'selectKeys', { "0": "IB Account", "1": "Deposit Account" }), (0, _defineProperty3.default)(_monthlyIBResult, 'typeList', { "-1": "All", "0": "Extra Commission", "1": "Lower Level Commission" }), (0, _defineProperty3.default)(_monthlyIBResult, 'IBStatusList', { "-1": "All", "2": "Unconfirmed", "3": "Confirmed", "4": "Rejected" }), (0, _defineProperty3.default)(_monthlyIBResult, 'statusList', { "-1": "All", "0": "Unconfirmed", "1": "All confirmed", "2": "Partially confirmed" }), (0, _defineProperty3.default)(_monthlyIBResult, 'total', { total: "Total", part: "part", index: 1 }), (0, _defineProperty3.default)(_monthlyIBResult, 'detailTotal', {
            total: 'Total',
            lots: 'Total Volume',
            index: 2,
            part: 'part'
        }), (0, _defineProperty3.default)(_monthlyIBResult, 'internal', { internal: 'Extra Commission Amount', index: 1, part: 'part' }), (0, _defineProperty3.default)(_monthlyIBResult, 'afterrule', { afterrule: 'Extra Commission Amount(After Rule)', index: 1, part: 'part' }), (0, _defineProperty3.default)(_monthlyIBResult, 'monthlyTh', [{ key: 'REPORT_ID', name: 'Record ID' }, { key: 'IBCommissionResult', name: 'IB Commmission Result', unneed: false }, { key: 'DATE_FROM', name: 'Start Time' }, { key: 'DATE_TO', name: 'End Time' }, { key: 'LAST_UPDATE', name: 'Completion Time', changeTime: true }, { key: 'status', name: 'Status' }]), (0, _defineProperty3.default)(_monthlyIBResult, 'commmissionTh', [{ key: 'type', name: 'Commission Type' }, { key: 'IB_ID', name: 'IB Account' }, { key: 'NAME', name: 'IB Name' }, { key: 'AMOUNT', name: 'Amount' }, { key: 'status', name: 'Status' }, { key: 'REJECT_REASON', name: 'Reject Reason' }, { key: 'DEPOSIT_ORDER_ID', name: 'Order ID' }, { key: 'DEPOSIT_COMMENT', name: 'Comment' }, { key: 'UPDATE_BY', name: 'Update By' }, { key: 'LAST_UPDATE', name: 'Last Update', changeTime: true }]), (0, _defineProperty3.default)(_monthlyIBResult, 'commmissionTh_v2', [{ key: 'type', name: 'Commission Type' }, { key: 'IB_ID', name: 'IB Account' }, { key: 'NAME', name: 'IB Name' }, { key: 'DEPOSIT_PLATFORM', name: 'Trade Platform' }, { key: 'DEPOSIT_ACCOUNT_ID', name: 'Deposit Account' }, { key: 'AMOUNT', name: 'Amount' }, { key: 'status', name: 'Status' }, { key: 'REJECT_REASON', name: 'Reject Reason' }, { key: 'DEPOSIT_ORDER_ID', name: 'Order ID' }, { key: 'DEPOSIT_COMMENT', name: 'Comment' }, { key: 'UPDATE_BY', name: 'Update By' }, { key: 'LAST_UPDATE', name: 'Last Update', changeTime: true }]), (0, _defineProperty3.default)(_monthlyIBResult, 'firstTh', {
            TYPE: 'Commission Type',
            IB_ID: 'IB Account',
            NAME: 'IB Name',
            AMOUNT: 'Amount(Adjusted)',
            TOTAL_COMMISSION: 'Total Extra Commission'
        }), (0, _defineProperty3.default)(_monthlyIBResult, 'firstTh_v2', {
            TYPE: 'Commission Type',
            IB_ID: 'IB Account',
            DEPOSIT_ACCOUNT: 'Deposit Account',
            NAME: 'IB Name',
            AMOUNT: 'Amount(Adjusted)',
            PLATFORM: 'Trade Platform',
            TOTAL_COMMISSION: 'Total Extra Commission'
        }), (0, _defineProperty3.default)(_monthlyIBResult, 'secondTh', {
            TYPE: 'Commission Type',
            IB_ID: 'IB Account',
            NAME: 'IB Name',
            AMOUNT: 'Amount',
            SUB_IB_ID: 'Sub IB Account',
            SUB_DEPOSIT_ACCOUNT: 'Sub IB Deposit Account',
            RULE_ID: 'Rule',
            VALUE: 'Rule Parameter',
            PRODUCT_GROUP: 'Product Group',
            TOTAL_VOLUME: 'Total Volume',
            INTERNAL_COMMISSION: 'Internal Commission',
            INTERNAL_COMMISSION_DIFF: 'Internal Commission(Diff)',
            RULE_COMMISSION: 'Rule Commission'
        }), (0, _defineProperty3.default)(_monthlyIBResult, 'lowerTh', [{ key: 'ib_id', name: 'IB Account' }, { key: 'SUB_DEPOSIT_ACCOUNT', name: 'Sub IB Deposit Account' }, { key: 'NAME', name: 'IB Name' }, { key: 'rule_id', name: 'Rule' }, { key: 'VALUE', name: 'Rule Parameter' }, { key: 'product_group', name: 'Product Group' }, { key: 'TOTAL_VOLUME', name: 'Total Volume' }, { key: 'INTERNAL_COMMISSION', name: 'Internal Commission' }, { key: 'INTERNAL_COMMISSION_DIFF', name: 'Internal Commission(Diff)' }, { key: 'RULE_COMMISSION', name: 'Rule Commission' }]), _monthlyIBResult)
    }
};

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        realTimeReport: {
            detail: '实时佣金明细',
            text: '实时佣金结果',
            typeText: '佣金类别：',
            IB_ID: '代理账号：',
            clientAccount: '客户账号：',
            mtlogin: 'MT交易账号：',
            depositAccount: '入金账号：',
            symbol: '交易品种：',
            trade_order_id: '交易单号：',
            deposit_order_id: '佣金单号：',
            start_time: '开始时间：',
            end_time: '结束时间：',
            search: '搜索',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            downloadExcelForms: "下载 Excel",
            downloadDetailExcel: "下载明细",
            downloadFilterExcel: '下载明细(指定账号)',
            nodata: "没有查询到数据",
            selectTimeText: '选择日期',
            moreSelect: '显示更多筛选',
            return: '返回',
            sheetName: ['代理佣金', '下层返佣'],
            downloadName: '实时佣金明细',
            filterName: '实时佣金明细(指定账号)',
            total: { total: "合计", part: "part", index: 1 },
            typeList: { "-1": '全部', "0": '代理佣金', "1": "下层返佣" },
            detailType: { "0": "买入", "1": "卖出" },
            errorMsg: '请填入正确的客户账号或者MT交易账号',
            detailTh: [{ key: 'trade_order_id', name: '交易单号' }, { key: 'IB_ID', name: '代理账号', flag: true }, { key: 'CLIENT_ID', name: '客户账号' }, { key: 'USER_GROUP', name: '组别' }, { key: 'SYMBOL', name: '交易品种' }, { key: 'type', name: '类型' }, { key: 'VOLUME', name: '交易量' }, { key: 'OPEN_TIME', name: '开仓时间' }, { key: 'CLOSE_TIME', name: '平仓时间' },
            // { key: 'EXTERNAL_COMMISSION_REBATE', name: '外佣每手佣金' },
            { key: 'EXTERNAL_COMMISSION_AFTER_RULE', name: '外佣金额' }, { key: 'SPREAD_REBATE', name: '加点每手佣金' }, { key: 'SPREAD_COMMISSION_AFTER_RULE', name: '加点金额' }, { key: 'INTERNAL_COMMISSION_REBATE', name: '内佣每手佣金' }, { key: 'INTERNAL_COMMISSION_AFTER_RULE', name: '内佣金额' }, { key: 'TOTAL_COMMISSION', name: '总金额' }],
            detailTh_v2: [{ key: 'trade_order_id', name: '交易单号' }, { key: 'IB_ID', name: '代理账号', flag: true }, { key: 'CLIENT_ID', name: '客户账号' }, { key: 'PLATFORM', name: '交易平台' }, { key: 'TRADING_ACCOUNT_ID', name: '交易账号' }, { key: 'USER_GROUP', name: '组别' }, { key: 'SYMBOL', name: '交易品种' }, { key: 'type', name: '类型' }, { key: 'VOLUME', name: '交易量' }, { key: 'OPEN_TIME', name: '开仓时间' }, { key: 'CLOSE_TIME', name: '平仓时间' },
            // { key: 'EXTERNAL_COMMISSION_REBATE', name: '外佣每手佣金' },
            { key: 'EXTERNAL_COMMISSION_AFTER_RULE', name: '外佣金额' }, { key: 'SPREAD_REBATE', name: '加点每手佣金' }, { key: 'SPREAD_COMMISSION_AFTER_RULE', name: '加点金额' }, { key: 'INTERNAL_COMMISSION_REBATE', name: '内佣每手佣金' }, { key: 'INTERNAL_COMMISSION_AFTER_RULE', name: '内佣金额' }, { key: 'TOTAL_COMMISSION', name: '总金额' }],
            extraHead: [{ key: 'F_IB_ID', name: '代理账号' }, { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' }, { key: 'DEPOSIT_COMMENT', name: '佣金注解' }, { key: 'DEPOSIT_ACCOUNT_ID', name: '入金账号' }],
            lowerLevel: [{ key: 'ib_id', name: '下层代理账号' }, { key: 'SUB_DEPOSIT_ACCOUNT', name: '下层代理入金账号' }, { key: 'NAME', name: '代理姓名' }, { key: 'rule_id', name: '规则' }, { key: 'VALUE', name: '规则参数' }, { key: 'product_group', name: '产品' }, { key: 'TOTAL_VOLUME', name: '总手数' }, { key: 'EXTERNAL_COMMISSION', name: '外佣金额' }, { key: 'SPREAD_COMMISSION', name: '加点金额' }, { key: 'INTERNAL_COMMISSION', name: '内佣金额' }, { key: 'RULE_COMMISSION', name: '总金额' }],
            realTimeTh: [{ key: 'type', name: '佣金类别' }, { key: 'REPORT_ID', name: '单号', flag: false }, { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' }, { key: 'IB_ID', name: '代理账号' }, { key: 'NAME', name: '代理名称' }, { key: 'AMOUNT', name: '金额' }, { key: 'DEPOSIT_COMMENT', name: '佣金注解' }, { key: 'BEGINTIME', name: '开始时间' }, { key: 'ENDTIME', name: '结束时间' }],
            realTimeTh_v2: [{ key: 'type', name: '佣金类别' }, { key: 'REPORT_ID', name: '单号', flag: false }, { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' }, { key: 'IB_ID', name: '代理账号' }, { key: 'NAME', name: '代理名称' }, { key: 'DEPOSIT_PLATFORM', name: '交易平台' }, { key: 'DEPOSIT_ACCOUNT_ID', name: '入金账号' }, { key: 'AMOUNT', name: '金额' }, { key: 'DEPOSIT_COMMENT', name: '佣金注解' }, { key: 'BEGINTIME', name: '开始时间' }, { key: 'ENDTIME', name: '结束时间' }]
        }
    },
    hk: {
        realTimeReport: {
            detail: '實時佣金明細',
            text: '實時佣金結果',
            typeText: '佣金類別：',
            IB_ID: '代理賬號：',
            clientAccount: '客戶賬號：',
            mtlogin: 'MT交易賬號：',
            depositAccount: '入金賬號：',
            symbol: '交易品種：',
            trade_order_id: '交易單號：',
            deposit_order_id: '佣金單號：',
            start_time: '開始時間：',
            end_time: '結束時間：',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            downloadExcelForms: "下載 Excel",
            downloadDetailExcel: "下載明細",
            downloadFilterExcel: '下載明細(指定賬號)',
            search: "搜索",
            nodata: "没有查询到数据",
            selectTimeText: '選擇日期',
            moreSelect: '顯示更多篩選',
            return: '返回',
            sheetName: ['代理佣金', '下層返佣'],
            downloadName: '實時佣金明細',
            filterName: '實時佣金明細(指定賬號)',
            total: { total: "合計", part: "part", index: 1 },
            typeList: { "-1": '全部', "0": '代理佣金', "1": "下層返佣" },
            detailType: { "0": "買入", "1": "賣出" },
            errorMsg: '請填入正確的客戶賬號或者MT交易賬號',
            detailTh: [{ key: 'trade_order_id', name: '交易單號' }, { key: 'IB_ID', name: '代理賬號', flag: true }, { key: 'CLIENT_ID', name: '客戶賬號' }, { key: 'USER_GROUP', name: '組別' }, { key: 'SYMBOL', name: '交易品種' }, { key: 'type', name: '類型' }, { key: 'VOLUME', name: '交易量' }, { key: 'OPEN_TIME', name: '開倉時間' }, { key: 'CLOSE_TIME', name: '平倉時間' },
            // { key: 'EXTERNAL_COMMISSION_REBATE', name: '外佣每手佣金' },
            { key: 'EXTERNAL_COMMISSION_AFTER_RULE', name: '外佣金額' }, { key: 'SPREAD_REBATE', name: '加點每手佣金' }, { key: 'SPREAD_COMMISSION_AFTER_RULE', name: '加點金額' }, { key: 'INTERNAL_COMMISSION_REBATE', name: '內佣每手佣金' }, { key: 'INTERNAL_COMMISSION_AFTER_RULE', name: '內佣金額' }, { key: 'TOTAL_COMMISSION', name: '總金額' }],
            detailTh_v2: [{ key: 'trade_order_id', name: '交易單號' }, { key: 'IB_ID', name: '代理賬號', flag: true }, { key: 'CLIENT_ID', name: '客戶賬號' }, { key: 'PLATFORM', name: '交易平台' }, { key: 'TRADING_ACCOUNT_ID', name: '交易賬號' }, { key: 'USER_GROUP', name: '組別' }, { key: 'SYMBOL', name: '交易品種' }, { key: 'type', name: '類型' }, { key: 'VOLUME', name: '交易量' }, { key: 'OPEN_TIME', name: '開倉時間' }, { key: 'CLOSE_TIME', name: '平倉時間' },
            // { key: 'EXTERNAL_COMMISSION_REBATE', name: '外佣每手佣金' },
            { key: 'EXTERNAL_COMMISSION_AFTER_RULE', name: '外佣金額' }, { key: 'SPREAD_REBATE', name: '加點每手佣金' }, { key: 'SPREAD_COMMISSION_AFTER_RULE', name: '加點金額' }, { key: 'INTERNAL_COMMISSION_REBATE', name: '內佣每手佣金' }, { key: 'INTERNAL_COMMISSION_AFTER_RULE', name: '內佣金額' }, { key: 'TOTAL_COMMISSION', name: '總金額' }],
            extraHead: [{ key: 'F_IB_ID', name: '代理賬號' }, { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' }, { key: 'DEPOSIT_COMMENT', name: '佣金註解' }, { key: 'DEPOSIT_ACCOUNT_ID', name: '入金賬號' }],
            lowerLevel: [{ key: 'ib_id', name: '下層代理賬號' }, { key: 'SUB_DEPOSIT_ACCOUNT', name: '下層代理入金賬號' }, { key: 'NAME', name: '代理姓名' }, { key: 'rule_id', name: '規則' }, { key: 'VALUE', name: '規則參數' }, { key: 'product_group', name: '產品' }, { key: 'TOTAL_VOLUME', name: '總手數' }, { key: 'EXTERNAL_COMMISSION', name: '外佣金額' }, { key: 'SPREAD_COMMISSION', name: '加點金額' }, { key: 'INTERNAL_COMMISSION', name: '內佣金額' }, { key: 'RULE_COMMISSION', name: '總金額' }],
            realTimeTh: [{ key: 'type', name: '佣金類別' }, { key: 'REPORT_ID', name: '單號', flag: false }, { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' }, { key: 'IB_ID', name: '代理賬號' }, { key: 'NAME', name: '代理名稱' }, { key: 'AMOUNT', name: '金額' }, { key: 'DEPOSIT_COMMENT', name: '佣金註解' }, { key: 'BEGINTIME', name: '開始時間' }, { key: 'ENDTIME', name: '結束時間' }],
            realTimeTh_v2: [{ key: 'type', name: '佣金類別' }, { key: 'REPORT_ID', name: '單號', flag: false }, { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' }, { key: 'IB_ID', name: '代理賬號' }, { key: 'NAME', name: '代理名稱' }, { key: 'DEPOSIT_PLATFORM', name: '交易平台' }, { key: 'DEPOSIT_ACCOUNT_ID', name: '入金賬號' }, { key: 'AMOUNT', name: '金額' }, { key: 'DEPOSIT_COMMENT', name: '佣金註解' }, { key: 'BEGINTIME', name: '開始時間' }, { key: 'ENDTIME', name: '結束時間' }]
        }
    },
    en: {
        realTimeReport: {
            detail: 'Real Time Result Detail',
            text: 'Real Time Result',
            typeText: 'Type：',
            IB_ID: 'Account：',
            clientAccount: 'Client Account：',
            mtlogin: 'Trading Account：',
            depositAccount: 'Deposit Account：',
            symbol: 'Symbol：',
            trade_order_id: 'Trade Order ID：',
            deposit_order_id: 'Order ID：',
            start_time: 'Start Time：',
            end_time: 'End Time：',
            search: 'Search',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            downloadExcelForms: "Download Excel",
            downloadDetailExcel: "Download Detail",
            downloadFilterExcel: "Download Detail(Assign Account)",
            nodata: "No data found",
            selectTimeText: 'Select Date',
            moreSelect: 'Show More Select',
            return: 'Go Back',
            sheetName: ['IB Commission', 'Lower Level Commission'],
            downloadName: 'Realtime Result Detail',
            filterName: 'Realtime Result Detail(Assign Account)',
            total: { total: "TOTAL", part: "part", index: 1 },
            typeList: { "-1": 'All', "0": 'IB Commission', "1": "Lower Level Commission" },
            detailType: { "0": "BUY", "1": "SELL" },
            errorMsg: 'Please fill in the correct client account or MT trading account',
            detailTh: [{ key: 'trade_order_id', name: 'Order ID' }, { key: 'IB_ID', name: 'IB Account', flag: true }, { key: 'CLIENT_ID', name: 'Customer Account' }, { key: 'USER_GROUP', name: 'Group' }, { key: 'SYMBOL', name: 'Symbol' }, { key: 'type', name: 'Type' }, { key: 'VOLUME', name: 'Volume' }, { key: 'OPEN_TIME', name: 'Open Time' }, { key: 'CLOSE_TIME', name: 'Close Time' }, { key: 'EXTERNAL_COMMISSION_REBATE', name: 'External Commission Rebate' }, { key: 'EXTERNAL_COMMISSION_AFTER_RULE', name: 'External Commission After Rule' }, { key: 'SPREAD_REBATE', name: 'Spread Rebate' }, { key: 'SPREAD_COMMISSION_AFTER_RULE', name: 'Spread Commission After Rule' }, { key: 'INTERNAL_COMMISSION_REBATE', name: 'Internal Commission Rebate' }, { key: 'INTERNAL_COMMISSION_AFTER_RULE', name: 'Internal Commission After Rule' }, { key: 'TOTAL_COMMISSION', name: 'Total Commission' }],
            detailTh_v2: [{ key: 'trade_order_id', name: 'Order ID' }, { key: 'IB_ID', name: 'IB Account', flag: true }, { key: 'CLIENT_ID', name: 'Client Account' }, { key: 'PLATFORM', name: 'Trade Platform' }, { key: 'TRADING_ACCOUNT_ID', name: 'Trading Account' }, { key: 'USER_GROUP', name: 'Group' }, { key: 'SYMBOL', name: 'Symbol' }, { key: 'type', name: 'Type' }, { key: 'VOLUME', name: 'Volume' }, { key: 'OPEN_TIME', name: 'Open Time' }, { key: 'CLOSE_TIME', name: 'Close Time' }, { key: 'EXTERNAL_COMMISSION_REBATE', name: 'External Commission Rebate' }, { key: 'EXTERNAL_COMMISSION_AFTER_RULE', name: 'External Commission After Rule' }, { key: 'SPREAD_REBATE', name: 'Spread Rebate' }, { key: 'SPREAD_COMMISSION_AFTER_RULE', name: 'Spread Commission After Rule' }, { key: 'INTERNAL_COMMISSION_REBATE', name: 'Internal Commission Rebate' }, { key: 'INTERNAL_COMMISSION_AFTER_RULE', name: 'Internal Commission After Rule' }, { key: 'TOTAL_COMMISSION', name: 'Total Commission' }],
            extraHead: [{ key: 'F_IB_ID', name: 'IB Account' }, { key: 'DEPOSIT_ORDER_ID', name: 'Deposit Order ID' }, { key: 'DEPOSIT_COMMENT', name: 'Comment' }, { key: 'DEPOSIT_ACCOUNT_ID', name: 'Deposit Account ID' }],
            lowerLevel: [{ key: 'ib_id', name: 'Lower IB Account' }, { key: 'SUB_DEPOSIT_ACCOUNT', name: 'Lower IB Deposit Account' }, { key: 'NAME', name: 'IB Name' }, { key: 'rule_id', name: 'Rule' }, { key: 'VALUE', name: 'Rule Parameter' }, { key: 'product_group', name: 'Product Group' }, { key: 'TOTAL_VOLUME', name: 'Total Volume' }, { key: 'EXTERNAL_COMMISSION', name: 'External Commission' }, { key: 'SPREAD_COMMISSION', name: 'Spread Commission' }, { key: 'INTERNAL_COMMISSION', name: 'Internal Commission' }, { key: 'RULE_COMMISSION', name: 'Rule Commission' }],
            realTimeTh: [{ key: 'type', name: 'Commission Type' }, { key: 'REPORT_ID', name: 'Record ID', flag: false }, { key: 'DEPOSIT_ORDER_ID', name: 'Order ID' }, { key: 'IB_ID', name: 'IB Account' }, { key: 'NAME', name: 'IB Name' }, { key: 'AMOUNT', name: 'Amount' }, { key: 'DEPOSIT_COMMENT', name: 'Comment' }, { key: 'BEGINTIME', name: 'Begin Time' }, { key: 'ENDTIME', name: 'End Time' }],
            realTimeTh_v2: [{ key: 'type', name: 'Commission Type' }, { key: 'REPORT_ID', name: 'Record ID', flag: false }, { key: 'DEPOSIT_ORDER_ID', name: 'Deposit Order ID' }, { key: 'IB_ID', name: 'IB Account' }, { key: 'NAME', name: 'IB Name' }, { key: 'DEPOSIT_PLATFORM', name: 'Trade Platform' }, { key: 'DEPOSIT_ACCOUNT_ID', name: 'Deposit Account' }, { key: 'AMOUNT', name: 'Amount' }, { key: 'DEPOSIT_COMMENT', name: 'Comment' }, { key: 'BEGINTIME', name: 'Begin Time' }, { key: 'ENDTIME', name: 'End Time' }]
        }
    }
};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        spreadCommissionMappingReport: {
            spreadCommission: '加点设定',
            th: {
                symbol: '货币对',
                Commission: '佣金(每10个点)',
                lastUpdate: '最后更新时间',
                operate: '操作',
                add: '添加',
                remove: '删除',
                save: '保存'
            },
            confirmDeleteText: '确定删除这条记录吗？',
            placeholder: '请选择',
            submitResult: {
                err: '请正确填写信息',
                succeed: '保存成功'
            }
        }
    },
    hk: {
        spreadCommissionMappingReport: {
            spreadCommission: '加點設定',
            th: {
                symbol: '貨幣對',
                Commission: '佣金(每10個點)',
                lastUpdate: '最后更新時間',
                operate: '操作',
                add: '添加',
                remove: '刪除',
                save: '保存'
            },
            confirmDeleteText: '確定刪除這條記錄嗎？',
            placeholder: '請選擇',
            submitResult: {
                err: '請正確填寫信息',
                succeed: '保存成功'
            }
        }
    },
    en: {
        spreadCommissionMappingReport: {
            spreadCommission: 'Spread Commission Setting',
            th: {
                symbol: 'Symbol',
                Commission: 'Commission (10 Points per USD)',
                lastUpdate: 'Last Update',
                operate: 'Operation',
                add: 'Add',
                remove: 'Remove',
                save: 'Save'
            },
            confirmDeleteText: 'Are you sure to delete this record?',
            placeholder: 'Please Choose',
            submitResult: {
                err: 'Please fill in the information correctly',
                succeed: 'Save Successsfully'
            }
        }
    }
};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        mtclient: {
            indexText: 'MT用户列表',
            loginText: '账号',
            search: '搜索',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            downloadExcelForms: "下载 Excel",
            nodata: "没有查询到数据",
            tableHead: [{ key: 'enable', name: '启用', sort: true }, { key: 'LOGIN', name: '账号', sort: true }, { key: 'NAME', name: '名称', sort: true }, { key: 'GROUP', name: '组别', sort: true }, { key: 'EMAIL', name: '电邮', sort: true }],
            status: ['禁用', '启用']
        }
    },
    hk: {
        mtclient: {
            indexText: 'MT用戶列表',
            loginText: '賬號',
            search: '搜索',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            downloadExcelForms: "下載 Excel",
            nodata: "沒有查詢到數據",
            tableHead: [{ key: 'enable', name: '啟用', sort: true }, { key: 'LOGIN', name: '賬號', sort: true }, { key: 'NAME', name: '名稱', sort: true }, { key: 'GROUP', name: '組別', sort: true }, { key: 'EMAIL', name: '電郵', sort: true }],
            status: ['禁用', '啟用']
        }
    },
    en: {
        mtclient: {
            indexText: 'MT Client List',
            loginText: 'Login',
            search: 'Search',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            downloadExcelForms: "Download Excel",
            nodata: "No data found",
            tableHead: [{ key: 'enable', name: 'Enable', sort: true }, { key: 'LOGIN', name: 'Login', sort: true }, { key: 'NAME', name: 'Name', sort: true }, { key: 'GROUP', name: 'Group', sort: true }, { key: 'EMAIL', name: 'Email', sort: true }],
            status: ['Disable', 'Enable']
        }
    }
};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        ruleItem: {
            currentSetting: '当前设定',
            levelSetting: '级设定',
            rule: '规则',
            toOriginalAccount: '分配給原始账号',
            toTargetAccount: '分配给指定账号',
            customTheMoney: '自定金额',
            addRule: '添加规则',
            remove: '刪除',
            fixamount_desc: '按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
            maxlevel_desc: '按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
            fixamountnonvip: '固定金额(普通组别)',
            fixamountnonvip_desc: '針 對 普 通 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
            fixamountvip: '固定金額(VIP 組別)',
            fixamountvip_desc: '針 對 V I P 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
            notExist: '不存在',
            notSalesSet: '没有设定销售资料'
        }
    },
    hk: {
        ruleItem: {
            currentSetting: '当前設定',
            levelSetting: '級設定',
            rule: '規則',
            toOriginalAccount: '分配給原始賬號',
            toTargetAccount: '分配給指定賬號',
            customTheMoney: '自定金額',
            addRule: '添加規則',
            remove: '刪除',
            notExist: '不存在',
            notSalesSet: '沒有設定銷售資料',
            fixamount_desc: '按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
            maxlevel_desc: '按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
            fixamountnonvip: '固定金額(普通组别)',
            fixamountnonvip_desc: '針 對 普 通 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
            fixamountvip: '固定金額(VIP 組別)',
            fixamountvip_desc: '針 對 V I P 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。'
        }
    },
    en: {
        ruleItem: {
            currentSetting: 'Current Setting',
            levelSetting: 'Level Setting',
            rule: 'Rule',
            toOriginalAccount: 'To Original Account',
            toTargetAccount: 'To Target Account',
            customTheMoney: 'Custom The Money',
            addRule: 'Add Rule',
            remove: 'Remove',
            notExist: 'Not Exist',
            notSalesSet: 'Not sales data are set',
            fixamount_desc: 'fixamount_desc',
            maxlevel_desc: 'maxlevel_desc',
            fixamountnonvip: 'Fixamountnonvip',
            fixamountnonvip_desc: 'fixamountnonvip_desc',
            fixamountvip: 'Fixamountvip',
            fixamountvip_desc: 'fixamountvip_desc'
        }
    }
};

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        salesCommission: {
            unconfirmed: '未审核的',
            confirmed: '已审核的',
            operate: '操作',
            templateSetting: '模板管理',
            templateName: '模板名称',
            templateHistory: '模板历史',
            templateCreate: '新建模板',
            templateBase: '基础模板',
            preview: {
                subordinateType: '下属类型',
                all: '全部',
                directCustomer: '直接客户',
                directIB: '直接代理',
                other: '其他',
                search: '搜索',
                showClauses: '显示条目数',
                totalClauses: '条目总数',
                current: '当前'
            },
            contrastBrowse: '对比浏览',
            singlepageBrowse: '单页浏览',
            salesCommissionSetting: '销售佣金设定',
            updateBy: '最后修改',
            confirmBy: '最后审核',
            roleCode: {
                UM: '系统',
                C: '公司',
                N: '国家',
                R: '地区',
                O: '办事处',
                M: '经理',
                SL: '销售',
                IB: '代理',
                CL: '客户'
            },
            alertMsg: {
                noAccount: '这不是一个正确的账号',
                alreadyExist: '已经存在了',
                IBNotFound: '查不到该代理账号',
                employeeNotFound: '查不到该员工账号',
                verifyTips: '是否确定审核，如果数据有修改，请先保存，否则将被覆盖!',
                checkFail: '不能由同一人完成修改和审核',
                beforeSave: '请先保存数据',
                checkRuleFail1: '分配账号设定不同。',
                checkRuleFail2: '固定金额与固定金额(普通组别)、固定金额(VIP 组别)不能同时选择。',
                checkRuleFail3: '相同规则下，全部客户类型与其他客户类型冲突。',
                checkRuleFail4: '存在重复的规则设定。',
                checkRuleFail5: '存在“分层最高金额”这个规则时，每个级别都必须有一条“分层最高金额”，并保证“客户类型”一致。',
                templateExist: '模板名已存在!'
            },
            saleAccount: '销售账号',
            excelTh: {
                type: '类型',
                Account: '收取佣金的账号',
                name: '收取佣金人姓名',
                ID: '其下属账号',
                TYPE: '其下属类型',
                REBATE: '收取佣金金额(美元/手)'
            },
            downloadExcel: '下载 Excel',
            virtualAccout: '虚拟账号',
            virtualIB: '虚拟代理',
            noData: '没有数据',
            recordCount: '条记录',
            crumbs: {
                amend: "佣金修改"
            },
            submitResult: {
                err: '请正确填写信息',
                succeed: '成功保存',
                auditSuccess: '审核成功',
                serverErr: '提交失败'
            },
            enable: '启用',
            costPerCommission: '每手佣金',
            btnGroup: {
                submit: '保存修改',
                add: '添加',
                remove: '删除',
                confirmDeleteText: '确认删除所选记录吗？',
                commissionPreviewBtn: '佣金预览',
                back: '返回',
                addLevel: '添加级别',
                removeLevel: '删除级别',
                check: '确认审核',
                backData: '返回之前数据'
            },
            overlookIB: '被忽略的代理',
            ibAccount: '代理账号',
            ibName: '代理姓名',
            allLowIB: '所有下层代理',
            specialIB: '特别代理佣金分配',
            filteText: '下属类型',
            seekPlaceholder: '搜索',
            seekBtnText: '搜索',
            previewThead: [{ text: '主账号' }, { text: '下层类型' }, { text: '下层账号' }, { text: '下层姓名' }, { text: '关系类型' }, { text: '主账号获取下层账号佣金条件' }],
            lowType: [{ key: "特别代理", val: 'specialIB' }, { key: "代理", val: 'IB' }, { key: "额外员工", val: 'extraEmployee' }, { key: "员工", val: 'employee' }],
            settingTemplate: '设定模板',
            sales_sales: '员工设定',
            sales_manager: '经理设定',
            sales_uae_level_1: 'LEVEL 1',
            sales_uae_level_2: 'LEVEL 2',
            sales_uae_level_3: 'LEVEL 3'
        }
    },
    hk: {
        salesCommission: {
            unconfirmed: '未審核的',
            confirmed: '已審核的',
            operate: '操作',
            templateSetting: '模板管理',
            templateName: '模板名称',
            templateHistory: '模板历史',
            templateCreate: '新建模板',
            templateBase: '基礎模板',
            preview: {
                subordinateType: '下屬類型',
                all: '全部',
                directCustomer: '直接客戶',
                directIB: '直接代理',
                other: '其他',
                search: '搜索',
                showClauses: '顯示條目數',
                totalClauses: '條目總數',
                current: '當前'
            },
            contrastBrowse: '對比瀏覽',
            singlepageBrowse: '單頁瀏覽',
            salesCommissionSetting: '銷售佣金設定',
            updateBy: '最后修改',
            confirmBy: '最后審核',
            roleCode: {
                UM: '系統',
                C: '公司',
                N: '國家',
                R: '地區',
                O: '辦事處',
                M: '經理',
                SL: '銷售',
                IB: '代理',
                CL: '客戶'
            },
            alertMsg: {
                noAccount: '這不是一個正確的賬號',
                alreadyExist: '已經存在了',
                IBNotFound: '查不到代理賬號',
                employeeNotFound: '查不到員工賬號',
                verifyTips: '是否確定審核，如果數據有修改，請先保存，否則將被覆蓋!',
                checkFail: '不能由同一人完成修改和審核',
                beforeSave: '請先保存數據',
                checkRuleFail1: '分配賬號設定不同。',
                checkRuleFail2: '固定金額與固定金額（普通組別）、固定金額（VIP 組別）不能同時選擇。',
                checkRuleFail3: '相同規則下，全部客戶類型與其他客戶類型沖突。',
                checkRuleFail4: '存在重復的規則設定。',
                checkRuleFail5: '存在“分層最高金額”這個規則時，每個級別都必須有一條“分層最高金額”，并保證“客戶類型”一致',
                templateExist: '模板名已存在!'
            },
            saleAccount: '銷售賬號',
            excelTh: {
                type: '類型',
                Account: '收取佣金賬號',
                name: '收取佣金人姓名',
                ID: '其下屬賬號',
                TYPE: '其下屬類型',
                REBATE: '收取佣金金額(美圓/手)'
            },
            downloadExcel: '下載 Excel',
            virtualAccout: '虛擬賬號',
            virtualIB: '虛擬代理',
            noData: '沒有數據',
            recordCount: '條記錄',
            crumbs: {
                amend: "佣金修改"
            },
            submitResult: {
                err: '請正確填寫信息',
                succeed: '成功保存',
                auditSuccess: '審核成功',
                serverErr: '提交失敗'
            },
            enable: '啟用',
            costPerCommission: '每手佣金',
            btnGroup: {
                submit: '保存修改',
                add: '添加',
                remove: '删除',
                confirmDeleteText: '確認刪除所選記錄嗎？',
                commissionPreviewBtn: '佣金預覽',
                back: '返回',
                addLevel: '添加級別',
                removeLevel: '刪除級別',
                check: '確認審核',
                backData: '返回之前數據'
            },
            overlookIB: '被忽略的代理',
            ibAccount: '代理賬號',
            ibName: '代理姓名',
            specialIB: '特別代理佣金分配',
            allLowIB: '所有下層代理',
            filteText: '下屬類型',
            seekPlaceholder: '搜索',
            seekBtnText: '搜索',
            previewThead: [{ text: '主賬號' }, { text: '下層類型' }, { text: '下層賬號' }, { text: '下層姓名' }, { text: '關系類型' }, { text: '主賬號獲取下層賬號傭金條件' }],
            lowType: [{ key: "特別代理", val: 'specialIB' }, { key: "代理", val: 'IB' }, { key: "額外員工", val: 'extraEmployee' }, { key: "員工", val: 'employee' }],
            settingTemplate: '設定模版',
            sales_sales: '員工設定',
            sales_manager: '經理設定',
            sales_uae_level_1: 'LEVEL 1',
            sales_uae_level_2: 'LEVEL 2',
            sales_uae_level_3: 'LEVEL 3'
        }
    },
    en: {
        salesCommission: {
            unconfirmed: 'unconfirmed',
            confirmed: 'confirmed',
            operate: 'operate',
            templateSetting: 'Template Maintenance',
            templateName: 'Template Name',
            templateHistory: 'Template History',
            templateCreate: 'New Template',
            templateBase: 'Base Template',
            preview: {
                subordinateType: 'Subordinate Type',
                all: 'ALL',
                directCustomer: 'Direct Customer',
                directIB: 'Direct IB',
                other: 'Other',
                search: 'Search',
                showClauses: 'Display Record Count',
                totalClauses: 'Record Total Count',
                current: 'Current'
            },
            contrastBrowse: 'Contrast Browse',
            singlepageBrowse: 'Singlepage Browse',
            salesCommissionSetting: 'Sales Commission Setting',
            updateBy: 'UpdateBy',
            confirmBy: 'ConfirmBy',
            roleCode: {
                UM: 'UM',
                C: 'COMPANY',
                N: 'COUNTRY',
                R: 'REGION',
                O: 'OFFICE',
                M: 'MANAGER',
                SL: 'SALES',
                IB: 'IB',
                CL: 'CLIENT'
            },
            alertMsg: {
                noAccount: 'Invalid Account',
                alreadyExist: 'Already exists',
                IBNotFound: 'IB account not found',
                employeeNotFound: 'Employee account not found',
                verifyTips: 'Whether to confirm audit, if the data has been modified, please save first, otherwise it will be overwritten!',
                checkFail: 'Can not check Modification and inspection by same person',
                beforeSave: 'Please save the data first',
                checkRuleFail1: 'Check Rule Setting Fail : 1',
                checkRuleFail2: 'Check Rule Setting Fail : 2',
                checkRuleFail3: 'Check Rule Setting Fail : 3',
                checkRuleFail4: 'Check Rule Setting Fail : 4',
                checkRuleFail5: 'Check Rule Setting Fail : 5',
                templateExist: 'Template Name Already Exist!'
            },
            saleAccount: 'Sales Account',
            excelTh: {
                type: 'Type',
                Account: 'Get Commission Account',
                name: 'Get Commission Name',
                ID: 'Subordinate Account',
                TYPE: 'Subordinate Type',
                REBATE: 'Get Cost Per Commission(Lots)'
            },
            downloadExcel: 'Download Excel',
            virtualAccout: 'Virtual Accout',
            virtualIB: 'Virtual IB',
            noData: 'No data',
            recordCount: 'record',
            crumbs: {
                amend: "Amend Commission"
            },
            submitResult: {
                err: 'Please fill in the information correctly',
                succeed: 'Save successfully',
                auditSuccess: 'Check Successfully',
                serverErr: 'Submit failed!'
            },
            enable: 'Enable',
            costPerCommission: 'Cost Per Commission',
            btnGroup: {
                submit: 'Save',
                add: 'Add',
                remove: 'Remove',
                confirmDeleteText: 'Are you sure to delete this record?',
                commissionPreviewBtn: 'Commission preview',
                back: 'Back',
                addLevel: 'Add Level',
                removeLevel: 'Remove Level',
                check: 'Check',
                backData: 'Back To Before Data'
            },
            overlookIB: 'Overlook IB',
            ibAccount: 'IB Account',
            ibName: 'IB Name',
            specialIB: 'Special IB',
            allLowIB: 'All Low IB',
            filteText: 'Low Type',
            seekPlaceholder: 'Search',
            seekBtnText: 'Search',
            previewThead: [{ text: 'Main Account' }, { text: 'Subordinate Type' }, { text: 'Subordinate Account' }, { text: 'Subordinate Name' }, { text: 'Relation Type' }, { text: 'Main Account To Obtain The Subordinate Account Commission Conditions' }],
            lowType: [{ key: "SpecialIB", val: 'specialIB' }, { key: "IB", val: 'IB' }, { key: "Extra Employee", val: 'extraEmployee' }, { key: "Employee", val: 'employee' }],
            settingTemplate: 'Setting Template',
            sales_sales: 'Sales Rebate',
            sales_manager: 'Manager Rebate',
            sales_uae_level_1: 'LEVEL 1',
            sales_uae_level_2: 'LEVEL 2',
            sales_uae_level_3: 'LEVEL 3'
        }
    }
};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        salesMonthlyResult: {
            indexText: '销售月结佣金结果',
            text: '销售月结佣金计算结果',
            datailText: '销售月结佣金计算结果明细',
            goback: '返回',
            start_time: "开始时间：",
            end_time: "结束时间：",
            selectTimeText: '选择日期',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            downloadExcelForms: "下载 Excel",
            downloadDetailExcel: "下载明细",
            nodata: "没有查询到数据",
            search: '搜索',
            commissionType: '佣金类别：',
            salesAccount: '销售账号：',
            status: '状态：',
            confirm: '佣金确定',
            reject: '佣金拒绝',
            rejectMessage: '请输入拒绝原因',
            spread: '展开',
            fold: '折叠',
            commit: '您真的要确定/拒绝吗?',
            downloadName: '销售月结佣金明细',
            selectKeys: { "id": "销售账号", "depositAccount": "入金账号" },
            typeList: { "-1": "所有", "0": "月结佣金", "1": "下层返佣" },
            statusList: { "-1": "所有", "2": "未确定", "3": "已确定", "4": "已拒绝" },
            indexStatusList: { "-1": "所有", "0": "未确定", "1": "全部确定", "2": "部分确定" },
            levelObj: { UN: '系统', C: '公司', N: '国家', R: '地区', O: '办事处', M: '经理', SL: '销售', IB: '代理', CL: '客户' },
            client_type: { "0": "全部客户", "1": "代理", "2": "直客", "3": "直客(VIP)", "4": "代理(VIP)" },
            indexTh: [{ key: 'REPORT_ID', name: '编号' }, { key: 'saleCommResult', name: '销售佣金结果', unneed: false }, { key: 'DATE_FROM', name: '开始时间' }, { key: 'DATE_TO', name: '结束时间' }, { key: 'LAST_UPDATE', name: '完成时间', changeTime: true }, { key: 'status', name: '状态' }],
            detailTotal: {
                TOTAL_LOTS: '合计手数',
                TOTAL_REBATE: '每手佣金',
                TOTAL_COMMISSION: '员工所得佣金',
                TOTAL: '的月结佣金',
                index: 2,
                part: 'part'
            },
            total: { total: '合计', index: 1, part: 'part' },
            commmissionTh: [{ key: 'type', name: '佣金类别' }, { key: 'SALES_ID', name: '销售账号' }, { key: 'NAME', name: '销售姓名' }, { key: 'level', name: '级别' }, { key: 'AMOUNT', name: '金额' }, { key: 'status', name: '状态' }, { key: 'REJECT_REASON', name: '拒绝原因' }, { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' }, { key: 'DEPOSIT_COMMENT', name: '佣金注解' }, { key: 'UPDATE_BY', name: '最后更新' }, { key: 'LAST_UPDATE', name: '更新时间', changeTime: true }],
            commmissionTh_v2: [{ key: 'type', name: '佣金类别' }, { key: 'SALES_ID', name: '销售账号' }, { key: 'NAME', name: '销售姓名' }, { key: 'level', name: '级别' }, { key: 'DEPOSIT_PLATFORM', name: '交易平台' }, { key: 'DEPOSIT_ACCOUNT_ID', name: '入金账号' }, { key: 'AMOUNT', name: '金额' }, { key: 'status', name: '状态' }, { key: 'REJECT_REASON', name: '拒绝原因' }, { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' }, { key: 'DEPOSIT_COMMENT', name: '佣金注解' }, { key: 'UPDATE_BY', name: '最后更新' }, { key: 'LAST_UPDATE', name: '更新时间', changeTime: true }],
            downloadTh: [{ key: 'TYPE', name: '佣金类别' }, { key: 'SALES_ID', name: '销售账号' }, { key: 'NAME', name: '销售姓名' }, { key: 'LEVEL', name: '级别' }, { key: 'AMOUNT', name: '金额' }, { key: 'ID', name: '账号' }, { key: 'LOW_LEVEL', name: '级别' }, { key: 'CLIENT_TYPE', name: '客户类别' }, { key: 'TOTAL_VOLUME', name: '交易量' }, { key: 'REBATE', name: '每手佣金' }, { key: 'TOTAL_COMMISSION', name: '所得金额' }],
            downloadTh_v2: [{ key: 'TYPE', name: '佣金类别' }, { key: 'SALES_ID', name: '销售账号' }, { key: 'NAME', name: '销售姓名' }, { key: 'LEVEL', name: '级别' }, { key: 'AMOUNT', name: '金额' }, { key: 'ID', name: '账号' }, { key: 'DEPOSIT_ACCOUNT', name: '代理入金账号' }, { key: 'LOW_LEVEL', name: '级别' }, { key: 'CLIENT_TYPE', name: '客户类别' }, { key: 'PLATFORM', name: '交易平台' }, { key: 'TOTAL_VOLUME', name: '交易量' }, { key: 'REBATE', name: '每手佣金' }, { key: 'TOTAL_COMMISSION', name: '所得金额' }],
            lowerTh: [{ key: 'sub_sales_id', name: '下层销售账号' }, { key: 'NAME', name: '销售姓名' }, { key: 'level', name: '级别' }, { key: 'rule_id', name: '规则' }, { key: 'VALUE', name: '规则参数' }, { key: 'client_type', name: '客户类别' }, { key: 'TOTAL_VOLUME', name: '总手数' }, { key: 'RULE_COMMISSION', name: '总金额' }],
            detailTh: {
                IB_ID: '代理账号',
                CLIENT_ID: '客户账号',
                FX_LOT: '外汇(手数)',
                FX_REBATE: '外汇(每手佣金)',
                FX_COMMISSION: '外汇(内佣)',
                GOLD_LOT: '黄金(手数)',
                GOLD_REBATE: '黄金(每手佣金)',
                GOLD_COMMISSION: '黄金(内佣)',
                SILVER_LOT: '白银(手数)',
                SILVER_REBATE: '白银(每手佣金)',
                SILVER_COMMISSION: '白银(内佣)',
                ENERGY_LOT: '能源(手数)',
                ENERGY_REBATE: '能源(每手佣金)',
                ENERGY_COMMISSION: '能源(内佣)',
                INDEX_LOT: '指数(手数)',
                INDEX_REBATE: '指数(每手佣金)',
                INDEX_COMMISSION: '指数(内佣)'
            },
            detailTh_v2: {
                IB_ID: '代理账号',
                PLATFORM: '交易平台',
                CLIENT_ID: '客户账号',
                TRADING_ACCOUNT_ID: '交易账号',
                FX_LOT: '外汇(手数)',
                FX_REBATE: '外汇(每手佣金)',
                FX_COMMISSION: '外汇(内佣)',
                GOLD_LOT: '黄金(手数)',
                GOLD_REBATE: '黄金(每手佣金)',
                GOLD_COMMISSION: '黄金(内佣)',
                SILVER_LOT: '白银(手数)',
                SILVER_REBATE: '白银(每手佣金)',
                SILVER_COMMISSION: '白银(内佣)',
                ENERGY_LOT: '能源(手数)',
                ENERGY_REBATE: '能源(每手佣金)',
                ENERGY_COMMISSION: '能源(内佣)',
                INDEX_LOT: '指数(手数)',
                INDEX_REBATE: '指数(每手佣金)',
                INDEX_COMMISSION: '指数(内佣)'
            }
        }
    },
    hk: {
        salesMonthlyResult: {
            indexText: '銷售月結佣金結果',
            text: '銷售月結佣金計算結果',
            datailText: '銷售月結佣金計算結果明細',
            goback: '返回',
            start_time: "開始時間：",
            end_time: "結束時間：",
            selectTimeText: '選擇日期',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            downloadExcelForms: "下載 Excel",
            downloadDetailExcel: "下載明細",
            search: "搜索",
            nodata: "沒有查詢到數據",
            commissionType: '佣金類別：',
            salesAccount: '銷售賬號：',
            status: '狀態：',
            confirm: '佣金確定',
            reject: '佣金拒絕',
            rejectMessage: '請輸入拒絕原因',
            spread: '展開',
            fold: '摺疊',
            commit: '您真的要確定/拒絕嗎?',
            downloadName: '銷售月結佣金明細',
            selectKeys: { "id": "銷售賬號", "depositAccount": "入金賬號" },
            typeList: { "-1": "所有", "0": "月結佣金", "1": "下層返佣" },
            statusList: { "-1": "所有", "2": "未確定", "3": "已確定", "4": "已拒絕" },
            indexStatusList: { "-1": "所有", "0": "未確定", "1": "全部確定", "2": "部分確定" },
            client_type: { "0": "全部客戶", "1": "代理", "2": "直客", "3": "直客(VIP)", "4": "代理(VIP)" },
            levelObj: {
                UN: '系統',
                C: '公司',
                N: '國家',
                R: '地區',
                O: '辦事處',
                M: '經理',
                SL: '銷售',
                IB: '代理',
                CL: '客戶'
            },
            indexTh: [{ key: 'REPORT_ID', name: '編號' }, { key: 'saleCommResult', name: '銷售佣金結果', unneed: false }, { key: 'DATE_FROM', name: '開始時間' }, { key: 'DATE_TO', name: '結束時間' }, { key: 'LAST_UPDATE', name: '完成時間', changeTime: true }, { key: 'status', name: '狀態' }],
            detailTotal: {
                TOTAL_LOTS: '合計手數',
                TOTAL_REBATE: '每手佣金',
                TOTAL_COMMISSION: '員工所得佣金',
                TOTAL: '的月結佣金',
                index: 2,
                part: 'part'
            },
            total: { total: '合計', index: 1, part: 'part' },
            commmissionTh: [{ key: 'type', name: '佣金類別' }, { key: 'SALES_ID', name: '銷售賬號' }, { key: 'NAME', name: '銷售姓名' }, { key: 'level', name: '級別' }, { key: 'AMOUNT', name: '金額' }, { key: 'status', name: '狀態' }, { key: 'REJECT_REASON', name: '拒絕原因' }, { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' }, { key: 'DEPOSIT_COMMENT', name: '佣金注解' }, { key: 'UPDATE_BY', name: '最後更新' }, { key: 'LAST_UPDATE', name: '更新時間', changeTime: true }],
            commmissionTh_v2: [{ key: 'type', name: '佣金類別' }, { key: 'SALES_ID', name: '銷售賬號' }, { key: 'NAME', name: '銷售姓名' }, { key: 'level', name: '級別' }, { key: 'DEPOSIT_PLATFORM', name: '交易平台' }, { key: 'DEPOSIT_ACCOUNT_ID', name: '入金賬號' }, { key: 'AMOUNT', name: '金額' }, { key: 'status', name: '狀態' }, { key: 'REJECT_REASON', name: '拒絕原因' }, { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' }, { key: 'DEPOSIT_COMMENT', name: '佣金注解' }, { key: 'UPDATE_BY', name: '最後更新' }, { key: 'LAST_UPDATE', name: '更新時間', changeTime: true }],
            downloadTh: [{ key: 'TYPE', name: '佣金類別' }, { key: 'SALES_ID', name: '銷售賬號' }, { key: 'NAME', name: '销售姓名' }, { key: 'LEVEL', name: '級別' }, { key: 'AMOUNT', name: '金額' }, { key: 'ID', name: '賬號' }, { key: 'LOW_LEVEL', name: '級別' }, { key: 'CLIENT_TYPE', name: '客戶類別' }, { key: 'TOTAL_VOLUME', name: '交易量' }, { key: 'REBATE', name: '每手佣金' }, { key: 'TOTAL_COMMISSION', name: '所得金額' }],
            downloadTh_v2: [{ key: 'TYPE', name: '佣金類別' }, { key: 'SALES_ID', name: '銷售賬號' }, { key: 'NAME', name: '销售姓名' }, { key: 'LEVEL', name: '級別' }, { key: 'AMOUNT', name: '金額' }, { key: 'ID', name: '賬號' }, { key: 'DEPOSIT_ACCOUNT', name: '代理入金賬號' }, { key: 'LOW_LEVEL', name: '級別' }, { key: 'CLIENT_TYPE', name: '客戶類別' }, { key: 'PLATFORM', name: '交易平台' }, { key: 'TOTAL_VOLUME', name: '交易量' }, { key: 'REBATE', name: '每手佣金' }, { key: 'TOTAL_COMMISSION', name: '所得金額' }],
            lowerTh: [{ key: 'sub_sales_id', name: '下層銷售賬號' }, { key: 'NAME', name: '銷售姓名' }, { key: 'level', name: '級別' }, { key: 'rule_id', name: '規則' }, { key: 'VALUE', name: '規則參數' }, { key: 'client_type', name: '客戶類別' }, { key: 'TOTAL_VOLUME', name: '總手數' }, { key: 'RULE_COMMISSION', name: '總金額' }],
            detailTh: {
                IB_ID: '代理賬號',
                CLIENT_ID: '客戶賬號',
                FX_LOT: '外匯(手數)',
                FX_REBATE: '外匯(每手佣金)',
                FX_COMMISSION: '外匯(內佣)',
                GOLD_LOT: '黃金(手數)',
                GOLD_REBATE: '黃金(每手佣金)',
                GOLD_COMMISSION: '黃金(內佣)',
                SILVER_LOT: '白銀(手數)',
                SILVER_REBATE: '白銀(每手佣金)',
                SILVER_COMMISSION: '白銀(內佣)',
                ENERGY_LOT: '能源(手數)',
                ENERGY_REBATE: '能源(每手佣金)',
                ENERGY_COMMISSION: '能源(內佣)',
                INDEX_LOT: '指數(手數)',
                INDEX_REBATE: '指數(每手佣金)',
                INDEX_COMMISSION: '指數(內佣)'
            },
            detailTh_v2: {
                IB_ID: '代理賬號',
                PLATFORM: '交易平台',
                CLIENT_ID: '客戶賬號',
                TRADING_ACCOUNT_ID: '交易賬號',
                FX_LOT: '外匯(手數)',
                FX_REBATE: '外匯(每手佣金)',
                FX_COMMISSION: '外匯(內佣)',
                GOLD_LOT: '黃金(手數)',
                GOLD_REBATE: '黃金(每手佣金)',
                GOLD_COMMISSION: '黃金(內佣)',
                SILVER_LOT: '白銀(手數)',
                SILVER_REBATE: '白銀(每手佣金)',
                SILVER_COMMISSION: '白銀(內佣)',
                ENERGY_LOT: '能源(手數)',
                ENERGY_REBATE: '能源(每手佣金)',
                ENERGY_COMMISSION: '能源(內佣)',
                INDEX_LOT: '指數(手數)',
                INDEX_REBATE: '指數(每手佣金)',
                INDEX_COMMISSION: '指數(內佣)'
            }
        }
    },
    en: {
        salesMonthlyResult: {
            indexText: 'Sales Monthly Commission Result',
            text: 'Sales Monthly Commission Result',
            datailText: 'Sales Monthly Commission Result Detail',
            goback: 'Go Back',
            start_time: "Start Time：",
            end_time: "End Time：",
            selectTimeText: 'Select Date',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            downloadExcelForms: "Download Excel",
            downloadDetailExcel: "Download Detail",
            search: "Search",
            nodata: "No data found",
            commissionType: 'Type：',
            salesAccount: 'Account：',
            status: 'Status：',
            confirm: 'Confirm',
            reject: 'Reject',
            rejectMessage: 'Please enter a reject reason',
            spread: 'Expand',
            fold: 'Collapse',
            commit: 'Do you really want to confirm/reject?',
            downloadName: 'Sales Monthly Commission Detail',
            selectKeys: { "id": "Account", "depositAccount": "Deposit Account" },
            typeList: { "-1": "All", "0": "Monthly Commission", "1": "Lower Level Commission" },
            statusList: { "-1": "All", "2": "Unconfirmed", "3": "Confirmed", "4": "Rejected" },
            indexStatusList: { "-1": "All", "0": "Unconfirmed", "1": "All Confirmed", "2": "Partially Confirmed" },
            client_type: { "0": "All Clients", "1": "IB", "2": "Sub Clients", "3": "Sub Clients(VIP)", "4": "IB(VIP)" },
            levelObj: {
                UN: 'SYSTEM',
                C: 'COMPANY',
                N: 'COUNTRY',
                R: 'REGION',
                O: 'OFFICE',
                M: 'MANAGER',
                SL: 'SALES',
                IB: 'IB',
                CL: 'CLIENT'
            },
            indexTh: [{ key: 'REPORT_ID', name: 'Record ID' }, { key: 'saleCommResult', name: 'Sales Commission Result', unneed: false }, { key: 'DATE_FROM', name: 'Start Time' }, { key: 'DATE_TO', name: 'End Time' }, { key: 'LAST_UPDATE', name: 'Completion Time', changeTime: true }, { key: 'status', name: 'Status' }],
            detailTotal: {
                TOTAL_LOTS: 'Total Lot',
                TOTAL_REBATE: 'Rebate',
                TOTAL_COMMISSION: 'Staff Commission',
                TOTAL: '\'s Monthly Commission',
                index: 2,
                part: 'part'
            },
            total: { total: 'Total', index: 1, part: 'part' },
            commmissionTh: [{ key: 'type', name: 'Commission Type' }, { key: 'SALES_ID', name: 'Sales Account' }, { key: 'NAME', name: 'Sales Name' }, { key: 'level', name: 'Level' }, { key: 'AMOUNT', name: 'Amount' }, { key: 'status', name: 'Status' }, { key: 'REJECT_REASON', name: 'Reject Reason' }, { key: 'DEPOSIT_ORDER_ID', name: 'Order ID' }, { key: 'DEPOSIT_COMMENT', name: 'Comment' }, { key: 'UPDATE_BY', name: 'Update By' }, { key: 'LAST_UPDATE', name: 'Last Update', changeTime: true }],
            commmissionTh_v2: [{ key: 'type', name: 'Commission Type' }, { key: 'SALES_ID', name: 'Sales Account' }, { key: 'NAME', name: 'Sales Name' }, { key: 'level', name: 'Level' }, { key: 'DEPOSIT_PLATFORM', name: 'Trade Platform' }, { key: 'DEPOSIT_ACCOUNT_ID', name: 'Deposit Account' }, { key: 'AMOUNT', name: 'Amount' }, { key: 'status', name: 'Status' }, { key: 'REJECT_REASON', name: 'Reject Reason' }, { key: 'DEPOSIT_ORDER_ID', name: 'Order ID' }, { key: 'DEPOSIT_COMMENT', name: 'Comment' }, { key: 'UPDATE_BY', name: 'Update By' }, { key: 'LAST_UPDATE', name: 'Last Update', changeTime: true }],
            downloadTh: [{ key: 'TYPE', name: 'Commission Type' }, { key: 'SALES_ID', name: 'Sales Account' }, { key: 'NAME', name: 'Sales Name' }, { key: 'LEVEL', name: 'Level' }, { key: 'AMOUNT', name: 'Amount' }, { key: 'ID', name: 'Account' }, { key: 'LOW_LEVEL', name: 'Level' }, { key: 'CLIENT_TYPE', name: 'Client Type' }, { key: 'TOTAL_VOLUME', name: 'Volume' }, { key: 'REBATE', name: 'Rebate' }, { key: 'TOTAL_COMMISSION', name: 'Total Commission' }],
            downloadTh_v2: [{ key: 'TYPE', name: 'Commission Type' }, { key: 'SALES_ID', name: 'Sales Account' }, { key: 'NAME', name: 'Sales Name' }, { key: 'LEVEL', name: 'Level' }, { key: 'AMOUNT', name: 'Amount' }, { key: 'ID', name: 'Account' }, { key: 'DEPOSIT_ACCOUNT', name: 'IB Deposit Account' }, { key: 'LOW_LEVEL', name: 'Level' }, { key: 'CLIENT_TYPE', name: 'Client Type' }, { key: 'PLATFORM', name: 'Trading Platform' }, { key: 'TOTAL_VOLUME', name: 'Volume' }, { key: 'REBATE', name: 'Rebate' }, { key: 'TOTAL_COMMISSION', name: 'Total Commission' }],
            lowerTh: [{ key: 'sub_sales_id', name: 'Sub Sales Account' }, { key: 'NAME', name: 'Sales Name' }, { key: 'level', name: 'Level' }, { key: 'rule_id', name: 'Rule' }, { key: 'VALUE', name: 'Rule Param' }, { key: 'client_type', name: 'Client Type' }, { key: 'TOTAL_VOLUME', name: 'Volume' }, { key: 'RULE_COMMISSION', name: 'Total Commission' }],
            detailTh: {
                IB_ID: 'IB Account',
                CLIENT_ID: 'Client Account',
                FX_LOT: 'FX(LOTS)',
                FX_REBATE: 'FX(Rebate)',
                FX_COMMISSION: 'FX(Internal Commission)',
                GOLD_LOT: 'GOLD(LOTS)',
                GOLD_REBATE: 'GOLD(Rebate)',
                GOLD_COMMISSION: 'GOLD(Internal Commission)',
                SILVER_LOT: 'SILVER(LOTS)',
                SILVER_REBATE: 'SILVER(Rebate)',
                SILVER_COMMISSION: 'SILVER(Internal Commission)',
                ENERGY_LOT: 'ENERGY(LOTS)',
                ENERGY_REBATE: 'ENERGY(Rebate)',
                ENERGY_COMMISSION: 'ENERGY(Internal Commission)',
                INDEX_LOT: 'INDEX(LOTS)',
                INDEX_REBATE: 'INDEX(Rebate)',
                INDEX_COMMISSION: 'INDEX(Internal Commission)'
            },
            detailTh_v2: {
                IB_ID: 'IB Account',
                PLATFORM: 'Platform',
                CLIENT_ID: 'Client Account',
                TRADING_ACCOUNT_ID: 'Trading Account',
                FX_LOT: 'FX(LOTS)',
                FX_REBATE: 'FX(Rebate)',
                FX_COMMISSION: 'FX(Internal Commission)',
                GOLD_LOT: 'GOLD(LOTS)',
                GOLD_REBATE: 'GOLD(Rebate)',
                GOLD_COMMISSION: 'GOLD(Internal Commission)',
                SILVER_LOT: 'SILVER(LOTS)',
                SILVER_REBATE: 'SILVER(Rebate)',
                SILVER_COMMISSION: 'SILVER(Internal Commission)',
                ENERGY_LOT: 'ENERGY(LOTS)',
                ENERGY_REBATE: 'ENERGY(Rebate)',
                ENERGY_COMMISSION: 'ENERGY(Internal Commission)',
                INDEX_LOT: 'INDEX(LOTS)',
                INDEX_REBATE: 'INDEX(Rebate)',
                INDEX_COMMISSION: 'INDEX(Internal Commission)'
            }
        }
    }
};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        commissionSeek: {
            account: '账号',
            seek: '搜索',
            dropdown: {
                loginId: '登录账号',
                userName: '账户名称',
                IBcode: 'IB代码',
                phone: '电话',
                email: '电子邮箱'
            }
        }
    },
    hk: {
        commissionSeek: {
            account: '賬號',
            seek: '搜索',
            dropdown: {
                loginId: '登錄帳號',
                userName: '帳戶名稱',
                IBcode: 'IB代碼',
                phone: '電話',
                email: '電子郵箱'
            }
        }
    },
    en: {
        commissionSeek: {
            account: 'Account',
            seek: 'Search',
            dropdown: {
                loginId: 'Login Account',
                userName: 'Account Name',
                IBcode: 'IB Code',
                phone: 'Phone',
                email: 'Email'
            }
        }
    }
};

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        commissionTable: {
            relationshipListReport: '关系图报表',
            isSetting: {
                allStatus: '全部状态',
                sated: '已设定',
                checked: '已审核',
                unchecked: '未审核',
                unsated: '未设定'

            },
            ibStatus: {
                enable: '启用',
                disenable: '禁用'
            },
            ibSpecialType: {
                all: '全部',
                special: '特殊返佣',
                normal: '普通返佣'
            },
            ibTempOverwriteType: ['未改写模版', '已改写模版', '全部'],
            ibreport: {
                text: '已激活代理报表',
                ibAccountText: '代理账号：',
                statusText: '状态：',
                statusList: { "-1": "全部", "0": "已激活", "1": "未激活", "2": "不活跃", "3": "已关闭" }
            },
            ibTh: [{ key: 'IB_ID', name: '代理的账号', sort: true }, { key: 'NAME', name: '代理姓名', sort: true }, { key: 'status', name: '状态', sort: true }, { key: 'FIRST_REBATE_TIME', name: '激活时间', sort: true, changeTime: true }, { key: 'LAST_REBATE_TIME', name: '最后收取佣金时间', sort: true, changeTime: true }],
            showName: '显示名字',
            th: {
                settingStatus: '设定状态',
                IBgroup: '组别',
                specialCommission: '特殊返佣',
                loginId: "登录账号",
                ibcAccount: "收佣账号",
                IBCode: "IB代码",
                accountName: "账户名称",
                phone: "电话",
                email: "电子邮箱",
                updateBy: "修改人",
                confirmBy: "审核人",
                template: "模版",
                remark: "备注",
                last_update: "最后修改时间",
                status: "状态",
                officeState: {
                    name: "职员状态",
                    countryArr: [{ text: "全职", value: "F" }, { text: "兼职", value: "P" }, { text: "离职", value: "D" }]
                },
                employeeState: {
                    F: '全职',
                    P: '兼职',
                    D: '离职'
                },
                loginType: {
                    name: "类型",
                    typeArr: [{ text: '系统', value: "UN" }, { text: '公司', value: "C" }, { text: '国家', value: "N" }, { text: '地区', value: "R" }, { text: '办事处', value: "O" }, { text: '经理', value: "M" }, { text: '销售', value: "SL" }, { text: '代理', value: "IB" }, { text: '客户', value: "CL" }],
                    roleType: {
                        UN: '系统',
                        UPUN1: '上层系统',
                        UPUN2: '上层系统',
                        UPUN3: '上层系统',
                        UPUN4: '上层系统',
                        UPUN5: '上层系统',
                        UPUN6: '上层系统',
                        UPUN7: '上层系统',
                        UPUN8: '上层系统',
                        UPUN9: '上层系统',
                        UPUN10: '上层系统',
                        C: '公司',
                        UPC1: "上层公司",
                        UPC2: "上层公司",
                        UPC3: "上层公司",
                        UPC4: "上层公司",
                        UPC5: "上层公司",
                        UPC6: "上层公司",
                        UPC7: "上层公司",
                        UPC8: "上层公司",
                        UPC9: "上层公司",
                        UPC10: "上层公司",
                        N: '国家',
                        UPN1: "上层国家",
                        UPN2: "上层国家",
                        UPN3: "上层国家",
                        UPN4: "上层国家",
                        UPN5: "上层国家",
                        UPN6: "上层国家",
                        UPN7: "上层国家",
                        UPN8: "上层国家",
                        UPN9: "上层国家",
                        UPN10: "上层国家",
                        R: '地区',
                        UPR1: '上层地区',
                        UPR2: '上层地区',
                        UPR3: '上层地区',
                        UPR4: '上层地区',
                        UPR5: '上层地区',
                        UPR6: '上层地区',
                        UPR7: '上层地区',
                        UPR8: '上层地区',
                        UPR9: '上层地区',
                        UPR10: '上层地区',
                        O: '办事处',
                        UPO1: '上层办事处',
                        UPO2: '上层办事处',
                        UPO3: '上层办事处',
                        UPO4: '上层办事处',
                        UPO5: '上层办事处',
                        UPO6: '上层办事处',
                        UPO7: '上层办事处',
                        UPO8: '上层办事处',
                        UPO9: '上层办事处',
                        UPO10: '上层办事处',
                        M: '经理',
                        UPM1: '上层经理',
                        UPM2: '上层经理',
                        UPM3: '上层经理',
                        UPM4: '上层经理',
                        UPM5: '上层经理',
                        UPM6: '上层经理',
                        UPM7: '上层经理',
                        UPM8: '上层经理',
                        UPM9: '上层经理',
                        UPM10: '上层经理',
                        SL: '销售',
                        UPSL1: '上级销售',
                        UPSL2: '上级销售',
                        UPSL3: '上级销售',
                        UPSL4: '上级销售',
                        UPSL5: '上级销售',
                        UPSL6: '上级销售',
                        UPSL7: '上级销售',
                        UPSL8: '上级销售',
                        UPSL9: '上级销售',
                        UPSL10: '上级销售',
                        IB: '代理',
                        UPIB1: '上级代理',
                        UPIB2: '上级代理',
                        UPIB3: '上级代理',
                        UPIB4: '上级代理',
                        UPIB5: '上级代理',
                        UPIB6: '上级代理',
                        UPIB7: '上级代理',
                        UPIB8: '上级代理',
                        UPIB9: '上级代理',
                        UPIB10: '上级代理',
                        CL: '客户',
                        TD: "交易账号"
                    }
                },
                operation: "操作"
            },
            clauses_text: "显示条目数",
            all: "全部",
            amount: "总数",
            present: "当前",
            refreshData: "全部数据",
            downloadExcelForms: "下载Excel",
            search: "搜索",
            nodata: "没有查询到数据",
            ibcAccount: "收佣账号",
            modifyTime: "修改时间",
            confirmTime: "审核时间"
        }
    },
    hk: {
        commissionTable: {
            relationshipListReport: '關系圖報表',
            isSetting: {
                allStatus: '全部狀態',
                sated: '已設定',
                checked: '已審核',
                unchecked: '未審核',
                unsated: '未設定'
            },
            ibStatus: {
                enable: '啟用',
                disenable: '禁用'
            },
            ibSpecialType: {
                all: '全部',
                special: '特殊返佣',
                normal: '普通返佣'
            },
            ibTempOverwriteType: ['未改写模版', '已改写模版', '全部'],
            ibreport: {
                text: '已激活代理報表',
                ibAccountText: '代理賬號：',
                statusText: '狀態：',
                statusList: { "-1": "全部", "0": "已激活", "1": "未激活", "2": "不活躍", "3": "已關閉" }
            },
            ibTh: [{ key: 'IB_ID', name: '代理的賬號', sort: true }, { key: 'NAME', name: '代理姓名', sort: true }, { key: 'status', name: '狀態', sort: true }, { key: 'FIRST_REBATE_TIME', name: '激活時間', sort: true, changeTime: true }, { key: 'LAST_REBATE_TIME', name: '最後收取佣金時間', sort: true, changeTime: true }],
            showName: '顯示名字',
            th: {
                settingStatus: '設定狀態',
                IBgroup: '組別',
                specialCommission: '特殊返佣',
                loginId: "登錄賬號",
                ibcAccount: "收佣賬號",
                IBCode: "IB代碼",
                accountName: "帳戶名稱",
                phone: "電話",
                email: "電子郵箱",
                updateBy: "修改人",
                confirmBy: "審核人",
                template: "模版",
                remark: "備註",
                last_update: "最後修改時間",
                status: "狀態",
                officeState: {
                    name: "職員狀態",
                    countryArr: [{ text: "全職", value: "F" }, { text: "兼職", value: "P" }, { text: "離職", value: "D" }]
                },
                employeeState: {
                    F: '全職',
                    P: '兼職',
                    D: '離職'
                },
                loginType: {
                    name: "類型",
                    typeArr: [{ text: '系統', value: "UN" }, { text: '公司', value: "C" }, { text: '國家', value: "N" }, { text: '地區', value: "R" }, { text: '辦事處', value: "O" }, { text: '經理', value: "M" }, { text: '銷售', value: "SL" }, { text: '代理', value: "IB" }, { text: '客戶', value: "CL" }],
                    roleType: {
                        UN: '系統',
                        UPUN1: "上級系統",
                        UPUN2: "上級系統",
                        UPUN3: "上級系統",
                        UPUN4: "上級系統",
                        UPUN5: "上級系統",
                        UPUN6: "上級系統",
                        UPUN7: "上級系統",
                        UPUN8: "上級系統",
                        UPUN9: "上級系統",
                        UPUN10: "上級系統",
                        C: '公司',
                        UPC1: "上級公司",
                        UPC2: "上級公司",
                        UPC3: "上級公司",
                        UPC4: "上級公司",
                        UPC5: "上級公司",
                        UPC6: "上級公司",
                        UPC7: "上級公司",
                        UPC8: "上級公司",
                        UPC9: "上級公司",
                        UPC10: "上級公司",
                        N: '國家',
                        UPN1: "上級國家",
                        UPN2: "上級國家",
                        UPN3: "上級國家",
                        UPN4: "上級國家",
                        UPN5: "上級國家",
                        UPN6: "上級國家",
                        UPN7: "上級國家",
                        UPN8: "上級國家",
                        UPN9: "上級國家",
                        UPN10: "上級國家",
                        R: '地區',
                        UPR1: "上級地區",
                        UPR2: "上級地區",
                        UPR3: "上級地區",
                        UPR4: "上級地區",
                        UPR5: "上級地區",
                        UPR6: "上級地區",
                        UPR7: "上級地區",
                        UPR8: "上級地區",
                        UPR9: "上級地區",
                        UPR10: "上級地區",
                        O: '辦事處',
                        UPO1: '上級辦事處',
                        UPO2: '上級辦事處',
                        UPO3: '上級辦事處',
                        UPO4: '上級辦事處',
                        UPO5: '上級辦事處',
                        UPO6: '上級辦事處',
                        UPO7: '上級辦事處',
                        UPO8: '上級辦事處',
                        UPO9: '上級辦事處',
                        UPO10: '上級辦事處',
                        M: '經理',
                        UPM1: '上級經理',
                        UPM2: '上級經理',
                        UPM3: '上級經理',
                        UPM4: '上級經理',
                        UPM5: '上級經理',
                        UPM6: '上級經理',
                        UPM7: '上級經理',
                        UPM8: '上級經理',
                        UPM9: '上級經理',
                        UPM10: '上級經理',
                        SL: '銷售',
                        UPSL1: '上級銷售',
                        UPSL2: '上級銷售',
                        UPSL3: '上級銷售',
                        UPSL4: '上級銷售',
                        UPSL5: '上級銷售',
                        UPSL6: '上級銷售',
                        UPSL7: '上級銷售',
                        UPSL8: '上級銷售',
                        UPSL9: '上級銷售',
                        UPSL10: '上級銷售',
                        IB: '代理',
                        UPIB1: '上級代理',
                        UPIB2: '上級代理',
                        UPIB3: '上級代理',
                        UPIB4: '上級代理',
                        UPIB5: '上級代理',
                        UPIB6: '上級代理',
                        UPIB7: '上級代理',
                        UPIB8: '上級代理',
                        UPIB9: '上級代理',
                        UPIB10: '上級代理',
                        CL: '客戶',
                        TD: '交易賬號'
                    }
                },
                operation: "操作"
            },
            clauses_text: "顯示條目數",
            all: "全部",
            amount: "總數",
            present: "當前",
            refreshData: "全部數據",
            downloadExcelForms: "下載Excel",
            search: "搜索",
            nodata: "没有查询到数据",
            ibcAccount: "收佣賬號",
            modifyTime: "修改時間",
            confirmTime: "審核時間"
        }
    },
    en: {
        commissionTable: {
            relationshipListReport: 'Relationship List Report',
            isSetting: {
                allStatus: 'All Status',
                sated: 'Configured',
                checked: 'Checked',
                unchecked: 'Unchecked',
                unsated: 'Unconfigured'
            },
            ibStatus: {
                enable: 'Enable',
                disenable: 'Disable'
            },
            ibSpecialType: {
                all: 'All',
                special: 'special',
                normal: 'normal'
            },
            ibTempOverwriteType: ['Not Overwritten', 'Overwritten', 'All'],
            ibreport: {
                text: 'Activated IB Report',
                ibAccountText: 'IB Account：',
                statusText: 'Status：',
                statusList: { "-1": "All", "0": "Activated", "1": "Inactive", "2": "Non-Activated", "3": "Closed" }
            },
            ibTh: [{ key: 'IB_ID', name: 'IB Account', sort: true }, { key: 'NAME', name: 'IB Name', sort: true }, { key: 'status', name: 'Status', sort: true }, { key: 'FIRST_REBATE_TIME', name: 'Activation Time', sort: true, changeTime: true }, { key: 'LAST_REBATE_TIME', name: 'Last Rebate Time', sort: true, changeTime: true }],
            showName: 'Show Name',
            th: {
                settingStatus: 'Setting Status',
                IBgroup: 'Group',
                specialCommission: 'Special',
                loginId: "Login Account",
                ibcAccount: "Commission Account",
                IBCode: "IB Code",
                accountName: "Account Name",
                phone: "Phone",
                email: "Email",
                updateBy: "Update By",
                confirmBy: "Confirm By",
                template: "Template",
                remark: "Remark",
                last_update: "Last Modification ",
                status: "Status",
                officeState: {
                    name: "Employee Status",
                    countryArr: [{ text: "full time", value: "F" }, { text: "part time", value: "P" }, { text: "Leave", value: "D" }]
                },
                employeeState: {
                    F: 'full time',
                    P: 'part time',
                    D: 'Leave'
                },
                loginType: {
                    name: "Types of",
                    typeArr: [{ text: 'SYSTEM', value: "UN" }, { text: 'COMPANY', value: "C" }, { text: 'COUNTRY', value: "N" }, { text: 'REGION', value: "R" }, { text: 'OFFICE', value: "O" }, { text: 'MANAGER', value: "M" }, { text: 'SALES', value: "SL" }, { text: 'IB', value: "IB" }, { text: 'cCLIENT', value: "CL" }],
                    roleType: {
                        UN: 'SYSTEM',
                        UPUN1: 'UPPER SYSTEM',
                        UPUN2: 'UPPER SYSTEM',
                        UPUN3: 'UPPER SYSTEM',
                        UPUN4: 'UPPER SYSTEM',
                        UPUN5: 'UPPER SYSTEM',
                        UPUN6: 'UPPER SYSTEM',
                        UPUN7: 'UPPER SYSTEM',
                        UPUN8: 'UPPER SYSTEM',
                        UPUN9: 'UPPER SYSTEM',
                        UPUN10: 'UPPER SYSTEM',
                        C: 'COMPANY',
                        UPC1: "UPPER COMPANY",
                        UPC2: "UPPER COMPANY",
                        UPC3: "UPPER COMPANY",
                        UPC4: "UPPER COMPANY",
                        UPC5: "UPPER COMPANY",
                        UPC6: "UPPER COMPANY",
                        UPC7: "UPPER COMPANY",
                        UPC8: "UPPER COMPANY",
                        UPC9: "UPPER COMPANY",
                        UPC10: "UPPER COMPANY",
                        N: 'COUNTRY',
                        UPN1: "UPPER COUNTRY",
                        UPN2: "UPPER COUNTRY",
                        UPN3: "UPPER COUNTRY",
                        UPN4: "UPPER COUNTRY",
                        UPN5: "UPPER COUNTRY",
                        UPN6: "UPPER COUNTRY",
                        UPN7: "UPPER COUNTRY",
                        UPN8: "UPPER COUNTRY",
                        UPN9: "UPPER COUNTRY",
                        UPN10: "UPPER COUNTRY",
                        R: 'REGION',
                        UPR1: 'UPPER REGION',
                        UPR2: 'UPPER REGION',
                        UPR3: 'UPPER REGION',
                        UPR4: 'UPPER REGION',
                        UPR5: 'UPPER REGION',
                        UPR6: 'UPPER REGION',
                        UPR7: 'UPPER REGION',
                        UPR8: 'UPPER REGION',
                        UPR9: 'UPPER REGION',
                        UPR10: 'UPPER REGION',
                        O: 'OFFICE',
                        UPO1: 'UPPER OFFICE',
                        UPO2: 'UPPER OFFICE',
                        UPO3: 'UPPER OFFICE',
                        UPO4: 'UPPER OFFICE',
                        UPO5: 'UPPER OFFICE',
                        UPO6: 'UPPER OFFICE',
                        UPO7: 'UPPER OFFICE',
                        UPO8: 'UPPER OFFICE',
                        UPO9: 'UPPER OFFICE',
                        UPO10: 'UPPER OFFICE',
                        M: 'MANAGER',
                        UPM1: 'UPPER MANAGER',
                        UPM2: 'UPPER MANAGER',
                        UPM3: 'UPPER MANAGER',
                        UPM4: 'UPPER MANAGER',
                        UPM5: 'UPPER MANAGER',
                        UPM6: 'UPPER MANAGER',
                        UPM7: 'UPPER MANAGER',
                        UPM8: 'UPPER MANAGER',
                        UPM9: 'UPPER MANAGER',
                        UPM10: 'UPPER MANAGER',
                        SL: 'SALES',
                        UPSL1: 'UPPER SALES',
                        UPSL2: 'UPPER SALES',
                        UPSL3: 'UPPER SALES',
                        UPSL4: 'UPPER SALES',
                        UPSL5: 'UPPER SALES',
                        UPSL6: 'UPPER SALES',
                        UPSL7: 'UPPER SALES',
                        UPSL8: 'UPPER SALES',
                        UPSL9: 'UPPER SALES',
                        UPSL10: 'UPPER SALES',
                        IB: 'IB',
                        UPIB1: 'UPPER IB',
                        UPIB2: 'UPPER IB',
                        UPIB3: 'UPPER IB',
                        UPIB4: 'UPPER IB',
                        UPIB5: 'UPPER IB',
                        UPIB6: 'UPPER IB',
                        UPIB7: 'UPPER IB',
                        UPIB8: 'UPPER IB',
                        UPIB9: 'UPPER IB',
                        UPIB10: 'UPPER IB',
                        CL: 'CLIENT',
                        TD: "Trading Account"
                    }
                },
                operation: "Operation"
            },
            clauses_text: "Display",
            all: "All",
            amount: " Total Count",
            present: "Current",
            refreshData: "Refresh Data",
            downloadExcelForms: "Download Excel",
            search: "Search",
            nodata: "No data found",
            ibcAccount: "Commission Account",
            modifyTime: "Mofify Time",
            confirmTime: "Confirm Time"
        }
    }
};

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        commissionView: {
            title: '佣金设定',
            role: {
                ib: '代理佣金设定',
                sale: '销售佣金设定'
            }
        }
    },
    hk: {
        commissionView: {
            title: '佣金設定',
            role: {
                ib: '代理佣金設定',
                sale: '銷售佣金設定'
            }
        }
    },
    en: {
        commissionView: {
            title: 'Commission Setting',
            role: {
                ib: 'IB Commission Setting',
                sale: 'Sales Commission Setting'
            }
        }
    }
};

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        ibPrimary: {
            back: '返回',
            commissionSetting: '佣金设定',
            templateSetting: '模板管理',
            ibResult: {
                title: '代理结果',
                list: [{ text: '实时佣金结果', link: '/ib/realTimeResult' }, { text: '月结佣金结果', link: '/ib/monthlyIBResult' }, { text: 'CPA佣金结果', link: '/ib/CPACommissionResult' }]
            },
            ibResult_v2: {
                title: '代理结果',
                list: [{ text: '实时佣金结果', link: '/ib_v2/realTimeResult' }, { text: '月结佣金结果', link: '/ib_v2/monthlyIBResult' }, { text: 'CPA佣金结果', link: '/ib_v2/CPACommissionResult' }]
            },
            ibReport: {
                title: '代理报表',
                list: [{ text: '已激活代理报表', link: '/ib/ibReport' }, { text: '审核跟踪报表', link: '/ib/auditTrailReport' },
                // { text: '加点设定', link: '/ib/spreadCommissionMappingReport' },
                { text: '代理佣金设定报表', link: '/ib/allCommissionReport' },
                // { text: '佣金设定提醒忽略表', link: '/ib/alert-ignore-list' },
                { text: '佣金设定提醒忽略表', link: '/ib/alert-ignore-list2' }, { text: '模板管理', link: '/ib/ibTemplateSetting' }]
            },
            ibReport_v2: {
                title: '代理报表',
                list: [{ text: '审核跟踪报表', link: '/ib_v2/auditTrailReport' },
                // { text: '加点设定', link: '/ib_v2/spreadCommissionMappingReport' },
                { text: '代理佣金设定报表', link: '/ib_v2/allCommissionReport' },
                // { text: '佣金设定提醒忽略表', link: '/ib_v2/alert-ignore-list' },
                { text: '佣金设定提醒忽略表', link: '/ib_v2/alert-ignore-list2' }, { text: '模板管理', link: '/ib_v2/ibTemplateSetting' }]
            }
        }
    },
    hk: {
        ibPrimary: {
            back: '返回',
            commissionSetting: '佣金設定',
            templateSetting: '模板管理',
            ibResult: {
                title: '代理結果',
                list: [{ text: '實時佣金結果', link: '/ib/realTimeResult' }, { text: '月結佣金結果', link: '/ib/monthlyIBResult' }, { text: 'CPA佣金結果', link: '/ib/CPACommissionResult' }]
            },
            ibResult_v2: {
                title: '代理結果',
                list: [{ text: '實時佣金結果', link: '/ib_v2/realTimeResult' }, { text: '月結佣金結果', link: '/ib_v2/monthlyIBResult' }, { text: 'CPA佣金結果', link: '/ib_v2/CPACommissionResult' }]
            },
            ibReport: {
                title: '代理報表',
                list: [{ text: '已激活代理報表', link: '/ib/ibReport' }, { text: '審核跟蹤報表', link: '/ib/auditTrailReport' },
                // { text: '加點設定', link: '/ib/spreadCommissionMappingReport' },
                { text: '代理佣金設定報表', link: '/ib/allCommissionReport' },
                // { text: '佣金設定提醒忽略表', link: '/ib/alert-ignore-list' },
                { text: '佣金設定提醒忽略表', link: '/ib/alert-ignore-list2' }, { text: '模板管理', link: '/ib/ibTemplateSetting' }]
            },
            ibReport_v2: {
                title: '代理報表',
                list: [{ text: '審核跟蹤報表', link: '/ib_v2/auditTrailReport' },
                // { text: '加點設定', link: '/ib_v2/spreadCommissionMappingReport' },
                { text: '代理佣金設定報表', link: '/ib_v2/allCommissionReport' },
                // { text: '佣金設定提醒忽略表', link: '/ib_v2/alert-ignore-list' },
                { text: '佣金設定提醒忽略表', link: '/ib_v2/alert-ignore-list2' }, { text: '模板管理', link: '/ib_v2/ibTemplateSetting' }]
            }
        }
    },
    en: {
        ibPrimary: {
            back: 'Back',
            commissionSetting: 'Commission Setting',
            templateSetting: 'Template Maintenance',
            ibResult: {
                title: 'IB Result',
                list: [{ text: 'Real Time Result', link: '/ib/realTimeResult' }, { text: 'Monthly IB Result', link: '/ib/monthlyIBResult' }, { text: 'CPA Result', link: '/ib/CPACommissionResult' }]
            },
            ibResult_v2: {
                title: 'IB Result',
                list: [{ text: 'Real Time Result', link: '/ib_v2/realTimeResult' }, { text: 'Monthly IB Result', link: '/ib_v2/monthlyIBResult' }, { text: 'CPA Result', link: '/ib_v2/CPACommissionResult' }]
            },
            ibReport: {
                title: 'IB Report',
                list: [{ text: 'Activated IB Report', link: '/ib/ibReport' }, { text: 'Audit Trail Report', link: '/ib/auditTrailReport' },
                // { text: 'Spread Commission Setting', link: '/ib/spreadCommissionMappingReport' },
                { text: 'IB Commission Setting Report', link: '/ib/allCommissionReport' },
                // { text: 'IB Commission Alert Ignores', link: '/ib/alert-ignore-list' },
                { text: 'IB Commission Alert Ignores', link: '/ib/alert-ignore-list2' }, { text: 'Template Maintenance', link: '/ib/ibTemplateSetting' }]
            },
            ibReport_v2: {
                title: 'IB Report',
                list: [{ text: 'Audit Trail Report', link: '/ib_v2/auditTrailReport' },
                // { text: 'Spread Commission Setting', link: '/ib_v2/spreadCommissionMappingReport' },
                { text: 'IB Commission Setting Report', link: '/ib_v2/allCommissionReport' },
                // { text: 'IB Commission Alert Ignores', link: '/ib_v2/alert-ignore-list' },
                { text: 'IB Commission Alert Ignores', link: '/ib_v2/alert-ignore-list2' }, { text: 'Template Maintenance', link: '/ib_v2/ibTemplateSetting' }]
            }
        }
    }
};

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(84);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    cn: {
        publicLan: {
            type: (0, _defineProperty3.default)({
                SL: '销售',
                M: '经理',
                IB: '代理',
                CL: '客户',
                extraEmployee: '额外员工',
                specialIB: '特别代理',
                employee: '员工',
                UN: "系统",
                C: '公司',
                N: '国家',
                R: '地区',
                O: '办事处'
            }, 'M', '经理'),
            relationType: {
                relation: '关系图',
                extra: '佣金转发',
                special: '额外添加'
            },
            clientType: {
                allClient: '全部客戶',
                IBClient: '代理客户',
                directClient: '直接客户'
            },
            rule: {
                percentage: "百分比",
                extrapercentage: "额外百分比",
                maxlevel: "分层最高金额(按佣金)",
                fixamount: "固定金额",
                maxlevel2: "分层最高金额(自定金额)",
                maxdiff: "与最高内返相差",
                fixamountnonvip: "固定金额(普通组别)",
                fixamountvip: "固定金额(VIP组别)",
                percentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 分 配 ，總 設 定 不 超 過 100 % 。',
                extrapercentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 計 算 ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
                maxlevel_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
                maxlevel2_desc: '按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
                fixamount_desc: '按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
                maxdiff_desc: '按 即 月 交 易 量 達 到 的 內 返 條 件 , 與 最 高 內 返 條 件 的 相 差 來 分 配 佣 金  。相 差 的 金 額 以 輸 入 的 上 限 由 下 到 上 來 分 配 。',
                fixamountnonvip_desc: '針 對 普 通 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
                fixamountvip_desc: '針 對 V I P 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。'
            },
            products: {
                ALL: '全部',

                FX: '外汇',
                FX_VIP: '外汇(VIP)',
                GOLD: '黄金',
                GOLD_VIP: '黄金(VIP)',
                SILVER: '白银',
                SILVER_VIP: '白银(VIP)',
                ENERGY: '能源',
                ENERGY_VIP: '能源(VIP)',
                INDEX: '指数',
                INDEX_VIP: '指数(VIP)',
                FX_MAJOR: '外汇(主要)',
                FX_MAJOR_VIP: '外汇(主要)(VIP)',
                FX_MINOR: '外汇(次要)',
                FX_MINOR_VIP: '外汇(次要)(VIP)',
                FX_EXOTIC: '外汇(其他)',
                FX_EXOTIC_VIP: '外汇(其他)(VIP)',
                BTC: '比特币',
                BTC_VIP: '比特币(VIP)',
                ETH_LTC: '以太币&莱特币',
                ETH_LTC_VIP: '以太币&莱特币(VIP)',
                FUTURE_GOLD: '黄金期货',
                FUTURE_GOLD_VIP: '黄金期货(VIP)',
                FUTURE_SILVER: '白银期货',
                FUTURE_SILVER_VIP: '白银期货(VIP)',
                FUTURE_COPPER: '黄铜期货',
                FUTURE_COPPER_VIP: '黄铜期货(VIP)',
                FUTURE_NATGAS: '天然气期货',
                FUTURE_NATGAS_VIP: '天然气期货(VIP)',
                COPPER: '铜',
                COPPER_VIP: '铜(VIP)'
            },
            detailTh: {
                IB_ID: '代理账号',
                CLIENT_ID: '客户账号',
                PLATFORM: '交易平台',
                TRADING_ACCOUNT_ID: '交易账号',

                FX_LOT: '外汇(手数)',
                FX_REBATE_DIFF: '外汇(每手差值)',
                FX_COMMISSION_DIFF: '外汇(额外佣金)',
                FX_VIP_LOT: '外汇(VIP)(手数)',
                FX_VIP_REBATE_DIFF: '外汇(VIP)(每手差值)',
                FX_VIP_COMMISSION_DIFF: '外汇(VIP)(额外佣金)',

                GOLD_LOT: '黄金(手数)',
                GOLD_REBATE_DIFF: '黄金(每手差值)',
                GOLD_COMMISSION_DIFF: '黄金(额外佣金)',
                GOLD_VIP_LOT: '黄金(VIP)(手数)',
                GOLD_VIP_REBATE_DIFF: '黄金(VIP)(每手差值)',
                GOLD_VIP_COMMISSION_DIFF: '黄金(VIP)(额外佣金)',

                SILVER_LOT: '白银(手数)',
                SILVER_REBATE_DIFF: '白银(每手差值)',
                SILVER_COMMISSION_DIFF: '白银(额外佣金)',
                SILVER_VIP_LOT: '白银(VIP)(手数)',
                SILVER_VIP_REBATE_DIFF: '白银(VIP)(每手差值)',
                SILVER_VIP_COMMISSION_DIFF: '白银(VIP)(额外佣金)',

                ENERGY_LOT: '能源(手数)',
                ENERGY_REBATE_DIFF: '能源(每手差值)',
                ENERGY_COMMISSION_DIFF: '能源(额外佣金)',
                ENERGY_VIP_LOT: '能源((VIP)(手数)',
                ENERGY_VIP_REBATE_DIFF: '能源((VIP)(每手差值)',
                ENERGY_VIP_COMMISSION_DIFF: '能源((VIP)(额外佣金)',

                INDEX_LOT: '指数(手数)',
                INDEX_REBATE_DIFF: '指数(每手差值)',
                INDEX_COMMISSION_DIFF: '指数(额外佣金)',
                INDEX_VIP_LOT: '指数(VIP)(手数)',
                INDEX_VIP_REBATE_DIFF: '指数(VIP)(每手差值)',
                INDEX_VIP_COMMISSION_DIFF: '指数(VIP)(额外佣金)',

                FX_MAJOR_LOT: '外汇(主要)(手数)',
                FX_MAJOR_REBATE_DIFF: '外汇(主要)(每手差值)',
                FX_MAJOR_COMMISSION_DIFF: '外汇(主要)(额外佣金)',
                FX_MAJOR_VIP_LOT: '外汇(主要)(VIP)(手数)',
                FX_MAJOR_VIP_REBATE_DIFF: '外汇(主要)(VIP)(每手差值)',
                FX_MAJOR_VIP_COMMISSION_DIFF: '外汇(主要)(VIP)(额外佣金)',

                FX_MINOR_LOT: '外汇(次要)(手数)',
                FX_MINOR_REBATE_DIFF: '外汇(次要)(每手差值)',
                FX_MINOR_COMMISSION_DIFF: '外汇(次要)(额外佣金)',
                FX_MINOR_VIP_LOT: '外汇(次要)(VIP)(手数)',
                FX_MINOR_VIP_REBATE_DIFF: '外汇(次要)(VIP)(每手差值)',
                FX_MINOR_VIP_COMMISSION_DIFF: '外汇(次要)(VIP)(额外佣金)',

                FX_EXOTIC_LOT: '外汇(其他)(手数)',
                FX_EXOTIC_REBATE_DIFF: '外汇(其他)(每手差值)',
                FX_EXOTIC_COMMISSION_DIFF: '外汇(其他)(额外佣金)',
                FX_EXOTIC_VIP_LOT: '外汇(其他)(VIP)(手数)',
                FX_EXOTIC_VIP_REBATE_DIFF: '外汇(其他)(VIP)(每手差值)',
                FX_EXOTIC_VIP_COMMISSION_DIFF: '外汇(其他)(VIP)(额外佣金)',

                BTC_LOT: '比特币(手数)',
                BTC_REBATE_DIFF: '比特币(每手差值)',
                BTC_COMMISSION_DIFF: '比特币(额外佣金)',
                BTC_VIP_LOT: '比特币(VIP)(手数)',
                BTC_VIP_REBATE_DIFF: '比特币(VIP)(每手差值)',
                BTC_VIP_COMMISSION_DIFF: '比特币(VIP)(额外佣金)',

                ETH_LTC_LOT: '以太币&莱特币(手数)',
                ETH_LTC_REBATE_DIFF: '以太币&莱特币(每手差值)',
                ETH_LTC_COMMISSION_DIFF: '以太币&莱特币(额外佣金)',
                ETH_LTC_VIP_LOT: '以太币&莱特币(VIP)(手数)',
                ETH_LTC_VIP_REBATE_DIFF: '以太币&莱特币(VIP)(每手差值)',
                ETH_LTC_VIP_COMMISSION_DIFF: '以太币&莱特币(VIP)(额外佣金)',

                FUTURE_GOLD_LOT: '黄金期货(手数)',
                FUTURE_GOLD_REBATE_DIFF: '黄金期货(每手差值)',
                FUTURE_GOLD_COMMISSION_DIFF: '黄金期货(额外佣金)',
                FUTURE_GOLD_VIP_LOT: '黄金期货(VIP)(手数)',
                FUTURE_GOLD_VIP_REBATE_DIFF: '黄金期货(VIP)(每手差值)',
                FUTURE_GOLD_VIP_COMMISSION_DIFF: '黄金期货(VIP)(额外佣金)',

                FUTURE_SILVER_LOT: '白银期货(手数)',
                FUTURE_SILVER_DIFF: '白银期货(每手差值)',
                FUTURE_SILVER_COMMISSION_DIFF: '白银期货(额外佣金)',
                FUTURE_SILVER_VIP_LOT: '白银期货(VIP)(手数)',
                FUTURE_SILVER_VIP_REBATE_DIFF: '白银期货(VIP)(每手差值)',
                FUTURE_SILVER_VIP_COMMISSION_DIFF: '白银期货(VIP)(额外佣金)',

                FUTURE_COPPER_LOT: '黄铜期货(手数)',
                FUTURE_COPPER_REBATE_DIFF: '黄铜期货(每手差值)',
                FUTURE_COPPER_COMMISSION_DIFF: '黄铜期货(额外佣金)',
                FUTURE_COPPER_VIP_LOT: '黄铜期货(VIP)(手数)',
                FUTURE_COPPER_VIP_REBATE_DIFF: '黄铜期货(VIP)(每手差值)',
                FUTURE_COPPER_VIP_COMMISSION_DIFF: '黄铜期货(VIP)(额外佣金)',

                FUTURE_NATGAS_LOT: '天然气期货(手数)',
                FUTURE_NATGAS_REBATE_DIFF: '天然气期货(每手差值)',
                FUTURE_NATGAS_COMMISSION_DIFF: '天然气期货(额外佣金)',
                FUTURE_NATGAS_VIP_LOT: '天然气期货(VIP)(手数)',
                FUTURE_NATGAS_VIP_REBATE_DIFF: '天然气期货(VIP)(每手差值)',
                FUTURE_NATGAS_VIP_COMMISSION_DIFF: '天然气期货(VIP)(额外佣金)',

                COPPER_LOT: '铜(手数)',
                COPPER_REBATE_DIFF: '铜(每手差值)',
                COPPER_COMMISSION_DIFF: '铜(额外佣金)',
                COPPER_VIP_LOT: '铜(VIP)(手数)',
                COPPER_VIP_REBATE_DIFF: '铜(VIP)(每手差值)',
                COPPER_VIP_COMMISSION_DIFF: '铜(VIP)(额外佣金)'
            },
            notNumber: '不是正整数，请检查输入'
        }
    },
    hk: {
        publicLan: {
            type: (0, _defineProperty3.default)({
                SL: '銷售',
                M: '經理',
                IB: '代理',
                CL: '客戶',
                extraEmployee: '額外員工',
                specialIB: '特別代理',
                employee: '員工',
                UN: "系統",
                C: '公司',
                N: '國家',
                R: '地區',
                O: '辦事處'
            }, 'M', '經理'),
            relationType: {
                relation: '關系圖',
                extra: '傭金轉發',
                special: '額外添加'
            },
            clientType: {
                allClient: '全部客戶',
                IBClient: '代理客户',
                directClient: '直接客户'
            },
            rule: {
                percentage: "百分比",
                extrapercentage: "額外百分比",
                maxlevel: "分層最高金額(按佣金)",
                fixamount: "固定金額",
                maxlevel2: "分層最高金額(自定金額)",
                maxdiff: "與最高內返相差",
                fixamountnonvip: "固定金額(普通組別)",
                fixamountvip: "固定金額(VIP組別)",
                percentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 分 配 ，總 設 定 不 超 過 100 % 。',
                extrapercentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 計 算 ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
                maxlevel_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
                maxlevel2_desc: '按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
                fixamount_desc: '按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
                maxdiff_desc: '按 即 月 交 易 量 達 到 的 內 返 條 件 , 與 最 高 內 返 條 件 的 相 差 來 分 配 佣 金  。相 差 的 金 額 以 輸 入 的 上 限 由 下 到 上 來 分 配 。',
                fixamountnonvip_desc: '針 對 普 通 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
                fixamountvip_desc: '針 對 V I P 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。'
            },
            products: {
                ALL: '全部',

                FX: '外匯',
                FX_VIP: '外匯(VIP)',
                GOLD: '黃金',
                GOLD_VIP: '黃金(VIP)',
                SILVER: '白銀',
                SILVER_VIP: '白銀(VIP)',
                ENERGY: '能源',
                ENERGY_VIP: '能源(VIP)',
                INDEX: '指數',
                INDEX_VIP: '指數(VIP)',
                FX_MAJOR: '外匯(主要)',
                FX_MAJOR_VIP: '外匯(主要)(VIP)',
                FX_MINOR: '外匯(次要)',
                FX_MINOR_VIP: '外匯(次要)(VIP)',
                FX_EXOTIC: '外匯(其他)',
                FX_EXOTIC_VIP: '外匯(其他)(VIP)',
                BTC: '比特幣',
                BTC_VIP: '比特幣(VIP)',
                ETH_LTC: '以太幣&萊特幣',
                ETH_LTC_VIP: '以太幣&萊特幣(VIP)',
                FUTURE_GOLD: '黃金期貨',
                FUTURE_GOLD_VIP: '黃金期貨(VIP)',
                FUTURE_SILVER: '白銀期貨',
                FUTURE_SILVER_VIP: '白銀期貨(VIP)',
                FUTURE_COPPER: '黃銅期貨',
                FUTURE_COPPER_VIP: '黃銅期貨(VIP)',
                FUTURE_NATGAS: '天然氣期貨',
                FUTURE_NATGAS_VIP: '天然氣期貨(VIP)',
                COPPER: '銅',
                COPPER_VIP: '銅(VIP)'
            },
            detailTh: {
                IB_ID: '代理賬號',
                CLIENT_ID: '客戶賬號',
                PLATFORM: '交易平台',
                TRADING_ACCOUNT_ID: '交易賬號',

                FX_LOT: '外匯(手數)',
                FX_REBATE_DIFF: '外匯(每手差值)',
                FX_COMMISSION_DIFF: '外匯(額外佣金)',
                FX_VIP_LOT: '外匯(VIP)(手數)',
                FX_VIP_REBATE_DIFF: '外匯(VIP)(每手差值)',
                FX_VIP_COMMISSION_DIFF: '外匯(VIP)(額外佣金)',

                GOLD_LOT: '黃金(手數)',
                GOLD_REBATE_DIFF: '黃金(每手差值)',
                GOLD_COMMISSION_DIFF: '黃金(額外佣金)',
                GOLD_VIP_LOT: '黃金(VIP)(手數)',
                GOLD_VIP_REBATE_DIFF: '黃金(VIP)(每手差值)',
                GOLD_VIP_COMMISSION_DIFF: '黃金(VIP)(額外佣金)',

                SILVER_LOT: '白銀(手數)',
                SILVER_REBATE_DIFF: '白銀(每手差值)',
                SILVER_COMMISSION_DIFF: '白銀(額外佣金)',
                SILVER_VIP_LOT: '白銀(VIP)(手數)',
                SILVER_VIP_REBATE_DIFF: '白銀(VIP)(每手差值)',
                SILVER_VIP_COMMISSION_DIFF: '白銀(VIP)(額外佣金)',

                ENERGY_LOT: '能源(手數)',
                ENERGY_REBATE_DIFF: '能源(每手差值)',
                ENERGY_COMMISSION_DIFF: '能源(額外佣金)',
                ENERGY_VIP_LOT: '能源((VIP)(手數)',
                ENERGY_VIP_REBATE_DIFF: '能源((VIP)(每手差值)',
                ENERGY_VIP_COMMISSION_DIFF: '能源((VIP)(額外佣金)',

                INDEX_LOT: '指數(手數)',
                INDEX_REBATE_DIFF: '指數(每手差值)',
                INDEX_COMMISSION_DIFF: '指數(額外佣金)',
                INDEX_VIP_LOT: '指數(VIP)(手數)',
                INDEX_VIP_REBATE_DIFF: '指數(VIP)(每手差值)',
                INDEX_VIP_COMMISSION_DIFF: '指數(VIP)(額外佣金)',

                FX_MAJOR_LOT: '外匯(主要)(手數)',
                FX_MAJOR_REBATE_DIFF: '外匯(主要)(每手差值)',
                FX_MAJOR_COMMISSION_DIFF: '外匯(主要)(額外佣金)',
                FX_MAJOR_VIP_LOT: '外匯(主要)(VIP)(手數)',
                FX_MAJOR_VIP_REBATE_DIFF: '外匯(主要)(VIP)(每手差值)',
                FX_MAJOR_VIP_COMMISSION_DIFF: '外匯(主要)(VIP)(額外佣金)',

                FX_MINOR_LOT: '外匯(次要)(手數)',
                FX_MINOR_REBATE_DIFF: '外匯(次要)(每手差值)',
                FX_MINOR_COMMISSION_DIFF: '外匯(次要)(額外佣金)',
                FX_MINOR_VIP_LOT: '外匯(次要)(VIP)(手數)',
                FX_MINOR_VIP_REBATE_DIFF: '外匯(次要)(VIP)(每手差值)',
                FX_MINOR_VIP_COMMISSION_DIFF: '外匯(次要)(VIP)(額外佣金)',

                FX_EXOTIC_LOT: '外匯(其他)(手數)',
                FX_EXOTIC_REBATE_DIFF: '外匯(其他)(每手差值)',
                FX_EXOTIC_COMMISSION_DIFF: '外匯(其他)(額外佣金)',
                FX_EXOTIC_VIP_LOT: '外匯(其他)(VIP)(手數)',
                FX_EXOTIC_VIP_REBATE_DIFF: '外匯(其他)(VIP)(每手差值)',
                FX_EXOTIC_VIP_COMMISSION_DIFF: '外匯(其他)(VIP)(額外佣金)',

                BTC_LOT: '比特幣(手數)',
                BTC_REBATE_DIFF: '比特幣(每手差值)',
                BTC_COMMISSION_DIFF: '比特幣(額外佣金)',
                BTC_VIP_LOT: '比特幣(VIP)(手數)',
                BTC_VIP_REBATE_DIFF: '比特幣(VIP)(每手差值)',
                BTC_VIP_COMMISSION_DIFF: '比特幣(VIP)(額外佣金)',

                ETH_LTC_LOT: '以太幣&萊特幣(手數)',
                ETH_LTC_REBATE_DIFF: '以太幣&萊特幣(每手差值)',
                ETH_LTC_COMMISSION_DIFF: '以太幣&萊特幣(額外佣金)',
                ETH_LTC_VIP_LOT: '以太幣&萊特幣(VIP)(手數)',
                ETH_LTC_VIP_REBATE_DIFF: '以太幣&萊特幣(VIP)(每手差值)',
                ETH_LTC_VIP_COMMISSION_DIFF: '以太幣&萊特幣(VIP)(額外佣金)',

                FUTURE_GOLD_LOT: '黃金期貨(手數)',
                FUTURE_GOLD_REBATE_DIFF: '黃金期貨(每手差值)',
                FUTURE_GOLD_COMMISSION_DIFF: '黃金期貨(額外佣金)',
                FUTURE_GOLD_VIP_LOT: '黃金期貨(VIP)(手數)',
                FUTURE_GOLD_VIP_REBATE_DIFF: '黃金期貨(VIP)(每手差值)',
                FUTURE_GOLD_VIP_COMMISSION_DIFF: '黃金期貨(VIP)(額外佣金)',

                FUTURE_SILVER_LOT: '白銀期貨(手數)',
                FUTURE_SILVER_DIFF: '白銀期貨(每手差值)',
                FUTURE_SILVER_COMMISSION_DIFF: '白銀期貨(額外佣金)',
                FUTURE_SILVER_VIP_LOT: '白銀期貨(VIP)(手數)',
                FUTURE_SILVER_VIP_REBATE_DIFF: '白銀期貨(VIP)(每手差值)',
                FUTURE_SILVER_VIP_COMMISSION_DIFF: '白銀期貨(VIP)(額外佣金)',

                FUTURE_COPPER_LOT: '黃銅期貨(手數)',
                FUTURE_COPPER_REBATE_DIFF: '黃銅期貨(每手差值)',
                FUTURE_COPPER_COMMISSION_DIFF: '黃銅期貨(額外佣金)',
                FUTURE_COPPER_VIP_LOT: '黃銅期貨(VIP)(手數)',
                FUTURE_COPPER_VIP_REBATE_DIFF: '黃銅期貨(VIP)(每手差值)',
                FUTURE_COPPER_VIP_COMMISSION_DIFF: '黃銅期貨(VIP)(額外佣金)',

                FUTURE_NATGAS_LOT: '天然氣期貨(手數)',
                FUTURE_NATGAS_REBATE_DIFF: '天然氣期貨(每手差值)',
                FUTURE_NATGAS_COMMISSION_DIFF: '天然氣期貨(額外佣金)',
                FUTURE_NATGAS_VIP_LOT: '天然氣期貨(VIP)(手數)',
                FUTURE_NATGAS_VIP_REBATE_DIFF: '天然氣期貨(VIP)(每手差值)',
                FUTURE_NATGAS_VIP_COMMISSION_DIFF: '天然氣期貨(VIP)(額外佣金)',

                COPPER_LOT: '銅(手數)',
                COPPER_REBATE_DIFF: '銅(每手差值)',
                COPPER_COMMISSION_DIFF: '銅(額外傭金)',
                COPPER_VIP_LOT: '銅(VIP)(手數)',
                COPPER_VIP_REBATE_DIFF: '銅(VIP)(每手差值)',
                COPPER_VIP_COMMISSION_DIFF: '銅(VIP)(額外傭金)'
            },
            notNumber: '不是正整數，請檢查輸入'
        }
    },
    en: {
        publicLan: {
            type: (0, _defineProperty3.default)({
                SL: 'Sales',
                M: 'Manager',
                IB: 'IB',
                CL: 'Client',
                extraEmployee: 'Extra Employee',
                specialIB: 'Special IB',
                employee: 'Employee',
                UN: "System",
                C: 'Company',
                N: 'Country',
                R: 'Region',
                O: 'Office'
            }, 'M', 'Manager'),
            relationType: {
                relation: 'Relation',
                extra: 'Extra',
                special: 'Special'
            },
            clientType: {
                allClient: 'All Client',
                IBClient: 'IB Client',
                directClient: 'Direct Client'
            },
            rule: {
                percentage: "Percentage",
                extrapercentage: "Extrapercentage",
                maxlevel: "Maxlevel",
                fixamount: "Fixamount",
                maxlevel2: "Maxlevel",
                maxdiff: "Maxdiff",
                fixamountnonvip: "Fixamount(Common Group)",
                fixamountvip: "Fixamount(VIP Group)",
                percentage_desc: 'percentage_desc',
                extrapercentage_desc: 'extrapercentage_desc',
                maxlevel_desc: 'maxlevel_desc',
                maxlevel2_desc: 'maxlevel2_desc',
                fixamount_desc: 'fixamount_desc',
                maxdiff_desc: 'maxdiff_desc',
                fixamountnonvip_desc: 'fixamountnonvip_desc',
                fixamountvip_desc: 'fixamountvip_desc'
            },
            products: {
                ALL: 'ALL',

                FX: 'FX',
                FX_VIP: 'FX(VIP)',
                GOLD: 'GOLD',
                GOLD_VIP: 'GOLD(VIP)',
                SILVER: 'SILVER',
                SILVER_VIP: 'SILVER(VIP)',
                ENERGY: 'ENERGY',
                ENERGY_VIP: 'ENERGY(VIP)',
                INDEX: 'INDEX',
                INDEX_VIP: 'INDEX(VIP)',
                FX_MAJOR: 'FX MAJOR',
                FX_MAJOR_VIP: 'FX MAJOR(VIP)',
                FX_MINOR: 'FX MINOR',
                FX_MINOR_VIP: 'FX MINOR(VIP)',
                FX_EXOTIC: 'FX EXOTIC',
                FX_EXOTIC_VIP: 'FX EXOTIC(VIP)',
                BTC: 'BTC',
                BTC_VIP: 'BTC(VIP)',
                ETH_LTC: 'ETH / LTC',
                ETH_LTC_VIP: 'ETH / LTC(VIP)',
                FUTURE_GOLD: 'FUTURE GOLD',
                FUTURE_GOLD_VIP: 'FUTURE GOLD(VIP)',
                FUTURE_SILVER: 'FUTURE SILVER',
                FUTURE_SILVER_VIP: 'FUTURE SILVER(VIP)',
                FUTURE_COPPER: 'FUTURE COPPER',
                FUTURE_COPPER_VIP: 'FUTURE COPPER(VIP)',
                FUTURE_NATGAS: 'FUTURE NATGAS',
                FUTURE_NATGAS_VIP: 'FUTURE NATGAS(VIP)',
                COPPER: 'COPPER',
                COPPER_VIP: 'COPPER(VIP)'
            },
            detailTh: {
                IB_ID: 'IB Account',
                CLIENT_ID: 'CLIENT ID',
                PLATFORM: 'Trading Platform',
                TRADING_ACCOUNT_ID: 'Trading Account',

                FX_LOT: 'FX(LOTS)',
                FX_REBATE_DIFF: 'FX(Rebate Diff.)',
                FX_COMMISSION_DIFF: 'FX(Commission Diff.)',
                FX_VIP_LOT: 'FX(VIP)(LOTS)',
                FX_VIP_REBATE_DIFF: 'FX(VIP)(Rebate Diff.)',
                FX_VIP_COMMISSION_DIFF: 'FX(VIP)(Commission Diff.)',

                GOLD_LOT: 'GOLD(LOTS)',
                GOLD_REBATE_DIFF: 'GOLD(Rebate Diff.)',
                GOLD_COMMISSION_DIFF: 'GOLD(Commission Diff.)',
                GOLD_VIP_LOT: 'GOLD(VIP)(LOTS)',
                GOLD_VIP_REBATE_DIFF: 'GOLD(VIP)(Rebate Diff.)',
                GOLD_VIP_COMMISSION_DIFF: 'GOLD(VIP)(Commission Diff.)',

                SILVER_LOT: 'SILVER(LOTS)',
                SILVER_REBATE_DIFF: 'SILVER(Rebate Diff.)',
                SILVER_COMMISSION_DIFF: 'SILVER(Commission Diff.)',
                SILVER_VIP_LOT: 'SILVER(VIP)(LOTS)',
                SILVER_VIP_REBATE_DIFF: 'SILVER(VIP)(Rebate Diff.)',
                SILVER_VIP_COMMISSION_DIFF: 'SILVER(VIP)(Commission Diff.)',

                ENERGY_LOT: 'ENERGY(LOTS)',
                ENERGY_REBATE_DIFF: 'ENERGY(Rebate Diff.)',
                ENERGY_COMMISSION_DIFF: 'ENERGY(Commission Diff.)',
                ENERGY_VIP_LOT: 'ENERGY((VIP)(LOTS)',
                ENERGY_VIP_REBATE_DIFF: 'ENERGY((VIP)(Rebate Diff.)',
                ENERGY_VIP_COMMISSION_DIFF: 'ENERGY((VIP)(Commission Diff.)',

                INDEX_LOT: 'INDEX(LOTS)',
                INDEX_REBATE_DIFF: 'INDEX(Rebate Diff.)',
                INDEX_COMMISSION_DIFF: 'INDEX(Commission Diff.)',
                INDEX_VIP_LOT: 'INDEX(VIP)(LOTS)',
                INDEX_VIP_REBATE_DIFF: 'INDEX(VIP)(Rebate Diff.)',
                INDEX_VIP_COMMISSION_DIFF: 'INDEX(VIP)(Commission Diff.)',

                FX_MAJOR_LOT: 'FX MAJOR(LOTS)',
                FX_MAJOR_REBATE_DIFF: 'FX MAJOR(Rebate Diff.)',
                FX_MAJOR_COMMISSION_DIFF: 'FX MAJOR(Commission Diff.)',
                FX_MAJOR_VIP_LOT: 'FX MAJOR(VIP)(LOTS)',
                FX_MAJOR_VIP_REBATE_DIFF: 'FX MAJOR(VIP)(Rebate Diff.)',
                FX_MAJOR_VIP_COMMISSION_DIFF: 'FX MAJOR(VIP)(Commission Diff.)',

                FX_MINOR_LOT: 'FX MINOR(LOTS)',
                FX_MINOR_REBATE_DIFF: 'FX MINOR(Rebate Diff.)',
                FX_MINOR_COMMISSION_DIFF: 'FX MINOR(Commission Diff.)',
                FX_MINOR_VIP_LOT: 'FX MINOR(VIP)(LOTS)',
                FX_MINOR_VIP_REBATE_DIFF: 'FX MINOR(VIP)(Rebate Diff.)',
                FX_MINOR_VIP_COMMISSION_DIFF: 'FX MINOR(VIP)(Commission Diff.)',

                FX_EXOTIC_LOT: 'FX EXOTIC(LOTS)',
                FX_EXOTIC_REBATE_DIFF: 'FX EXOTIC(Rebate Diff.)',
                FX_EXOTIC_COMMISSION_DIFF: 'FX EXOTIC(Commission Diff.)',
                FX_EXOTIC_VIP_LOT: 'FX EXOTIC(VIP)(LOTS)',
                FX_EXOTIC_VIP_REBATE_DIFF: 'FX EXOTIC(VIP)(Rebate Diff.)',
                FX_EXOTIC_VIP_COMMISSION_DIFF: 'FX EXOTIC(VIP)(Commission Diff.)',

                BTC_LOT: 'BTC(LOTS)',
                BTC_REBATE_DIFF: 'BTC(Rebate Diff.)',
                BTC_COMMISSION_DIFF: 'BTC(Commission Diff.)',
                BTC_VIP_LOT: 'BTC(VIP)(LOTS)',
                BTC_VIP_REBATE_DIFF: 'BTC(VIP)(Rebate Diff.)',
                BTC_VIP_COMMISSION_DIFF: 'BTC(VIP)(Commission Diff.)',

                ETH_LTC_LOT: 'ETH / LTC(LOTS)',
                ETH_LTC_REBATE_DIFF: 'ETH / LTC(Rebate Diff.)',
                ETH_LTC_COMMISSION_DIFF: 'ETH / LTC(Commission Diff.)',
                ETH_LTC_VIP_LOT: 'ETH / LTC(VIP)(LOTS)',
                ETH_LTC_VIP_REBATE_DIFF: 'ETH / LTC(VIP)(Rebate Diff.)',
                ETH_LTC_VIP_COMMISSION_DIFF: 'ETH / LTC(VIP)(Commission Diff.)',

                FUTURE_GOLD_LOT: 'FUTURE GOLD(LOTS)',
                FUTURE_GOLD_REBATE_DIFF: 'FUTURE GOLD(Rebate Diff.)',
                FUTURE_GOLD_COMMISSION_DIFF: 'FUTURE GOLD(Commission Diff.)',
                FUTURE_GOLD_VIP_LOT: 'FUTURE GOLD(VIP)(LOTS)',
                FUTURE_GOLD_VIP_REBATE_DIFF: 'FUTURE GOLD(VIP)(Rebate Diff.)',
                FUTURE_GOLD_VIP_COMMISSION_DIFF: 'FUTURE GOLD(VIP)(Commission Diff.)',

                FUTURE_SILVER_LOT: 'FUTURE SILVER(LOTS)',
                FUTURE_SILVER_DIFF: 'FUTURE SILVER(Rebate Diff.)',
                FUTURE_SILVER_COMMISSION_DIFF: 'FUTURE SILVER(Commission Diff.)',
                FUTURE_SILVER_VIP_LOT: 'FUTURE SILVER(VIP)(LOTS)',
                FUTURE_SILVER_VIP_REBATE_DIFF: 'FUTURE SILVER(VIP)(Rebate Diff.)',
                FUTURE_SILVER_VIP_COMMISSION_DIFF: 'FUTURE SILVER(VIP)(Commission Diff.)',

                FUTURE_COPPER_LOT: 'FUTURE COPPER(LOTS)',
                FUTURE_COPPER_REBATE_DIFF: 'FUTURE COPPER(Rebate Diff.)',
                FUTURE_COPPER_COMMISSION_DIFF: 'FUTURE COPPER(Commission Diff.)',
                FUTURE_COPPER_VIP_LOT: 'FUTURE COPPER(VIP)(LOTS)',
                FUTURE_COPPER_VIP_REBATE_DIFF: 'FUTURE COPPER(VIP)(Rebate Diff.)',
                FUTURE_COPPER_VIP_COMMISSION_DIFF: 'FUTURE COPPER(VIP)(Commission Diff.)',

                FUTURE_NATGAS_LOT: 'FUTURE NATGAS(LOTS)',
                FUTURE_NATGAS_REBATE_DIFF: 'FUTURE NATGAS(Rebate Diff.)',
                FUTURE_NATGAS_COMMISSION_DIFF: 'FUTURE NATGAS(Commission Diff.)',
                FUTURE_NATGAS_VIP_LOT: 'FUTURE NATGAS(VIP)(LOTS)',
                FUTURE_NATGAS_VIP_REBATE_DIFF: 'FUTURE NATGAS(VIP)(Rebate Diff.)',
                FUTURE_NATGAS_VIP_COMMISSION_DIFF: 'FUTURE NATGAS(VIP)(Commission Diff.)',

                COPPER_LOT: 'COPPER(LOTS)',
                COPPER_REBATE_DIFF: 'COPPER(Rebate Diff.)',
                COPPER_COMMISSION_DIFF: 'COPPER(Commission Diff.)',
                COPPER_VIP_LOT: 'COPPER(VIP)(LOTS)',
                COPPER_VIP_REBATE_DIFF: 'COPPER(VIP)(Rebate Diff.)',
                COPPER_VIP_COMMISSION_DIFF: 'COPPER(VIP)(Commission Diff.)'
            },
            notNumber: ' is not a number, please check your input'
        }
    }
};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        salePrimary: {
            commissionSetting: '佣金设定',
            saleResult: {
                title: '销售结果',
                list: [{ text: '月结佣金结果', link: '/sale/saleMonthlyResult' }]
            },
            saleResult_v2: {
                title: '销售结果',
                list: [{ text: '月结佣金结果', link: '/sale_v2/saleMonthlyResult' }]
            },
            saleReport: {
                title: '销售报表',
                list: [{ text: '关系列表报表', link: '/sale/relationshipListReport' }, { text: 'MT用户列表', link: '/sale/mtclientReport' }, { text: '模板管理', link: '/sale/saleTemplateSetting' }]
            },
            saleReport_v2: {
                title: '销售报表',
                list: [{ text: '关系列表报表', link: '/sale_v2/relationshipListReport' }, { text: 'MT用户列表', link: '/sale_v2/mtclientReport' }, { text: '模板管理', link: '/sale_v2/saleTemplateSetting' }]
            }
        }
    },
    hk: {
        salePrimary: {
            commissionSetting: '佣金設定',
            saleResult: {
                title: '銷售结果',
                list: [{ text: '月結佣金結果', link: '/sale/saleMonthlyResult' }]
            },
            saleResult_v2: {
                title: '銷售结果',
                list: [{ text: '月結佣金結果', link: '/sale_v2/saleMonthlyResult' }]
            },
            saleReport: {
                title: '銷售报表',
                list: [{ text: '關系列表報表', link: '/sale/relationshipListReport' }, { text: 'MT用戶列表', link: '/sale/mtclientReport' }, { text: '模板管理', link: '/sale/saleTemplateSetting' }]
            },
            saleReport_v2: {
                title: '銷售报表',
                list: [{ text: '關系列表報表', link: '/sale_v2/relationshipListReport' }, { text: 'MT用戶列表', link: '/sale_v2/mtclientReport' }, { text: '模板管理', link: '/sale_v2/saleTemplateSetting' }]
            }
        }
    },
    en: {
        salePrimary: {
            commissionSetting: 'Commission Setting',
            saleResult: {
                title: 'Sale Result',
                list: [{ text: 'Sales Monthly Result', link: '/sale/saleMonthlyResult' }]
            },
            saleResult_v2: {
                title: 'Sale Result',
                list: [{ text: 'Sales Monthly Result', link: '/sale_v2/saleMonthlyResult' }]
            },
            saleReport: {
                title: 'Sale Report',
                list: [{ text: 'Relationship List Report', link: '/sale/relationshipListReport' }, { text: 'MT Client List', link: '/sale/mtclientReport' }, { text: 'Template Maintenance', link: '/sale/saleTemplateSetting' }]
            },
            saleReport_v2: {
                title: 'Sale Report',
                list: [{ text: 'Relationship List Report', link: '/sale_v2/relationshipListReport' }, { text: 'MT Client List', link: '/sale_v2/mtclientReport' }, { text: 'Template Maintenance', link: '/sale_v2/saleTemplateSetting' }]
            }
        }
    }
};

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        accountSetting: {
            title: '账号设定',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            nodata: "没有查询到数据",
            status_text: '状态：',
            search: '搜索',
            undo: '重新绑定',
            do: '解除绑定',
            doConfirm: '确认解绑',
            undoConfirm: '确认重绑',
            three: '设置下次计算日期',
            threeConfirm: '确认下次计算日期',
            commit: '您真的要确认吗？',
            confirmation: '请您选择日期再设置下次计算日期',
            status_mapper: { "-1": "所有", "0": "生效中", "1": "已解绑" },
            result_mapper: { "0": "已计算", "1": "未能分成" },
            code_mapping: { '9000': '添加账户成功', '9001': '添加失败，账户已经存在', '9002': '添加失败，无效的账户' },
            message_type: { '9000': 'success', '9001': 'warning', '9002': 'warning' },
            enable_mapping: { 'ALL': '全部', 'Y': '启用', 'N': '禁用' },
            dialog_title: '日期设置',
            date_placeholder: '请选择日期',
            cancel: '取 消',
            ensure: '确 定',
            downloadExcelForms: "下载 Excel",
            calculate: '计算分成',
            addUser: '新增账户',
            confirm: '您确定要开始计算分成吗？',
            calculateDone: '计算已完成',
            noNeedCal: '没有需要计算的分成',
            required: '您需要选择日期才能确定',
            add_title: '新增账户',
            login: '账号',
            ib_account: '代理账号',
            percentage: '百分比',
            app_date: '申请日期',
            moreSelect: '显示更多筛选',
            deposit: '入金：',
            withdrawal: '出金：',
            transfer: '转账：',
            selectArr: [{ label: '账号', value: 'LOGIN' }, { label: '代理账号', value: 'IB_ID' }],
            rules: {
                login: [{ required: true, message: '请输入账号', trigger: 'blur' }, {
                    validator: function validator(rule, value, callback) {
                        if (isNaN(value)) callback(new Error('请输入数字值'));else callback();
                    },
                    trigger: 'blur'
                }],
                ib: [{ required: true, message: '请输入代理账号', trigger: 'blur' }, {
                    validator: function validator(rule, value, callback) {
                        if (isNaN(value)) callback(new Error('请输入数字值'));else callback();
                    },
                    trigger: 'blur'
                }],
                percentage: [{ required: true, message: '请输入百分比', trigger: 'blur' }, {
                    validator: function validator(rule, value, callback) {
                        var message = isNaN(value) ? '请输入数字值' : value >= 1 || value <= 0 ? '百分比只能在0到1之间' : '';
                        message ? callback(new Error(message)) : callback();
                    },
                    trigger: 'blur'
                }],
                date: [{ type: 'date', required: true, message: '请选择申请日期', trigger: 'blur' }]
            },
            first_row: [{ key: 'LOGIN', name: '账号' }, { key: 'GROUP', name: '组别' }, { key: 'IB_ID', name: '代理账号' }, { key: 'PERCENTAGE', name: '百分比' }, { key: 'APPLICATION_DATE', name: '申请日期' }, { key: 'DISCONNECT_DATE', name: '解绑日期' }, { key: 'deposit', name: '入金' }, { key: 'withdrawal', name: '出金' }, { key: 'fundtransfer', name: '转账' }, { key: 'LAST_CALC_START_DATE', name: '最后计算开始日期' }, { key: 'LAST_CALC_END_DATE', name: '最后计算结束日期' }, { key: 'NEXT_CALC_DATE', name: '下次计算日期' }, { key: 'is_negative_before', name: '上次结果' }, { key: 'is_deleted', name: '状态' }, { key: 'UPDATE_BY', name: '最后更新' }, { key: 'LAST_UPDATE', name: '更新时间', changeTime: true }]
        }
    },
    hk: {
        accountSetting: {
            title: '賬號設定',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            nodata: "沒有查詢到數據",
            status_text: '狀態：',
            search: '搜索',
            undo: '重新綁定',
            do: '解除綁定',
            doConfirm: '確認解綁',
            undoConfirm: '確認重綁',
            three: '設置下次計算日期',
            threeConfirm: '確認下次計算日期',
            commit: '您真的要確認嗎？',
            confirmation: '请您选择日期再设置下次计算日期',
            status_mapper: { "-1": "所有", "0": "生效中", "1": "已解綁" },
            result_mapper: { "0": "已計算", "1": "未能分成" },
            code_mapping: { '9000': '添加賬戶成功', '9001': '添加失敗，賬戶已經存在', '9002': '添加失敗，無效的賬戶' },
            message_type: { '9000': 'success', '9001': 'warning', '9002': 'warning' },
            enable_mapping: { 'ALL': '全部', 'Y': '啟用', 'N': '禁用' },
            dialog_title: '日期設置',
            date_placeholder: '請選擇日期',
            cancel: '取 消',
            ensure: '確 定',
            downloadExcelForms: "下載 Excel",
            calculate: '計算分成',
            addUser: '新增賬戶',
            confirm: '您確定要開始計算分成嗎？',
            calculateDone: '計算已完成',
            noNeedCal: '沒有需要計算的分成',
            required: '您需要選擇日期才能確定',
            add_title: '新增賬戶',
            login: '賬號',
            ib_account: '代理賬號',
            percentage: '百分比',
            app_date: '申請日期',
            moreSelect: '顯示更多篩選',
            deposit: '入金：',
            withdrawal: '出金：',
            transfer: '轉賬：',
            selectArr: [{ label: '賬號', value: 'LOGIN' }, { label: '代理賬號', value: 'IB_ID' }],
            rules: {
                login: [{ required: true, message: '請輸入賬號', trigger: 'blur' }, {
                    validator: function validator(rule, value, callback) {
                        if (isNaN(value)) callback(new Error('請輸入數字值'));else callback();
                    },
                    trigger: 'blur'
                }],
                ib: [{ required: true, message: '請輸入代理賬號', trigger: 'blur' }, {
                    validator: function validator(rule, value, callback) {
                        if (isNaN(value)) callback(new Error('請輸入數字值'));else callback();
                    },
                    trigger: 'blur'
                }],
                percentage: [{ required: true, message: '請輸入百分比', trigger: 'blur' }, {
                    validator: function validator(rule, value, callback) {
                        var message = isNaN(value) ? '請輸入數字值' : value >= 1 || value <= 0 ? '百分比只能在0到1之間' : '';
                        message ? callback(new Error(message)) : callback();
                    },
                    trigger: 'blur'
                }],
                date: [{ type: 'date', required: true, message: '請選擇申請日期', trigger: 'blur' }]
            },
            first_row: [{ key: 'LOGIN', name: '賬號' }, { key: 'GROUP', name: '組別' }, { key: 'IB_ID', name: '代理賬號' }, { key: 'PERCENTAGE', name: '百分比' }, { key: 'APPLICATION_DATE', name: '申請日期' }, { key: 'DISCONNECT_DATE', name: '解綁日期' }, { key: 'deposit', name: '入金' }, { key: 'withdrawal', name: '出金' }, { key: 'fundtransfer', name: '轉賬' }, { key: 'LAST_CALC_START_DATE', name: '最後計算開始日期' }, { key: 'LAST_CALC_END_DATE', name: '最後計算結束日期' }, { key: 'NEXT_CALC_DATE', name: '下次計算日期' }, { key: 'is_negative_before', name: '上次結果' }, { key: 'is_deleted', name: '狀態' }, { key: 'UPDATE_BY', name: '最後更新' }, { key: 'LAST_UPDATE', name: '更新時間', changeTime: true }]
        }
    },
    en: {
        accountSetting: {
            title: 'Account Setting',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            nodata: "No data found",
            status_text: 'Status：',
            search: 'Search',
            undo: 'Rebind',
            do: 'Unbind',
            doConfirm: 'Confirm Unbind',
            undoConfirm: 'Confirm Rebind',
            three: 'Set Next Calculate Date',
            threeConfirm: 'Comfirm Next Calculate Date',
            commit: 'Do you really want to confirm?',
            status_mapper: { "-1": "All", "0": "Active", "1": "Deleted" },
            result_mapper: { "0": "Calculated", "1": "No Share" },
            code_mapping: { '9000': 'Add account successful', '9001': 'Add failed, account already exists', '9002': 'Add failed, invalid login' },
            message_type: { '9000': 'success', '9001': 'warning', '9002': 'warning' },
            enable_mapping: { 'ALL': 'All', 'Y': 'Enable', 'N': 'Disable' },
            dialog_title: 'Date Setting',
            date_placeholder: 'Select Date',
            cancel: 'Cancel',
            ensure: 'Ensure',
            downloadExcelForms: "Download Excel",
            calculate: 'Calculate',
            addUser: 'Add User',
            confirm: 'Are you sure start calculating the share?',
            calculateDone: 'Calculate complete',
            noNeedCal: 'No datas need to calculate',
            required: 'You need to select a date to ensure',
            login: 'Login',
            ib_account: 'IB Account',
            percentage: 'Percentage',
            app_date: 'Applicaton Date',
            moreSelect: 'Show More Select',
            deposit: 'Deposit：',
            withdrawal: 'Withdrawal：',
            transfer: 'Transfer：',
            selectArr: [{ label: 'Login', value: 'LOGIN' }, { label: 'IB Account', value: 'IB_ID' }],
            rules: {
                login: [{ required: true, message: 'Please input login', trigger: 'blur' }, {
                    validator: function validator(rule, value, callback) {
                        if (isNaN(value)) callback(new Error('Please input number'));else callback();
                    },
                    trigger: 'blur'
                }],
                ib: [{ required: true, message: 'Please input ib account', trigger: 'blur' }, {
                    validator: function validator(rule, value, callback) {
                        if (isNaN(value)) callback(new Error('Please input number'));else callback();
                    },
                    trigger: 'blur'
                }],
                percentage: [{ required: true, message: 'Please input percentage', trigger: 'blur' }, {
                    validator: function validator(rule, value, callback) {
                        var message = isNaN(value) ? 'Please input number' : value >= 1 || value <= 0 ? 'Percentage must be between 0 and 1' : '';
                        message ? callback(new Error(message)) : callback();
                    },
                    trigger: 'blur'
                }],
                date: [{ type: 'date', required: true, message: 'Please select application date', trigger: 'blur' }]
            },
            first_row: [{ key: 'LOGIN', name: 'Login' }, { key: 'GROUP', name: 'Group' }, { key: 'IB_ID', name: 'IB Account' }, { key: 'PERCENTAGE', name: 'Percentage' }, { key: 'APPLICATION_DATE', name: 'Applicaton Date' }, { key: 'DISCONNECT_DATE', name: 'Disconnect Date' }, { key: 'deposit', name: 'Deposit' }, { key: 'withdrawal', name: 'Withdrawal' }, { key: 'fundtransfer', name: 'Transfer' }, { key: 'LAST_CALC_START_DATE', name: 'Last Start Date' }, { key: 'LAST_CALC_END_DATE', name: 'Last End Date' }, { key: 'NEXT_CALC_DATE', name: 'Next Date' }, { key: 'is_negative_before', name: 'Last Result' }, { key: 'is_deleted', name: 'Status' }, { key: 'UPDATE_BY', name: 'Update By' }, { key: 'LAST_UPDATE', name: 'Last Update', changeTime: true }]
        }
    }
};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        profitShareReport: {
            title: '分成报表',
            search: '搜索',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            nodata: "没有查询到数据",
            downloadExcelForms: "下载 Excel",
            begin: '编号区间：',
            to: '到',
            selectArr: [{ label: '账号', value: 'LOGIN' }, { label: '代理账号', value: 'TO_ACC' }],
            first_row: [{ key: 'REPORT_ID', name: '编号' },
            // { key: 'APPLICATION_DATE', name: '申请日期' },
            { key: 'DATE_FROM', name: '开始日期' }, { key: 'DATE_TO', name: '结束日期' }, { key: 'LOGIN', name: '账号' }, { key: 'TO_ACC', name: '代理账号' }, { key: 'PERCENTAGE', name: '百分比' }, { key: 'TOTAL_PL', name: '总盈亏' }, { key: 'SHARE_PL', name: '分成利润' }, { key: 'CALC_CLOSED_PL', name: '平仓盈亏' }, { key: 'CALC_FIRST_FLOATING_PL', name: '开始计算时未平仓盈亏' }, { key: 'CALC_LAST_FLOATING_PL', name: '结束计算后未平仓盈亏' }, { key: 'CALC_FIRST_EQUITY', name: '开始计算时净值' }, { key: 'CALC_LAST_EQUITY', name: '结束计算后净值' }, { key: 'CALC_TOTAL_DEPOSIT', name: '总入金' }, { key: 'CALC_TOTAL_WITHDRAWAL', name: '总出金' }, { key: 'CALC_TOTAL_CREDIT', name: '总信贷' }, { key: 'SHARE_AMOUNT_METHOD1', name: '方法一分成' }, { key: 'SHARE_AMOUNT_METHOD2', name: '方法二分成' }]
        }
    },
    hk: {
        profitShareReport: {
            title: '分成報表',
            search: '搜索',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            nodata: "沒有查詢到數據",
            downloadExcelForms: "下載 Excel",
            begin: '編號區間：',
            to: '到',
            selectArr: [{ label: '賬號', value: 'LOGIN' }, { label: '代理賬號', value: 'TO_ACC' }],
            first_row: [{ key: 'REPORT_ID', name: '編號' }, { key: 'DATE_FROM', name: '開始日期' }, { key: 'DATE_TO', name: '結束日期' }, { key: 'LOGIN', name: '賬號' }, { key: 'TO_ACC', name: '代理賬號' }, { key: 'PERCENTAGE', name: '百分比' }, { key: 'TOTAL_PL', name: '總盈虧' }, { key: 'SHARE_PL', name: '分成利潤' }, { key: 'CALC_CLOSED_PL', name: '平倉盈虧' }, { key: 'CALC_FIRST_FLOATING_PL', name: '開始計算時未平倉盈虧' }, { key: 'CALC_LAST_FLOATING_PL', name: '結束計算後未平倉盈虧' }, { key: 'CALC_FIRST_EQUITY', name: '開始計算時淨值' }, { key: 'CALC_LAST_EQUITY', name: '結束計算後淨值' }, { key: 'CALC_TOTAL_DEPOSIT', name: '總入金' }, { key: 'CALC_TOTAL_WITHDRAWAL', name: '總出金' }, { key: 'CALC_TOTAL_CREDIT', name: '總信貸' }, { key: 'SHARE_AMOUNT_METHOD1', name: '方法一分成' }, { key: 'SHARE_AMOUNT_METHOD2', name: '方法二分成' }]
        }
    },
    en: {
        profitShareReport: {
            title: 'Profit Share Report',
            search: 'Search',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            nodata: "No data found",
            downloadExcelForms: "Download Excel",
            begin: 'Report ID Interval：',
            to: 'To',
            selectArr: [{ label: 'Login', value: 'LOGIN' }, { label: 'IB Account', value: 'TO_ACC' }],
            first_row: [{ key: 'REPORT_ID', name: 'Report ID' }, { key: 'DATE_FROM', name: 'Date From' }, { key: 'DATE_TO', name: 'Date To' }, { key: 'LOGIN', name: 'Login' }, { key: 'TO_ACC', name: 'IB Account' }, { key: 'PERCENTAGE', name: 'Percentage' }, { key: 'TOTAL_PL', name: 'Total PL' }, { key: 'SHARE_PL', name: 'Share PL' }, { key: 'CALC_CLOSED_PL', name: 'Closed PL' }, { key: 'CALC_FIRST_FLOATING_PL', name: 'First Floating PL' }, { key: 'CALC_LAST_FLOATING_PL', name: 'Last Floating PL' }, { key: 'CALC_FIRST_EQUITY', name: 'First Equity' }, { key: 'CALC_LAST_EQUITY', name: 'Last Equity' }, { key: 'CALC_TOTAL_DEPOSIT', name: 'Total Deposit' }, { key: 'CALC_TOTAL_WITHDRAWAL', name: 'Total Withdrawal' }, { key: 'CALC_TOTAL_CREDIT', name: 'Total Credit' }, { key: 'SHARE_AMOUNT_METHOD1', name: 'Share Amount Method1' }, { key: 'SHARE_AMOUNT_METHOD2', name: 'Share Amount Method2' }]
        }
    }
};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        profitShareView: {
            title: '利润分成设定',
            account_setting: '账号设定',
            profit_report: '分成报表',
            list: [{ text: '利润分成报表', link: '/profit/shareReport' }, { text: '已计算版本报表', link: '/profit/versionReport' }]
        }
    },
    hk: {
        profitShareView: {
            title: '利潤分成設定',
            account_setting: '賬號設定',
            profit_report: '分成報表',
            list: [{ text: '利潤分成報表', link: '/profit/shareReport' }, { text: '已計算版本報表', link: '/profit/versionReport' }]
        }
    },
    en: {
        profitShareView: {
            title: 'Profit Sahre Setting',
            account_setting: 'Account Setting',
            profit_report: 'Profit Share Report',
            list: [{ text: 'Profit Share Report', link: '/profit/shareReport' }, { text: 'Version Report', link: '/profit/versionReport' }]
        }
    }
};

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        versionReport: {
            title: '已计算版本报表',
            search: '搜索',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            nodata: "没有查询到数据",
            btn: '版本回退',
            commit: '您真的要确认吗？',
            status_mapper: { "-1": "所有", "0": "生效中", "1": "已解绑" },
            selectArr: [{ label: '账号', value: 'LOGIN' }, { label: '代理账号', value: 'IB_ID' }],
            first_row: [{ key: 'LOGIN', name: '账号' }, { key: 'IB_ID', name: '代理账号' }, { key: 'VERSION', name: '版本' }, { key: 'LAST_CALC_START_DATE', name: '计算开始日期' }, { key: 'LAST_CALC_END_DATE', name: '计算结束日期' }, { key: 'PERCENTAGE', name: '百分比' }, { key: 'TOTAL_PL', name: '总盈亏' }, { key: 'SHARE_PL', name: '分成利润' }, { key: 'is_deleted', name: '账号当前状态' }]
        }
    },
    hk: {
        versionReport: {
            title: '已計算版本報表',
            search: '搜索',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            nodata: "沒有查詢到數據",
            btn: '版本回退',
            commit: '您真的要確認嗎？',
            status_mapper: { "-1": "所有", "0": "生效中", "1": "已解綁" },
            selectArr: [{ label: '賬號', value: 'LOGIN' }, { label: '代理賬號', value: 'IB_ID' }],
            first_row: [{ key: 'LOGIN', name: '賬號' }, { key: 'IB_ID', name: '代理賬號' }, { key: 'VERSION', name: '版本' }, { key: 'LAST_CALC_START_DATE', name: '計算開始日期' }, { key: 'LAST_CALC_END_DATE', name: '計算結束日期' }, { key: 'PERCENTAGE', name: '百分比' }, { key: 'TOTAL_PL', name: '總盈虧' }, { key: 'SHARE_PL', name: '分成利潤' }, { key: 'is_deleted', name: '賬號當前狀態' }]
        }
    },
    en: {
        versionReport: {
            title: 'Version Report',
            search: 'Search',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            nodata: "No data found",
            btn: 'Version Back',
            commit: 'Do you really want to confirm?',
            status_mapper: { "-1": "All", "0": "Active", "1": "Deleted" },
            selectArr: [{ label: 'Login', value: 'LOGIN' }, { label: 'IB Account', value: 'IB_ID' }],
            first_row: [{ key: 'LOGIN', name: 'Login' }, { key: 'IB_ID', name: 'IB Account' }, { key: 'VERSION', name: 'Version' }, { key: 'LAST_CALC_START_DATE', name: 'Calculate Start Date' }, { key: 'LAST_CALC_END_DATE', name: 'Calculate End Date' }, { key: 'PERCENTAGE', name: 'Percentage' }, { key: 'TOTAL_PL', name: 'Total PL' }, { key: 'SHARE_PL', name: 'Share PL' }, { key: 'is_deleted', name: 'Current Status' }]
        }
    }
};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    accountDatum: {
      crumbs: {
        newaAccount: "账户开户",
        amend: "账户修改"
      },
      links: {
        mtName: '服务器名称',
        delete: '删除',
        copyLink: '复制链接',
        GenerateLink: '生成链接',
        Operating: '操作',
        CreateBy: '创建人',
        CreateTime: '创建时间',
        LINK: '链接',
        Videoverification: '视频认证',
        SpreadType: '点差类型',
        Mtgroup: '组别',
        select: '请选择',
        Leverage: '杠杆',
        commission: '佣金',
        Addpoints: '加点',
        Currency: '货币',
        Platformtype: '平台类型',
        SLlink: '代理链接',
        addExclusiveLink: '新增专属链接',
        addSLlink: '绑定代理链接',
        exclusiveLink: '专属链接',
        save: '保存',
        cancel: '取消',
        bindingSLlink: '已绑定代理链接',
        open: '开启',
        close: '关闭'
      },
      sales: {
        title: '账号资料',
        form: {
          sales_id: "账号",
          acc_name: '账户名称',
          acc_type: {
            name: '账户类型',
            genderArr: [{ text: '请选择', value: "" }, { text: '公司', value: "C" }, { text: '国家', value: "N" }, { text: '地区', value: "R" }, { text: '办事处', value: "O" }, { text: '经理', value: "M" }, { text: '职员', value: "SL" }]
          },
          amend: "修改",
          codeUk: "UK代码",
          codeGm: "GM代码",
          codeUae: "UAE代码",
          codeMu: "MU代码",
          codeEu: "EU代码",
          codeKy: "GM2代码",
          last_code: "上级账户",
          password: '密码',
          agent: [{ 'text': '请选择', value: 0, childList: [{ 'text': '请选择', value: "" }] }, { 'text': '中国(8)', value: 8, childList: [{ 'text': '请选择', value: 0 }, { 'text': '香港(10)', value: 10 }, { 'text': '上海(11)', value: 11 }, { 'text': '新疆(12)', value: 12 }, { 'text': '西安(13)', value: 13 }, { 'text': '湖南(14)', value: 14 }, { 'text': '深圳(15)', value: 15 }, { 'text': '台湾(16)', value: 16 }, { 'text': '河南(17)', value: 17 }, { 'text': '大连(18)', value: 18 }] }, { 'text': '东南亚(7)', value: 7, childList: [{ 'text': '请选择', value: 0 }, { 'text': '办事处1(10)', value: 10 }, { 'text': '办事处2(11)', value: 11 }, { 'text': '办事处3(12)', value: 12 }] }, { 'text': '欧洲(3)', value: 3, childList: [{ 'text': '请选择', value: 0 }, { 'text': '办事处1(10)', value: 10 }, { 'text': '办事处2(11)', value: 11 }, { 'text': '办事处3(12)', value: 12 }] }, { 'text': '中东(5)', value: 5, childList: [{ 'text': '请选择', value: 0 }, { 'text': '办事处1(10)', value: 10 }, { 'text': '办事处2(11)', value: 11 }, { 'text': '办事处3(12)', value: 12 }] }],
          Area: [{ 'text': '请选择', value: 0, childList: [{ 'text': '请选择', value: 0 }] }, { 'text': 'UK(8)', value: 8, childList: [{ 'text': '请选择', value: 0 }, { 'text': '中国(8)', value: 8 }, { 'text': '东南亚(7)', value: 7 }, { 'text': '欧洲(3)', value: 3 }, { 'text': '中东(5)', value: 5 }] }, { 'text': 'GM(6)', value: 6, childList: [{ 'text': '请选择', value: 0 }, { 'text': '中国(8)', value: 8 }, { 'text': '东南亚(7)', value: 7 }, { 'text': '欧洲(3)', value: 3 }, { 'text': '中东(5)', value: 5 }] }, { 'text': 'MU(1)', value: 1, childList: [{ 'text': '请选择', value: 0 }, { 'text': '中国(8)', value: 8 }, { 'text': '东南亚(6)', value: 6 }, { 'text': '中东(9)', value: 9 }] }, { 'text': 'EU(5)', value: 5, childList: [{ 'text': '请选择', value: 0 }, { 'text': '中国(8)', value: 8 }, { 'text': '东南亚(7)', value: 7 }, { 'text': '欧洲(3)', value: 3 }, { 'text': '中东(5)', value: 5 }] }],
          officeState: {
            name: "职员状态",
            countryArr: [{ 'text': '全职', value: 'F' }, { 'text': '兼职', value: 'P' }, { 'text': '离职', value: 'D' }]
          },
          onboard_date: '入职时间',
          resignation_date: '离职时间'
        }
      },
      sales_info: {
        title: '个人资料',
        form: {
          birth_date: "出生日期",
          gender: {
            name: '性别',
            genderArr: [{ 'text': '请选择', value: '' }, { 'text': '先生', value: 'F' }, { 'text': '女士', value: 'M' }]
          },
          country: {
            name: '国家/地区',
            countryArr: ['请选择', '中国', '香港特别行政区', '台湾', '阿富汗', '阿尔巴尼亚', '亚尔及利亚', '萨摩亚', '安道尔', '安哥拉', '安圭拉', '南极', '安提瓜和巴布达', '阿根廷', '亚美尼亚', '阿鲁巴', '澳洲', '维也纳', '阿塞拜疆', '巴哈马', '巴林', '孟加拉共和国', '巴巴多斯', '白俄逻斯', '比利时', '伯利兹', '贝宁', '百慕达', '不丹', '玻利维亚', '波斯尼亚', '博茨瓦纳', '波维特岛', '巴西', '英属印度洋领域', '英国公民', '英国属土公民', '英国国民海外', '英国海外公民', '受英国保护人士', '英籍人士', '文莱', '保加利亚', '布基纳法索', '布基纳法索', '缅甸', '蒲隆地', '柬埔寨', '喀麦隆', '加拿大', '佛得角', '开曼群岛', '中非共和国', '乍得', '智利', '圣诞岛', '科科斯群岛', '哥伦比亚', '科摩逻', '刚果', '库克群岛', '哥斯达尼加', '科特迪瓦', '克逻地亚', '古巴', '塞浦路斯', '捷克', '丹麦', '吉布提', '多明尼加共和国', '多米尼克', '东帝汶', '厄瓜多尔', '埃及', '西班牙', '萨尔瓦多', '赤道几内亚', '厄立特里亚', '爱沙尼亚', '埃塞俄比亚', '福克兰群岛', '法逻群岛', '斐济', '芬兰', '法国', '法国大都会', '法属圭亚那', '玻里尼西亚', '法国南方属地', '加彭', '冈比亚', '甘比亚', '格鲁吉亚', '德国', '迦纳', '直布逻陀', '希蜡', '格陵兰', '格林纳达', '关岛', '危地马拉', '几内亚', '几内亚比绍', '圭亚那', '海地', '赫德及麦当奴群岛', '洪都拉斯', '匈牙利', '冰岛', '印度', '印度尼西亚', '伊朗', '伊拉克', '爱尔兰', '以色列', '意大利', '牙买加', '日本', '约旦', '哈萨克斯坦', '肯尼亚', '基里巴斯', '韩国', '科威特', '吉尔吉斯坦', '老挝寮国', '拉脱维亚', '黎巴嫩', '莱索托', '利比里亚', '阿拉伯利比亚民众国', '列支敦士登', '立陶宛', '卢森堡', '澳门特别行政区', '前南斯拉夫马其顿共和国', '马达加斯加', '马拉维', '马来西亚', '马尔代夫', '马里', '马耳他', '马绍尔群岛', '马提尼克岛', '毛里塔尼亚', '毛里求斯', '马约特岛', '墨西哥', '密克逻尼西亚联邦', '摩尔多瓦', '摩纳哥', '蒙古', '蒙特内哥逻', '蒙特塞拉特', '摩洛哥', '莫桑比克', '缅甸', '纳米比亚', '瑙鲁', '尼泊尔', '荷属安的列斯群岛', '荷兰', '新喀里多尼亚', '新西兰', '尼加拉瓜', '尼日尔', '尼日利亚', '纽埃', '诺福克岛', '朝鲜', '北马里亚纳群岛', '挪威', '巴勒斯坦佔领区', '阿曼', '巴基斯坦', '帕劳', '巴拿马', '巴布亚新几内亚', '巴拉圭', '秘鲁', '菲律宾', '皮特凯恩', '波兰', '葡萄牙', '波多黎各', '卡塔尔', '难民', '其他难民', '留尼汪岛', '逻马尼亚', '俄逻斯联邦', '卢旺达', '圣卢西亚', '萨摩亚', '圣马利诺', '圣多美和普林西比', '沙特阿拉伯', '塞内加尔', '塞尔维亚', '塞舌尔', '塞拉利昂', '新加坡', '斯洛伐克共和国', '斯洛文尼亚', '所逻门群岛', '索马里', '斯里兰卡', '圣赫勒拿', '基茨-尼维斯', '圣皮埃尔岛及密克隆岛', '圣文森特和格林纳丁斯', '无国籍人士', '苏丹', '苏里南', '斯瓦巴及尖绵', '斯威士兰', '瑞典', '瑞士', '叙利亚', '塔吉克斯坦', '坦桑尼亚', '泰国', '多哥', '托克劳群岛', '东加', '特立尼达和多巴哥', '突尼斯', '土耳其', '土库曼斯坦', '特克斯和凯科斯群岛', '图瓦卢', '美国米诺群岛', '乌干达', '乌克兰', '阿拉伯联合酋长国', '联合国办事署', '联合国组织', '美利坚合众国美国', '乌拉圭', '乌兹别克斯坦', '瓦努阿图', '梵蒂冈', '委内瑞拉', '越南', '英属处女群岛', '美属处女群岛', '瓦利斯和富图纳群岛', '萨摩亚西', '也门', '也门共和国', '南非', '扎伊尔', '赞比亚', '津巴布韦']
          },
          addr: "地址",
          phone: "电话",
          email: "邮箱",
          lang: {
            name: '语言',
            langArr: ['请选择', '简体中文', '繁体中文', '英文']
          },
          doc_type: {
            name: '证件类型',
            docTypeArr: ['请选择', '身份证', '驾驶证', '护照']
          },
          concatArr: ["请选择", "CNY", "USD"],
          docNo: '证件号码',
          docFrontImg: '证件附件(正面)',
          docBackImg: '证件附件(反面)',
          localCcy: '当地货币',
          bankCardType: {
            name: '银行卡类型',
            bankCardTypeArr: ['请选择', 'DR借记卡', 'CR信用卡']
          },
          bankCardNo: '银行卡号',
          beneficiaryName: '受益人',
          bank: {
            name: '银行',
            bankArr: ['请选择', '中国工商银行', '中国农业银行', '中国建设银行', '招商银行', '中信银行', '交通银行', '广东发展银行', '上海浦东发展银行', '中国银行', '城市商业银行', '中国农业发展银行', '光大银行', '华夏银行', '中国民生银行', '深圳发展银行', '兴业银行', '恒丰银行', '浙商银行', '农村合作银行', '农村商业银行', '农村信用合作社', '城市信用合作社', '徽商银行', '渤海银行', '中国邮政储蓄银行', '北京银行', '平安银行股份有限公司', '南京银行', '江苏银行', '宁波银行', '上海银行', '杭州银行', '东亚银行', '青岛银行', '广州银行', '其他']
          },
          swiftCode: '银行代码',
          bankAddr: '开户行地址',
          bankCardImg: '银行卡图片',
          remark: '备注',
          branchName: '分行名称',
          branchProvince: '分行所在省份',
          branchCity: '分行所在城市',
          addTile: '银行帐号',
          addButton: '添加',
          cancel: '取消',
          Operating: '操作',
          delete: '刪除',
          createby: '创建人',
          createtime: '创建时间',
          PaymentInfo: '付款资讯',
          status: '状态',
          statusDate: {
            0: '启用',
            1: '未启用'
          }
        }
      },
      inputHint: {
        noAccount: "账户不存在",
        sales_id: '请正确输入6位以上数字的账号',
        acc_name: '请正确输入账户名称',
        acc_type: '请选择账户类型',
        codeUk: '请正确输入20位以内的UK代码',
        codeGm: '请正确输入20位以内的GM代码',
        codeUae: '请正确输入20位以内的UAE代码',
        codeMu: '请正确输入20位以内的MU代码',
        codeEu: '请正确输入20位以内的EU代码',
        codeKy: '请正确输入20位以内的GM2代码',
        last_code: '请正确输入11位以内的上级账户',
        password: '请正确输入6位以上密码',
        birth_date: '请选择出生日期',
        gender: '请选择性别',
        officeState: '请选择职员状态',
        country: '请选择国家',
        addr: '请输入地址',
        phone: '请正确输入电话',
        email: '请正确输入电子邮箱',
        lang: '请选择语言',
        doc_type: '请选择证件类型',
        doc_no: '请正确输入证件号码',
        doc_front_img: '请选择上传图片',
        doc_back_img: '请选择上传图片',
        local_ccy: '请选择货币',
        bank_card_type: '请选择银行卡类型',
        bank_card_no: '请输入银行卡号',
        branchName: '请输入分行名称',
        branchProvince: '请输入分行所在省份',
        branchCity: '请输入分行所在城市',
        bank: '请选择银行',
        beneficiary_name: '请输入受益人',
        swift_code: '请输入银行代码',
        bank_addr: '请输入开户地址',
        bank_card_img: '请选择上传图片',
        remark: '请输入备注',
        birth_date_Verify: '年龄未满18周岁,请填写大于18周岁的正确出生日期'
      },
      send: "发送邮件",
      submit: "注册",
      query: "查询",
      changeBtn: '保存修改',
      flaseTip: '请正确输入',
      loginTip: '账号或密码有误',
      fileUpload: '选择文件上传',
      repeatId: '该账号已被注册',
      TipPassWord: '密码已进行隐藏处理，如需修改请直接填写',
      copy: '复制',
      logOut: {
        word: "是否退出登录?",
        yes: '确定',
        no: '取消'
      },
      submitResult: {
        succeed: "保存成功",
        sendEmailSucceed: "发送邮件成功",
        sendEmailErr: "发送邮件失败",
        err: "请正确填写信息"
      },
      backstageErr: {
        sales_id: "该用户账号已存在",
        sales_id_err: "该账号已重复存在",
        acc_name: "该用户账户名称已存在",
        last_code: "上级账户输入有误",
        codeVerify: '该代码已存在'
      }
    }
  },
  hk: {
    accountDatum: {
      crumbs: {
        newaAccount: "帳戶開戶",
        amend: "帳戶修改"
      },
      links: {
        mtName: '服務器名稱',
        delete: '刪除',
        copyLink: '複製鏈接',
        GenerateLink: '生成鏈接',
        Operating: '操作',
        CreateBy: '創建人',
        CreateTime: '創建時間',
        LINK: '鏈接',
        Videoverification: '視頻認證',
        SpreadType: '點差類型',
        Mtgroup: '組別',
        select: '請選擇',
        Leverage: '槓桿',
        commission: '佣金',
        Addpoints: '加點',
        Currency: '貨幣',
        Platformtype: '平台類型',
        SLlink: '代理鏈接',
        addExclusiveLink: '新增專屬鏈接',
        addSLlink: '綁定代理链接',
        exclusiveLink: '專屬鏈接',
        save: '保存',
        cancel: '取消',
        bindingSLlink: '已綁定代理鏈接',
        open: '開啟',
        close: '關閉'
      },
      sales: {
        title: '帳號資料',
        form: {
          sales_id: "帳號",
          acc_name: '帳戶名稱',
          acc_type: {
            name: '帳戶類型',
            genderArr: [{ text: '請選擇', value: "" }, { text: '公司', value: "C" }, { text: '國家', value: "N" }, { text: '地區', value: "R" }, { text: '辦事處', value: "O" }, { text: '經理', value: "M" }, { text: '職員', value: "SL" }]
          },
          amend: "修改",
          codeUk: "UK代碼",
          codeGm: "GM代碼",
          codeUae: "UAE代碼",
          codeMu: "MU代碼",
          codeEu: "EU代碼",
          codeKy: "GM2代碼",
          last_code: "上級帳戶",
          password: '密碼',
          agent: [{ 'text': '請選擇', value: 0, childList: [{ 'text': '請選擇', value: 0 }] }, { 'text': '中國(8)', value: 8, childList: [{ 'text': '請選擇', value: 0 }, { 'text': '香港(10)', value: 10 }, { 'text': '上海(11)', value: 11 }, { 'text': '新疆(12)', value: 12 }, { 'text': '西安(13)', value: 13 }, { 'text': '湖南(14)', value: 14 }, { 'text': '深圳(15)', value: 15 }, { 'text': '臺灣(16)', value: 16 }, { 'text': '河南(17)', value: 17 }, { 'text': '大連(18)', value: 18 }] }, { 'text': '東南亞(7)', value: 7, childList: [{ 'text': '請選擇', value: 0 }, { 'text': '辦事處1(10)', value: 10 }, { 'text': '辦事處2(11)', value: 11 }, { 'text': '辦事處3(12)', value: 12 }] }, { 'text': '歐洲(3)', value: 3, childList: [{ 'text': '請選擇', value: 0 }, { 'text': '辦事處1(10)', value: 10 }, { 'text': '辦事處2(11)', value: 11 }, { 'text': '辦事處3(12)', value: 12 }] }, { 'text': '中東(5)', value: 5, childList: [{ 'text': '請選擇', value: 0 }, { 'text': '辦事處1(10)', value: 10 }, { 'text': '辦事處2(11)', value: 11 }, { 'text': '辦事處3(12)', value: 12 }] }],
          Area: [{ 'text': '請選擇', value: 0, childList: [{ 'text': '請選擇', value: 0 }] }, { 'text': 'UK(8)', value: 8, childList: [{ 'text': '請選擇', value: 0 }, { 'text': '中國(8)', value: 8 }, { 'text': '東南亞(7)', value: 7 }, { 'text': '欧洲(3)', value: 3 }, { 'text': '中东(5)', value: 5 }] }, { 'text': 'GM(6)', value: 6, childList: [{ 'text': '請選擇', value: 0 }, { 'text': '中國(8)', value: 8 }, { 'text': '東南亞(7)', value: 7 }, { 'text': '歐洲(3)', value: 3 }, { 'text': '中東(5)', value: 5 }] }, { 'text': 'MU(1)', value: 1, childList: [{ 'text': '請選擇', value: 0 }, { 'text': '中國(8)', value: 8 }, { 'text': '東南亞(6)', value: 6 }, { 'text': '中東(9)', value: 9 }] }],
          officeState: {
            name: "職員狀態",
            countryArr: [{ 'text': '全職', value: 'F' }, { 'text': '兼職', value: 'P' }, { 'text': '離職', value: 'D' }]
          },
          onboard_date: '入職時間',
          resignation_date: '離職時間'
        }
      },
      sales_info: {
        title: '個人資料',
        form: {
          birth_date: "出生日期",
          gender: {
            name: '性別',
            genderArr: [{ 'text': '請選擇', value: '' }, { 'text': '先生', value: 'F' }, { 'text': '女士', value: 'M' }]
          },
          country: {
            name: '國家/地區',
            countryArr: ['請選擇', '中國', '香港特別行政區', '臺灣', '阿富汗', '阿爾巴尼亞', '亞爾及利亞', '薩摩亞', '安道爾', '安哥拉', '安圭拉', '南極', '安地卡及巴布達', '阿根廷', '亞美尼亞', '阿魯巴', '澳洲', '維也納', '亞塞拜然', '巴哈馬', '巴林', '孟加拉共和國', '巴貝多', '白俄邏斯', '比利時', '貝里斯', '貝南', '百慕達', '不丹', '玻利維亞', '波士尼亞', '波札那', '波維特島', '巴西', '英屬印度洋領域', '英國公民', '英國屬土公民', '英國國民海外', '英國海外公民', '受英國保護人士', '英籍人士', '汶萊', '保加利亞', '布吉納法索', '布吉納法索', '緬甸', '蒲隆地', '柬埔寨', '喀麥隆', '加拿大', '維德角', '開曼群島', '中非共和國', '查德', '智利', '聖誕島', '科科斯群島', '哥倫比亞', '科摩邏', '剛果', '科克群島', '哥斯達尼加', '象牙海岸', '克邏地亞', '古巴', '賽普勒斯', '捷克', '丹麥', '吉布地', '多明尼加共和國', '多明尼克', '東帝汶', '厄瓜多爾', '埃及', '西班牙', '薩爾瓦多', '赤道幾內亞', '厄立特里亞', '愛沙尼亞', '衣索比亞', '福克蘭群島', '法邏群島', '斐濟', '芬蘭', '法國', '法國大都會', '法屬圭亞那', '玻裡尼西亞', '法國南方屬地', '加彭', '甘比亞', '甘比亞', '格魯吉亞', '德國', '迦納', '直布邏陀', '希蠟', '格陵蘭', '格瑞那達', '關島', '瓜地馬拉', '幾內亞', '幾內亞比索', '圭亞那', '海地', '赫德及麥當奴群島', '洪都拉斯', '匈牙利', '冰島', '印度', '印尼', '伊朗', '伊拉克', '愛爾蘭', '以色列', '義大利', '牙買加', '日本', '約旦', '哈薩克', '肯亞', '吉里巴斯', '韓國', '科威特', '吉爾吉斯坦', '老撾寮國', '拉脫維亞', '黎巴嫩', '賴索托', '賴比瑞亞', '阿拉伯利比亞民眾國', '列支敦士登', '立陶宛', '盧森堡', '澳門特別行政區', '前南斯拉夫馬其頓共和國', '馬達加斯加', '馬拉威', '馬來西亞', '馬爾地夫', '馬里', '馬爾他', '馬紹爾群島', '馬提尼克島', '茅利塔尼亞', '模里西斯', '馬約特', '墨西哥', '密克邏尼西亞聯邦', '莫爾達瓦', '摩納哥', '蒙古', '蒙特內哥邏', '蒙瑟拉特島', '摩洛哥', '莫三比克', '緬甸', '納米比亞', '諾魯', '尼泊爾', '荷屬安的列斯群島', '荷蘭', '新赫里多尼亞', '紐西蘭', '尼加拉瓜', '尼日爾', '奈及利亞', '紐埃', '諾福克島', '朝鮮', '北馬里安納群島', '挪威', '巴勒斯坦佔領區', '阿曼', '巴基斯坦', '帛琉', '巴拿馬', '巴布亞紐幾內亞', '巴拉圭', '秘魯', '菲律賓', '皮特凱恩', '波蘭', '葡萄牙', '波多黎各', '卡達', '難民', '其他難民', '留尼旺島', '邏馬尼亞', '俄邏斯聯邦', '盧旺達', '聖露西亞', '薩摩亞', '聖馬利諾', '聖多美及普林西比島', '沙烏地阿拉伯', '塞內加爾', '塞爾維亞', '塞席爾', '獅子山', '新加坡', '斯洛伐克共和國', '斯洛維尼亞', '所邏門群島', '索馬里', '斯里蘭卡', '聖赫勒拿', '基茨-尼維斯', '聖皮爾島及密克隆島', '聖文森特和格林納丁斯群島', '無國籍人士', '蘇丹', '蘇利南', '斯瓦巴及尖綿', '史瓦濟蘭', '瑞典', '瑞士', '敘利亞', '塔吉克斯坦', '坦桑尼亞', '泰國', '多哥', '托克勞群島', '東加', '千里達和多巴哥', '突尼斯', '土耳其', '土庫曼斯坦', '特克斯和凱科斯群島', '吐瓦魯', '美國米諾群島', '烏干達', '烏克蘭', '阿拉伯聯合大公國', '聯合國辦事署', '聯合國組織', '美利堅合眾國美國', '烏拉圭', '烏茲別克斯坦', '瓦努阿圖', '梵蒂岡', '委內瑞拉', '越南', '英屬處女群島', '美屬處女群島', '瓦利斯和富圖納群島', '薩摩亞西', '葉門', '葉門共和國', '南非', '薩伊', '尚比亞', '辛巴威']
          },
          addr: "地址",
          phone: "電話",
          email: "郵箱",
          lang: {
            name: '語言',
            langArr: ['請選擇', '簡體中文', '繁體中文', '英文']
          },
          doc_type: {
            name: '證件類型',
            docTypeArr: ['請選擇', '身份證', '駕駛證', '護照']
          },
          concatArr: ["請選擇", "CNY", "USD"],
          docNo: '證件號碼',
          docFrontImg: '證件附件(正面)',
          docBackImg: '證件附件(反面)',
          localCcy: '當地貨幣',
          bankCardType: {
            name: '銀行卡類型',
            bankCardTypeArr: ['請選擇', 'DR借記卡', 'CR信用卡']
          },
          bankCardNo: '銀行卡號',
          beneficiaryName: '受益人',
          bank: {
            name: '銀行',
            bankArr: ['請選擇', '中國工商銀行', '中國農業銀行', '中國建設銀行', '招商銀行', '中信銀行', '交通銀行', '廣東發展銀行', '上海浦東發展銀行', '中國銀行', '城市商業銀行', '中國農業發展銀行', '光大銀行', '華夏銀行', '中國民生銀行', '深圳發展銀行', '興業銀行', '恒豐銀行', '浙商銀行', '農村合作銀行', '農村商業銀行', '農村信用合作社', '城市信用合作社', '徽商銀行', '渤海銀行', '中國郵政儲蓄銀行', '北京銀行', '平安銀行股份有限公司', '南京銀行', '江蘇銀行', '寧波銀行', '上海銀行', '杭州銀行', '東亞銀行', '青島銀行', '廣州銀行', '其他']
          },
          swiftCode: '銀行代碼',
          bankAddr: '開戶行地址',
          bankCardImg: '銀行卡圖片',
          remark: '備註',
          branchName: '分行名稱',
          branchProvince: '分行所在省份',
          branchCity: '分行所在城市',
          addTile: '銀行賬號',
          addButton: '添加',
          cancel: '取消',
          Operating: '操作',
          delete: '刪除',
          createby: '創建人',
          createtime: '創建時間',
          PaymentInfo: '付款資訊',
          status: '狀態',
          statusDate: {
            0: '啟用',
            1: '未啟用'
          }
        }
      },
      inputHint: {
        noAccount: "帳戶不存在",
        sales_id: '請正確輸入6位以上數字的帳號',
        acc_name: '请正确输入账户名称',
        acc_type: '請選擇帳戶類型',
        codeUk: '請正確輸入20位以內的UK代碼',
        codeGm: '請正確輸入20位以內的GM代碼',
        codeUae: '請正確輸入20位以內的UAE代碼',
        codeMu: '請正確輸入20位以內的MU代碼',
        codeEu: '請正確輸入20位以內的EU代碼',
        codeKy: '請正確輸入20位以內的GM2代碼',
        last_code: '请正确输入11位以内的上级账户',
        password: '請正確輸入6位以上密碼',
        birth_date: '请选择出生日期',
        gender: '请选择性别',
        officeState: '請選擇職員狀態',
        country: '请选择国家',
        addr: '请输入地址',
        phone: '请正确输入电话',
        email: '请正确输入电子邮箱',
        lang: '请选择语言',
        doc_type: '请选择证件类型',
        doc_no: '请正确输入证件号码',
        doc_front_img: '请选择上传图片',
        doc_back_img: '请选择上传图片',
        local_ccy: '请选择货币',
        bank_card_type: '请选择银行卡类型',
        bank_card_no: '请输入银行卡号',
        bank: '请选择银行',
        beneficiary_name: '请输入受益人',
        branchName: '请输入分行名称',
        branchProvince: '请输入分行所在省份',
        branchCity: '请输入分行所在城市',
        swift_code: '请输入银行代码',
        bank_addr: '请输入开户地址',
        bank_card_img: '请选择上传图片',
        remark: '请输入备注',
        birth_date_Verify: '年齡未滿18周歲,請填寫大于18周歲的正確出生日期'
      },
      send: "發送郵件",
      submit: "註冊",
      query: "查詢",
      changeBtn: '保存修改',
      flaseTip: '請正確輸入',
      loginTip: '帳號或密碼有誤',
      fileUpload: '選擇檔上傳',
      repeatId: '該帳號已被注册',
      TipPassWord: '密碼已進行隱藏處理，如需修改請直接填寫',
      copy: '複製',
      logOut: {
        word: '是否登出?',
        yes: '確定',
        no: '取消'
      },
      submitResult: {
        succeed: "保存成功",
        sendEmailSucceed: "發送郵件成功",
        sendEmailErr: "發送郵件失敗",
        err: "請正確填寫資訊"
      },
      backstageErr: {
        sales_id: "該用戶賬號已存在",
        sales_id_err: "该賬戶已重複存在",
        acc_name: "該用戶賬戶名稱已存在",
        last_code: "上級帳戶輸入有誤",
        codeVerify: '該代碼已存在'
      }
    }
  },
  en: {
    accountDatum: {
      crumbs: {
        newaAccount: "Create account",
        amend: "Account changes"
      },
      links: {
        mtName: 'Server Name',
        delete: 'Delete',
        copyLink: 'COPY LINK',
        GenerateLink: 'Generate link',
        Operating: 'Operating',
        CreateBy: 'Create by',
        CreateTime: 'Create time',
        LINK: 'LINK',
        Videoverification: 'Video verification',
        SpreadType: 'Spread Type',
        Mtgroup: 'Mt group',
        select: 'Select',
        Leverage: 'Leverage',
        commission: 'Commission',
        Addpoints: 'Add points',
        Currency: 'Currency',
        Platformtype: 'Platform type',
        SLlink: 'SL link',
        addExclusiveLink: 'Add exclusive link',
        addSLlink: 'Add SL link',
        exclusiveLink: 'Exclusive link',
        save: 'save',
        cancel: 'cancel',
        bindingSLlink: 'Binding SL link',
        open: 'Open',
        close: 'Close'
      },
      sales: {
        title: 'Account Information',
        form: {
          sales_id: "Sales Id",
          acc_name: 'Account Name',
          acc_type: {
            name: 'Account Type',
            genderArr: [{ text: 'Please Select', value: "" }, { text: 'Company', value: "C" }, { text: 'Regions', value: "N" }, { text: 'Area', value: "R" }, { text: 'Office', value: "O" }, { text: 'Manager', value: "M" }, { text: 'Staff', value: "SL" }]
          },
          amend: "modify",
          codeUk: "UK code",
          codeGm: "GM code",
          codeUae: "UAE code",
          codeMu: "MU code",
          codeEu: "EU code",
          codeKy: "GM2 code",
          last_code: "Parent Account",
          password: 'Password',
          agent: [{ 'text': 'Please Select', value: 0, childList: [{ 'text': 'Please Select', value: 0 }] }, { 'text': 'China(8)', value: 8, childList: [{ 'text': 'Please Select', value: 0 }, { 'text': 'Hongkong(10)', value: 10 }, { 'text': 'Shanghai(11)', value: 11 }, { 'text': 'Sinkiang(12)', value: 12 }, { 'text': 'XiAn(13)', value: 13 }, { 'text': 'HuNan(14)', value: 14 }, { 'text': 'Shenzhen(15)', value: 15 }, { 'text': 'Formosa(16)', value: 16 }, { 'text': 'Henan Province(17)', value: 17 }, { 'text': 'Dalian(18)', value: 18 }] }, { 'text': 'Southeast Asia(7)', value: 7, childList: [{ 'text': 'Please Select', value: 0 }, { 'text': 'office1(10)', value: 10 }, { 'text': 'office2(11)', value: 11 }, { 'text': 'office3(12)', value: 12 }] }, { 'text': 'Europe(3)', value: 3, childList: [{ 'text': 'Please Select', value: 0 }, { 'text': 'office1(10)', value: 10 }, { 'text': 'office2(11)', value: 11 }, { 'text': 'office3(12)', value: 12 }] }, { 'text': 'the Middle East(5)', value: 5, childList: [{ 'text': 'Please Select', value: 0 }, { 'text': 'office1(10)', value: 10 }, { 'text': 'office2(11)', value: 11 }, { 'text': 'office3(12)', value: 12 }] }],
          Area: [{ 'text': 'Please Select', value: 0, childList: [{ 'text': 'Please Select', value: 0 }] }, { 'text': 'UK(8)', value: 8, childList: [{ 'text': 'Please Select', value: 0 }, { 'text': 'China(8)', value: 8 }, { 'text': 'Southeast Asia(7)', value: 7 }, { 'text': 'Europe(3)', value: 3 }, { 'text': 'the Middle East(5)', value: 5 }] }, { 'text': 'GM(6)', value: 6, childList: [{ 'text': 'Please Select', value: 0 }, { 'text': 'China(8)', value: 8 }, { 'text': 'Southeast Asia(7)', value: 7 }, { 'text': 'Europe(3)', value: 3 }, { 'text': 'the Middle East(5)', value: 5 }] }, { 'text': 'MU(1)', value: 1, childList: [{ 'text': 'Please Select', value: 0 }, { 'text': 'China(8)', value: 8 }, { 'text': 'Southeast Asia(6)', value: 6 }, { 'text': 'the Middle East(9)', value: 9 }] }],
          officeState: {
            name: "Employee status",
            countryArr: [{ 'text': 'full time', value: 'F' }, { 'text': 'part time', value: 'P' }, { 'text': 'Leave', value: 'D' }]
          },
          onboard_date: 'Onboard Date',
          resignation_date: 'Resigned Date'
        }
      },
      sales_info: {
        title: 'Personal Information',
        form: {
          birth_date: "Birth Date",
          gender: {
            name: 'Gender',
            genderArr: [{ 'text': 'Please Select', value: '' }, { 'text': 'Male', value: 'F' }, { 'text': 'Female', value: 'M' }]
          },
          country: {
            name: 'Country',
            countryArr: ['Please Select', 'CHN China', 'HKG Hong Kong S.A.R.', 'TWN Taiwan', 'AFG Afghanistan', 'ALB Albania', 'DZA Algeria', 'ASM Samoa', 'And Andorra', 'AGO Angola', 'AIA Anguilla', 'ATA Antarctica', 'ATG Antigua and Barbuda', 'ARG Argentina', 'ARM Armenia', 'ABW Aruba', 'AUS Australia', 'AUT Vienna', 'AZE Azerbaijan', 'BHS Bahamas', 'BHR Bahrain', 'BGD Bangladesh', 'BRB Barbados', 'BLR Belarus', 'BEL Belgium', 'BLZ Belize', 'Ben Benin', 'BMU Bermuda', 'BTN Bhutan', 'Bol Bolivia', 'BIH Bosnia', 'BWA Botswana', 'BVT Povet', 'BRA Brazil', 'IOT British Indian Ocean Area', 'GBR British citizenship', 'GBD British Dependent Territories Citizens', 'GBN British National Overseas', 'GBO British Overseas Citizen', 'GBP protected by the British,', 'GBS British', 'BRN Brunei', 'BGR Bulgaria', 'BFA Burkina Faso', 'HVO Burkina Faso', 'BUR Burma', 'BDI Burundi', 'KHM Cambodia', 'CMR Cameroon', 'CAN Canada', 'CPV Cape Verde', 'CYM Cayman Islands', 'CAF Central African Republic', 'TCD Chad', 'CHL Chile', 'CXR Christmas Island', 'CCK Cocos Islands', 'COL Colombia', 'COM Como', 'COG Congo', 'COK Cook Islands', 'CRI Costa Rica', "CIV Côte d'Ivoire", 'HRV Kolodia', 'CUB Cuba', 'CYP Cyprus', 'CZE Czech', 'DNK Denmark', 'DJI Djibouti', 'Dom Dominican Republic', 'DMA Dominica', 'TLS East Timor', 'ECU Ecuador', 'EGY Egypt', 'ESP Spain', 'SLV Salvador', 'GNQ Equatorial Guinea', 'ERI Eritrea', 'Est Estonia', 'ETH Ethiopia', 'FLK Falkland Islands', 'FRO Lego Islands', 'FJI Fiji', 'FIN Finland', 'FRA France', 'FXX Metropolis of France', 'GUF French Guiana', 'PYF Polynesia', 'ATF South of France', 'GAB Gabon', 'GLP Gambia', 'GMB Gambia', 'GEO Georgia', 'DEU Germany', 'GHA Ghana', 'GIB Direct', 'GRC Greek wax', 'GRL Greenland', 'GRD Grenada', 'GUM Guam', 'GTM Guatemala', 'GIN Guinea', 'GNB-Bissau', 'GUY Guyana', 'HTI Haiti', 'HMD Hurd and McDonald Islands', 'HND Honduras', 'HUN Hungary', 'ISL Iceland', 'IND India', 'IDN Indonesia', 'IRN Iran', 'IRQ Iraq', 'IRL Ireland', 'ISR Israel', 'ITA Italy', 'JAM Jamaica', 'JPN Japan', 'JOR Jordan', 'KAZ Kazakhstan', 'Ken Kenya', 'KIR Kiribati', 'KOR Korea', 'KWT Kuwait', 'KGZ Kyrgyzstan', 'LAO Laos Laos', 'LVA Latvia', 'LBN Lebanon', 'LSO Lesotho', 'LBR Liberia', 'LBY Libyan Arab Jamahiriya', 'LIE Liechtenstein', 'LTU Lithuania', 'LUX Luxembourg', 'MAC Macao Special Administrative Region', 'MKD Former Yugoslav Republic of Macedonia', 'MDG Madagascar', 'MWI Malawi', 'MYS Malaysia', 'MDV Maldives', 'MLI Mali', 'MLT Malta', 'MHL Marshall Islands', 'MTQ Martinique', 'MRT Mauritania', 'MUS Mauritius', 'MYT Mayotte', 'MEX Mexico', 'FSM Federated States of Micronesia', 'MDA Moldova', 'MCO Monaco', 'MNG Mongolia', 'MNE Montenegro', 'MSR Montserrat', 'MAR Morocco', 'MOZ Mozambique', 'MMR Burma', 'Nam Namibia', 'NRU Nauru', 'NPL Nepal', 'ANT Netherlands Antilles', 'NLD Netherlands', 'NCL New Caledonia', 'NZL New Zealand', 'NIC Nicaragua', 'NER Niger', 'NGA Nigeria', 'NIU Niue', 'NFK Norfolk Island', 'PRK North Korea', 'MNP Northern Mariana Islands', 'NOR NORWAY', 'PSE Occupied Palestinian Territory', 'OMN Oman', 'PAK PAKISTAN', 'PLW Palau', 'Pan Panama', 'PNG Papua New Guinea', 'PRY Paraguay', 'PER Peru', 'PHL Philippines', 'PCN Pitcairn', 'POL Poland', 'PRT Portugal', 'PRI Puerto Rico', 'QAT Qatar,', 'XXB Refugee', 'XXC other refugees', 'REU Reunion Island', 'ROU Romanian', 'RUS Russian Federation', 'RWA Rwanda', 'LCA Saint Lucia', 'WSM Samoa', 'SMR San Marino', 'STP Sao Tome and Principe', 'SAU Saudi Arabia', 'SEN Senegal', 'SRB Serbia', 'SYC Seychelles', 'SLE Sierra', 'SGP Singapore', 'SVK the Slovak Republic', 'SVN Slovenia', 'SLB Solomon Islands', 'SOM Somalia', 'LKA Sri Lanka', 'SHN St. Helena', 'KNA Kitts-Nevis', 'SPM Saint Pierre and Miquelon', 'VCT Saint Vincent and the Grenadines', 'XXA stateless person', 'SDN Sudan', 'SUR Suriname', 'SJM Swabian and Spike', 'SWZ Swaziland', 'SWE Sweden', 'CHE Switzerland', 'SYR Syria', 'TJK Tajikistan', 'TZA Tanzania', 'THA Thailand', 'TGO Togo', 'TKL Tokelau', 'TON Plus', 'TTO Trinidad and Tobago', 'TUN Tunisia', 'TUR Turkey', 'TKM Turkmenistan', 'TCA Turks and Caicos Islands', 'TUV Tuvalu', 'UMI American Mino', 'UGA Uganda', 'UKR Ukraine', 'ARE United Arab Emirates', 'UNA United Nations Office', 'UNO United Nations Organization', 'USA United States of America USA', 'URY Uruguay', 'UZB Uzbekistan', 'VUT Vanuatu', 'VAT Vatican', 'VEN Venezuela', 'VNM Vietnam', 'VGB British Virgin Islands', 'VIR American Virgin Islands', 'WLF Wallis and Futuna Islands', 'ESH Samoa West', 'YMD Yemen', 'YEM Republic of Yemen', 'ZAF South Africa', 'ZAR Zaire', 'ZMB Zambia', 'ZWE Zimbabwe']
          },
          addr: "Address",
          phone: "Phone:",
          email: "Email",
          lang: {
            name: 'Email Language',
            langArr: ['Please Select', 'CHS Simplified Chinese', 'CHT Traditional Chinese', 'ENG English']
          },
          doc_type: {
            name: 'Document Type',
            docTypeArr: ['Please Select', 'IDC Identity Card', 'DRI Driver License', 'POT Passport']
          },
          concatArr: ["Please Select", "CNY", "USD"],
          docNo: 'Id Number',
          docFrontImg: 'Id Front Img',
          docBackImg: 'Id back Img',
          localCcy: 'Local Currency',
          bankCardType: {
            name: 'Card Type',
            bankCardTypeArr: ['please select', 'DR debit card', 'CR credit card']
          },
          bankCardNo: 'Bank Card Number',
          beneficiaryName: 'Beneficiary Name',
          bank: {
            name: 'Bank',
            bankArr: ['Please Select', 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA', 'AGRICULTURAL BANK OF CHINA', 'CHINA CONSTRUCTION BANK CORPORATION', 'CHINA MERCHANTS BANK', 'CITIC BANK CORPORATION LIMITED', 'BANK OF COMMUNICATIONS', 'CHINA GUANGFA BANK', 'SHANGHAI PUDONG DEVELOPMENT BANK', 'BANK OF CHINA LIMITED', 'CITY COMMERCIAL BANKS', 'AGRICULTURAL DEVELOPMENT BANK OF CHINA', 'CHINA EVERBRIGHT BANK', 'HUA XIA BANK', 'CHINA MINSHENG BANKING CORPORATION, LIMITED', 'SHENZHEN DEVELOPMENT BANK CO., LTD', 'INDUSTRIAL BANK', 'EVERGROWING BANK', 'CHINA ZHESHANG BANK', 'RURAL COOPERATION BANK', 'RURAL COMMERCIAL BANK', 'RURAL CREDIT COOPERATIVES UNION', 'CITY CREDIT COOPERATIVES UNION', 'HUISHANG BANK', 'CHINA BOHAI BANK', 'POSTAL SAVINGS BANK OF CHINA', 'BANK OF BEIJING', 'PING AN BANK', 'BANK OF NANJING', 'BANK OF JIANGSU', 'BANK OF NINGBO', 'BANK OF SHANGHAI', 'BANK OF HANGZHOU CO., LTD', 'THE BANK OF EAST ASIA LIMITED', 'BANK OF QINGDAO', 'BANK OF GUANGZHOU', 'OTHER']
          },
          swiftCode: 'Swift Code',
          bankAddr: 'Bank Address',
          bankCardImg: 'Bank Card Img',
          remark: 'Remark',
          branchName: 'Branch Name',
          branchProvince: 'Branch Province',
          branchCity: 'Branch City',
          addTile: 'Local Currency',
          addButton: 'Add',
          cancel: 'cancel',
          Operating: 'Operating',
          delete: 'delete',
          createby: 'createBy',
          createtime: 'createTime',
          PaymentInfo: 'Payment Info',
          status: 'Status',
          statusDate: {
            0: 'Approved',
            1: 'Unapproved'
          }
        }
      },
      inputHint: {
        noAccount: "Account does not exist",
        sales_id: 'Please enter the correct number above 6 digits',
        acc_name: 'Please enter the account name correctly',
        acc_type: 'Please select account type',
        codeUk: 'Please enter the UK code within 20 digits correctly',
        codeGm: 'Please enter the correct GM code within 20 digits',
        codeUae: 'Please enter the UAE code within 20 digits correctly',
        codeMu: 'Please enter the correct MU code within 20 digits',
        codeEu: 'Please enter the correct EU code within 20 digits',
        codeKy: 'Please enter the correct GM2 code within 20 digits',
        last_code: 'Please enter the superior account within 11 digits correctly',
        password: 'Please enter the correct password 6 or more',
        birth_date: 'select your birth date',
        gender: 'choose sex',
        officeState: 'office Clerk State',
        country: 'Please Select a Country',
        addr: 'enter your primary address',
        phone: 'Please input the telephone',
        email: 'Please enter your email address',
        lang: 'Please select a language, please choose a language',
        doc_type: 'Please select certificate type',
        doc_no: 'Please enter your id number correctly',
        doc_front_img: 'Please select upload images',
        doc_back_img: 'Please select upload images',
        local_ccy: 'Please select currency',
        bank_card_type: 'Please choose the type of bank card',
        bank_card_no: 'Please enter the bank card number',
        bank: 'Please select the bank',
        beneficiary_name: 'Please input beneficiary',
        branchName: 'Please input branch name',
        branchProvince: 'Please input branch Province',
        branchCity: 'Please input branch City',
        swift_code: 'Please enter the bank code',
        bank_addr: 'Please enter an account opening address',
        bank_card_img: 'Please select upload images',
        remark: 'Please input remarks',
        birth_date_Verify: 'Please fill in the blank when you are under 18 years of age'
      },
      send: "email",
      submit: "Submit",
      query: "query",
      changeBtn: 'Save Modify',
      flaseTip: 'Please input correctly',
      loginTip: 'The account or password is incorrect',
      fileUpload: 'Select upload file',
      repeatId: 'this account has been registered',
      TipPassWord: 'If you need to change it, please fill it out directly',
      copy: 'copy',
      logOut: {
        word: 'Do you want to logout?',
        yes: 'Sure',
        no: 'Cancel'
      },
      submitResult: {
        succeed: "save successfully",
        sendEmailSucceed: "sendEmailSucceed",
        sendEmailErr: "sendEmailErr",
        err: "Please fill in the information correctly"
      },
      backstageErr: {
        sales_id: "The user account already exists",
        sales_id_err: "The account already exists",
        acc_name: "The user account name already exists",
        last_code: "Parent account is entered incorrectly",
        codeVerify: 'The code already exists'
      }
    }
  }
};

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    addRoleDialog: {
      roleNameError: '字母，数字，下划线，减号(4-16位)',
      not_empty: '不能为空',
      role_exists: '该角色已经存在',
      select_one_option: '请至少选择一项'
    }
  },
  hk: {
    addRoleDialog: {
      roleNameError: '字母，數字，下劃線，減號(4-16位)',
      not_empty: '不能為空',
      role_exists: '該角色已經存在',
      select_one_option: '請至少選擇一項'
    }
  },
  en: {
    addRoleDialog: {
      roleNameError: 'Letters, numbers, underscores, minus signs (4-16 digits)',
      not_empty: 'Can not be empty',
      role_exists: 'The role already exists!',
      select_one_option: 'Please select at least one'
    }
  }
};

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    authOption: {
      emptyBtn: "清空",
      selectBtn: "全选",
      resetBtn: "重置",
      title: "添加角色",
      crumbs: {
        newaAccount: "权限管理",
        amend: "权限管理"
      },
      sales: {
        title: '权限管理'
      },
      changeBtn: '保存修改',
      logOut: {
        yes: '确定',
        no: '取消'
      },
      submitResult: {
        succeed: "保存成功",
        err: "请正确填写信息",
        role_error: "请确认此角色下面是否存在用户"
      }
    }
  },
  hk: {
    authOption: {
      emptyBtn: "清空",
      selectBtn: "全選",
      resetBtn: "重置",
      title: "添加角色",
      crumbs: {
        newaAccount: "權限管理",
        amend: "權限管理"
      },
      sales: {
        title: '權限管理'
      },
      changeBtn: '保存修改',
      logOut: {
        yes: '確定',
        no: '取消'
      },
      submitResult: {
        succeed: "保存成功",
        err: "請正確填寫信息",
        role_error: "請確認此角色下面是否存在用戶"
      }
    }
  },
  en: {
    authOption: {
      emptyBtn: "empty",
      selectBtn: "all select",
      resetBtn: "reset",
      title: "add role",
      crumbs: {
        newaAccount: "auth option",
        amend: "auth option"
      },
      sales: {
        title: 'auth option'
      },
      changeBtn: 'save modify',
      logOut: {
        yes: 'Sure',
        no: 'Cancel'
      },
      submitResult: {
        succeed: "save successfully",
        err: "Please fill in the information correctly",
        role_error: "Please confirm if there is a user under this role"
      }
    }
  }
};

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    seek: {
      dropdown: {
        funds: '出入金记录',
        acRecord: "代理佣金记录",
        wallet: "钱包",
        loginId: '登录账号',
        userName: '账户名称',
        IBcode: 'IB代码',
        phone: '电话',
        email: '电子邮箱',
        certificateId: '证件号码',
        superiorMT: '上级MT4账号',
        superiorMTIB: '上级IB代码'
      },
      err: {
        dateFormat: "YYYY-MM-DD",
        startDate: "请正确输入开始时间",
        endDate: "请正确输入结束时间"
      },
      show: '显示',
      password: '更改密码',
      indenta: '未平仓订单',
      indexb: '已平仓订单',
      submit: '提交',
      login: '登录',
      seek: '搜索',
      affirm: '确认'
    }
  },
  hk: {
    seek: {
      dropdown: {
        funds: '出入金記錄',
        acRecord: "代理佣金記錄",
        wallet: "錢包",
        loginId: '登錄帳號',
        userName: '帳戶名稱',
        IBcode: 'IB代碼',
        phone: '電話',
        email: '電子郵箱',
        certificateId: '證件號碼',
        superiorMT: '上級MT4帳號',
        superiorMTIB: '上級IB代碼'
      },
      err: {
        dateFormat: "YYYY-MM-DD",
        startDate: "請正確輸入開始時間",
        endDate: "請正確輸入結束時間"
      },
      show: '顯示',
      password: '更改密碼',
      indenta: '未平倉訂單',
      indexb: '已平倉訂單',
      submit: '提交',
      login: '登錄',
      seek: '搜索',
      affirm: '確認'
    }
  },
  en: {
    seek: {
      dropdown: {
        funds: 'Entry and exit record',
        acRecord: "Agent commission record",
        wallet: "wallet",
        loginId: 'loginId',
        userName: 'userName',
        IBcode: 'IBcode',
        phone: 'phone',
        email: 'email',
        certificateId: 'certificateId',
        superiorMT: 'superiorMT',
        superiorMTIB: 'superiorMTIB'
      },
      err: {
        dateFormat: "YYYY-MM-DD",
        startDate: "Please enter the start time correctly",
        endDate: "Please enter the start time correctly"
      },
      show: 'show',
      password: 'password',
      indenta: 'indenta',
      indexb: 'indexb',
      submit: 'submit',
      login: 'login',
      seek: 'search',
      affirm: 'affirm'
    }
  }
};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    clientParentInfo: {
      title: '客户上级信息',
      search: '搜索',
      download: '下载',
      downloadAll: '下载全部',
      mt4Number: 'MT4账号',
      downTips: '数据过多无法显示,将自动生成Excel!',
      errorTips: '查询出错',
      table: {
        cln_id: '帐号',
        acc_type: '类型',
        ib_type: 'IB类型',
        area_code: '大区',
        area_name: '大区名',
        manager: '经理',
        manager_name: '经理名',
        manager_email: '经理邮箱',
        sales: '员工',
        sales_name: '员工名',
        sales_email: '员工邮箱',
        create_date: '创建时间'
      },
      roomtable: {
        addtitle: '添加直播间信息',
        edittitle: '编辑直播间信息',
        roomName: '直播间名称',
        roomAccount: '直播间账号',
        addbtn: '添加',
        closebtn: '关闭',
        roomList: '直播间列表',
        operate: '操作',
        edit: '编辑',
        delete: '删除',
        save: '保存'
      },
      datePicker: {
        startTime: '开始日期',
        endTime: '结束日期',
        to: '至'
      }
    }
  },
  hk: {
    clientParentInfo: {
      title: '客戶上級信息',
      search: '搜索',
      download: '下载',
      downloadAll: '下载全部',
      mt4Number: 'MT4賬號',
      downTips: '数据过多无法显示,将自动生成Excel!',
      errorTips: '查询出错',
      table: {
        cln_id: '帐号',
        acc_type: '类型',
        ib_type: 'IB类型',
        area_code: '大区',
        area_name: '大区名',
        manager: '经理',
        manager_name: '经理名',
        manager_email: '经理邮箱',
        sales: '员工',
        sales_name: '员工名',
        sales_email: '员工邮箱',
        create_date: '创建时间'
      },
      roomtable: {
        addtitle: '添加直播間信息',
        edittitle: '編輯直播間信息',
        roomName: '直播間名稱',
        roomAccount: '直播間賬號',
        addbtn: '添加',
        closebtn: '關閉',
        roomList: '直播間列表',
        operate: '操作',
        edit: '編輯',
        delete: '刪除',
        save: '保存'
      },
      datePicker: {
        startTime: '开始日期',
        endTime: '结束日期',
        to: '至'
      }
    }
  },
  en: {
    clientParentInfo: {
      title: 'Client Parent Information',
      search: 'Search',
      download: 'Download',
      downloadAll: 'Download All',
      mt4Number: 'MT4 Account',
      downTips: 'Too much data, will auto download Excel!',
      errorTips: 'Search Error',
      table: {
        cln_id: 'Client ID',
        acc_type: 'Client Type',
        ib_type: 'IB Type',
        area_name: 'Area Name',
        area_code: 'Area Code',
        manager: 'Manager',
        manager_name: 'Manager Name',
        manager_email: 'Manager Email',
        sales: 'Sales',
        sales_name: 'Sales Name',
        sales_email: 'Sales Email',
        create_date: 'Create Date'
      },
      roomtable: {
        addtitle: 'Add live steam information',
        edittitle: 'Edit live steam information',
        roomName: 'Live steam name',
        roomAccount: 'Live steam account',
        addbtn: 'add',
        closebtn: 'close',
        roomList: 'Live steam list',
        operate: 'operate',
        edit: 'edit',
        delete: 'delete',
        save: 'save'
      },
      datePicker: {
        startTime: 'Start Time',
        endTime: 'End Time',
        to: 'To'
      }
    }
  }
};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    header: {
      hello: '你好',
      userName: '欢迎使用销售后台',
      language: '简体中文',
      adminSuperuser: {
        text: '管理超级用户',
        list: {
          logOut: '登出'
        }
      }
    }
  },
  hk: {
    header: {
      hello: '你好',
      userName: '歡迎使用銷售後臺',
      language: '繁體中文',
      adminSuperuser: {
        text: '管理超級用戶',
        list: {
          logOut: '登出'
        }
      }
    }
  },
  en: {
    header: {
      hello: 'Hello',
      userName: 'Welcome to SPBO',
      language: 'English',
      adminSuperuser: {
        text: 'adminSuperuser',
        list: {
          logOut: 'logOut'
        }
      }
    }
  }
};

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__(20);

var _vue2 = _interopRequireDefault(_vue);

var _vueMultilanguage = __webpack_require__(549);

var _vueMultilanguage2 = _interopRequireDefault(_vueMultilanguage);

var _header = __webpack_require__(578);

var _header2 = _interopRequireDefault(_header);

var _login = __webpack_require__(580);

var _login2 = _interopRequireDefault(_login);

var _accountDatum = __webpack_require__(573);

var _accountDatum2 = _interopRequireDefault(_accountDatum);

var _userDatum = __webpack_require__(589);

var _userDatum2 = _interopRequireDefault(_userDatum);

var _authOption = __webpack_require__(575);

var _authOption2 = _interopRequireDefault(_authOption);

var _addRoleDialog = __webpack_require__(574);

var _addRoleDialog2 = _interopRequireDefault(_addRoleDialog);

var _btn = __webpack_require__(576);

var _btn2 = _interopRequireDefault(_btn);

var _select = __webpack_require__(582);

var _select2 = _interopRequireDefault(_select);

var _sidebarList = __webpack_require__(583);

var _sidebarList2 = _interopRequireDefault(_sidebarList);

var _table = __webpack_require__(584);

var _table2 = _interopRequireDefault(_table);

var _tableModelAccountList = __webpack_require__(585);

var _tableModelAccountList2 = _interopRequireDefault(_tableModelAccountList);

var _tableModelUserList = __webpack_require__(588);

var _tableModelUserList2 = _interopRequireDefault(_tableModelUserList);

var _tableModelAuthList = __webpack_require__(586);

var _tableModelAuthList2 = _interopRequireDefault(_tableModelAuthList);

var _tableModelChangeParentSales = __webpack_require__(587);

var _tableModelChangeParentSales2 = _interopRequireDefault(_tableModelChangeParentSales);

var _relation = __webpack_require__(581);

var _relation2 = _interopRequireDefault(_relation);

var _clientParentInfo = __webpack_require__(577);

var _clientParentInfo2 = _interopRequireDefault(_clientParentInfo);

var _salesCommission = __webpack_require__(561);

var _salesCommission2 = _interopRequireDefault(_salesCommission);

var _ibCommission = __webpack_require__(554);

var _ibCommission2 = _interopRequireDefault(_ibCommission);

var _alertIgnore = __webpack_require__(550);

var _alertIgnore2 = _interopRequireDefault(_alertIgnore);

var _monthlyIBResult = __webpack_require__(556);

var _monthlyIBResult2 = _interopRequireDefault(_monthlyIBResult);

var _cpaIBResult = __webpack_require__(553);

var _cpaIBResult2 = _interopRequireDefault(_cpaIBResult);

var _auditTrailReport = __webpack_require__(552);

var _auditTrailReport2 = _interopRequireDefault(_auditTrailReport);

var _salesMonthlyResult = __webpack_require__(562);

var _salesMonthlyResult2 = _interopRequireDefault(_salesMonthlyResult);

var _realTimeReport = __webpack_require__(557);

var _realTimeReport2 = _interopRequireDefault(_realTimeReport);

var _spreadCommissionMappingReport = __webpack_require__(558);

var _spreadCommissionMappingReport2 = _interopRequireDefault(_spreadCommissionMappingReport);

var _allCommissionReport = __webpack_require__(551);

var _allCommissionReport2 = _interopRequireDefault(_allCommissionReport);

var _commissionTable = __webpack_require__(564);

var _commissionTable2 = _interopRequireDefault(_commissionTable);

var _commissionSeek = __webpack_require__(563);

var _commissionSeek2 = _interopRequireDefault(_commissionSeek);

var _ibCommissionRuleSetting = __webpack_require__(555);

var _ibCommissionRuleSetting2 = _interopRequireDefault(_ibCommissionRuleSetting);

var _ruleItem = __webpack_require__(560);

var _ruleItem2 = _interopRequireDefault(_ruleItem);

var _mtclient = __webpack_require__(559);

var _mtclient2 = _interopRequireDefault(_mtclient);

var _profitShareView = __webpack_require__(571);

var _profitShareView2 = _interopRequireDefault(_profitShareView);

var _accountSetting = __webpack_require__(569);

var _accountSetting2 = _interopRequireDefault(_accountSetting);

var _profitShareReport = __webpack_require__(570);

var _profitShareReport2 = _interopRequireDefault(_profitShareReport);

var _versionReport = __webpack_require__(572);

var _versionReport2 = _interopRequireDefault(_versionReport);

var _commissionView = __webpack_require__(565);

var _commissionView2 = _interopRequireDefault(_commissionView);

var _ibPrimary = __webpack_require__(566);

var _ibPrimary2 = _interopRequireDefault(_ibPrimary);

var _salePrimary = __webpack_require__(568);

var _salePrimary2 = _interopRequireDefault(_salePrimary);

var _publicLan = __webpack_require__(567);

var _publicLan2 = _interopRequireDefault(_publicLan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 翻译 佣金设定
var LanguageArr = [_header2.default, _login2.default, _accountDatum2.default, _userDatum2.default, _btn2.default, _select2.default, _sidebarList2.default, _table2.default, _tableModelAccountList2.default, _relation2.default, _salesCommission2.default, _ibCommission2.default, _monthlyIBResult2.default, _auditTrailReport2.default, _cpaIBResult2.default, _salesMonthlyResult2.default, _realTimeReport2.default, _commissionView2.default, _ibPrimary2.default, _salePrimary2.default, _publicLan2.default, _authOption2.default, _addRoleDialog2.default, _spreadCommissionMappingReport2.default, _allCommissionReport2.default, _commissionTable2.default, _commissionSeek2.default, _ibCommissionRuleSetting2.default, _ruleItem2.default, _mtclient2.default, _tableModelUserList2.default, _tableModelAuthList2.default, _tableModelChangeParentSales2.default, _profitShareView2.default, _accountSetting2.default, _profitShareReport2.default, _versionReport2.default, _clientParentInfo2.default, _alertIgnore2.default];
var LanguageData = {
    cn: {},
    hk: {},
    en: {}

    // var LanguageData = (LanguageArr => LanguageKeys => LanguageKeys.map( (item,index) => ({[index]: LanguageArr[index]}) ) )(LanguageArr)
    // console.log(LanguageData(LanguageKeys))

};var LanguageKeys = (0, _keys2.default)(LanguageData);

LanguageArr.forEach(function (item, index) {
    // 重新合并对象
    LanguageKeys.forEach(function (lan) {
        var key = [(0, _keys2.default)(LanguageArr[index][lan])[0]];
        LanguageData[lan][key] = LanguageArr[index][lan][key];
    });
});

// 检测翻译
var allKey = {};
var detection = function detection(obj, LanguageKey) {
    var keys = (0, _keys2.default)(obj);
    keys.forEach(function (item) {
        if (Object.prototype.toString.call(obj[item]) == "[object Object]") {
            detection(obj[item], LanguageKey);
        }
        allKey[LanguageKey]++;
    });
};
LanguageKeys.forEach(function (item) {
    allKey[item] = 0;
    detection(LanguageData[item], item);
});
console.log(allKey);
// 检测翻译

_vue2.default.use(_vueMultilanguage2.default, LanguageData);

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    login: {
      memberCenter: '销售后台',
      idTxt: '登录账号',
      loginTxt: '账户名称',
      passwordTxt: '交易密码',
      verification: "请输入验证码",
      btn: "登 录",
      language: '请选择语言:',
      hint: "提示",
      tips: {
        loginNoTxt: '请输入登录账号',
        loginNoSure: "账号只能由数字组成",
        passwordNoTxt: "请输入交易密码",
        passwordNoSure: "密码只能由字母或数字组成",
        verifyCodeNoTxt: "请输入验证码",
        verifyCodeNoSure: "验证码错误",
        loginErr: "账号或密码错误"
      },
      select_language: '语言:',
      forgotPassword: '忘记密码?'
    }
  },
  hk: {
    login: {
      memberCenter: '銷售後臺',
      idTxt: '登入帳號',
      loginTxt: '帳戶名稱',
      passwordTxt: '交易密碼',
      verification: "請輸入驗證碼",
      btn: "登 錄",
      language: '請選擇語言:',
      hint: "提示",
      tips: {
        loginNoTxt: '請輸入登錄帳號',
        loginNoSure: "帳號只能由數位組成",
        passwordNoTxt: "請輸入交易密碼",
        passwordNoSure: "密碼只能由字母或數位組成",
        verifyCodeNoTxt: "請輸入驗證碼",
        verifyCodeNoSure: "驗證碼錯誤",
        loginErr: "帳號或密碼錯誤"
      },
      select_language: '語言:',
      forgotPassword: '忘記密碼?'
    }
  },
  en: {
    login: {
      memberCenter: 'Sales Portal Backoffice',
      idTxt: 'login account',
      loginTxt: 'account name',
      passwordTxt: 'passwordTxt',
      verification: "verification",
      btn: "login",
      language: 'language:',
      hint: "hint",
      tips: {
        loginNoTxt: 'Please enter your logon account number',
        loginNoSure: "Accounts can only be made up of numbers",
        passwordNoTxt: "Please enter the transaction password",
        passwordNoSure: "Passwords can only be made up of letters or numbers",
        verifyCodeNoTxt: "Please enter a verification code",
        verifyCodeNoSure: "Verify code error",
        loginErr: "An account or password error"
      },
      select_language: 'Language:',
      forgotPassword: 'Forgot Password?'
    }
  }
};

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    relation: {
      title: '关系图',
      list: {
        node_id: '账号',
        node_code: '代码',
        acc_type: '类型',
        acc_name: '姓名',
        enable: '状态'
      },
      type: {
        TD: '交易帐号',
        IB: '代理',
        SL: '职员',
        CL: '客户',
        M: '经理',
        O: '办事处',
        UN: '系统',
        C: '公司',
        N: '国家',
        R: '地区',
        one: '启用',
        two: '停用',
        F: '全职',
        P: '兼职',
        D: '离职'
      },
      seek: '搜索',
      nodata: "没有查询到数据"
    }
  },
  hk: {
    relation: {
      title: '關系圖',
      list: {
        node_id: '帳號',
        node_code: '代碼',
        acc_type: '類型',
        acc_name: '姓名',
        enable: '狀態'
      },
      type: {
        TD: '交易帳號',
        IB: '代理',
        SL: '職員',
        CL: '客戶',
        M: '經理',
        O: '辦事處',
        UN: '系統',
        C: '公司',
        N: '國家',
        R: '地區',
        one: '启用',
        two: '停用',
        F: '全職',
        P: '兼職',
        D: '離職'
      },
      seek: '搜索',
      nodata: "沒有查詢到數據"
    }
  },
  en: {
    relation: {
      title: 'Hierarchy',
      list: {
        node_id: 'Account ID',
        node_code: 'Code',
        acc_type: 'Account Type',
        acc_name: 'name',
        enable: 'enable'
      },
      type: {
        TD: 'TD',
        IB: 'IB',
        SL: 'Sales',
        CL: 'Client',
        M: 'manager',
        O: 'Office',
        UN: 'system',
        C: 'company',
        N: 'Country',
        R: 'region',
        one: 'enable',
        two: 'disable',
        F: 'full-time',
        P: 'part-time',
        D: 'dimission'
      },
      seek: 'search',
      nodata: "No data was found"
    }
  }
};

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    select: {
      uncoveredPosition: '未平仓交易',
      all: '所有',
      today: '今天',
      triduum: '最近三天',
      hebdomad: '最近一周',
      oneMonth: '最近一个月',
      transactionType: '交易类型',
      tiemText: '时间周期',
      tiema: '时间周期',
      tiemb: '时间周期'
    }
  },
  hk: {
    select: {
      uncoveredPosition: '未平倉交易',
      all: '所有',
      today: '今天',
      triduum: '最近三天',
      hebdomad: '最近一周',
      oneMonth: '最近一個月',
      transactionType: '交易類型',
      tiemText: '時間週期',
      tiema: '時間週期',
      tiemb: '時間週期'
    }
  },
  en: {
    select: {
      uncoveredPosition: 'uncoveredPosition',
      all: 'all',
      today: 'today',
      triduum: 'triduum',
      hebdomad: 'hebdomad',
      oneMonth: 'oneMonth',
      transactionType: 'transactionType',
      tiemText: 'tiemText',
      tiema: 'tiema',
      tiemb: 'tiemb'
    }
  }
};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        sidebarList: {
            profitShareView: {
                text: '利润分成设定',
                content: {}
            },
            commissionView: {
                text: '佣金设定',
                content: {}
            },
            commissionView_v2: {
                text: '佣金设定2.0',
                content: {}
            },
            dailyReport: {
                text: '每日总结'
            },
            userList: {
                text: '用户列表',
                content: {}
            },
            accountList: {
                text: '账户列表',
                content: {}
            },
            authList: {
                text: '权限管理',
                content: {}
            },
            indenta: {
                text: '未平仓订单',
                content: {}
            },
            password: {
                text: '修改密码',
                content: {}
            },
            indexb: {
                text: '已平仓订单',
                content: {}
            },
            wasteBook: {
                text: '出入金记录',
                content: {}
            },
            warehouse: {
                text: '仓库总结',
                content: {}
            },
            withdrawal: {
                text: '取款',
                content: {
                    serialNumber: '编号',
                    name: '姓名',
                    email: '电子邮箱',
                    phone: '电话',
                    bank: '银行名称',
                    bankSite: '银行地址',
                    branch: '分行名称',
                    branchProvince: '分行省份',
                    swift: 'SWIFT编码',
                    card: '银行卡号',
                    payee: '收款人',
                    fetch: '可取资金',
                    money: '取款金额',
                    code: '验证码'
                }
            },
            link: {
                text: '专属链接',
                content: {}
            },
            signals: {
                text: '交易信号',
                content: {}
            },
            // 关系图 
            relation: {
                text: '关系图',
                content: {}
            },
            loginSalePlatform: {
                text: '登录销售平台',
                content: {
                    salesId: '销售账号',
                    confirmLogin: '确认登录',
                    succeed: "正在跳转到销售平台，请稍等",
                    err: "输入有误"
                }
            },
            changeParentSales: {
                text: '指派上级',
                content: {
                    account: '登录账号',
                    parentId: '上级账号',
                    agentAccount: '代理账号',
                    comment: '注释',
                    searchAccount: '搜索',
                    assignSales: '指派',
                    succeed: "已成功指派",
                    err: "输入有误",
                    childrenLengthErr: "子下级超过限制，请分批指派"
                }
            },
            clientParentInfo: {
                text: '客户上级信息',
                content: {
                    account: '登录账号',
                    parentId: '上级账号',
                    agentAccount: '代理账号',
                    comment: '注释',
                    searchAccount: '搜索',
                    assignSales: '指派',
                    succeed: "已成功指派",
                    err: "输入有误",
                    childrenLengthErr: "子下级超过限制，请分批指派"
                }
            },
            changepswd: {
                text: '更改密码',
                content: {
                    account: '登录账号',
                    accountName: '账户名称',
                    passworda: '旧密码',
                    passwordb: '新密码',
                    passwordc: '确认密码',
                    okChange: '确认修改',
                    errora: '密码有误',
                    errorb: '新密码和确认密码不一致',
                    errorc: '请输入六位以上的密码',
                    PasswordChangesSucceeded: '密码修改成功',
                    hint: "提示",
                    succeed: "修改成功",
                    err: "输入有误"
                }
            },
            logOut: {
                text: '登出',
                content: {}
            }
        }
    },
    hk: {
        sidebarList: {
            profitShareView: {
                text: '利潤分成設定',
                content: {}
            },
            commissionView: {
                text: '佣金設定',
                content: {}
            },
            commissionView_v2: {
                text: '佣金設定2.0',
                content: {}
            },
            dailyReport: {
                text: '每日總結'
            },
            userList: {
                text: '用戶列表',
                content: {}
            },
            accountList: {
                text: '帳戶列表',
                content: {}
            },
            authList: {
                text: '權限管理',
                content: {}
            },
            indenta: {
                text: '未平倉訂單',
                content: {}
            },
            indexb: {
                text: '已平倉訂單',
                content: {}
            },
            wasteBook: {
                text: '出入金記錄',
                content: {}
            },
            warehouse: {
                text: '倉庫總結',
                content: {}
            },
            withdrawal: {
                text: '取款',
                content: {
                    serialNumber: '編號',
                    name: '姓名',
                    email: '電子郵箱',
                    phone: '電話',
                    bank: '銀行名稱',
                    bankSite: '銀行地址',
                    branch: '分行名稱',
                    branchProvince: '分行省份',
                    swift: 'SWIFT編碼',
                    card: '銀行卡號',
                    payee: '收款人',
                    fetch: '可取資金',
                    money: '取款金額',
                    code: '驗證碼'
                }
            },
            link: {
                text: '專屬連結',
                content: {}
            },
            signals: {
                text: '交易信號',
                content: {}
            },
            // 关系图 
            relation: {
                text: '關系圖',
                content: {}
            },
            loginSalePlatform: {
                text: '登錄銷售平台',
                content: {
                    salesId: '銷售賬號',
                    confirmLogin: '確認登錄',
                    succeed: "正在跳转到销售平台，请稍等",
                    err: "输入有误"
                }
            },
            changeParentSales: {
                text: '指派上級',
                content: {
                    account: '登錄賬號',
                    parentId: '上級賬號',
                    agentAccount: '代理賬號',
                    comment: '註釋',
                    searchAccount: '搜索',
                    assignSales: '指派',
                    succeed: "已成功指派",
                    err: "輸入有誤",
                    childrenLengthErr: "子下級超過限制, 請分批指派"
                }
            },
            clientParentInfo: {
                text: '客戶上級信息',
                content: {
                    account: '登錄賬號',
                    parentId: '上級賬號',
                    agentAccount: '代理賬號',
                    comment: '註釋',
                    searchAccount: '搜索',
                    assignSales: '指派',
                    succeed: "已成功指派",
                    err: "輸入有誤",
                    childrenLengthErr: "子下級超過限制, 請分批指派"
                }
            },
            changepswd: {
                text: '更改密碼',
                content: {
                    account: '帳號',
                    accountName: '帳戶名稱',
                    passworda: '舊密碼',
                    passwordb: '新密碼',
                    passwordc: '確認密碼',
                    okChange: '確認修改',
                    errora: '密碼有誤',
                    errorb: '新密碼和確認密碼不一致',
                    errorc: '請輸入六位以上的密碼',
                    PasswordChangesSucceeded: '密碼修改成功',
                    hint: "提示",
                    succeed: "修改成功",
                    err: "輸入有誤"
                }
            },
            logOut: {
                text: '登出',
                content: {}
            }
        }
    },
    en: {
        sidebarList: {
            profitShareView: {
                text: 'Profit Share Setting',
                content: {}
            },
            commissionView: {
                text: 'Commission Profile Setting',
                content: {}
            },
            commissionView_v2: {
                text: 'Commission Profile Setting 2.0',
                content: {}
            },
            dailyReport: {
                text: 'Daily summary'
            },
            userList: {
                text: 'User List',
                content: {}
            },
            accountList: {
                text: 'Account List',
                content: {}
            },
            authList: {
                text: 'Auth List',
                content: {}
            },
            indenta: {
                text: 'indenta',
                content: {}
            },
            indexb: {
                text: 'indexb',
                content: {}
            },
            wasteBook: {
                text: 'wasteBook',
                content: {}
            },
            warehouse: {
                text: 'warehouse',
                content: {}
            },
            withdrawal: {
                text: 'withdrawal',
                content: {
                    serialNumber: 'serialNumber',
                    name: 'name',
                    email: 'email',
                    phone: 'phone',
                    bank: 'bank',
                    bankSite: 'bankSite',
                    branch: 'branch',
                    branchProvince: 'branchProvince',
                    swift: 'swift',
                    card: 'card',
                    payee: 'payee',
                    fetch: 'fetch',
                    money: 'money',
                    code: 'code'
                }
            },
            link: {
                text: 'link',
                content: {}
            },
            signals: {
                text: 'signals',
                content: {}
            },
            // 关系图 
            relation: {
                text: 'Hierarchy',
                content: {}
            },
            loginSalePlatform: {
                text: 'Login to Sales Portal',
                content: {
                    salesId: 'Sales ID',
                    confirmLogin: 'Login Now',
                    succeed: "is skipping,please,waiting...",
                    err: "input error"
                }
            },
            changeParentSales: {
                text: 'Hierarchy Assignment',
                content: {
                    account: 'Account Number',
                    parentId: 'Parent Account Number',
                    agentAccount: 'Parent Node Code',
                    comment: 'MT4 Comment',
                    searchAccount: 'Search',
                    assignSales: 'Assign',
                    succeed: "assign succeed",
                    err: "input error",
                    childrenLengthErr: "Sub-subordinate exceeds limit, please assign in batches"
                }
            },
            clientParentInfo: {
                text: 'Client Parent Infomation',
                content: {
                    account: 'Account Number',
                    parentId: 'Parent Account Number',
                    agentAccount: 'Parent Node Code',
                    comment: 'MT4 Comment',
                    searchAccount: 'Search',
                    assignSales: 'Assign',
                    succeed: "assign succeed",
                    err: "input error",
                    childrenLengthErr: "Sub-subordinate exceeds limit, please assign in batches"
                }
            },
            changepswd: {
                text: 'Change Password',
                content: {
                    account: 'User ID',
                    accountName: 'Username',
                    passworda: 'Current Password',
                    passwordb: 'New Password',
                    passwordc: 'Re-enter New Password',
                    okChange: 'Change Password',
                    errora: 'wrong password',
                    errorb: 'The new password is different from the confirmation password',
                    errorc: 'Please enter your more then six password over ',
                    PasswordChangesSucceeded: 'Password changes succeeded',
                    hint: "hint",
                    succeed: "succeed",
                    err: "err"
                }
            },
            logOut: {
                text: 'Log out',
                content: {}
            }
        }
    }
};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cn: {
        table: {
            hr: {
                indent: '订单',
                user: '登录账号',
                account: '账号',
                warehouseTime: '开仓时间',
                type: '类型',
                number: '手数',
                variety: '交易品种',
                warehousePrice: '开仓价格',
                stopLoss: '止损',
                stopProfit: '止盈',
                price: '价格',
                serviceCharge: '手续费',
                storageFee: '库存费',
                profit: '获利',
                summarize: '总结',
                applySerialNumber: '申请编号',
                orderNumber: '订单编号',
                withdrawal: '取款金额',
                submitTime: '提交时间',
                state: '状态',
                message: '信息',
                userName: '姓名',
                income: '收入',
                disburse: '支出',
                MoneyInto: '资金转入',
                volumeBusiness: '交易量',
                brokerage: '佣金',
                accrual: '利息',
                profitAndLoss: '盈亏',
                balance: '余额',
                userLiseBrokerage: '代理佣金',
                dealTime: '交易时间',
                annotation: '注释',
                closeOutTime: '平仓时间',
                closeOutPrice: '平仓价格',
                SuperioruserLiseAccount: '上级代理账号',
                netValue: '净值',
                UsedPrepayment: '已用预支付',
                usablePrepayment: '可用预支付',
                prepaymentRatio: '预支付比例',
                subordinateuserLiseNumber: '下级代理总数',
                domesticConsumerNumber: '普通客户总数',
                prepaid: '已用预付款',
                AvailableAdvance: '可用预付款',
                AdvancePaymentRatio: '预付款比例',
                phone: '电话',
                email: '电子邮箱',
                certificate: '证件号码',
                userType: '客户类型',
                swift: 'SWIFT编码',
                bankAccout: '银行账户',
                bankName: '银行名称',
                bankSite: '开户银行地址',
                openOrder: '未平仓订单',
                openOrderlots: '未平仓订单手数',
                openOrderProfitAndLoss: '未平仓订单盈亏',
                usableFund: '可用资金',
                cashDepositProportion: '保证金比例',
                deadline: '以上数据截止'
            }
        }
    },
    hk: {
        table: {
            hr: {
                indent: '訂單',
                user: '登錄帳號',
                account: '帳號',
                warehouseTime: '開倉時間',
                type: '類型',
                number: '手數',
                variety: '交易品種',
                warehousePrice: '開倉價格',
                stopLoss: '止損',
                stopProfit: '止盈',
                price: '價格',
                serviceCharge: '手續費',
                storageFee: '庫存費',
                profit: '獲利',
                summarize: '總結',
                applySerialNumber: '申請編號',
                orderNumber: '訂單編號',
                withdrawal: '取款金額',
                submitTime: '提交時間',
                state: '狀態',
                message: '信息',
                userName: '姓名',
                income: '收入',
                disburse: '支出',
                MoneyInto: '資金轉入',
                volumeBusiness: '交易量',
                brokerage: '佣金',
                accrual: '利息',
                profitAndLoss: '盈虧',
                balance: '餘額',
                userLiseBrokerage: '代理佣金',
                dealTime: '交易時間',
                annotation: '注釋',
                closeOutTime: '平倉時間',
                closeOutPrice: '平倉價格',
                SuperioruserLiseAccount: '上級代理帳號',
                netValue: '淨值',
                UsedPrepayment: '已用預支付',
                usablePrepayment: '可用預支付',
                prepaymentRatio: '預支付比例',
                subordinateuserLiseNumber: '下級代理總數',
                domesticConsumerNumber: '普通客戶總數',
                prepaid: '已用預付款',
                AvailableAdvance: '可用預付款',
                AdvancePaymentRatio: '預付款比例',
                phone: '電話',
                email: '電子郵箱',
                certificate: '證件號碼',
                userType: '客戶類型',
                swift: 'SWIFT編碼',
                bankAccout: '銀行帳戶',
                bankName: '銀行名稱',
                bankSite: '開戶銀行地址',
                openOrder: '未平倉訂單',
                openOrderlots: '未平倉訂單手數',
                openOrderProfitAndLoss: '未平倉訂單盈虧',
                usableFund: '可用資金',
                cashDepositProportion: '保證金比例',
                deadline: '以上資料截止'
            }
        }
    },
    en: {
        table: {
            hr: {
                indent: 'indent',
                user: 'user',
                account: 'account',
                warehouseTime: 'warehouseTime',
                type: 'type',
                number: 'number',
                variety: 'variety',
                warehousePrice: 'warehousePrice',
                stopLoss: 'stopLoss',
                stopProfit: 'stopProfit',
                price: 'price',
                serviceCharge: 'serviceCharge',
                storageFee: 'storageFee',
                profit: 'profit',
                summarize: 'summarize',
                applySerialNumber: 'applySerialNumber',
                orderNumber: 'orderNumber',
                withdrawal: 'withdrawal',
                submitTime: 'submitTime',
                state: 'state',
                message: 'message',
                userName: 'userName',
                income: 'income',
                disburse: 'disburse',
                MoneyInto: 'MoneyInto',
                volumeBusiness: 'volumeBusiness',
                brokerage: 'brokerage',
                accrual: 'accrual',
                profitAndLoss: 'profitAndLoss',
                balance: 'balance',
                userLiseBrokerage: 'userLiseBrokerage',
                dealTime: 'dealTime',
                annotation: 'annotation',
                closeOutTime: 'closeOutTime',
                closeOutPrice: 'closeOutPrice',
                SuperioruserLiseAccount: 'SuperioruserLiseAccount',
                netValue: 'netValue',
                UsedPrepayment: 'UsedPrepayment',
                usablePrepayment: 'usablePrepayment',
                prepaymentRatio: 'prepaymentRatio',
                subordinateuserLiseNumber: 'subordinateuserLiseNumber',
                domesticConsumerNumber: 'domesticConsumerNumber',
                prepaid: 'prepaid',
                AvailableAdvance: 'AvailableAdvance',
                AdvancePaymentRatio: 'AdvancePaymentRatio',
                phone: 'phone',
                email: 'email',
                certificate: 'certificate',
                userType: 'userType',
                swift: 'swift',
                bankAccout: 'bankAccout',
                bankName: 'bankName',
                bankSite: 'bankSite',
                openOrder: 'openOrder',
                openOrderlots: 'openOrderlots',
                openOrderProfitAndLoss: 'openOrderProfitAndLoss',
                usableFund: 'usableFund',
                cashDepositProportion: 'cashDepositProportion',
                deadline: 'deadline'
            }
        }
    }
};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    tableModelAccountList: {
      th: {
        WalletBalance: "钱包余额",
        funds: '出入金记录',
        loginId: "登录账号",
        IBCode: "IB代码",
        order: "订单",
        dealTime: '交易时间',
        annotation: '注释',
        nodeCode: '代理代码',
        money: "金额",
        ReportType: "报表类型",
        accountName: "账户名称",
        group: "团队",
        superiorAccount: "上级MT4账号",
        superiorCode: "上级IB代码",
        phone: "电话",
        email: "电子邮箱",
        remark: "备注",
        last_update: "最后修改时间",
        comment: "上级代码",
        superAgentNum: "上级代理账号",
        superAgentCode: "上级代理代码",
        lowerAgentTotal: "下级代理总数",
        generalClientTotal: "普通客户总数",
        margin: "已用预支付",
        marginfree: "可用预付款",
        marginlevel: "预付款比例",
        status: "状态",
        equity: "净值",
        balance: "余额",
        accType: "类型",
        mt4_sync_deposits_sum: "入金",
        mt4_sync_withdrawal_sum: "出金",
        commission_sum: "佣金",
        commission_sum2: "代理佣金",
        profit_sum: "盈亏",
        swaps_sum: "利息",
        volume_sum: "交易量",
        balance2: "净入金",
        balance3: "余额",
        newAgentCount: "新代理",
        newClientCount: "新客户",
        mt4_sync_transfer_ins_sum: "资金转入",
        summary: "总结",
        officeState: {
          name: "职员状态",
          countryArr: [{ text: "全职", value: "F" }, { text: "兼职", value: "P" }, { text: "离职", value: "D" }]
        },
        loginType: {
          name: "类型",
          typeArr: [{ text: '系统', value: "UN" }, { text: '公司', value: "C" }, { text: '国家', value: "N" }, { text: '地区', value: "R" }, { text: '办事处', value: "O" }, { text: '经理', value: "M" }, { text: '销售', value: "SL" }, { text: '代理', value: "IB" }, { text: '客户', value: "CL" }]
        },
        Role_ID: "角色ID",
        Desc: "描述",
        operation: "操作"
      },
      crumbs: {
        userList: '用户列表',
        authList: '权限管理',
        accountList: '账户列表',
        ibList: "代理名单",
        dailyReport: "每日总结",
        clientList: "客户名单",
        warehouse: "仓库总结"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "登录账号",
          userName: "账户名称",
          IBcode: "IB代码",
          phone: "电话",
          email: "电子邮箱",
          certificateId: "证件号码",
          superiorMT: "上级MT4账号",
          superiorMTIB: "上级IB代码"
        }
      },
      show: "显示",
      num: "数",
      clauses: "条目",
      clauses_text: "显示条目数",
      all: "全部",
      amount: "总数",
      present: "当前",
      refreshData: "全部数据",
      downloadExcelForms: "下载Excel",
      addAccount: "添加账户",
      deletedData: "删除数据",
      addRole: "添加角色",
      deleteRole: "删除角色",
      roleName: "角色名称",
      roleDesc: "角色描述",
      confirmDelete: "确认删除",
      search: "搜索",
      nodata: "没有查询到数据",
      getBack: "返回上一级",
      tier: "代理层级",
      total: "合计"
    }
  },
  hk: {
    tableModelAccountList: {
      th: {
        WalletBalance: "錢包餘額",
        funds: '出入金記錄',
        loginId: "登錄賬號",
        IBCode: "IB代碼",
        order: "訂單",
        dealTime: '交易時間',
        annotation: '注釋',
        nodeCode: '代理代碼',
        money: "金額",
        ReportType: "報表類型",
        accountName: "帳戶名稱",
        group: "團隊",
        superiorAccount: "上級MT4帳號",
        superiorCode: "上級IB代碼",
        phone: "電話",
        email: "電子郵箱",
        remark: "備註",
        last_update: "最後修改時間",

        comment: "上級代碼",
        superAgentNum: "上級代理賬號",
        superAgentCode: "上級代理代碼",
        lowerAgentTotal: "下級代理总数",
        generalClientTotal: "普通客戶總數",
        margin: "已用預付款",
        marginfree: "可用預付款",
        marginlevel: "預付款比例",
        status: "狀態",

        equity: "淨值",
        balance: "餘額",

        accType: "類型",
        mt4_sync_deposits_sum: "入金",
        mt4_sync_withdrawal_sum: "出金",
        commission_sum: "傭金",
        commission_sum2: "代理傭金",
        profit_sum: "盈虧",
        swaps_sum: "利息",
        volume_sum: "交易量",
        balance2: "淨入金",
        balance3: "餘額",
        newAgentCount: "新代理",
        newClientCount: "新客戶",
        mt4_sync_transfer_ins_sum: "資金轉入",
        summary: "總結",
        officeState: {
          name: "職員狀態",
          countryArr: [{ text: "全職", value: "F" }, { text: "兼職", value: "P" }, { text: "離職", value: "D" }]
        },
        loginType: {
          name: "類型",
          typeArr: [{ text: '系統', value: "UN" }, { text: '公司', value: "C" }, { text: '國家', value: "N" }, { text: '地區', value: "R" }, { text: '辦事處', value: "O" }, { text: '經理', value: "M" }, { text: '銷售', value: "SL" }, { text: '代理', value: "IB" }, { text: '客戶', value: "CL" }]
        },
        Role_ID: "角色ID",
        Desc: "描述",
        operation: "操作"
      },
      crumbs: {
        userList: '用戶列表',
        authList: '權限管理',
        accountList: '帳戶列表',
        ibList: "代理名單",
        dailyReport: "每日总结",
        clientList: "客戶名單",
        warehouse: "倉庫總結"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "登錄帳號",
          userName: "帳戶名稱",
          IBcode: "IB代碼",
          phone: "電話",
          email: "電子郵箱",
          certificateId: "證件號碼",
          superiorMT: "上級MT4帳號",
          superiorMTIB: "上級IB代碼"
        }
      },
      show: "顯示",
      num: "數",
      clauses: "條目",
      clauses_text: "顯示條目數",
      all: "全部",
      amount: "總數",
      present: "當前",
      refreshData: "全部數據",
      downloadExcelForms: "下載Excel",
      addAccount: "添加帳戶",
      deletedData: "刪除數據",
      addRole: "添加角色",
      deleteRole: "删除角色",
      confirmDelete: "確認刪除",
      roleName: "角色名称",
      roleDesc: "角色描述",
      search: "搜索",
      nodata: "没有查询到数据",
      getBack: "返回上一級",
      tier: "代理層級",
      total: "合計"
    }
  },
  en: {
    tableModelAccountList: {
      th: {
        WalletBalance: "Wallet Balance",
        funds: 'Entry and exit record',
        loginId: "Login Account",
        IBCode: "IB Code",
        order: "Order",
        dealTime: 'Deal time',
        annotation: 'Annotation',
        nodeCode: 'nodeCode',
        money: "Amount of money",
        ReportType: "Report type",
        accountName: "Account Name",
        group: "group",
        superiorAccount: "Superior MT4 Account",
        superiorCode: "Superior IB Code",
        phone: "Phone",
        email: "Email",
        remark: "Remark",
        last_update: "Last modification ",
        comment: "comment",
        superAgentNum: "superAgentNum",
        superAgentCode: "superAgentCode",
        lowerAgentTotal: "lowerAgentTotal",
        generalClientTotal: "generalClientTotal",
        margin: "margin",
        marginfree: "marginfree",
        marginlevel: "marginlevel",
        status: "status",
        equity: "equity",
        balance: "balance",
        accType: "Types of",
        mt4_sync_deposits_sum: "Into the gold",
        mt4_sync_withdrawal_sum: "Out of gold",
        commission_sum: "commission",
        commission_sum2: "Agency commission",
        profit_sum: "Profit and loss",
        swaps_sum: "interest",
        volume_sum: "Trading volume",
        balance2: "Net deposit",
        balance3: "Balance",
        newAgentCount: "newAgentCount",
        newClientCount: "newClientCount",
        mt4_sync_transfer_ins_sum: "Capital transfer",
        summary: "summary",
        officeState: {
          name: "Employee status",
          countryArr: [{ text: "full time", value: "F" }, { text: "part time", value: "P" }, { text: "Leave", value: "D" }]
        },
        loginType: {
          name: "Types of",
          typeArr: [{ text: 'system', value: "UN" }, { text: 'the company', value: "C" }, { text: 'country', value: "N" }, { text: 'area', value: "R" }, { text: 'office', value: "O" }, { text: 'manager', value: "M" }, { text: 'Sales', value: "SL" }, { text: 'IB', value: "IB" }, { text: 'client', value: "CL" }]
        },
        Role_ID: "Role_ID",
        Desc: "Desc",
        operation: "Operation"
      },
      crumbs: {
        userList: 'user list',
        accountList: 'Account List',
        authList: 'auth list',
        ibList: "client list",
        dailyReport: "Daily summary",
        clientList: "Proxy list",
        warehouse: "Warehouse to summarize"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "loginId",
          userName: "userName",
          IBcode: "IBcode",
          phone: "phone",
          email: "email",
          certificateId: "certificateId",
          superiorMT: "superiorMT",
          superiorMTIB: "superiorMTIB"
        }
      },
      show: "show",
      num: "num",
      clauses: "clauses",
      clauses_text: "Display",
      all: "all",
      amount: "amount",
      present: "present",
      refreshData: "Refresh",
      downloadExcelForms: "Download",
      addAccount: "Create account",
      deletedData: "deletedData",
      addRole: "addRole",
      deleteRole: "deleteRole",
      roleName: "roleName",
      roleDesc: "roleDesc",
      confirmDelete: "confirmDelete",
      search: "search",
      nodata: "No data was found",
      getBack: "Return to the next level",
      tier: "hierarchical agency",
      total: "Total"
    }
  }
};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    tableModelAuthList: {
      th: {
        WalletBalance: "钱包余额",
        funds: '出入金记录',
        loginId: "登录账号",
        IBCode: "IB代码",
        order: "订单",
        dealTime: '交易时间',
        annotation: '注释',
        nodeCode: '代理代码',
        money: "金额",
        ReportType: "报表类型",
        accountName: "账户名称",
        group: "团队",
        superiorAccount: "上级MT4账号",
        superiorCode: "上级IB代码",
        phone: "电话",
        email: "电子邮箱",
        remark: "备注",
        last_update: "最后修改时间",
        comment: "上级代码",
        superAgentNum: "上级代理账号",
        superAgentCode: "上级代理代码",
        lowerAgentTotal: "下级代理总数",
        generalClientTotal: "普通客户总数",
        margin: "已用预支付",
        marginfree: "可用预付款",
        marginlevel: "预付款比例",
        status: "状态",
        equity: "净值",
        balance: "余额",
        accType: "类型",
        mt4_sync_deposits_sum: "入金",
        mt4_sync_withdrawal_sum: "出金",
        commission_sum: "佣金",
        commission_sum2: "代理佣金",
        profit_sum: "盈亏",
        swaps_sum: "利息",
        volume_sum: "交易量",
        balance2: "净入金",
        balance3: "余额",
        newAgentCount: "新代理",
        newClientCount: "新客户",
        mt4_sync_transfer_ins_sum: "资金转入",
        summary: "总结",
        officeState: {
          name: "职员状态",
          countryArr: [{ text: "全职", value: "F" }, { text: "兼职", value: "P" }, { text: "离职", value: "D" }]
        },
        loginType: {
          name: "类型",
          typeArr: [{ text: '系统', value: "UN" }, { text: '公司', value: "C" }, { text: '国家', value: "N" }, { text: '地区', value: "R" }, { text: '办事处', value: "O" }, { text: '经理', value: "M" }, { text: '销售', value: "SL" }, { text: '代理', value: "IB" }, { text: '客户', value: "CL" }]
        },
        Role_ID: "角色ID",
        Desc: "描述",
        operation: "操作"
      },
      crumbs: {
        userList: '用户列表',
        authList: '权限管理',
        accountList: '账户列表',
        ibList: "代理名单",
        dailyReport: "每日总结",
        clientList: "客户名单",
        warehouse: "仓库总结"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "登录账号",
          userName: "账户名称",
          IBcode: "IB代码",
          phone: "电话",
          email: "电子邮箱",
          certificateId: "证件号码",
          superiorMT: "上级MT4账号",
          superiorMTIB: "上级IB代码"
        }
      },
      show: "显示",
      num: "数",
      clauses: "条目",
      clauses_text: "显示条目数",
      all: "全部",
      amount: "总数",
      present: "当前",
      refreshData: "全部数据",
      downloadExcelForms: "下载Excel",
      addAccount: "添加账户",
      deletedData: "删除数据",
      addRole: "添加角色",
      deleteRole: "删除角色",
      roleName: "角色ID",
      roleDesc: "角色描述",
      confirmDelete: "确认删除",
      search: "搜索",
      nodata: "没有查询到数据",
      getBack: "返回上一级",
      tier: "代理层级",
      total: "合计"
    }
  },
  hk: {
    tableModelAuthList: {
      th: {
        WalletBalance: "錢包餘額",
        funds: '出入金記錄',
        loginId: "登錄帳戶",
        IBCode: "IB代碼",
        order: "訂單",
        dealTime: '交易時間',
        annotation: '注釋',
        nodeCode: '代理代碼',
        money: "金額",
        ReportType: "報表類型",
        accountName: "帳戶名稱",
        group: "團隊",
        superiorAccount: "上級MT4帳號",
        superiorCode: "上級IB代碼",
        phone: "電話",
        email: "電子郵箱",
        remark: "備註",
        last_update: "最後修改時間",

        comment: "上級代碼",
        superAgentNum: "上級代理賬號",
        superAgentCode: "上級代理代碼",
        lowerAgentTotal: "下級代理总数",
        generalClientTotal: "普通客戶總數",
        margin: "已用預付款",
        marginfree: "可用預付款",
        marginlevel: "預付款比例",
        status: "狀態",

        equity: "淨值",
        balance: "餘額",

        accType: "類型",
        mt4_sync_deposits_sum: "入金",
        mt4_sync_withdrawal_sum: "出金",
        commission_sum: "傭金",
        commission_sum2: "代理傭金",
        profit_sum: "盈虧",
        swaps_sum: "利息",
        volume_sum: "交易量",
        balance2: "淨入金",
        balance3: "餘額",
        newAgentCount: "新代理",
        newClientCount: "新客戶",
        mt4_sync_transfer_ins_sum: "資金轉入",
        summary: "總結",
        officeState: {
          name: "職員狀態",
          countryArr: [{ text: "全職", value: "F" }, { text: "兼職", value: "P" }, { text: "離職", value: "D" }]
        },
        loginType: {
          name: "類型",
          typeArr: [{ text: '系統', value: "UN" }, { text: '公司', value: "C" }, { text: '國家', value: "N" }, { text: '地區', value: "R" }, { text: '辦事處', value: "O" }, { text: '經理', value: "M" }, { text: '銷售', value: "SL" }, { text: '代理', value: "IB" }, { text: '客戶', value: "CL" }]
        },
        Role_ID: "角色ID",
        Desc: "描述",
        operation: "操作"
      },
      crumbs: {
        userList: '用戶列表',
        authList: '權限管理',
        accountList: '帳戶列表',
        ibList: "代理名單",
        dailyReport: "每日总结",
        clientList: "客戶名單",
        warehouse: "倉庫總結"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "登錄帳號",
          userName: "帳戶名稱",
          IBcode: "IB代碼",
          phone: "電話",
          email: "電子郵箱",
          certificateId: "證件號碼",
          superiorMT: "上級MT4帳號",
          superiorMTIB: "上級IB代碼"
        }
      },
      show: "顯示",
      num: "數",
      clauses: "條目",
      clauses_text: "顯示條目數",
      all: "全部",
      amount: "總數",
      present: "當前",
      refreshData: "全部數據",
      downloadExcelForms: "下載Excel",
      addAccount: "添加帳戶",
      deletedData: "刪除數據",
      addRole: "添加角色",
      deleteRole: "删除角色",
      confirmDelete: "確認刪除",
      roleName: "角色ID",
      roleDesc: "角色描述",
      search: "搜索",
      nodata: "没有查询到数据",
      getBack: "返回上一級",
      tier: "代理層級",
      total: "合計"
    }
  },
  en: {
    tableModelAuthList: {
      th: {
        WalletBalance: "Wallet Balance",
        funds: 'Entry and exit record',
        loginId: "Login Account",
        IBCode: "IB Code",
        order: "Order",
        dealTime: 'Deal time',
        annotation: 'Annotation',
        nodeCode: 'nodeCode',
        money: "Amount of money",
        ReportType: "Report type",
        accountName: "Account Name",
        group: "group",
        superiorAccount: "Superior MT4 Account",
        superiorCode: "Superior IB Code",
        phone: "Phone",
        email: "Email",
        remark: "Remark",
        last_update: "Last modification ",
        comment: "comment",
        superAgentNum: "superAgentNum",
        superAgentCode: "superAgentCode",
        lowerAgentTotal: "lowerAgentTotal",
        generalClientTotal: "generalClientTotal",
        margin: "margin",
        marginfree: "marginfree",
        marginlevel: "marginlevel",
        status: "status",
        equity: "equity",
        balance: "balance",
        accType: "Types of",
        mt4_sync_deposits_sum: "Into the gold",
        mt4_sync_withdrawal_sum: "Out of gold",
        commission_sum: "commission",
        commission_sum2: "Agency commission",
        profit_sum: "Profit and loss",
        swaps_sum: "interest",
        volume_sum: "Trading volume",
        balance2: "Net deposit",
        balance3: "Balance",
        newAgentCount: "newAgentCount",
        newClientCount: "newClientCount",
        mt4_sync_transfer_ins_sum: "Capital transfer",
        summary: "summary",
        officeState: {
          name: "Employee status",
          countryArr: [{ text: "full time", value: "F" }, { text: "part time", value: "P" }, { text: "Leave", value: "D" }]
        },
        loginType: {
          name: "Types of",
          typeArr: [{ text: 'system', value: "UN" }, { text: 'the company', value: "C" }, { text: 'country', value: "N" }, { text: 'area', value: "R" }, { text: 'office', value: "O" }, { text: 'manager', value: "M" }, { text: 'Sales', value: "SL" }, { text: 'IB', value: "IB" }, { text: 'client', value: "CL" }]
        },
        Role_ID: "Role_ID",
        Desc: "Desc",
        operation: "Operation"
      },
      crumbs: {
        userList: 'user list',
        accountList: 'account list',
        authList: 'auth list',
        ibList: "client list",
        dailyReport: "Daily summary",
        clientList: "Proxy list",
        warehouse: "Warehouse to summarize"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "loginId",
          userName: "userName",
          IBcode: "IBcode",
          phone: "phone",
          email: "email",
          certificateId: "certificateId",
          superiorMT: "superiorMT",
          superiorMTIB: "superiorMTIB"
        }
      },
      show: "show",
      num: "num",
      clauses: "clauses",
      clauses_text: "Display",
      all: "all",
      amount: "amount",
      present: "present",
      refreshData: "refreshData",
      downloadExcelForms: "downloadExcel",
      addAccount: "addAccount",
      deletedData: "deletedData",
      addRole: "addRole",
      deleteRole: "deleteRole",
      roleName: "Role ID",
      roleDesc: "roleDesc",
      confirmDelete: "confirmDelete",
      search: "search",
      nodata: "No data was found",
      getBack: "Return to the next level",
      tier: "hierarchical agency",
      total: "Total"
    }
  }
};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    tableModelChangeParentSales: {
      th: {
        systemVersion: "系统版本",
        WalletBalance: "钱包余额",
        funds: '出入金记录',
        loginId: "登录账号",
        IBCode: "IB代码",
        order: "订单",
        dealTime: '交易时间',
        annotation: '注释',
        nodeCode: '代理代码',
        money: "金额",
        ReportType: "报表类型",
        accountName: "账户名称",
        group: "团队",
        superiorAccount: "上级MT4账号",
        superiorCode: "上级IB代码",
        phone: "电话",
        email: "电子邮箱",
        remark: "备注",
        last_update: "最后修改时间",
        comment: "上级代码",
        superAgentNum: "上级代理账号",
        superAgentCode: "上级代理代码",
        lowerAgentTotal: "下级代理总数",
        generalClientTotal: "普通客户总数",
        margin: "已用预支付",
        marginfree: "可用预付款",
        marginlevel: "预付款比例",
        status: "状态",
        equity: "净值",
        balance: "余额",
        accType: "类型",
        mt4_sync_deposits_sum: "入金",
        mt4_sync_withdrawal_sum: "出金",
        commission_sum: "佣金",
        commission_sum2: "代理佣金",
        profit_sum: "盈亏",
        swaps_sum: "利息",
        volume_sum: "交易量",
        balance2: "净入金",
        balance3: "余额",
        newAgentCount: "新代理",
        newClientCount: "新客户",
        mt4_sync_transfer_ins_sum: "资金转入",
        summary: "总结",
        officeState: {
          name: "职员状态",
          countryArr: [{ text: "全职", value: "F" }, { text: "兼职", value: "P" }, { text: "离职", value: "D" }]
        },
        loginType: {
          name: "类型",
          typeArr: [{ text: '系统', value: "UN" }, { text: '公司', value: "C" }, { text: '国家', value: "N" }, { text: '地区', value: "R" }, { text: '办事处', value: "O" }, { text: '经理', value: "M" }, { text: '销售', value: "SL" }, { text: '代理', value: "IB" }, { text: '客户', value: "CL" }]
        },
        Role_ID: "角色ID",
        Desc: "描述",
        operation: "操作"
      },
      crumbs: {
        userList: '用户列表',
        authList: '权限管理',
        accountList: '账户列表',
        ibList: "代理名单",
        dailyReport: "每日总结",
        clientList: "客户名单",
        warehouse: "仓库总结"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "登录账号",
          userName: "账户名称",
          IBcode: "IB代码",
          phone: "电话",
          email: "电子邮箱",
          certificateId: "证件号码",
          superiorMT: "上级MT4账号",
          superiorMTIB: "上级IB代码"
        }
      },
      show: "显示",
      num: "数",
      clauses: "条目",
      clauses_text: "显示条目数",
      all: "全部",
      amount: "总数",
      present: "当前",
      refreshData: "全部数据",
      downloadExcelForms: "下载Excel",
      addAccount: "添加账户",
      deletedData: "删除数据",
      addRole: "添加角色",
      deleteRole: "删除角色",
      roleName: "角色名称",
      roleDesc: "角色描述",
      confirmDelete: "确认删除",
      search: "搜索",
      nodata: "没有查询到数据",
      getBack: "返回上一级",
      tier: "代理层级",
      total: "合计",
      tip: {
        max_limit: "最多只能选50个帐号执行操作。",
        submit: "处理中,请稍等。"
      },
      changeNew: "使用新版",
      changeOld: "使用旧版"
    }
  },
  hk: {
    tableModelChangeParentSales: {
      th: {
        systemVersion: "系統版本",
        WalletBalance: "錢包餘額",
        funds: '出入金記錄',
        loginId: "登錄賬號",
        IBCode: "IB代碼",
        order: "訂單",
        dealTime: '交易時間',
        annotation: '注釋',
        nodeCode: '代理代碼',
        money: "金額",
        ReportType: "報表類型",
        accountName: "帳戶名稱",
        group: "團隊",
        superiorAccount: "上級MT4帳號",
        superiorCode: "上級IB代碼",
        phone: "電話",
        email: "電子郵箱",
        remark: "備註",
        last_update: "最後修改時間",

        comment: "上級代碼",
        superAgentNum: "上級代理賬號",
        superAgentCode: "上級代理代碼",
        lowerAgentTotal: "下級代理总数",
        generalClientTotal: "普通客戶總數",
        margin: "已用預付款",
        marginfree: "可用預付款",
        marginlevel: "預付款比例",
        status: "狀態",

        equity: "淨值",
        balance: "餘額",

        accType: "類型",
        mt4_sync_deposits_sum: "入金",
        mt4_sync_withdrawal_sum: "出金",
        commission_sum: "傭金",
        commission_sum2: "代理傭金",
        profit_sum: "盈虧",
        swaps_sum: "利息",
        volume_sum: "交易量",
        balance2: "淨入金",
        balance3: "餘額",
        newAgentCount: "新代理",
        newClientCount: "新客戶",
        mt4_sync_transfer_ins_sum: "資金轉入",
        summary: "總結",
        officeState: {
          name: "職員狀態",
          countryArr: [{ text: "全職", value: "F" }, { text: "兼職", value: "P" }, { text: "離職", value: "D" }]
        },
        loginType: {
          name: "類型",
          typeArr: [{ text: '系統', value: "UN" }, { text: '公司', value: "C" }, { text: '國家', value: "N" }, { text: '地區', value: "R" }, { text: '辦事處', value: "O" }, { text: '經理', value: "M" }, { text: '銷售', value: "SL" }, { text: '代理', value: "IB" }, { text: '客戶', value: "CL" }]
        },
        Role_ID: "角色ID",
        Desc: "描述",
        operation: "操作"
      },
      crumbs: {
        userList: '用戶列表',
        authList: '權限管理',
        accountList: '帳戶列表',
        ibList: "代理名單",
        dailyReport: "每日总结",
        clientList: "客戶名單",
        warehouse: "倉庫總結"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "登錄帳號",
          userName: "帳戶名稱",
          IBcode: "IB代碼",
          phone: "電話",
          email: "電子郵箱",
          certificateId: "證件號碼",
          superiorMT: "上級MT4帳號",
          superiorMTIB: "上級IB代碼"
        }
      },
      show: "顯示",
      num: "數",
      clauses: "條目",
      clauses_text: "顯示條目數",
      all: "全部",
      amount: "總數",
      present: "當前",
      refreshData: "全部數據",
      downloadExcelForms: "下載Excel",
      addAccount: "添加帳戶",
      deletedData: "刪除數據",
      addRole: "添加角色",
      deleteRole: "删除角色",
      confirmDelete: "確認刪除",
      roleName: "角色名称",
      roleDesc: "角色描述",
      search: "搜索",
      nodata: "没有查询到数据",
      getBack: "返回上一級",
      tier: "代理層級",
      total: "合計",
      tip: {
        max_limit: "最多只能選50個賬號執行操作。",
        submit: "處理中,請稍等。"
      },
      changeNew: "使用新版",
      changeOld: "使用舊版"
    }
  },
  en: {
    tableModelChangeParentSales: {
      th: {
        systemVersion: "System Version",
        WalletBalance: "Wallet Balance",
        funds: 'Entry and exit record',
        loginId: "Account Number",
        IBCode: "IB Code",
        order: "Order",
        dealTime: 'Deal time',
        annotation: 'Annotation',
        nodeCode: 'Node Code',
        money: "Amount of money",
        ReportType: "Report type",
        accountName: "Account Name",
        group: "group",
        superiorAccount: "Superior MT4 Account",
        superiorCode: "Superior IB Code",
        phone: "Phone",
        email: "Email",
        remark: "Remark",
        last_update: "Last modification ",
        comment: "comment",
        superAgentNum: "Parent Account Number",
        superAgentCode: "superAgentCode",
        lowerAgentTotal: "lowerAgentTotal",
        generalClientTotal: "generalClientTotal",
        margin: "margin",
        marginfree: "marginfree",
        marginlevel: "marginlevel",
        status: "status",
        equity: "equity",
        balance: "balance",
        accType: "Account Type",
        mt4_sync_deposits_sum: "Into the gold",
        mt4_sync_withdrawal_sum: "Out of gold",
        commission_sum: "commission",
        commission_sum2: "Agency commission",
        profit_sum: "Profit and loss",
        swaps_sum: "interest",
        volume_sum: "Trading volume",
        balance2: "Net deposit",
        balance3: "Balance",
        newAgentCount: "newAgentCount",
        newClientCount: "newClientCount",
        mt4_sync_transfer_ins_sum: "Capital transfer",
        summary: "summary",
        officeState: {
          name: "Employee status",
          countryArr: [{ text: "full time", value: "F" }, { text: "part time", value: "P" }, { text: "Leave", value: "D" }]
        },
        loginType: {
          name: "Types of",
          typeArr: [{ text: 'system', value: "UN" }, { text: 'the company', value: "C" }, { text: 'country', value: "N" }, { text: 'area', value: "R" }, { text: 'office', value: "O" }, { text: 'manager', value: "M" }, { text: 'Sales', value: "SL" }, { text: 'IB', value: "IB" }, { text: 'client', value: "CL" }]
        },
        Role_ID: "Role_ID",
        Desc: "Desc",
        operation: "Operation"
      },
      crumbs: {
        userList: 'user list',
        accountList: 'account list',
        authList: 'auth list',
        ibList: "client list",
        dailyReport: "Daily summary",
        clientList: "Proxy list",
        warehouse: "Warehouse to summarize"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "loginId",
          userName: "userName",
          IBcode: "IBcode",
          phone: "phone",
          email: "email",
          certificateId: "certificateId",
          superiorMT: "superiorMT",
          superiorMTIB: "superiorMTIB"
        }
      },
      show: "show",
      num: "num",
      clauses: "clauses",
      clauses_text: "Display",
      all: "all",
      amount: "amount",
      present: "present",
      refreshData: "refreshData",
      downloadExcelForms: "downloadExcel",
      addAccount: "addAccount",
      deletedData: "deletedData",
      addRole: "addRole",
      deleteRole: "deleteRole",
      roleName: "roleName",
      roleDesc: "roleDesc",
      confirmDelete: "confirmDelete",
      search: "Search",
      nodata: "No data was found",
      getBack: "Return to the next level",
      tier: "hierarchical agency",
      total: "Total",
      tip: {
        max_limit: "Can only select a maximum of 50 records to process。",
        submit: "Processing, please wait a moment。"
      },
      changeNew: "Use New",
      changeOld: "Use Old"
    }
  }
};

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    tableModelUserList: {
      th: {
        WalletBalance: "钱包余额",
        funds: '出入金记录',
        loginId: "登录账号",
        IBCode: "IB代码",
        order: "订单",
        dealTime: '交易时间',
        annotation: '注释',
        nodeCode: '代理代码',
        money: "金额",
        ReportType: "报表类型",
        accountName: "账户名称",
        group: "团队",
        superiorAccount: "上级MT4账号",
        superiorCode: "上级IB代码",
        phone: "电话",
        email: "电子邮箱",
        remark: "备注",
        last_update: "最后修改时间",
        comment: "上级代码",
        superAgentNum: "上级代理账号",
        superAgentCode: "上级代理代码",
        lowerAgentTotal: "下级代理总数",
        generalClientTotal: "普通客户总数",
        margin: "已用预支付",
        marginfree: "可用预付款",
        marginlevel: "预付款比例",
        status: "状态",
        equity: "净值",
        balance: "余额",
        accType: "类型",
        mt4_sync_deposits_sum: "入金",
        mt4_sync_withdrawal_sum: "出金",
        commission_sum: "佣金",
        commission_sum2: "代理佣金",
        profit_sum: "盈亏",
        swaps_sum: "利息",
        volume_sum: "交易量",
        balance2: "净入金",
        balance3: "余额",
        newAgentCount: "新代理",
        newClientCount: "新客户",
        mt4_sync_transfer_ins_sum: "资金转入",
        summary: "总结",
        officeState: {
          name: "职员状态",
          countryArr: [{ text: "全职", value: "F" }, { text: "兼职", value: "P" }, { text: "离职", value: "D" }]
        },
        loginType: {
          name: "类型",
          typeArr: [{ text: '系统', value: "UN" }, { text: '公司', value: "C" }, { text: '国家', value: "N" }, { text: '地区', value: "R" }, { text: '办事处', value: "O" }, { text: '经理', value: "M" }, { text: '销售', value: "SL" }, { text: '代理', value: "IB" }, { text: '客户', value: "CL" }]
        },
        Role_ID: "角色ID",
        Desc: "描述",
        operation: "操作"
      },
      crumbs: {
        userList: '用户列表',
        authList: '权限管理',
        accountList: '账户列表',
        ibList: "代理名单",
        dailyReport: "每日总结",
        clientList: "客户名单",
        warehouse: "仓库总结"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "登录账号",
          userName: "账户名称",
          IBcode: "IB代码",
          phone: "电话",
          email: "电子邮箱",
          certificateId: "证件号码",
          superiorMT: "上级MT4账号",
          superiorMTIB: "上级IB代码"
        }
      },
      show: "显示",
      num: "数",
      clauses: "条目",
      clauses_text: "显示条目数",
      all: "全部",
      amount: "总数",
      present: "当前",
      refreshData: "全部数据",
      downloadExcelForms: "下载Excel",
      addAccount: "添加账户",
      deletedData: "删除数据",
      addRole: "添加角色",
      deleteRole: "删除角色",
      roleName: "角色名称",
      roleDesc: "角色描述",
      confirmDelete: "确认删除",
      search: "搜索",
      nodata: "没有查询到数据",
      getBack: "返回上一级",
      tier: "代理层级",
      total: "合计"
    }
  },
  hk: {
    tableModelUserList: {
      th: {
        WalletBalance: "錢包餘額",
        funds: '出入金記錄',
        loginId: "登錄賬號",
        IBCode: "IB代碼",
        order: "訂單",
        dealTime: '交易時間',
        annotation: '注釋',
        nodeCode: '代理代碼',
        money: "金額",
        ReportType: "報表類型",
        accountName: "帳戶名稱",
        group: "團隊",
        superiorAccount: "上級MT4帳號",
        superiorCode: "上級IB代碼",
        phone: "電話",
        email: "電子郵箱",
        remark: "備註",
        last_update: "最後修改時間",

        comment: "上級代碼",
        superAgentNum: "上級代理賬號",
        superAgentCode: "上級代理代碼",
        lowerAgentTotal: "下級代理总数",
        generalClientTotal: "普通客戶總數",
        margin: "已用預付款",
        marginfree: "可用預付款",
        marginlevel: "預付款比例",
        status: "狀態",

        equity: "淨值",
        balance: "餘額",

        accType: "類型",
        mt4_sync_deposits_sum: "入金",
        mt4_sync_withdrawal_sum: "出金",
        commission_sum: "傭金",
        commission_sum2: "代理傭金",
        profit_sum: "盈虧",
        swaps_sum: "利息",
        volume_sum: "交易量",
        balance2: "淨入金",
        balance3: "餘額",
        newAgentCount: "新代理",
        newClientCount: "新客戶",
        mt4_sync_transfer_ins_sum: "資金轉入",
        summary: "總結",
        officeState: {
          name: "職員狀態",
          countryArr: [{ text: "全職", value: "F" }, { text: "兼職", value: "P" }, { text: "離職", value: "D" }]
        },
        loginType: {
          name: "類型",
          typeArr: [{ text: '系統', value: "UN" }, { text: '公司', value: "C" }, { text: '國家', value: "N" }, { text: '地區', value: "R" }, { text: '辦事處', value: "O" }, { text: '經理', value: "M" }, { text: '銷售', value: "SL" }, { text: '代理', value: "IB" }, { text: '客戶', value: "CL" }]
        },
        Role_ID: "角色ID",
        Desc: "描述",
        operation: "操作"
      },
      crumbs: {
        userList: '用戶列表',
        authList: '權限管理',
        accountList: '帳戶列表',
        ibList: "代理名單",
        dailyReport: "每日总结",
        clientList: "客戶名單",
        warehouse: "倉庫總結"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "登錄帳號",
          userName: "帳戶名稱",
          IBcode: "IB代碼",
          phone: "電話",
          email: "電子郵箱",
          certificateId: "證件號碼",
          superiorMT: "上級MT4帳號",
          superiorMTIB: "上級IB代碼"
        }
      },
      show: "顯示",
      num: "數",
      clauses: "條目",
      clauses_text: "顯示條目數",
      all: "全部",
      amount: "總數",
      present: "當前",
      refreshData: "全部數據",
      downloadExcelForms: "下載Excel",
      addAccount: "添加帳戶",
      deletedData: "刪除數據",
      addRole: "添加角色",
      deleteRole: "删除角色",
      confirmDelete: "確認刪除",
      roleName: "角色名称",
      roleDesc: "角色描述",
      search: "搜索",
      nodata: "没有查询到数据",
      getBack: "返回上一級",
      tier: "代理層級",
      total: "合計"
    }
  },
  en: {
    tableModelUserList: {
      th: {
        WalletBalance: "Wallet Balance",
        funds: 'Entry and exit record',
        loginId: "User ID",
        IBCode: "IB Code",
        order: "Order",
        dealTime: 'Deal time',
        annotation: 'Annotation',
        nodeCode: 'nodeCode',
        money: "Amount of money",
        ReportType: "Report type",
        accountName: "User Name",
        group: "group",
        superiorAccount: "Superior MT4 Account",
        superiorCode: "Superior IB Code",
        phone: "Phone",
        email: "Email",
        remark: "Remark",
        last_update: "Last modification ",
        comment: "comment",
        superAgentNum: "superAgentNum",
        superAgentCode: "superAgentCode",
        lowerAgentTotal: "lowerAgentTotal",
        generalClientTotal: "generalClientTotal",
        margin: "margin",
        marginfree: "marginfree",
        marginlevel: "marginlevel",
        status: "status",
        equity: "equity",
        balance: "balance",
        accType: "Types of",
        mt4_sync_deposits_sum: "Into the gold",
        mt4_sync_withdrawal_sum: "Out of gold",
        commission_sum: "commission",
        commission_sum2: "Agency commission",
        profit_sum: "Profit and loss",
        swaps_sum: "interest",
        volume_sum: "Trading volume",
        balance2: "Net deposit",
        balance3: "Balance",
        newAgentCount: "newAgentCount",
        newClientCount: "newClientCount",
        mt4_sync_transfer_ins_sum: "Capital transfer",
        summary: "summary",
        officeState: {
          name: "Employee status",
          countryArr: [{ text: "full time", value: "F" }, { text: "part time", value: "P" }, { text: "Leave", value: "D" }]
        },
        loginType: {
          name: "Types of",
          typeArr: [{ text: 'system', value: "UN" }, { text: 'the company', value: "C" }, { text: 'country', value: "N" }, { text: 'area', value: "R" }, { text: 'office', value: "O" }, { text: 'manager', value: "M" }, { text: 'Sales', value: "SL" }, { text: 'IB', value: "IB" }, { text: 'client', value: "CL" }]
        },
        Role_ID: "Role_ID",
        Desc: "Desc",
        operation: "Operation"
      },
      crumbs: {
        userList: 'User List',
        accountList: 'account list',
        authList: 'auth list',
        ibList: "client list",
        dailyReport: "Daily summary",
        clientList: "Proxy list",
        warehouse: "Warehouse to summarize"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "loginId",
          userName: "userName",
          IBcode: "IBcode",
          phone: "phone",
          email: "email",
          certificateId: "certificateId",
          superiorMT: "superiorMT",
          superiorMTIB: "superiorMTIB"
        }
      },
      show: "show",
      num: "num",
      clauses: "clauses",
      clauses_text: "Display",
      all: "all",
      amount: "amount",
      present: "present",
      refreshData: "Refresh",
      downloadExcelForms: "Download",
      addAccount: "Create user",
      deletedData: "Delete user",
      addRole: "addRole",
      deleteRole: "deleteRole",
      roleName: "roleName",
      roleDesc: "roleDesc",
      confirmDelete: "confirmDelete",
      search: "search",
      nodata: "No data was found",
      getBack: "Return to the next level",
      tier: "hierarchical agency",
      total: "Total"
    }
  }
};

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cn: {
    userDatum: {
      crumbs: {
        newaAccount: "用户开户",
        amend: "用户修改"
      },
      sales: {
        title: '账号资料',
        form: {
          sales_id: "账号",
          acc_name: '账户名称',
          acc_type: "账户类型",
          phone: '手机号',
          email: '邮箱',
          remark: '备注',
          code: "代码",
          last_code: "上级代码",
          password: '密码'
        }
      },
      sales_info: {
        title: '个人资料',
        form: {
          birth_date: "出生日期",
          jurisdiction: {
            name: "权限级别",
            genderArr: ['客服', '管理员']
          },
          gender: {
            name: '性别',
            genderArr: ['请选择', '先生', '女士']
          },
          country: {
            name: '国家/地区',
            countryArr: ['请选择', '中国', '香港特别行政区', '台湾', '阿富汗', '阿尔巴尼亚', '亚尔及利亚', '萨摩亚', '安道尔', '安哥拉', '安圭拉', '南极', '安提瓜和巴布达', '阿根廷', '亚美尼亚', '阿鲁巴', '澳洲', '维也纳', '阿塞拜疆', '巴哈马', '巴林', '孟加拉共和国', '巴巴多斯', '白俄逻斯', '比利时', '伯利兹', '贝宁', '百慕达', '不丹', '玻利维亚', '波斯尼亚', '博茨瓦纳', '波维特岛', '巴西', '英属印度洋领域', '英国公民', '英国属土公民', '英国国民海外', '英国海外公民', '受英国保护人士', '英籍人士', '文莱', '保加利亚', '布基纳法索', '布基纳法索', '缅甸', '蒲隆地', '柬埔寨', '喀麦隆', '加拿大', '佛得角', '开曼群岛', '中非共和国', '乍得', '智利', '圣诞岛', '科科斯群岛', '哥伦比亚', '科摩逻', '刚果', '库克群岛', '哥斯达尼加', '科特迪瓦', '克逻地亚', '古巴', '塞浦路斯', '捷克', '丹麦', '吉布提', '多明尼加共和国', '多米尼克', '东帝汶', '厄瓜多尔', '埃及', '西班牙', '萨尔瓦多', '赤道几内亚', '厄立特里亚', '爱沙尼亚', '埃塞俄比亚', '福克兰群岛', '法逻群岛', '斐济', '芬兰', '法国', '法国大都会', '法属圭亚那', '玻里尼西亚', '法国南方属地', '加彭', '冈比亚', '甘比亚', '格鲁吉亚', '德国', '迦纳', '直布逻陀', '希蜡', '格陵兰', '格林纳达', '关岛', '危地马拉', '几内亚', '几内亚比绍', '圭亚那', '海地', '赫德及麦当奴群岛', '洪都拉斯', '匈牙利', '冰岛', '印度', '印度尼西亚', '伊朗', '伊拉克', '爱尔兰', '以色列', '意大利', '牙买加', '日本', '约旦', '哈萨克斯坦', '肯尼亚', '基里巴斯', '韩国', '科威特', '吉尔吉斯坦', '老挝寮国', '拉脱维亚', '黎巴嫩', '莱索托', '利比里亚', '阿拉伯利比亚民众国', '列支敦士登', '立陶宛', '卢森堡', '澳门特别行政区', '前南斯拉夫马其顿共和国', '马达加斯加', '马拉维', '马来西亚', '马尔代夫', '马里', '马耳他', '马绍尔群岛', '马提尼克岛', '毛里塔尼亚', '毛里求斯', '马约特岛', '墨西哥', '密克逻尼西亚联邦', '摩尔多瓦', '摩纳哥', '蒙古', '蒙特内哥逻', '蒙特塞拉特', '摩洛哥', '莫桑比克', '缅甸', '纳米比亚', '瑙鲁', '尼泊尔', '荷属安的列斯群岛', '荷兰', '新喀里多尼亚', '新西兰', '尼加拉瓜', '尼日尔', '尼日利亚', '纽埃', '诺福克岛', '朝鲜', '北马里亚纳群岛', '挪威', '巴勒斯坦佔领区', '阿曼', '巴基斯坦', '帕劳', '巴拿马', '巴布亚新几内亚', '巴拉圭', '秘鲁', '菲律宾', '皮特凯恩', '波兰', '葡萄牙', '波多黎各', '卡塔尔', '难民', '其他难民', '留尼汪岛', '逻马尼亚', '俄逻斯联邦', '卢旺达', '圣卢西亚', '萨摩亚', '圣马利诺', '圣多美和普林西比', '沙特阿拉伯', '塞内加尔', '塞尔维亚', '塞舌尔', '塞拉利昂', '新加坡', '斯洛伐克共和国', '斯洛文尼亚', '所逻门群岛', '索马里', '斯里兰卡', '圣赫勒拿', '基茨-尼维斯', '圣皮埃尔岛及密克隆岛', '圣文森特和格林纳丁斯', '无国籍人士', '苏丹', '苏里南', '斯瓦巴及尖绵', '斯威士兰', '瑞典', '瑞士', '叙利亚', '塔吉克斯坦', '坦桑尼亚', '泰国', '多哥', '托克劳群岛', '东加', '特立尼达和多巴哥', '突尼斯', '土耳其', '土库曼斯坦', '特克斯和凯科斯群岛', '图瓦卢', '美国米诺群岛', '乌干达', '乌克兰', '阿拉伯联合酋长国', '联合国办事署', '联合国组织', '美利坚合众国美国', '乌拉圭', '乌兹别克斯坦', '瓦努阿图', '梵蒂冈', '委内瑞拉', '越南', '英属处女群岛', '美属处女群岛', '瓦利斯和富图纳群岛', '萨摩亚西', '也门', '也门共和国', '南非', '扎伊尔', '赞比亚', '津巴布韦']
          },
          addr: "地址",
          phone: "电话",
          email: "邮箱",
          lang: {
            name: '语言',
            langArr: ['请选择', '简体中文', '繁体中文', '英文']
          },
          doc_type: {
            name: '证件类型',
            docTypeArr: ['请选择', '身份证', '驾驶证', '护照']
          },
          docNo: '证件号码',
          docFrontImg: '证件附件(正面)',
          docBackImg: '证件附件(反面)',
          localCcy: '当地货币',
          bankCardType: '银行卡类型',
          bankCardNo: '银行卡号',
          beneficiaryName: '受益人',
          bank: {
            name: '银行',
            bankArr: ['请选择', '中国工商银行', '中国农业银行', '中国建设银行', '招商银行', '中信银行', '交通银行', '广东发展银行', '上海浦东发展银行', '中国银行', '城市商业银行', '中国农业发展银行', '光大银行', '华夏银行', '中国民生银行', '深圳发展银行', '兴业银行', '恒丰银行', '浙商银行', '农村合作银行', '农村商业银行', '农村信用合作社', '城市信用合作社', '徽商银行', '渤海银行', '中国邮政储蓄银行', '北京银行', '平安银行股份有限公司', '南京银行', '江苏银行', '宁波银行', '上海银行', '杭州银行', '东亚银行', '青岛银行', '广州银行', '其他']
          },
          swiftCode: '银行代码',
          bankAddr: '开户行地址',
          bankCardImg: '银行卡图片',
          remark: '备注'
        }
      },
      submit: "注册",
      changeBtn: '保存修改',
      flaseTipNum: '请输入11位以内数字',
      flaseTipName: '请输入您的账户名称',
      flaseTipPass: '请输入您的密码',
      flasePhone: '请输入您的手机号',
      flaseTip: '请正确输入',
      loginTip: '账号或密码有误',
      fileUpload: '选择文件上传',
      repeatId: '该账号已被注册',
      TipPassWord: '密码已进行隐藏处理，如需修改请直接填写',
      logOut: {
        word: "是否退出登录?",
        yes: '确定',
        no: '取消'
      },
      submitResult: {
        succeed: "保存成功",
        err: "请正确填写信息"
      },
      user_id_point: '该账号已经存在',
      user_name_point: '该账户名称已经存在',
      email_isRepeat: '邮箱已被注册，请重新输入'
    }
  },
  hk: {
    userDatum: {
      crumbs: {
        newaAccount: "用戶開戶",
        amend: "用戶修改"
      },
      sales: {
        title: '帳號資料',
        form: {
          sales_id: "帳號",
          acc_name: '帳戶名稱',
          acc_type: "帳戶類型",
          code: "代碼",
          phone: '手機號',
          email: '郵箱',
          remark: '備注',
          last_code: "上級代碼",
          password: '密碼'
        }
      },
      sales_info: {
        title: '個人資料',
        form: {
          birth_date: "出生日期",
          jurisdiction: {
            name: "許可權級別",
            genderArr: ['客服', '管理員']
          },
          gender: {
            name: '性別',
            genderArr: ['', '先生', '女士']
          },
          country: {
            name: '國家/地區',
            countryArr: ['', '中國', '香港特別行政區', '臺灣', '阿富汗', '阿爾巴尼亞', '亞爾及利亞', '薩摩亞', '安道爾', '安哥拉', '安圭拉', '南極', '安地卡及巴布達', '阿根廷', '亞美尼亞', '阿魯巴', '澳洲', '維也納', '亞塞拜然', '巴哈馬', '巴林', '孟加拉共和國', '巴貝多', '白俄邏斯', '比利時', '貝里斯', '貝南', '百慕達', '不丹', '玻利維亞', '波士尼亞', '波札那', '波維特島', '巴西', '英屬印度洋領域', '英國公民', '英國屬土公民', '英國國民海外', '英國海外公民', '受英國保護人士', '英籍人士', '汶萊', '保加利亞', '布吉納法索', '布吉納法索', '緬甸', '蒲隆地', '柬埔寨', '喀麥隆', '加拿大', '維德角', '開曼群島', '中非共和國', '查德', '智利', '聖誕島', '科科斯群島', '哥倫比亞', '科摩邏', '剛果', '科克群島', '哥斯達尼加', '象牙海岸', '克邏地亞', '古巴', '賽普勒斯', '捷克', '丹麥', '吉布地', '多明尼加共和國', '多明尼克', '東帝汶', '厄瓜多爾', '埃及', '西班牙', '薩爾瓦多', '赤道幾內亞', '厄立特里亞', '愛沙尼亞', '衣索比亞', '福克蘭群島', '法邏群島', '斐濟', '芬蘭', '法國', '法國大都會', '法屬圭亞那', '玻裡尼西亞', '法國南方屬地', '加彭', '甘比亞', '甘比亞', '格魯吉亞', '德國', '迦納', '直布邏陀', '希蠟', '格陵蘭', '格瑞那達', '關島', '瓜地馬拉', '幾內亞', '幾內亞比索', '圭亞那', '海地', '赫德及麥當奴群島', '洪都拉斯', '匈牙利', '冰島', '印度', '印尼', '伊朗', '伊拉克', '愛爾蘭', '以色列', '義大利', '牙買加', '日本', '約旦', '哈薩克', '肯亞', '吉里巴斯', '韓國', '科威特', '吉爾吉斯坦', '老撾寮國', '拉脫維亞', '黎巴嫩', '賴索托', '賴比瑞亞', '阿拉伯利比亞民眾國', '列支敦士登', '立陶宛', '盧森堡', '澳門特別行政區', '前南斯拉夫馬其頓共和國', '馬達加斯加', '馬拉威', '馬來西亞', '馬爾地夫', '馬里', '馬爾他', '馬紹爾群島', '馬提尼克島', '茅利塔尼亞', '模里西斯', '馬約特', '墨西哥', '密克邏尼西亞聯邦', '莫爾達瓦', '摩納哥', '蒙古', '蒙特內哥邏', '蒙瑟拉特島', '摩洛哥', '莫三比克', '緬甸', '納米比亞', '諾魯', '尼泊爾', '荷屬安的列斯群島', '荷蘭', '新赫里多尼亞', '紐西蘭', '尼加拉瓜', '尼日爾', '奈及利亞', '紐埃', '諾福克島', '朝鮮', '北馬里安納群島', '挪威', '巴勒斯坦佔領區', '阿曼', '巴基斯坦', '帛琉', '巴拿馬', '巴布亞紐幾內亞', '巴拉圭', '秘魯', '菲律賓', '皮特凱恩', '波蘭', '葡萄牙', '波多黎各', '卡達', '難民', '其他難民', '留尼旺島', '邏馬尼亞', '俄邏斯聯邦', '盧旺達', '聖露西亞', '薩摩亞', '聖馬利諾', '聖多美及普林西比島', '沙烏地阿拉伯', '塞內加爾', '塞爾維亞', '塞席爾', '獅子山', '新加坡', '斯洛伐克共和國', '斯洛維尼亞', '所邏門群島', '索馬里', '斯里蘭卡', '聖赫勒拿', '基茨-尼維斯', '聖皮爾島及密克隆島', '聖文森特和格林納丁斯群島', '無國籍人士', '蘇丹', '蘇利南', '斯瓦巴及尖綿', '史瓦濟蘭', '瑞典', '瑞士', '敘利亞', '塔吉克斯坦', '坦桑尼亞', '泰國', '多哥', '托克勞群島', '東加', '千里達和多巴哥', '突尼斯', '土耳其', '土庫曼斯坦', '特克斯和凱科斯群島', '吐瓦魯', '美國米諾群島', '烏干達', '烏克蘭', '阿拉伯聯合大公國', '聯合國辦事署', '聯合國組織', '美利堅合眾國美國', '烏拉圭', '烏茲別克斯坦', '瓦努阿圖', '梵蒂岡', '委內瑞拉', '越南', '英屬處女群島', '美屬處女群島', '瓦利斯和富圖納群島', '薩摩亞西', '葉門', '葉門共和國', '南非', '薩伊', '尚比亞', '辛巴威']
          },
          addr: "地址",
          phone: "電話",
          email: "郵箱",
          lang: {
            name: '語言',
            langArr: ['', '簡體中文', '繁體中文', '英文']
          },
          doc_type: {
            name: '證件類型',
            docTypeArr: ['', '身份證', '駕駛證', '護照']
          },
          docNo: '證件號碼',
          docFrontImg: '證件附件(正面)',
          docBackImg: '證件附件(反面)',
          localCcy: '當地貨幣',
          bankCardType: '銀行卡類型',
          bankCardNo: '銀行卡號',
          beneficiaryName: '受益人',
          bank: {
            name: '銀行',
            bankArr: ['', '中國工商銀行', '中國農業銀行', '中國建設銀行', '招商銀行', '中信銀行', '交通銀行', '廣東發展銀行', '上海浦東發展銀行', '中國銀行', '城市商業銀行', '中國農業發展銀行', '光大銀行', '華夏銀行', '中國民生銀行', '深圳發展銀行', '興業銀行', '恒豐銀行', '浙商銀行', '農村合作銀行', '農村商業銀行', '農村信用合作社', '城市信用合作社', '徽商銀行', '渤海銀行', '中國郵政儲蓄銀行', '北京銀行', '平安銀行股份有限公司', '南京銀行', '江蘇銀行', '寧波銀行', '上海銀行', '杭州銀行', '東亞銀行', '青島銀行', '廣州銀行', '其他']
          },
          swiftCode: '銀行代碼',
          bankAddr: '開戶行地址',
          bankCardImg: '銀行卡圖片',
          remark: '備註'
        }
      },
      submit: "註冊",
      changeBtn: '保存修改',
      flaseTipNum: '請輸入11位以內數字',
      flaseTipName: '請輸入您的賬戶名稱',
      flaseTipPass: '請輸入您的密碼',
      flasePhone: '請輸入您的手機號',
      flaseTip: '請正確輸入',
      loginTip: '帳號或密碼有誤',
      fileUpload: '選擇檔上傳',
      repeatId: '該帳號已被注册',
      TipPassWord: '密碼已進行隱藏處理，如需修改請直接填寫',
      logOut: {
        word: '是否登出?',
        yes: '確定',
        no: '取消'
      },
      submitResult: {
        succeed: "保存成功",
        err: "請正確填寫資訊"
      },
      user_id_point: '該賬號已經存在',
      user_name_point: '該帳戶名稱已經存在',
      email_isRepeat: '郵箱已被註冊，請重新輸入'
    }
  },
  en: {
    userDatum: {
      crumbs: {
        newaAccount: "Create a user account",
        amend: "Create a user account"
      },
      sales: {
        title: 'Account Information',
        form: {
          sales_id: "User ID",
          acc_name: 'User Name',
          acc_type: "Account Type",
          code: "Code",
          phone: 'Phone',
          email: 'Email',
          remark: 'Remark',
          last_code: "Superior Code",
          password: 'Password'
        }
      },
      sales_info: {
        title: 'Personal Information',
        form: {
          birth_date: "Birth Date",
          jurisdiction: {
            name: "Profile Setting",
            genderArr: ['service', 'Administrator']
          },
          gender: {
            name: 'Gender',
            genderArr: ['', 'Male', 'Female']
          },
          country: {
            name: 'Country',
            countryArr: ['', 'CHN China', 'HKG Hong Kong S.A.R.', 'TWN Taiwan', 'AFG Afghanistan', 'ALB Albania', 'DZA Algeria', 'ASM Samoa', 'And Andorra', 'AGO Angola', 'AIA Anguilla', 'ATA Antarctica', 'ATG Antigua and Barbuda', 'ARG Argentina', 'ARM Armenia', 'ABW Aruba', 'AUS Australia', 'AUT Vienna', 'AZE Azerbaijan', 'BHS Bahamas', 'BHR Bahrain', 'BGD Bangladesh', 'BRB Barbados', 'BLR Belarus', 'BEL Belgium', 'BLZ Belize', 'Ben Benin', 'BMU Bermuda', 'BTN Bhutan', 'Bol Bolivia', 'BIH Bosnia', 'BWA Botswana', 'BVT Povet', 'BRA Brazil', 'IOT British Indian Ocean Area', 'GBR British citizenship', 'GBD British Dependent Territories Citizens', 'GBN British National Overseas', 'GBO British Overseas Citizen', 'GBP protected by the British,', 'GBS British', 'BRN Brunei', 'BGR Bulgaria', 'BFA Burkina Faso', 'HVO Burkina Faso', 'BUR Burma', 'BDI Burundi', 'KHM Cambodia', 'CMR Cameroon', 'CAN Canada', 'CPV Cape Verde', 'CYM Cayman Islands', 'CAF Central African Republic', 'TCD Chad', 'CHL Chile', 'CXR Christmas Island', 'CCK Cocos Islands', 'COL Colombia', 'COM Como', 'COG Congo', 'COK Cook Islands', 'CRI Costa Rica', "CIV Côte d'Ivoire", 'HRV Kolodia', 'CUB Cuba', 'CYP Cyprus', 'CZE Czech', 'DNK Denmark', 'DJI Djibouti', 'Dom Dominican Republic', 'DMA Dominica', 'TLS East Timor', 'ECU Ecuador', 'EGY Egypt', 'ESP Spain', 'SLV Salvador', 'GNQ Equatorial Guinea', 'ERI Eritrea', 'Est Estonia', 'ETH Ethiopia', 'FLK Falkland Islands', 'FRO Lego Islands', 'FJI Fiji', 'FIN Finland', 'FRA France', 'FXX Metropolis of France', 'GUF French Guiana', 'PYF Polynesia', 'ATF South of France', 'GAB Gabon', 'GLP Gambia', 'GMB Gambia', 'GEO Georgia', 'DEU Germany', 'GHA Ghana', 'GIB Direct', 'GRC Greek wax', 'GRL Greenland', 'GRD Grenada', 'GUM Guam', 'GTM Guatemala', 'GIN Guinea', 'GNB-Bissau', 'GUY Guyana', 'HTI Haiti', 'HMD Hurd and McDonald Islands', 'HND Honduras', 'HUN Hungary', 'ISL Iceland', 'IND India', 'IDN Indonesia', 'IRN Iran', 'IRQ Iraq', 'IRL Ireland', 'ISR Israel', 'ITA Italy', 'JAM Jamaica', 'JPN Japan', 'JOR Jordan', 'KAZ Kazakhstan', 'Ken Kenya', 'KIR Kiribati', 'KOR Korea', 'KWT Kuwait', 'KGZ Kyrgyzstan', 'LAO Laos Laos', 'LVA Latvia', 'LBN Lebanon', 'LSO Lesotho', 'LBR Liberia', 'LBY Libyan Arab Jamahiriya', 'LIE Liechtenstein', 'LTU Lithuania', 'LUX Luxembourg', 'MAC Macao Special Administrative Region', 'MKD Former Yugoslav Republic of Macedonia', 'MDG Madagascar', 'MWI Malawi', 'MYS Malaysia', 'MDV Maldives', 'MLI Mali', 'MLT Malta', 'MHL Marshall Islands', 'MTQ Martinique', 'MRT Mauritania', 'MUS Mauritius', 'MYT Mayotte', 'MEX Mexico', 'FSM Federated States of Micronesia', 'MDA Moldova', 'MCO Monaco', 'MNG Mongolia', 'MNE Montenegro', 'MSR Montserrat', 'MAR Morocco', 'MOZ Mozambique', 'MMR Burma', 'Nam Namibia', 'NRU Nauru', 'NPL Nepal', 'ANT Netherlands Antilles', 'NLD Netherlands', 'NCL New Caledonia', 'NZL New Zealand', 'NIC Nicaragua', 'NER Niger', 'NGA Nigeria', 'NIU Niue', 'NFK Norfolk Island', 'PRK North Korea', 'MNP Northern Mariana Islands', 'NOR NORWAY', 'PSE Occupied Palestinian Territory', 'OMN Oman', 'PAK PAKISTAN', 'PLW Palau', 'Pan Panama', 'PNG Papua New Guinea', 'PRY Paraguay', 'PER Peru', 'PHL Philippines', 'PCN Pitcairn', 'POL Poland', 'PRT Portugal', 'PRI Puerto Rico', 'QAT Qatar,', 'XXB Refugee', 'XXC other refugees', 'REU Reunion Island', 'ROU Romanian', 'RUS Russian Federation', 'RWA Rwanda', 'LCA Saint Lucia', 'WSM Samoa', 'SMR San Marino', 'STP Sao Tome and Principe', 'SAU Saudi Arabia', 'SEN Senegal', 'SRB Serbia', 'SYC Seychelles', 'SLE Sierra', 'SGP Singapore', 'SVK the Slovak Republic', 'SVN Slovenia', 'SLB Solomon Islands', 'SOM Somalia', 'LKA Sri Lanka', 'SHN St. Helena', 'KNA Kitts-Nevis', 'SPM Saint Pierre and Miquelon', 'VCT Saint Vincent and the Grenadines', 'XXA stateless person', 'SDN Sudan', 'SUR Suriname', 'SJM Swabian and Spike', 'SWZ Swaziland', 'SWE Sweden', 'CHE Switzerland', 'SYR Syria', 'TJK Tajikistan', 'TZA Tanzania', 'THA Thailand', 'TGO Togo', 'TKL Tokelau', 'TON Plus', 'TTO Trinidad and Tobago', 'TUN Tunisia', 'TUR Turkey', 'TKM Turkmenistan', 'TCA Turks and Caicos Islands', 'TUV Tuvalu', 'UMI American Mino', 'UGA Uganda', 'UKR Ukraine', 'ARE United Arab Emirates', 'UNA United Nations Office', 'UNO United Nations Organization', 'USA United States of America USA', 'URY Uruguay', 'UZB Uzbekistan', 'VUT Vanuatu', 'VAT Vatican', 'VEN Venezuela', 'VNM Vietnam', 'VGB British Virgin Islands', 'VIR American Virgin Islands', 'WLF Wallis and Futuna Islands', 'ESH Samoa West', 'YMD Yemen', 'YEM Republic of Yemen', 'ZAF South Africa', 'ZAR Zaire', 'ZMB Zambia', 'ZWE Zimbabwe']
          },
          addr: "Address",
          phone: "Phone:",
          email: "Email",
          lang: {
            name: 'Email Language',
            langArr: ['', 'CHS Simplified Chinese', 'CHT Traditional Chinese', 'ENG English']
          },
          doc_type: {
            name: 'Document Type',
            docTypeArr: ['', 'IDC Identity Card', 'DRI Driver License', 'POT Passport']
          },
          docNo: 'Id Number',
          docFrontImg: 'Id Front Img',
          docBackImg: 'Id back Img',
          localCcy: 'Local Currency',
          bankCardType: 'Bank Card Type',
          bankCardNo: 'Bank Card Number',
          beneficiaryName: 'Beneficiary Name',
          bank: {
            name: 'Bank',
            bankArr: ['', 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA', 'AGRICULTURAL BANK OF CHINA', 'CHINA CONSTRUCTION BANK CORPORATION', 'CHINA MERCHANTS BANK', 'CITIC BANK CORPORATION LIMITED', 'BANK OF COMMUNICATIONS', 'CHINA GUANGFA BANK', 'SHANGHAI PUDONG DEVELOPMENT BANK', 'BANK OF CHINA LIMITED', 'CITY COMMERCIAL BANKS', 'AGRICULTURAL DEVELOPMENT BANK OF CHINA', 'CHINA EVERBRIGHT BANK', 'HUA XIA BANK', 'CHINA MINSHENG BANKING CORPORATION, LIMITED', 'SHENZHEN DEVELOPMENT BANK CO., LTD', 'INDUSTRIAL BANK', 'EVERGROWING BANK', 'CHINA ZHESHANG BANK', 'RURAL COOPERATION BANK', 'RURAL COMMERCIAL BANK', 'RURAL CREDIT COOPERATIVES UNION', 'CITY CREDIT COOPERATIVES UNION', 'HUISHANG BANK', 'CHINA BOHAI BANK', 'POSTAL SAVINGS BANK OF CHINA', 'BANK OF BEIJING', 'PING AN BANK', 'BANK OF NANJING', 'BANK OF JIANGSU', 'BANK OF NINGBO', 'BANK OF SHANGHAI', 'BANK OF HANGZHOU CO., LTD', 'THE BANK OF EAST ASIA LIMITED', 'BANK OF QINGDAO', 'BANK OF GUANGZHOU', 'OTHER']
          },
          swiftCode: 'Swift Code',
          bankAddr: 'Bank Address',
          bankCardImg: 'Bank Card Img',
          remark: 'Remark'
        }
      },
      submit: "Submit",
      changeBtn: 'Save Modify',
      flaseTipNum: 'Please input 11 digits or less',
      flasePhone: 'Please input your mobile phone number',
      flaseTipName: 'Please enter your account name',
      flaseTipPass: 'Please enter your password',
      flaseTip: 'Please input correctly',
      loginTip: 'The account or password is incorrect',
      fileUpload: 'Select upload file',
      repeatId: 'this account has been registered',
      TipPassWord: 'If you need to change it, please fill it out directly',
      logOut: {
        word: 'Do you want to logout?',
        yes: 'Sure',
        no: 'Cancel'
      },
      submitResult: {
        succeed: "save successfully",
        err: "Please fill in the information correctly"
      },
      user_id_point: 'The account already exists',
      user_name_point: 'The account name already exists',
      email_isRepeat: 'Email has been registered, please re-enter'
    }
  }
};

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthMtable = undefined;

var _authTable = __webpack_require__(994);

var _authTable2 = _interopRequireDefault(_authTable);

var _crumbs = __webpack_require__(57);

var _crumbs2 = _interopRequireDefault(_crumbs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthMtable = exports.AuthMtable = function AuthMtable(par) {
  var PAGEMAX = par.PAGEMAX;
  return {
    data: function data() {
      return {
        trData: "", //  表格tr数据
        selPage: { // 显示条目关联分页
          list: [PAGEMAX * 1, PAGEMAX * 2, PAGEMAX * 3, PAGEMAX * 4, PAGEMAX * 5, PAGEMAX * 6, PAGEMAX * 7, PAGEMAX * 8],
          active: localStorage.pageMaxIndex
        },
        page: { // 分页
          pageActive: 1,
          pageLeng: 0
        },
        sort: par.sort, // 排序
        seekDropdown: par.seekDropdown, // 搜索选项
        handle: par.handle // 操作传参
      };
    },
    mounted: function mounted() {
      this.tableAjax();
    },

    computed: {
      pageLimit: function pageLimit() {
        // 请求跳过条数
        return (this.page.pageActive - 1) * this.selPage.list[this.selPage.active];
      },
      jsonExcelUrl: function jsonExcelUrl() {
        // 下载Excel传参
        return par.ajax + "?offset=0&limit=20000&sortKey=" + this.sort.initKey + "&sort=ASC&seekKey=" + this.seekDropdown.list[this.seekDropdown.active] + "&seekVal=" + this.seekDropdown.seekStr;
      }
    },
    methods: {
      pageShowItem: function pageShowItem(index) {
        this.SAVEPAGEMAXINDEX(index);
        this.tableAjax();
      },
      refresh: function refresh() {
        // 刷新事件
        this.page.pageActive = 1;
        this.seekDropdown.seekStr = "";
        this.tableAjax();
      },
      deleteList: function deleteList(list) {
        var _this = this;

        // 删除事件
        this.$http.post(this.handle.deleteUrl, {
          sortKey: this.handle.deleteKey,
          removeList: list
        }).then(function (res) {
          _this.tableAjax();
        });
      }
    },
    components: {
      authMtable: _authTable2.default,
      crumbs: _crumbs2.default
    }
  };
};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(20);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(1152);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _spView = __webpack_require__(1062);

var _spView2 = _interopRequireDefault(_spView);

var _login = __webpack_require__(1061);

var _login2 = _interopRequireDefault(_login);

var _dailyReport = __webpack_require__(1060);

var _dailyReport2 = _interopRequireDefault(_dailyReport);

var _userList = __webpack_require__(1064);

var _userList2 = _interopRequireDefault(_userList);

var _authList = __webpack_require__(1057);

var _authList2 = _interopRequireDefault(_authList);

var _userDatum = __webpack_require__(1063);

var _userDatum2 = _interopRequireDefault(_userDatum);

var _authOption = __webpack_require__(1058);

var _authOption2 = _interopRequireDefault(_authOption);

var _changepswd = __webpack_require__(1059);

var _changepswd2 = _interopRequireDefault(_changepswd);

var _commissionSpbo = __webpack_require__(1048);

var _commissionSpbo2 = _interopRequireDefault(_commissionSpbo);

var _ProfitShareView = __webpack_require__(1054);

var _ProfitShareView2 = _interopRequireDefault(_ProfitShareView);

var _AccountSetting = __webpack_require__(1052);

var _AccountSetting2 = _interopRequireDefault(_AccountSetting);

var _ProfitShareReport = __webpack_require__(1053);

var _ProfitShareReport2 = _interopRequireDefault(_ProfitShareReport);

var _VersionReport = __webpack_require__(1055);

var _VersionReport2 = _interopRequireDefault(_VersionReport);

var _commissionView = __webpack_require__(1049);

var _commissionView2 = _interopRequireDefault(_commissionView);

var _ibPrimary = __webpack_require__(1050);

var _ibPrimary2 = _interopRequireDefault(_ibPrimary);

var _salePrimary = __webpack_require__(1051);

var _salePrimary2 = _interopRequireDefault(_salePrimary);

var _ibSettingView = __webpack_require__(1022);

var _ibSettingView2 = _interopRequireDefault(_ibSettingView);

var _ibCommissionSetting = __webpack_require__(1020);

var _ibCommissionSetting2 = _interopRequireDefault(_ibCommissionSetting);

var _realTimeResult = __webpack_require__(1016);

var _realTimeResult2 = _interopRequireDefault(_realTimeResult);

var _realTimeDetailResult = __webpack_require__(1015);

var _realTimeDetailResult2 = _interopRequireDefault(_realTimeDetailResult);

var _monthlyIBResult = __webpack_require__(1014);

var _monthlyIBResult2 = _interopRequireDefault(_monthlyIBResult);

var _monthlyIBCommisionResult = __webpack_require__(1013);

var _monthlyIBCommisionResult2 = _interopRequireDefault(_monthlyIBCommisionResult);

var _monthCommDetailResult = __webpack_require__(1012);

var _monthCommDetailResult2 = _interopRequireDefault(_monthCommDetailResult);

var _CPACommissionResult = __webpack_require__(1009);

var _CPACommissionResult2 = _interopRequireDefault(_CPACommissionResult);

var _CPAMonthlyCommResult = __webpack_require__(1011);

var _CPAMonthlyCommResult2 = _interopRequireDefault(_CPAMonthlyCommResult);

var _CPAMonthlyCommDetailResult = __webpack_require__(1010);

var _CPAMonthlyCommDetailResult2 = _interopRequireDefault(_CPAMonthlyCommDetailResult);

var _ibReport = __webpack_require__(1007);

var _ibReport2 = _interopRequireDefault(_ibReport);

var _auditTrailReport = __webpack_require__(1006);

var _auditTrailReport2 = _interopRequireDefault(_auditTrailReport);

var _auditTrailDetailReport = __webpack_require__(1005);

var _auditTrailDetailReport2 = _interopRequireDefault(_auditTrailDetailReport);

var _spreadCommissionMappingReport = __webpack_require__(1008);

var _spreadCommissionMappingReport2 = _interopRequireDefault(_spreadCommissionMappingReport);

var _allCommissionReport = __webpack_require__(1004);

var _allCommissionReport2 = _interopRequireDefault(_allCommissionReport);

var _AlertIgnore = __webpack_require__(999);

var _AlertIgnore2 = _interopRequireDefault(_AlertIgnore);

var _AlertIgnore3 = __webpack_require__(1000);

var _AlertIgnore4 = _interopRequireDefault(_AlertIgnore3);

var _ibTemplateSetting = __webpack_require__(1025);

var _ibTemplateSetting2 = _interopRequireDefault(_ibTemplateSetting);

var _saleSettingView = __webpack_require__(1041);

var _saleSettingView2 = _interopRequireDefault(_saleSettingView);

var _saleCommissionSetting = __webpack_require__(1040);

var _saleCommissionSetting2 = _interopRequireDefault(_saleCommissionSetting);

var _saleMonthlyResult = __webpack_require__(1035);

var _saleMonthlyResult2 = _interopRequireDefault(_saleMonthlyResult);

var _saleMonCommResult = __webpack_require__(1034);

var _saleMonCommResult2 = _interopRequireDefault(_saleMonCommResult);

var _saleMonCommDetailResult = __webpack_require__(1033);

var _saleMonCommDetailResult2 = _interopRequireDefault(_saleMonCommDetailResult);

var _relationshipListReport = __webpack_require__(1031);

var _relationshipListReport2 = _interopRequireDefault(_relationshipListReport);

var _mtclientReport = __webpack_require__(1029);

var _mtclientReport2 = _interopRequireDefault(_mtclientReport);

var _saleTemplateView = __webpack_require__(1045);

var _saleTemplateView2 = _interopRequireDefault(_saleTemplateView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 用于测试功能的页面


// 2.0销售的一些页面
//销售首选项

// 2.0代理的一些页面

// import loginSalePlatform from 'views/loginSalePlatform'
// import changeParentSales from 'views/changeParentSales'
// import changeParentSalesNew from 'views/changeParentSalesNew'
// import clientParentInfo from 'views/clientParentInfo'
// import relation from 'views/relation' //关系树状图

// 佣金主页面

// import accountList from 'views/accountList'
// import accountDatum from 'views/accountDatum'
_vue2.default.use(_vueRouter2.default); // 代理首选项


// 佣金2.0页面

// import commissionView from 'views/CommissionSetting/commissionView'
// import ibPrimary from 'views/CommissionSetting/ibPrimary' // 代理首选项
// import salePrimary from 'views/CommissionSetting/salePrimary' //销售首选项

// 代理的一些页面
// import ibSetting from 'views/CommissionSetting/IB/IBSetting/ibSettingView'
// import IBCommissionSetting from 'views/CommissionSetting/IB/IBSetting/ibCommissionSetting'
// import realTimeResult from 'views/CommissionSetting/IB/IBResult/realTimeResult'
// import realTimeDetailResult from 'views/CommissionSetting/IB/IBResult/realTimeDetailResult'
// import monthlyIBResult from 'views/CommissionSetting/IB/IBResult/monthlyIBResult'
// import monthlyIBCommisionResult from 'views/CommissionSetting/IB/IBResult/monthlyIBCommisionResult'
// import monthCommDetailResult from 'views/CommissionSetting/IB/IBResult/monthCommDetailResult'
// import CPACommissionResult from 'views/CommissionSetting/IB/IBResult/CPACommissionResult'
// import CPAMonthlyCommResult from 'views/CommissionSetting/IB/IBResult/CPAMonthlyCommResult'
// import CPAMonthlyCommDetailResult from 'views/CommissionSetting/IB/IBResult/CPAMonthlyCommDetailResult'
// import ibReport from 'views/CommissionSetting/IB/IBReport/ibReport'
// import auditTrailReport from 'views/CommissionSetting/IB/IBReport/auditTrailReport'
// import auditTrailDetailReport from 'views/CommissionSetting/IB/IBReport/auditTrailDetailReport'
// import spreadCommissionMappingReport from 'views/CommissionSetting/IB/IBReport/spreadCommissionMappingReport'
// import allCommissionReport from 'views/CommissionSetting/IB/IBReport/allCommissionReport'
// import AlertIgnore from 'views/CommissionSetting/IB/AlertIgnore/AlertIgnore'
// import AlertIgnore_new from 'views/CommissionSetting/IB/AlertIgnore/AlertIgnore2'
// import ibTemplateMaintenanceV1 from 'views/CommissionSetting/IB/IBTemplateSetting/ibTemplateSetting'


// 销售的一些页面
// import saleSetting from 'views/CommissionSetting/Sale/SaleSetting/saleSettingView'
// import saleCommissionSetting from 'views/CommissionSetting/Sale/SaleSetting/saleCommissionSetting'
// import saleMonthlyResult from 'views/CommissionSetting/Sale/SaleResult/saleMonthlyResult'
// import saleMonCommResult from 'views/CommissionSetting/Sale/SaleResult/saleMonCommResult'
// import saleMonCommDetailResult from 'views/CommissionSetting/Sale/SaleResult/saleMonCommDetailResult'
// import relationshipListReport from 'views/CommissionSetting/Sale/SaleReport/relationshipListReport'
// import mtclientReport from 'views/CommissionSetting/Sale/SaleReport/mtclientReport'
// import saleTemplateMaintenanceV1 from 'views/CommissionSetting/Sale/SaleTemplate/saleTemplateView'

// 利润分成主界面


var viewObj = function viewObj(view) {
    var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return new Object({ path: '/' + (view.name || ""), name: view.name || "", component: view, children: children });
}; // 获取router对象方法
var viewItem = function (viewObj) {
    return function (view) {
        return viewObj(view);
    };
}(viewObj); // 获取router里的name并调用viewObj方法
var childView = function (viewItem) {
    return function () {
        var viewObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return viewObj.map(function (view) {
            return viewItem(view);
        });
    };
}(viewItem); // 循环views获取viewObj生产对象的数组
var parentView = function (viewObj) {
    return function (view, children) {
        return viewObj(view, children);
    };
}(viewObj); // 生成父路由并且把子路由挂上去

var spViewChild = [// 获取spView子路由
// viewObj(accountList),
// viewObj(accountDatum),
viewObj(_authList2.default), viewObj(_userList2.default), viewObj(_authOption2.default), viewObj(_userDatum2.default), viewObj(_changepswd2.default),
// viewObj(relation),
// viewObj(loginSalePlatform),
// viewObj(changeParentSales),
// viewObj(changeParentSalesNew),
// viewObj(clientParentInfo),
viewObj(_dailyReport2.default),
// 设置 利润分成路由
viewObj(_ProfitShareView2.default, [{ path: '/', redirect: '/profit/accountSetting' }, { path: '/profit/accountSetting', component: _AccountSetting2.default }, { path: '/profit/shareReport', component: _ProfitShareReport2.default }, { path: '/profit/versionReport', component: _VersionReport2.default }]),

// 设置 佣金的嵌套路由
// viewObj(commissionView, [
//     { path: '/', redirect: '/ibPrimary' },
//     {
//         path: '/ibPrimary',
//         component: ibPrimary,
//         children: [
//             { path: '/', redirect: '/ib/ibSetting' },
//             { path: '/ib/ibSetting', component: ibSetting },
//             { path: '/ib/realTimeResult', component: realTimeResult },
//             { path: '/ib/realTimeDetailResult', component: realTimeDetailResult },
//             { path: '/ib/monthlyIBResult', component: monthlyIBResult },
//             { path: '/ib/monthlyIBCommisionResult', component: monthlyIBCommisionResult },
//             { path: '/ib/monthCommDetailResult', component: monthCommDetailResult },
//             { path: '/ib/CPACommissionResult', component: CPACommissionResult },
//             { path: '/ib/CPAMonthlyCommResult', component: CPAMonthlyCommResult },
//             { path: '/ib/CPAMonthlyCommDetailResult', component: CPAMonthlyCommDetailResult },
//             { path: '/ib/ibReport', component: ibReport },
//             { path: '/ib/auditTrailReport', component: auditTrailReport },
//             { path: '/ib/auditTrailDetailReport', component: auditTrailDetailReport },
//             { path: '/ib/spreadCommissionMappingReport', component: spreadCommissionMappingReport },
//             { path: '/ib/allCommissionReport', component: allCommissionReport },
//             { path: '/ib/ibCommissionSetting', component: IBCommissionSetting },
//             { path: '/ib/alert-ignore-list', component: AlertIgnore },
//             { path: '/ib/alert-ignore-list2', component: AlertIgnore_new },
//             { path: '/ib/ibTemplateSetting', component: ibTemplateMaintenanceV1 },
//         ]
//     },
//     {
//         path: '/salePrimary',
//         component: salePrimary,
//         children: [
//             { path: '/', redirect: '/sale/saleSetting' },
//             { path: '/sale/saleSetting', component: saleSetting },
//             { path: '/sale/saleMonthlyResult', component: saleMonthlyResult },
//             { path: '/sale/saleMonCommResult', component: saleMonCommResult },
//             { path: '/sale/saleMonCommDetailResult', component: saleMonCommDetailResult },
//             { path: '/sale/relationshipListReport', component: relationshipListReport },
//             { path: '/sale/saleCommissionSetting', component: saleCommissionSetting },
//             { path: '/sale/mtclientReport', component: mtclientReport },
//             { path: '/sale/saleTemplateSetting', component: saleTemplateMaintenanceV1 },
//         ]
//     },
// ]),
viewObj(_commissionView2.default, [{ path: '/', redirect: '/ibPrimary_v2' }, {
    path: '/ibPrimary_v2',
    component: _ibPrimary2.default,
    children: [{ path: '/', redirect: '/ib_v2/ibSetting' }, { path: '/ib_v2/ibSetting', component: _ibSettingView2.default }, { path: '/ib_v2/realTimeResult', component: _realTimeResult2.default }, { path: '/ib_v2/realTimeDetailResult', component: _realTimeDetailResult2.default }, { path: '/ib_v2/monthlyIBResult', component: _monthlyIBResult2.default }, { path: '/ib_v2/monthlyIBCommisionResult', component: _monthlyIBCommisionResult2.default }, { path: '/ib_v2/monthCommDetailResult', component: _monthCommDetailResult2.default }, { path: '/ib_v2/CPACommissionResult', component: _CPACommissionResult2.default }, { path: '/ib_v2/CPAMonthlyCommResult', component: _CPAMonthlyCommResult2.default }, { path: '/ib_v2/CPAMonthlyCommDetailResult', component: _CPAMonthlyCommDetailResult2.default }, { path: '/ib_v2/ibReport', component: _ibReport2.default }, { path: '/ib_v2/auditTrailReport', component: _auditTrailReport2.default }, { path: '/ib_v2/auditTrailDetailReport', component: _auditTrailDetailReport2.default }, { path: '/ib_v2/spreadCommissionMappingReport', component: _spreadCommissionMappingReport2.default }, { path: '/ib_v2/allCommissionReport', component: _allCommissionReport2.default }, { path: '/ib_v2/ibCommissionSetting', component: _ibCommissionSetting2.default }, { path: '/ib_v2/alert-ignore-list', component: _AlertIgnore2.default }, { path: '/ib_v2/alert-ignore-list2', component: _AlertIgnore4.default }, { path: '/ib_v2/ibTemplateSetting', component: _ibTemplateSetting2.default }]
}, {
    path: '/salePrimary_v2',
    component: _salePrimary2.default,
    children: [{ path: '/', redirect: '/sale_v2/saleSetting' }, { path: '/sale_v2/saleSetting', component: _saleSettingView2.default }, { path: '/sale_v2/saleMonthlyResult', component: _saleMonthlyResult2.default }, { path: '/sale_v2/saleMonCommResult', component: _saleMonCommResult2.default }, { path: '/sale_v2/saleMonCommDetailResult', component: _saleMonCommDetailResult2.default }, { path: '/sale_v2/relationshipListReport', component: _relationshipListReport2.default }, { path: '/sale_v2/saleCommissionSetting', component: _saleCommissionSetting2.default }, { path: '/sale_v2/mtclientReport', component: _mtclientReport2.default }, { path: '/sale_v2/saleTemplateSetting', component: _saleTemplateView2.default }]
}])];

var spViewObj = parentView(_spView2.default, spViewChild); // 获取spView完整对象
if (window.location.href.indexOf('fromSpbo2') > 0) spViewObj = viewObj(_commissionSpbo2.default, spViewChild);
exports.default = new _vueRouter2.default({
    mode: 'history',
    routes: [{
        path: '/',
        redirect: 'login'
    }, {
        path: '/fromSpbo2',
        redirect: 'ibPrimary_v2'
    }, viewObj(_login2.default), spViewObj]
});

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(20);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(24);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: {
    USER: '',
    LANGUAGE: 'cn',
    PAGEMAXINDEX: 0,
    SIDEBARACTIVE: '',
    SIDEBARVUE: null
  },
  mutations: {
    SAVEUSER: function SAVEUSER(state, user) {
      state.USER = user;
      sessionStorage.user = user;
    },
    SAVELANGUAGE: function SAVELANGUAGE(state, language) {
      state.LANGUAGE = language;
      localStorage.language = language;
    },
    SAVEPAGEMAXINDEX: function SAVEPAGEMAXINDEX(state, pageMaxIndex) {
      state.PAGEMAXINDEX = pageMaxIndex;
      localStorage.pageMaxIndex = pageMaxIndex;
    },
    SAVESIDEBARACTIVE: function SAVESIDEBARACTIVE(state, sidebarActive) {
      state.SIDEBARACTIVE = sidebarActive;
    },
    GETSIDEBARVUE: function GETSIDEBARVUE(state, vue) {
      state.SIDEBARVUE = vue;
    }
  },
  actions: {
    SAVEUSER: function SAVEUSER(context, user) {
      context.commit('SAVEUSER', user);
    },
    SAVELANGUAGE: function SAVELANGUAGE(state, language) {
      context.commit('SAVELANGUAGE', language);
    },
    SAVEPAGEMAXINDEX: function SAVEPAGEMAXINDEX(state, pageMaxIndex) {
      context.commit('SAVEPAGEMAXINDEX', pageMaxIndex);
    },
    SAVESIDEBARACTIVE: function SAVESIDEBARACTIVE(state, sidebarActive) {
      context.commit('SAVESIDEBARACTIVE', sidebarActive);
    },
    GETSIDEBARVUE: function GETSIDEBARVUE(state, vue) {
      context.commit('GETSIDEBARVUE', vue);
    }
  }
});

/***/ }),
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 875 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 878 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 879 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 880 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 881 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 884 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 888 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 889 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 890 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 891 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 892 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 894 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 895 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 903 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 911 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 912 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 915 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 916 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 935 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 936 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 955 */,
/* 956 */,
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 276,
	"./af.js": 276,
	"./ar": 284,
	"./ar-dz": 277,
	"./ar-dz.js": 277,
	"./ar-kw": 278,
	"./ar-kw.js": 278,
	"./ar-ly": 279,
	"./ar-ly.js": 279,
	"./ar-ma": 280,
	"./ar-ma.js": 280,
	"./ar-ps": 281,
	"./ar-ps.js": 281,
	"./ar-sa": 282,
	"./ar-sa.js": 282,
	"./ar-tn": 283,
	"./ar-tn.js": 283,
	"./ar.js": 284,
	"./az": 285,
	"./az.js": 285,
	"./be": 286,
	"./be.js": 286,
	"./bg": 287,
	"./bg.js": 287,
	"./bm": 288,
	"./bm.js": 288,
	"./bn": 290,
	"./bn-bd": 289,
	"./bn-bd.js": 289,
	"./bn.js": 290,
	"./bo": 291,
	"./bo.js": 291,
	"./br": 292,
	"./br.js": 292,
	"./bs": 293,
	"./bs.js": 293,
	"./ca": 294,
	"./ca.js": 294,
	"./cs": 295,
	"./cs.js": 295,
	"./cv": 296,
	"./cv.js": 296,
	"./cy": 297,
	"./cy.js": 297,
	"./da": 298,
	"./da.js": 298,
	"./de": 301,
	"./de-at": 299,
	"./de-at.js": 299,
	"./de-ch": 300,
	"./de-ch.js": 300,
	"./de.js": 301,
	"./dv": 302,
	"./dv.js": 302,
	"./el": 303,
	"./el.js": 303,
	"./en-au": 304,
	"./en-au.js": 304,
	"./en-ca": 305,
	"./en-ca.js": 305,
	"./en-gb": 306,
	"./en-gb.js": 306,
	"./en-ie": 307,
	"./en-ie.js": 307,
	"./en-il": 308,
	"./en-il.js": 308,
	"./en-in": 309,
	"./en-in.js": 309,
	"./en-nz": 310,
	"./en-nz.js": 310,
	"./en-sg": 311,
	"./en-sg.js": 311,
	"./eo": 312,
	"./eo.js": 312,
	"./es": 316,
	"./es-do": 313,
	"./es-do.js": 313,
	"./es-mx": 314,
	"./es-mx.js": 314,
	"./es-us": 315,
	"./es-us.js": 315,
	"./es.js": 316,
	"./et": 317,
	"./et.js": 317,
	"./eu": 318,
	"./eu.js": 318,
	"./fa": 319,
	"./fa.js": 319,
	"./fi": 320,
	"./fi.js": 320,
	"./fil": 321,
	"./fil.js": 321,
	"./fo": 322,
	"./fo.js": 322,
	"./fr": 325,
	"./fr-ca": 323,
	"./fr-ca.js": 323,
	"./fr-ch": 324,
	"./fr-ch.js": 324,
	"./fr.js": 325,
	"./fy": 326,
	"./fy.js": 326,
	"./ga": 327,
	"./ga.js": 327,
	"./gd": 328,
	"./gd.js": 328,
	"./gl": 329,
	"./gl.js": 329,
	"./gom-deva": 330,
	"./gom-deva.js": 330,
	"./gom-latn": 331,
	"./gom-latn.js": 331,
	"./gu": 332,
	"./gu.js": 332,
	"./he": 333,
	"./he.js": 333,
	"./hi": 334,
	"./hi.js": 334,
	"./hr": 335,
	"./hr.js": 335,
	"./hu": 336,
	"./hu.js": 336,
	"./hy-am": 337,
	"./hy-am.js": 337,
	"./id": 338,
	"./id.js": 338,
	"./is": 339,
	"./is.js": 339,
	"./it": 341,
	"./it-ch": 340,
	"./it-ch.js": 340,
	"./it.js": 341,
	"./ja": 342,
	"./ja.js": 342,
	"./jv": 343,
	"./jv.js": 343,
	"./ka": 344,
	"./ka.js": 344,
	"./kk": 345,
	"./kk.js": 345,
	"./km": 346,
	"./km.js": 346,
	"./kn": 347,
	"./kn.js": 347,
	"./ko": 348,
	"./ko.js": 348,
	"./ku": 350,
	"./ku-kmr": 349,
	"./ku-kmr.js": 349,
	"./ku.js": 350,
	"./ky": 351,
	"./ky.js": 351,
	"./lb": 352,
	"./lb.js": 352,
	"./lo": 353,
	"./lo.js": 353,
	"./lt": 354,
	"./lt.js": 354,
	"./lv": 355,
	"./lv.js": 355,
	"./me": 356,
	"./me.js": 356,
	"./mi": 357,
	"./mi.js": 357,
	"./mk": 358,
	"./mk.js": 358,
	"./ml": 359,
	"./ml.js": 359,
	"./mn": 360,
	"./mn.js": 360,
	"./mr": 361,
	"./mr.js": 361,
	"./ms": 363,
	"./ms-my": 362,
	"./ms-my.js": 362,
	"./ms.js": 363,
	"./mt": 364,
	"./mt.js": 364,
	"./my": 365,
	"./my.js": 365,
	"./nb": 366,
	"./nb.js": 366,
	"./ne": 367,
	"./ne.js": 367,
	"./nl": 369,
	"./nl-be": 368,
	"./nl-be.js": 368,
	"./nl.js": 369,
	"./nn": 370,
	"./nn.js": 370,
	"./oc-lnc": 371,
	"./oc-lnc.js": 371,
	"./pa-in": 372,
	"./pa-in.js": 372,
	"./pl": 373,
	"./pl.js": 373,
	"./pt": 375,
	"./pt-br": 374,
	"./pt-br.js": 374,
	"./pt.js": 375,
	"./ro": 376,
	"./ro.js": 376,
	"./ru": 377,
	"./ru.js": 377,
	"./sd": 378,
	"./sd.js": 378,
	"./se": 379,
	"./se.js": 379,
	"./si": 380,
	"./si.js": 380,
	"./sk": 381,
	"./sk.js": 381,
	"./sl": 382,
	"./sl.js": 382,
	"./sq": 383,
	"./sq.js": 383,
	"./sr": 385,
	"./sr-cyrl": 384,
	"./sr-cyrl.js": 384,
	"./sr.js": 385,
	"./ss": 386,
	"./ss.js": 386,
	"./sv": 387,
	"./sv.js": 387,
	"./sw": 388,
	"./sw.js": 388,
	"./ta": 389,
	"./ta.js": 389,
	"./te": 390,
	"./te.js": 390,
	"./tet": 391,
	"./tet.js": 391,
	"./tg": 392,
	"./tg.js": 392,
	"./th": 393,
	"./th.js": 393,
	"./tk": 394,
	"./tk.js": 394,
	"./tl-ph": 395,
	"./tl-ph.js": 395,
	"./tlh": 396,
	"./tlh.js": 396,
	"./tr": 397,
	"./tr.js": 397,
	"./tzl": 398,
	"./tzl.js": 398,
	"./tzm": 400,
	"./tzm-latn": 399,
	"./tzm-latn.js": 399,
	"./tzm.js": 400,
	"./ug-cn": 401,
	"./ug-cn.js": 401,
	"./uk": 402,
	"./uk.js": 402,
	"./ur": 403,
	"./ur.js": 403,
	"./uz": 405,
	"./uz-latn": 404,
	"./uz-latn.js": 404,
	"./uz.js": 405,
	"./vi": 406,
	"./vi.js": 406,
	"./x-pseudo": 407,
	"./x-pseudo.js": 407,
	"./yo": 408,
	"./yo.js": 408,
	"./zh-cn": 409,
	"./zh-cn.js": 409,
	"./zh-hk": 410,
	"./zh-hk.js": 410,
	"./zh-mo": 411,
	"./zh-mo.js": 411,
	"./zh-tw": 412,
	"./zh-tw.js": 412
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 957;

/***/ }),
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAWlJREFUeNpi/P//PwOtARMDHcDwsYQFXWD69Om41LoAcRgQS0P5L4F4DRBvQ1aUmZlJ2BIcoASIHYH4CdRgUGoxAeJsIDYH4nqSfIIFpEEtaAHi40jiC4DYCIibgbgciDvJjRN+IPYH4pVoFsDAOSCeBcR2QCxJriW2UHoxHjUbobQPuZbAXEdMjiXbJy9JSKlvyLXkMJSOwqPGE0pvJ9eS99B8EA3Epljk9YA4B5oA7lOShKdC1TUA8UkgvgmNI1UgtgLis0BcR2k+0UWKVHMoRgaCUB9dIteSRCAOQcp8IJ+8hvL5oLk+HojbgXgLqFQi1ZI4qAUngLgDiH+jyX8H4q1QnAvNJ4xAPI3YiNcA4nBoLm/GYgE6mAz1iTewgDUn1pIqKN1CQj4BBdUPIK4gxhJZIBYG4iVkVB0zgZgN6Bt9QpZYQ+kDZFgCy7xOhCwRhEbqOzIsAen7AMTMyIKMo60VUgBAgAEAMmFKE+uGQbIAAAAASUVORK5CYII="

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAS9JREFUeNpi/P//PwOtAeOwsYQBZAkJOBGITwNxJCn6SLEg9j8qCKO2JZH/sYMgalkSiGbwATS+F6WWeKMZWAgVr0QTdyHXEnQLcqHi8lC6BE3elVRL3NAMyICKV0H5jVB+Hpo6e2ItcULTmAQVr0ATr4OKZ6CJWxOyxA5NQwyOOICBeqh8Epq4BS5LXNEURhKwAN2ieDRxO2yWwMBvIA4m0gIYaICqjwLiP+iJAdkSUFjqArEMlJ/7nzRQDNUnBzUHZJ4qvtSl+Z88oIXNPCYc5SY3FrEnQBwLxC5AHA3ED7Go4SSlFNbH4soQAsXNf6g+on2CDbxG478nViMplvAQEaQkWcJKRHhzEqmPgQWHJV+A+CYs2oCYGUtwgfi3gfgvqBpH0jeMGxJ0sQQgwABUVbqIsCXcCgAAAABJRU5ErkJggg=="

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAZZJREFUeNrs1r8vA2EYwPFe0yhVpYtF2tCIGMSPlRhsBhamMvkTjGLqvyGRsBosBqtJYsHAUiHpwEAqqrS05HzfeMSby73n7oRE4k0+Sfvc+97Tvu/zvneWbduRn27RyC+0P5FkCfs4RgEJ115qTUJI4tR+b48o259tzNk/bIJbueGUFs/gEi9IfCdJK64lwaDL9YRcK4RNksWz3CTn0e8eB3osyMJXsAcLFx79YmiEqa5FrKGMPFoM/UbRho0g1aXm+Fym6EhbjwaGHX1zcq0YpLriuJGBq5iT+BAeUEeXxHq1ck75TZLUEqiKmpbPGbneLd9nEZPPVaTd7meaoo/N1S8x9esqjmmawQqecIcO06y4BU8M+2BAylO1KylT1Uro9FpbZyAvA8cNA6KYxxa2seBnjzkDh6j5GLiLHr8bOeao8yRePfZLFiVV+WgPe9RvSqK0S9+cJKgihaLvs8Lx1yw05ZTt0+ITslY1bW/45hYc0Z4NdTm6VTsz7YOvWIYXiTiWMYkmdrAe9vFp/b+tBGlvAgwApygt4FAS+F8AAAAASUVORK5CYII="

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANNJREFUeNpi+v//PwOtMRMDHcCoJcPXEj8g/gTET7FJslDJEn4g5oViqlqSCMTGQLwDiB9DxT5T25JMIDYFYm4g7qNWnDBCDTWD8m9D6RdAzIZPIyk+ARl0CsnCd0MqCdcA8VEo/QuIf6AFH1UscQRiKyC2B+L/QPyPWj7ZCMR7gFgXiI8gRS5JricU8X5QWpKUyCU3uP4AsQCUDcvJnEjyPFCaC8mxROd4UPnDB43kj9Bc/Boq9wrJojdQufdA/BPKxprjGUHV42hRP2oJTQBAgAEA2j5wMdO6ObYAAAAASUVORK5CYII="

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAi1JREFUeNq81k1IVFEUwPFRxw/UwNRJkSIKjPygsiBBF4om4ddGRFJwEbRyEYFLWxWtDFy5sIVmRLhoUSCKi6CNi0wyUYhQECEQrcjRCLJo+l84D57He9+MQ3ngx7x3373v3Ddz73mTEovFQv87wgn0qUUl8pCOPzAzS8NvfMMqXrlukBLwJMW4jeNyg7dYV31OogrXsIdHWDlwJ5PEogaP0eu4btOBMbToa7bO1ZjAuUMk8ERkco1BSYpkNmeSSODJx1OcdSW5a3tcy1fZEKfPVQx656m+n+cScjHlWAj58tmPB3Jc4Og7h++oNyf+JFfw2jFoCbfk+Cu25LgLa8iwjDGTvaCTRPDO0vkFijAi51nIluNxbGPWMm5R9ta+JJm+GXphZtKOUkSlbUc2oIkfsk/K0KbG7nn3C6tGHXfksaO+tgE1ORMT6MGkat8JWTrrOIVPqi3qexIvNqXkHNjrOomt0wZKEqhvEalpOnJ1kl+WJTmEVhyLk+QGnlmKb7FO8gUXVccFzEiVdcW8LOOXqr1C9sq+JGYvNFhu0ipf20fcxAl54i5Z8ua8xjKuGR9sVfg+6hyl4h4WsIRlvMdDR99yDCFsq12nMYqCgLpkqnNZwPV0jKMyqNQ3SbmOJFGBszCMznjvE+M6nshnoglqZXLd+lrQ6/c8+mRpT+MNdlUfU8Muy4+cJ7Vs7jDveC+82pWDz7IsY3JeiJ/y7n+ezB+JfxapoSOIvwIMAFowxhmkL2TxAAAAAElFTkSuQmCC"

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAfRJREFUeNq81s9LlEEYwPF9l0UpFoW2DSFSVLoka5E/IBOhg4eERbvZ0iEIlui4QiXIXjop7B9gQqQHg8CTB4lIEGzpx6EMcdkuEVQLLVpQmG2Ht+/QE0zDu++PXdqBD+zMO+/zvDPvzLxr2bYd+t8lHGpA8ZNkDl+wg8fYwAd8xIivLGq6XKygglGj3ULW/lMmPGK4JrklQZpd+lyVPvFakoRlBCmvp8RTLNeSJIltHwmUSyi69an24s/Ky/VTXuEHWoKurgM0+UxySOL8CprkEXp8JhpDREYTeAmXcN/jfcRkdWVqXcKDEmDSpU8/5uvZJ8plSXQHXbK0nfpF6kmitNv/lr8jU3toXfbJM/mdqiVJGk8kiDpiFnAciyjjGk7iFK5jF0tBkuQl0A2j/aaMKOpwT1Su3dbbrSrfkyJ+os9Y/614h/MoIIfvqKADaQxhFTG3fXJPgvU6bLBxOfILUl+TBzmHh9KWx0v9pogRJIErOFZlW7Xhm1ZX35mSjPqz1v7Jbcdn8QBfqyR5jhNa/YhMS1yfHsqA245/gQseK+49prV6HxJaPWeeymYAdbwf9kgyLCtoyuFaRq6d0dvNd7KFfY8DcRMXcRdJvIGF0+iU7/5r/QZzCas53vN5xB/FDLrVrOMtZlE2O1qN+N/1W4ABAO6Y7dIKFJyzAAAAAElFTkSuQmCC"

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAXxJREFUeNpi/P//PwOtARMDHcDIsUQXiNcC8X8ongXEsiTbAop4HNjlPwLcBOJHSHwFPPowMC4JIahhr4FYHUncDir+hBqW9EMNU8Mi5wyVi4byxaE+xYaX4bPkJtQgbHKMULmFUL4UEP/DgQ+D1LDgiKp3eKKRDUp/gNLPCCYgHK6NhLo2B4tcH1ROj9I4AeE1UMOKoXGjA8RdULFmJHWg4PqBBf8C4r0gNYx4yi4PIN6OQ04fiC9B2eJAfBRbIAHxWSCOwGXJeiAOAOIXQLwRiB9BxRWA2A9q8BIgjiU3Mx6DBslMIObCIs8NxIuharahyTEBMSsQMyPRGJZMgWouJSJCm6FqG5HE7v5HBTfQ4wQUFPeh8eBFZKl0AojNgVgYmuyrgVgJKscIxLeAuAPZZbCUo0hCkWEC1VNGbBK+DcTfSSmToBiUs4/jU4Oc46WAmAOIi4GYE+pdvGkGiH9D1UkQm7o2AvGX/6SDT0jlGFbMONqQGHSWAAQYAKNCri9ZSyi9AAAAAElFTkSuQmCC"

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAXhJREFUeNrs1k8oBFEcwPGx5LAlpW3jIs7kRpE2taXksnFdyclBcpCrIxclpZRclOLiQG1bG7clbSK0ByXyL6H2sPa6je/op17TjHnDjguvPvXmzXvz2/f77ZsmZJqmEbSQ8Qvt7wZZQlFs6C6q8RkkgjrpR4PaSUnpvwUVpKD0i5UOksAaBpSxHqxi1HO15oHqMN1bb6UO4znaHca7kf1puqyUhKWfR1K5N40j6Vcj5jdd/cjiAhHbvTQObWO1yOEUCfvznALsSa7T33gZrsvanFdN4thHGVsY1KhZXN4A1gFNodMrXSU0oRmbeMYlpiQt6txxnOEFu2iT8SuvdJXRolyHMYtrPGFOru9xiwU0KPOr8OgVxGqLLjkfwgnyGHGZMyPP+DLImPzqBywjqlHweszLzqzdTnoFUYMd4BUZ9DnM6cKO1OQYE5IuQzfIpxi2JZhV5CSG5W9aQErOlesz/JyBRinyDe6wgladtR9b+/+Q0G3vAgwA1KaGsOeWFeIAAAAASUVORK5CYII="

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAY1JREFUeNrs1j8sA1EcwPEWSYX4E8QoJAYVo4pFR6aGpFYkLBaDSBiIxSBGo4jEIrEoC5OEtCaNpVsXtdBoo8SfoYOc74uf5Lz02ntpicEv+SR39/71vd+7d/ValuX56ajy/EL82UG20GTUQuXEwI71Gccm7UwGmLS+x2KlBxmyCke4UoN04MlhkHf0lurDTeLzGEZYez6DAJ4rmfhObRb9btuabOF27b6t3PckhBiCtmc+rU6d7dqPKKYKdVaj3au1X5BffYqUrSyHuFx7kbaVZXCOOUxjExGnnHxFDPWGL6pyYOvDMSdqJ80iiXskMFFiycdkhm9yr5YsW2x3qeiWaz/28IgbrKNRyqqxjCReZAYDUtaA12Ivo4oe7ZkPS7hGFnHc4RZraNbqtyJfapArDDqseQiHco4VKu/DmZ4TvVIAJ7IEiSKd6dQZdintLhB0c3Z1YVvOrBw20KLVqcUK0pKDfZmJ8QGp8jGPFB5whFHsIiO5WbVtiLK/JyOI2pI/7rat9//fikl8CDAAF/cvc+IvZggAAAAASUVORK5CYII="

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAi1JREFUeNrc1s1LVFEYx/GuL2WDqaMiBkmkhhVovhAFMkRiEbRKWwSCbhJJCNq40T9AcCmMG12IItomCsra1Cp8wyIxIxRfcGFqSRLOjFQ0fQ/8kGE6zr1Ebrzw4d65h3uee5/znHPGiUajRw76cA59kHNo1dlBss6O2nfxS9c/MI4gwl6DtOEh3uMNJrGILXVojnTk4jwu4wpO6tlnf0UxQeKYo8ty380Utm1tti9ZwBK+yUesYRsRJOEospGHQqWxSmkNeEnXO9xHCa6iWB2ajlM1FibYDlawihcoQotS55quBZRY7qfiBHxwLO3NmLGlK8VSDD7Y7v+UfSsVx6wtlshr2EInAvAnGOx83EQQYbz2OvCmZCdUmqfwW/Uf0fwwb5ym8Tlu3hNzCCEHN7wM/KIqxVRTBi5oUmYrHVEF3MAHVZ95kUb0WlNm+bxPKP2HeZKBaltbkmWYspDpcVkqx7DKfgAFXpeVZeX7FV6qg3mlKfZoQj8eYUwvd0fzqSxmCbIGmUKf3rJC5RxS+Zovf44hrOM2nsQ9/1191CYak2UUxPzOwSXUoQkXMYzpuOcqsYRbOu+12YJ8Rp7LIJtO2pCOblzTwhpU+6hbkBUM4nSCIJMY0PWcArTHTeiEk/EsepCv/H7FF63IYV2bRfEp/JpPZl691fMjqNEK7br9nsF1TUS/JlmKgppdsxsPUI/HKEU77qq6Zv/XHt+BezHb8iYatCcdwn8rfwQYABGks0i/KoQGAAAAAElFTkSuQmCC"

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAYxJREFUeNrs1c0rxEEYwPH9seudpBzQKi5e9qDk4u0vIGflqLi5ODk4KX8AB4qyV+VCibMDN7kpW6IoDt5f2qWM7+T5bWNM7fJbLnbq0/6aneb5zfM8s+sppUK/PQpCfzDyQX4cZAo3UDnwhBl/47ARpAPVGIMX4MXfsIBuV5AivGIpBxkaR4UryAsiWEdjgAB3aMGOqyZrks8hFAYQQyU20zvrG29IIW7NfVen+hhRfy5sHdWT4vtDP9ci4UhLv9RRGVk5k1OEjM8vQfRxz+V5GcMox7G0ZNxY14UyK8g+7o0XdgZJ4RHTGDXmm7GCS2xJm17JfTCDPLguuD2hNxnEpDW/Kp/zxlsWo8QScbWbfZJn1KFUTrWNPfTJ91HjwlXJOrOe+m5cZwqi83+CJtlE93qNnE6PQ2NtQgpvjgup0+dhtV8Ss5hQ7tGTRQsPyNqYP2fXROe5HnNS+AOcYgOt2M3ixt/aWbLTpVPQhhEcYVHuim7hBvRm+PHUtWqXLkumi5X/j/+fQd4FGABlj/ThkXgtaAAAAABJRU5ErkJggg=="

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAklJREFUeNrs1ktIVFEcx3FnaiSkdAQjMSS1hiKTAgmiF0RRCyGX9oIKEnvhQldBRpsWEQUpJSREkLSplUZqKwUXhQsjekgqQYUVlmVYWJm374nfidN4uGNB0qIDH+bOvf97zzn/8z93JhIEQdrfbtG0GWgz0slsz7nF2IpMZGEJ4niPfoziLXpw/086OY0SZCMDs5CDBbr+BRN4hxuoxRwnI+P4GtZJrx5+BwnNwLanuK0BBPqM6bgZmxV3BFenTMVUFy5iDGeDqa0GUWxUrHENH3Xc7cQedmJ+stPcg8vY4UmpWYtJXXuIBjzHY13/4MSOh61JVLnO0vd9WIajqEAnzuAQlium43dLuFUPa9b3hTiGeTiJESxNujdhMz7d6tqp6W9AC05hPV5iEHuxWh0OanD9uvez87xXYZ3swkrUYRXuYYsqyLZ0laeJG8JcVVWhE7PJ6TQmrRG9u0xqqjR6c2INCpCHfJV2Pdq06LnTXI7jP7LilNoJleF1rEMeFqFQip3Y4SB1q7fx9qbzSCAfvU7gBPpwFwM6ZwcwGdJBi2+fmF36BPtRqqoqRyNe6PVi1uGK1mZIqfU185ztvh1v0pGD1xpJO3ajAHFkIFMzOICbiKEqaQZjiv9lx9uDJjToeBsepMj3G8xX/AXnfKnvtWKrK66yNWk6qM0ZqLpydf4ThvFMZVqNYlRq9xvnfPmLJP38XtJNpj1CFwb0G2Je6UVYqxI37RbKUhayZ3om73XowTdPqvr0tl7hS01Yuv7/kfh3OvkuwABilmr/oucnsQAAAABJRU5ErkJggg=="

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAbBJREFUeNrE1s0rBGEcwHFjtxYrbxeiJXkrd0nyB0g4uEg5KRc5uCgn+ReUixwkLhIHHJQo5Wrbtr2I2IOl3YPsajctO76Tn0zbvDw7kl99mmfneZ559nme3zyNput62V9HeYntJ3GAQ8wq9zJmoiCImP4Vd7iRchKtbv1VZ/IEH1rQjk7UIoI46n47k10UHOqNmUWdnuE2QECWZcShTZu0CXldrkHkcOzQxliuFMa9ZlcjMgp7lkaD10EeUK0wSBBJu0q/xb0AxhCS5arCEvLQivNGrk2YlrYJnODZKbv29J9IIIIcsnI1ywoju+LIS79Tt+wyOp8pvqRWtpF2y643XP7iqDrHi9vGv8vb7DXqUSj1gKzBKrYwZLrfjx0pb2DYawobmXaFecmeC3RInXFeTUl5pugPuKawOfpMD/2OfWxiQH4vyDXldZBbi3vNWEYWYawgKmVPgzxiFGuSDOtYLDUT/Db79Gr6fST8knlukTGdBLYbX4lum9RWiR5JY8eZGGs7gXuZkU/x4R+okESJmSs0i6+VLsyhV2aq+jmjSdtreW/CToP8+yeRp/gUYAD2Gdn9RnpT3AAAAABJRU5ErkJggg=="

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAU5JREFUeNpi/P//PwOtARMDHQBdLGEhRtH06dN1gVQYEBshCR8H4i2ZmZkXCOlnJBQnQAvcgFQ+lPsSiN8BsTgQC0HF1gItmke2JUALZIDUTCD+A8RVQMOuIslZAKlaKHcKUG47uXGSCaVzkS0AS2RmngBSBVBuDtBSIZItAWpiA1IGQHwDaOAjrC7IzLwNpHZAua7kRLwklD5PwLeLgBgUrA/IsYQHSn/AG56ZmR+BVDm5+eQLlP5OaT7BmrqA8eEIpEBJVw+IPwHxQ3xmAPF/aNK+DvTZZmKDC5QvWKG+4QJiXSIdbQ/ERFsCEgeFdTIQ/4C6Fhf4D1XfB8RKpEQ8yNCPQK9/RzIIH/gNDOJnuCxhorRcQwIcw7+ox2fJPxLN+kuOJawkWsJKTuSKA1NMKwlJ2IhUS/YAsQ20FCYWgOqcS2TVjKOtFWQAEGAAVjBf9ENnmGgAAAAASUVORK5CYII="

/***/ }),
/* 987 */,
/* 988 */,
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(941)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(1136),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(911)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(1105),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(891)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(1084),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(952)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(1149),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(951)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(1148),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(886)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(1078),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(914)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(1108),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(1070),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(896)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(1090),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(1116),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(894)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1087),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ab98bfe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(928)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(1123),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-69dbaf81",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(905)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(1099),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d6ad1fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(884)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(1075),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16fac089",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(922)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(1117),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61418286",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(897)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(1091),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31db775a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(908)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(1102),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-41665074",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(876)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(1066),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03654156",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(887)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(1079),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a10dbfa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(950)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(1147),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f2cb3ac4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(901)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(1095),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35c739ff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(943)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(1139),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d781ca40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(934)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(1129),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8e1189a2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(910)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(1104),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42c2b95d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(932)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(1127),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-741d1116",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(898)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(1092),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-330601b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(909)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(1103),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-424474f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(921)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(1115),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ffc5a55",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(895)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(1089),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ff851bb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(883)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(1074),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1629b70e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(933)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(1128),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-809f6a40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(877)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(1067),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-055df168",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(878)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(1068),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08d221a1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(920)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1114),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5b6c7fd8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(940)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(1135),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bafd98c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(879)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(1069),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0adb3a50",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(935)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1130),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-905e0842",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(918)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(1112),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-546bb34a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(936)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(1131),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-91aa6494",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(880)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(1071),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0e492d14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(942)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1138),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cf3b81c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(881)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(1072),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1124d3b0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(948)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(1145),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ea5fda40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(938)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(1133),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(904)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1098),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-39ebcd22",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(954)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(1151),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fcc1721e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(893)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1086),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a846c86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(900)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1094),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34306e10",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(885)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1076),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-177303ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(906)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1100),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d98b93a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(937)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1132),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a921d99c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(889)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1081),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1dc68c8c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1143),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(924)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1119),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61ba6476",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(916)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1110),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-512e6994",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(931)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1126),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73e1d190",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(946)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1142),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e14cd114",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1137),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1088),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(919)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1113),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(890)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1082),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-205111da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(949)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(1146),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ec6d1722",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(903)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1097),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36d135fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(923)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1118),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61ab8cc5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(915)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1109),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4aa490c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(947)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1144),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e64e8664",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(929)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1124),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a61e33a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(1083),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(939)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1134),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(925)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1120),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-631baef6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(927)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(1122),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67389e88",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(912)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1106),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(892)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1085),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-26a0ff51",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(875)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1065),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1125),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6fedf468",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(945)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(1141),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "routerView"
  }, [_c('mheader', {
    ref: "mheader"
  }), _vm._v(" "), _c('div', {
    staticClass: "mat"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('sidebar'), _vm._v(" "), _c('router-view', {
    staticClass: "content-wrapper clearfix"
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.auditTrailLan.indexText))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "link": _vm.link,
      "back": _vm.back,
      "page": _vm.page,
      "selPage": _vm.selPage,
      "multiLanguage": _vm.auditTrailLan,
      "downLoadTran": _vm.downLoadTran,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "name": _vm.name
    },
    on: {
      "tableChange": _vm.tableAjax
    }
  }, [_c('div', {
    staticClass: "slotDiv",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "selectDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.auditTrailLan.type))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    on: {
      "change": _vm.searchDatas
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  }, _vm._l((_vm.auditTrailLan.category), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "inputDiv"
  }, [_c('div', {
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.auditTrailLan.account))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.account),
      callback: function($$v) {
        _vm.account = $$v
      },
      expression: "account"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.auditTrailLan.start_time))]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": _vm.auditTrailLan.selectTimeText
    },
    model: {
      value: (_vm.start_time),
      callback: function($$v) {
        _vm.start_time = $$v
      },
      expression: "start_time"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.auditTrailLan.end_time))]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": _vm.auditTrailLan.selectTimeText
    },
    model: {
      value: (_vm.end_time),
      callback: function($$v) {
        _vm.end_time = $$v
      },
      expression: "end_time"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btnDiv"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.start_time || !_vm.end_time
    },
    on: {
      "click": _vm.searchDatas
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.auditTrailLan.search) + "\n                            ")])], 1)])])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibCommission-box"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("\n      " + _vm._s(_vm.ibCommissionLan.ibAccount) + " : " + _vm._s(_vm.$route.query.id) + "    " + _vm._s(_vm.ibCommissionLan.ibcAccount) + " : " + _vm._s(_vm.$route.query.ibc) + "\n      "), (_vm.showPreview) ? _c('span', [_vm._v(" - " + _vm._s(_vm.ibCommissionLan.btnGroup.commissionPreviewBtn))]) : _vm._e()]), _vm._v(" "), (!_vm.showPreview) ? _c('div', {
    staticClass: "pull-right viewBtn-box"
  }, [_c('button', {
    staticClass: "double",
    on: {
      "click": function($event) {
        _vm.viewBtn = 'double'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.ibCommissionLan.contrastBrowse) + "\n      ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.viewBtn = 'onlyOne'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.ibCommissionLan.singlepageBrowse) + "\n      ")])]) : _vm._e(), _vm._v(" "), (!_vm.showPreview) ? _c('button', {
    staticClass: "pull-right preview-btn",
    on: {
      "click": function($event) {
        _vm.showPreview = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.ibCommissionLan.btnGroup.commissionPreviewBtn) + "\n    ")]) : _c('button', {
    staticClass: "pull-right preview-btn",
    on: {
      "click": function($event) {
        _vm.showPreview = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.ibCommissionLan.btnGroup.back) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (_vm.showPreview) ? _c('ib-commission-preview', {
    attrs: {
      "region": _vm.$route.query.region,
      "ibCommissionLan": _vm.ibCommissionLan
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showPreview) ? _c('div', {
    staticClass: "content-box"
  }, [(_vm.viewBtn == 'double') ? _c('div', {
    staticClass: "version0",
    class: {
      'doubleView margin-right': _vm.viewBtn === 'double'
    }
  }, [_c('ib-commission-setting-content', {
    ref: "version0",
    attrs: {
      "multiLanguage": _vm.ibCommissionLan,
      "version": '0',
      "curArea": _vm.curArea,
      "viewBtn": _vm.viewBtn
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "version1",
    class: {
      'doubleView': _vm.viewBtn === 'double'
    }
  }, [_c('ib-commission-setting-content', {
    ref: "version1",
    attrs: {
      "multiLanguage": _vm.ibCommissionLan,
      "version": '1',
      "viewBtn": _vm.viewBtn,
      "curArea": _vm.curArea
    },
    on: {
      "afterVerify": _vm.afterVerifyFn
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commissionDatum"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commission.enable),
      expression: "commission.enable"
    }],
    staticClass: "enable-btn",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.version == '0'
    },
    domProps: {
      "checked": Array.isArray(_vm.commission.enable) ? _vm._i(_vm.commission.enable, null) > -1 : (_vm.commission.enable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.commission.enable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.commission, "enable", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.commission, "enable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.commission, "enable", $$c)
        }
      }
    }
  }), _vm._v(" \n        "), _c('span', {
    staticClass: "enable-text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.enable))])]), _vm._v(" "), _c('span', {
    staticClass: "table-title"
  }, [_vm._v(_vm._s(_vm.multiLanguage.ibCommissionSetting) + " "), (_vm.version == '1') ? _c('span', [_vm._v("(" + _vm._s(_vm.commission.isConfirm ? _vm.multiLanguage.confirmed : _vm.multiLanguage.unconfirmed) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.templateLang) ? _c('div', {
    staticClass: "template-box"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.templateName) + ": ")]), _vm._v(" "), _c('span', {
    staticClass: "enable-text"
  }, [_vm._v(_vm._s(_vm.templateLang))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-box pull-right"
  }, [(_vm.version == '1') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.verify
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-ok"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.check) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.version == '1') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.submit
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-edit"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.submit) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.version == '1') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.pageInit('0')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-repeat"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.backData) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commission.isSpecial),
      expression: "commission.isSpecial"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.commission.isSpecial) ? _vm._i(_vm.commission.isSpecial, null) > -1 : (_vm.commission.isSpecial)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.commission.isSpecial,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.commission, "isSpecial", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.commission, "isSpecial", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.commission, "isSpecial", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#F08712",
      "font-weight": "700",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.specialCommission))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "last-update-box"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.multiLanguage.updateBy) + " : " + _vm._s(_vm.commission.updateBy) + " "), (_vm.commission.lastUpdate) ? _c('span', [_vm._v("(" + _vm._s(_vm.commission.lastUpdate) + ")")]) : _vm._e()]), _vm._v(" "), (true) ? _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.confirmBy) + " : " + _vm._s(_vm.commission.confirmBy) + " "), (_vm.commission.lastConfirm) ? _c('span', [_vm._v("(" + _vm._s(_vm.commission.lastConfirm) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "cpa-switch-box"
  }, [_c('div', {
    staticClass: "cpa-switch pull-left"
  }, [_c('btn', {
    staticClass: "internal",
    class: {
      'active': _vm.mode == 0 && _vm.commission.enable
    },
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": function($event) {
        _vm.mode = 0
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.multiLanguage.commonCaculation) + "\n        ")]), _vm._v(" "), (_vm.commission.cpa !== 'not exist') ? _c('btn', {
    staticClass: "CPA",
    class: {
      'active': _vm.mode == 1 && _vm.commission.enable
    },
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": function($event) {
        _vm.mode = 1
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.multiLanguage.CPACaculation) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.commission.cpa !== 'not exist') ? _c('btn', {
    staticClass: "internalAndCPA",
    class: {
      'active': _vm.mode == 2 && _vm.commission.enable
    },
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": function($event) {
        _vm.mode = 2
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.multiLanguage.comAndCPA) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "preinstall-box pull-right",
    style: (_vm.version == '0' ? 'visibility:hidden;' : '')
  }, [_c('Dropdown', {
    attrs: {
      "menu-right": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "data-role": "trigger",
      "type": "button",
      "disabled": !_vm.commission.enable || _vm.version == '0'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.SettingTemplate))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, _vm._l((_vm.ibTemplate), function(item, index) {
    return (item.isDisplay) ? _c('li', {
      on: {
        "click": function($event) {
          return _vm.normSetFn(item.templateId, 'ib')
        }
      }
    }, [_c('a', [_vm._v(_vm._s(_vm.multiLanguage[item.langKey] || item.templateId))])]) : _vm._e()
  }), 0)], 2), _vm._v(" "), (_vm.commission.cpa !== 'not exist') ? _c('Dropdown', {
    attrs: {
      "menu-right": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "data-role": "trigger",
      "type": "button",
      "disabled": !_vm.commission.enable || _vm.version == '0'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.cpa_SettingTemplate))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, _vm._l((_vm.cpaTemplate), function(item, index) {
    return (item.isDisplay) ? _c('li', {
      on: {
        "click": function($event) {
          return _vm.normSetFn(item.templateId, 'cpa')
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(_vm.multiLanguage[item.langKey]))])]) : _vm._e()
  }), 0)], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (_vm.mode == 0 || _vm.mode == 2) ? _c('internal-commission', {
    ref: "internalCommission",
    attrs: {
      "commission": _vm.commission,
      "groupSeq": _vm.groupSeq,
      "multiLanguage": _vm.multiLanguage,
      "version": _vm.version,
      "viewBtn": _vm.viewBtn
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mode == 1 || _vm.mode == 2) ? _c('cpa-commission', {
    ref: "cpaCommission",
    style: (_vm.mode == '2' ? 'margin-top:10px' : ''),
    attrs: {
      "commission": _vm.commission,
      "multiLanguage": _vm.multiLanguage,
      "version": _vm.version,
      "viewBtn": _vm.viewBtn
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "expired-box"
  }, [_c('div', {
    staticClass: "pull-left ReminderDate"
  }, [_c('h4', [_vm._v(_vm._s(_vm.multiLanguage.reminderDate))]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "disabled": !_vm.commission.enable || _vm.version == '0',
      "placeholder": _vm.multiLanguage.choiceDateTime
    },
    on: {
      "change": function($event) {
        _vm.timeIsChange = true
      }
    },
    model: {
      value: (_vm.commission.ReminderDate),
      callback: function($$v) {
        _vm.$set(_vm.commission, "ReminderDate", $$v)
      },
      expression: "commission.ReminderDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right ReminderMsg"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.multiLanguage.reminderMsg))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.commission.sendEml),
      expression: "commission.sendEml"
    }],
    staticClass: "pull-left text-success send-eml"
  }, [_vm._v(_vm._s(_vm.multiLanguage.sented))]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "disabled": !_vm.commission.enable || _vm.version == '0',
      "placeholder": _vm.multiLanguage.reminderMsgPlaceholder
    },
    on: {
      "change": function($event) {
        _vm.timeIsChange = true
      }
    },
    model: {
      value: (_vm.commission.ReminderMsg),
      callback: function($$v) {
        _vm.$set(_vm.commission, "ReminderMsg", $$v)
      },
      expression: "commission.ReminderMsg"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commission.enableUpperCalc),
      expression: "commission.enableUpperCalc"
    }],
    staticClass: "enable-btn",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.version == '0'
    },
    domProps: {
      "checked": Array.isArray(_vm.commission.enableUpperCalc) ? _vm._i(_vm.commission.enableUpperCalc, null) > -1 : (_vm.commission.enableUpperCalc)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.commission.enableUpperCalc,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.commission, "enableUpperCalc", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.commission, "enableUpperCalc", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.commission, "enableUpperCalc", $$c)
        }
      }
    }
  }), _vm._v(" \n      "), _c('span', {
    staticClass: "enable-text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.enable))])]), _vm._v(" "), _c('span', {
    staticClass: "table-title"
  }, [_vm._v(_vm._s(_vm.multiLanguage.upperCommissiondistribution))])]), _vm._v(" "), _c('div', [_c('rule-setting', {
    ref: "ruleSetting",
    attrs: {
      "enableUpperCalc": _vm.commission.enableUpperCalc,
      "multiLanguage": _vm.multiLanguage,
      "groupSeq": _vm.groupSeq,
      "version": _vm.version,
      "relation": _vm.relation,
      "currentIB": _vm.currentIB,
      "rule": _vm.rule,
      "ruleSeq": _vm.ruleSeq,
      "viewBtn": _vm.viewBtn
    },
    on: {
      "checkId": _vm.checkIdFn
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "size": "sm",
      "header": false,
      "footer": false
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sucSave),
      expression: "!sucSave"
    }]
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-warning-sign color-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v(_vm._s(_vm.multiLanguage.submitResult.err))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sucSave),
      expression: "sucSave"
    }]
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-ok color-green"
  }), _vm._v(" "), _c('span', {
    staticClass: "color-green"
  }, [_vm._v(_vm._s(_vm.multiLanguage.submitResult.succeed))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ruleSetting-box"
  }, [_c('div', {
    staticClass: "ruleLevel-btn-box",
    style: (_vm.version == '0' ? 'visibility:hidden;' : '')
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-style-add",
    attrs: {
      "disabled": !_vm.enableUpperCalc || _vm.version == '0'
    },
    on: {
      "click": _vm.addLevel
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.addLevel) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-style-remove",
    attrs: {
      "disabled": !_vm.enableUpperCalc || _vm.version == '0'
    },
    on: {
      "click": _vm.removeLevel
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-trash"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.removeLevel) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('draggable', {
    attrs: {
      "list": _vm.rule,
      "options": {
        group: 'levelGroup',
        disabled: _vm.onfocus
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": 'flip-list'
    }
  }, _vm._l((_vm.rule), function(levelItem, levelIndex) {
    return _c('div', {
      key: levelIndex,
      staticClass: "rule-content-box panel panel-default",
      class: {
        'disabled': !_vm.enableUpperCalc || _vm.version == '0'
      }
    }, [_c('div', {
      staticClass: "panel-heading title-bg"
    }, [_c('div', {
      staticClass: "panel-title"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('label', [(levelIndex !== _vm.rule.length - 1) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedLevel),
        expression: "checkedLevel"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.enableUpperCalc || _vm.version == '0'
      },
      domProps: {
        "value": levelIndex,
        "checked": Array.isArray(_vm.checkedLevel) ? _vm._i(_vm.checkedLevel, levelIndex) > -1 : (_vm.checkedLevel)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedLevel,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = levelIndex,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedLevel = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedLevel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedLevel = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "primary-color"
    }, [_vm._v("\n                  " + _vm._s(levelIndex == _vm.rule.length - 1 ? _vm.ruleSettingLan.currentIB : levelIndex + 1 + _vm.ruleSettingLan.levelIB) + "\n                  "), (levelIndex == _vm.rule.length - 1) ? _c('span', [_vm._v("\n                    (" + _vm._s(_vm.currentIB.id + '-' + _vm.currentIB.name + '-' + _vm.currentIB.ibc) + ")\n                  ")]) : _c('span', [_vm._v("\n                    (" + _vm._s(_vm.relation[levelIndex] ? _vm.relation[levelIndex].id + '-' + _vm.relation[levelIndex].name + '-' + _vm.relation[levelIndex].ibc : _vm.ruleSettingLan.notExist) + ")\n                  ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "pull-right",
      style: (_vm.version == '0' ? 'visibility:hidden;' : '')
    }, [_c('button', {
      staticClass: "btn btn-style-add",
      attrs: {
        "disabled": !_vm.enableUpperCalc || _vm.version == '0'
      },
      on: {
        "click": function($event) {
          return _vm.addRule(levelItem)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-plus"
    }), _vm._v("\n                " + _vm._s(_vm.ruleSettingLan.addRule) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])]), _vm._v(" "), _c('draggable', {
      attrs: {
        "list": levelItem,
        "options": {
          group: 'ruleGroup',
          disabled: _vm.onfocus
        }
      }
    }, [_c('transition-group', {
      attrs: {
        "type": "transition",
        "name": 'flip-list'
      }
    }, _vm._l((levelItem), function(ruleItem, ruleIndex) {
      return _c('div', {
        key: ruleIndex,
        staticClass: "panel-body"
      }, [_c('div', {
        staticClass: "rule-title"
      }, [_c('div', {
        staticClass: "pull-left primary-color"
      }, [_vm._v(_vm._s(_vm.ruleSettingLan.rule) + _vm._s(ruleIndex + 1))]), _vm._v(" "), _c('div', {
        staticClass: "pull-right",
        style: (_vm.version == '0' ? 'visibility:hidden;' : '')
      }, [_c('button', {
        staticClass: "btn btn-xs",
        attrs: {
          "disabled": !_vm.enableUpperCalc || _vm.version == '0'
        },
        on: {
          "click": function($event) {
            return _vm.removeRule(levelItem, ruleIndex)
          }
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-trash"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "clear"
      })]), _vm._v(" "), _c('div', {
        staticClass: "rule-content"
      }, [_c('div', {
        staticClass: "form-horizontal"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "col-sm-1 control-label"
      }, [_vm._v("\n                      " + _vm._s(_vm.ruleSettingLan.product) + "\n                    ")]), _vm._v(" "), _c('div', {
        class: {
          'col-sm-11': _vm.viewBtn == 'double',
          'col-sm-5': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.productGroup),
          expression: "ruleItem.productGroup"
        }],
        staticClass: "form-control",
        attrs: {
          "disabled": !_vm.enableUpperCalc || _vm.version == '0'
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(ruleItem, "productGroup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "ALL"
        }
      }, [_vm._v(_vm._s(_vm.ruleSettingLan.ALL))]), _vm._v(" "), _vm._l((_vm.groupSeq), function(productItem, productIndex) {
        return _c('option', {
          key: productIndex,
          domProps: {
            "value": productItem
          }
        }, [_vm._v(_vm._s(_vm.publicLan.products[productItem]))])
      })], 2)])])]), _vm._v(" "), _c('div', {
        staticClass: "form-horizontal"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        class: {
          'col-sm-5': _vm.viewBtn == 'double',
          'col-sm-3': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.enableCommTarget),
          expression: "ruleItem.enableCommTarget"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'enableCommTarget',
          "disabled": !_vm.enableUpperCalc || _vm.version == '0'
        },
        domProps: {
          "value": false,
          "checked": _vm._q(ruleItem.enableCommTarget, false)
        },
        on: {
          "change": function($event) {
            return _vm.$set(ruleItem, "enableCommTarget", false)
          }
        }
      }), _vm._v("\n                        " + _vm._s(_vm.ruleSettingLan.toOriginalAccount) + "\n                      ")]), _vm._v(" "), _c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.enableCommTarget),
          expression: "ruleItem.enableCommTarget"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'enableCommTarget',
          "disabled": !_vm.enableUpperCalc || _vm.version == '0'
        },
        domProps: {
          "value": true,
          "checked": _vm._q(ruleItem.enableCommTarget, true)
        },
        on: {
          "change": function($event) {
            return _vm.$set(ruleItem, "enableCommTarget", true)
          }
        }
      }), _vm._v("\n                        " + _vm._s(_vm.ruleSettingLan.toTargetAccount) + "\n                      ")])]), _vm._v(" "), _c('label', {
        class: {
          'col-sm-7': _vm.viewBtn == 'double',
          'col-sm-3': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.commTarget),
          expression: "ruleItem.commTarget"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|numeric'),
          expression: "'required|numeric'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'commTarget') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || !ruleItem.enableCommTarget,
          "name": levelIndex + '_' + ruleIndex + '_' + 'commTarget'
        },
        domProps: {
          "value": (ruleItem.commTarget)
        },
        on: {
          "focus": function($event) {
            _vm.onfocus = true
          },
          "blur": function($event) {
            _vm.onfocus = false
          },
          "change": function($event) {
            !_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'commTarget') && _vm.checkId(ruleItem)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(ruleItem, "commTarget", $event.target.value)
          }
        }
      })])])]), _vm._v(" "), _c('div', {
        staticClass: "form-inline"
      }, [_c('div', {
        class: {
          'row': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "has-feedback tips-wrap margin-bottom flex-box",
        class: {
          'col-sm-6': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('label', {
        staticClass: "radio-inline flex-item-left"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.ruleGroup),
          expression: "ruleItem.ruleGroup"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'ruleId',
          "disabled": !_vm.enableUpperCalc || _vm.version == '0'
        },
        domProps: {
          "value": 0,
          "checked": _vm._q(ruleItem.ruleGroup, 0)
        },
        on: {
          "change": [function($event) {
            return _vm.$set(ruleItem, "ruleGroup", 0)
          }, function($event) {
            return _vm.selectRuleFn(ruleItem)
          }]
        }
      }), _vm._v("\n                        " + _vm._s(_vm.ruleSettingLan.ruleIdGroup[0]) + "\n                      ")]), _vm._v(" "), _c('div', {
        staticClass: "input-group flex-item-right"
      }, [_c('div', {
        staticClass: "input-group"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.ruleId),
          expression: "ruleItem.ruleId"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'ruleId') ? 'border-color:#f44336;' : ''),
        attrs: {
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 0,
          "name": levelIndex + '_' + ruleIndex + '_' + 'ruleId'
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(ruleItem, "ruleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return (ruleSeqItem.group === 0) ? _c('option', {
          key: ruleSeqIndex,
          domProps: {
            "value": ruleSeqItem.ruleId
          }
        }, [_vm._v("\n                              " + _vm._s(_vm.publicLan.rule[ruleSeqItem.langKey.split('.')[1]]) + "\n                            ")]) : _vm._e()
      }), 0), _vm._v(" "), _c('span', {
        staticClass: "input-group-addon"
      }, [_c('el-tooltip', {
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "placement": "top-start",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 0
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-tags"
      }), _vm._v(" "), _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return (ruleSeqItem.ruleId === ruleItem.ruleId) ? _c('div', {
          staticStyle: {
            "width": "180px",
            "line-height": "20px"
          },
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v("\n                                  " + _vm._s(_vm.publicLan.rule[ruleSeqItem.descLangKey.split('.')[1]]) + "\n                              ")]) : _vm._e()
      })], 2)], 1)]), _vm._v(" "), _c('div', {
        staticClass: "input-group"
      }, [(ruleItem.ruleGroup == 0) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.value),
          expression: "ruleItem.value"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|min_value:0.00|decimal:4'),
          expression: "'required|min_value:0.00|decimal:4'"
        }],
        staticClass: "form-control",
        staticStyle: {
          "border-radius": "3px"
        },
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'value1') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 0,
          "name": levelIndex + '_' + ruleIndex + '_' + 'value1'
        },
        domProps: {
          "value": (ruleItem.value)
        },
        on: {
          "focus": function($event) {
            _vm.onfocus = true
          },
          "blur": function($event) {
            _vm.onfocus = false
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(ruleItem, "value", $event.target.value)
          }
        }
      }) : _c('input', {
        staticClass: "form-control",
        staticStyle: {
          "border-radius": "3px"
        },
        attrs: {
          "type": "text",
          "disabled": ""
        }
      })])])])]), _vm._v(" "), _c('div', {
        class: {
          'row': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "has-feedback margin-bottom flex-box",
        class: {
          'col-sm-6': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('label', {
        staticClass: "radio-inline flex-item-left"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.ruleGroup),
          expression: "ruleItem.ruleGroup"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'ruleId',
          "disabled": !_vm.enableUpperCalc || _vm.version == '0'
        },
        domProps: {
          "value": 1,
          "checked": _vm._q(ruleItem.ruleGroup, 1)
        },
        on: {
          "change": [function($event) {
            return _vm.$set(ruleItem, "ruleGroup", 1)
          }, function($event) {
            return _vm.selectRuleFn(ruleItem)
          }]
        }
      }), _vm._v("\n                        " + _vm._s(_vm.ruleSettingLan.ruleIdGroup[1]) + "\n                      ")]), _vm._v(" "), _c('div', {
        staticClass: "input-group flex-item-right"
      }, [_c('div', {
        staticClass: "input-group"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.ruleId),
          expression: "ruleItem.ruleId"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'ruleId') ? 'border-color:#f44336;' : ''),
        attrs: {
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 1,
          "name": levelIndex + '_' + ruleIndex + '_' + 'ruleId'
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(ruleItem, "ruleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.selectRule6Fn(ruleItem)
          }]
        }
      }, _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return (ruleSeqItem.group == 1) ? _c('option', {
          key: ruleSeqIndex,
          domProps: {
            "value": ruleSeqItem.ruleId
          }
        }, [_vm._v("\n                              " + _vm._s(_vm.publicLan.rule[ruleSeqItem.langKey.split('.')[1]]) + "\n                            ")]) : _vm._e()
      }), 0), _vm._v(" "), _c('span', {
        staticClass: "input-group-addon"
      }, [_c('el-tooltip', {
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "placement": "top-start",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 1
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-tags"
      }), _vm._v(" "), _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return (ruleSeqItem.ruleId === ruleItem.ruleId) ? _c('div', {
          staticStyle: {
            "width": "180px",
            "line-height": "20px"
          },
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v("\n                                  " + _vm._s(_vm.publicLan.rule[ruleSeqItem.descLangKey.split('.')[1]]) + "\n                              ")]) : _vm._e()
      })], 2)], 1)]), _vm._v(" "), _c('div', {
        staticClass: "input-group"
      }, [(ruleItem.ruleGroup == 1 && ruleItem.ruleId != 6) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.value),
          expression: "ruleItem.value"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|min_value:0.00|decimal:4'),
          expression: "'required|min_value:0.00|decimal:4'"
        }],
        staticClass: "form-control",
        staticStyle: {
          "border-radius": "3px"
        },
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'value2') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 1,
          "name": levelIndex + '_' + ruleIndex + '_' + 'value2'
        },
        domProps: {
          "value": (ruleItem.value)
        },
        on: {
          "focus": function($event) {
            _vm.onfocus = true
          },
          "blur": function($event) {
            _vm.onfocus = false
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(ruleItem, "value", $event.target.value)
          }
        }
      }) : _c('input', {
        staticClass: "form-control",
        staticStyle: {
          "border-radius": "3px"
        },
        attrs: {
          "type": "text",
          "disabled": ""
        }
      })])])])]), _vm._v(" "), _c('div', {
        class: {
          'row': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "has-feedback margin-bottom",
        class: {
          'col-sm-6': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('label', {
        staticClass: "radio-inline",
        staticStyle: {
          "padding-left": "0"
        },
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'spreadEnable') ? 'color:#f44336;' : '')
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.spreadEnable),
          expression: "ruleItem.spreadEnable"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: (!ruleItem.externalCommissionEnable && !ruleItem.internalCommissionEnable ? 'required:true' : ''),
          expression: "!ruleItem.externalCommissionEnable && !ruleItem.internalCommissionEnable ? 'required:true' : ''"
        }],
        attrs: {
          "type": "checkbox",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 0,
          "name": levelIndex + '_' + ruleIndex + '_' + 'spreadEnable'
        },
        domProps: {
          "checked": Array.isArray(ruleItem.spreadEnable) ? _vm._i(ruleItem.spreadEnable, null) > -1 : (ruleItem.spreadEnable)
        },
        on: {
          "change": function($event) {
            var $$a = ruleItem.spreadEnable,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ruleItem, "spreadEnable", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ruleItem, "spreadEnable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ruleItem, "spreadEnable", $$c)
            }
          }
        }
      }), _vm._v("\n                        " + _vm._s(_vm.ruleSettingLan.spreadCommission) + "\n                      ")]), _vm._v(" "), _c('label', {
        staticClass: "radio-inline",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'externalCommissionEnable') ? 'color:#f44336;' : '')
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.externalCommissionEnable),
          expression: "ruleItem.externalCommissionEnable"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: (!ruleItem.spreadEnable && !ruleItem.internalCommissionEnable ? 'required:true' : ''),
          expression: "!ruleItem.spreadEnable && !ruleItem.internalCommissionEnable ? 'required:true' : ''"
        }],
        attrs: {
          "type": "checkbox",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 0,
          "name": levelIndex + '_' + ruleIndex + '_' + 'externalCommissionEnable'
        },
        domProps: {
          "checked": Array.isArray(ruleItem.externalCommissionEnable) ? _vm._i(ruleItem.externalCommissionEnable, null) > -1 : (ruleItem.externalCommissionEnable)
        },
        on: {
          "change": function($event) {
            var $$a = ruleItem.externalCommissionEnable,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ruleItem, "externalCommissionEnable", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ruleItem, "externalCommissionEnable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ruleItem, "externalCommissionEnable", $$c)
            }
          }
        }
      }), _vm._v("\n                        " + _vm._s(_vm.ruleSettingLan.externalCommission) + "\n                      ")]), _vm._v(" "), _c('label', {
        staticClass: "radio-inline",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'internalCommissionEnable') ? 'color:#f44336;' : '')
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.internalCommissionEnable),
          expression: "ruleItem.internalCommissionEnable"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: (!ruleItem.externalCommissionEnable && !ruleItem.spreadEnable ? 'required:true' : ''),
          expression: "!ruleItem.externalCommissionEnable && !ruleItem.spreadEnable ? 'required:true' : ''"
        }],
        attrs: {
          "type": "checkbox",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 0,
          "name": levelIndex + '_' + ruleIndex + '_' + 'internalCommissionEnable'
        },
        domProps: {
          "checked": Array.isArray(ruleItem.internalCommissionEnable) ? _vm._i(ruleItem.internalCommissionEnable, null) > -1 : (ruleItem.internalCommissionEnable)
        },
        on: {
          "change": function($event) {
            var $$a = ruleItem.internalCommissionEnable,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ruleItem, "internalCommissionEnable", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ruleItem, "internalCommissionEnable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ruleItem, "internalCommissionEnable", $$c)
            }
          }
        }
      }), _vm._v("\n                        " + _vm._s(_vm.ruleSettingLan.internalCommission) + "\n                      ")])])])])])])
    }), 0)], 1)], 1)
  }), 0)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.id_name
    },
    on: {
      "click": _vm.generate_excel
    }
  }, [_vm._t("default", function() {
    return [_vm._v("\n    " + _vm._s(_vm.button_text) + _vm._s(_vm.ajaxGetKey) + "\n  ")]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ruleSetting-box"
  }, [_c('div', {
    staticClass: "ruleLevel-btn-box",
    style: (_vm.version == '0' ? 'visibility:hidden;' : '')
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-style-add",
    attrs: {
      "disabled": !_vm.enableUpperCalc || _vm.version == '0'
    },
    on: {
      "click": _vm.addLevel
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.addLevel) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-style-remove",
    attrs: {
      "disabled": !_vm.enableUpperCalc || _vm.version == '0'
    },
    on: {
      "click": _vm.removeLevel
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-trash"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.removeLevel) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('draggable', {
    attrs: {
      "list": _vm.rule,
      "options": {
        group: 'levelGroup',
        disabled: _vm.onfocus
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": 'flip-list'
    }
  }, _vm._l((_vm.rule), function(levelItem, levelIndex) {
    return _c('div', {
      key: levelIndex + levelItem,
      staticClass: "rule-content-box panel panel-default",
      class: {
        'disabled': !_vm.enableUpperCalc || _vm.version == '0'
      }
    }, [_c('div', {
      staticClass: "panel-heading title-bg"
    }, [_c('div', {
      staticClass: "panel-title"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('label', [(levelIndex !== _vm.rule.length - 1) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedLevel),
        expression: "checkedLevel"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.enableUpperCalc || _vm.version == '0'
      },
      domProps: {
        "value": levelIndex,
        "checked": Array.isArray(_vm.checkedLevel) ? _vm._i(_vm.checkedLevel, levelIndex) > -1 : (_vm.checkedLevel)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedLevel,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = levelIndex,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedLevel = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedLevel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedLevel = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "primary-color"
    }, [_vm._v("\n                  " + _vm._s(levelIndex == _vm.rule.length - 1 ? _vm.ruleSettingLan.currentIB : levelIndex + 1 + _vm.ruleSettingLan.levelIB) + "\n                  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "pull-right",
      style: (_vm.version == '0' ? 'visibility:hidden;' : '')
    }, [_c('button', {
      staticClass: "btn btn-style-add",
      attrs: {
        "disabled": !_vm.enableUpperCalc || _vm.version == '0'
      },
      on: {
        "click": function($event) {
          return _vm.addRule(levelItem)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-plus"
    }), _vm._v("\n                " + _vm._s(_vm.ruleSettingLan.addRule) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])]), _vm._v(" "), _c('draggable', {
      attrs: {
        "list": levelItem,
        "options": {
          group: 'ruleGroup',
          disabled: _vm.onfocus
        }
      }
    }, [_c('transition-group', {
      attrs: {
        "type": "transition",
        "name": 'flip-list'
      }
    }, _vm._l((levelItem), function(ruleItem, ruleIndex) {
      return _c('div', {
        key: ruleIndex + ruleItem,
        staticClass: "panel-body"
      }, [_c('div', {
        staticClass: "rule-title"
      }, [_c('div', {
        staticClass: "pull-left primary-color"
      }, [_vm._v(_vm._s(_vm.ruleSettingLan.rule) + _vm._s(ruleIndex + 1))]), _vm._v(" "), _c('div', {
        staticClass: "pull-right",
        style: (_vm.version == '0' ? 'visibility:hidden;' : '')
      }, [_c('button', {
        staticClass: "btn btn-xs",
        attrs: {
          "disabled": !_vm.enableUpperCalc || _vm.version == '0'
        },
        on: {
          "click": function($event) {
            return _vm.removeRule(levelItem, ruleIndex)
          }
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-trash"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "clear"
      })]), _vm._v(" "), _c('div', {
        staticClass: "rule-content"
      }, [_c('div', {
        staticClass: "form-horizontal"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "col-sm-1 control-label"
      }, [_vm._v("\n                      " + _vm._s(_vm.ruleSettingLan.product) + "\n                    ")]), _vm._v(" "), _c('div', {
        class: {
          'col-sm-11': _vm.viewBtn == 'double',
          'col-sm-5': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.productGroup),
          expression: "ruleItem.productGroup"
        }],
        staticClass: "form-control",
        attrs: {
          "disabled": !_vm.enableUpperCalc || _vm.version == '0'
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(ruleItem, "productGroup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "ALL"
        }
      }, [_vm._v(_vm._s(_vm.ruleSettingLan.ALL))]), _vm._v(" "), _vm._l((_vm.groupSeq), function(productItem, productIndex) {
        return _c('option', {
          key: productIndex + productItem,
          domProps: {
            "value": productItem
          }
        }, [_vm._v(_vm._s(_vm.publicLan.products[productItem]))])
      })], 2)])])]), _vm._v(" "), _c('div', {
        staticClass: "form-horizontal"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        class: {
          'col-sm-5': _vm.viewBtn == 'double',
          'col-sm-3': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.enableCommTarget),
          expression: "ruleItem.enableCommTarget"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'enableCommTarget',
          "disabled": !_vm.enableUpperCalc || _vm.version == '0'
        },
        domProps: {
          "value": false,
          "checked": _vm._q(ruleItem.enableCommTarget, false)
        },
        on: {
          "change": function($event) {
            return _vm.$set(ruleItem, "enableCommTarget", false)
          }
        }
      }), _vm._v(" \n                        " + _vm._s(_vm.ruleSettingLan.toOriginalAccount) + "\n                      ")]), _vm._v(" "), _c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.enableCommTarget),
          expression: "ruleItem.enableCommTarget"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'enableCommTarget',
          "disabled": !_vm.enableUpperCalc || _vm.version == '0'
        },
        domProps: {
          "value": true,
          "checked": _vm._q(ruleItem.enableCommTarget, true)
        },
        on: {
          "change": function($event) {
            return _vm.$set(ruleItem, "enableCommTarget", true)
          }
        }
      }), _vm._v(" \n                        " + _vm._s(_vm.ruleSettingLan.toTargetAccount) + "\n                      ")])]), _vm._v(" "), _c('label', {
        class: {
          'col-sm-7': _vm.viewBtn == 'double',
          'col-sm-3': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.commTarget),
          expression: "ruleItem.commTarget"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|numeric'),
          expression: "'required|numeric'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'commTarget') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || !ruleItem.enableCommTarget,
          "name": levelIndex + '_' + ruleIndex + '_' + 'commTarget'
        },
        domProps: {
          "value": (ruleItem.commTarget)
        },
        on: {
          "focus": function($event) {
            _vm.onfocus = true
          },
          "blur": function($event) {
            _vm.onfocus = false
          },
          "change": function($event) {
            !_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'commTarget') && _vm.checkId(ruleItem)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(ruleItem, "commTarget", $event.target.value)
          }
        }
      })])])]), _vm._v(" "), _c('div', {
        staticClass: "form-inline"
      }, [_c('div', {
        class: {
          'row': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "has-feedback tips-wrap margin-bottom flex-box",
        class: {
          'col-sm-6': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('label', {
        staticClass: "radio-inline flex-item-left"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.ruleGroup),
          expression: "ruleItem.ruleGroup"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'ruleId',
          "disabled": !_vm.enableUpperCalc || _vm.version == '0'
        },
        domProps: {
          "value": 0,
          "checked": _vm._q(ruleItem.ruleGroup, 0)
        },
        on: {
          "change": [function($event) {
            return _vm.$set(ruleItem, "ruleGroup", 0)
          }, function($event) {
            return _vm.selectRuleFn(ruleItem)
          }]
        }
      }), _vm._v(" \n                        " + _vm._s(_vm.ruleSettingLan.ruleIdGroup[0]) + "\n                      ")]), _vm._v(" "), _c('div', {
        staticClass: "input-group flex-item-right"
      }, [_c('div', {
        staticClass: "input-group"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.ruleId),
          expression: "ruleItem.ruleId"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'ruleId') ? 'border-color:#f44336;' : ''),
        attrs: {
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 0,
          "name": levelIndex + '_' + ruleIndex + '_' + 'ruleId'
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(ruleItem, "ruleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return (ruleSeqItem.group === 0) ? _c('option', {
          key: ruleSeqIndex + ruleSeqItem,
          domProps: {
            "value": ruleSeqItem.ruleId
          }
        }, [_vm._v("\n                              " + _vm._s(_vm.publicLan.rule[ruleSeqItem.langKey.split('.')[1]]) + "\n                            ")]) : _vm._e()
      }), 0), _vm._v(" "), _c('span', {
        staticClass: "input-group-addon"
      }, [_c('el-tooltip', {
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "placement": "top-start",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 0
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-tags"
      }), _vm._v(" "), _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return (ruleSeqItem.ruleId === ruleItem.ruleId) ? _c('div', {
          staticStyle: {
            "width": "180px",
            "line-height": "20px"
          },
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v("\n                                  " + _vm._s(_vm.publicLan.rule[ruleSeqItem.descLangKey.split('.')[1]]) + "\n                              ")]) : _vm._e()
      })], 2)], 1)]), _vm._v(" "), _c('div', {
        staticClass: "input-group"
      }, [(ruleItem.ruleGroup == 0) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.value),
          expression: "ruleItem.value"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|min_value:0.00|decimal:4'),
          expression: "'required|min_value:0.00|decimal:4'"
        }],
        staticClass: "form-control",
        staticStyle: {
          "border-radius": "3px"
        },
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'value1') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 0,
          "name": levelIndex + '_' + ruleIndex + '_' + 'value1'
        },
        domProps: {
          "value": (ruleItem.value)
        },
        on: {
          "focus": function($event) {
            _vm.onfocus = true
          },
          "blur": function($event) {
            _vm.onfocus = false
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(ruleItem, "value", $event.target.value)
          }
        }
      }) : _c('input', {
        staticClass: "form-control",
        staticStyle: {
          "border-radius": "3px"
        },
        attrs: {
          "type": "text",
          "disabled": ""
        }
      })])])])]), _vm._v(" "), _c('div', {
        class: {
          'row': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "has-feedback margin-bottom flex-box",
        class: {
          'col-sm-6': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('label', {
        staticClass: "radio-inline flex-item-left"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.ruleGroup),
          expression: "ruleItem.ruleGroup"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'ruleId',
          "disabled": !_vm.enableUpperCalc || _vm.version == '0'
        },
        domProps: {
          "value": 1,
          "checked": _vm._q(ruleItem.ruleGroup, 1)
        },
        on: {
          "change": [function($event) {
            return _vm.$set(ruleItem, "ruleGroup", 1)
          }, function($event) {
            return _vm.selectRuleFn(ruleItem)
          }]
        }
      }), _vm._v(" \n                        " + _vm._s(_vm.ruleSettingLan.ruleIdGroup[1]) + "\n                      ")]), _vm._v(" "), _c('div', {
        staticClass: "input-group flex-item-right"
      }, [_c('div', {
        staticClass: "input-group"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.ruleId),
          expression: "ruleItem.ruleId"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'ruleId') ? 'border-color:#f44336;' : ''),
        attrs: {
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 1,
          "name": levelIndex + '_' + ruleIndex + '_' + 'ruleId'
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(ruleItem, "ruleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.selectRule6Fn(ruleItem)
          }]
        }
      }, _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return (ruleSeqItem.group == 1) ? _c('option', {
          key: ruleSeqIndex + ruleSeqItem,
          domProps: {
            "value": ruleSeqItem.ruleId
          }
        }, [_vm._v("\n                              " + _vm._s(_vm.publicLan.rule[ruleSeqItem.langKey.split('.')[1]]) + "\n                            ")]) : _vm._e()
      }), 0), _vm._v(" "), _c('span', {
        staticClass: "input-group-addon"
      }, [_c('el-tooltip', {
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "placement": "top-start",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 1
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-tags"
      }), _vm._v(" "), _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return (ruleSeqItem.ruleId === ruleItem.ruleId) ? _c('div', {
          staticStyle: {
            "width": "180px",
            "line-height": "20px"
          },
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v("\n                                  " + _vm._s(_vm.publicLan.rule[ruleSeqItem.descLangKey.split('.')[1]]) + "\n                              ")]) : _vm._e()
      })], 2)], 1)]), _vm._v(" "), _c('div', {
        staticClass: "input-group"
      }, [(ruleItem.ruleGroup == 1 && ruleItem.ruleId != 6) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.value),
          expression: "ruleItem.value"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|min_value:0.00|decimal:4'),
          expression: "'required|min_value:0.00|decimal:4'"
        }],
        staticClass: "form-control",
        staticStyle: {
          "border-radius": "3px"
        },
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'value2') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 1,
          "name": levelIndex + '_' + ruleIndex + '_' + 'value2'
        },
        domProps: {
          "value": (ruleItem.value)
        },
        on: {
          "focus": function($event) {
            _vm.onfocus = true
          },
          "blur": function($event) {
            _vm.onfocus = false
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(ruleItem, "value", $event.target.value)
          }
        }
      }) : _c('input', {
        staticClass: "form-control",
        staticStyle: {
          "border-radius": "3px"
        },
        attrs: {
          "type": "text",
          "disabled": ""
        }
      })])])])]), _vm._v(" "), _c('div', {
        class: {
          'row': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "has-feedback margin-bottom",
        class: {
          'col-sm-6': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('label', {
        staticClass: "radio-inline",
        staticStyle: {
          "padding-left": "0"
        },
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'spreadEnable') ? 'color:#f44336;' : '')
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.spreadEnable),
          expression: "ruleItem.spreadEnable"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: (!ruleItem.externalCommissionEnable && !ruleItem.internalCommissionEnable ? 'required:true' : ''),
          expression: "!ruleItem.externalCommissionEnable && !ruleItem.internalCommissionEnable ? 'required:true' : ''"
        }],
        attrs: {
          "type": "checkbox",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 0,
          "name": levelIndex + '_' + ruleIndex + '_' + 'spreadEnable'
        },
        domProps: {
          "checked": Array.isArray(ruleItem.spreadEnable) ? _vm._i(ruleItem.spreadEnable, null) > -1 : (ruleItem.spreadEnable)
        },
        on: {
          "change": function($event) {
            var $$a = ruleItem.spreadEnable,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ruleItem, "spreadEnable", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ruleItem, "spreadEnable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ruleItem, "spreadEnable", $$c)
            }
          }
        }
      }), _vm._v(" \n                        " + _vm._s(_vm.ruleSettingLan.spreadCommission) + "\n                      ")]), _vm._v(" "), _c('label', {
        staticClass: "radio-inline",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'externalCommissionEnable') ? 'color:#f44336;' : '')
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.externalCommissionEnable),
          expression: "ruleItem.externalCommissionEnable"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: (!ruleItem.spreadEnable && !ruleItem.internalCommissionEnable ? 'required:true' : ''),
          expression: "!ruleItem.spreadEnable && !ruleItem.internalCommissionEnable ? 'required:true' : ''"
        }],
        attrs: {
          "type": "checkbox",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 0,
          "name": levelIndex + '_' + ruleIndex + '_' + 'externalCommissionEnable'
        },
        domProps: {
          "checked": Array.isArray(ruleItem.externalCommissionEnable) ? _vm._i(ruleItem.externalCommissionEnable, null) > -1 : (ruleItem.externalCommissionEnable)
        },
        on: {
          "change": function($event) {
            var $$a = ruleItem.externalCommissionEnable,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ruleItem, "externalCommissionEnable", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ruleItem, "externalCommissionEnable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ruleItem, "externalCommissionEnable", $$c)
            }
          }
        }
      }), _vm._v(" \n                        " + _vm._s(_vm.ruleSettingLan.externalCommission) + "\n                      ")]), _vm._v(" "), _c('label', {
        staticClass: "radio-inline",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'internalCommissionEnable') ? 'color:#f44336;' : '')
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.internalCommissionEnable),
          expression: "ruleItem.internalCommissionEnable"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: (!ruleItem.externalCommissionEnable && !ruleItem.spreadEnable ? 'required:true' : ''),
          expression: "!ruleItem.externalCommissionEnable && !ruleItem.spreadEnable ? 'required:true' : ''"
        }],
        attrs: {
          "type": "checkbox",
          "disabled": !_vm.enableUpperCalc || _vm.version == '0' || ruleItem.ruleGroup !== 0,
          "name": levelIndex + '_' + ruleIndex + '_' + 'internalCommissionEnable'
        },
        domProps: {
          "checked": Array.isArray(ruleItem.internalCommissionEnable) ? _vm._i(ruleItem.internalCommissionEnable, null) > -1 : (ruleItem.internalCommissionEnable)
        },
        on: {
          "change": function($event) {
            var $$a = ruleItem.internalCommissionEnable,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ruleItem, "internalCommissionEnable", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ruleItem, "internalCommissionEnable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ruleItem, "internalCommissionEnable", $$c)
            }
          }
        }
      }), _vm._v(" \n                        " + _vm._s(_vm.ruleSettingLan.internalCommission) + "\n                      ")])])])])])])
    }), 0)], 1)], 1)
  }), 0)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper no-footer mtable"
  }, [_c('div', {
    staticClass: "datatable-header mtable-tool hui-group-dib-box"
  }, [(_vm.seekDropdown) ? _c('seek', {
    staticClass: "pull-left m-r-30 mtable-tool-seek",
    attrs: {
      "seekDropdown": _vm.seekDropdownProps
    },
    on: {
      "seek": _vm.seek
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selPage) ? _c('selPage', {
    staticClass: "pull-right",
    attrs: {
      "multiLanguage": _vm.multiLanguage,
      "selPage": _vm.selPage
    },
    on: {
      "selPage": _vm.selPageFn
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group p-0 pull-left mtable-tool-fn"
  }, [_c('label', {
    staticClass: "btn btn-default showName"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showName),
      expression: "showName"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showName) ? _vm._i(_vm.showName, null) > -1 : (_vm.showName)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showName,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showName = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showName = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showName = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.multiLanguage.showName))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.excelCallbackFn
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-save tab-he-glyphicon"
  }), _vm._v(_vm._s(_vm.multiLanguage.downloadExcelForms) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "datatable-scroll"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover datatable-highlight dataTable no-footer table-striped",
    attrs: {
      "id": "DataTables_Table_2",
      "role": "grid",
      "aria-describedby": "DataTables_Table_2_info"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, _vm._l((_vm.thData), function(item, index) {
    return _c('th', [_c('dropdown', {
      attrs: {
        "tag": "li"
      }
    }, [_c('a', {
      staticClass: "dropdown-toggle",
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(_vm.multiLanguage.th.loginType.roleType[item])), _c('span', {
      staticClass: "caret"
    })]), _vm._v(" "), _c('template', {
      slot: "dropdown"
    }, [_c('ul', {
      staticClass: "dropdown-item"
    }, _vm._l((_vm.filterData[item]), function(data, num) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.filterFn(data, _vm.filterData[item], _vm.seekDropdown.seekStr, index)
          }
        }
      }, [_c('a', {
        attrs: {
          "role": "button"
        }
      }, [_vm._v(_vm._s(data))])])
    }), 0)])], 2)], 1)
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.trData), function(item, index) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [(item.TD) ? _c('td', [_c('span', [_vm._v(_vm._s(item.TD.id))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showName),
        expression: "showName"
      }]
    }, [_vm._v(" - " + _vm._s(item.TD.name))])]) : _vm._e(), _vm._v(" "), (item.CL) ? _c('td', [_c('span', [_vm._v(_vm._s(item.CL.id))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showName),
        expression: "showName"
      }]
    }, [_vm._v(" - " + _vm._s(item.CL.name))])]) : _c('td', [_vm._v("-")]), _vm._v(" "), (item.IB && item.IB.length == 1) ? _c('td', [_c('span', [_vm._v(_vm._s(item.IB[0].id))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showName),
        expression: "showName"
      }]
    }, [_vm._v("-" + _vm._s(item.IB[0].name))])]) : (item.IB && item.IB.length > 1) ? _vm._l((item.IB), function(obj, i) {
      return _c('td', [_c('span', [_vm._v(_vm._s(obj.id))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showName),
          expression: "showName"
        }]
      }, [_vm._v("-" + _vm._s(obj.name))])])
    }) : _c('td', [_vm._v("-")]), _vm._v(" "), (item.SL && item.SL.length == 1) ? _c('td', [_c('span', [_vm._v(_vm._s(item.SL[0].id))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showName),
        expression: "showName"
      }]
    }, [_vm._v("-" + _vm._s(item.SL[0].name))])]) : (item.SL && item.SL.length > 1) ? _vm._l((item.SL), function(obj, i) {
      return _c('td', [_c('span', [_vm._v(_vm._s(obj.id))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showName),
          expression: "showName"
        }]
      }, [_vm._v("-" + _vm._s(obj.name))])])
    }) : _c('td', [_vm._v("-")]), _vm._v(" "), (item.M && item.M.length == 1) ? _c('td', [_c('span', [_vm._v(_vm._s(item.M[0].id))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showName),
        expression: "showName"
      }]
    }, [_vm._v("-" + _vm._s(item.M[0].name))])]) : (item.M && item.M.length > 1) ? _vm._l((item.M), function(obj, i) {
      return _c('td', [_c('span', [_vm._v(_vm._s(obj.id))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showName),
          expression: "showName"
        }]
      }, [_vm._v("-" + _vm._s(obj.name))])])
    }) : _c('td', [_vm._v("-")]), _vm._v(" "), (item.O && item.O.length == 1) ? _c('td', [_c('span', [_vm._v(_vm._s(item.O[0].id))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showName),
        expression: "showName"
      }]
    }, [_vm._v("-" + _vm._s(item.O[0].name))])]) : (item.O && item.O.length > 1) ? _vm._l((item.O), function(obj, i) {
      return _c('td', [_c('span', [_vm._v(_vm._s(obj.id))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showName),
          expression: "showName"
        }]
      }, [_vm._v("-" + _vm._s(obj.name))])])
    }) : _c('td', [_vm._v("-")]), _vm._v(" "), (item.R && item.R.length == 1) ? _c('td', [_c('span', [_vm._v(_vm._s(item.R[0].id))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showName),
        expression: "showName"
      }]
    }, [_vm._v("-" + _vm._s(item.R[0].name))])]) : (item.R && item.R.length > 1) ? _vm._l((item.R), function(obj, i) {
      return _c('td', [_c('span', [_vm._v(_vm._s(obj.id))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showName),
          expression: "showName"
        }]
      }, [_vm._v("-" + _vm._s(obj.name))])])
    }) : _c('td', [_vm._v("-")]), _vm._v(" "), (item.N && item.N.length == 1) ? _c('td', [_c('span', [_vm._v(_vm._s(item.N[0].id))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showName),
        expression: "showName"
      }]
    }, [_vm._v("-" + _vm._s(item.N[0].name))])]) : (item.N && item.N.length > 1) ? _vm._l((item.N), function(obj, i) {
      return _c('td', [_c('span', [_vm._v(_vm._s(obj.id))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showName),
          expression: "showName"
        }]
      }, [_vm._v("-" + _vm._s(obj.name))])])
    }) : _c('td', [_vm._v("-")]), _vm._v(" "), (item.C && item.C.length == 1) ? _c('td', [_c('span', [_vm._v(_vm._s(item.C[0].id))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showName),
        expression: "showName"
      }]
    }, [_vm._v("-" + _vm._s(item.C[0].name))])]) : (item.C && item.C.length > 1) ? _vm._l((item.C), function(obj, i) {
      return _c('td', [_c('span', [_vm._v(_vm._s(obj.id))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showName),
          expression: "showName"
        }]
      }, [_vm._v("-" + _vm._s(obj.name))])])
    }) : _c('td', [_vm._v("-")]), _vm._v(" "), (item.UN && item.UN.length == 1) ? _c('td', [_c('span', [_vm._v(_vm._s(item.UN[0].id))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showName),
        expression: "showName"
      }]
    }, [_vm._v("-" + _vm._s(item.UN[0].name))])]) : (item.UN && item.UN.length > 1) ? _vm._l((item.UN), function(obj, i) {
      return _c('td', [_c('span', [_vm._v(_vm._s(obj.id))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showName),
          expression: "showName"
        }]
      }, [_vm._v("-" + _vm._s(obj.name))])])
    }) : _c('td', [_vm._v("-")])], 2)
  }), 0)]), _vm._v(" "), (_vm.trData.length == 0) ? _c('noData', {
    attrs: {
      "text": _vm.multiLanguage.nodata,
      "fontSize": '18'
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "datatable-footer"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "id": "DataTables_Table_2_info",
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.multiLanguage.clauses) + _vm._s(_vm.multiLanguage.amount) + ": \n              " + _vm._s(_vm.page.pageLeng) + "  " + _vm._s(_vm.multiLanguage.present) + ": " + _vm._s(_vm.page.active * _vm.selPage.limit - _vm.selPage.limit + 1) + "-" + _vm._s(Math.min(_vm.page.active * _vm.selPage.limit, _vm.page.pageLeng)) + "\n          ")]), _vm._v(" "), (Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active])) ? _c('div', {
    staticClass: "dataTables_paginate paging_simple_numbers",
    attrs: {
      "id": "DataTables_Table_2_paginate"
    }
  }, [_c('pagination', {
    attrs: {
      "boundary-links": true,
      "direction-links": true,
      "total-page": Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active]),
      "max-size": _vm.page.pagenum
    },
    on: {
      "change": _vm.callpageFn
    },
    model: {
      value: (_vm.pageactive),
      callback: function($$v) {
        _vm.pageactive = $$v
      },
      expression: "pageactive"
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "noData"
  }, [_c('div', {
    style: ('font-size:' + _vm.fontSize + 'px')
  }, [_c('i', {
    staticClass: "glyphicon glyphicon glyphicon-info-sign"
  }), _vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper no-footer mtable"
  }, [_c('div', {
    staticClass: "datatable-header mtable-tool hui-group-dib-box"
  }, [(_vm.seekDropdown) ? _c('seek', {
    staticClass: "pull-left m-r-30 mtable-tool-seek",
    attrs: {
      "hideBtn": true,
      "seekDropdown": _vm.seekDropdownProps
    },
    on: {
      "seek": _vm.seek
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "seek pull-left m-r-30 mtable-tool-seek"
  }, [_c('div', {
    staticClass: "pull-left seekDropdown dropdown"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle hui-dropdown-toggle no-pointer",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.ibcAccount))])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ibcAccount),
      expression: "ibcAccount"
    }],
    staticClass: "form-control hui-form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.multiLanguage.search
    },
    domProps: {
      "value": (_vm.ibcAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ibcAccount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left seekDropdown dropdown",
    staticStyle: {
      "margin-left": "15px",
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle hui-dropdown-toggle no-pointer",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.th.specialCommission))])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left form-group"
  }, [_c('Dropdown', {
    ref: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-default select-btn",
    attrs: {
      "type": "button",
      "data-role": "trigger"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.ibSpecialType[_vm.ibSpecialType.listActive]))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, [_c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.dropdownFnSpecial($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.ibSpecialType.all))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.dropdownFnSpecial($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.ibSpecialType.special))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.dropdownFnSpecial($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.ibSpecialType.normal))])])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-left btn btn-default btn-primary",
    staticStyle: {
      "margin-left": "15px",
      "border-radius": "3px"
    },
    on: {
      "click": _vm.seek
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.search))]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (_vm.selPage) ? _c('selPage', {
    staticClass: "pull-right",
    attrs: {
      "multiLanguage": _vm.multiLanguage,
      "selPage": _vm.selPage
    },
    on: {
      "selPage": _vm.selPageFn
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group p-0 pull-left mtable-tool-fn"
  }, [_c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.refresh
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-refresh tab-he-glyphicon"
  }), _vm._v(_vm._s(_vm.multiLanguage.refreshData))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.excelCallbackFn
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-save tab-he-glyphicon"
  }), _vm._v(_vm._s(_vm.multiLanguage.downloadExcelForms) + "\n      ")]), _vm._v(" "), _c('Dropdown', {
    ref: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-default select-btn",
    attrs: {
      "type": "button",
      "data-role": "trigger"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.isSetting[_vm.isSetting.listActive]))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, [_c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.dropdownFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.isSetting.checked))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.dropdownFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.isSetting.unchecked))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.dropdownFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.isSetting.unsated))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.dropdownFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.isSetting.allStatus))])])])], 2), _vm._v(" "), _c('Dropdown', {
    ref: "droptemplate",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default select-btn",
    staticStyle: {
      "max-width": "150px",
      "overflow": "hidden"
    },
    attrs: {
      "type": "button",
      "data-role": "trigger"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ibTemplate[_vm.templateSel.active] ? _vm.ibCommissionLan[_vm.ibTemplate[_vm.templateSel.active].langKey] || _vm.templateSel.active : ''))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, [_c('div', {
    staticStyle: {
      "height": "350px",
      "width": "200px",
      "overflow-y": "scroll"
    }
  }, _vm._l((Object.keys(_vm.ibTemplate)), function(item) {
    return _c('li', {
      key: item,
      staticClass: "template-li"
    }, [_c('a', {
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.dropdownFnTemplate(_vm.ibTemplate[item])
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.ibCommissionLan[_vm.ibTemplate[item].langKey] || _vm.ibTemplate[item].templateId))])])
  }), 0)])], 2), _vm._v(" "), _c('Dropdown', {
    ref: "dropdown",
    staticStyle: {
      "margin-left": "-1px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default select-btn",
    attrs: {
      "type": "button",
      "data-role": "trigger"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage['ibTempOverwriteType'][_vm.templateSel.overwritten]))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, [_c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.templateSel.overwritten = 2
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage['ibTempOverwriteType'][2]))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.templateSel.overwritten = 1
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage['ibTempOverwriteType'][1]))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.templateSel.overwritten = 0
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage['ibTempOverwriteType'][0]))])])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "datatable-header mtable-tool hui-group-dib-box"
  }, [_c('div', {
    staticClass: "pull-left form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.modifyTime))]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "select"
    },
    model: {
      value: (_vm.modifyTstart),
      callback: function($$v) {
        _vm.modifyTstart = $$v
      },
      expression: "modifyTstart"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" -")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "select"
    },
    model: {
      value: (_vm.modifyTend),
      callback: function($$v) {
        _vm.modifyTend = $$v
      },
      expression: "modifyTend"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-left form-group",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.confirmTime))]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "select"
    },
    model: {
      value: (_vm.confirmTstart),
      callback: function($$v) {
        _vm.confirmTstart = $$v
      },
      expression: "confirmTstart"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" -")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "select"
    },
    model: {
      value: (_vm.confirmTend),
      callback: function($$v) {
        _vm.confirmTend = $$v
      },
      expression: "confirmTend"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "datatable-scroll"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-striped datatable-highlight dataTable no-footer",
    attrs: {
      "id": "DataTables_Table_2",
      "role": "grid",
      "aria-describedby": "DataTables_Table_2_info"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_vm._l((_vm.thData), function(item, index) {
    return _c('th', {
      class: {
        sorting: _vm.sort && index == 1
      },
      on: {
        "click": function($event) {
          _vm.sortFn(Object.keys(_vm.trData[0])[index])
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), (_vm.handle) ? _c('th', [_vm._v(_vm._s(_vm.multiLanguage.th.operation))]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.trData), function(item, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.trData.length > 0),
        expression: "trData.length > 0"
      }],
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [(item.isSpecial) ? _c('i', {
      staticClass: "glyphicon glyphicon-ok",
      staticStyle: {
        "color": "#2196F3"
      }
    }) : _c('i', {
      staticClass: "glyphicon glyphicon-minus"
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.node_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ibc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.node_code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updateBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.confirmBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.templateLang(item)))]), _vm._v(" "), (item.enable == 0) ? _c('td', [_vm._v(_vm._s(_vm.multiLanguage.ibStatus.disenable))]) : _c('td', [_vm._v(_vm._s(_vm.multiLanguage.ibStatus.enable))]), _vm._v(" "), (item.ib_rebatesetting == 2) ? _c('td', [_vm._v(_vm._s(_vm.multiLanguage.isSetting.checked))]) : (item.ib_rebatesetting == 1) ? _c('td', [_vm._v(_vm._s(_vm.multiLanguage.isSetting.unchecked))]) : (item.ib_rebatesetting == 0) ? _c('td', [_vm._v(_vm._s(_vm.multiLanguage.isSetting.unsated))]) : _vm._e(), _vm._v(" "), (_vm.handle) ? _c('td', {
      staticClass: "text-center pointer",
      on: {
        "click": function($event) {
          return _vm.linkRegister(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon-compose"
    })]) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.trData.length == 0) ? _c('noData', {
    attrs: {
      "text": _vm.multiLanguage.nodata,
      "fontSize": '18'
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.selPage) ? _c('div', {
    staticClass: "datatable-footer"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "id": "DataTables_Table_2_info",
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.multiLanguage.clauses) + _vm._s(_vm.multiLanguage.amount) + ": \n      " + _vm._s(_vm.page.pageLeng) + "  " + _vm._s(_vm.multiLanguage.present) + ": " + _vm._s(_vm.page.active * _vm.selPage.limit - _vm.selPage.limit + 1) + "-" + _vm._s(Math.min(_vm.page.active * _vm.selPage.limit, _vm.page.pageLeng)) + "\n    ")]), _vm._v(" "), (Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active])) ? _c('div', {
    staticClass: "dataTables_paginate paging_simple_numbers",
    attrs: {
      "id": "DataTables_Table_2_paginate"
    }
  }, [_c('pagination', {
    attrs: {
      "boundary-links": true,
      "direction-links": true,
      "total-page": Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active]),
      "max-size": _vm.page.pagenum
    },
    on: {
      "change": _vm.callpageFn
    },
    model: {
      value: (_vm.page.active),
      callback: function($$v) {
        _vm.$set(_vm.page, "active", $$v)
      },
      expression: "page.active"
    }
  })], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', _vm._l((_vm.values), function(v, k) {
    return _c('editable-list-cell', {
      key: ("cell-" + k),
      attrs: {
        "data": v.split(',').filter(function (d) { return d != ''; }),
        "pattern": "^\\d+$",
        "width": _vm.widths[k],
        "editable": _vm.columnNames[k].editable,
        "change": _vm.getSave(k)
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper no-footer mtable"
  }, [_c('div', {
    staticClass: "datatable-header mtable-tool hui-group-dib-box"
  }, [(_vm.seekDatePicker) ? _c('seekDatePicker', {
    staticClass: "pull-left m-r-30 mtable-tool-seek",
    attrs: {
      "seekDatePicker": _vm.seekDatePicker
    },
    on: {
      "seekDatePicker": _vm.seekDatePickerFn
    }
  }) : _vm._e(), _vm._v(" "), (_vm.seekDropdown) ? _c('seek', {
    staticClass: "pull-left m-r-30 mtable-tool-seek",
    attrs: {
      "seekDropdown": _vm.seekDropdownProps
    },
    on: {
      "seek": _vm.seek,
      "clickSeekDropdown": _vm.clickSeekDropdown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selPage) ? _c('selPage', {
    staticClass: "pull-right",
    attrs: {
      "multiLanguage": _vm.multiLanguage,
      "selPage": _vm.selPage
    },
    on: {
      "selPage": _vm.selPageFn
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group p-0 pull-left mtable-tool-fn"
  }, [_c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.refresh
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-refresh tab-he-glyphicon"
  }), _vm._v(_vm._s(_vm.multiLanguage.refreshData))]), _vm._v(" "), (_vm.jsonExcelAjax) ? _c('jsonExcel', {
    staticClass: "btn btn-default",
    attrs: {
      "name": "filename.xlsx",
      "ajaxUrl": _vm.jsonExcelAjax.url || false,
      "ajaxPar": _vm.jsonExcelAjax.ajaxPar || false,
      "ajaxType": _vm.jsonExcelAjax.ajaxType,
      "keys": _vm.thData,
      "ajaxGetKey": _vm.jsonExcelAjax.getKey,
      "multiLanguage": _vm.multiLanguage,
      "label": _vm.label,
      "colData": []
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-save tab-he-glyphicon"
  }), _vm._v(_vm._s(_vm.multiLanguage.downloadExcelForms) + "\n            ")]) : _vm._e(), _vm._v(" "), (!(JSON.stringify(_vm.isSetting) === '{}')) ? _c('Dropdown', {
    ref: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-default select-btn",
    attrs: {
      "type": "button",
      "data-role": "trigger"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.isSetting[_vm.isSetting.listActive]))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, [_c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.dropdownFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.isSetting.checked))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.dropdownFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.isSetting.unchecked))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.dropdownFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.isSetting.unsated))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.dropdownFn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.isSetting.allStatus))])])])], 2) : _vm._e(), _vm._v(" "), (_vm.handle && _vm.handle.link === 'accountDatum') ? _c('router-link', {
    staticClass: "btn btn-default",
    class: {
      'radius-r': !_vm.handle.delete
    },
    attrs: {
      "to": _vm.handle.link
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-new-window tab-he-glyphicon"
  }), _vm._v(_vm._s(_vm.multiLanguage.addAccount))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handle.delete && !_vm.deleteCol.switch),
      expression: "handle.delete && !deleteCol.switch"
    }],
    staticClass: "btn btn-default btn-danger mtable-tool-delete",
    class: {
      'radius-r': _vm.handle.delete
    },
    on: {
      "click": function($event) {
        _vm.deleteCol.switch = true
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-trash tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.deletedData) + "\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handle.delete && _vm.deleteCol.switch),
      expression: "handle.delete && deleteCol.switch"
    }],
    staticClass: "btn btn-default btn-danger mtable-tool-delete",
    class: {
      'radius-r': _vm.handle.delete
    },
    on: {
      "click": _vm.deleteColNotarizeFn
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-log-out tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.confirmDelete) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "datatable-scroll"
  }, [_vm._t("datatable-scroll"), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover datatable-highlight dataTable no-footer table-striped",
    attrs: {
      "id": "DataTables_Table_2",
      "role": "grid",
      "aria-describedby": "DataTables_Table_2_info"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_vm._l((_vm.thData), function(item, index) {
    return _c('th', {
      class: {
        sorting: _vm.sort && index == 0
      },
      on: {
        "click": function($event) {
          _vm.sortFn(Object.keys(_vm.trData[0])[index])
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), (_vm.handle) ? _c('th', {
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.th.operation))]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', {
    class: {
      'deleteCol-opt': _vm.handle.delete
    }
  }, [_vm._l((_vm.trData), function(item, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.trData.length > 0),
        expression: "trData.length > 0"
      }],
      class: _vm.trCls && _vm.trCls(item, index),
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          return _vm.clickColFn(item, index)
        }
      }
    }, [_vm._l((_vm.trDataKeys), function(key) {
      return _c('td', {
        staticClass: "sorting_1",
        class: {
          'pointer': _vm.deleteCol.switch
        },
        on: {
          "click": function($event) {
            return _vm.deletePitch(item)
          }
        }
      }, [(key == 'officeState' && item[key] == 'F') ? _c('span', [_vm._v(_vm._s(_vm.multiLanguage.th.officeState.countryArr[0].text))]) : (key == 'officeState' && item[key] == 'P') ? _c('span', [_vm._v(_vm._s(_vm.multiLanguage.th.officeState.countryArr[1].text))]) : (key == 'officeState' && item[key] == 'D') ? _c('span', [_vm._v(_vm._s(_vm.multiLanguage.th.officeState.countryArr[2].text))]) : (key == 'status' && item[key] == 0) ? _c('span', [_vm._v(_vm._s(_vm.multiLanguage.isSetting.unsated))]) : (key == 'status' && item[key] == 1) ? _c('span', [_vm._v(_vm._s(_vm.multiLanguage.isSetting.unchecked))]) : (key == 'status' && item[key] == 2) ? _c('span', [_vm._v(_vm._s(_vm.multiLanguage.isSetting.checked))]) : (key == 'last_update') ? _c('span', [_vm._v(_vm._s(_vm.momentFn(item[key])))]) : _c('span', [_vm._v(_vm._s(item[key]))])])
    }), _vm._v(" "), (_vm.handle) ? _c('td', {
      staticClass: "text-center pointer",
      class: {
        'pointer': _vm.deleteCol.switch
      },
      on: {
        "click": function($event) {
          return _vm.linkRegister(item)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.deleteCol.switch),
        expression: "!deleteCol.switch"
      }],
      staticClass: "icon-compose"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.deleteCol.switch && _vm.deleteCol.list.indexOf(item[_vm.handle.idKey]) != -1),
        expression: "deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) != -1"
      }],
      staticClass: "glyphicon glyphicon-ok color-red"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.deleteCol.switch && _vm.deleteCol.list.indexOf(item[_vm.handle.idKey]) == -1),
        expression: "deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) == -1"
      }],
      staticClass: "glyphicon glyphicon-trash tab-he-glyphicon"
    })]) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.trData.length > 0 && Object.keys(_vm.totalTr).length > 0) ? _c('tr', _vm._l((_vm.totalTr), function(item) {
    return _c('td', [_vm._v(_vm._s(item))])
  }), 0) : _vm._e()], 2)]), _vm._v(" "), (_vm.trData.length == 0) ? _c('noData', {
    attrs: {
      "text": _vm.multiLanguage.nodata,
      "fontSize": '18'
    }
  }) : _vm._e()], 2), _vm._v(" "), (_vm.selPage) ? _c('div', {
    staticClass: "datatable-footer"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "id": "DataTables_Table_2_info",
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.multiLanguage.clauses) + _vm._s(_vm.multiLanguage.amount) + ": " + _vm._s(_vm.page.pageLeng) + "  " + _vm._s(_vm.multiLanguage.present) + ": " + _vm._s(_vm.page.active * _vm.selPage.limit - _vm.selPage.limit + 1) + "-" + _vm._s(Math.min(_vm.page.active * _vm.selPage.limit, _vm.page.pageLeng)) + "\n    ")]), _vm._v(" "), (Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active])) ? _c('div', {
    staticClass: "dataTables_paginate paging_simple_numbers",
    attrs: {
      "id": "DataTables_Table_2_paginate"
    }
  }, [_c('pagination', {
    attrs: {
      "boundary-links": true,
      "direction-links": true,
      "total-page": Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active]),
      "max-size": _vm.page.pagenum
    },
    on: {
      "change": _vm.callpageFn
    },
    model: {
      value: (_vm.pageactive),
      callback: function($$v) {
        _vm.pageactive = $$v
      },
      expression: "pageactive"
    }
  })], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.id_name
    },
    on: {
      "click": _vm.generate_excel
    }
  }, [_vm._t("default", function() {
    return [_vm._v("\n    " + _vm._s(_vm.button_text) + _vm._s(_vm.ajaxGetKey) + "\n  ")]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper no-footer mtable"
  }, [_c('div', {
    staticClass: "datatable-header mtable-tool hui-group-dib-box"
  }, [_c('div', {
    staticClass: "btn-group p-0 pull-left mtable-tool-fn"
  }, [_c('div', {
    staticClass: "btn btn-default",
    class: {
      'radius-r': !_vm.handle.delete
    },
    on: {
      "click": _vm.addRole
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-new-window tab-he-glyphicon"
  }), _vm._v(_vm._s(_vm.multiLanguage.addRole) + "\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handle.delete && !_vm.deleteCol.switch),
      expression: "handle.delete && !deleteCol.switch"
    }],
    staticClass: "btn btn-default btn-danger mtable-tool-delete",
    class: {
      'radius-r': _vm.handle.delete
    },
    on: {
      "click": function($event) {
        _vm.deleteCol.switch = true
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-trash tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.deleteRole) + "\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handle.delete && _vm.deleteCol.switch),
      expression: "handle.delete && deleteCol.switch"
    }],
    staticClass: "btn btn-default btn-danger mtable-tool-delete",
    class: {
      'radius-r': _vm.handle.delete
    },
    on: {
      "click": _vm.deleteColNotarizeFn
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-log-out tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.confirmDelete) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "datatable-scroll"
  }, [_vm._t("datatable-scroll"), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover datatable-highlight dataTable no-footer",
    attrs: {
      "id": "DataTables_Table_2",
      "role": "grid",
      "aria-describedby": "DataTables_Table_2_info"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_vm._l((_vm.thData), function(item, index) {
    return _c('th', [_vm._v(_vm._s(item))])
  }), _vm._v(" "), (_vm.handle) ? _c('th', {
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.th.operation))]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', {
    class: {
      'deleteCol-opt': _vm.handle.delete
    }
  }, [_vm._l((_vm.trData), function(item, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.trData.length > 0),
        expression: "trData.length > 0"
      }],
      class: _vm.trCls && _vm.trCls(item, index),
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          return _vm.clickColFn(item, index)
        }
      }
    }, [_vm._l((_vm.trDataKeys), function(key) {
      return _c('td', {
        staticClass: "sorting_1",
        on: {
          "click": function($event) {
            return _vm.deletePitch(item)
          }
        }
      }, [_vm._v(_vm._s(item[key]))])
    }), _vm._v(" "), (_vm.handle) ? _c('td', {
      staticClass: "text-center pointer",
      class: {
        'pointer': _vm.deleteCol.switch
      },
      on: {
        "click": function($event) {
          return _vm.linkRegister(item)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.deleteCol.switch),
        expression: "!deleteCol.switch"
      }],
      staticClass: "icon-compose"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.deleteCol.switch && _vm.deleteCol.list.indexOf(item[_vm.handle.idKey]) != -1),
        expression: "deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) != -1"
      }],
      staticClass: "glyphicon glyphicon-ok color-red"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.deleteCol.switch && _vm.deleteCol.list.indexOf(item[_vm.handle.idKey]) == -1),
        expression: "deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) == -1"
      }],
      staticClass: "glyphicon glyphicon-trash tab-he-glyphicon"
    })]) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.trData.length > 0 && Object.keys(_vm.totalTr).length > 0) ? _c('tr', _vm._l((_vm.totalTr), function(item) {
    return _c('td', [_vm._v(_vm._s(item))])
  }), 0) : _vm._e()], 2)]), _vm._v(" "), (_vm.trData.length == 0) ? _c('noData', {
    attrs: {
      "text": _vm.multiLanguage.nodata,
      "fontSize": '18'
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "datatable-footer"
  }), _vm._v(" "), _c('RoleDialog', {
    ref: "RoleDialog",
    on: {
      "addRefresh": _vm.addRefresh
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.multiLanguage.ibreport.text))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "multiLanguage": _vm.multiLanguage,
      "selPage": _vm.selPage,
      "page": _vm.page,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "downLoadTran": _vm.downLoadTran,
      "sort": _vm.sort,
      "name": _vm.name
    },
    on: {
      "tableChange": _vm.tableAjax
    }
  }, [_c('div', {
    staticClass: "ibReportSlot",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "ibReportSelect"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.ibreport.statusText))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "change": _vm.searchData
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.multiLanguage.ibreport.statusList), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "ibReportInput"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.ibreport.ibAccountText))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    model: {
      value: (_vm.ibAccount),
      callback: function($$v) {
        _vm.ibAccount = $$v
      },
      expression: "ibAccount"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.multiLanguage.search) + "\n                        ")]), _vm._v("\n                                    \n                    ")], 1)])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper no-footer mtable"
  }, [_c('div', {
    staticClass: "datatable-header mtable-tool hui-group-dib-box"
  }, [(_vm.seekDatePicker) ? _c('seekDatePicker', {
    staticClass: "pull-left m-r-30 mtable-tool-seek",
    attrs: {
      "seekDatePicker": _vm.seekDatePicker
    },
    on: {
      "seekDatePicker": _vm.seekDatePickerFn
    }
  }) : _vm._e(), _vm._v(" "), (_vm.seekDropdown) ? _c('seek', {
    staticClass: "pull-left m-r-30 mtable-tool-seek",
    attrs: {
      "seekDropdown": _vm.seekDropdownProps
    },
    on: {
      "seek": _vm.seek,
      "clickSeekDropdown": _vm.clickSeekDropdown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selPage) ? _c('selPage', {
    staticClass: "pull-right",
    attrs: {
      "multiLanguage": _vm.multiLanguage,
      "selPage": _vm.selPage
    },
    on: {
      "selPage": _vm.selPageFn
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group p-0 pull-left mtable-tool-fn"
  }, [_c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.refresh
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-refresh tab-he-glyphicon"
  }), _vm._v(_vm._s(_vm.multiLanguage.refreshData))]), _vm._v(" "), (_vm.jsonExcelAjax) ? _c('jsonExcel', {
    staticClass: "btn btn-default",
    attrs: {
      "name": "filename.xlsx",
      "ajaxUrl": _vm.jsonExcelAjax.url || false,
      "ajaxPar": _vm.jsonExcelAjax.ajaxPar || false,
      "ajaxType": _vm.jsonExcelAjax.ajaxType,
      "keys": _vm.thData,
      "ajaxGetKey": _vm.jsonExcelAjax.getKey,
      "colData": Object.keys(_vm.totalTr).length > 0 ? _vm.jsonExcelAjax.colData.concat( [_vm.totalTr]) : _vm.jsonExcelAjax.colData
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-save tab-he-glyphicon"
  }), _vm._v(_vm._s(_vm.multiLanguage.downloadExcelForms) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.handle) ? _c('router-link', {
    staticClass: "btn btn-default",
    class: {
      'radius-r': !_vm.handle.delete
    },
    attrs: {
      "to": _vm.handle.link
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-new-window tab-he-glyphicon"
  }), _vm._v(_vm._s(_vm.multiLanguage.addAccount))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handle.delete && !_vm.deleteCol.switch),
      expression: "handle.delete && !deleteCol.switch"
    }],
    staticClass: "btn btn-default btn-danger mtable-tool-delete",
    class: {
      'radius-r': _vm.handle.delete
    },
    on: {
      "click": function($event) {
        _vm.deleteCol.switch = true
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-trash tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.deletedData) + "\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handle.delete && _vm.deleteCol.switch),
      expression: "handle.delete && deleteCol.switch"
    }],
    staticClass: "btn btn-default btn-danger mtable-tool-delete",
    class: {
      'radius-r': _vm.handle.delete
    },
    on: {
      "click": _vm.deleteColNotarizeFn
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-log-out tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.confirmDelete) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "datatable-scroll"
  }, [_vm._t("datatable-scroll"), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover datatable-highlight dataTable no-footer",
    attrs: {
      "id": "DataTables_Table_2",
      "role": "grid",
      "aria-describedby": "DataTables_Table_2_info"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_vm._l((_vm.thData), function(item, index) {
    return _c('th', {
      class: {
        sorting: _vm.sort && index == 0
      },
      on: {
        "click": function($event) {
          _vm.sortFn(Object.keys(_vm.trData[0])[index])
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), (_vm.handle) ? _c('th', {
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.th.operation))]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', {
    class: {
      'deleteCol-opt': _vm.handle.delete
    }
  }, [_vm._l((_vm.trData), function(item, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.trData.length > 0),
        expression: "trData.length > 0"
      }],
      class: _vm.trCls && _vm.trCls(item, index),
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          return _vm.clickColFn(item, index)
        }
      }
    }, [_vm._l((_vm.trDataKeys), function(key) {
      return _c('td', {
        staticClass: "sorting_1",
        class: {
          'pointer': _vm.deleteCol.switch
        },
        on: {
          "click": function($event) {
            return _vm.deletePitch(item)
          }
        }
      }, [_vm._v(_vm._s(item[key]))])
    }), _vm._v(" "), (_vm.handle) ? _c('td', {
      staticClass: "text-center pointer",
      class: {
        'pointer': _vm.deleteCol.switch
      },
      on: {
        "click": function($event) {
          return _vm.linkRegister(item)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.deleteCol.switch),
        expression: "!deleteCol.switch"
      }],
      staticClass: "icon-compose"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.deleteCol.switch && _vm.deleteCol.list.indexOf(item[_vm.handle.idKey]) != -1),
        expression: "deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) != -1"
      }],
      staticClass: "glyphicon glyphicon-ok color-red"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.deleteCol.switch && _vm.deleteCol.list.indexOf(item[_vm.handle.idKey]) == -1),
        expression: "deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) == -1"
      }],
      staticClass: "glyphicon glyphicon-trash tab-he-glyphicon"
    })]) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.trData.length > 0 && Object.keys(_vm.totalTr).length > 0) ? _c('tr', _vm._l((_vm.totalTr), function(item) {
    return _c('td', [_vm._v(_vm._s(item))])
  }), 0) : _vm._e()], 2)]), _vm._v(" "), (_vm.trData.length == 0) ? _c('noData', {
    attrs: {
      "text": _vm.multiLanguage.nodata,
      "fontSize": '18'
    }
  }) : _vm._e()], 2), _vm._v(" "), (_vm.selPage) ? _c('div', {
    staticClass: "datatable-footer"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "id": "DataTables_Table_2_info",
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.multiLanguage.clauses) + _vm._s(_vm.multiLanguage.amount) + ": " + _vm._s(_vm.page.pageLeng) + "  " + _vm._s(_vm.multiLanguage.present) + ": " + _vm._s(_vm.page.active * _vm.selPage.limit - _vm.selPage.limit + 1) + "-" + _vm._s(Math.min(_vm.page.active * _vm.selPage.limit, _vm.page.pageLeng)) + "\n    ")]), _vm._v(" "), (Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active])) ? _c('div', {
    staticClass: "dataTables_paginate paging_simple_numbers",
    attrs: {
      "id": "DataTables_Table_2_paginate"
    }
  }, [_c('pagination', {
    attrs: {
      "boundary-links": true,
      "direction-links": true,
      "total-page": Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active]),
      "max-size": _vm.page.pagenum
    },
    on: {
      "change": _vm.callpageFn
    },
    model: {
      value: (_vm.pageactive),
      callback: function($$v) {
        _vm.pageactive = $$v
      },
      expression: "pageactive"
    }
  })], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "salesCommission"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.salesCommissionLan.saleAccount) + " : " + _vm._s(_vm.$route.query.id)), (_vm.showPreview) ? _c('span', [_vm._v(" - " + _vm._s(_vm.salesCommissionLan.btnGroup.commissionPreviewBtn))]) : _vm._e()]), _vm._v(" "), (!_vm.showPreview) ? _c('div', {
    staticClass: "pull-right viewBtn-box"
  }, [_c('button', {
    staticClass: "double",
    on: {
      "click": function($event) {
        _vm.viewBtn = 'double'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.salesCommissionLan.contrastBrowse) + "\n      ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.viewBtn = 'onlyOne'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.salesCommissionLan.singlepageBrowse) + "\n      ")])]) : _vm._e(), _vm._v(" "), (!_vm.showPreview) ? _c('button', {
    staticClass: "pull-right preview-btn",
    on: {
      "click": function($event) {
        _vm.showPreview = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.salesCommissionLan.btnGroup.commissionPreviewBtn) + "\n    ")]) : _c('button', {
    staticClass: "pull-right preview-btn",
    on: {
      "click": function($event) {
        _vm.showPreview = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.salesCommissionLan.btnGroup.back) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (_vm.showPreview) ? _c('div', {
    staticClass: "content-box"
  }, [_c('sale-commission-preview', {
    attrs: {
      "region": _vm.curArea,
      "multiLanguage": _vm.salesCommissionLan,
      "reqData": _vm.reqData
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showPreview) ? _c('div', {
    staticClass: "content-box"
  }, [(_vm.viewBtn == 'double') ? _c('div', {
    staticClass: "version0",
    class: {
      'doubleView margin-right': _vm.viewBtn === 'double'
    }
  }, [_c('sale-commission-content', {
    ref: "version0",
    attrs: {
      "multiLanguage": _vm.salesCommissionLan,
      "version": '0',
      "viewBtn": _vm.viewBtn,
      "curArea": _vm.curArea
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "version1",
    class: {
      'doubleView': _vm.viewBtn === 'double'
    }
  }, [_c('sale-commission-content', {
    ref: "version1",
    attrs: {
      "multiLanguage": _vm.salesCommissionLan,
      "version": '1',
      "viewBtn": _vm.viewBtn,
      "curArea": _vm.curArea
    },
    on: {
      "afterVerify": _vm.afterVerifyFn
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.fromSpbo2) ? _c('crumbs', [_c('i', {
    staticClass: "glyphicon glyphicon-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.commissionViewLan.title))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "principal-wrap"
  }, [_c('el-button-group', {
    staticClass: "role-btn-group"
  }, [_c('el-button', {
    staticClass: "role",
    class: {
      'curRole': (_vm.active == '/ib_v2')
    },
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.jump('/ibPrimary_v2')
      }
    }
  }, [_vm._v(_vm._s(_vm.commissionViewLan.role.ib))]), _vm._v(" "), _c('el-button', {
    staticClass: "role",
    class: {
      'curRole': (_vm.active == '/sale_v2')
    },
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.jump('/salePrimary_v2')
      }
    }
  }, [_vm._v(_vm._s(_vm.commissionViewLan.role.sale))])], 1), _vm._v(" "), _c('router-view', {
    attrs: {
      "status": _vm.status
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "download"
    }
  }), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.generate_excel
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-list-wrap"
  }, _vm._l((_vm.show_list_opt_data), function(item, key) {
    return _c(_vm.box_type(item), {
      key: key,
      ref: item.right_id,
      refInFor: true,
      tag: "box",
      attrs: {
        "check_data": _vm.right_ids,
        "box_data": item
      },
      on: {
        "check_change": _vm.data_change
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "loginBox"
  }, [_vm._m(0), _vm._v(" "), _c('label', [_c('img', {
    attrs: {
      "src": __webpack_require__(973),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromValue.name),
      expression: "fromValue.name"
    }],
    staticClass: "username-but",
    attrs: {
      "type": "text",
      "placeholder": _vm.loginLan.loginTxt
    },
    domProps: {
      "value": (_vm.fromValue.name)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loginFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fromValue, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_c('img', {
    attrs: {
      "src": __webpack_require__(986),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromValue.password),
      expression: "fromValue.password"
    }],
    staticClass: "username-but",
    attrs: {
      "type": "password",
      "placeholder": _vm.loginLan.passwordTxt
    },
    domProps: {
      "value": (_vm.fromValue.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loginFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fromValue, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "forgot-password-box"
  }, [_c('span', {
    staticClass: "forgot-password"
  }, [_vm._v(_vm._s(_vm.loginLan.forgotPassword))])]), _vm._v(" "), _c('div', {
    staticClass: "login-but-box"
  }, [_c('button', {
    staticClass: "login-but",
    on: {
      "click": _vm.loginFn
    }
  }, [_vm._v(_vm._s(_vm.loginLan.btn))])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('div', {
    staticClass: "language-box"
  }, [_c('span', {
    staticClass: "select_language-span"
  }, [_vm._v(_vm._s(_vm.loginLan.select_language))])]), _vm._v(" "), _c('div', {
    staticClass: "select_language-box"
  }, [_c('i', {
    staticClass: "el-icon-arrow-down"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.languageSelActive),
      expression: "languageSelActive"
    }],
    ref: "language",
    staticClass: "select-but",
    attrs: {
      "name": "language",
      "id": "language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.languageSelActive = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languageSelList), function(item, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])])]), _vm._v(" "), _c('Modal', {
    staticClass: "modal-content-j",
    attrs: {
      "size": "sm",
      "footer": false,
      "header": false,
      "backdrop": true
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-warning-sign color-red"
  }), _vm._v(_vm._s(_vm.loginLan.tips.loginErr))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-image-box"
  }, [_c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": __webpack_require__(972)
    }
  })])
}]}

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.salesMonthlyLan.indexText))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "selPage": _vm.selPage,
      "page": _vm.page,
      "link": _vm.link,
      "back": _vm.back,
      "region": _vm.curArea,
      "multiLanguage": _vm.salesMonthlyLan,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "downLoadTran": _vm.downLoadTran,
      "name": _vm.name
    },
    on: {
      "tableChange": _vm.tableAjax
    }
  }, [_c('div', {
    staticClass: "monthlyHandle",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.salesMonthlyLan.start_time))]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.salesMonthlyLan.selectTimeText
    },
    model: {
      value: (_vm.beginTime),
      callback: function($$v) {
        _vm.beginTime = $$v
      },
      expression: "beginTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.salesMonthlyLan.end_time))]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.salesMonthlyLan.selectTimeText
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btnDiv"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v(_vm._s(_vm.salesMonthlyLan.search))])], 1)])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rows.length == 0) ? _c('span', [_vm._v("Please Wait, the data of " + _vm._s(_vm.curArea) + " is loading.")]) : _c('editable-table', {
    attrs: {
      "title": (_vm.curArea + " Alert Ignore List").toUpperCase(),
      "column-names": _vm.columnNames,
      "rows": _vm.rows,
      "save": _vm.onSave()
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": function($event) {
        return _vm.tablesToExcel()
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cpaCommission-box"
  }, [_c('div', {
    staticClass: "tableBtn-box",
    style: (_vm.version == '0' ? 'visibility:hidden;' : '')
  }, [_c('button', {
    staticClass: "btn btn-style-add",
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.addItem
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.addLots) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-style-remove",
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.removeItem
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-trash"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.removeLots) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-box"
  }, [_c('table', {
    staticClass: "table table-bordered",
    class: {
      'table-striped': _vm.commission.enable && _vm.version == '1',
      'disabled': !_vm.commission.enable || _vm.version == '0'
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.multiLanguage.CPA.totalVolume) + " >= 25 " + _vm._s(_vm.multiLanguage.CPA.LOT) + "(" + _vm._s(_vm.multiLanguage.CPA.remarks) + ")")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.CPA.commissionPer))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.commission.cpa), function(cpaItem, index) {
    return _c('tr', [_c('td', [(_vm.version == '1') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedCPAS),
        expression: "checkedCPAS"
      }],
      class: {
        'min-checkbox': _vm.viewBtn == 'double'
      },
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.commission.enable || _vm.version == '0'
      },
      domProps: {
        "value": index,
        "checked": Array.isArray(_vm.checkedCPAS) ? _vm._i(_vm.checkedCPAS, index) > -1 : (_vm.checkedCPAS)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedCPAS,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = index,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedCPAS = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedCPAS = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedCPAS = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), (index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cpaItem.start),
        expression: "cpaItem.start"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|min_value:1.00|decimal:2'),
        expression: "'required|min_value:1.00|decimal:2'"
      }],
      style: (_vm.errors.has(index + '_' + 'cpaStart') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.commission.enable || _vm.version == '0',
        "name": index + '_' + 'cpaStart'
      },
      domProps: {
        "value": (cpaItem.start)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cpaItem, "start", $event.target.value)
        }
      }
    }) : _c('span', {
      staticClass: "cpa-text"
    }, [_vm._v(_vm._s(cpaItem.start ? cpaItem.start : '1.00'))]), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), (index !== _vm.commission.cpa.length - 1) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cpaItem.end),
        expression: "cpaItem.end"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|min_value:1.00|decimal:2'),
        expression: "'required|min_value:1.00|decimal:2'"
      }],
      style: (_vm.errors.has(index + '_' + 'cpaEnd') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.commission.enable || _vm.version == '0',
        "name": index + '_' + 'cpaEnd'
      },
      domProps: {
        "value": (cpaItem.end)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cpaItem, "end", $event.target.value)
        }
      }
    }) : _c('span', {
      staticClass: "cpa-text"
    }, [_vm._v(_vm._s(_vm.multiLanguage.infinite))])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cpaItem.CPA),
        expression: "cpaItem.CPA"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|min_value:0.01|decimal:2'),
        expression: "'required|min_value:0.01|decimal:2'"
      }],
      style: (_vm.errors.has(index + '_' + 'cpaData') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.commission.enable || _vm.version == '0',
        "name": index + '_' + 'cpaData'
      },
      domProps: {
        "value": (cpaItem.CPA)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cpaItem, "CPA", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span')])])
  }), 0)])])])])
},staticRenderFns: []}

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar sidebar-main"
  }, [_c('div', {
    staticClass: "sidebar-content"
  }, [_c('div', {
    staticClass: "sidebar-category sidebar-category-visible"
  }, [_c('div', {
    staticClass: "category-content no-padding"
  }, [_c('ul', {
    staticClass: "navigation navigation-main navigation-accordion"
  }, _vm._l((_vm.sidebarListCom), function(item, index) {
    return (_vm.sidebarListCom[index] && _vm.sidebarListCom[index].show) ? _c('li', {
      staticClass: "sidebar-item",
      class: {
        'active': _vm.sidebarListCom[index].set
      },
      on: {
        "click": function($event) {
          return _vm.sidebarSet(index)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('i', {
      class: _vm.sidebarListCom[index].icon
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.sidebarLan[index].text))])])]) : _vm._e()
  }), 0)])])])])
},staticRenderFns: []}

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.allCommissionLan.title))])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "seek pull-left"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('button', {
    staticClass: "btn btn-default no-pointer acc",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.allCommissionLan.account))])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.seekStr),
      expression: "seekStr"
    }],
    staticClass: "form-control seekinput",
    attrs: {
      "type": "text",
      "placeholder": _vm.allCommissionLan.seek
    },
    domProps: {
      "value": (_vm.seekStr)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.seekFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.seekStr = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left btn btn-default btn-primary",
    on: {
      "click": _vm.seekFn
    }
  }, [_vm._v(_vm._s(_vm.allCommissionLan.seek))]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left btn-group"
  }, [(_vm.jsonExcelAjax) ? _c('jsonExcel', {
    staticClass: "btn btn-default",
    attrs: {
      "name": "filename.xlsx",
      "ajaxUrl": _vm.getIBInfoUrl || false,
      "ajaxPar": _vm.jsonExcelAjax.ajaxPar || false,
      "ajaxType": _vm.jsonExcelAjax.ajaxType,
      "keys": _vm.thData,
      "ajaxGetKey": _vm.jsonExcelAjax.getKey,
      "multiLanguage": _vm.allCommissionLan,
      "label": _vm.label,
      "colData": []
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-save tab-he-glyphicon"
  }), _vm._v(_vm._s(_vm.allCommissionLan.downloadExcelForms) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.selPage) ? _c('selPage', {
    staticClass: "pull-right",
    attrs: {
      "multiLanguage": _vm.allCommissionLan,
      "selPage": _vm.selPage
    },
    on: {
      "selPage": _vm.selPageFn
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('table', {
    staticClass: "table table-striped DataTable"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.allCommissionLan.type))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.allCommissionLan.account))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.allCommissionLan.name))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.allCommissionLan.commissionReturn))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.trData), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.allCommissionLan[item.type]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ibId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.mode == 0) ? _c('td', [_vm._v("\n              " + _vm._s(_vm.allCommissionLan.internalCommission + ' : ') + "\n              "), _vm._l((item.first), function(data, key) {
      return _c('span', [_vm._v("\n                  " + _vm._s(data) + " " + _vm._s(_vm.allCommissionLan.unit) + " \n                  "), (key < item.first.length - 1) ? _c('span', [_vm._v("/")]) : _vm._e()])
    })], 2) : (item.mode == 1) ? _c('td', [_vm._v("\n              " + _vm._s(_vm.allCommissionLan.CPACommission + ' : ') + "\n              "), _vm._l((item.cpa), function(data, key) {
      return _c('span', [_vm._v("\n                  " + _vm._s(data) + " " + _vm._s(_vm.allCommissionLan.unit) + " \n                  "), (key < item.cpa.length - 1) ? _c('span', [_vm._v("/")]) : _vm._e()])
    })], 2) : (item.mode == 2) ? _c('td', [_vm._v("\n              " + _vm._s(_vm.allCommissionLan.internalCommission + ' : ') + "\n              "), _vm._l((item.first), function(data, key) {
      return _c('span', [_vm._v("\n                  " + _vm._s(data) + " " + _vm._s(_vm.allCommissionLan.unit) + " \n                  "), (key < item.first.length - 1) ? _c('span', [_vm._v("/")]) : _vm._e()])
    }), _vm._v("\n              +\n              " + _vm._s(_vm.allCommissionLan.CPACommission + ' : ') + "\n              "), _vm._l((item.cpa), function(data, key) {
      return _c('span', [_vm._v("\n                  " + _vm._s(data) + " " + _vm._s(_vm.allCommissionLan.unit) + " \n                  "), (key < item.cpa.length - 1) ? _c('span', [_vm._v("/")]) : _vm._e()])
    })], 2) : _c('td')])
  }), 0)])]), _vm._v(" "), (_vm.selPage) ? _c('div', {
    staticClass: "datatable-footer"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "id": "DataTables_Table_2_info",
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.allCommissionLan.clauses) + _vm._s(_vm.allCommissionLan.amount) + ": \n          " + _vm._s(_vm.page.pageLeng) + "  " + _vm._s(_vm.allCommissionLan.present) + ": " + _vm._s(_vm.page.active * _vm.selPage.limit - _vm.selPage.limit + 1) + "-" + _vm._s(Math.min(_vm.page.active * _vm.selPage.limit, _vm.page.pageLeng)) + "\n      ")]), _vm._v(" "), (Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active]) > 1) ? _c('div', {
    staticClass: "dataTables_paginate paging_simple_numbers",
    attrs: {
      "id": "DataTables_Table_2_paginate"
    }
  }, [_c('pagination', {
    attrs: {
      "boundary-links": true,
      "direction-links": true,
      "total-page": Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active]),
      "max-size": 5
    },
    on: {
      "change": _vm.callpageFn
    },
    model: {
      value: (_vm.pageactive),
      callback: function($$v) {
        _vm.pageactive = $$v
      },
      expression: "pageactive"
    }
  })], 1) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.monthlyLan.indexText))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "back": _vm.back,
      "downLoadTran": _vm.downLoadTran,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "link": _vm.link,
      "multiLanguage": _vm.monthlyLan,
      "name": _vm.name,
      "page": _vm.page,
      "region": _vm.curArea,
      "selPage": _vm.selPage,
      "thData": _vm.thData,
      "trData": _vm.trData
    },
    on: {
      "tableChange": _vm.tableAjax
    }
  }, [_c('div', {
    staticClass: "monthlyHandle",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.monthlyLan.start_time))]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.monthlyLan.selectTimeText
    },
    model: {
      value: (_vm.beginTime),
      callback: function($$v) {
        _vm.beginTime = $$v
      },
      expression: "beginTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.monthlyLan.end_time))]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.monthlyLan.selectTimeText
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btnDiv"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v(_vm._s(_vm.monthlyLan.search))])], 1)])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seekDatePicker m-r-30 mtable-tool-seek"
  }, [_c('Dropdown', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:YYYY-MM-DD'),
      expression: "'required|date_format:YYYY-MM-DD'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.seekDatePicker.startDate),
      expression: "seekDatePicker.startDate"
    }],
    ref: "birth_date",
    staticClass: "form-control input-date input-date1",
    attrs: {
      "name": "startDate",
      "type": "text",
      "col-lg-12": "",
      "placeholder": _vm.seekLan.err.dateFormat
    },
    domProps: {
      "value": (_vm.seekDatePicker.startDate)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.emitSeek.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.seekDatePicker, "startDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default date date1",
    attrs: {
      "type": "button",
      "data-role": "trigger"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-calendar"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, [_c('li', [_c('DatePicker', {
    staticClass: "date-picker",
    attrs: {
      "format": 'yyyy-MM-dd',
      "close-on-selected": true
    },
    model: {
      value: (_vm.seekDatePicker.startDate),
      callback: function($$v) {
        _vm.$set(_vm.seekDatePicker, "startDate", $$v)
      },
      expression: "seekDatePicker.startDate"
    }
  })], 1)])], 2), _vm._v(" "), _c('Dropdown', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.testStopDate),
      expression: "testStopDate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.seekDatePicker.endDate),
      expression: "seekDatePicker.endDate"
    }],
    ref: "birth_date",
    staticClass: "form-control input-date",
    attrs: {
      "name": "endDate",
      "type": "text",
      "col-lg-12": "",
      "placeholder": _vm.seekLan.err.dateFormat
    },
    domProps: {
      "value": (_vm.seekDatePicker.endDate)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.emitSeek.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.seekDatePicker, "endDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default date",
    attrs: {
      "type": "button",
      "data-role": "trigger"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-calendar"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, [_c('li', [_c('DatePicker', {
    staticClass: "date-picker",
    attrs: {
      "format": 'yyyy-MM-dd',
      "close-on-selected": true
    },
    model: {
      value: (_vm.seekDatePicker.endDate),
      callback: function($$v) {
        _vm.$set(_vm.seekDatePicker, "endDate", $$v)
      },
      expression: "seekDatePicker.endDate"
    }
  })], 1)])], 2), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default btn-primary",
    on: {
      "click": _vm.emitSeek
    }
  }, [_vm._v(_vm._s(_vm.seekLan.seek))])], 1)
},staticRenderFns: []}

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ruleSetting-box"
  }, [_c('div', {
    staticClass: "ruleLevel-btn-box"
  }, [_c('div', {
    staticClass: "pull-right",
    style: (_vm.version == '0' ? 'visibility:hidden;' : '')
  }, [_c('button', {
    staticClass: "btn btn-style-add",
    attrs: {
      "disabled": !_vm.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.addLevel
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.addLevel) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-style-remove",
    attrs: {
      "disabled": !_vm.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.removeLevel
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-trash"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.removeLevel) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('draggable', {
    attrs: {
      "list": _vm.rule,
      "options": {
        group: 'levelGroup',
        disabled: _vm.onfocus
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.newRelation),
      callback: function($$v) {
        _vm.newRelation = $$v
      },
      expression: "newRelation"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": 'flip-list'
    }
  }, _vm._l((_vm.rule), function(levelItem, levelIndex) {
    return _c('div', {
      key: levelIndex,
      staticClass: "rule-content-box panel panel-default",
      class: {
        'disabled': !_vm.enable || _vm.version == '0'
      }
    }, [_c('div', {
      staticClass: "panel-heading title-bg"
    }, [_c('div', {
      staticClass: "panel-title"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('label', [(levelIndex !== _vm.rule.length - 1) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedLevel),
        expression: "checkedLevel"
      }],
      style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.enable || _vm.version == '0'
      },
      domProps: {
        "value": levelIndex,
        "checked": Array.isArray(_vm.checkedLevel) ? _vm._i(_vm.checkedLevel, levelIndex) > -1 : (_vm.checkedLevel)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedLevel,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = levelIndex,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedLevel = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedLevel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedLevel = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "primary-color"
    }, [_vm._v("\n                  " + _vm._s(levelIndex == _vm.rule.length - 1 ? _vm.ruleSettingLan.currentSetting : levelIndex + 1 + _vm.ruleSettingLan.levelSetting) + "\n                  "), (levelIndex == _vm.rule.length - 1) ? _c('span', [_vm._v("\n                    (" + _vm._s(_vm.currentIB.id + '-' + _vm.currentIB.name) + ")\n                  ")]) : _c('span', [_vm._v("\n                    (\n                      " + _vm._s(_vm.newRelation[levelIndex].id !== 'not exist' ? _vm.newRelation[levelIndex].id + '-' + (_vm.newRelation[levelIndex].name === 'not exist' ? _vm.ruleSettingLan.notSalesSet : _vm.newRelation[levelIndex].name) : _vm.ruleSettingLan.notExist) + "\n                    )\n                  ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "pull-right",
      style: (_vm.version == '0' ? 'visibility:hidden;' : '')
    }, [_c('button', {
      staticClass: "btn btn-style-add",
      attrs: {
        "disabled": !_vm.enable || _vm.version == '0'
      },
      on: {
        "click": function($event) {
          return _vm.addRule(levelItem)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-plus"
    }), _vm._v("\n                " + _vm._s(_vm.ruleSettingLan.addRule) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])]), _vm._v(" "), _c('draggable', {
      attrs: {
        "list": levelItem,
        "options": {
          group: 'ruleGroup',
          disabled: _vm.onfocus
        }
      },
      on: {
        "start": function($event) {
          _vm.drag = true
        },
        "end": function($event) {
          _vm.drag = false
        }
      }
    }, [_c('transition-group', {
      attrs: {
        "type": "transition",
        "name": 'flip-list'
      }
    }, _vm._l((levelItem), function(ruleItem, ruleIndex) {
      return _c('div', {
        key: ruleIndex,
        staticClass: "panel-body"
      }, [_c('div', {
        staticClass: "rule-title"
      }, [_c('div', {
        staticClass: "pull-left primary-color"
      }, [_vm._v(_vm._s(_vm.ruleSettingLan.rule) + _vm._s(ruleIndex + 1))]), _vm._v(" "), _c('div', {
        staticClass: "pull-right",
        style: (_vm.version == '0' ? 'visibility:hidden;' : '')
      }, [_c('button', {
        staticClass: "btn btn-xs",
        attrs: {
          "disabled": !_vm.enable || _vm.version == '0'
        },
        on: {
          "click": function($event) {
            return _vm.removeRule(levelItem, ruleIndex)
          }
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-trash"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "clear"
      })]), _vm._v(" "), _c('div', {
        staticClass: "rule-content"
      }, [_c('div', {
        staticClass: "form-horizontal",
        class: {
          'row': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "form-group",
        class: {
          'col-sm-6': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "col-sm-6"
      }, [_c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.enableCommTarget),
          expression: "ruleItem.enableCommTarget"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'enableCommTarget',
          "disabled": !_vm.enable || _vm.version == '0'
        },
        domProps: {
          "value": false,
          "checked": _vm._q(ruleItem.enableCommTarget, false)
        },
        on: {
          "change": function($event) {
            return _vm.$set(ruleItem, "enableCommTarget", false)
          }
        }
      }), _vm._v("\n                        " + _vm._s(_vm.ruleSettingLan.toOriginalAccount) + "\n                      ")]), _vm._v(" "), _c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.enableCommTarget),
          expression: "ruleItem.enableCommTarget"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'enableCommTarget',
          "disabled": !_vm.enable || _vm.version == '0'
        },
        domProps: {
          "value": true,
          "checked": _vm._q(ruleItem.enableCommTarget, true)
        },
        on: {
          "change": function($event) {
            return _vm.$set(ruleItem, "enableCommTarget", true)
          }
        }
      }), _vm._v("\n                        " + _vm._s(_vm.ruleSettingLan.toTargetAccount) + "\n                      ")])]), _vm._v(" "), _c('label', {
        staticClass: "col-sm-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.commTarget),
          expression: "ruleItem.commTarget"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|numeric'),
          expression: "'required|numeric'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'commTarget') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enable || _vm.version == '0' || !ruleItem.enableCommTarget,
          "name": levelIndex + '_' + ruleIndex + '_' + 'commTarget'
        },
        domProps: {
          "value": (ruleItem.commTarget)
        },
        on: {
          "focus": function($event) {
            _vm.onfocus = true
          },
          "blur": function($event) {
            _vm.onfocus = false
          },
          "change": function($event) {
            return _vm.checkId(ruleItem)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(ruleItem, "commTarget", $event.target.value)
          }
        }
      })])])]), _vm._v(" "), _c('div', {
        staticClass: "form-inline",
        class: {
          'col-sm-6 row': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "radio-inline flex-item-left"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'ruleId',
          "disabled": !_vm.enable || _vm.version == '0',
          "checked": ""
        },
        domProps: {
          "value": 0
        }
      }), _vm._v("\n                      " + _vm._s(_vm.ruleSettingLan.customTheMoney) + "\n                    ")])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        staticClass: "input-group"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.ruleId),
          expression: "ruleItem.ruleId"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'ruleId') ? 'border-color:#f44336;' : ''),
        attrs: {
          "disabled": !_vm.enable || _vm.version == '0',
          "name": levelIndex + '_' + ruleIndex + '_' + 'ruleId'
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(ruleItem, "ruleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return _c('option', {
          domProps: {
            "value": ruleSeqItem.ruleId
          }
        }, [_vm._v("\n                          " + _vm._s(_vm.publicLan.rule[ruleSeqItem.langKey.split('.')[1]]) + "\n                        ")])
      }), 0), _vm._v(" "), _c('span', {
        staticClass: "input-group-addon"
      }, [_c('el-tooltip', {
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "placement": "top-start",
          "disabled": !_vm.enable || _vm.version == '0'
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-tags"
      }), _vm._v(" "), _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return (ruleSeqItem.ruleId === ruleItem.ruleId) ? _c('div', {
          staticStyle: {
            "width": "180px",
            "line-height": "20px"
          },
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v("\n                              " + _vm._s(_vm.publicLan.rule[ruleSeqItem.descLangKey.split('.')[1]]) + "\n                          ")]) : _vm._e()
      })], 2)], 1)])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.value),
          expression: "ruleItem.value"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|min_value:0.0001|decimal:4'),
          expression: "'required|min_value:0.0001|decimal:4'"
        }],
        staticClass: "form-control",
        staticStyle: {
          "border-radius": "3px"
        },
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'value1') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enable || _vm.version == '0',
          "name": levelIndex + '_' + ruleIndex + '_' + 'value1'
        },
        domProps: {
          "value": (ruleItem.value)
        },
        on: {
          "focus": function($event) {
            _vm.onfocus = true
          },
          "blur": function($event) {
            _vm.onfocus = false
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(ruleItem, "value", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.clientType),
          expression: "ruleItem.clientType"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'clientType') ? 'border-color:#f44336;' : ''),
        attrs: {
          "disabled": !_vm.enable || _vm.version == '0',
          "name": levelIndex + '_' + ruleIndex + '_' + 'clientType'
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(ruleItem, "clientType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        domProps: {
          "value": 0
        }
      }, [_vm._v(_vm._s(_vm.publicLan.clientType.allClient))]), _vm._v(" "), _c('option', {
        domProps: {
          "value": 1
        }
      }, [_vm._v(_vm._s(_vm.publicLan.clientType.IBClient))]), _vm._v(" "), _c('option', {
        domProps: {
          "value": 2
        }
      }, [_vm._v(_vm._s(_vm.publicLan.clientType.directClient))])])])]), _vm._v(" "), _c('div', {
        staticClass: "clear"
      })])])
    }), 0)], 1)], 1)
  }), 0)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.CPAResultLan.indexText))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "page": _vm.page,
      "selPage": _vm.selPage,
      "link": _vm.link,
      "back": _vm.back,
      "multiLanguage": _vm.CPAResultLan,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "downLoadTran": _vm.downLoadTran,
      "name": _vm.name
    },
    on: {
      "tableChange": _vm.tableAjax
    }
  }, [_c('div', {
    staticClass: "CPAHandle",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.CPAResultLan.start_time))]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.CPAResultLan.selectTimeText
    },
    model: {
      value: (_vm.beginTime),
      callback: function($$v) {
        _vm.beginTime = $$v
      },
      expression: "beginTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.CPAResultLan.end_time))]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.CPAResultLan.selectTimeText
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btnDiv"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v(_vm._s(_vm.CPAResultLan.search))])], 1)])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seek"
  }, [(Object.keys(_vm.seekDropdown.list).length != 1) ? _c('Dropdown', {
    staticClass: "pull-left seekDropdown"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle hui-dropdown-toggle",
    attrs: {
      "data-role": "trigger",
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.seekLan.dropdown[_vm.seekDropdown.active]))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _vm._l((_vm.seekLan.dropdown), function(item, index) {
    return (_vm.seekDropdown.list[index]) ? _c('template', {
      slot: "dropdown"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.setSeekDropdown(index)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(item))])])]) : _vm._e()
  })], 2) : _c('div', {
    staticClass: "pull-left seekDropdown dropdown"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle hui-dropdown-toggle no-pointer",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.seekLan.dropdown[_vm.seekDropdown.active]))])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.seekDropdown.seekStr),
      expression: "seekDropdown.seekStr"
    }],
    staticClass: "form-control hui-form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.seekLan.seek
    },
    domProps: {
      "value": (_vm.seekDropdown.seekStr)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.emitSeek.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.seekDropdown, "seekStr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left btn btn-default btn-primary",
    on: {
      "click": _vm.emitSeek
    }
  }, [_vm._v(_vm._s(_vm.seekLan.seek))]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "region-box pull-left"
  }, [_c('button', {
    staticClass: "back pull-left"
  }, [_c('img', {
    staticStyle: {
      "width": "24px",
      "margin-top": "3px"
    },
    attrs: {
      "src": __webpack_require__(416)
    },
    on: {
      "click": function($event) {
        return _vm.jump('/sale_v2/saleSetting')
      }
    }
  })]), _vm._v(" "), (_vm.apiChangeable && _vm.$route.path.split('/')[2] !== 'saleCommissionSetting') ? _c('div', {
    staticClass: "btn-group pull-left"
  }, _vm._l((_vm.area), function(item, key) {
    return _c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': item == _vm.actArea
      },
      on: {
        "click": function($event) {
          return _vm.areaGroupSwitchFn(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item) + "\n           ")])
  }), 0) : _c('div', {
    staticClass: "btn-group pull-left"
  }, _vm._l((_vm.area), function(item, key) {
    return _c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': item == _vm.actArea
      }
    }, [_vm._v("\n                " + _vm._s(item) + "\n           ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('btn-group', {
    staticClass: "primary-box pull-right"
  }, [_c('btn', {
    class: {
      'active': (_vm.activePrimary == '/saleSetting' || _vm.activePrimary == '/saleCommissionSetting')
    },
    on: {
      "click": function($event) {
        return _vm.jump('/sale_v2/saleSetting')
      }
    }
  }, [_vm._v("\n             " + _vm._s(_vm.salePrimaryLan.commissionSetting) + "\n          ")]), _vm._v(" "), _c('Dropdown', {
    staticClass: "pull-left seekDropdown",
    staticStyle: {
      "margin-left": "-1px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    class: {
      'active': _vm.activePrimary.indexOf('Result') != -1
    },
    attrs: {
      "data-role": "trigger",
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.salePrimaryLan.saleResult.title))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _vm._l((_vm.salePrimaryLan.saleResult_v2.list), function(item, index) {
    return _c('template', {
      slot: "dropdown"
    }, [_c('li', {
      class: {
        'active': _vm.activePrimary == item.link
      },
      on: {
        "click": function($event) {
          return _vm.jump(item.link)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.text))])])])
  })], 2), _vm._v(" "), _c('Dropdown', {
    staticClass: "pull-left seekDropdown",
    staticStyle: {
      "margin-left": "-1px"
    },
    attrs: {
      "menu-right": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    class: {
      'active': _vm.activePrimary.indexOf('Report') != -1
    },
    attrs: {
      "data-role": "trigger",
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.salePrimaryLan.saleReport.title))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _vm._l((_vm.salePrimaryLan.saleReport_v2.list), function(item, index) {
    return _c('template', {
      slot: "dropdown"
    }, [_c('li', {
      class: {
        'active': _vm.activePrimary == item.link
      },
      on: {
        "click": function($event) {
          return _vm.jump(item.link)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.text))])])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "curArea": _vm.curArea,
      "status": _vm.status
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.salesMonDetailLan.datailText) + "(" + _vm._s(_vm.queryObj.REPORT_ID) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('el-button', {
    staticClass: "preview-btn",
    attrs: {
      "round": "",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.salesMonDetailLan.goback))])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    ref: "table",
    attrs: {
      "downLoadTran": _vm.downLoadTran,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "multiLanguage": _vm.salesMonDetailLan,
      "name": _vm.name,
      "thData": _vm.thData,
      "trData": _vm.trData
    }
  }, [_c('div', {
    staticClass: "monthly-detail",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "monthly-detail"
  }, [_c('span', [_vm._v(_vm._s(_vm.salesMonDetailLan.salesAccount) + " " + _vm._s(_vm.queryObj.SALES_ID))])]), _vm._v(" "), _c('div', {
    staticClass: "monthly-detail"
  }, [_c('span', [_vm._v(_vm._s(_vm.salesMonDetailLan.commissionType) + " " + _vm._s(_vm.queryObj.type))])]), _vm._v(" "), (_vm.isLower) ? _c('div', {
    staticClass: "monthly-detail"
  }, [_c('el-switch', {
    attrs: {
      "active-text": _vm.salesMonDetailLan.spread,
      "inactive-text": _vm.salesMonDetailLan.fold,
      "active-color": "#3F51B5"
    },
    on: {
      "change": _vm.actionChange
    },
    model: {
      value: (_vm.action),
      callback: function($$v) {
        _vm.action = $$v
      },
      expression: "action"
    }
  })], 1) : _vm._e()])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": (_vm.width + "%")
    }
  }, [_c('div', {
    staticClass: "root"
  }, [_vm._l((_vm.newData), function(d, i) {
    return _c('div', {
      key: i,
      class: _vm.editable ? 'data' : '',
      attrs: {
        "cell-type": "list",
        "title": _vm.editable ? ("Click to Delete value: " + d) : ''
      },
      on: {
        "click": function($event) {
          _vm.editable ? _vm.deleteDataAt(i) : void ''
        }
      }
    }, [_vm._v(_vm._s(d))])
  }), _vm._v(" "), (_vm.addItem == null && _vm.editable) ? _c('div', {
    key: "plus",
    staticClass: "plus",
    attrs: {
      "title": "add a new data"
    },
    on: {
      "click": _vm.adding
    }
  }, [_vm._v("+")]) : (_vm.editable) ? _c('div', {
    key: "adding",
    staticClass: "adding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.addItem),
      expression: "addItem",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "pattern": "pattern",
      "placeholder": _vm.tips || ("/" + _vm.pattern + "/")
    },
    domProps: {
      "value": (_vm.addItem)
    },
    on: {
      "change": function($event) {
        _vm.addItem = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "save",
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Save")])]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commissionDatum"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enable),
      expression: "enable"
    }],
    staticClass: "enable-btn",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.version == '0'
    },
    domProps: {
      "checked": Array.isArray(_vm.enable) ? _vm._i(_vm.enable, null) > -1 : (_vm.enable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.enable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.enable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enable = $$c
        }
      }
    }
  }), _vm._v(" \n        "), _c('span', {
    staticClass: "enable-text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.enable))])]), _vm._v(" "), _c('span', {
    staticClass: "table-title"
  }, [_vm._v(_vm._s(_vm.multiLanguage.salesCommissionSetting) + " "), (_vm.version == '1') ? _c('span', [_vm._v("(" + _vm._s(_vm.isConfirm ? _vm.multiLanguage.confirmed : _vm.multiLanguage.unconfirmed) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "btn-box pull-right"
  }, [(_vm.version == '1') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.verify
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-ok"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.check) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.version == '1') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.submit
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-edit"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.submit) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.version == '1') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.pageInit('0')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-repeat"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.backData) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "last-update-box"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.multiLanguage.updateBy) + " : " + _vm._s(_vm.updateBy) + " (" + _vm._s(_vm.lastUpdate) + ")")]), _vm._v(" "), (_vm.version == '0') ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.multiLanguage.confirmBy) + " : " + _vm._s(_vm.confirmBy) + " (" + _vm._s(_vm.lastConfirm) + ")")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "cpa-switch-box"
  }, [_c('div', {
    staticClass: "preinstall-box pull-right",
    style: (_vm.version == '0' ? 'visibility:hidden;' : '')
  }, [_c('Dropdown', {
    attrs: {
      "menu-right": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "data-role": "trigger",
      "type": "button",
      "disabled": !_vm.enable || _vm.version == '0'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.settingTemplate))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, _vm._l((_vm.salesTemplate), function(item, index) {
    return (item.isDisplay) ? _c('li', {
      on: {
        "click": function($event) {
          return _vm.normSetFn(item.templateId)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(_vm.multiLanguage[item.langKey] || item.templateId))])]) : _vm._e()
  }), 0)], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div'), _vm._v(" "), _c('rule-setting', {
    ref: "ruleSetting",
    attrs: {
      "enable": _vm.enable,
      "multiLanguage": _vm.multiLanguage,
      "version": _vm.version,
      "relation": _vm.relation,
      "currentIB": _vm.currentIB,
      "viewBtn": _vm.viewBtn,
      "rule": _vm.rule,
      "ruleSeq": _vm.ruleSeq
    },
    on: {
      "checkId": _vm.checkIdFn
    }
  }), _vm._v(" "), _c('special-and-overlook', {
    ref: "specialAndOverlook",
    attrs: {
      "enable": _vm.enable,
      "multiLanguage": _vm.multiLanguage,
      "version": _vm.version,
      "specialIB": _vm.specialIB,
      "overlookIB": _vm.overlookIB,
      "curArea": _vm.curArea
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "size": "sm",
      "header": false,
      "footer": false
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sucSave),
      expression: "!sucSave"
    }]
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-warning-sign color-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v(_vm._s(_vm.multiLanguage.submitResult.err))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sucSave),
      expression: "sucSave"
    }]
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-ok color-green"
  }), _vm._v(" "), _c('span', {
    staticClass: "color-green"
  }, [_vm._v(_vm._s(_vm.multiLanguage.submitResult.succeed))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper no-footer mtable"
  }, [_vm._t("menu"), _vm._v(" "), _c('div', {
    staticClass: "datatable-header mtable-tool hui-group-dib-box"
  }, [(_vm.seekDatePicker) ? _c('seekDatePicker', {
    staticClass: "pull-left m-r-30 mtable-tool-seek",
    attrs: {
      "seekDatePicker": _vm.seekDatePicker
    },
    on: {
      "seekDatePicker": _vm.seekDatePickerFn
    }
  }) : _vm._e(), _vm._v(" "), (_vm.seekDropdown) ? _c('seek', {
    staticClass: "pull-left m-r-30 mtable-tool-seek",
    attrs: {
      "seekDropdown": _vm.seekDropdownProps
    },
    on: {
      "clickSeekDropdown": _vm.clickSeekDropdown,
      "seek": _vm.seek
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selPage) ? _c('selPage', {
    staticClass: "pull-right",
    attrs: {
      "multiLanguage": _vm.multiLanguage,
      "selPage": _vm.selPage
    },
    on: {
      "selPage": _vm.selPageFn
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group p-0 pull-left mtable-tool-fn"
  }, [_vm._t("return-back"), _vm._v(" "), _vm._t("handle"), _vm._v(" "), (_vm.operate.checkbox) ? _c('div', {
    staticClass: "commission-confirm"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.checkedArr.length == 0,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateStatus(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.confirm))])], 1) : _vm._e(), _vm._v(" "), (_vm.operate.checkbox) ? _c('div', {
    staticClass: "commission-confirm"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.checkedArr.length == 0 || _vm.refuseReason.length == 0,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateStatus(4)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.reject))])], 1) : _vm._e(), _vm._v(" "), (_vm.operate.checkbox) ? _c('div', {
    staticClass: "commission-confirm"
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.checkedArr.length == 0,
      "placeholder": _vm.multiLanguage.rejectMessage,
      "autosize": "",
      "type": "textarea"
    },
    model: {
      value: (_vm.refuseReason),
      callback: function($$v) {
        _vm.refuseReason = $$v
      },
      expression: "refuseReason"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.jsonExcelAjax) ? _c('jsonExcel', {
    staticClass: "btn btn-default",
    attrs: {
      "ajaxGetKey": _vm.jsonExcelAjax.getKey,
      "ajaxPar": _vm.jsonExcelAjax.ajaxPar || false,
      "ajaxType": _vm.jsonExcelAjax.ajaxType,
      "ajaxUrl": _vm.jsonExcelAjax.url || false,
      "cID": _vm.jsonExcelAjax.cID,
      "downLoadTran": _vm.downLoadTran,
      "keys": _vm.thData,
      "name": _vm.name,
      "rID": _vm.jsonExcelAjax.rID,
      "type": _vm.jsonExcelAjax.type
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-save tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.downloadExcelForms) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.detailExcelAjax) ? _c('jsonExcel', {
    staticClass: "btn btn-default",
    attrs: {
      "ajaxGetKey": _vm.detailExcelAjax.getKey,
      "ajaxPar": _vm.detailExcelAjax.ajaxPar || false,
      "ajaxType": _vm.detailExcelAjax.ajaxType,
      "ajaxUrl": _vm.detailExcelAjax.url || false,
      "downLoadTran": _vm.downLoadTran,
      "keys": _vm.detailTh,
      "name": _vm.detailName,
      "rID": _vm.detailExcelAjax.rID
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-save tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.downloadDetailExcel) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.multiExcelAjax) ? _c('multi-sheet-excel', {
    staticClass: "btn btn-default",
    attrs: {
      "ajaxGetKey": _vm.multiExcelAjax.getKey,
      "ajaxPar": _vm.multiExcelAjax.ajaxPar || false,
      "ajaxType": _vm.multiExcelAjax.ajaxType,
      "ajaxUrl": _vm.multiExcelAjax.url || false,
      "dataTh": _vm.multiExcelAjax.dataTh,
      "downloadName": _vm.multiLanguage.downloadName,
      "firstTh": _vm.firstTh,
      "rID": _vm.multiExcelAjax.rID,
      "secondTh": _vm.secondTh,
      "sheetName": _vm.multiLanguage.sheetName
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-save tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.downloadDetailExcel) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.multiExcelAjax.filter) ? _c('multi-sheet-excel', {
    staticClass: "btn btn-default",
    attrs: {
      "ajaxGetKey": _vm.multiExcelAjax.getKey,
      "ajaxPar": _vm.multiExcelAjax.ajaxPar || false,
      "ajaxType": _vm.multiExcelAjax.ajaxType,
      "ajaxUrl": _vm.multiExcelAjax.url || false,
      "dataTh": _vm.multiExcelAjax.dataTh,
      "downloadName": _vm.multiExcelAjax.filter.filterDownloadName,
      "filter": _vm.multiExcelAjax.filter,
      "firstTh": _vm.firstTh,
      "rID": _vm.multiExcelAjax.rID,
      "secondTh": _vm.secondTh,
      "sheetName": _vm.multiLanguage.sheetName
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-save tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiExcelAjax.filter.btnName) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.handle && _vm.handle.link === 'accountDatum') ? _c('router-link', {
    staticClass: "btn btn-default",
    class: {
      'radius-r': !_vm.handle.delete
    },
    attrs: {
      "to": _vm.handle.link
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-new-window tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.addAccount) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handle.delete && !_vm.deleteCol.switch),
      expression: "handle.delete && !deleteCol.switch"
    }],
    staticClass: "btn btn-default btn-danger mtable-tool-delete",
    class: {
      'radius-r': _vm.handle.delete
    },
    on: {
      "click": function($event) {
        _vm.deleteCol.switch = true
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-trash tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.deletedData) + "\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handle.delete && _vm.deleteCol.switch),
      expression: "handle.delete && deleteCol.switch"
    }],
    staticClass: "btn btn-default btn-danger mtable-tool-delete",
    class: {
      'radius-r': _vm.handle.delete
    },
    on: {
      "click": _vm.deleteColNotarizeFn
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-log-out tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.confirmDelete) + "\n      ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "datatable-scroll",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_vm._t("datatable-scroll"), _vm._v(" "), _vm._t("title-name"), _vm._v(" "), (Array.isArray(_vm.trData[0])) ? _c('div', [_c('table', {
    staticClass: "table table-striped table-bordered table-hover datatable-highlight dataTable no-footer",
    attrs: {
      "aria-describedby": "DataTables_Table_2_info",
      "id": "DataTables_Table_2",
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.operate.checkbox) ? _c('th') : _vm._e(), _vm._v(" "), _vm._l((_vm.thData), function(item, index) {
    return (item.flag === undefined ? true : item.flag) ? _c('th', {
      class: {
        sorting: item.sort
      },
      on: {
        "click": function($event) {
          return _vm.sortFn(item.key, item.sort)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()
  }), _vm._v(" "), (_vm.handle) ? _c('th', {
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.th.operation))]) : _vm._e()], 2)]), _vm._v(" "), _vm._l((_vm.trData), function(trArr, under) {
    return _c('tbody', {
      class: {
        'deleteCol-opt': _vm.handle.delete
      }
    }, _vm._l((trArr), function(item, index) {
      return _c('tr', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (trArr.length > 0),
          expression: "trArr.length > 0"
        }],
        class: _vm.trCls && _vm.trCls(item, index),
        attrs: {
          "role": "row"
        },
        on: {
          "click": function($event) {
            return _vm.clickColFn(item, index)
          }
        }
      }, [(_vm.operate.checkbox) ? _c('td', [([3, 4].indexOf(+item.STATUS) == -1) ? _c('input', {
        attrs: {
          "type": "checkbox"
        },
        on: {
          "change": function($event) {
            return _vm.updateCheckArr(item)
          }
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.thData), function(obj) {
        return (obj.flag === undefined ? true : obj.flag) ? _c('td', {
          staticClass: "sorting_1",
          class: {
            'pointer': _vm.deleteCol.switch
          }
        }, [(_vm.link && _vm.link.key.indexOf(obj.key) > -1) ? _c('a', {
          on: {
            "click": function($event) {
              return _vm.linkDetails(item)
            }
          }
        }, [_vm._v(_vm._s(item[obj.key]))]) : _c('span', [_vm._v(_vm._s(item[obj.key]))])]) : _vm._e()
      })], 2)
    }), 0)
  })], 2)]) : _c('div', [_c('table', {
    staticClass: "table table-striped table-bordered table-hover datatable-highlight dataTable no-footer",
    attrs: {
      "aria-describedby": "DataTables_Table_2_info",
      "id": "DataTables_Table_2",
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.operate.checkbox) ? _c('th', [(_vm.selectData.length !== 0) ? _c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.checkAll
    },
    model: {
      value: (_vm.selectAll),
      callback: function($$v) {
        _vm.selectAll = $$v
      },
      expression: "selectAll"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.thData), function(item, index) {
    return (item.flag === undefined ? true : item.flag) ? _c('th', {
      class: {
        sorting: item.sort
      },
      on: {
        "click": function($event) {
          return _vm.sortFn(item.key, item.sort)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()
  }), _vm._v(" "), (_vm.handle) ? _c('th', {
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.th.operation))]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', {
    class: {
      'deleteCol-opt': _vm.handle.delete
    }
  }, [_vm._l((_vm.trData), function(item, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.trData.length > 0),
        expression: "trData.length > 0"
      }],
      class: _vm.trCls && _vm.trCls(item, index),
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          return _vm.clickColFn(item, index)
        }
      }
    }, [(_vm.operate.checkbox) ? _c('td', [([3, 4].indexOf(+item.STATUS) == -1) ? _c('el-checkbox', {
      on: {
        "change": function($event) {
          return _vm.updateCheckArr(item)
        }
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.thData), function(obj) {
      return (obj.flag === undefined ? true : obj.flag) ? _c('td', {
        staticClass: "sorting_1",
        class: {
          'pointer': _vm.deleteCol.switch
        },
        on: {
          "click": function($event) {
            return _vm.deletePitch(item)
          }
        }
      }, [(_vm.link && _vm.link.key.indexOf(obj.key) > -1) ? _c('a', {
        on: {
          "click": function($event) {
            return _vm.linkDetails(item)
          }
        }
      }, [_vm._v(_vm._s(item[obj.key]))]) : (_vm.tip && _vm.tip.key.indexOf(obj.key) > -1) ? _c('span', [_c('el-tooltip', [_c('div', {
        attrs: {
          "slot": "content"
        },
        slot: "content"
      }, _vm._l((JSON.parse(item[obj.key])), function(tips, value) {
        return _c('span', [_vm._v("\n                      " + _vm._s(value) + "  :  " + _vm._s(tips) + "\n                      "), _c('br')])
      }), 0), _vm._v(" "), (item[obj.key] && item[obj.key].length > 40) ? _c('span', [_vm._v(_vm._s(item[obj.key].substr(0, 40) + '...'))]) : _c('span', [_vm._v(_vm._s(item[obj.key]))])])], 1) : _c('span', [_vm._v(_vm._s(item[obj.key]))])]) : _vm._e()
    }), _vm._v(" "), (_vm.handle) ? _c('td', {
      staticClass: "text-center pointer",
      class: {
        'pointer': _vm.deleteCol.switch
      },
      on: {
        "click": function($event) {
          return _vm.linkRegister(item)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.deleteCol.switch),
        expression: "!deleteCol.switch"
      }],
      staticClass: "icon-compose"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.deleteCol.switch && _vm.deleteCol.list.indexOf(item[_vm.handle.idKey]) != -1),
        expression: "deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) != -1"
      }],
      staticClass: "glyphicon glyphicon-ok color-red"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.deleteCol.switch && _vm.deleteCol.list.indexOf(item[_vm.handle.idKey]) == -1),
        expression: "deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) == -1"
      }],
      staticClass: "glyphicon glyphicon-trash tab-he-glyphicon"
    })]) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.trData.length > 0 && Object.keys(_vm.totalTr).length > 0) ? _c('tr', _vm._l((_vm.totalTr), function(item) {
    return _c('td', [_vm._v(_vm._s(item))])
  }), 0) : _vm._e()], 2)])]), _vm._v(" "), (_vm.trData.length == 0) ? _c('noData', {
    attrs: {
      "fontSize": '18',
      "text": _vm.multiLanguage.nodata
    }
  }) : _vm._e()], 2), _vm._v(" "), (_vm.selPage) ? _c('div', {
    staticClass: "datatable-footer"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "aria-live": "polite",
      "id": "DataTables_Table_2_info",
      "role": "status"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.clauses) + _vm._s(_vm.multiLanguage.amount) + ": " + _vm._s(_vm.page.pageLeng) + "  " + _vm._s(_vm.multiLanguage.present) + ": " + _vm._s(_vm.page.active * _vm.selPage.limit - _vm.selPage.limit + 1) + "-" + _vm._s(Math.min(_vm.page.active * _vm.selPage.limit, _vm.page.pageLeng)))]), _vm._v(" "), (Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active])) ? _c('div', {
    staticClass: "dataTables_paginate paging_simple_numbers",
    attrs: {
      "id": "DataTables_Table_2_paginate"
    }
  }, [_c('pagination', {
    attrs: {
      "boundary-links": true,
      "direction-links": true,
      "max-size": _vm.page.pagenum,
      "total-page": Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active])
    },
    on: {
      "change": _vm.callpageFn
    },
    model: {
      value: (_vm.page.active),
      callback: function($$v) {
        _vm.$set(_vm.page, "active", $$v)
      },
      expression: "page.active"
    }
  })], 1) : _vm._e()]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.detailLan.detailText) + "  (" + _vm._s(_vm.queryObj.MODIFIED_ID) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('el-button', {
    staticClass: "preview-btn",
    attrs: {
      "type": "warning",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.detailLan.goback) + "\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "page": _vm.page,
      "selPage": _vm.selPage,
      "tip": _vm.tip,
      "multiLanguage": _vm.detailLan,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "downLoadTran": _vm.downLoadTran,
      "name": _vm.name
    },
    on: {
      "tableChange": _vm.tableAjax
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.multiLanguage.detail) + "  (" + _vm._s(_vm.obj.IB_ID) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('el-button', {
    staticClass: "preview-btn",
    attrs: {
      "round": "",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.return))])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "downLoadTran": _vm.downLoadTran,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "multiLanguage": _vm.multiLanguage,
      "name": _vm.name,
      "thData": _vm.thData,
      "trData": _vm.trData
    }
  }, [_c('div', {
    staticClass: "handleDiv",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "spanDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.IB_ID) + " " + _vm._s(_vm.obj.IB_ID))])]), _vm._v(" "), _c('div', {
    staticClass: "spanDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.typeText) + " " + _vm._s(_vm.obj.type))])]), _vm._v(" "), _c('div', {
    staticClass: "spanDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.deposit_order_id) + " " + _vm._s(_vm.obj.DEPOSIT_ORDER_ID))])]), _vm._v(" "), _c('div', {
    staticClass: "spanDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.start_time) + " " + _vm._s(_vm.obj.BEGINTIME))])]), _vm._v(" "), _c('div', {
    staticClass: "spanDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.end_time) + " " + _vm._s(_vm.obj.ENDTIME))])])])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.detailLan.datailText) + "  (" + _vm._s(_vm.queryObj.REPORT_ID) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('el-button', {
    staticClass: "preview-btn",
    attrs: {
      "round": "",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.detailLan.goback))])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "downLoadTran": _vm.downLoadTran,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "multiLanguage": _vm.detailLan,
      "name": _vm.name,
      "thData": _vm.thData,
      "trData": _vm.trData
    }
  }, [_c('div', {
    staticClass: "monthly-detail",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "monthly-detail"
  }, [_c('span', [_vm._v(_vm._s(_vm.detailLan.proxyAccount) + " " + _vm._s(_vm.queryObj.IB_ID))])]), _vm._v(" "), _c('div', {
    staticClass: "monthly-detail"
  }, [_c('span', [_vm._v(_vm._s(_vm.detailLan.commissionType) + " " + _vm._s(_vm.queryObj.type))])]), _vm._v(" "), (_vm.isLower) ? _c('div', {
    staticClass: "monthly-detail"
  }, [_c('el-switch', {
    attrs: {
      "active-text": _vm.detailLan.spread,
      "inactive-text": _vm.detailLan.fold,
      "active-color": "#3F51B5"
    },
    on: {
      "change": _vm.actionChange
    },
    model: {
      value: (_vm.action),
      callback: function($$v) {
        _vm.action = $$v
      },
      expression: "action"
    }
  })], 1) : _vm._e()])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.registerLan.title,
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "label-width": "80px",
      "model": _vm.formLabelAlign
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.sidebarLan1.roleName,
      "prop": "Role_No"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formLabelAlign.Role_No),
      callback: function($$v) {
        _vm.$set(_vm.formLabelAlign, "Role_No", $$v)
      },
      expression: "formLabelAlign.Role_No"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.sidebarLan1.roleDesc,
      "prop": "Desc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.formLabelAlign.Desc),
      callback: function($$v) {
        _vm.$set(_vm.formLabelAlign, "Desc", $$v)
      },
      expression: "formLabelAlign.Desc"
    }
  })], 1), _vm._v(" "), _c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.data2,
      "show-checkbox": "",
      "default-expand-all": "",
      "node-key": "Role_ID",
      "highlight-current": "",
      "props": _vm.defaultProps
    }
  }), _vm._v(" "), (!_vm.selectBool) ? _c('el-button', {
    on: {
      "click": _vm.setCheckedNodes
    }
  }, [_vm._v(_vm._s(_vm.registerLan.selectBtn))]) : _vm._e(), _vm._v(" "), (_vm.selectBool) ? _c('el-button', {
    on: {
      "click": _vm.setCheckedNodes
    }
  }, [_vm._v(_vm._s(_vm.registerLan.emptyBtn))]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.registerLan.logOut.no))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.registerLan.logOut.yes))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dailyReport"
  }, [_c('crumbs', [_c('i', {
    staticClass: "icon-copy"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.crumbs.dailyReport))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "panel"
  }, [(_vm.path.length > 0) ? _c('div', {
    staticClass: "btn btn-default getBack",
    on: {
      "click": function($event) {
        return _vm.goPath(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.getBack))]) : _vm._e(), _vm._v(" "), _c('mtable', {
    ref: "mtable",
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "totalData": _vm.trData,
      "multiLanguage": _vm.multiLanguage,
      "seekDropdown": _vm.seekDropdown,
      "seekDatePicker": _vm.seekDatePicker,
      "sort": _vm.sort,
      "jsonExcelAjax": _vm.jsonExcelAjax
    },
    on: {
      "tableChange": _vm.tableAjax
    }
  }, [_c('div', {
    staticClass: "nodePath",
    attrs: {
      "slot": "datatable-scroll"
    },
    slot: "datatable-scroll"
  }, [_c('div', {
    attrs: {
      "id": "chooseCheck"
    }
  }, _vm._l((_vm.checkboxs), function(item, index) {
    return _c('div', {
      staticClass: "checker"
    }, [_c('span', {
      class: {
        'checked': item.bool
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.allType),
        expression: "allType"
      }],
      staticClass: "choosebox",
      attrs: {
        "type": "checkbox",
        "id": item.name
      },
      domProps: {
        "value": item.name,
        "checked": Array.isArray(_vm.allType) ? _vm._i(_vm.allType, item.name) > -1 : (_vm.allType)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(item)
        },
        "change": function($event) {
          var $$a = _vm.allType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.name,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.allType = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.allType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.allType = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "labelStyle",
      attrs: {
        "for": item.name
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.multiLanguage.th.loginType.typeArr[index].text) + "\n                ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "m-6"
  }, [_c('span', {
    staticClass: "span"
  }, [_vm._v("开户总数 : " + _vm._s(_vm.apply.counts))]), _vm._v(" "), _c('span', {
    staticClass: "span"
  }, [_vm._v("开户成功 : " + _vm._s(_vm.apply.approved))]), _vm._v(" "), _c('span', {
    staticClass: "span"
  }, [_vm._v("开户失败 : " + _vm._s(_vm.apply.fail))]), _vm._v(" "), _c('span', {
    staticClass: "span"
  }, [_vm._v("等待审核 : " + _vm._s(_vm.apply.tracking))])]), _vm._v("\n          " + _vm._s(_vm.multiLanguage.tier) + " : "), _vm._l((_vm.path), function(item, index) {
    return (_vm.path.length > 0) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.goPath(item)
        }
      }
    }, [(index) ? _c('span', [_vm._v("/")]) : _vm._e(), (item) ? _c('span', {
      staticClass: "path-item"
    }, [_vm._v(_vm._s(item))]) : _vm._e()]) : _vm._e()
  })], 2)])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seek"
  }, [(Object.keys(_vm.seekDropdown.list).length != 1) ? _c('Dropdown', {
    staticClass: "pull-left seekDropdown"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle hui-dropdown-toggle",
    attrs: {
      "data-role": "trigger",
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.seekLan.dropdown[_vm.seekDropdown.active]))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _vm._l((_vm.seekLan.dropdown), function(item, index) {
    return (_vm.seekDropdown.list[index]) ? _c('template', {
      slot: "dropdown"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.setSeekDropdown(index)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(item))])])]) : _vm._e()
  })], 2) : _c('div', {
    staticClass: "pull-left seekDropdown dropdown"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle hui-dropdown-toggle no-pointer",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.seekLan.dropdown[_vm.seekDropdown.active]))])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.seekDropdown.seekStr),
      expression: "seekDropdown.seekStr"
    }],
    staticClass: "form-control hui-form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.seekLan.seek
    },
    domProps: {
      "value": (_vm.seekDropdown.seekStr)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.emitSeek.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.seekDropdown, "seekStr", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.hideBtn) ? _c('div', {
    staticClass: "pull-left btn btn-default btn-primary",
    on: {
      "click": _vm.emitSeek
    }
  }, [_vm._v(_vm._s(_vm.seekLan.seek))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar navbar-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse"
  }, [_c('div', {
    staticClass: "user-wrapper"
  }, [_c('div', {
    staticClass: "user-text"
  }, [_vm._v("\n        " + _vm._s(_vm.headerLan.hello) + " ! " + _vm._s(_vm.user.user_name) + "  " + _vm._s(_vm.headerLan.userName) + "\n      ")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('dropdown', {
    attrs: {
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-role": "trigger"
    }
  }, [_c('img', {
    staticClass: "position-left language",
    attrs: {
      "src": _vm.languageImage
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.headerLan.language))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeLanguage('cn')
      }
    }
  }, [_c('a', {
    staticClass: "china language"
  }, [_c('img', {
    staticClass: "language",
    attrs: {
      "src": "/static/limitless/assets/images/flags/cn.png"
    }
  }), _vm._v("简体中文")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeLanguage('hk')
      }
    }
  }, [_c('a', {
    staticClass: "english"
  }, [_c('img', {
    staticClass: "language",
    attrs: {
      "src": "/static/limitless/assets/images/flags/hk.png"
    }
  }), _vm._v("繁體中文")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeLanguage('en')
      }
    }
  }, [_c('a', {
    staticClass: "english"
  }, [_c('img', {
    staticClass: "language",
    attrs: {
      "src": "/static/limitless/assets/images/flags/en.png"
    }
  }), _vm._v("English")])])])], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('ul', {
    staticClass: "nav navbar-nav visible-xs-block"
  }, [_c('li', [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#navbar-mobile"
    }
  }, [_c('i', {
    staticClass: "icon-tree5"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sidebar-mobile-main-toggle"
  }, [_c('i', {
    staticClass: "icon-paragraph-justify3"
  })])])])])
}]}

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profit-box"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.report.title))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [_c('profit-table', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "page": _vm.page,
      "selPage": _vm.selPage,
      "curArea": _vm.curArea,
      "name": _vm.name,
      "multiLanguage": _vm.report,
      "jsonExcelAjax": _vm.jsonExcelAjax
    },
    on: {
      "tableChange": _vm.requestHandle
    }
  }, [_c('div', {
    staticClass: "conditions",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "condition"
  }, [_c('span', [_vm._v(_vm._s(_vm.report.begin))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.idFrom),
      callback: function($$v) {
        _vm.idFrom = $$v
      },
      expression: "idFrom"
    }
  }, _vm._l((_vm.report_id_list), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1), _vm._v("\n           " + _vm._s(_vm.report.to) + " \n          "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.idTo),
      callback: function($$v) {
        _vm.idTo = $$v
      },
      expression: "idTo"
    }
  }, _vm._l((_vm.report_id_list), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "condition change-el-input-group-style"
  }, [_c('el-input', {
    model: {
      value: (_vm.searchVal),
      callback: function($$v) {
        _vm.searchVal = $$v
      },
      expression: "searchVal"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "105px"
    },
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend",
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = $$v
      },
      expression: "searchKey"
    }
  }, _vm._l((_vm.report.selectArr), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.searchHandle
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.report.search))])], 1)], 1)])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ruleSetting-box"
  }, [_c('div', {
    staticClass: "ruleLevel-btn-box"
  }, [_c('div', {
    staticClass: "pull-right",
    style: (_vm.version == '0' ? 'visibility:hidden;' : '')
  }, [_c('button', {
    staticClass: "btn btn-style-add",
    attrs: {
      "disabled": !_vm.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.addLevel
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.addLevel) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-style-remove",
    attrs: {
      "disabled": !_vm.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.removeLevel
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-trash"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.removeLevel) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('draggable', {
    attrs: {
      "list": _vm.rule,
      "options": {
        group: 'levelGroup',
        disabled: _vm.onfocus
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.newRelation),
      callback: function($$v) {
        _vm.newRelation = $$v
      },
      expression: "newRelation"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": 'flip-list'
    }
  }, _vm._l((_vm.rule), function(levelItem, levelIndex) {
    return _c('div', {
      key: levelIndex + levelItem,
      staticClass: "rule-content-box panel panel-default",
      class: {
        'disabled': !_vm.enable || _vm.version == '0'
      }
    }, [_c('div', {
      staticClass: "panel-heading title-bg"
    }, [_c('div', {
      staticClass: "panel-title"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('label', [(levelIndex !== _vm.rule.length - 1) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedLevel),
        expression: "checkedLevel"
      }],
      style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.enable || _vm.version == '0'
      },
      domProps: {
        "value": levelIndex,
        "checked": Array.isArray(_vm.checkedLevel) ? _vm._i(_vm.checkedLevel, levelIndex) > -1 : (_vm.checkedLevel)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedLevel,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = levelIndex,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedLevel = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedLevel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedLevel = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "primary-color"
    }, [_vm._v("\n                  " + _vm._s(levelIndex == _vm.rule.length - 1 ? _vm.ruleSettingLan.currentSetting : levelIndex + 1 + _vm.ruleSettingLan.levelSetting) + "\n                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "pull-right",
      style: (_vm.version == '0' ? 'visibility:hidden;' : '')
    }, [_c('button', {
      staticClass: "btn btn-style-add",
      attrs: {
        "disabled": !_vm.enable || _vm.version == '0'
      },
      on: {
        "click": function($event) {
          return _vm.addRule(levelItem)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-plus"
    }), _vm._v("\n                " + _vm._s(_vm.ruleSettingLan.addRule) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])]), _vm._v(" "), _c('draggable', {
      attrs: {
        "list": levelItem,
        "options": {
          group: 'ruleGroup',
          disabled: _vm.onfocus
        }
      },
      on: {
        "start": function($event) {
          _vm.drag = true
        },
        "end": function($event) {
          _vm.drag = false
        }
      }
    }, [_c('transition-group', {
      attrs: {
        "type": "transition",
        "name": 'flip-list'
      }
    }, _vm._l((levelItem), function(ruleItem, ruleIndex) {
      return _c('div', {
        key: ruleIndex + ruleItem,
        staticClass: "panel-body"
      }, [_c('div', {
        staticClass: "rule-title"
      }, [_c('div', {
        staticClass: "pull-left primary-color"
      }, [_vm._v(_vm._s(_vm.ruleSettingLan.rule) + _vm._s(ruleIndex + 1))]), _vm._v(" "), _c('div', {
        staticClass: "pull-right",
        style: (_vm.version == '0' ? 'visibility:hidden;' : '')
      }, [_c('button', {
        staticClass: "btn btn-xs",
        attrs: {
          "disabled": !_vm.enable || _vm.version == '0'
        },
        on: {
          "click": function($event) {
            return _vm.removeRule(levelItem, ruleIndex)
          }
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-trash"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "clear"
      })]), _vm._v(" "), _c('div', {
        staticClass: "rule-content"
      }, [_c('div', {
        staticClass: "form-horizontal",
        class: {
          'row': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "form-group",
        class: {
          'col-sm-6': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "col-sm-6"
      }, [_c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.enableCommTarget),
          expression: "ruleItem.enableCommTarget"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'enableCommTarget',
          "disabled": !_vm.enable || _vm.version == '0'
        },
        domProps: {
          "value": false,
          "checked": _vm._q(ruleItem.enableCommTarget, false)
        },
        on: {
          "change": function($event) {
            return _vm.$set(ruleItem, "enableCommTarget", false)
          }
        }
      }), _vm._v(" \n                        " + _vm._s(_vm.ruleSettingLan.toOriginalAccount) + "\n                      ")]), _vm._v(" "), _c('label', {
        staticClass: "radio-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.enableCommTarget),
          expression: "ruleItem.enableCommTarget"
        }],
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'enableCommTarget',
          "disabled": !_vm.enable || _vm.version == '0'
        },
        domProps: {
          "value": true,
          "checked": _vm._q(ruleItem.enableCommTarget, true)
        },
        on: {
          "change": function($event) {
            return _vm.$set(ruleItem, "enableCommTarget", true)
          }
        }
      }), _vm._v(" \n                        " + _vm._s(_vm.ruleSettingLan.toTargetAccount) + "\n                      ")])]), _vm._v(" "), _c('label', {
        staticClass: "col-sm-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.commTarget),
          expression: "ruleItem.commTarget"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|numeric'),
          expression: "'required|numeric'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'commTarget') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enable || _vm.version == '0' || !ruleItem.enableCommTarget,
          "name": levelIndex + '_' + ruleIndex + '_' + 'commTarget'
        },
        domProps: {
          "value": (ruleItem.commTarget)
        },
        on: {
          "focus": function($event) {
            _vm.onfocus = true
          },
          "blur": function($event) {
            _vm.onfocus = false
          },
          "change": function($event) {
            return _vm.checkId(ruleItem)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(ruleItem, "commTarget", $event.target.value)
          }
        }
      })])])]), _vm._v(" "), _c('div', {
        staticClass: "form-inline",
        class: {
          'col-sm-6 row': _vm.viewBtn == 'onlyOne'
        }
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "radio-inline flex-item-left"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": _vm.version + '_' + levelIndex + '_' + ruleIndex + '_' + 'ruleId',
          "disabled": !_vm.enable || _vm.version == '0',
          "checked": ""
        },
        domProps: {
          "value": 0
        }
      }), _vm._v(" \n                      " + _vm._s(_vm.ruleSettingLan.customTheMoney) + "\n                    ")])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        staticClass: "input-group"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.ruleId),
          expression: "ruleItem.ruleId"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'ruleId') ? 'border-color:#f44336;' : ''),
        attrs: {
          "disabled": !_vm.enable || _vm.version == '0',
          "name": levelIndex + '_' + ruleIndex + '_' + 'ruleId'
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(ruleItem, "ruleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return _c('option', {
          domProps: {
            "value": ruleSeqItem.ruleId
          }
        }, [_vm._v("\n                          " + _vm._s(_vm.publicLan.rule[ruleSeqItem.langKey.split('.')[1]]) + "\n                        ")])
      }), 0), _vm._v(" "), _c('span', {
        staticClass: "input-group-addon"
      }, [_c('el-tooltip', {
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "placement": "top-start",
          "disabled": !_vm.enable || _vm.version == '0'
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-tags"
      }), _vm._v(" "), _vm._l((_vm.ruleSeq), function(ruleSeqItem, ruleSeqIndex) {
        return (ruleSeqItem.ruleId === ruleItem.ruleId) ? _c('div', {
          staticStyle: {
            "width": "180px",
            "line-height": "20px"
          },
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v("\n                              " + _vm._s(_vm.publicLan.rule[ruleSeqItem.descLangKey.split('.')[1]]) + "\n                          ")]) : _vm._e()
      })], 2)], 1)])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.value),
          expression: "ruleItem.value"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|min_value:0.0001|decimal:4'),
          expression: "'required|min_value:0.0001|decimal:4'"
        }],
        staticClass: "form-control",
        staticStyle: {
          "border-radius": "3px"
        },
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'value1') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enable || _vm.version == '0',
          "name": levelIndex + '_' + ruleIndex + '_' + 'value1'
        },
        domProps: {
          "value": (ruleItem.value)
        },
        on: {
          "focus": function($event) {
            _vm.onfocus = true
          },
          "blur": function($event) {
            _vm.onfocus = false
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(ruleItem, "value", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ruleItem.clientType),
          expression: "ruleItem.clientType"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control",
        style: (_vm.errors.has(levelIndex + '_' + ruleIndex + '_' + 'clientType') ? 'border-color:#f44336;' : ''),
        attrs: {
          "disabled": !_vm.enable || _vm.version == '0',
          "name": levelIndex + '_' + ruleIndex + '_' + 'clientType'
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(ruleItem, "clientType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        domProps: {
          "value": 0
        }
      }, [_vm._v(_vm._s(_vm.publicLan.clientType.allClient))]), _vm._v(" "), _c('option', {
        domProps: {
          "value": 1
        }
      }, [_vm._v(_vm._s(_vm.publicLan.clientType.IBClient))]), _vm._v(" "), _c('option', {
        domProps: {
          "value": 2
        }
      }, [_vm._v(_vm._s(_vm.publicLan.clientType.directClient))])])])]), _vm._v(" "), _c('div', {
        staticClass: "clear"
      })])])
    }), 0)], 1)], 1)
  }), 0)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selPage) ? _c('div', {
    staticClass: "mtable-tool-selPage"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.clauses_text) + "：")]), _vm._v(" "), _c('Dropdown', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "data-role": "trigger",
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selPage.list[_vm.selPage.active]))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _vm._l((_vm.selPage.list), function(item, index) {
    return (_vm.selPage) ? _c('template', {
      class: {
        hide: _vm.selPage.list.length >= 1
      },
      slot: "dropdown"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.emitSelPage(index, item)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(item))])])]) : _vm._e()
  })], 2)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commissionDatum"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('label', [_c('span', {
    staticClass: "enable-text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.templateName) + " :")]), _vm._v(" \n      "), (!_vm.newTempFlag) ? _c('el-select', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.onTemplateChange
    },
    model: {
      value: (_vm.temp_name),
      callback: function($$v) {
        _vm.temp_name = $$v
      },
      expression: "temp_name"
    }
  }, _vm._l((_vm.ibTemplate), function(item) {
    return (item.isDisplay) ? _c('el-option', {
      key: item.templateId,
      attrs: {
        "label": ((item.templateId) + " " + (_vm.multiLanguage[item.langKey]?'('+_vm.multiLanguage[item.langKey]+')':'')),
        "value": item.templateId
      }
    }) : _vm._e()
  }), 1) : _vm._e(), _vm._v(" "), (_vm.newTempFlag) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTempName),
      expression: "newTempName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 18,
        regex: /^([a-z]|[0-9]|[A-Z]|_)+$/
      }),
      expression: "{required:true,max:18,regex:/^([a-z]|[0-9]|[A-Z]|_)+$/}"
    }],
    staticClass: "template_name",
    style: (_vm.errors.has('newTempName') ? 'border-color:#f44336;' : ''),
    attrs: {
      "type": "text",
      "name": "newTempName"
    },
    domProps: {
      "value": (_vm.newTempName)
    },
    on: {
      "focus": function($event) {
        _vm.onfocus = true
      },
      "blur": function($event) {
        _vm.onfocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTempName = $event.target.value
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-box pull-right"
  }, [(_vm.version == '1') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.submit
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-edit"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.submit) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.version == '1') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.createTemplate
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-repeat"
  }), _vm._v("\n        " + _vm._s(_vm.newTempFlag ? _vm.multiLanguage.btnGroup.back : _vm.multiLanguage.templateCreate) + "\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.newTempFlag) ? _c('div', [_c('span', {
    staticClass: "enable-text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.templateBase) + " :")]), _vm._v(" \n      "), _c('el-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.onTemplateChange
    },
    model: {
      value: (_vm.temp_name),
      callback: function($$v) {
        _vm.temp_name = $$v
      },
      expression: "temp_name"
    }
  }, _vm._l((_vm.ibTemplate), function(item) {
    return (item.isDisplay) ? _c('el-option', {
      key: item.templateId,
      attrs: {
        "label": ((item.templateId) + " " + (_vm.multiLanguage[item.langKey]?'('+_vm.multiLanguage[item.langKey]+')':'')),
        "value": item.templateId
      }
    }) : _vm._e()
  }), 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.newTempFlag) ? _c('div', {
    style: ({
      'visibility': _vm.version == 1 ? 'hidden' : 'visible',
      'height': _vm.viewBtn == 'double' ? '30px' : '0px'
    })
  }, [_c('span', {
    staticClass: "enable-text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.templateHistory) + " : ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.onVersionChange
    },
    model: {
      value: (_vm.currentVersion),
      callback: function($$v) {
        _vm.currentVersion = $$v
      },
      expression: "currentVersion"
    }
  }, _vm._l((_vm.tempHistory), function(item) {
    return _c('el-option', {
      key: item.VERSION,
      attrs: {
        "label": item.VERSION == 0 ? "current" : ((item.UPDATE_BY) + " (" + (_vm.dataFormat(new Date(item.LAST_UPDATE))) + ") (" + (item.VERSION) + ")"),
        "value": item.VERSION
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1) : _vm._e(), _vm._v(" \n    "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', [_vm._v(" \n    "), _vm._v(" "), (_vm.mode == 0 || _vm.mode == 2) ? _c('internal-commission', {
    ref: "internalCommission",
    attrs: {
      "commission": _vm.commission,
      "groupSeq": _vm.groupSeq,
      "multiLanguage": _vm.multiLanguage,
      "version": _vm.version,
      "viewBtn": _vm.viewBtn
    }
  }) : _vm._e()], 1), _vm._v(" \n  "), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "table-title"
  }, [_vm._v(_vm._s(_vm.multiLanguage.upperCommissiondistribution))])]), _vm._v(" "), _c('div', [_c('rule-setting', {
    ref: "ruleSetting",
    attrs: {
      "enableUpperCalc": _vm.commission.enableUpperCalc,
      "multiLanguage": _vm.multiLanguage,
      "groupSeq": _vm.groupSeq,
      "version": _vm.version,
      "relation": _vm.relation,
      "currentIB": _vm.currentIB,
      "rule": _vm.rule,
      "ruleSeq": _vm.ruleSeq,
      "viewBtn": _vm.viewBtn
    },
    on: {
      "checkId": _vm.checkIdFn
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "size": "sm",
      "header": false,
      "footer": false
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sucSave),
      expression: "!sucSave"
    }]
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-warning-sign color-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v(_vm._s(_vm.multiLanguage.submitResult.err))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sucSave),
      expression: "sucSave"
    }]
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-ok color-green"
  }), _vm._v(" "), _c('span', {
    staticClass: "color-green"
  }, [_vm._v(_vm._s(_vm.multiLanguage.submitResult.succeed))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibSetting-box"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true
      }
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.5)"
    }
  }, [_c('itable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "handle": _vm.handle,
      "page": _vm.page,
      "multiLanguage": _vm.multiLanguage,
      "sort": _vm.sort,
      "seekDropdown": _vm.seekDropdown,
      "selPage": _vm.selPage,
      "region": _vm.curArea,
      "isSetting": _vm.isSetting,
      "ibSpecialType": _vm.ibSpecialType,
      "ibc": _vm.ibc,
      "modifyTime": _vm.modifyTime,
      "confirmTime": _vm.confirmTime,
      "templateSel": _vm.templateSel,
      "ibTemplate": _vm.ibTemplate
    },
    on: {
      "update:ibc": function($event) {
        _vm.ibc = $event
      },
      "update:modifyTime": function($event) {
        _vm.modifyTime = $event
      },
      "update:modify-time": function($event) {
        _vm.modifyTime = $event
      },
      "update:confirmTime": function($event) {
        _vm.confirmTime = $event
      },
      "update:confirm-time": function($event) {
        _vm.confirmTime = $event
      },
      "tableChange": _vm.tableAjax,
      "downLoadExcelFn": _vm.excelDown,
      "seek": _vm.tableAjax
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.multiLanguage.text))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "back": _vm.back,
      "downLoadTran": _vm.downLoadTran,
      "firstTh": _vm.firstTh,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "link": _vm.link,
      "multiExcelAjax": _vm.multiExcelAjax,
      "multiLanguage": _vm.multiLanguage,
      "name": _vm.name,
      "page": _vm.page,
      "region": _vm.curArea,
      "secondTh": _vm.secondTh,
      "selPage": _vm.selPage,
      "thData": _vm.thData,
      "trData": _vm.trData
    },
    on: {
      "seek": _vm.tableAjax,
      "tableChange": _vm.tableAjax
    }
  }, [_c('div', {
    staticClass: "slotDiv",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "selectDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.typeText))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "105px"
    },
    on: {
      "change": _vm.searchData
    },
    model: {
      value: (_vm.realTime.type),
      callback: function($$v) {
        _vm.$set(_vm.realTime, "type", $$v)
      },
      expression: "realTime.type"
    }
  }, _vm._l((_vm.multiLanguage.typeList), function(val, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": val,
        "value": key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "inputDiv"
  }, [_c('div', {
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.start_time))]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.multiLanguage.selectTimeText,
      "type": "datetime"
    },
    model: {
      value: (_vm.realTime.start_time),
      callback: function($$v) {
        _vm.$set(_vm.realTime, "start_time", $$v)
      },
      expression: "realTime.start_time"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.end_time))]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.multiLanguage.selectTimeText,
      "type": "datetime"
    },
    model: {
      value: (_vm.realTime.end_time),
      callback: function($$v) {
        _vm.$set(_vm.realTime, "end_time", $$v)
      },
      expression: "realTime.end_time"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btnDiv"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.search))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "extraSearch",
    attrs: {
      "slot": "title-name"
    },
    slot: "title-name"
  }, [_c('div', {
    staticClass: "moreSelect"
  }, [_c('el-switch', {
    attrs: {
      "active-text": _vm.multiLanguage.moreSelect,
      "inactive-text": ""
    },
    model: {
      value: (_vm.more),
      callback: function($$v) {
        _vm.more = $$v
      },
      expression: "more"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.IB_ID))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.realTime.IB_ID),
      callback: function($$v) {
        _vm.$set(_vm.realTime, "IB_ID", $$v)
      },
      expression: "realTime.IB_ID"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.deposit_order_id))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.realTime.deposit_order_id),
      callback: function($$v) {
        _vm.$set(_vm.realTime, "deposit_order_id", $$v)
      },
      expression: "realTime.deposit_order_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.more),
      expression: "more"
    }],
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.clientAccount))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.realTime.client_account),
      callback: function($$v) {
        _vm.$set(_vm.realTime, "client_account", $$v)
      },
      expression: "realTime.client_account"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.more),
      expression: "more"
    }],
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.mtlogin))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.realTime.mtlogin),
      callback: function($$v) {
        _vm.$set(_vm.realTime, "mtlogin", $$v)
      },
      expression: "realTime.mtlogin"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.more),
      expression: "more"
    }],
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.symbol))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.realTime.symbol),
      callback: function($$v) {
        _vm.$set(_vm.realTime, "symbol", $$v)
      },
      expression: "realTime.symbol"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.more),
      expression: "more"
    }],
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.trade_order_id))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.realTime.trade_order_id),
      callback: function($$v) {
        _vm.$set(_vm.realTime, "trade_order_id", $$v)
      },
      expression: "realTime.trade_order_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.more),
      expression: "more"
    }],
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.depositAccount))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.realTime.depositAccount),
      callback: function($$v) {
        _vm.$set(_vm.realTime, "depositAccount", $$v)
      },
      expression: "realTime.depositAccount"
    }
  })], 1)])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": function($event) {
        return _vm.tablesToExcel()
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    attrs: {
      "border": "1"
    }
  }, [(_vm.title != '') ? _c('caption', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('tr', _vm._l((_vm.columnNames), function(key) {
    return _c('th', {
      key: key.name || key
    }, [_vm._v(_vm._s(key.name || key))])
  }), 0), _vm._v(" "), _vm._l((_vm.rows), function(row, index) {
    return _c('editable-row', {
      key: ("row-" + index),
      attrs: {
        "column-names": _vm.columnNames,
        "values": row,
        "save": _vm.onSave(index)
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profit-box"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.accountSettingLan.title))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('profit-table', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "page": _vm.page,
      "selPage": _vm.selPage,
      "operate": _vm.operate,
      "curArea": _vm.curArea,
      "name": _vm.name,
      "multiLanguage": _vm.accountSettingLan,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "downLoadTran": _vm.downLoadTran
    },
    on: {
      "tableChange": _vm.requestHandle
    }
  }, [_c('div', {
    staticClass: "conditions",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "condition"
  }, [_c('span', [_vm._v(_vm._s(_vm.accountSettingLan.status_text))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "95px"
    },
    on: {
      "change": _vm.changeHandle
    },
    model: {
      value: (_vm.is_selected),
      callback: function($$v) {
        _vm.is_selected = $$v
      },
      expression: "is_selected"
    }
  }, _vm._l((_vm.accountSettingLan.status_mapper), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "condition change-el-input-group-style"
  }, [_c('el-input', {
    model: {
      value: (_vm.searchVal),
      callback: function($$v) {
        _vm.searchVal = $$v
      },
      expression: "searchVal"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "105px"
    },
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend",
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = $$v
      },
      expression: "searchKey"
    }
  }, _vm._l((_vm.accountSettingLan.selectArr), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.requestHandle
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.accountSettingLan.search))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "condition"
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.calculateHandle
    }
  }, [_vm._v(_vm._s(_vm.accountSettingLan.calculate))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addAccount
    }
  }, [_vm._v(_vm._s(_vm.accountSettingLan.addUser))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.accountSettingLan.add_title,
      "close-on-click-modal": false,
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    ref: "account",
    attrs: {
      "model": _vm.account,
      "label-position": "top",
      "rules": _vm.accountSettingLan.rules
    }
  }, [_c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.accountSettingLan.login,
      "prop": "login"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.account.login),
      callback: function($$v) {
        _vm.$set(_vm.account, "login", $$v)
      },
      expression: "account.login"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.accountSettingLan.ib_account,
      "prop": "ib"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.account.ib),
      callback: function($$v) {
        _vm.$set(_vm.account, "ib", $$v)
      },
      expression: "account.ib"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.accountSettingLan.percentage,
      "prop": "percentage"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.account.percentage),
      callback: function($$v) {
        _vm.$set(_vm.account, "percentage", $$v)
      },
      expression: "account.percentage"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.accountSettingLan.app_date,
      "prop": "date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.accountSettingLan.date_placeholder
    },
    model: {
      value: (_vm.account.date),
      callback: function($$v) {
        _vm.$set(_vm.account, "date", $$v)
      },
      expression: "account.date"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelSubmit
    }
  }, [_vm._v(_vm._s(_vm.accountSettingLan.cancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addAccountHandle
    }
  }, [_vm._v(_vm._s(_vm.accountSettingLan.ensure))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "extraSearch",
    attrs: {
      "slot": "title-name"
    },
    slot: "title-name"
  }, [_c('div', {
    staticClass: "moreSelect"
  }, [_c('el-switch', {
    attrs: {
      "active-text": _vm.accountSettingLan.moreSelect,
      "inactive-text": ""
    },
    model: {
      value: (_vm.more),
      callback: function($$v) {
        _vm.more = $$v
      },
      expression: "more"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.more),
      expression: "more"
    }],
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.accountSettingLan.deposit))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "95px"
    },
    on: {
      "change": _vm.changeHandle
    },
    model: {
      value: (_vm.filter.deposit),
      callback: function($$v) {
        _vm.$set(_vm.filter, "deposit", $$v)
      },
      expression: "filter.deposit"
    }
  }, _vm._l((_vm.accountSettingLan.enable_mapping), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.more),
      expression: "more"
    }],
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.accountSettingLan.withdrawal))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "95px"
    },
    on: {
      "change": _vm.changeHandle
    },
    model: {
      value: (_vm.filter.withdrawal),
      callback: function($$v) {
        _vm.$set(_vm.filter, "withdrawal", $$v)
      },
      expression: "filter.withdrawal"
    }
  }, _vm._l((_vm.accountSettingLan.enable_mapping), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.more),
      expression: "more"
    }],
    staticClass: "searchDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.accountSettingLan.transfer))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "95px"
    },
    on: {
      "change": _vm.changeHandle
    },
    model: {
      value: (_vm.filter.transfer),
      callback: function($$v) {
        _vm.$set(_vm.filter, "transfer", $$v)
      },
      expression: "filter.transfer"
    }
  }, _vm._l((_vm.accountSettingLan.enable_mapping), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1)], 1)])]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "specialAndOverlook-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "table-title"
  }, [_vm._v(_vm._s(_vm.multiLanguage.specialIB))])]), _vm._v(" "), _c('div', {
    staticClass: "specialIB-box"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    class: {
      'disabled': !_vm.enable || _vm.version == '0'
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.multiLanguage.allLowIB))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.ibAccount))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.ibName))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.costPerCommission))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.operate))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.newSpecialIB), function(item, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.withSub),
        expression: "item.withSub"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.enable || _vm.version == '0'
      },
      domProps: {
        "checked": Array.isArray(item.withSub) ? _vm._i(item.withSub, null) > -1 : (item.withSub)
      },
      on: {
        "input": function($event) {
          return _vm.withSubChecked(item)
        },
        "change": function($event) {
          var $$a = item.withSub,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "withSub", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "withSub", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "withSub", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ibId),
        expression: "item.ibId"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('numeric'),
        expression: "'numeric'"
      }],
      staticClass: "form-control",
      style: (_vm.errors.has(index + '_' + 'specialIbId') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.enable || _vm.version == '0',
        "name": index + '_' + 'specialIbId'
      },
      domProps: {
        "value": (item.ibId)
      },
      on: {
        "change": function($event) {
          _vm.checkIBFn(item, 'special', _vm.errors.has(index + '_' + 'specialIbId'))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ibId", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', _vm._l((item.value), function(lev, i) {
      return _c('div', {
        key: i,
        staticStyle: {
          "margin": "3px 0",
          "text-align": "left"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "90px",
          "text-align": "right"
        }
      }, [_vm._v(_vm._s(lev.level == 0 ? _vm.ruleSettingLan.currentSetting : item.value.length - lev.level + _vm.ruleSettingLan.levelSetting))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (lev.rebate),
          expression: "lev.rebate"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: (lev.ibId ? 'required|min_value:0.00|decimal:2' : 'min_value:0.00|decimal:2'),
          expression: "lev.ibId ? 'required|min_value:0.00|decimal:2' : 'min_value:0.00|decimal:2'"
        }],
        staticClass: "form-control form-control-small",
        style: (_vm.errors.has(index + '_' + 'specialRebate') ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.enable || _vm.version == '0',
          "name": index + '_' + 'specialRebate'
        },
        domProps: {
          "value": (lev.rebate)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(lev, "rebate", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', [_c('el-button', {
        style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
        attrs: {
          "type": "warning",
          "size": "small",
          "disabled": !_vm.enable
        },
        on: {
          "click": function($event) {
            return _vm.removeItemLev(index, i, _vm.newSpecialIB)
          }
        }
      }, [_vm._v(_vm._s(_vm.multiLanguage.btnGroup.remove))]), _vm._v(" "), (i == 0) ? _c('el-button', {
        style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
        attrs: {
          "type": "primary",
          "size": "small",
          "disabled": !_vm.enable
        },
        on: {
          "click": function($event) {
            return _vm.addItemLev(index, i, _vm.newSpecialIB)
          }
        }
      }, [_vm._v(_vm._s(_vm.multiLanguage.btnGroup.add))]) : _vm._e()], 1)])
    }), 0), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-style-add",
      style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
      attrs: {
        "disabled": !_vm.enable
      },
      on: {
        "click": function($event) {
          return _vm.addItem(index, _vm.newSpecialIB)
        }
      }
    }, [_vm._v(_vm._s(_vm.multiLanguage.btnGroup.add))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-style-remove",
      style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
      attrs: {
        "disabled": !_vm.enable
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(index, _vm.newSpecialIB)
        }
      }
    }, [_vm._v(_vm._s(_vm.multiLanguage.btnGroup.remove))])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "table-title"
  }, [_vm._v(_vm._s(_vm.multiLanguage.overlookIB))])]), _vm._v(" "), _c('div', {
    staticClass: "overlookIB-box"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    class: {
      'disabled': !_vm.enable
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.multiLanguage.allLowIB))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.ibAccount))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.ibName))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.operate))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.newOverlookIB), function(item, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.withSub),
        expression: "item.withSub"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.enable || _vm.version == '0'
      },
      domProps: {
        "checked": Array.isArray(item.withSub) ? _vm._i(item.withSub, null) > -1 : (item.withSub)
      },
      on: {
        "change": function($event) {
          var $$a = item.withSub,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "withSub", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "withSub", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "withSub", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ibId),
        expression: "item.ibId"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('numeric'),
        expression: "'numeric'"
      }],
      staticClass: "form-control",
      style: (_vm.errors.has(index + '_' + 'overlookIbId') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.enable || _vm.version == '0',
        "name": index + '_' + 'overlookIbId'
      },
      domProps: {
        "value": (item.ibId)
      },
      on: {
        "change": function($event) {
          _vm.checkIBFn(item, 'ignore', _vm.errors.has(index + '_' + 'overlookIbId'))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ibId", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-style-add",
      style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
      attrs: {
        "disabled": !_vm.enable
      },
      on: {
        "click": function($event) {
          return _vm.addItem(index, _vm.newOverlookIB)
        }
      }
    }, [_vm._v(_vm._s(_vm.multiLanguage.btnGroup.add))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-style-remove",
      style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
      attrs: {
        "disabled": !_vm.enable
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(index, _vm.newOverlookIB)
        }
      }
    }, [_vm._v(_vm._s(_vm.multiLanguage.btnGroup.remove))])])])
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authOption"
  }, [_c('crumbs', [_c('i', {
    staticClass: "icon-stack2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s((_vm.actionType == "reg") ? _vm.registerLan.crumbs.newaAccount : _vm.registerLan.crumbs.amend))])]), _vm._v(" "), _c('div', {
    staticClass: "content_box"
  }, [_c('h2', [_vm._v(_vm._s(_vm.registerLan.sales.title))]), _vm._v(" "), _c('div', {
    staticClass: "inputBox"
  }, [_c('auth-list', {
    ref: "tree",
    attrs: {
      "auth_list": _vm.auth_data,
      "lang": _vm.lang_data
    }
  }), _vm._v(" "), (!_vm.selectBool) ? _c('el-button', {
    on: {
      "click": _vm.setCheckedNodes
    }
  }, [_vm._v(_vm._s(_vm.registerLan.selectBtn))]) : _c('el-button', {
    on: {
      "click": _vm.setCheckedNodes
    }
  }, [_vm._v(_vm._s(_vm.registerLan.emptyBtn))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.resetData
    }
  }, [_vm._v(_vm._s(_vm.registerLan.resetBtn))])], 1), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn bg-teal",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitFn
    }
  }, [_vm._v(_vm._s(_vm.registerLan.changeBtn))])])]), _vm._v(" "), _c('Modal', {
    staticClass: "modal-content-j",
    attrs: {
      "size": "sm",
      "header": false,
      "footer": false,
      "backdrop": !_vm.modalLink
    },
    on: {
      "hide": _vm.toModalLink
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    class: (_vm.modalBool ? 'color-green' : 'color-red')
  }, [_c('i', {
    staticClass: "glyphicon",
    class: (_vm.modalBool ? 'glyphicon-ok' : 'glyphicon-warning-sign')
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.modalBool ? _vm.registerLan.submitResult.succeed : _vm.registerLan.submitResult.err))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalLink),
      expression: "modalLink"
    }],
    staticClass: "btn btn-success btn-xs",
    on: {
      "click": function($event) {
        _vm.modalShow = false
      }
    }
  }, [_vm._v(_vm._s(_vm.registerLan.logOut.yes))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mimput col-md-12 p-0"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: 'col-lg-' + _vm.col
  }, [_c('div', {
    staticClass: "col-md-4 mimput-label",
    class: 'col-lg-' + _vm.labelCol
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 m-0",
    class: 'col-lg-' + _vm.contentCol
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._t("default"), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errBool),
      expression: "errBool"
    }],
    staticClass: "errText-wrapper"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-remove-circle errText"
  }, [_vm._v(_vm._s(_vm.errTexrt))])])], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "changepawd"
  }, [_c('crumbs', [_c('i', {
    staticClass: "icon-stack"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.sidebarListLan.changepswd.text))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('mimput', {
    staticClass: "col-lg-8 col-lg-offset-2",
    attrs: {
      "col": 12,
      "label": _vm.sidebarListLan.changepswd.content.account
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    ref: "user_name",
    staticClass: "form-control col-lg-12",
    attrs: {
      "name": "user_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "user_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-8 col-lg-offset-2",
    attrs: {
      "col": 12,
      "label": _vm.sidebarListLan.changepswd.content.passworda,
      "errBool": _vm.errors.has('oldpaswd'),
      "errTexrt": _vm.sidebarListLan.changepswd.content.errora
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|'),
      expression: "'required|'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.fromVal.oldpaswd),
      expression: "fromVal.oldpaswd"
    }],
    staticClass: "form-control col-lg-12",
    attrs: {
      "name": "oldpaswd",
      "type": "password"
    },
    domProps: {
      "value": (_vm.fromVal.oldpaswd)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeOk.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fromVal, "oldpaswd", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-8 col-lg-offset-2",
    attrs: {
      "col": 12,
      "label": _vm.sidebarListLan.changepswd.content.passwordb,
      "errBool": _vm.errors.has('newpaswd'),
      "errTexrt": _vm.sidebarListLan.changepswd.content.errorc
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.fromVal.newpaswd),
      expression: "fromVal.newpaswd"
    }],
    staticClass: "form-control col-lg-12",
    attrs: {
      "name": "newpaswd",
      "type": "password",
      "placeholder": _vm.sidebarListLan.changepswd.content.passwordb
    },
    domProps: {
      "value": (_vm.fromVal.newpaswd)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeOk.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fromVal, "newpaswd", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-8 col-lg-offset-2",
    attrs: {
      "col": 12,
      "label": _vm.sidebarListLan.changepswd.content.passwordc,
      "errBool": _vm.errors.has('okpaswd'),
      "errTexrt": _vm.sidebarListLan.changepswd.content.errorb
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.fromVal.okpaswd),
      expression: "fromVal.okpaswd"
    }],
    staticClass: "form-control col-lg-12",
    attrs: {
      "name": "okpaswd",
      "type": "password",
      "placeholder": _vm.sidebarListLan.changepswd.content.passwordc
    },
    domProps: {
      "value": (_vm.fromVal.okpaswd)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeOk.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fromVal, "okpaswd", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-8 col-lg-offset-2",
    attrs: {
      "col": 12
    }
  }, [_c('button', {
    staticClass: "btn bg-teal",
    on: {
      "click": _vm.changeOk
    }
  }, [_vm._v(_vm._s(_vm.sidebarListLan.changepswd.content.okChange))])]), _vm._v(" "), _c('Modal', {
    staticClass: "modal-content-j",
    attrs: {
      "size": "sm",
      "footer": false,
      "header": false,
      "backdrop": !_vm.modalLink
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    class: (_vm.modalBool ? 'color-green' : 'color-red')
  }, [_c('i', {
    staticClass: "glyphicon",
    class: (_vm.modalBool ? 'glyphicon-ok' : 'glyphicon-warning-sign')
  }), _vm._v("\n            " + _vm._s(_vm.modalBool ? _vm.sidebarListLan.changepswd.content.succeed : _vm.sidebarListLan.changepswd.content.err) + "\n          ")])])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ignore-box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticStyle: {
      "font": "4ex bold",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s((_vm.curArea + " Alert Ignore List").toUpperCase()))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_c('el-dropdown', {
    on: {
      "command": _vm.dropdownFn
    }
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n          " + _vm._s(_vm.typeMap[_vm.activeType])), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "ALL"
    }
  }, [_vm._v(_vm._s(_vm.typeMap['ALL']))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "IB"
    }
  }, [_vm._v(_vm._s(_vm.typeMap['IB']))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "IB_SUB"
    }
  }, [_vm._v(_vm._s(_vm.typeMap['IB_SUB']))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "SL"
    }
  }, [_vm._v(_vm._s(_vm.typeMap['SL']))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "SL_SUB"
    }
  }, [_vm._v(_vm._s(_vm.typeMap['SL_SUB']))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.refresh
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-refresh"
  }), _vm._v(_vm._s(_vm.multiLanguage.refresh))]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.addItem
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(_vm._s(_vm.multiLanguage.add))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline",
      "margin-left": "50px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.node_id) + ":")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.searchVal),
      callback: function($$v) {
        _vm.searchVal = $$v
      },
      expression: "searchVal"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.trData,
      "border": "",
      "size": "small",
      "element-loading-spinner": "el-icon-loading"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "label",
      "label": _vm.multiLanguage.type
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "node_id",
      "label": _vm.multiLanguage.node_id
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": _vm.multiLanguage.operate
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteItem(scope.row)
            }
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.delete))])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.multiLanguage.add,
      "visible": _vm.dialogFormVisible,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "margin": "10px"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.type))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.addData.type),
      callback: function($$v) {
        _vm.$set(_vm.addData, "type", $$v)
      },
      expression: "addData.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.typeMap['IB'],
      "value": "IB"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.typeMap['IB_SUB'],
      "value": "IB_SUB"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.typeMap['SL'],
      "value": "SL"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.typeMap['SL_SUB'],
      "value": "SL_SUB"
    }
  })], 1)], 1)], 1), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "margin": "10px"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.node_id))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-input', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.addData.node_id),
      callback: function($$v) {
        _vm.$set(_vm.addData, "node_id", $$v)
      },
      expression: "addData.node_id"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.cancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addCommit
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.submit))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profit-box"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.version.title))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [_c('profit-table', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "page": _vm.page,
      "selPage": _vm.selPage,
      "curArea": _vm.curArea,
      "operate": _vm.operate,
      "multiLanguage": _vm.version
    },
    on: {
      "tableChange": _vm.requestHandle
    }
  }, [_c('div', {
    staticClass: "conditions",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "condition change-el-input-group-style"
  }, [_c('el-input', {
    model: {
      value: (_vm.searchVal),
      callback: function($$v) {
        _vm.searchVal = $$v
      },
      expression: "searchVal"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "105px"
    },
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend",
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = $$v
      },
      expression: "searchKey"
    }
  }, _vm._l((_vm.version.selectArr), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.requestHandle
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.version.search))])], 1)], 1)])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register_client"
  }, [_c('crumbs', [_c('i', {
    staticClass: "icon-stack2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s((_vm.actionType == "reg") ? _vm.registerLan.crumbs.newaAccount : _vm.registerLan.crumbs.amend))])]), _vm._v(" "), _c('div', {
    staticClass: "content_box"
  }, [_c('h2', [_vm._v(_vm._s(_vm.registerLan.sales.title))]), _vm._v(" "), _c('div', {
    staticClass: "inputBox"
  }, [_c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales.form.sales_id,
      "errBool": _vm.errors.has('sales_id'),
      "errTexrt": _vm.registerLan.flaseTipNum
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|max:11'),
      expression: "'required|numeric|max:11'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.sales_id),
      expression: "formMsgArr.sales_id"
    }],
    ref: "sales_id",
    staticClass: "form-control col-lg-12",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('sales_id')
    },
    attrs: {
      "name": "sales_id",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formMsgArr.sales_id)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "sales_id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user_id_point),
      expression: "user_id_point"
    }],
    staticClass: "errText-wrapper"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-remove-circle errText"
  }, [_vm._v(_vm._s(_vm.registerLan.user_id_point))])])]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales.form.acc_name,
      "errBool": _vm.errors.has('user_name'),
      "errTexrt": _vm.registerLan.flaseTipName
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:45'),
      expression: "'required|max:45'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.user_name),
      expression: "formMsgArr.user_name"
    }],
    ref: "user_name",
    staticClass: "form-control col-lg-12",
    attrs: {
      "name": "user_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formMsgArr.user_name)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "user_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user_name_point),
      expression: "user_name_point"
    }],
    staticClass: "errText-wrapper"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-remove-circle errText"
  }, [_vm._v(_vm._s(_vm.registerLan.user_name_point))])])]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales.form.password,
      "errBool": _vm.errors.has('password'),
      "errTexrt": _vm.registerLan.flaseTipPass
    }
  }, [(_vm.actionType == 'reg') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_dash|min:1|max:256'),
      expression: "'required|alpha_dash|min:1|max:256'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.password),
      expression: "formMsgArr.password"
    }],
    staticClass: "form-control col-lg-12",
    attrs: {
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.formMsgArr.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "password", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.actionType == 'change') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('alpha_dash|min:1|max:256'),
      expression: "'alpha_dash|min:1|max:256'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.password),
      expression: "formMsgArr.password"
    }],
    staticClass: "form-control col-lg-12",
    attrs: {
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.formMsgArr.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "password", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales.form.phone,
      "errBool": _vm.errors.has('phone'),
      "errTexrt": _vm.registerLan.flasePhone
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num|max:255'),
      expression: "'required|alpha_num|max:255'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.phone),
      expression: "formMsgArr.phone"
    }],
    staticClass: "form-control col-lg-12",
    attrs: {
      "type": "text",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.formMsgArr.phone)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales.form.email,
      "errBool": _vm.errors.has('email'),
      "errTexrt": _vm.registerLan.flaseTip
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.email),
      expression: "formMsgArr.email"
    }],
    staticClass: "form-control col-lg-12",
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.formMsgArr.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "email", $event.target.value)
      }, _vm.validate_email]
    }
  }), _vm._v(" "), (_vm.is_repeat_email) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.registerLan.email_isRepeat))]) : _vm._e()]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales_info.form.jurisdiction.name
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.jurisdictionActive),
      expression: "jurisdictionActive"
    }],
    staticClass: "dfinput form-control col-lg-12",
    attrs: {
      "name": "qx"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jurisdictionActive = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectChange('jurisdictionActive')
      }]
    }
  }, _vm._l((_vm.jurisdictions), function(item, index) {
    return _c('option', {
      domProps: {
        "value": _vm.jurisdictions[index]
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('qx')),
      expression: "errors.has('qx')"
    }],
    staticClass: "help-block"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-remove-circle false"
  }, [_vm._v(_vm._s(_vm.registerLan.flaseTip))])])]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales.form.remark
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.remark),
      expression: "formMsgArr.remark"
    }],
    staticClass: "form-control col-lg-12",
    attrs: {
      "name": "remark",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formMsgArr.remark)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "remark", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn bg-teal",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitFn
    }
  }, [_vm._v(_vm._s(_vm.actionType == "reg" ? _vm.registerLan.submit : _vm.registerLan.changeBtn))])])]), _vm._v(" "), _c('Modal', {
    staticClass: "modal-content-j",
    attrs: {
      "size": "sm",
      "header": false,
      "footer": false,
      "backdrop": !_vm.modalLink
    },
    on: {
      "hide": _vm.toModalLink
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    class: (_vm.modalBool ? 'color-green' : 'color-red')
  }, [_c('i', {
    staticClass: "glyphicon",
    class: (_vm.modalBool ? 'glyphicon-ok' : 'glyphicon-warning-sign')
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.modalBool ? _vm.registerLan.submitResult.succeed : _vm.registerLan.submitResult.err))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalLink),
      expression: "modalLink"
    }],
    staticClass: "btn btn-success btn-xs",
    on: {
      "click": function($event) {
        _vm.modalShow = false
      }
    }
  }, [_vm._v(_vm._s(_vm.registerLan.logOut.yes))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commissionDatum"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('label', [_c('span', {
    staticClass: "enable-text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.templateName) + " :")]), _vm._v(" \n      "), (!_vm.newTempFlag) ? _c('el-select', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.onTemplateChange
    },
    model: {
      value: (_vm.temp_name),
      callback: function($$v) {
        _vm.temp_name = $$v
      },
      expression: "temp_name"
    }
  }, _vm._l((_vm.salesTemplate), function(item) {
    return (item.isDisplay) ? _c('el-option', {
      key: item.templateId,
      attrs: {
        "label": ((item.templateId) + " " + (_vm.multiLanguage[item.langKey]?'('+_vm.multiLanguage[item.langKey]+')':'')),
        "value": item.templateId
      }
    }) : _vm._e()
  }), 1) : _vm._e(), _vm._v(" "), (_vm.newTempFlag) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTempName),
      expression: "newTempName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 18,
        regex: /^([a-z]|[0-9]|[A-Z]|_)+$/
      }),
      expression: "{required:true,max:18,regex:/^([a-z]|[0-9]|[A-Z]|_)+$/}"
    }],
    staticClass: "template_name",
    style: (_vm.errors.has('newTempName') ? 'border-color:#f44336;' : ''),
    attrs: {
      "type": "text",
      "name": "newTempName"
    },
    domProps: {
      "value": (_vm.newTempName)
    },
    on: {
      "focus": function($event) {
        _vm.onfocus = true
      },
      "blur": function($event) {
        _vm.onfocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTempName = $event.target.value
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-box pull-right"
  }, [(_vm.version == '1') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.submit
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-edit"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.submit) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.version == '1') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.createTemplate
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-repeat"
  }), _vm._v("\n        " + _vm._s(_vm.newTempFlag ? _vm.multiLanguage.btnGroup.back : _vm.multiLanguage.templateCreate) + "\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.newTempFlag) ? _c('div', [_c('span', {
    staticClass: "enable-text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.templateBase) + " :")]), _vm._v(" \n      "), _c('el-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.onTemplateChange
    },
    model: {
      value: (_vm.temp_name),
      callback: function($$v) {
        _vm.temp_name = $$v
      },
      expression: "temp_name"
    }
  }, _vm._l((_vm.salesTemplate), function(item) {
    return (item.isDisplay) ? _c('el-option', {
      key: item.templateId,
      attrs: {
        "label": ((item.templateId) + " " + (_vm.multiLanguage[item.langKey]?'('+_vm.multiLanguage[item.langKey]+')':'')),
        "value": item.templateId
      }
    }) : _vm._e()
  }), 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.newTempFlag) ? _c('div', {
    style: ({
      'visibility': _vm.version == 1 ? 'hidden' : 'visible',
      'height': _vm.viewBtn == 'double' ? '30px' : '0px'
    })
  }, [_c('span', {
    staticClass: "enable-text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.templateHistory) + " : ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.onVersionChange
    },
    model: {
      value: (_vm.currentVersion),
      callback: function($$v) {
        _vm.currentVersion = $$v
      },
      expression: "currentVersion"
    }
  }, _vm._l((_vm.tempHistory), function(item) {
    return _c('el-option', {
      key: item.VERSION,
      attrs: {
        "label": item.VERSION == 0 ? "current" : ((item.UPDATE_BY) + " (" + (_vm.dataFormat(new Date(item.LAST_UPDATE))) + ") (" + (item.VERSION) + ")"),
        "value": item.VERSION
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1) : _vm._e(), _vm._v(" \n    "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div'), _vm._v(" "), _c('rule-setting', {
    ref: "ruleSetting",
    attrs: {
      "enable": _vm.enable,
      "multiLanguage": _vm.multiLanguage,
      "version": _vm.version,
      "relation": _vm.relation,
      "currentIB": _vm.currentIB,
      "viewBtn": _vm.viewBtn,
      "rule": _vm.rule,
      "ruleSeq": _vm.ruleSeq
    },
    on: {
      "checkId": _vm.checkIdFn
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "size": "sm",
      "header": false,
      "footer": false
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sucSave),
      expression: "!sucSave"
    }]
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-warning-sign color-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v(_vm._s(_vm.multiLanguage.submitResult.err))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sucSave),
      expression: "sucSave"
    }]
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-ok color-green"
  }), _vm._v(" "), _c('span', {
    staticClass: "color-green"
  }, [_vm._v(_vm._s(_vm.multiLanguage.submitResult.succeed))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.monthlyIBCommLan.text) + "  (" + _vm._s(_vm.queryObj.REPORT_ID) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('el-button', {
    staticClass: "preview-btn",
    attrs: {
      "round": "",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/ib_v2/monthlyIBResult')
      }
    }
  }, [_vm._v(_vm._s(_vm.monthlyIBCommLan.goback))])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "back": _vm.back,
      "downLoadTran": _vm.downLoadTran,
      "firstTh": _vm.firstTh,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "link": _vm.link,
      "multiExcelAjax": _vm.multiExcelAjax,
      "multiLanguage": _vm.monthlyIBCommLan,
      "name": _vm.downLoadName,
      "operate": _vm.operate,
      "page": _vm.page,
      "secondTh": _vm.secondTh,
      "selPage": _vm.selPage,
      "thData": _vm.thData,
      "trData": _vm.trData
    },
    on: {
      "tableChange": _vm.tableAjax
    }
  }, [_c('div', {
    staticClass: "filterCond",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "commission-condition"
  }, [_c('span', [_vm._v(_vm._s(_vm.monthlyIBCommLan.commissionType))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "105px"
    },
    on: {
      "change": _vm.searchDatas
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.monthlyIBCommLan.typeList), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "commission-condition"
  }, [_c('span', [_vm._v(_vm._s(_vm.monthlyIBCommLan.status))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "105px"
    },
    on: {
      "change": _vm.searchDatas
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.monthlyIBCommLan.IBStatusList), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "commission-condition"
  }, [_c('div', {
    staticClass: "commission-search",
    staticStyle: {
      "line-height": "0"
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    model: {
      value: (_vm.selectVal),
      callback: function($$v) {
        _vm.selectVal = $$v
      },
      expression: "selectVal"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend",
    model: {
      value: (_vm.selectKey),
      callback: function($$v) {
        _vm.selectKey = $$v
      },
      expression: "selectKey"
    }
  }, _vm._l((_vm.monthlyIBCommLan.selectKeys), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchDatas
    },
    slot: "append"
  })], 1)], 1)])])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-box"
  }, [_c('div', {
    staticClass: "preview-section"
  }, [_c('h4', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.ibCommissionPreview))]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.th.ibType))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.th.ibAccount))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.th.ibName))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.th.CommissionReturn))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.previewData.IB), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview[item.type]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.mode == 1 && item.cpa !== 'not set') ? _c('td', [_vm._v("\n            " + _vm._s(_vm.ibCommissionLan.CPACommission + " : ") + "\n            "), _vm._l((item.cpa), function(data, key) {
      return _c('span', [_vm._v("\n                " + _vm._s(data) + " " + _vm._s(_vm.ibCommissionLan.ibCommissionPreview.unit) + "\n                "), (key < item.cpa.length - 1) ? _c('span', [_vm._v("/")]) : _vm._e()])
    })], 2) : (item.mode == 0 && item.first !== 'not set') ? _c('td', [_vm._v("\n            " + _vm._s(_vm.ibCommissionLan.ruleCommission.internalCommission + " : ") + "\n            "), _vm._l((item.first), function(data, key) {
      return _c('span', [_vm._v("\n                " + _vm._s(data) + " " + _vm._s(_vm.ibCommissionLan.ibCommissionPreview.unit) + "\n                "), (key < item.first.length - 1) ? _c('span', [_vm._v("/")]) : _vm._e()])
    })], 2) : (item.mode == 2) ? _c('td', [_vm._v("\n            " + _vm._s(_vm.ibCommissionLan.ruleCommission.internalCommission + " : ") + "\n            "), _vm._l((item.first), function(data, key) {
      return (item.first !== 'not set') ? _c('span', [_vm._v("\n                " + _vm._s(data) + " " + _vm._s(_vm.ibCommissionLan.ibCommissionPreview.unit) + "\n                "), (key < item.first.length - 1) ? _c('span', [_vm._v("/")]) : _vm._e()]) : _vm._e()
    }), _vm._v("\n            +\n            " + _vm._s(_vm.ibCommissionLan.CPACommission + " : ") + "\n            "), _vm._l((item.cpa), function(data, key) {
      return (item.cpa !== 'not set') ? _c('span', [_vm._v("\n                " + _vm._s(data) + " " + _vm._s(_vm.ibCommissionLan.ibCommissionPreview.unit) + "\n                "), (key < item.cpa.length - 1) ? _c('span', [_vm._v("/")]) : _vm._e()]) : _vm._e()
    })], 2) : _c('td')])
  }), 0)])]), _vm._v(" "), (_vm.enableDistribution) ? _c('div', {
    staticClass: "preview-section"
  }, [_c('h4', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.lowerIBCommissionPreview))]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.th.mainIBAccount))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.th.subIBAccount))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.th.ibName))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.th.getSubCondition))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.previewData.lowerIB), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.previewData.mainIB))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', _vm._l((item.rules), function(rule, i) {
      return _c('div', _vm._l((_vm.ruleSeq), function(ruleSeqItem) {
        return (rule.ruleId == ruleSeqItem.ruleId) ? _c('div', [_vm._v("\n                " + _vm._s(i + 1) + "、\n                " + _vm._s(_vm.ibCommissionRuleSettingLan[ruleSeqItem.langKey.split('.')[1]]) + "\n                " + _vm._s(rule.ruleId && rule.ruleId < 3 ? '(' : '') + "\n                    "), (rule.spreadEnable) ? _c('span', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.rules.spreadCommission) + ",")]) : _vm._e(), _vm._v(" "), (rule.externalCommissionEnable) ? _c('span', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.rules.externalCommission) + ",")]) : _vm._e(), _vm._v(" "), (rule.internalCommissionEnable) ? _c('span', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.rules.internalCommission))]) : _vm._e(), _vm._v("\n                " + _vm._s(rule.ruleId && rule.ruleId < 3 ? ')' : '') + "\n                :\n                " + _vm._s(rule.value) + " " + _vm._s(rule.ruleId && rule.ruleId < 3 ? '%' : 'USD') + "\n              ")]) : _vm._e()
      }), 0)
    }), 0)])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.enableDistribution) ? _c('div', {
    staticClass: "preview-section"
  }, [_c('h4', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.specialIBCommissionPreview))]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.th.mainIBAccount))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.th.specialIBAccount))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.th.ibName))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.th.originalMainAccount))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.th.getSpecialCondition))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.previewData.specialIB), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.previewData.mainIB))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.original))]), _vm._v(" "), _c('td', _vm._l((item.rules), function(rule, i) {
      return _c('div', _vm._l((_vm.ruleSeq), function(ruleSeqItem) {
        return (rule.ruleId == ruleSeqItem.ruleId) ? _c('div', [_vm._v("\n                " + _vm._s(i + 1) + "、\n                " + _vm._s(_vm.ibCommissionRuleSettingLan[ruleSeqItem.langKey.split('.')[1]]) + "\n                " + _vm._s(rule.ruleId && rule.ruleId < 3 ? '(' : '') + "\n                    "), (rule.spreadEnable) ? _c('span', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.rules.spreadCommission) + ",")]) : _vm._e(), _vm._v(" "), (rule.externalCommissionEnable) ? _c('span', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.rules.externalCommission) + ",")]) : _vm._e(), _vm._v(" "), (rule.internalCommissionEnable) ? _c('span', [_vm._v(_vm._s(_vm.ibCommissionLan.ibCommissionPreview.rules.internalCommission))]) : _vm._e(), _vm._v("\n                " + _vm._s(rule.ruleId && rule.ruleId < 3 ? ')' : '') + "\n                :\n                " + _vm._s(rule.value) + " " + _vm._s(rule.ruleId && rule.ruleId < 3 ? '%' : 'USD') + "\n              ")]) : _vm._e()
      }), 0)
    }), 0)])
  }), 0)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.CPACommLan.text) + "  (" + _vm._s(_vm.queryObj.REPORT_ID) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('el-button', {
    staticClass: "preview-btn",
    attrs: {
      "type": "warning",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/ib_v2/CPACommissionResult')
      }
    }
  }, [_vm._v(_vm._s(_vm.CPACommLan.goback))])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "page": _vm.page,
      "selPage": _vm.selPage,
      "link": _vm.link,
      "operate": _vm.operate,
      "back": _vm.back,
      "multiLanguage": _vm.CPACommLan,
      "downLoadTran": _vm.downLoadTran,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "name": _vm.name
    },
    on: {
      "tableChange": _vm.tableAjax
    }
  }, [_c('div', {
    staticClass: "filterCond",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "commission-condition"
  }, [_c('span', [_vm._v(_vm._s(_vm.CPACommLan.status))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "105px"
    },
    on: {
      "change": _vm.searchDatas
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.CPACommLan.CPAStatusList), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "commission-condition"
  }, [_c('div', {
    staticClass: "commission-search"
  }, [_c('span', [_vm._v(_vm._s(_vm.CPACommLan.proxyAccount))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.proxyAccount),
      callback: function($$v) {
        _vm.proxyAccount = $$v
      },
      expression: "proxyAccount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "commission-search"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchDatas
    }
  }, [_vm._v(_vm._s(_vm.CPACommLan.search))])], 1)])])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibCommission-box"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.ibCommissionLan.templateSetting))]), _vm._v(" "), (!_vm.showPreview) ? _c('div', {
    staticClass: "pull-right viewBtn-box"
  }, [_c('button', {
    staticClass: "double",
    on: {
      "click": function($event) {
        _vm.viewBtn = 'double'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.ibCommissionLan.contrastBrowse) + "\n      ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.viewBtn = 'onlyOne'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.ibCommissionLan.singlepageBrowse) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, [(_vm.viewBtn == 'double') ? _c('div', {
    staticClass: "version0",
    class: {
      'doubleView margin-right': _vm.viewBtn === 'double'
    }
  }, [_c('ib-template-setting-content', {
    ref: "version0",
    attrs: {
      "multiLanguage": _vm.ibCommissionLan,
      "version": '0',
      "curArea": _vm.curArea,
      "viewBtn": _vm.viewBtn
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "version1",
    class: {
      'doubleView': _vm.viewBtn === 'double'
    }
  }, [_c('ib-template-setting-content', {
    ref: "version1",
    attrs: {
      "multiLanguage": _vm.ibCommissionLan,
      "version": '1',
      "viewBtn": _vm.viewBtn,
      "curArea": _vm.curArea
    },
    on: {
      "afterVerify": _vm.afterVerifyFn
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "internalCommission-box"
  }, [_c('div', {
    staticClass: "tableBtn-box",
    style: (_vm.version == '0' ? 'visibility:hidden;' : '')
  }, [_c('button', {
    staticClass: "btn btn-style-add",
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.addItem
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v("\n      " + _vm._s(_vm.multiLanguage.btnGroup.addLots) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-style-remove",
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.removeItem
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-trash"
  }), _vm._v("\n      " + _vm._s(_vm.multiLanguage.btnGroup.removeLots) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-fixed pull-left"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.groupSeq), function(groupitem) {
    return _c('tr', [_c('td', {
      staticClass: "fixed-td"
    }, [_vm._v(_vm._s(_vm.publicLan.products[groupitem]))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "table-moveable pull-left"
  }, [_c('table', {
    staticClass: "table table-bordered",
    class: {
      'table-striped': _vm.commission.enable && _vm.version == '1',
      'disabled': !_vm.commission.enable || _vm.version == '0'
    }
  }, [_c('thead', {
    staticClass: "moveable_thead"
  }, [_c('tr', [_c('th', {
    attrs: {
      "colspan": _vm.commission.lvl.length
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.thead.lots))])]), _vm._v(" "), _c('tr', _vm._l((_vm.commission.lvl), function(lvlItem, lvlIndex) {
    return _c('th', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedLvls),
        expression: "checkedLvls"
      }],
      class: {
        'min-checkbox': _vm.viewBtn == 'double'
      },
      style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.commission.enable || _vm.version == '0'
      },
      domProps: {
        "value": lvlIndex,
        "checked": Array.isArray(_vm.checkedLvls) ? _vm._i(_vm.checkedLvls, lvlIndex) > -1 : (_vm.checkedLvls)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedLvls,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = lvlIndex,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedLvls = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedLvls = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedLvls = $$c
          }
        }
      }
    }), _vm._v(" "), (lvlIndex == 0) ? _c('span', [_vm._v(_vm._s(lvlItem.start ? lvlItem.start : '0.00'))]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lvlItem.start),
        expression: "lvlItem.start"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|min_value:0.00|decimal:2'),
        expression: "'required|min_value:0.00|decimal:2'"
      }],
      style: (_vm.errors.has(lvlIndex + '_' + 'start') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.commission.enable || _vm.version == '0',
        "name": lvlIndex + '_' + 'start'
      },
      domProps: {
        "value": (lvlItem.start)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(lvlItem, "start", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), (lvlIndex == _vm.commission.lvl.length - 1) ? _c('span', [_vm._v(_vm._s(_vm.multiLanguage.infinite))]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lvlItem.end),
        expression: "lvlItem.end"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|min_value:0.00|decimal:2'),
        expression: "'required|min_value:0.00|decimal:2'"
      }],
      style: (_vm.errors.has(lvlIndex + '_' + 'end') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.commission.enable || _vm.version == '0',
        "name": lvlIndex + '_' + 'end'
      },
      domProps: {
        "value": (lvlItem.end)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(lvlItem, "end", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v("Lots")])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.groupSeq), function(groupitem, groupIndex) {
    return _c('tr', _vm._l((_vm.commission.lvl), function(lvlItem, lvlIndex) {
      return _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (lvlItem[groupitem]),
          expression: "lvlItem[groupitem]"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|min_value:0.00|decimal:2'),
          expression: "'required|min_value:0.00|decimal:2'"
        }],
        style: (_vm.errors.has(lvlIndex + '_' + groupitem) ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.commission.enable || _vm.version == '0',
          "name": lvlIndex + '_' + groupitem
        },
        domProps: {
          "value": (lvlItem[groupitem])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(lvlItem, groupitem, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span')])
    }), 0)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "space"
  })])])
}]}

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-box"
  }, [_c('div', {
    staticClass: "p-header"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.multiLanguage.preview.subordinateType) + "：")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form-control",
    staticStyle: {
      "border-radius": "3px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.preview.all))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.preview.directCustomer))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.preview.directIB))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.preview.other))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.seachVal),
      expression: "seachVal"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.seachVal)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.seachFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.seachVal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon btn btn-primary",
    on: {
      "click": _vm.seachFn
    }
  }, [_vm._v("\n            " + _vm._s(_vm.multiLanguage.preview.search) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group pull-right"
  }, [_c('label', [_vm._v(_vm._s(_vm.multiLanguage.preview.showClauses) + "：")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clause),
      expression: "clause"
    }],
    staticClass: "form-control",
    staticStyle: {
      "border-radius": "3px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.clause = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('jsonExcel', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-left": "20px",
      "padding": "8px 12px"
    },
    attrs: {
      "name": "filename.xlsx",
      "ajaxUrl": _vm.jsonExcelAjax.url || false,
      "ajaxPar": _vm.jsonExcelAjax.ajaxPar || false,
      "ajaxType": _vm.jsonExcelAjax.ajaxType,
      "keys": _vm.thData,
      "ajaxGetKey": _vm.jsonExcelAjax.getKey,
      "multiLanguage": _vm.publicLan,
      "publicLan": _vm.publicLan,
      "colData": [],
      "mainAcc": _vm.mainAcc,
      "reqData": _vm.reqData
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-save tab-he-glyphicon"
  }), _vm._v("\n          " + _vm._s(_vm.multiLanguage.downloadExcel) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "p-body",
    attrs: {
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.5)"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', _vm._l((_vm.multiLanguage.previewThead), function(item) {
    return _c('th', [_vm._v(_vm._s(item.text))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.previewData), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.mainAcc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.publicLan.type[item.type]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.account))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.publicLan.relationType[item.relationType]))]), _vm._v(" "), _c('td', _vm._l((item.condition), function(data, index) {
      return _c('span', _vm._l((_vm.reqData), function(d, i) {
        return (d.ruleId === data.ruleId) ? _c('span', [_vm._v("\n                " + _vm._s(data.clientType == 1 ? _vm.publicLan.clientType.IBClient : data.clientType == 2 ? _vm.publicLan.clientType.directClient : '') + "\n                " + _vm._s(_vm.publicLan.rule[d.langKey.split('.')[1]]) + " : " + _vm._s(data.value) + "；\n              ")]) : _vm._e()
      }), 0)
    }), 0)])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "p-footer",
    staticStyle: {
      "line-height": "36px",
      "height": "36px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("\n      " + _vm._s(_vm.multiLanguage.preview.totalClauses) + "：" + _vm._s(_vm.totalData) + "\n      " + _vm._s(_vm.multiLanguage.preview.current) + "：" + _vm._s((_vm.currentPage - 1) * _vm.clause + 1) + " - " + _vm._s(Math.min(_vm.currentPage * _vm.clause, _vm.totalData)) + "\n    ")]), _vm._v(" "), _c('pagination', {
    staticClass: "pull-right",
    attrs: {
      "boundary-links": "",
      "total-page": _vm.totalPage,
      "align": "right"
    },
    on: {
      "change": _vm.callpageFn
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seek"
  }, [_c('div', {
    staticClass: "pull-left seekDropdown dropdown"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle hui-dropdown-toggle no-pointer",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.seekLan.account))])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.seekDropdown.seekStr),
      expression: "seekDropdown.seekStr"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "form-control hui-form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.seekLan.seek
    },
    domProps: {
      "value": (_vm.seekDropdown.seekStr)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.emitSeek.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.seekDropdown, "seekStr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left btn btn-default btn-primary",
    on: {
      "click": _vm.emitSeek
    }
  }, [_vm._v(_vm._s(_vm.seekLan.seek))]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('crumbs', [_c('i', {
    staticClass: "icon-stack2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.crumbs.authList))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('authMtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "multiLanguage": _vm.multiLanguage,
      "handle": _vm.handle
    },
    on: {
      "deleteList": _vm.deleteList,
      "refresh": _vm.refresh,
      "addRefresh": _vm.tableAjax
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "internalCommission-box"
  }, [_c('div', {
    staticClass: "tableBtn-box",
    style: (_vm.version == '0' ? 'visibility:hidden;' : '')
  }, [_c('button', {
    staticClass: "btn btn-style-add",
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.addItem
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v("\n      " + _vm._s(_vm.multiLanguage.btnGroup.addLots) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-style-remove",
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.removeItem
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-trash"
  }), _vm._v("\n      " + _vm._s(_vm.multiLanguage.btnGroup.removeLots) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-fixed pull-left"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.groupSeq), function(groupitem) {
    return _c('tr', [_c('td', {
      staticClass: "fixed-td"
    }, [_vm._v(_vm._s(_vm.publicLan.products[groupitem]))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "table-moveable pull-left"
  }, [_c('table', {
    staticClass: "table table-bordered",
    class: {
      'table-striped': _vm.commission.enable && _vm.version == '1',
      'disabled': !_vm.commission.enable || _vm.version == '0'
    }
  }, [_c('thead', {
    staticClass: "moveable_thead"
  }, [_c('tr', [_c('th', {
    attrs: {
      "colspan": _vm.commission.lvl.length
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.thead.lots))])]), _vm._v(" "), _c('tr', _vm._l((_vm.commission.lvl), function(lvlItem, lvlIndex) {
    return _c('th', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedLvls),
        expression: "checkedLvls"
      }],
      class: {
        'min-checkbox': _vm.viewBtn == 'double'
      },
      style: (_vm.version == '0' ? 'visibility:hidden;' : ''),
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.commission.enable || _vm.version == '0'
      },
      domProps: {
        "value": lvlIndex,
        "checked": Array.isArray(_vm.checkedLvls) ? _vm._i(_vm.checkedLvls, lvlIndex) > -1 : (_vm.checkedLvls)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedLvls,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = lvlIndex,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedLvls = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedLvls = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedLvls = $$c
          }
        }
      }
    }), _vm._v(" "), (lvlIndex == 0) ? _c('span', [_vm._v(_vm._s(lvlItem.start ? lvlItem.start : '0.00'))]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lvlItem.start),
        expression: "lvlItem.start"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|min_value:0.00|decimal:2'),
        expression: "'required|min_value:0.00|decimal:2'"
      }],
      style: (_vm.errors.has(lvlIndex + '_' + 'start') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.commission.enable || _vm.version == '0',
        "name": lvlIndex + '_' + 'start'
      },
      domProps: {
        "value": (lvlItem.start)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(lvlItem, "start", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), (lvlIndex == _vm.commission.lvl.length - 1) ? _c('span', [_vm._v(_vm._s(_vm.multiLanguage.infinite))]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lvlItem.end),
        expression: "lvlItem.end"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|min_value:0.00|decimal:2'),
        expression: "'required|min_value:0.00|decimal:2'"
      }],
      style: (_vm.errors.has(lvlIndex + '_' + 'end') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.commission.enable || _vm.version == '0',
        "name": lvlIndex + '_' + 'end'
      },
      domProps: {
        "value": (lvlItem.end)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(lvlItem, "end", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v("Lots")])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.groupSeq), function(groupitem, groupIndex) {
    return _c('tr', _vm._l((_vm.commission.lvl), function(lvlItem, lvlIndex) {
      return _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (lvlItem[groupitem]),
          expression: "lvlItem[groupitem]"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|min_value:0.00|decimal:2'),
          expression: "'required|min_value:0.00|decimal:2'"
        }],
        style: (_vm.errors.has(lvlIndex + '_' + groupitem) ? 'border-color:#f44336;' : ''),
        attrs: {
          "type": "text",
          "disabled": !_vm.commission.enable || _vm.version == '0',
          "name": lvlIndex + '_' + groupitem
        },
        domProps: {
          "value": (lvlItem[groupitem])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(lvlItem, groupitem, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span')])
    }), 0)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "space"
  })])])
}]}

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "download"
    }
  }), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.generate_excel
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.mtclient.indexText))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [_c('div', {
    staticClass: "btn-group"
  }, _vm._l((_vm.mtdbs), function(item, key) {
    return _c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': item.name == _vm.selDb
      },
      on: {
        "click": function($event) {
          return _vm.changeMT(item.name)
        }
      }
    }, [_vm._v("\n                     " + _vm._s(((item.serverName) + "(" + (item.mtType) + ")")) + "\n                ")])
  }), 0), _vm._v(" "), (_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "selPage": _vm.selPage,
      "page": _vm.page,
      "name": _vm.name,
      "sort": _vm.sort,
      "multiLanguage": _vm.mtclient,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "downLoadTran": _vm.downLoadTran
    },
    on: {
      "tableChange": _vm.tableAjax
    }
  }, [_c('div', {
    staticClass: "monthlyHandle",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.login),
      callback: function($$v) {
        _vm.login = $$v
      },
      expression: "login"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.mtclient.loginText))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "size": "medium"
    },
    on: {
      "click": _vm.searchData
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.mtclient.search))])], 2)], 1)]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.CPACommDetailLan.datailText) + "  (" + _vm._s(_vm.queryObj.REPORT_ID) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('el-button', {
    staticClass: "preview-btn",
    attrs: {
      "type": "warning",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.CPACommDetailLan.goback))])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "multiLanguage": _vm.CPACommDetailLan,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "downLoadTran": _vm.downLoadTran,
      "name": _vm.name
    }
  }, [_c('div', {
    staticClass: "cpa-detail",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "cpa-detail"
  }, [_c('span', [_vm._v(_vm._s(_vm.CPACommDetailLan.proxyAccount) + " " + _vm._s(_vm.queryObj.IB_ID))])]), _vm._v(" "), _c('div', {
    staticClass: "cpa-detail"
  }, [_c('span', [_vm._v(_vm._s(_vm.CPACommDetailLan.commissionType) + " " + _vm._s(_vm.CPACommDetailLan.type))])])])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header-wrapper"
  }, [_c('div', {
    staticClass: "page-header page-header-default"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "mat"
  })])
},staticRenderFns: []}

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('crumbs', [_c('i', {
    staticClass: "icon-stack2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.crumbs.userList))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "panel"
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "multiLanguage": _vm.multiLanguage,
      "selPage": _vm.selPage,
      "seekDropdown": _vm.seekDropdown,
      "page": _vm.page,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "handle": _vm.handle,
      "sort": _vm.sort
    },
    on: {
      "seek": _vm.tableAjax,
      "tableChange": _vm.tableAjax,
      "deleteList": _vm.deleteList
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "salesCommission"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.salesCommissionLan.templateSetting))]), _vm._v(" "), (!_vm.showPreview) ? _c('div', {
    staticClass: "pull-right viewBtn-box"
  }, [_c('button', {
    staticClass: "double",
    on: {
      "click": function($event) {
        _vm.viewBtn = 'double'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.salesCommissionLan.contrastBrowse) + "\n      ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.viewBtn = 'onlyOne'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.salesCommissionLan.singlepageBrowse) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (!_vm.showPreview) ? _c('div', {
    staticClass: "content-box"
  }, [(_vm.viewBtn == 'double') ? _c('div', {
    staticClass: "version0",
    class: {
      'doubleView margin-right': _vm.viewBtn === 'double'
    }
  }, [_c('sale-template-content', {
    ref: "version0",
    attrs: {
      "multiLanguage": _vm.salesCommissionLan,
      "version": '0',
      "viewBtn": _vm.viewBtn,
      "curArea": _vm.curArea
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "version1",
    class: {
      'doubleView': _vm.viewBtn === 'double'
    }
  }, [_c('sale-template-content', {
    ref: "version1",
    attrs: {
      "multiLanguage": _vm.salesCommissionLan,
      "version": '1',
      "viewBtn": _vm.viewBtn,
      "curArea": _vm.curArea
    },
    on: {
      "afterVerify": _vm.afterVerifyFn
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "salesCommission"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true
      }
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.5)"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "multiLanguage": _vm.multiLanguage,
      "selPage": _vm.selPage,
      "seekDropdown": _vm.seekDropdown,
      "page": _vm.page,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "handle": _vm.handle,
      "sort": _vm.sort,
      "isSetting": _vm.isSetting,
      "region": _vm.curArea,
      "label": _vm.label
    },
    on: {
      "seek": _vm.tableAjax,
      "tableChange": _vm.tableAjax
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('crumbs', [_c('i', {
    staticClass: "glyphicon glyphicon-file"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.profitShareViewLan.title))])]), _vm._v(" "), _c('div', {
    staticClass: "principal-wrap"
  }, [_c('div', {
    staticClass: "region-box pull-left"
  }, [_c('div', {
    staticClass: "btn-group pull-left"
  }, _vm._l((_vm.profitshare_area), function(item, key) {
    return _c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': item == _vm.curArea
      },
      on: {
        "click": function($event) {
          return _vm.areaGroupSwitchFn(item)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item) + "\n              ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('btn-group', {
    staticClass: "primary-box pull-right"
  }, [_c('btn', {
    class: {
      'active': (_vm.activePrimary == '/accountSetting')
    },
    on: {
      "click": function($event) {
        return _vm.jump('/profit/accountSetting')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.profitShareViewLan.account_setting) + "\n          ")]), _vm._v(" "), _c('Dropdown', {
    staticClass: "pull-left seekDropdown",
    staticStyle: {
      "margin-left": "-1px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    class: {
      'active': _vm.activePrimary.indexOf('Report') != -1
    },
    attrs: {
      "data-role": "trigger",
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.profitShareViewLan.profit_report))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _vm._l((_vm.profitShareViewLan.list), function(item, index) {
    return _c('template', {
      slot: "dropdown"
    }, [_c('li', {
      class: {
        'active': _vm.activePrimary == item.link
      },
      on: {
        "click": function($event) {
          return _vm.jump(item.link)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.text))])])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "curArea": _vm.curArea
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.multiLanguage.relationshipListReport))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.5)"
    }
  }, [_c('itable', {
    attrs: {
      "thData": _vm.thTitle,
      "trData": _vm.trData,
      "page": _vm.page,
      "multiLanguage": _vm.multiLanguage,
      "seekDropdown": _vm.seekDropdown,
      "selPage": _vm.selPage,
      "filterData": _vm.filterData
    },
    on: {
      "tableChange": _vm.tableAjax,
      "seek": _vm.tableAjax,
      "downLoadExcelFn": _vm.excelDown,
      "filterFn": _vm.filterFn
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "region-box pull-left"
  }, [_c('button', {
    staticClass: "back pull-left"
  }, [_c('img', {
    staticStyle: {
      "width": "24px",
      "margin-top": "3px"
    },
    attrs: {
      "src": __webpack_require__(416)
    },
    on: {
      "click": function($event) {
        return _vm.jump('/ib_v2/ibSetting')
      }
    }
  })]), _vm._v(" "), (_vm.apiChangeable && _vm.$route.path.split('/')[2] !== 'ibCommissionSetting') ? _c('div', {
    staticClass: "btn-group pull-left"
  }, _vm._l((_vm.area), function(item) {
    return _c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': item == _vm.actArea
      },
      on: {
        "click": function($event) {
          return _vm.areaGroupSwitchFn(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])
  }), 0) : _c('div', {
    staticClass: "btn-group pull-left"
  }, _vm._l((_vm.area), function(item, key) {
    return _c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': item == _vm.actArea
      }
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('btn-group', {
    staticClass: "primary-box pull-right"
  }, [_c('btn', {
    class: {
      'active': (_vm.activePrimary == '/ibSetting' || _vm.activePrimary == '/ibCommissionSetting')
    },
    on: {
      "click": function($event) {
        return _vm.jump('/ib_v2/ibSetting')
      }
    }
  }, [_vm._v("\n             " + _vm._s(_vm.ibPrimaryLan.commissionSetting) + "\n          ")]), _vm._v(" "), _c('Dropdown', {
    staticClass: "pull-left seekDropdown",
    staticStyle: {
      "margin-left": "-1px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    class: {
      'active': _vm.activePrimary.indexOf('Result') != -1
    },
    attrs: {
      "data-role": "trigger",
      "type": "button"
    },
    on: {
      "click": _vm.checkCpaFn
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ibPrimaryLan.ibResult.title))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _vm._l((_vm.ibPrimaryLan.ibResult_v2.list), function(item, index) {
    return _c('template', {
      slot: "dropdown"
    }, [(item.link !== '/ib_v2/CPACommissionResult' || _vm.checkCpa) ? _c('li', {
      class: {
        'active': _vm.activePrimary == item.link
      },
      on: {
        "click": function($event) {
          return _vm.jump(item.link)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.text))])]) : _vm._e()])
  })], 2), _vm._v(" "), _c('Dropdown', {
    staticClass: "pull-left seekDropdown",
    staticStyle: {
      "margin-left": "-1px"
    },
    attrs: {
      "menu-right": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    class: {
      'active': _vm.activePrimary.indexOf('Report') != -1
    },
    attrs: {
      "data-role": "trigger",
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ibPrimaryLan.ibReport.title))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _vm._l((_vm.ibPrimaryLan.ibReport_v2.list), function(item, index) {
    return _c('template', {
      slot: "dropdown"
    }, [_c('li', {
      class: {
        'active': _vm.activePrimary == item.link
      },
      on: {
        "click": function($event) {
          return _vm.jump(item.link)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.text))])])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "curArea": _vm.curArea,
      "status": _vm.status
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.spreadCommissionLan.spreadCommission))])]), _vm._v(" "), _c('div', {
    staticClass: "spreadCommission"
  }, [_c('table', {
    staticClass: "table tableData table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.spreadCommissionLan.th.symbol))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.spreadCommissionLan.th.Commission))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.spreadCommissionLan.th.lastUpdate))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.spreadCommissionLan.th.operate))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(item, index) {
    return _c('tr', [(item.newItem) ? _c('td', [_c('el-select', {
      attrs: {
        "placeholder": _vm.spreadCommissionLan.placeholder
      },
      model: {
        value: (item.SYMBOL),
        callback: function($$v) {
          _vm.$set(item, "SYMBOL", $$v)
        },
        expression: "item.SYMBOL"
      }
    }, _vm._l((item.selecteData), function(data) {
      return _c('el-option', {
        key: data.value,
        attrs: {
          "label": data.label,
          "value": data.label
        }
      })
    }), 1)], 1) : _c('td', [_vm._v(_vm._s(item.SYMBOL))]), _vm._v(" "), _c('td', [_c('el-input', {
      staticClass: "commission",
      on: {
        "change": function($event) {
          item.changed = true
        }
      },
      model: {
        value: (item.COMMISSION),
        callback: function($$v) {
          _vm.$set(item, "COMMISSION", $$v)
        },
        expression: "item.COMMISSION"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.LAST_UPDATE))]), _vm._v(" "), (index < _vm.data.length - 1) ? _c('td', [_c('button', {
      staticClass: "btn btn-xs",
      staticStyle: {
        "background-color": "#3f51b5",
        "color": "#fff"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(item, _vm.data)
        }
      }
    }, [_vm._v(_vm._s(_vm.spreadCommissionLan.th.add))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs",
      staticStyle: {
        "background-color": "#f08712",
        "color": "#fff"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(item, _vm.data)
        }
      }
    }, [_vm._v(_vm._s(_vm.spreadCommissionLan.th.remove))])]) : _c('td')])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn bg-teal",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitFn
    }
  }, [_vm._v(_vm._s(_vm.spreadCommissionLan.th.save))])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "size": "sm",
      "header": false,
      "footer": false
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sucSave),
      expression: "!sucSave"
    }]
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-warning-sign color-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v(_vm._s(_vm.spreadCommissionLan.submitResult.err))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sucSave),
      expression: "sucSave"
    }]
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-ok color-green"
  }), _vm._v(" "), _c('span', {
    staticClass: "color-green"
  }, [_vm._v(_vm._s(_vm.spreadCommissionLan.submitResult.succeed))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-list-box-2-wrap"
  }, [_c('div', {
    staticClass: "line-1"
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate,
      "label": _vm.box_data.right_id
    },
    on: {
      "change": _vm.check_all_change
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v(_vm._s(_vm.box_data.label))])], 1), _vm._v(" "), _c('div', {
    staticClass: "line-2"
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.checked_change
    },
    model: {
      value: (_vm.entity_data),
      callback: function($$v) {
        _vm.entity_data = $$v
      },
      expression: "entity_data"
    }
  }, _vm._l((_vm.box_data.entity), function(item, key) {
    return _c('el-checkbox', {
      key: key,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-list-box-2-wrap"
  }, [_c('div', {
    staticClass: "line-1"
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.data_change
    },
    model: {
      value: (_vm.check_data),
      callback: function($$v) {
        _vm.check_data = $$v
      },
      expression: "check_data"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.box_data.right_id
    }
  }, [_vm._v(_vm._s(_vm.box_data.label))])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper no-footer mtable"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.multiLanguage.dialog_title,
      "width": "15%",
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.multiLanguage.date_placeholder,
      "value-format": "yyyy-MM-dd 00:00:00",
      "picker-options": _vm.pickerOption
    },
    model: {
      value: (_vm.timePicker),
      callback: function($$v) {
        _vm.timePicker = $$v
      },
      expression: "timePicker"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.cancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmDateHandle
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.ensure))])], 1)], 1), _vm._v(" "), _vm._t("menu"), _vm._v(" "), _c('div', {
    staticClass: "datatable-header mtable-tool hui-group-dib-box"
  }, [(_vm.selPage) ? _c('selPage', {
    staticClass: "pull-right",
    attrs: {
      "multiLanguage": _vm.multiLanguage,
      "selPage": _vm.selPage
    },
    on: {
      "selPage": _vm.selPageFn
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group p-0 pull-left mtable-tool-fn"
  }, [_vm._t("return-back"), _vm._v(" "), _vm._t("handle"), _vm._v(" "), (_vm.operate) ? _c('div', {
    staticClass: "commission-confirm"
  }, [(_vm.operate.btnGroup) ? _c('el-button-group', [(_vm.doConfirm) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.undoConfirm || !_vm.threeConfirm
    },
    on: {
      "click": function($event) {
        return _vm.confirmHandle(_vm.operate.updateVal.do)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.do))]) : _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": !_vm.undoConfirm
    },
    on: {
      "click": function($event) {
        return _vm.confirmHandle(_vm.operate.updateVal.do)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.doConfirm))]), _vm._v(" "), (_vm.undoConfirm) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.doConfirm || !_vm.threeConfirm
    },
    on: {
      "click": function($event) {
        return _vm.confirmHandle(_vm.operate.updateVal.undo)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.undo))]) : _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": !_vm.doConfirm
    },
    on: {
      "click": function($event) {
        return _vm.confirmHandle(_vm.operate.updateVal.undo)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.undoConfirm))]), _vm._v(" "), (_vm.threeConfirm) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.doConfirm || !_vm.undoConfirm
    },
    on: {
      "click": function($event) {
        return _vm.confirmHandle(_vm.operate.updateVal.three)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.three))]) : _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": !_vm.doConfirm || !_vm.undoConfirm
    },
    on: {
      "click": function($event) {
        return _vm.confirmHandle(_vm.operate.updateVal.three)
      }
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.threeConfirm))])], 1) : _vm._e(), _vm._v(" "), (_vm.operate.btn) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.checkedArr.length == 0
    },
    on: {
      "click": _vm.updateStatus
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.btn))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.jsonExcelAjax) ? _c('jsonExcel', {
    staticClass: "btn btn-default",
    attrs: {
      "ajaxUrl": _vm.jsonExcelAjax.url || false,
      "ajaxPar": _vm.jsonExcelAjax.ajaxPar || false,
      "ajaxType": _vm.jsonExcelAjax.ajaxType,
      "rID": _vm.jsonExcelAjax.rID,
      "cID": _vm.jsonExcelAjax.cID,
      "type": _vm.jsonExcelAjax.type,
      "keys": _vm.thData,
      "ajaxGetKey": _vm.jsonExcelAjax.getKey,
      "downLoadTran": _vm.downLoadTran,
      "name": _vm.name
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-save tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.downloadExcelForms) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.detailExcelAjax) ? _c('jsonExcel', {
    staticClass: "btn btn-default",
    attrs: {
      "ajaxUrl": _vm.detailExcelAjax.url || false,
      "ajaxPar": _vm.detailExcelAjax.ajaxPar || false,
      "ajaxType": _vm.detailExcelAjax.ajaxType,
      "rID": _vm.detailExcelAjax.rID,
      "keys": _vm.detailTh,
      "ajaxGetKey": _vm.detailExcelAjax.getKey,
      "downLoadTran": _vm.downLoadTran,
      "name": _vm.detailName
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-save tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.downloadDetailExcel) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.multiExcelAjax) ? _c('multi-sheet-excel', {
    staticClass: "btn btn-default",
    attrs: {
      "ajaxUrl": _vm.multiExcelAjax.url || false,
      "ajaxPar": _vm.multiExcelAjax.ajaxPar || false,
      "ajaxType": _vm.multiExcelAjax.ajaxType,
      "firstTh": _vm.firstTh,
      "secondTh": _vm.secondTh,
      "rID": _vm.multiExcelAjax.rID,
      "sheetName": _vm.multiLanguage.sheetName,
      "downloadName": _vm.multiLanguage.downloadName,
      "ajaxGetKey": _vm.multiExcelAjax.getKey,
      "dataTh": _vm.multiExcelAjax.dataTh
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-save tab-he-glyphicon"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.downloadDetailExcel) + "\n      ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "datatable-scroll",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_vm._t("datatable-scroll"), _vm._v(" "), _vm._t("title-name"), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-hover datatable-highlight dataTable no-footer",
    attrs: {
      "id": "DataTables_Table_2",
      "role": "grid",
      "aria-describedby": "DataTables_Table_2_info"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.operate) ? _c('th', [(_vm.selectData.length !== 0) ? _c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.checkAll
    },
    model: {
      value: (_vm.selectAll),
      callback: function($$v) {
        _vm.selectAll = $$v
      },
      expression: "selectAll"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.thData), function(item, index) {
    return (item.flag === undefined ? true : item.flag) ? _c('th', [_vm._v(_vm._s(item.name))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.trData), function(item, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.trData.length > 0),
        expression: "trData.length > 0"
      }],
      attrs: {
        "role": "row"
      }
    }, [(_vm.operate) ? _c('td', [(item.show) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.checked),
        expression: "item.checked"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.checked) ? _vm._i(item.checked, null) > -1 : (item.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = item.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "checked", $$c)
          }
        }, function($event) {
          return _vm.updateCheckArr(item)
        }]
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.thData), function(obj) {
      return (obj.flag === undefined ? true : obj.flag) ? _c('td', [(_vm.link && _vm.link.key.indexOf(obj.key) > -1) ? _c('a', {
        on: {
          "click": function($event) {
            return _vm.linkDetails(item)
          }
        }
      }, [_vm._v(_vm._s(item[obj.key]))]) : (_vm.tip && _vm.tip.key.indexOf(obj.key) > -1) ? _c('span', [_c('el-tooltip', [_c('div', {
        attrs: {
          "slot": "content"
        },
        slot: "content"
      }, _vm._l((JSON.parse(item[obj.key])), function(tips, value) {
        return _c('span', [_vm._v("\n                    " + _vm._s(value) + "  :  " + _vm._s(tips) + "\n                    "), _c('br')])
      }), 0), _vm._v(" "), (item[obj.key] && item[obj.key].length > 40) ? _c('span', [_vm._v(_vm._s(item[obj.key].substr(0, 40) + '...'))]) : _c('span', [_vm._v(_vm._s(item[obj.key]))])])], 1) : _c('span', [_vm._v(_vm._s(item[obj.key]))])]) : _vm._e()
    })], 2)
  }), 0)]), _vm._v(" "), (_vm.trData.length == 0) ? _c('noData', {
    attrs: {
      "text": _vm.multiLanguage.nodata,
      "fontSize": '18'
    }
  }) : _vm._e()], 2), _vm._v(" "), (_vm.selPage) ? _c('div', {
    staticClass: "datatable-footer"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "id": "DataTables_Table_2_info",
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v(_vm._s(_vm.multiLanguage.clauses) + _vm._s(_vm.multiLanguage.amount) + ": " + _vm._s(_vm.page.pageLeng) + "  " + _vm._s(_vm.multiLanguage.present) + ": " + _vm._s(_vm.page.active * _vm.selPage.limit - _vm.selPage.limit + 1) + "-" + _vm._s(Math.min(_vm.page.active * _vm.selPage.limit, _vm.page.pageLeng)))]), _vm._v(" "), (Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active])) ? _c('div', {
    staticClass: "dataTables_paginate paging_simple_numbers",
    attrs: {
      "id": "DataTables_Table_2_paginate"
    }
  }, [_c('pagination', {
    attrs: {
      "boundary-links": true,
      "direction-links": true,
      "total-page": Math.ceil(_vm.page.pageLeng / _vm.selPage.list[_vm.selPage.active]),
      "max-size": _vm.page.pagenum
    },
    on: {
      "change": _vm.callpageFn
    },
    model: {
      value: (_vm.page.active),
      callback: function($$v) {
        _vm.$set(_vm.page, "active", $$v)
      },
      expression: "page.active"
    }
  })], 1) : _vm._e()]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.monthlySalesCommLan.text) + "  (" + _vm._s(_vm.queryObj.REPORT_ID) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('el-button', {
    staticClass: "preview-btn",
    attrs: {
      "round": "",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/sale_v2/saleMonthlyResult')
      }
    }
  }, [_vm._v(_vm._s(_vm.monthlySalesCommLan.goback))])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "back": _vm.back,
      "detailExcelAjax": _vm.detailExcelAjax,
      "detailName": _vm.detailName,
      "detailTh": _vm.detailTh,
      "downLoadTran": _vm.downLoadTran,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "link": _vm.link,
      "multiLanguage": _vm.monthlySalesCommLan,
      "name": _vm.name,
      "operate": _vm.operate,
      "page": _vm.page,
      "selPage": _vm.selPage,
      "thData": _vm.thData,
      "trData": _vm.trData
    },
    on: {
      "tableChange": _vm.tableAjax
    }
  }, [_c('div', {
    staticClass: "filterCond",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "commission-condition"
  }, [_c('span', [_vm._v(_vm._s(_vm.monthlySalesCommLan.commissionType))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "105px"
    },
    on: {
      "change": _vm.searchDatas
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.monthlySalesCommLan.typeList), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "commission-condition"
  }, [_c('span', [_vm._v(_vm._s(_vm.monthlySalesCommLan.status))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "105px"
    },
    on: {
      "change": _vm.searchDatas
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.monthlySalesCommLan.statusList), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "commission-condition",
    staticStyle: {
      "line-height": "0"
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    model: {
      value: (_vm.selectVal),
      callback: function($$v) {
        _vm.selectVal = $$v
      },
      expression: "selectVal"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend",
    model: {
      value: (_vm.selectKey),
      callback: function($$v) {
        _vm.selectKey = $$v
      },
      expression: "selectKey"
    }
  }, _vm._l((_vm.monthlySalesCommLan.selectKeys), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchDatas
    },
    slot: "append"
  })], 1)], 1)])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1152 */,
/* 1153 */,
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./sidebar-_tem1.png": 974,
	"./sidebar-_tem10.png": 975,
	"./sidebar-_tem11.png": 976,
	"./sidebar-_tem12.png": 977,
	"./sidebar-_tem2.png": 978,
	"./sidebar-_tem3.png": 979,
	"./sidebar-_tem4.png": 980,
	"./sidebar-_tem5.png": 981,
	"./sidebar-_tem6.png": 982,
	"./sidebar-_tem7.png": 983,
	"./sidebar-_tem8.png": 984,
	"./sidebar-_tem9.png": 985
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1154;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(197);
module.exports = __webpack_require__(421);


/***/ })
],[1155]);


// WEBPACK FOOTER //
// static/js/app.0c65b6fd1de47e7d7791.js